webpackJsonp([6],{

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateWorkspace_vue__ = __webpack_require__(2561);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36bd936f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateWorkspace_vue__ = __webpack_require__(3692);
function injectStyle (ssrContext) {
  __webpack_require__(3404)
  __webpack_require__(3406)
  this["$style"] = __webpack_require__(3408)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36bd936f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateWorkspace_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36bd936f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateWorkspace_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * ElementUI 日期选择组件的参数
 * @Author: anker.wang
 * @Date: 2018-01-08 11:27:07
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-01-08 11:28:27
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dateTimePickerOptions: {
        shortcuts: [{
          text: '一周后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '明天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '今天',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      dateTimePickerRangeOptions: {
        shortcuts: [{
          text: '最近1周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近6个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近2年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 730);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1095);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  }
});

/***/ }),

/***/ 1350:
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(22);


/***/ }),

/***/ 1351:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var core = __webpack_require__(12);
var LIBRARY = __webpack_require__(104);
var wksExt = __webpack_require__(1350);
var defineProperty = __webpack_require__(54).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1357), __esModule: true };

/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(144)('meta');
var isObject = __webpack_require__(55);
var has = __webpack_require__(75);
var setDesc = __webpack_require__(54).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(76)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 1354:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(244);
var hiddenKeys = __webpack_require__(148).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(78);

/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(79);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1358);


/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var get = __webpack_require__(145);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 1359:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1384)
var ieee754 = __webpack_require__(1385)
var isArray = __webpack_require__(1386)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),

/***/ 1360:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(77);

/***/ }),

/***/ 1362:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1365);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1366);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ 1365:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1368), __esModule: true };

/***/ }),

/***/ 1366:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1369), __esModule: true };

/***/ }),

/***/ 1367:
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(235);
var createDesc = __webpack_require__(103);
var toIObject = __webpack_require__(100);
var toPrimitive = __webpack_require__(236);
var has = __webpack_require__(75);
var IE8_DOM_DEFINE = __webpack_require__(243);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(40) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ 1368:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(143);
__webpack_require__(234);
module.exports = __webpack_require__(1350).f('iterator');


/***/ }),

/***/ 1369:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1370);
__webpack_require__(241);
__webpack_require__(1373);
__webpack_require__(1374);
module.exports = __webpack_require__(12).Symbol;


/***/ }),

/***/ 1370:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(17);
var has = __webpack_require__(75);
var DESCRIPTORS = __webpack_require__(40);
var $export = __webpack_require__(28);
var redefine = __webpack_require__(245);
var META = __webpack_require__(1353).KEY;
var $fails = __webpack_require__(76);
var shared = __webpack_require__(147);
var setToStringTag = __webpack_require__(105);
var uid = __webpack_require__(144);
var wks = __webpack_require__(22);
var wksExt = __webpack_require__(1350);
var wksDefine = __webpack_require__(1351);
var enumKeys = __webpack_require__(1371);
var isArray = __webpack_require__(1356);
var anObject = __webpack_require__(41);
var isObject = __webpack_require__(55);
var toObject = __webpack_require__(78);
var toIObject = __webpack_require__(100);
var toPrimitive = __webpack_require__(236);
var createDesc = __webpack_require__(103);
var _create = __webpack_require__(240);
var gOPNExt = __webpack_require__(1372);
var $GOPD = __webpack_require__(1367);
var $GOPS = __webpack_require__(237);
var $DP = __webpack_require__(54);
var $keys = __webpack_require__(101);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(1354).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(235).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(104)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(56)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 1371:
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(101);
var gOPS = __webpack_require__(237);
var pIE = __webpack_require__(235);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ 1372:
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(100);
var gOPN = __webpack_require__(1354).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ 1373:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1351)('asyncIterator');


/***/ }),

/***/ 1374:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1351)('observable');


/***/ }),

/***/ 1375:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download

(function (root, factory) {
	if (true) {
		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like environments that support module.exports,
		// like Node.
		module.exports = factory();
	} else {
		// Browser globals (root is window)
		root.download = factory();
  }
}(this, function () {

	return function download(data, strFileName, strMimeType) {

		var self = window, // this script is only for browsers anyway...
			defaultMime = "application/octet-stream", // this default mime also triggers iframe downloads
			mimeType = strMimeType || defaultMime,
			payload = data,
			url = !strFileName && !strMimeType && payload,
			anchor = document.createElement("a"),
			toString = function(a){return String(a);},
			myBlob = (self.Blob || self.MozBlob || self.WebKitBlob || toString),
			fileName = strFileName || "download",
			blob,
			reader;
			myBlob= myBlob.call ? myBlob.bind(self) : Blob ;
	  
		if(String(this)==="true"){ //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
			payload=[payload, mimeType];
			mimeType=payload[0];
			payload=payload[1];
		}


		if(url && url.length< 2048){ // if no filename and no mime, assume a url was passed as the only argument
			fileName = url.split("/").pop().split("?")[0];
			anchor.href = url; // assign href prop to temp anchor
		  	if(anchor.href.indexOf(url) !== -1){ // if the browser determines that it's a potentially valid url path:
        		var ajax=new XMLHttpRequest();
        		ajax.open( "GET", url, true);
        		ajax.responseType = 'blob';
        		ajax.onload= function(e){ 
				  download(e.target.response, fileName, defaultMime);
				};
        		setTimeout(function(){ ajax.send();}, 0); // allows setting custom ajax headers using the return:
			    return ajax;
			} // end if valid url?
		} // end if url?


		//go ahead and download dataURLs right away
		if(/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)){
		
			if(payload.length > (1024*1024*1.999) && myBlob !== toString ){
				payload=dataUrlToBlob(payload);
				mimeType=payload.type || defaultMime;
			}else{			
				return navigator.msSaveBlob ?  // IE10 can't do a[download], only Blobs:
					navigator.msSaveBlob(dataUrlToBlob(payload), fileName) :
					saver(payload) ; // everyone else can save dataURLs un-processed
			}
			
		}else{//not data url, is it a string with special needs?
			if(/([\x80-\xff])/.test(payload)){			  
				var i=0, tempUiArr= new Uint8Array(payload.length), mx=tempUiArr.length;
				for(i;i<mx;++i) tempUiArr[i]= payload.charCodeAt(i);
			 	payload=new myBlob([tempUiArr], {type: mimeType});
			}		  
		}
		blob = payload instanceof myBlob ?
			payload :
			new myBlob([payload], {type: mimeType}) ;


		function dataUrlToBlob(strUrl) {
			var parts= strUrl.split(/[:;,]/),
			type= parts[1],
			decoder= parts[2] == "base64" ? atob : decodeURIComponent,
			binData= decoder( parts.pop() ),
			mx= binData.length,
			i= 0,
			uiArr= new Uint8Array(mx);

			for(i;i<mx;++i) uiArr[i]= binData.charCodeAt(i);

			return new myBlob([uiArr], {type: type});
		 }

		function saver(url, winMode){

			if ('download' in anchor) { //html5 A[download]
				anchor.href = url;
				anchor.setAttribute("download", fileName);
				anchor.className = "download-js-link";
				anchor.innerHTML = "downloading...";
				anchor.style.display = "none";
				document.body.appendChild(anchor);
				setTimeout(function() {
					anchor.click();
					document.body.removeChild(anchor);
					if(winMode===true){setTimeout(function(){ self.URL.revokeObjectURL(anchor.href);}, 250 );}
				}, 66);
				return true;
			}

			// handle non-a[download] safari as best we can:
			if(/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
				if(/^data:/.test(url))	url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
				if(!window.open(url)){ // popup blocked, offer direct download:
					if(confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")){ location.href=url; }
				}
				return true;
			}

			//do iframe dataURL download (old ch+FF):
			var f = document.createElement("iframe");
			document.body.appendChild(f);

			if(!winMode && /^data:/.test(url)){ // force a mime that will download:
				url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
			}
			f.src=url;
			setTimeout(function(){ document.body.removeChild(f); }, 333);

		}//end saver




		if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
			return navigator.msSaveBlob(blob, fileName);
		}

		if(self.URL){ // simple fast and modern way using Blob and URL:
			saver(self.URL.createObjectURL(blob), true);
		}else{
			// handle non-Blob()+non-URL browsers:
			if(typeof blob === "string" || blob.constructor===toString ){
				try{
					return saver( "data:" +  mimeType   + ";base64,"  +  self.btoa(blob)  );
				}catch(y){
					return saver( "data:" +  mimeType   + "," + encodeURIComponent(blob)  );
				}
			}

			// Blob but not URL support:
			reader=new FileReader();
			reader.onload=function(e){
				saver(this.result);
			};
			reader.readAsDataURL(blob);
		}
		return true;
	}; /* end download() */
}));


/***/ }),

/***/ 1376:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1381);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1352);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 1381:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1382), __esModule: true };

/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1383);


/***/ }),

/***/ 1383:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(146);
var ITERATOR = __webpack_require__(22)('iterator');
var Iterators = __webpack_require__(66);
module.exports = __webpack_require__(12).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 1384:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 1385:
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 1386:
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ 1429:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ 1443:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(73);

/***/ }),

/***/ 1449:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(253);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ 1507:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main__ = __webpack_require__(1632);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main__["a" /* default */]);

/***/ }),

/***/ 1519:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {"object"==typeof navigator&&function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("Plyr",t):(e=e||self).Plyr=t()}(this,function(){"use strict";function e(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function t(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}function n(e,n,i){return n&&t(e.prototype,n),i&&t(e,i),e}function i(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){var n=[],i=!0,a=!1,s=void 0;try{for(var r,o=e[Symbol.iterator]();!(i=(r=o.next()).done)&&(n.push(r.value),!t||n.length!==t);i=!0);}catch(e){a=!0,s=e}finally{try{i||null==o.return||o.return()}finally{if(a)throw s}}return n}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function s(e){return function(e){if(Array.isArray(e)){for(var t=0,n=new Array(e.length);t<e.length;t++)n[t]=e[t];return n}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var r={addCSS:!0,thumbWidth:15,watch:!0};var o=function(e){return null!=e?e.constructor:null},l=function(e,t){return Boolean(e&&t&&e instanceof t)},c=function(e){return null==e},u=function(e){return o(e)===Object},d=function(e){return o(e)===String},h=function(e){return Array.isArray(e)},m=function(e){return l(e,NodeList)},p={nullOrUndefined:c,object:u,number:function(e){return o(e)===Number&&!Number.isNaN(e)},string:d,boolean:function(e){return o(e)===Boolean},function:function(e){return o(e)===Function},array:h,nodeList:m,element:function(e){return l(e,Element)},event:function(e){return l(e,Event)},empty:function(e){return c(e)||(d(e)||h(e)||m(e))&&!e.length||u(e)&&!Object.keys(e).length}};function f(e,t){if(t<1){var n=(i="".concat(t).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/))?Math.max(0,(i[1]?i[1].length:0)-(i[2]?+i[2]:0)):0;return parseFloat(e.toFixed(n))}var i;return Math.round(e/t)*t}var g,y,v,b=function(){function t(n,i){e(this,t),p.element(n)?this.element=n:p.string(n)&&(this.element=document.querySelector(n)),p.element(this.element)&&p.empty(this.element.rangeTouch)&&(this.config=Object.assign({},r,i),this.init())}return n(t,[{key:"init",value:function(){t.enabled&&(this.config.addCSS&&(this.element.style.userSelect="none",this.element.style.webKitUserSelect="none",this.element.style.touchAction="manipulation"),this.listeners(!0),this.element.rangeTouch=this)}},{key:"destroy",value:function(){t.enabled&&(this.listeners(!1),this.element.rangeTouch=null)}},{key:"listeners",value:function(e){var t=this,n=e?"addEventListener":"removeEventListener";["touchstart","touchmove","touchend"].forEach(function(e){t.element[n](e,function(e){return t.set(e)},!1)})}},{key:"get",value:function(e){if(!t.enabled||!p.event(e))return null;var n,i=e.target,a=e.changedTouches[0],s=parseFloat(i.getAttribute("min"))||0,r=parseFloat(i.getAttribute("max"))||100,o=parseFloat(i.getAttribute("step"))||1,l=r-s,c=i.getBoundingClientRect(),u=100/c.width*(this.config.thumbWidth/2)/100;return(n=100/c.width*(a.clientX-c.left))<0?n=0:n>100&&(n=100),n<50?n-=(100-2*n)*u:n>50&&(n+=2*(n-50)*u),s+f(l*(n/100),o)}},{key:"set",value:function(e){t.enabled&&p.event(e)&&!e.target.disabled&&(e.preventDefault(),e.target.value=this.get(e),function(e,t){if(e&&t){var n=new Event(t);e.dispatchEvent(n)}}(e.target,"touchend"===e.type?"change":"input"))}}],[{key:"setup",value:function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=null;if(p.empty(e)||p.string(e)?i=Array.from(document.querySelectorAll(p.string(e)?e:'input[type="range"]')):p.element(e)?i=[e]:p.nodeList(e)?i=Array.from(e):p.array(e)&&(i=e.filter(p.element)),p.empty(i))return null;var a=Object.assign({},r,n);p.string(e)&&a.watch&&new MutationObserver(function(n){Array.from(n).forEach(function(n){Array.from(n.addedNodes).forEach(function(n){if(p.element(n)&&function(){return Array.from(document.querySelectorAll(i)).includes(this)}.call(n,i=e)){var i;new t(n,a)}})})}).observe(document.body,{childList:!0,subtree:!0});return i.map(function(e){return new t(e,n)})}},{key:"enabled",get:function(){return"ontouchstart"in document.documentElement}}]),t}(),k=function(e){return null!=e?e.constructor:null},w=function(e,t){return Boolean(e&&t&&e instanceof t)},T=function(e){return null==e},C=function(e){return k(e)===Object},A=function(e){return k(e)===String},E=function(e){return Array.isArray(e)},S=function(e){return w(e,NodeList)},P=function(e){return T(e)||(A(e)||E(e)||S(e))&&!e.length||C(e)&&!Object.keys(e).length},N={nullOrUndefined:T,object:C,number:function(e){return k(e)===Number&&!Number.isNaN(e)},string:A,boolean:function(e){return k(e)===Boolean},function:function(e){return k(e)===Function},array:E,weakMap:function(e){return w(e,WeakMap)},nodeList:S,element:function(e){return w(e,Element)},textNode:function(e){return k(e)===Text},event:function(e){return w(e,Event)},keyboardEvent:function(e){return w(e,KeyboardEvent)},cue:function(e){return w(e,window.TextTrackCue)||w(e,window.VTTCue)},track:function(e){return w(e,TextTrack)||!T(e)&&A(e.kind)},promise:function(e){return w(e,Promise)},url:function(e){if(w(e,window.URL))return!0;if(!A(e))return!1;var t=e;e.startsWith("http://")&&e.startsWith("https://")||(t="http://".concat(e));try{return!P(new URL(t).hostname)}catch(e){return!1}},empty:P},M=(g=document.createElement("span"),y={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"},v=Object.keys(y).find(function(e){return void 0!==g.style[e]}),!!N.string(v)&&y[v]);function x(e,t){setTimeout(function(){try{e.hidden=!0,e.offsetHeight,e.hidden=!1}catch(e){}},t)}var L={isIE:!!document.documentMode,isEdge:window.navigator.userAgent.includes("Edge"),isWebkit:"WebkitAppearance"in document.documentElement.style&&!/Edge/.test(navigator.userAgent),isIPhone:/(iPhone|iPod)/gi.test(navigator.platform),isIos:/(iPad|iPhone|iPod)/gi.test(navigator.platform)},I=function(){var e=!1;try{var t=Object.defineProperty({},"passive",{get:function(){return e=!0,null}});window.addEventListener("test",null,t),window.removeEventListener("test",null,t)}catch(e){}return e}();function _(e,t,n){var i=this,a=arguments.length>3&&void 0!==arguments[3]&&arguments[3],s=!(arguments.length>4&&void 0!==arguments[4])||arguments[4],r=arguments.length>5&&void 0!==arguments[5]&&arguments[5];if(e&&"addEventListener"in e&&!N.empty(t)&&N.function(n)){var o=t.split(" "),l=r;I&&(l={passive:s,capture:r}),o.forEach(function(t){i&&i.eventListeners&&a&&i.eventListeners.push({element:e,type:t,callback:n,options:l}),e[a?"addEventListener":"removeEventListener"](t,n,l)})}}function O(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",n=arguments.length>2?arguments[2]:void 0,i=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],a=arguments.length>4&&void 0!==arguments[4]&&arguments[4];_.call(this,e,t,n,!0,i,a)}function j(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",n=arguments.length>2?arguments[2]:void 0,i=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],a=arguments.length>4&&void 0!==arguments[4]&&arguments[4];_.call(this,e,t,n,!1,i,a)}function q(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",i=arguments.length>2?arguments[2]:void 0,a=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],s=arguments.length>4&&void 0!==arguments[4]&&arguments[4];_.call(this,e,n,function r(){j(e,n,r,a,s);for(var o=arguments.length,l=new Array(o),c=0;c<o;c++)l[c]=arguments[c];i.apply(t,l)},!0,a,s)}function H(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{};if(N.element(e)&&!N.empty(t)){var a=new CustomEvent(t,{bubbles:n,detail:Object.assign({},i,{plyr:this})});e.dispatchEvent(a)}}function D(e,t){return t.split(".").reduce(function(e,t){return e&&e[t]},e)}function F(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length,n=new Array(t>1?t-1:0),a=1;a<t;a++)n[a-1]=arguments[a];if(!n.length)return e;var s=n.shift();return N.object(s)?(Object.keys(s).forEach(function(t){N.object(s[t])?(Object.keys(e).includes(t)||Object.assign(e,i({},t,{})),F(e[t],s[t])):Object.assign(e,i({},t,s[t]))}),F.apply(void 0,[e].concat(n))):e}function R(e,t){var n=e.length?e:[e];Array.from(n).reverse().forEach(function(e,n){var i=n>0?t.cloneNode(!0):t,a=e.parentNode,s=e.nextSibling;i.appendChild(e),s?a.insertBefore(i,s):a.appendChild(i)})}function V(e,t){N.element(e)&&!N.empty(t)&&Object.entries(t).filter(function(e){var t=a(e,2)[1];return!N.nullOrUndefined(t)}).forEach(function(t){var n=a(t,2),i=n[0],s=n[1];return e.setAttribute(i,s)})}function B(e,t,n){var i=document.createElement(e);return N.object(t)&&V(i,t),N.string(n)&&(i.innerText=n),i}function U(e,t,n,i){N.element(t)&&t.appendChild(B(e,n,i))}function W(e){N.nodeList(e)||N.array(e)?Array.from(e).forEach(W):N.element(e)&&N.element(e.parentNode)&&e.parentNode.removeChild(e)}function z(e){if(N.element(e))for(var t=e.childNodes.length;t>0;)e.removeChild(e.lastChild),t-=1}function K(e,t){return N.element(t)&&N.element(t.parentNode)&&N.element(e)?(t.parentNode.replaceChild(e,t),e):null}function Y(e,t){if(!N.string(e)||N.empty(e))return{};var n={},i=F({},t);return e.split(",").forEach(function(e){var t=e.trim(),s=t.replace(".",""),r=t.replace(/[[\]]/g,"").split("="),o=a(r,1)[0],l=r.length>1?r[1].replace(/["']/g,""):"";switch(t.charAt(0)){case".":N.string(i.class)?n.class="".concat(i.class," ").concat(s):n.class=s;break;case"#":n.id=t.replace("#","");break;case"[":n[o]=l}}),F(i,n)}function Q(e,t){if(N.element(e)){var n=t;N.boolean(n)||(n=!e.hidden),e.hidden=n}}function X(e,t,n){if(N.nodeList(e))return Array.from(e).map(function(e){return X(e,t,n)});if(N.element(e)){var i="toggle";return void 0!==n&&(i=n?"add":"remove"),e.classList[i](t),e.classList.contains(t)}return!1}function J(e,t){return N.element(e)&&e.classList.contains(t)}function $(e,t){return function(){return Array.from(document.querySelectorAll(t)).includes(this)}.call(e,t)}function G(e){return this.elements.container.querySelectorAll(e)}function Z(e){return this.elements.container.querySelector(e)}function ee(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];N.element(e)&&(e.focus({preventScroll:!0}),t&&X(e,this.config.classNames.tabFocus))}var te,ne={"audio/ogg":"vorbis","audio/wav":"1","video/webm":"vp8, vorbis","video/mp4":"avc1.42E01E, mp4a.40.2","video/ogg":"theora"},ie={audio:"canPlayType"in document.createElement("audio"),video:"canPlayType"in document.createElement("video"),check:function(e,t,n){var i=L.isIPhone&&n&&ie.playsinline,a=ie[e]||"html5"!==t;return{api:a,ui:a&&ie.rangeInput&&("video"!==e||!L.isIPhone||i)}},pip:!(L.isIPhone||!N.function(B("video").webkitSetPresentationMode)&&(!document.pictureInPictureEnabled||B("video").disablePictureInPicture)),airplay:N.function(window.WebKitPlaybackTargetAvailabilityEvent),playsinline:"playsInline"in document.createElement("video"),mime:function(e){if(N.empty(e))return!1;var t=a(e.split("/"),1)[0],n=e;if(!this.isHTML5||t!==this.type)return!1;Object.keys(ne).includes(n)&&(n+='; codecs="'.concat(ne[e],'"'));try{return Boolean(n&&this.media.canPlayType(n).replace(/no/,""))}catch(e){return!1}},textTracks:"textTracks"in document.createElement("video"),rangeInput:(te=document.createElement("input"),te.type="range","range"===te.type),touch:"ontouchstart"in document.documentElement,transitions:!1!==M,reducedMotion:"matchMedia"in window&&window.matchMedia("(prefers-reduced-motion)").matches};function ae(e){return!!(N.array(e)||N.string(e)&&e.includes(":"))&&(N.array(e)?e:e.split(":")).map(Number).every(N.number)}function se(e){if(!N.array(e)||!e.every(N.number))return null;var t=a(e,2),n=t[0],i=t[1],s=function e(t,n){return 0===n?t:e(n,t%n)}(n,i);return[n/s,i/s]}function re(e){var t=function(e){return ae(e)?e.split(":").map(Number):null},n=t(e);if(null===n&&(n=t(this.config.ratio)),null===n&&!N.empty(this.embed)&&N.array(this.embed.ratio)&&(n=this.embed.ratio),null===n&&this.isHTML5){var i=this.media;n=se([i.videoWidth,i.videoHeight])}return n}function oe(e){if(!this.isVideo)return{};var t=re.call(this,e),n=a(N.array(t)?t:[0,0],2),i=100/n[0]*n[1];if(this.elements.wrapper.style.paddingBottom="".concat(i,"%"),this.isVimeo&&this.supported.ui){var s=(240-i)/4.8;this.media.style.transform="translateY(-".concat(s,"%)")}else this.isHTML5&&this.elements.wrapper.classList.toggle(this.config.classNames.videoFixedRatio,null!==t);return{padding:i,ratio:t}}var le={getSources:function(){var e=this;return this.isHTML5?Array.from(this.media.querySelectorAll("source")).filter(function(t){var n=t.getAttribute("type");return!!N.empty(n)||ie.mime.call(e,n)}):[]},getQualityOptions:function(){return le.getSources.call(this).map(function(e){return Number(e.getAttribute("size"))}).filter(Boolean)},extend:function(){if(this.isHTML5){var e=this;N.empty(this.config.ratio)||oe.call(e),Object.defineProperty(e.media,"quality",{get:function(){var t=le.getSources.call(e).find(function(t){return t.getAttribute("src")===e.source});return t&&Number(t.getAttribute("size"))},set:function(t){var n=le.getSources.call(e).find(function(e){return Number(e.getAttribute("size"))===t});if(n){var i=e.media,a=i.currentTime,s=i.paused,r=i.preload,o=i.readyState;e.media.src=n.getAttribute("src"),("none"!==r||o)&&(e.once("loadedmetadata",function(){e.currentTime=a,s||e.play()}),e.media.load()),H.call(e,e.media,"qualitychange",!1,{quality:t})}}})}},cancelRequests:function(){this.isHTML5&&(W(le.getSources.call(this)),this.media.setAttribute("src",this.config.blankVideo),this.media.load(),this.debug.log("Cancelled network requests"))}};function ce(e){return N.array(e)?e.filter(function(t,n){return e.indexOf(t)===n}):e}function ue(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),i=1;i<t;i++)n[i-1]=arguments[i];return N.empty(e)?e:e.toString().replace(/{(\d+)}/g,function(e,t){return n[t].toString()})}function de(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"";return e.replace(new RegExp(t.toString().replace(/([.*+?^=!:${}()|[\]\/\\])/g,"\\$1"),"g"),n.toString())}function he(){return(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"").toString().replace(/\w\S*/g,function(e){return e.charAt(0).toUpperCase()+e.substr(1).toLowerCase()})}function me(){var e=(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"").toString();return(e=function(){var e=(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"").toString();return e=de(e,"-"," "),e=de(e,"_"," "),de(e=he(e)," ","")}(e)).charAt(0).toLowerCase()+e.slice(1)}function pe(e){var t=document.createElement("div");return t.appendChild(e),t.innerHTML}var fe={pip:"PIP",airplay:"AirPlay",html5:"HTML5",vimeo:"Vimeo",youtube:"YouTube"},ge=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(N.empty(e)||N.empty(t))return"";var n=D(t.i18n,e);if(N.empty(n))return Object.keys(fe).includes(e)?fe[e]:"";var i={"{seektime}":t.seekTime,"{title}":t.title};return Object.entries(i).forEach(function(e){var t=a(e,2),i=t[0],s=t[1];n=de(n,i,s)}),n},ye=function(){function t(n){e(this,t),this.enabled=n.config.storage.enabled,this.key=n.config.storage.key}return n(t,[{key:"get",value:function(e){if(!t.supported||!this.enabled)return null;var n=window.localStorage.getItem(this.key);if(N.empty(n))return null;var i=JSON.parse(n);return N.string(e)&&e.length?i[e]:i}},{key:"set",value:function(e){if(t.supported&&this.enabled&&N.object(e)){var n=this.get();N.empty(n)&&(n={}),F(n,e),window.localStorage.setItem(this.key,JSON.stringify(n))}}}],[{key:"supported",get:function(){try{if(!("localStorage"in window))return!1;return window.localStorage.setItem("___test","___test"),window.localStorage.removeItem("___test"),!0}catch(e){return!1}}}]),t}();function ve(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"text";return new Promise(function(n,i){try{var a=new XMLHttpRequest;if(!("withCredentials"in a))return;a.addEventListener("load",function(){if("text"===t)try{n(JSON.parse(a.responseText))}catch(e){n(a.responseText)}else n(a.response)}),a.addEventListener("error",function(){throw new Error(a.status)}),a.open("GET",e,!0),a.responseType=t,a.send()}catch(e){i(e)}})}function be(e,t){if(N.string(e)){var n=N.string(t),i=function(){return null!==document.getElementById(t)},a=function(e,t){e.innerHTML=t,n&&i()||document.body.insertAdjacentElement("afterbegin",e)};if(!n||!i()){var s=ye.supported,r=document.createElement("div");if(r.setAttribute("hidden",""),n&&r.setAttribute("id",t),s){var o=window.localStorage.getItem("".concat("cache","-").concat(t));if(null!==o){var l=JSON.parse(o);a(r,l.content)}}ve(e).then(function(e){N.empty(e)||(s&&window.localStorage.setItem("".concat("cache","-").concat(t),JSON.stringify({content:e})),a(r,e))}).catch(function(){})}}}var ke=function(e){return Math.trunc(e/60/60%60,10)},we=function(e){return Math.trunc(e/60%60,10)},Te=function(e){return Math.trunc(e%60,10)};function Ce(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(!N.number(e))return Ce(null,t,n);var i=function(e){return"0".concat(e).slice(-2)},a=ke(e),s=we(e),r=Te(e);return a=t||a>0?"".concat(a,":"):"","".concat(n&&e>0?"-":"").concat(a).concat(i(s),":").concat(i(r))}var Ae={getIconUrl:function(){var e=new URL(this.config.iconUrl,window.location).host!==window.location.host||L.isIE&&!window.svg4everybody;return{url:this.config.iconUrl,cors:e}},findElements:function(){try{return this.elements.controls=Z.call(this,this.config.selectors.controls.wrapper),this.elements.buttons={play:G.call(this,this.config.selectors.buttons.play),pause:Z.call(this,this.config.selectors.buttons.pause),restart:Z.call(this,this.config.selectors.buttons.restart),rewind:Z.call(this,this.config.selectors.buttons.rewind),fastForward:Z.call(this,this.config.selectors.buttons.fastForward),mute:Z.call(this,this.config.selectors.buttons.mute),pip:Z.call(this,this.config.selectors.buttons.pip),airplay:Z.call(this,this.config.selectors.buttons.airplay),settings:Z.call(this,this.config.selectors.buttons.settings),captions:Z.call(this,this.config.selectors.buttons.captions),fullscreen:Z.call(this,this.config.selectors.buttons.fullscreen)},this.elements.progress=Z.call(this,this.config.selectors.progress),this.elements.inputs={seek:Z.call(this,this.config.selectors.inputs.seek),volume:Z.call(this,this.config.selectors.inputs.volume)},this.elements.display={buffer:Z.call(this,this.config.selectors.display.buffer),currentTime:Z.call(this,this.config.selectors.display.currentTime),duration:Z.call(this,this.config.selectors.display.duration)},N.element(this.elements.progress)&&(this.elements.display.seekTooltip=this.elements.progress.querySelector(".".concat(this.config.classNames.tooltip))),!0}catch(e){return this.debug.warn("It looks like there is a problem with your custom controls HTML",e),this.toggleNativeControls(!0),!1}},createIcon:function(e,t){var n=Ae.getIconUrl.call(this),i="".concat(n.cors?"":n.url,"#").concat(this.config.iconPrefix),a=document.createElementNS("http://www.w3.org/2000/svg","svg");V(a,F(t,{role:"presentation",focusable:"false"}));var s=document.createElementNS("http://www.w3.org/2000/svg","use"),r="".concat(i,"-").concat(e);return"href"in s&&s.setAttributeNS("http://www.w3.org/1999/xlink","href",r),s.setAttributeNS("http://www.w3.org/1999/xlink","xlink:href",r),a.appendChild(s),a},createLabel:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=ge(e,this.config);return B("span",Object.assign({},t,{class:[t.class,this.config.classNames.hidden].filter(Boolean).join(" ")}),n)},createBadge:function(e){if(N.empty(e))return null;var t=B("span",{class:this.config.classNames.menu.value});return t.appendChild(B("span",{class:this.config.classNames.menu.badge},e)),t},createButton:function(e,t){var n=this,i=F({},t),a=me(e),s={element:"button",toggle:!1,label:null,icon:null,labelPressed:null,iconPressed:null};switch(["element","icon","label"].forEach(function(e){Object.keys(i).includes(e)&&(s[e]=i[e],delete i[e])}),"button"!==s.element||Object.keys(i).includes("type")||(i.type="button"),Object.keys(i).includes("class")?i.class.split(" ").some(function(e){return e===n.config.classNames.control})||F(i,{class:"".concat(i.class," ").concat(this.config.classNames.control)}):i.class=this.config.classNames.control,e){case"play":s.toggle=!0,s.label="play",s.labelPressed="pause",s.icon="play",s.iconPressed="pause";break;case"mute":s.toggle=!0,s.label="mute",s.labelPressed="unmute",s.icon="volume",s.iconPressed="muted";break;case"captions":s.toggle=!0,s.label="enableCaptions",s.labelPressed="disableCaptions",s.icon="captions-off",s.iconPressed="captions-on";break;case"fullscreen":s.toggle=!0,s.label="enterFullscreen",s.labelPressed="exitFullscreen",s.icon="enter-fullscreen",s.iconPressed="exit-fullscreen";break;case"play-large":i.class+=" ".concat(this.config.classNames.control,"--overlaid"),a="play",s.label="play",s.icon="play";break;default:N.empty(s.label)&&(s.label=a),N.empty(s.icon)&&(s.icon=e)}var r=B(s.element);return s.toggle?(r.appendChild(Ae.createIcon.call(this,s.iconPressed,{class:"icon--pressed"})),r.appendChild(Ae.createIcon.call(this,s.icon,{class:"icon--not-pressed"})),r.appendChild(Ae.createLabel.call(this,s.labelPressed,{class:"label--pressed"})),r.appendChild(Ae.createLabel.call(this,s.label,{class:"label--not-pressed"}))):(r.appendChild(Ae.createIcon.call(this,s.icon)),r.appendChild(Ae.createLabel.call(this,s.label))),F(i,Y(this.config.selectors.buttons[a],i)),V(r,i),"play"===a?(N.array(this.elements.buttons[a])||(this.elements.buttons[a]=[]),this.elements.buttons[a].push(r)):this.elements.buttons[a]=r,r},createRange:function(e,t){var n=B("input",F(Y(this.config.selectors.inputs[e]),{type:"range",min:0,max:100,step:.01,value:0,autocomplete:"off",role:"slider","aria-label":ge(e,this.config),"aria-valuemin":0,"aria-valuemax":100,"aria-valuenow":0},t));return this.elements.inputs[e]=n,Ae.updateRangeFill.call(this,n),b.setup(n),n},createProgress:function(e,t){var n=B("progress",F(Y(this.config.selectors.display[e]),{min:0,max:100,value:0,role:"progressbar","aria-hidden":!0},t));if("volume"!==e){n.appendChild(B("span",null,"0"));var i={played:"played",buffer:"buffered"}[e],a=i?ge(i,this.config):"";n.innerText="% ".concat(a.toLowerCase())}return this.elements.display[e]=n,n},createTime:function(e,t){var n=Y(this.config.selectors.display[e],t),i=B("div",F(n,{class:"".concat(n.class?n.class:""," ").concat(this.config.classNames.display.time," ").trim(),"aria-label":ge(e,this.config)}),"00:00");return this.elements.display[e]=i,i},bindMenuItemShortcuts:function(e,t){var n=this;O(e,"keydown keyup",function(i){if([32,38,39,40].includes(i.which)&&(i.preventDefault(),i.stopPropagation(),"keydown"!==i.type)){var a,s=$(e,'[role="menuitemradio"]');if(!s&&[32,39].includes(i.which))Ae.showMenuPanel.call(n,t,!0);else 32!==i.which&&(40===i.which||s&&39===i.which?(a=e.nextElementSibling,N.element(a)||(a=e.parentNode.firstElementChild)):(a=e.previousElementSibling,N.element(a)||(a=e.parentNode.lastElementChild)),ee.call(n,a,!0))}},!1),O(e,"keyup",function(e){13===e.which&&Ae.focusFirstMenuItem.call(n,null,!0)})},createMenuItem:function(e){var t=this,n=e.value,i=e.list,a=e.type,s=e.title,r=e.badge,o=void 0===r?null:r,l=e.checked,c=void 0!==l&&l,u=Y(this.config.selectors.inputs[a]),d=B("button",F(u,{type:"button",role:"menuitemradio",class:"".concat(this.config.classNames.control," ").concat(u.class?u.class:"").trim(),"aria-checked":c,value:n})),h=B("span");h.innerHTML=s,N.element(o)&&h.appendChild(o),d.appendChild(h),Object.defineProperty(d,"checked",{enumerable:!0,get:function(){return"true"===d.getAttribute("aria-checked")},set:function(e){e&&Array.from(d.parentNode.children).filter(function(e){return $(e,'[role="menuitemradio"]')}).forEach(function(e){return e.setAttribute("aria-checked","false")}),d.setAttribute("aria-checked",e?"true":"false")}}),this.listeners.bind(d,"click keyup",function(e){if(!N.keyboardEvent(e)||32===e.which){switch(e.preventDefault(),e.stopPropagation(),d.checked=!0,a){case"language":t.currentTrack=Number(n);break;case"quality":t.quality=n;break;case"speed":t.speed=parseFloat(n)}Ae.showMenuPanel.call(t,"home",N.keyboardEvent(e))}},a,!1),Ae.bindMenuItemShortcuts.call(this,d,a),i.appendChild(d)},formatTime:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];return N.number(e)?Ce(e,ke(this.duration)>0,t):e},updateTimeDisplay:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];N.element(e)&&N.number(t)&&(e.innerText=Ae.formatTime(t,n))},updateVolume:function(){this.supported.ui&&(N.element(this.elements.inputs.volume)&&Ae.setRange.call(this,this.elements.inputs.volume,this.muted?0:this.volume),N.element(this.elements.buttons.mute)&&(this.elements.buttons.mute.pressed=this.muted||0===this.volume))},setRange:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;N.element(e)&&(e.value=t,Ae.updateRangeFill.call(this,e))},updateProgress:function(e){var t=this;if(this.supported.ui&&N.event(e)){var n,i,a=0;if(e)switch(e.type){case"timeupdate":case"seeking":case"seeked":n=this.currentTime,i=this.duration,a=0===n||0===i||Number.isNaN(n)||Number.isNaN(i)?0:(n/i*100).toFixed(2),"timeupdate"===e.type&&Ae.setRange.call(this,this.elements.inputs.seek,a);break;case"playing":case"progress":!function(e,n){var i=N.number(n)?n:0,a=N.element(e)?e:t.elements.display.buffer;if(N.element(a)){a.value=i;var s=a.getElementsByTagName("span")[0];N.element(s)&&(s.childNodes[0].nodeValue=i)}}(this.elements.display.buffer,100*this.buffered)}}},updateRangeFill:function(e){var t=N.event(e)?e.target:e;if(N.element(t)&&"range"===t.getAttribute("type")){if($(t,this.config.selectors.inputs.seek)){t.setAttribute("aria-valuenow",this.currentTime);var n=Ae.formatTime(this.currentTime),i=Ae.formatTime(this.duration),a=ge("seekLabel",this.config);t.setAttribute("aria-valuetext",a.replace("{currentTime}",n).replace("{duration}",i))}else if($(t,this.config.selectors.inputs.volume)){var s=100*t.value;t.setAttribute("aria-valuenow",s),t.setAttribute("aria-valuetext","".concat(s.toFixed(1),"%"))}else t.setAttribute("aria-valuenow",t.value);L.isWebkit&&t.style.setProperty("--value","".concat(t.value/t.max*100,"%"))}},updateSeekTooltip:function(e){var t=this;if(this.config.tooltips.seek&&N.element(this.elements.inputs.seek)&&N.element(this.elements.display.seekTooltip)&&0!==this.duration){var n="".concat(this.config.classNames.tooltip,"--visible"),i=function(e){return X(t.elements.display.seekTooltip,n,e)};if(this.touch)i(!1);else{var a=0,s=this.elements.progress.getBoundingClientRect();if(N.event(e))a=100/s.width*(e.pageX-s.left);else{if(!J(this.elements.display.seekTooltip,n))return;a=parseFloat(this.elements.display.seekTooltip.style.left,10)}a<0?a=0:a>100&&(a=100),Ae.updateTimeDisplay.call(this,this.elements.display.seekTooltip,this.duration/100*a),this.elements.display.seekTooltip.style.left="".concat(a,"%"),N.event(e)&&["mouseenter","mouseleave"].includes(e.type)&&i("mouseenter"===e.type)}}},timeUpdate:function(e){var t=!N.element(this.elements.display.duration)&&this.config.invertTime;Ae.updateTimeDisplay.call(this,this.elements.display.currentTime,t?this.duration-this.currentTime:this.currentTime,t),e&&"timeupdate"===e.type&&this.media.seeking||Ae.updateProgress.call(this,e)},durationUpdate:function(){if(this.supported.ui&&(this.config.invertTime||!this.currentTime)){if(this.duration>=Math.pow(2,32))return Q(this.elements.display.currentTime,!0),void Q(this.elements.progress,!0);N.element(this.elements.inputs.seek)&&this.elements.inputs.seek.setAttribute("aria-valuemax",this.duration);var e=N.element(this.elements.display.duration);!e&&this.config.displayDuration&&this.paused&&Ae.updateTimeDisplay.call(this,this.elements.display.currentTime,this.duration),e&&Ae.updateTimeDisplay.call(this,this.elements.display.duration,this.duration),Ae.updateSeekTooltip.call(this)}},toggleMenuButton:function(e,t){Q(this.elements.settings.buttons[e],!t)},updateSetting:function(e,t,n){var i=this.elements.settings.panels[e],a=null,s=t;if("captions"===e)a=this.currentTrack;else{if(a=N.empty(n)?this[e]:n,N.empty(a)&&(a=this.config[e].default),!N.empty(this.options[e])&&!this.options[e].includes(a))return void this.debug.warn("Unsupported value of '".concat(a,"' for ").concat(e));if(!this.config[e].options.includes(a))return void this.debug.warn("Disabled value of '".concat(a,"' for ").concat(e))}if(N.element(s)||(s=i&&i.querySelector('[role="menu"]')),N.element(s)){this.elements.settings.buttons[e].querySelector(".".concat(this.config.classNames.menu.value)).innerHTML=Ae.getLabel.call(this,e,a);var r=s&&s.querySelector('[value="'.concat(a,'"]'));N.element(r)&&(r.checked=!0)}},getLabel:function(e,t){switch(e){case"speed":return 1===t?ge("normal",this.config):"".concat(t,"&times;");case"quality":if(N.number(t)){var n=ge("qualityLabel.".concat(t),this.config);return n.length?n:"".concat(t,"p")}return he(t);case"captions":return Pe.getLabel.call(this);default:return null}},setQualityMenu:function(e){var t=this;if(N.element(this.elements.settings.panels.quality)){var n=this.elements.settings.panels.quality.querySelector('[role="menu"]');N.array(e)&&(this.options.quality=ce(e).filter(function(e){return t.config.quality.options.includes(e)}));var i=!N.empty(this.options.quality)&&this.options.quality.length>1;if(Ae.toggleMenuButton.call(this,"quality",i),z(n),Ae.checkMenu.call(this),i){var a=function(e){var n=ge("qualityBadge.".concat(e),t.config);return n.length?Ae.createBadge.call(t,n):null};this.options.quality.sort(function(e,n){var i=t.config.quality.options;return i.indexOf(e)>i.indexOf(n)?1:-1}).forEach(function(e){Ae.createMenuItem.call(t,{value:e,list:n,type:"quality",title:Ae.getLabel.call(t,"quality",e),badge:a(e)})}),Ae.updateSetting.call(this,"quality",n)}}},setCaptionsMenu:function(){var e=this;if(N.element(this.elements.settings.panels.captions)){var t=this.elements.settings.panels.captions.querySelector('[role="menu"]'),n=Pe.getTracks.call(this),i=Boolean(n.length);if(Ae.toggleMenuButton.call(this,"captions",i),z(t),Ae.checkMenu.call(this),i){var a=n.map(function(n,i){return{value:i,checked:e.captions.toggled&&e.currentTrack===i,title:Pe.getLabel.call(e,n),badge:n.language&&Ae.createBadge.call(e,n.language.toUpperCase()),list:t,type:"language"}});a.unshift({value:-1,checked:!this.captions.toggled,title:ge("disabled",this.config),list:t,type:"language"}),a.forEach(Ae.createMenuItem.bind(this)),Ae.updateSetting.call(this,"captions",t)}}},setSpeedMenu:function(e){var t=this;if(N.element(this.elements.settings.panels.speed)){var n=this.elements.settings.panels.speed.querySelector('[role="menu"]');N.array(e)?this.options.speed=e:(this.isHTML5||this.isVimeo)&&(this.options.speed=[.5,.75,1,1.25,1.5,1.75,2]),this.options.speed=this.options.speed.filter(function(e){return t.config.speed.options.includes(e)});var i=!N.empty(this.options.speed)&&this.options.speed.length>1;Ae.toggleMenuButton.call(this,"speed",i),z(n),Ae.checkMenu.call(this),i&&(this.options.speed.forEach(function(e){Ae.createMenuItem.call(t,{value:e,list:n,type:"speed",title:Ae.getLabel.call(t,"speed",e)})}),Ae.updateSetting.call(this,"speed",n))}},checkMenu:function(){var e=this.elements.settings.buttons,t=!N.empty(e)&&Object.values(e).some(function(e){return!e.hidden});Q(this.elements.settings.menu,!t)},focusFirstMenuItem:function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(!this.elements.settings.popup.hidden){var n=e;N.element(n)||(n=Object.values(this.elements.settings.panels).find(function(e){return!e.hidden}));var i=n.querySelector('[role^="menuitem"]');ee.call(this,i,t)}},toggleMenu:function(e){var t=this.elements.settings.popup,n=this.elements.buttons.settings;if(N.element(t)&&N.element(n)){var i=t.hidden,a=i;if(N.boolean(e))a=e;else if(N.keyboardEvent(e)&&27===e.which)a=!1;else if(N.event(e)){var s=N.function(e.composedPath)?e.composedPath()[0]:e.target,r=t.contains(s);if(r||!r&&e.target!==n&&a)return}n.setAttribute("aria-expanded",a),Q(t,!a),X(this.elements.container,this.config.classNames.menu.open,a),a&&N.keyboardEvent(e)?Ae.focusFirstMenuItem.call(this,null,!0):a||i||ee.call(this,n,N.keyboardEvent(e))}},getMenuSize:function(e){var t=e.cloneNode(!0);t.style.position="absolute",t.style.opacity=0,t.removeAttribute("hidden"),e.parentNode.appendChild(t);var n=t.scrollWidth,i=t.scrollHeight;return W(t),{width:n,height:i}},showMenuPanel:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",n=arguments.length>1&&void 0!==arguments[1]&&arguments[1],i=this.elements.container.querySelector("#plyr-settings-".concat(this.id,"-").concat(t));if(N.element(i)){var a=i.parentNode,s=Array.from(a.children).find(function(e){return!e.hidden});if(ie.transitions&&!ie.reducedMotion){a.style.width="".concat(s.scrollWidth,"px"),a.style.height="".concat(s.scrollHeight,"px");var r=Ae.getMenuSize.call(this,i);O.call(this,a,M,function t(n){n.target===a&&["width","height"].includes(n.propertyName)&&(a.style.width="",a.style.height="",j.call(e,a,M,t))}),a.style.width="".concat(r.width,"px"),a.style.height="".concat(r.height,"px")}Q(s,!0),Q(i,!1),Ae.focusFirstMenuItem.call(this,i,n)}},setDownloadUrl:function(){var e=this.elements.buttons.download;N.element(e)&&e.setAttribute("href",this.download)},create:function(e){var t=this,n=Ae.bindMenuItemShortcuts,i=Ae.createButton,a=Ae.createProgress,s=Ae.createRange,r=Ae.createTime,o=Ae.setQualityMenu,l=Ae.setSpeedMenu,c=Ae.showMenuPanel;this.elements.controls=null,this.config.controls.includes("play-large")&&this.elements.container.appendChild(i.call(this,"play-large"));var u=B("div",Y(this.config.selectors.controls.wrapper));this.elements.controls=u;var d={class:"plyr__controls__item"};return ce(this.config.controls).forEach(function(o){if("restart"===o&&u.appendChild(i.call(t,"restart",d)),"rewind"===o&&u.appendChild(i.call(t,"rewind",d)),"play"===o&&u.appendChild(i.call(t,"play",d)),"fast-forward"===o&&u.appendChild(i.call(t,"fast-forward",d)),"progress"===o){var l=B("div",{class:"".concat(d.class," plyr__progress__container")}),h=B("div",Y(t.config.selectors.progress));if(h.appendChild(s.call(t,"seek",{id:"plyr-seek-".concat(e.id)})),h.appendChild(a.call(t,"buffer")),t.config.tooltips.seek){var m=B("span",{class:t.config.classNames.tooltip},"00:00");h.appendChild(m),t.elements.display.seekTooltip=m}t.elements.progress=h,l.appendChild(t.elements.progress),u.appendChild(l)}if("current-time"===o&&u.appendChild(r.call(t,"currentTime",d)),"duration"===o&&u.appendChild(r.call(t,"duration",d)),"mute"===o||"volume"===o){var p=t.elements.volume;if(N.element(p)&&u.contains(p)||(p=B("div",F({},d,{class:"".concat(d.class," plyr__volume").trim()})),t.elements.volume=p,u.appendChild(p)),"mute"===o&&p.appendChild(i.call(t,"mute")),"volume"===o){var f={max:1,step:.05,value:t.config.volume};p.appendChild(s.call(t,"volume",F(f,{id:"plyr-volume-".concat(e.id)})))}}if("captions"===o&&u.appendChild(i.call(t,"captions",d)),"settings"===o&&!N.empty(t.config.settings)){var g=B("div",F({},d,{class:"".concat(d.class," plyr__menu").trim(),hidden:""}));g.appendChild(i.call(t,"settings",{"aria-haspopup":!0,"aria-controls":"plyr-settings-".concat(e.id),"aria-expanded":!1}));var y=B("div",{class:"plyr__menu__container",id:"plyr-settings-".concat(e.id),hidden:""}),v=B("div"),b=B("div",{id:"plyr-settings-".concat(e.id,"-home")}),k=B("div",{role:"menu"});b.appendChild(k),v.appendChild(b),t.elements.settings.panels.home=b,t.config.settings.forEach(function(i){var a=B("button",F(Y(t.config.selectors.buttons.settings),{type:"button",class:"".concat(t.config.classNames.control," ").concat(t.config.classNames.control,"--forward"),role:"menuitem","aria-haspopup":!0,hidden:""}));n.call(t,a,i),O(a,"click",function(){c.call(t,i,!1)});var s=B("span",null,ge(i,t.config)),r=B("span",{class:t.config.classNames.menu.value});r.innerHTML=e[i],s.appendChild(r),a.appendChild(s),k.appendChild(a);var o=B("div",{id:"plyr-settings-".concat(e.id,"-").concat(i),hidden:""}),l=B("button",{type:"button",class:"".concat(t.config.classNames.control," ").concat(t.config.classNames.control,"--back")});l.appendChild(B("span",{"aria-hidden":!0},ge(i,t.config))),l.appendChild(B("span",{class:t.config.classNames.hidden},ge("menuBack",t.config))),O(o,"keydown",function(e){37===e.which&&(e.preventDefault(),e.stopPropagation(),c.call(t,"home",!0))},!1),O(l,"click",function(){c.call(t,"home",!1)}),o.appendChild(l),o.appendChild(B("div",{role:"menu"})),v.appendChild(o),t.elements.settings.buttons[i]=a,t.elements.settings.panels[i]=o}),y.appendChild(v),g.appendChild(y),u.appendChild(g),t.elements.settings.popup=y,t.elements.settings.menu=g}if("pip"===o&&ie.pip&&u.appendChild(i.call(t,"pip",d)),"airplay"===o&&ie.airplay&&u.appendChild(i.call(t,"airplay",d)),"download"===o){var w=F({},d,{element:"a",href:t.download,target:"_blank"}),T=t.config.urls.download;!N.url(T)&&t.isEmbed&&F(w,{icon:"logo-".concat(t.provider),label:t.provider}),u.appendChild(i.call(t,"download",w))}"fullscreen"===o&&u.appendChild(i.call(t,"fullscreen",d))}),this.isHTML5&&o.call(this,le.getQualityOptions.call(this)),l.call(this),u},inject:function(){var e=this;if(this.config.loadSprite){var t=Ae.getIconUrl.call(this);t.cors&&be(t.url,"sprite-plyr")}this.id=Math.floor(1e4*Math.random());var n=null;this.elements.controls=null;var i={id:this.id,seektime:this.config.seekTime,title:this.config.title},s=!0;N.function(this.config.controls)&&(this.config.controls=this.config.controls.call(this,i)),this.config.controls||(this.config.controls=[]),N.element(this.config.controls)||N.string(this.config.controls)?n=this.config.controls:(n=Ae.create.call(this,{id:this.id,seektime:this.config.seekTime,speed:this.speed,quality:this.quality,captions:Pe.getLabel.call(this)}),s=!1);var r,o=function(e){var t=e;return Object.entries(i).forEach(function(e){var n=a(e,2),i=n[0],s=n[1];t=de(t,"{".concat(i,"}"),s)}),t};if(s&&(N.string(this.config.controls)?n=o(n):N.element(n)&&(n.innerHTML=o(n.innerHTML))),N.string(this.config.selectors.controls.container)&&(r=document.querySelector(this.config.selectors.controls.container)),N.element(r)||(r=this.elements.container),r[N.element(n)?"insertAdjacentElement":"insertAdjacentHTML"]("afterbegin",n),N.element(this.elements.controls)||Ae.findElements.call(this),!N.empty(this.elements.buttons)){var l=function(t){var n=e.config.classNames.controlPressed;Object.defineProperty(t,"pressed",{enumerable:!0,get:function(){return J(t,n)},set:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];X(t,n,e)}})};Object.values(this.elements.buttons).filter(Boolean).forEach(function(e){N.array(e)||N.nodeList(e)?Array.from(e).filter(Boolean).forEach(l):l(e)})}if(L.isEdge&&x(r),this.config.tooltips.controls){var c=this.config,u=c.classNames,d=c.selectors,h="".concat(d.controls.wrapper," ").concat(d.labels," .").concat(u.hidden),m=G.call(this,h);Array.from(m).forEach(function(t){X(t,e.config.classNames.hidden,!1),X(t,e.config.classNames.tooltip,!0)})}}};function Ee(e){var t=e;if(!(arguments.length>1&&void 0!==arguments[1])||arguments[1]){var n=document.createElement("a");n.href=t,t=n.href}try{return new URL(t)}catch(e){return null}}function Se(e){var t=new URLSearchParams;return N.object(e)&&Object.entries(e).forEach(function(e){var n=a(e,2),i=n[0],s=n[1];t.set(i,s)}),t}var Pe={setup:function(){if(this.supported.ui)if(!this.isVideo||this.isYouTube||this.isHTML5&&!ie.textTracks)N.array(this.config.controls)&&this.config.controls.includes("settings")&&this.config.settings.includes("captions")&&Ae.setCaptionsMenu.call(this);else{if(N.element(this.elements.captions)||(this.elements.captions=B("div",Y(this.config.selectors.captions)),function(e,t){N.element(e)&&N.element(t)&&t.parentNode.insertBefore(e,t.nextSibling)}(this.elements.captions,this.elements.wrapper)),L.isIE&&window.URL){var e=this.media.querySelectorAll("track");Array.from(e).forEach(function(e){var t=e.getAttribute("src"),n=Ee(t);null!==n&&n.hostname!==window.location.href.hostname&&["http:","https:"].includes(n.protocol)&&ve(t,"blob").then(function(t){e.setAttribute("src",window.URL.createObjectURL(t))}).catch(function(){W(e)})})}var t=ce((navigator.languages||[navigator.language||navigator.userLanguage||"en"]).map(function(e){return e.split("-")[0]})),n=(this.storage.get("language")||this.config.captions.language||"auto").toLowerCase();if("auto"===n)n=a(t,1)[0];var i=this.storage.get("captions");if(N.boolean(i)||(i=this.config.captions.active),Object.assign(this.captions,{toggled:!1,active:i,language:n,languages:t}),this.isHTML5){var s=this.config.captions.update?"addtrack removetrack":"removetrack";O.call(this,this.media.textTracks,s,Pe.update.bind(this))}setTimeout(Pe.update.bind(this),0)}},update:function(){var e=this,t=Pe.getTracks.call(this,!0),n=this.captions,i=n.active,a=n.language,s=n.meta,r=n.currentTrackNode,o=Boolean(t.find(function(e){return e.language===a}));this.isHTML5&&this.isVideo&&t.filter(function(e){return!s.get(e)}).forEach(function(t){e.debug.log("Track added",t),s.set(t,{default:"showing"===t.mode}),t.mode="hidden",O.call(e,t,"cuechange",function(){return Pe.updateCues.call(e)})}),(o&&this.language!==a||!t.includes(r))&&(Pe.setLanguage.call(this,a),Pe.toggle.call(this,i&&o)),X(this.elements.container,this.config.classNames.captions.enabled,!N.empty(t)),(this.config.controls||[]).includes("settings")&&this.config.settings.includes("captions")&&Ae.setCaptionsMenu.call(this)},toggle:function(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(this.supported.ui){var n=this.captions.toggled,i=this.config.classNames.captions.active,a=N.nullOrUndefined(e)?!n:e;if(a!==n){if(t||(this.captions.active=a,this.storage.set({captions:a})),!this.language&&a&&!t){var r=Pe.getTracks.call(this),o=Pe.findTrack.call(this,[this.captions.language].concat(s(this.captions.languages)),!0);return this.captions.language=o.language,void Pe.set.call(this,r.indexOf(o))}this.elements.buttons.captions&&(this.elements.buttons.captions.pressed=a),X(this.elements.container,i,a),this.captions.toggled=a,Ae.updateSetting.call(this,"captions"),H.call(this,this.media,a?"captionsenabled":"captionsdisabled")}}},set:function(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],n=Pe.getTracks.call(this);if(-1!==e)if(N.number(e))if(e in n){if(this.captions.currentTrack!==e){this.captions.currentTrack=e;var i=n[e],a=(i||{}).language;this.captions.currentTrackNode=i,Ae.updateSetting.call(this,"captions"),t||(this.captions.language=a,this.storage.set({language:a})),this.isVimeo&&this.embed.enableTextTrack(a),H.call(this,this.media,"languagechange")}Pe.toggle.call(this,!0,t),this.isHTML5&&this.isVideo&&Pe.updateCues.call(this)}else this.debug.warn("Track not found",e);else this.debug.warn("Invalid caption argument",e);else Pe.toggle.call(this,!1,t)},setLanguage:function(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(N.string(e)){var n=e.toLowerCase();this.captions.language=n;var i=Pe.getTracks.call(this),a=Pe.findTrack.call(this,[n]);Pe.set.call(this,i.indexOf(a),t)}else this.debug.warn("Invalid language argument",e)},getTracks:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];return Array.from((this.media||{}).textTracks||[]).filter(function(n){return!e.isHTML5||t||e.captions.meta.has(n)}).filter(function(e){return["captions","subtitles"].includes(e.kind)})},findTrack:function(e){var t,n=this,i=arguments.length>1&&void 0!==arguments[1]&&arguments[1],a=Pe.getTracks.call(this),s=function(e){return Number((n.captions.meta.get(e)||{}).default)},r=Array.from(a).sort(function(e,t){return s(t)-s(e)});return e.every(function(e){return!(t=r.find(function(t){return t.language===e}))}),t||(i?r[0]:void 0)},getCurrentTrack:function(){return Pe.getTracks.call(this)[this.currentTrack]},getLabel:function(e){var t=e;return!N.track(t)&&ie.textTracks&&this.captions.toggled&&(t=Pe.getCurrentTrack.call(this)),N.track(t)?N.empty(t.label)?N.empty(t.language)?ge("enabled",this.config):e.language.toUpperCase():t.label:ge("disabled",this.config)},updateCues:function(e){if(this.supported.ui)if(N.element(this.elements.captions))if(N.nullOrUndefined(e)||Array.isArray(e)){var t=e;if(!t){var n=Pe.getCurrentTrack.call(this);t=Array.from((n||{}).activeCues||[]).map(function(e){return e.getCueAsHTML()}).map(pe)}var i=t.map(function(e){return e.trim()}).join("\n");if(i!==this.elements.captions.innerHTML){z(this.elements.captions);var a=B("span",Y(this.config.selectors.caption));a.innerHTML=i,this.elements.captions.appendChild(a),H.call(this,this.media,"cuechange")}}else this.debug.warn("updateCues: Invalid input",e);else this.debug.warn("No captions element to render to")}},Ne={enabled:!0,title:"",debug:!1,autoplay:!1,autopause:!0,playsinline:!0,seekTime:10,volume:1,muted:!1,duration:null,displayDuration:!0,invertTime:!0,toggleInvert:!0,ratio:null,clickToPlay:!0,hideControls:!0,resetOnEnd:!1,disableContextMenu:!0,loadSprite:!0,iconPrefix:"plyr",iconUrl:"https://cdn.plyr.io/3.5.6/plyr.svg",blankVideo:"https://cdn.plyr.io/static/blank.mp4",quality:{default:576,options:[4320,2880,2160,1440,1080,720,576,480,360,240]},loop:{active:!1},speed:{selected:1,options:[.5,.75,1,1.25,1.5,1.75,2]},keyboard:{focused:!0,global:!1},tooltips:{controls:!1,seek:!0},captions:{active:!1,language:"auto",update:!1},fullscreen:{enabled:!0,fallback:!0,iosNative:!1},storage:{enabled:!0,key:"plyr"},controls:["play-large","play","progress","current-time","mute","volume","captions","settings","pip","airplay","fullscreen"],settings:["captions","quality","speed"],i18n:{restart:"Restart",rewind:"Rewind {seektime}s",play:"Play",pause:"Pause",fastForward:"Forward {seektime}s",seek:"Seek",seekLabel:"{currentTime} of {duration}",played:"Played",buffered:"Buffered",currentTime:"Current time",duration:"Duration",volume:"Volume",mute:"Mute",unmute:"Unmute",enableCaptions:"Enable captions",disableCaptions:"Disable captions",download:"Download",enterFullscreen:"Enter fullscreen",exitFullscreen:"Exit fullscreen",frameTitle:"Player for {title}",captions:"Captions",settings:"Settings",menuBack:"Go back to previous menu",speed:"Speed",normal:"Normal",quality:"Quality",loop:"Loop",start:"Start",end:"End",all:"All",reset:"Reset",disabled:"Disabled",enabled:"Enabled",advertisement:"Ad",qualityBadge:{2160:"4K",1440:"HD",1080:"HD",720:"HD",576:"SD",480:"SD"}},urls:{download:null,vimeo:{sdk:"https://player.vimeo.com/api/player.js",iframe:"https://player.vimeo.com/video/{0}?{1}",api:"https://vimeo.com/api/v2/video/{0}.json"},youtube:{sdk:"https://www.youtube.com/iframe_api",api:"https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}"},googleIMA:{sdk:"https://imasdk.googleapis.com/js/sdkloader/ima3.js"}},listeners:{seek:null,play:null,pause:null,restart:null,rewind:null,fastForward:null,mute:null,volume:null,captions:null,download:null,fullscreen:null,pip:null,airplay:null,speed:null,quality:null,loop:null,language:null},events:["ended","progress","stalled","playing","waiting","canplay","canplaythrough","loadstart","loadeddata","loadedmetadata","timeupdate","volumechange","play","pause","error","seeking","seeked","emptied","ratechange","cuechange","download","enterfullscreen","exitfullscreen","captionsenabled","captionsdisabled","languagechange","controlshidden","controlsshown","ready","statechange","qualitychange","adsloaded","adscontentpause","adscontentresume","adstarted","adsmidpoint","adscomplete","adsallcomplete","adsimpression","adsclick"],selectors:{editable:"input, textarea, select, [contenteditable]",container:".plyr",controls:{container:null,wrapper:".plyr__controls"},labels:"[data-plyr]",buttons:{play:'[data-plyr="play"]',pause:'[data-plyr="pause"]',restart:'[data-plyr="restart"]',rewind:'[data-plyr="rewind"]',fastForward:'[data-plyr="fast-forward"]',mute:'[data-plyr="mute"]',captions:'[data-plyr="captions"]',download:'[data-plyr="download"]',fullscreen:'[data-plyr="fullscreen"]',pip:'[data-plyr="pip"]',airplay:'[data-plyr="airplay"]',settings:'[data-plyr="settings"]',loop:'[data-plyr="loop"]'},inputs:{seek:'[data-plyr="seek"]',volume:'[data-plyr="volume"]',speed:'[data-plyr="speed"]',language:'[data-plyr="language"]',quality:'[data-plyr="quality"]'},display:{currentTime:".plyr__time--current",duration:".plyr__time--duration",buffer:".plyr__progress__buffer",loop:".plyr__progress__loop",volume:".plyr__volume--display"},progress:".plyr__progress",captions:".plyr__captions",caption:".plyr__caption"},classNames:{type:"plyr--{0}",provider:"plyr--{0}",video:"plyr__video-wrapper",embed:"plyr__video-embed",videoFixedRatio:"plyr__video-wrapper--fixed-ratio",embedContainer:"plyr__video-embed__container",poster:"plyr__poster",posterEnabled:"plyr__poster-enabled",ads:"plyr__ads",control:"plyr__control",controlPressed:"plyr__control--pressed",playing:"plyr--playing",paused:"plyr--paused",stopped:"plyr--stopped",loading:"plyr--loading",hover:"plyr--hover",tooltip:"plyr__tooltip",cues:"plyr__cues",hidden:"plyr__sr-only",hideControls:"plyr--hide-controls",isIos:"plyr--is-ios",isTouch:"plyr--is-touch",uiSupported:"plyr--full-ui",noTransition:"plyr--no-transition",display:{time:"plyr__time"},menu:{value:"plyr__menu__value",badge:"plyr__badge",open:"plyr--menu-open"},captions:{enabled:"plyr--captions-enabled",active:"plyr--captions-active"},fullscreen:{enabled:"plyr--fullscreen-enabled",fallback:"plyr--fullscreen-fallback"},pip:{supported:"plyr--pip-supported",active:"plyr--pip-active"},airplay:{supported:"plyr--airplay-supported",active:"plyr--airplay-active"},tabFocus:"plyr__tab-focus",previewThumbnails:{thumbContainer:"plyr__preview-thumb",thumbContainerShown:"plyr__preview-thumb--is-shown",imageContainer:"plyr__preview-thumb__image-container",timeContainer:"plyr__preview-thumb__time-container",scrubbingContainer:"plyr__preview-scrubbing",scrubbingContainerShown:"plyr__preview-scrubbing--is-shown"}},attributes:{embed:{provider:"data-plyr-provider",id:"data-plyr-embed-id"}},ads:{enabled:!1,publisherId:"",tagUrl:""},previewThumbnails:{enabled:!1,src:""},vimeo:{byline:!1,portrait:!1,title:!1,speed:!0,transparent:!1},youtube:{noCookie:!1,rel:0,showinfo:0,iv_load_policy:3,modestbranding:1}},Me="picture-in-picture",xe="inline",Le={html5:"html5",youtube:"youtube",vimeo:"vimeo"},Ie={audio:"audio",video:"video"};var _e=function(){},Oe=function(){function t(){var n=arguments.length>0&&void 0!==arguments[0]&&arguments[0];e(this,t),this.enabled=window.console&&n,this.enabled&&this.log("Debugging enabled")}return n(t,[{key:"log",get:function(){return this.enabled?Function.prototype.bind.call(console.log,console):_e}},{key:"warn",get:function(){return this.enabled?Function.prototype.bind.call(console.warn,console):_e}},{key:"error",get:function(){return this.enabled?Function.prototype.bind.call(console.error,console):_e}}]),t}();function je(){if(this.enabled){var e=this.player.elements.buttons.fullscreen;N.element(e)&&(e.pressed=this.active),H.call(this.player,this.target,this.active?"enterfullscreen":"exitfullscreen",!0),L.isIos||function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(N.element(e)){var n=G.call(this,"button:not(:disabled), input:not(:disabled), [tabindex]"),i=n[0],a=n[n.length-1];_.call(this,this.elements.container,"keydown",function(e){if("Tab"===e.key&&9===e.keyCode){var t=document.activeElement;t!==a||e.shiftKey?t===i&&e.shiftKey&&(a.focus(),e.preventDefault()):(i.focus(),e.preventDefault())}},t,!1)}}.call(this.player,this.target,this.active)}}function qe(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(e?this.scrollPosition={x:window.scrollX||0,y:window.scrollY||0}:window.scrollTo(this.scrollPosition.x,this.scrollPosition.y),document.body.style.overflow=e?"hidden":"",X(this.target,this.player.config.classNames.fullscreen.fallback,e),L.isIos){var t=document.head.querySelector('meta[name="viewport"]'),n="viewport-fit=cover";t||(t=document.createElement("meta")).setAttribute("name","viewport");var i=N.string(t.content)&&t.content.includes(n);e?(this.cleanupViewport=!i,i||(t.content+=",".concat(n))):this.cleanupViewport&&(t.content=t.content.split(",").filter(function(e){return e.trim()!==n}).join(","))}je.call(this)}var He=function(){function t(n){var i=this;e(this,t),this.player=n,this.prefix=t.prefix,this.property=t.property,this.scrollPosition={x:0,y:0},this.forceFallback="force"===n.config.fullscreen.fallback,O.call(this.player,document,"ms"===this.prefix?"MSFullscreenChange":"".concat(this.prefix,"fullscreenchange"),function(){je.call(i)}),O.call(this.player,this.player.elements.container,"dblclick",function(e){N.element(i.player.elements.controls)&&i.player.elements.controls.contains(e.target)||i.toggle()}),this.update()}return n(t,[{key:"update",value:function(){var e;this.enabled?(e=this.forceFallback?"Fallback (forced)":t.native?"Native":"Fallback",this.player.debug.log("".concat(e," fullscreen enabled"))):this.player.debug.log("Fullscreen not supported and fallback disabled");X(this.player.elements.container,this.player.config.classNames.fullscreen.enabled,this.enabled)}},{key:"enter",value:function(){this.enabled&&(L.isIos&&this.player.config.fullscreen.iosNative?this.target.webkitEnterFullscreen():!t.native||this.forceFallback?qe.call(this,!0):this.prefix?N.empty(this.prefix)||this.target["".concat(this.prefix,"Request").concat(this.property)]():this.target.requestFullscreen())}},{key:"exit",value:function(){if(this.enabled)if(L.isIos&&this.player.config.fullscreen.iosNative)this.target.webkitExitFullscreen(),this.player.play();else if(!t.native||this.forceFallback)qe.call(this,!1);else if(this.prefix){if(!N.empty(this.prefix)){var e="moz"===this.prefix?"Cancel":"Exit";document["".concat(this.prefix).concat(e).concat(this.property)]()}}else(document.cancelFullScreen||document.exitFullscreen).call(document)}},{key:"toggle",value:function(){this.active?this.exit():this.enter()}},{key:"usingNative",get:function(){return t.native&&!this.forceFallback}},{key:"enabled",get:function(){return(t.native||this.player.config.fullscreen.fallback)&&this.player.config.fullscreen.enabled&&this.player.supported.ui&&this.player.isVideo}},{key:"active",get:function(){return!!this.enabled&&(!t.native||this.forceFallback?J(this.target,this.player.config.classNames.fullscreen.fallback):(this.prefix?document["".concat(this.prefix).concat(this.property,"Element")]:document.fullscreenElement)===this.target)}},{key:"target",get:function(){return L.isIos&&this.player.config.fullscreen.iosNative?this.player.media:this.player.elements.container}}],[{key:"native",get:function(){return!!(document.fullscreenEnabled||document.webkitFullscreenEnabled||document.mozFullScreenEnabled||document.msFullscreenEnabled)}},{key:"prefix",get:function(){if(N.function(document.exitFullscreen))return"";var e="";return["webkit","moz","ms"].some(function(t){return!(!N.function(document["".concat(t,"ExitFullscreen")])&&!N.function(document["".concat(t,"CancelFullScreen")]))&&(e=t,!0)}),e}},{key:"property",get:function(){return"moz"===this.prefix?"FullScreen":"Fullscreen"}}]),t}();function De(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;return new Promise(function(n,i){var a=new Image,s=function(){delete a.onload,delete a.onerror,(a.naturalWidth>=t?n:i)(a)};Object.assign(a,{onload:s,onerror:s,src:e})})}var Fe={addStyleHook:function(){X(this.elements.container,this.config.selectors.container.replace(".",""),!0),X(this.elements.container,this.config.classNames.uiSupported,this.supported.ui)},toggleNativeControls:function(){arguments.length>0&&void 0!==arguments[0]&&arguments[0]&&this.isHTML5?this.media.setAttribute("controls",""):this.media.removeAttribute("controls")},build:function(){var e=this;if(this.listeners.media(),!this.supported.ui)return this.debug.warn("Basic support only for ".concat(this.provider," ").concat(this.type)),void Fe.toggleNativeControls.call(this,!0);N.element(this.elements.controls)||(Ae.inject.call(this),this.listeners.controls()),Fe.toggleNativeControls.call(this),this.isHTML5&&Pe.setup.call(this),this.volume=null,this.muted=null,this.loop=null,this.quality=null,this.speed=null,Ae.updateVolume.call(this),Ae.timeUpdate.call(this),Fe.checkPlaying.call(this),X(this.elements.container,this.config.classNames.pip.supported,ie.pip&&this.isHTML5&&this.isVideo),X(this.elements.container,this.config.classNames.airplay.supported,ie.airplay&&this.isHTML5),X(this.elements.container,this.config.classNames.isIos,L.isIos),X(this.elements.container,this.config.classNames.isTouch,this.touch),this.ready=!0,setTimeout(function(){H.call(e,e.media,"ready")},0),Fe.setTitle.call(this),this.poster&&Fe.setPoster.call(this,this.poster,!1).catch(function(){}),this.config.duration&&Ae.durationUpdate.call(this)},setTitle:function(){var e=ge("play",this.config);if(N.string(this.config.title)&&!N.empty(this.config.title)&&(e+=", ".concat(this.config.title)),Array.from(this.elements.buttons.play||[]).forEach(function(t){t.setAttribute("aria-label",e)}),this.isEmbed){var t=Z.call(this,"iframe");if(!N.element(t))return;var n=N.empty(this.config.title)?"video":this.config.title,i=ge("frameTitle",this.config);t.setAttribute("title",i.replace("{title}",n))}},togglePoster:function(e){X(this.elements.container,this.config.classNames.posterEnabled,e)},setPoster:function(e){var t=this;return arguments.length>1&&void 0!==arguments[1]&&!arguments[1]||!this.poster?(this.media.setAttribute("poster",e),function(){var e=this;return new Promise(function(t){return e.ready?setTimeout(t,0):O.call(e,e.elements.container,"ready",t)}).then(function(){})}.call(this).then(function(){return De(e)}).catch(function(n){throw e===t.poster&&Fe.togglePoster.call(t,!1),n}).then(function(){if(e!==t.poster)throw new Error("setPoster cancelled by later call to setPoster")}).then(function(){return Object.assign(t.elements.poster.style,{backgroundImage:"url('".concat(e,"')"),backgroundSize:""}),Fe.togglePoster.call(t,!0),e})):Promise.reject(new Error("Poster already set"))},checkPlaying:function(e){var t=this;X(this.elements.container,this.config.classNames.playing,this.playing),X(this.elements.container,this.config.classNames.paused,this.paused),X(this.elements.container,this.config.classNames.stopped,this.stopped),Array.from(this.elements.buttons.play||[]).forEach(function(e){Object.assign(e,{pressed:t.playing})}),N.event(e)&&"timeupdate"===e.type||Fe.toggleControls.call(this)},checkLoading:function(e){var t=this;this.loading=["stalled","waiting"].includes(e.type),clearTimeout(this.timers.loading),this.timers.loading=setTimeout(function(){X(t.elements.container,t.config.classNames.loading,t.loading),Fe.toggleControls.call(t)},this.loading?250:0)},toggleControls:function(e){var t=this.elements.controls;if(t&&this.config.hideControls){var n=this.touch&&this.lastSeekTime+2e3>Date.now();this.toggleControls(Boolean(e||this.loading||this.paused||t.pressed||t.hover||n))}}},Re=function(){function t(n){e(this,t),this.player=n,this.lastKey=null,this.focusTimer=null,this.lastKeyDown=null,this.handleKey=this.handleKey.bind(this),this.toggleMenu=this.toggleMenu.bind(this),this.setTabFocus=this.setTabFocus.bind(this),this.firstTouch=this.firstTouch.bind(this)}return n(t,[{key:"handleKey",value:function(e){var t=this.player,n=t.elements,i=e.keyCode?e.keyCode:e.which,a="keydown"===e.type,s=a&&i===this.lastKey;if(!(e.altKey||e.ctrlKey||e.metaKey||e.shiftKey)&&N.number(i)){if(a){var r=document.activeElement;if(N.element(r)){var o=t.config.selectors.editable;if(r!==n.inputs.seek&&$(r,o))return;if(32===e.which&&$(r,'button, [role^="menuitem"]'))return}switch([32,37,38,39,40,48,49,50,51,52,53,54,56,57,67,70,73,75,76,77,79].includes(i)&&(e.preventDefault(),e.stopPropagation()),i){case 48:case 49:case 50:case 51:case 52:case 53:case 54:case 55:case 56:case 57:s||(t.currentTime=t.duration/10*(i-48));break;case 32:case 75:s||t.togglePlay();break;case 38:t.increaseVolume(.1);break;case 40:t.decreaseVolume(.1);break;case 77:s||(t.muted=!t.muted);break;case 39:t.forward();break;case 37:t.rewind();break;case 70:t.fullscreen.toggle();break;case 67:s||t.toggleCaptions();break;case 76:t.loop=!t.loop}27===i&&!t.fullscreen.usingNative&&t.fullscreen.active&&t.fullscreen.toggle(),this.lastKey=i}else this.lastKey=null}}},{key:"toggleMenu",value:function(e){Ae.toggleMenu.call(this.player,e)}},{key:"firstTouch",value:function(){var e=this.player,t=e.elements;e.touch=!0,X(t.container,e.config.classNames.isTouch,!0)}},{key:"setTabFocus",value:function(e){var t=this.player,n=t.elements;if(clearTimeout(this.focusTimer),"keydown"!==e.type||9===e.which){"keydown"===e.type&&(this.lastKeyDown=e.timeStamp);var i,a=e.timeStamp-this.lastKeyDown<=20;if("focus"!==e.type||a)i=t.config.classNames.tabFocus,X(G.call(t,".".concat(i)),i,!1),this.focusTimer=setTimeout(function(){var e=document.activeElement;n.container.contains(e)&&X(document.activeElement,t.config.classNames.tabFocus,!0)},10)}}},{key:"global",value:function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0],t=this.player;t.config.keyboard.global&&_.call(t,window,"keydown keyup",this.handleKey,e,!1),_.call(t,document.body,"click",this.toggleMenu,e),q.call(t,document.body,"touchstart",this.firstTouch),_.call(t,document.body,"keydown focus blur",this.setTabFocus,e,!1,!0)}},{key:"container",value:function(){var e=this.player,t=e.config,n=e.elements,i=e.timers;!t.keyboard.global&&t.keyboard.focused&&O.call(e,n.container,"keydown keyup",this.handleKey,!1),O.call(e,n.container,"mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen",function(t){var a=n.controls;a&&"enterfullscreen"===t.type&&(a.pressed=!1,a.hover=!1);var s=0;["touchstart","touchmove","mousemove"].includes(t.type)&&(Fe.toggleControls.call(e,!0),s=e.touch?3e3:2e3),clearTimeout(i.controls),i.controls=setTimeout(function(){return Fe.toggleControls.call(e,!1)},s)});var s=function(t){if(!t)return oe.call(e);var i=n.container.getBoundingClientRect(),a=i.width,s=i.height;return oe.call(e,"".concat(a,":").concat(s))},r=function(){clearTimeout(i.resized),i.resized=setTimeout(s,50)};O.call(e,n.container,"enterfullscreen exitfullscreen",function(t){var i=e.fullscreen,o=i.target,l=i.usingNative;if(o===n.container&&(e.isEmbed||!N.empty(e.config.ratio))){var c="enterfullscreen"===t.type,u=s(c);u.padding;!function(t,n,i){if(e.isVimeo){var s=e.elements.wrapper.firstChild,r=a(t,2)[1],o=a(re.call(e),2),l=o[0],c=o[1];s.style.maxWidth=i?"".concat(r/c*l,"px"):null,s.style.margin=i?"0 auto":null}}(u.ratio,0,c),l||(c?O.call(e,window,"resize",r):j.call(e,window,"resize",r))}})}},{key:"media",value:function(){var e=this,t=this.player,n=t.elements;if(O.call(t,t.media,"timeupdate seeking seeked",function(e){return Ae.timeUpdate.call(t,e)}),O.call(t,t.media,"durationchange loadeddata loadedmetadata",function(e){return Ae.durationUpdate.call(t,e)}),O.call(t,t.media,"canplay loadeddata",function(){Q(n.volume,!t.hasAudio),Q(n.buttons.mute,!t.hasAudio)}),O.call(t,t.media,"ended",function(){t.isHTML5&&t.isVideo&&t.config.resetOnEnd&&t.restart()}),O.call(t,t.media,"progress playing seeking seeked",function(e){return Ae.updateProgress.call(t,e)}),O.call(t,t.media,"volumechange",function(e){return Ae.updateVolume.call(t,e)}),O.call(t,t.media,"playing play pause ended emptied timeupdate",function(e){return Fe.checkPlaying.call(t,e)}),O.call(t,t.media,"waiting canplay seeked playing",function(e){return Fe.checkLoading.call(t,e)}),t.supported.ui&&t.config.clickToPlay&&!t.isAudio){var i=Z.call(t,".".concat(t.config.classNames.video));if(!N.element(i))return;O.call(t,n.container,"click",function(a){([n.container,i].includes(a.target)||i.contains(a.target))&&(t.touch&&t.config.hideControls||(t.ended?(e.proxy(a,t.restart,"restart"),e.proxy(a,t.play,"play")):e.proxy(a,t.togglePlay,"play")))})}t.supported.ui&&t.config.disableContextMenu&&O.call(t,n.wrapper,"contextmenu",function(e){e.preventDefault()},!1),O.call(t,t.media,"volumechange",function(){t.storage.set({volume:t.volume,muted:t.muted})}),O.call(t,t.media,"ratechange",function(){Ae.updateSetting.call(t,"speed"),t.storage.set({speed:t.speed})}),O.call(t,t.media,"qualitychange",function(e){Ae.updateSetting.call(t,"quality",null,e.detail.quality)}),O.call(t,t.media,"ready qualitychange",function(){Ae.setDownloadUrl.call(t)});var a=t.config.events.concat(["keyup","keydown"]).join(" ");O.call(t,t.media,a,function(e){var i=e.detail,a=void 0===i?{}:i;"error"===e.type&&(a=t.media.error),H.call(t,n.container,e.type,!0,a)})}},{key:"proxy",value:function(e,t,n){var i=this.player,a=i.config.listeners[n],s=!0;N.function(a)&&(s=a.call(i,e)),s&&N.function(t)&&t.call(i,e)}},{key:"bind",value:function(e,t,n,i){var a=this,s=!(arguments.length>4&&void 0!==arguments[4])||arguments[4],r=this.player,o=r.config.listeners[i],l=N.function(o);O.call(r,e,t,function(e){return a.proxy(e,n,i)},s&&!l)}},{key:"controls",value:function(){var e=this,t=this.player,n=t.elements,i=L.isIE?"change":"input";if(n.buttons.play&&Array.from(n.buttons.play).forEach(function(n){e.bind(n,"click",t.togglePlay,"play")}),this.bind(n.buttons.restart,"click",t.restart,"restart"),this.bind(n.buttons.rewind,"click",t.rewind,"rewind"),this.bind(n.buttons.fastForward,"click",t.forward,"fastForward"),this.bind(n.buttons.mute,"click",function(){t.muted=!t.muted},"mute"),this.bind(n.buttons.captions,"click",function(){return t.toggleCaptions()}),this.bind(n.buttons.download,"click",function(){H.call(t,t.media,"download")},"download"),this.bind(n.buttons.fullscreen,"click",function(){t.fullscreen.toggle()},"fullscreen"),this.bind(n.buttons.pip,"click",function(){t.pip="toggle"},"pip"),this.bind(n.buttons.airplay,"click",t.airplay,"airplay"),this.bind(n.buttons.settings,"click",function(e){e.stopPropagation(),Ae.toggleMenu.call(t,e)}),this.bind(n.buttons.settings,"keyup",function(e){var n=e.which;[13,32].includes(n)&&(13!==n?(e.preventDefault(),e.stopPropagation(),Ae.toggleMenu.call(t,e)):Ae.focusFirstMenuItem.call(t,null,!0))},null,!1),this.bind(n.settings.menu,"keydown",function(e){27===e.which&&Ae.toggleMenu.call(t,e)}),this.bind(n.inputs.seek,"mousedown mousemove",function(e){var t=n.progress.getBoundingClientRect(),i=100/t.width*(e.pageX-t.left);e.currentTarget.setAttribute("seek-value",i)}),this.bind(n.inputs.seek,"mousedown mouseup keydown keyup touchstart touchend",function(e){var n=e.currentTarget,i=e.keyCode?e.keyCode:e.which;if(!N.keyboardEvent(e)||39===i||37===i){t.lastSeekTime=Date.now();var a=n.hasAttribute("play-on-seeked"),s=["mouseup","touchend","keyup"].includes(e.type);a&&s?(n.removeAttribute("play-on-seeked"),t.play()):!s&&t.playing&&(n.setAttribute("play-on-seeked",""),t.pause())}}),L.isIos){var s=G.call(t,'input[type="range"]');Array.from(s).forEach(function(t){return e.bind(t,i,function(e){return x(e.target)})})}this.bind(n.inputs.seek,i,function(e){var n=e.currentTarget,i=n.getAttribute("seek-value");N.empty(i)&&(i=n.value),n.removeAttribute("seek-value"),t.currentTime=i/n.max*t.duration},"seek"),this.bind(n.progress,"mouseenter mouseleave mousemove",function(e){return Ae.updateSeekTooltip.call(t,e)}),this.bind(n.progress,"mousemove touchmove",function(e){var n=t.previewThumbnails;n&&n.loaded&&n.startMove(e)}),this.bind(n.progress,"mouseleave click",function(){var e=t.previewThumbnails;e&&e.loaded&&e.endMove(!1,!0)}),this.bind(n.progress,"mousedown touchstart",function(e){var n=t.previewThumbnails;n&&n.loaded&&n.startScrubbing(e)}),this.bind(n.progress,"mouseup touchend",function(e){var n=t.previewThumbnails;n&&n.loaded&&n.endScrubbing(e)}),L.isWebkit&&Array.from(G.call(t,'input[type="range"]')).forEach(function(n){e.bind(n,"input",function(e){return Ae.updateRangeFill.call(t,e.target)})}),t.config.toggleInvert&&!N.element(n.display.duration)&&this.bind(n.display.currentTime,"click",function(){0!==t.currentTime&&(t.config.invertTime=!t.config.invertTime,Ae.timeUpdate.call(t))}),this.bind(n.inputs.volume,i,function(e){t.volume=e.target.value},"volume"),this.bind(n.controls,"mouseenter mouseleave",function(e){n.controls.hover=!t.touch&&"mouseenter"===e.type}),this.bind(n.controls,"mousedown mouseup touchstart touchend touchcancel",function(e){n.controls.pressed=["mousedown","touchstart"].includes(e.type)}),this.bind(n.controls,"focusin",function(){var i=t.config,a=t.timers;X(n.controls,i.classNames.noTransition,!0),Fe.toggleControls.call(t,!0),setTimeout(function(){X(n.controls,i.classNames.noTransition,!1)},0);var s=e.touch?3e3:4e3;clearTimeout(a.controls),a.controls=setTimeout(function(){return Fe.toggleControls.call(t,!1)},s)}),this.bind(n.inputs.volume,"wheel",function(e){var n=e.webkitDirectionInvertedFromDevice,i=a([e.deltaX,-e.deltaY].map(function(e){return n?-e:e}),2),s=i[0],r=i[1],o=Math.sign(Math.abs(s)>Math.abs(r)?s:r);t.increaseVolume(o/50);var l=t.media.volume;(1===o&&l<1||-1===o&&l>0)&&e.preventDefault()},"volume",!1)}}]),t}();"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self&&self;var Ve=function(e,t){return e(t={exports:{}},t.exports),t.exports}(function(e,t){e.exports=function(){var e=function(){},t={},n={},i={};function a(e,t){if(e){var a=i[e];if(n[e]=t,a)for(;a.length;)a[0](e,t),a.splice(0,1)}}function s(t,n){t.call&&(t={success:t}),n.length?(t.error||e)(n):(t.success||e)(t)}function r(t,n,i,a){var s,o,l=document,c=i.async,u=(i.numRetries||0)+1,d=i.before||e,h=t.replace(/^(css|img)!/,"");a=a||0,/(^css!|\.css$)/.test(t)?((o=l.createElement("link")).rel="stylesheet",o.href=h,(s="hideFocus"in o)&&o.relList&&(s=0,o.rel="preload",o.as="style")):/(^img!|\.(png|gif|jpg|svg)$)/.test(t)?(o=l.createElement("img")).src=h:((o=l.createElement("script")).src=t,o.async=void 0===c||c),o.onload=o.onerror=o.onbeforeload=function(e){var l=e.type[0];if(s)try{o.sheet.cssText.length||(l="e")}catch(e){18!=e.code&&(l="e")}if("e"==l){if((a+=1)<u)return r(t,n,i,a)}else if("preload"==o.rel&&"style"==o.as)return o.rel="stylesheet";n(t,l,e.defaultPrevented)},!1!==d(t,o)&&l.head.appendChild(o)}function o(e,n,i){var o,l;if(n&&n.trim&&(o=n),l=(o?i:n)||{},o){if(o in t)throw"LoadJS";t[o]=!0}function c(t,n){!function(e,t,n){var i,a,s=(e=e.push?e:[e]).length,o=s,l=[];for(i=function(e,n,i){if("e"==n&&l.push(e),"b"==n){if(!i)return;l.push(e)}--s||t(l)},a=0;a<o;a++)r(e[a],i,n)}(e,function(e){s(l,e),t&&s({success:t,error:n},e),a(o,e)},l)}if(l.returnPromise)return new Promise(c);c()}return o.ready=function(e,t){return function(e,t){e=e.push?e:[e];var a,s,r,o=[],l=e.length,c=l;for(a=function(e,n){n.length&&o.push(e),--c||t(o)};l--;)s=e[l],(r=n[s])?a(s,r):(i[s]=i[s]||[]).push(a)}(e,function(e){s(t,e)}),o},o.done=function(e){a(e,[])},o.reset=function(){t={},n={},i={}},o.isDefined=function(e){return e in t},o}()});function Be(e){return new Promise(function(t,n){Ve(e,{success:t,error:n})})}function Ue(e){e&&!this.embed.hasPlayed&&(this.embed.hasPlayed=!0),this.media.paused===e&&(this.media.paused=!e,H.call(this,this.media,e?"play":"pause"))}var We={setup:function(){var e=this;X(this.elements.wrapper,this.config.classNames.embed,!0),oe.call(this),N.object(window.Vimeo)?We.ready.call(this):Be(this.config.urls.vimeo.sdk).then(function(){We.ready.call(e)}).catch(function(t){e.debug.warn("Vimeo SDK (player.js) failed to load",t)})},ready:function(){var e=this,t=this,n=t.config.vimeo,i=Se(F({},{loop:t.config.loop.active,autoplay:t.autoplay,muted:t.muted,gesture:"media",playsinline:!this.config.fullscreen.iosNative},n)),s=t.media.getAttribute("src");N.empty(s)&&(s=t.media.getAttribute(t.config.attributes.embed.id));var r,o=(r=s,N.empty(r)?null:N.number(Number(r))?r:r.match(/^.*(vimeo.com\/|video\/)(\d+).*/)?RegExp.$2:r),l=B("iframe"),c=ue(t.config.urls.vimeo.iframe,o,i);l.setAttribute("src",c),l.setAttribute("allowfullscreen",""),l.setAttribute("allowtransparency",""),l.setAttribute("allow","autoplay");var u=B("div",{poster:t.poster,class:t.config.classNames.embedContainer});u.appendChild(l),t.media=K(u,t.media),ve(ue(t.config.urls.vimeo.api,o),"json").then(function(e){if(!N.empty(e)){var n=new URL(e[0].thumbnail_large);n.pathname="".concat(n.pathname.split("_")[0],".jpg"),Fe.setPoster.call(t,n.href).catch(function(){})}}),t.embed=new window.Vimeo.Player(l,{autopause:t.config.autopause,muted:t.muted}),t.media.paused=!0,t.media.currentTime=0,t.supported.ui&&t.embed.disableTextTrack(),t.media.play=function(){return Ue.call(t,!0),t.embed.play()},t.media.pause=function(){return Ue.call(t,!1),t.embed.pause()},t.media.stop=function(){t.pause(),t.currentTime=0};var d=t.media.currentTime;Object.defineProperty(t.media,"currentTime",{get:function(){return d},set:function(e){var n=t.embed,i=t.media,a=t.paused,s=t.volume,r=a&&!n.hasPlayed;i.seeking=!0,H.call(t,i,"seeking"),Promise.resolve(r&&n.setVolume(0)).then(function(){return n.setCurrentTime(e)}).then(function(){return r&&n.pause()}).then(function(){return r&&n.setVolume(s)}).catch(function(){})}});var h=t.config.speed.selected;Object.defineProperty(t.media,"playbackRate",{get:function(){return h},set:function(e){t.embed.setPlaybackRate(e).then(function(){h=e,H.call(t,t.media,"ratechange")}).catch(function(e){"Error"===e.name&&Ae.setSpeedMenu.call(t,[])})}});var m=t.config.volume;Object.defineProperty(t.media,"volume",{get:function(){return m},set:function(e){t.embed.setVolume(e).then(function(){m=e,H.call(t,t.media,"volumechange")})}});var p=t.config.muted;Object.defineProperty(t.media,"muted",{get:function(){return p},set:function(e){var n=!!N.boolean(e)&&e;t.embed.setVolume(n?0:t.config.volume).then(function(){p=n,H.call(t,t.media,"volumechange")})}});var f,g=t.config.loop;Object.defineProperty(t.media,"loop",{get:function(){return g},set:function(e){var n=N.boolean(e)?e:t.config.loop.active;t.embed.setLoop(n).then(function(){g=n})}}),t.embed.getVideoUrl().then(function(e){f=e,Ae.setDownloadUrl.call(t)}).catch(function(t){e.debug.warn(t)}),Object.defineProperty(t.media,"currentSrc",{get:function(){return f}}),Object.defineProperty(t.media,"ended",{get:function(){return t.currentTime===t.duration}}),Promise.all([t.embed.getVideoWidth(),t.embed.getVideoHeight()]).then(function(n){var i=a(n,2),s=i[0],r=i[1];t.embed.ratio=[s,r],oe.call(e)}),t.embed.setAutopause(t.config.autopause).then(function(e){t.config.autopause=e}),t.embed.getVideoTitle().then(function(n){t.config.title=n,Fe.setTitle.call(e)}),t.embed.getCurrentTime().then(function(e){d=e,H.call(t,t.media,"timeupdate")}),t.embed.getDuration().then(function(e){t.media.duration=e,H.call(t,t.media,"durationchange")}),t.embed.getTextTracks().then(function(e){t.media.textTracks=e,Pe.setup.call(t)}),t.embed.on("cuechange",function(e){var n=e.cues,i=(void 0===n?[]:n).map(function(e){return function(e){var t=document.createDocumentFragment(),n=document.createElement("div");return t.appendChild(n),n.innerHTML=e,t.firstChild.innerText}(e.text)});Pe.updateCues.call(t,i)}),t.embed.on("loaded",function(){(t.embed.getPaused().then(function(e){Ue.call(t,!e),e||H.call(t,t.media,"playing")}),N.element(t.embed.element)&&t.supported.ui)&&t.embed.element.setAttribute("tabindex",-1)}),t.embed.on("play",function(){Ue.call(t,!0),H.call(t,t.media,"playing")}),t.embed.on("pause",function(){Ue.call(t,!1)}),t.embed.on("timeupdate",function(e){t.media.seeking=!1,d=e.seconds,H.call(t,t.media,"timeupdate")}),t.embed.on("progress",function(e){t.media.buffered=e.percent,H.call(t,t.media,"progress"),1===parseInt(e.percent,10)&&H.call(t,t.media,"canplaythrough"),t.embed.getDuration().then(function(e){e!==t.media.duration&&(t.media.duration=e,H.call(t,t.media,"durationchange"))})}),t.embed.on("seeked",function(){t.media.seeking=!1,H.call(t,t.media,"seeked")}),t.embed.on("ended",function(){t.media.paused=!0,H.call(t,t.media,"ended")}),t.embed.on("error",function(e){t.media.error=e,H.call(t,t.media,"error")}),setTimeout(function(){return Fe.build.call(t)},0)}};function ze(e){e&&!this.embed.hasPlayed&&(this.embed.hasPlayed=!0),this.media.paused===e&&(this.media.paused=!e,H.call(this,this.media,e?"play":"pause"))}function Ke(e){return e.noCookie?"https://www.youtube-nocookie.com":"http:"===window.location.protocol?"http://www.youtube.com":void 0}var Ye={setup:function(){var e=this;if(X(this.elements.wrapper,this.config.classNames.embed,!0),N.object(window.YT)&&N.function(window.YT.Player))Ye.ready.call(this);else{var t=window.onYouTubeIframeAPIReady;window.onYouTubeIframeAPIReady=function(){N.function(t)&&t(),Ye.ready.call(e)},Be(this.config.urls.youtube.sdk).catch(function(t){e.debug.warn("YouTube API failed to load",t)})}},getTitle:function(e){var t=this;ve(ue(this.config.urls.youtube.api,e)).then(function(e){if(N.object(e)){var n=e.title,i=e.height,a=e.width;t.config.title=n,Fe.setTitle.call(t),t.embed.ratio=[a,i]}oe.call(t)}).catch(function(){oe.call(t)})},ready:function(){var e=this,t=e.media&&e.media.getAttribute("id");if(N.empty(t)||!t.startsWith("youtube-")){var n=e.media.getAttribute("src");N.empty(n)&&(n=e.media.getAttribute(this.config.attributes.embed.id));var i,a,s=(i=n,N.empty(i)?null:i.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/)?RegExp.$2:i),r=(a=e.provider,"".concat(a,"-").concat(Math.floor(1e4*Math.random()))),o=B("div",{id:r,poster:e.poster});e.media=K(o,e.media);var l=function(e){return"https://i.ytimg.com/vi/".concat(s,"/").concat(e,"default.jpg")};De(l("maxres"),121).catch(function(){return De(l("sd"),121)}).catch(function(){return De(l("hq"))}).then(function(t){return Fe.setPoster.call(e,t.src)}).then(function(t){t.includes("maxres")||(e.elements.poster.style.backgroundSize="cover")}).catch(function(){});var c=e.config.youtube;e.embed=new window.YT.Player(r,{videoId:s,host:Ke(c),playerVars:F({},{autoplay:e.config.autoplay?1:0,hl:e.config.hl,controls:e.supported.ui?0:1,disablekb:1,playsinline:e.config.fullscreen.iosNative?0:1,cc_load_policy:e.captions.active?1:0,cc_lang_pref:e.config.captions.language,widget_referrer:window?window.location.href:null},c),events:{onError:function(t){if(!e.media.error){var n=t.data,i={2:"The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.",5:"The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.",100:"The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.",101:"The owner of the requested video does not allow it to be played in embedded players.",150:"The owner of the requested video does not allow it to be played in embedded players."}[n]||"An unknown error occured";e.media.error={code:n,message:i},H.call(e,e.media,"error")}},onPlaybackRateChange:function(t){var n=t.target;e.media.playbackRate=n.getPlaybackRate(),H.call(e,e.media,"ratechange")},onReady:function(t){if(!N.function(e.media.play)){var n=t.target;Ye.getTitle.call(e,s),e.media.play=function(){ze.call(e,!0),n.playVideo()},e.media.pause=function(){ze.call(e,!1),n.pauseVideo()},e.media.stop=function(){n.stopVideo()},e.media.duration=n.getDuration(),e.media.paused=!0,e.media.currentTime=0,Object.defineProperty(e.media,"currentTime",{get:function(){return Number(n.getCurrentTime())},set:function(t){e.paused&&!e.embed.hasPlayed&&e.embed.mute(),e.media.seeking=!0,H.call(e,e.media,"seeking"),n.seekTo(t)}}),Object.defineProperty(e.media,"playbackRate",{get:function(){return n.getPlaybackRate()},set:function(e){n.setPlaybackRate(e)}});var i=e.config.volume;Object.defineProperty(e.media,"volume",{get:function(){return i},set:function(t){i=t,n.setVolume(100*i),H.call(e,e.media,"volumechange")}});var a=e.config.muted;Object.defineProperty(e.media,"muted",{get:function(){return a},set:function(t){var i=N.boolean(t)?t:a;a=i,n[i?"mute":"unMute"](),H.call(e,e.media,"volumechange")}}),Object.defineProperty(e.media,"currentSrc",{get:function(){return n.getVideoUrl()}}),Object.defineProperty(e.media,"ended",{get:function(){return e.currentTime===e.duration}}),e.options.speed=n.getAvailablePlaybackRates(),e.supported.ui&&e.media.setAttribute("tabindex",-1),H.call(e,e.media,"timeupdate"),H.call(e,e.media,"durationchange"),clearInterval(e.timers.buffering),e.timers.buffering=setInterval(function(){e.media.buffered=n.getVideoLoadedFraction(),(null===e.media.lastBuffered||e.media.lastBuffered<e.media.buffered)&&H.call(e,e.media,"progress"),e.media.lastBuffered=e.media.buffered,1===e.media.buffered&&(clearInterval(e.timers.buffering),H.call(e,e.media,"canplaythrough"))},200),setTimeout(function(){return Fe.build.call(e)},50)}},onStateChange:function(t){var n=t.target;switch(clearInterval(e.timers.playing),e.media.seeking&&[1,2].includes(t.data)&&(e.media.seeking=!1,H.call(e,e.media,"seeked")),t.data){case-1:H.call(e,e.media,"timeupdate"),e.media.buffered=n.getVideoLoadedFraction(),H.call(e,e.media,"progress");break;case 0:ze.call(e,!1),e.media.loop?(n.stopVideo(),n.playVideo()):H.call(e,e.media,"ended");break;case 1:e.config.autoplay||!e.media.paused||e.embed.hasPlayed?(ze.call(e,!0),H.call(e,e.media,"playing"),e.timers.playing=setInterval(function(){H.call(e,e.media,"timeupdate")},50),e.media.duration!==n.getDuration()&&(e.media.duration=n.getDuration(),H.call(e,e.media,"durationchange"))):e.media.pause();break;case 2:e.muted||e.embed.unMute(),ze.call(e,!1)}H.call(e,e.elements.container,"statechange",!1,{code:t.data})}}})}}},Qe={setup:function(){this.media?(X(this.elements.container,this.config.classNames.type.replace("{0}",this.type),!0),X(this.elements.container,this.config.classNames.provider.replace("{0}",this.provider),!0),this.isEmbed&&X(this.elements.container,this.config.classNames.type.replace("{0}","video"),!0),this.isVideo&&(this.elements.wrapper=B("div",{class:this.config.classNames.video}),R(this.media,this.elements.wrapper),this.elements.poster=B("div",{class:this.config.classNames.poster}),this.elements.wrapper.appendChild(this.elements.poster)),this.isHTML5?le.extend.call(this):this.isYouTube?Ye.setup.call(this):this.isVimeo&&We.setup.call(this)):this.debug.warn("No media element found!")}},Xe=function(){function t(n){var i=this;e(this,t),this.player=n,this.config=n.config.ads,this.playing=!1,this.initialized=!1,this.elements={container:null,displayContainer:null},this.manager=null,this.loader=null,this.cuePoints=null,this.events={},this.safetyTimer=null,this.countdownTimer=null,this.managerPromise=new Promise(function(e,t){i.on("loaded",e),i.on("error",t)}),this.load()}return n(t,[{key:"load",value:function(){var e=this;this.enabled&&(N.object(window.google)&&N.object(window.google.ima)?this.ready():Be(this.player.config.urls.googleIMA.sdk).then(function(){e.ready()}).catch(function(){e.trigger("error",new Error("Google IMA SDK failed to load"))}))}},{key:"ready",value:function(){var e,t=this;this.enabled||((e=this).manager&&e.manager.destroy(),e.elements.displayContainer&&e.elements.displayContainer.destroy(),e.elements.container.remove()),this.startSafetyTimer(12e3,"ready()"),this.managerPromise.then(function(){t.clearSafetyTimer("onAdsManagerLoaded()")}),this.listeners(),this.setupIMA()}},{key:"setupIMA",value:function(){this.elements.container=B("div",{class:this.player.config.classNames.ads}),this.player.elements.container.appendChild(this.elements.container),google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED),google.ima.settings.setLocale(this.player.config.ads.language),google.ima.settings.setDisableCustomPlaybackForIOS10Plus(this.player.config.playsinline),this.elements.displayContainer=new google.ima.AdDisplayContainer(this.elements.container,this.player.media),this.requestAds()}},{key:"requestAds",value:function(){var e=this,t=this.player.elements.container;try{this.loader=new google.ima.AdsLoader(this.elements.displayContainer),this.loader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,function(t){return e.onAdsManagerLoaded(t)},!1),this.loader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR,function(t){return e.onAdError(t)},!1);var n=new google.ima.AdsRequest;n.adTagUrl=this.tagUrl,n.linearAdSlotWidth=t.offsetWidth,n.linearAdSlotHeight=t.offsetHeight,n.nonLinearAdSlotWidth=t.offsetWidth,n.nonLinearAdSlotHeight=t.offsetHeight,n.forceNonLinearFullSlot=!1,n.setAdWillPlayMuted(!this.player.muted),this.loader.requestAds(n)}catch(e){this.onAdError(e)}}},{key:"pollCountdown",value:function(){var e=this;if(!(arguments.length>0&&void 0!==arguments[0]&&arguments[0]))return clearInterval(this.countdownTimer),void this.elements.container.removeAttribute("data-badge-text");this.countdownTimer=setInterval(function(){var t=Ce(Math.max(e.manager.getRemainingTime(),0)),n="".concat(ge("advertisement",e.player.config)," - ").concat(t);e.elements.container.setAttribute("data-badge-text",n)},100)}},{key:"onAdsManagerLoaded",value:function(e){var t=this;if(this.enabled){var n=new google.ima.AdsRenderingSettings;n.restoreCustomPlaybackStateOnAdBreakComplete=!0,n.enablePreloading=!0,this.manager=e.getAdsManager(this.player,n),this.cuePoints=this.manager.getCuePoints(),this.manager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR,function(e){return t.onAdError(e)}),Object.keys(google.ima.AdEvent.Type).forEach(function(e){t.manager.addEventListener(google.ima.AdEvent.Type[e],function(e){return t.onAdEvent(e)})}),this.trigger("loaded")}}},{key:"addCuePoints",value:function(){var e=this;N.empty(this.cuePoints)||this.cuePoints.forEach(function(t){if(0!==t&&-1!==t&&t<e.player.duration){var n=e.player.elements.progress;if(N.element(n)){var i=100/e.player.duration*t,a=B("span",{class:e.player.config.classNames.cues});a.style.left="".concat(i.toString(),"%"),n.appendChild(a)}}})}},{key:"onAdEvent",value:function(e){var t=this,n=this.player.elements.container,i=e.getAd(),a=e.getAdData();switch(function(e){H.call(t.player,t.player.media,"ads".concat(e.replace(/_/g,"").toLowerCase()))}(e.type),e.type){case google.ima.AdEvent.Type.LOADED:this.trigger("loaded"),this.pollCountdown(!0),i.isLinear()||(i.width=n.offsetWidth,i.height=n.offsetHeight);break;case google.ima.AdEvent.Type.STARTED:this.manager.setVolume(this.player.volume);break;case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:this.loadAds();break;case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:this.pauseContent();break;case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:this.pollCountdown(),this.resumeContent();break;case google.ima.AdEvent.Type.LOG:a.adError&&this.player.debug.warn("Non-fatal ad error: ".concat(a.adError.getMessage()))}}},{key:"onAdError",value:function(e){this.cancel(),this.player.debug.warn("Ads error",e)}},{key:"listeners",value:function(){var e,t=this,n=this.player.elements.container;this.player.on("canplay",function(){t.addCuePoints()}),this.player.on("ended",function(){t.loader.contentComplete()}),this.player.on("timeupdate",function(){e=t.player.currentTime}),this.player.on("seeked",function(){var n=t.player.currentTime;N.empty(t.cuePoints)||t.cuePoints.forEach(function(i,a){e<i&&i<n&&(t.manager.discardAdBreak(),t.cuePoints.splice(a,1))})}),window.addEventListener("resize",function(){t.manager&&t.manager.resize(n.offsetWidth,n.offsetHeight,google.ima.ViewMode.NORMAL)})}},{key:"play",value:function(){var e=this,t=this.player.elements.container;this.managerPromise||this.resumeContent(),this.managerPromise.then(function(){e.manager.setVolume(e.player.volume),e.elements.displayContainer.initialize();try{e.initialized||(e.manager.init(t.offsetWidth,t.offsetHeight,google.ima.ViewMode.NORMAL),e.manager.start()),e.initialized=!0}catch(t){e.onAdError(t)}}).catch(function(){})}},{key:"resumeContent",value:function(){this.elements.container.style.zIndex="",this.playing=!1,this.player.media.play()}},{key:"pauseContent",value:function(){this.elements.container.style.zIndex=3,this.playing=!0,this.player.media.pause()}},{key:"cancel",value:function(){this.initialized&&this.resumeContent(),this.trigger("error"),this.loadAds()}},{key:"loadAds",value:function(){var e=this;this.managerPromise.then(function(){e.manager&&e.manager.destroy(),e.managerPromise=new Promise(function(t){e.on("loaded",t),e.player.debug.log(e.manager)}),e.requestAds()}).catch(function(){})}},{key:"trigger",value:function(e){for(var t=this,n=arguments.length,i=new Array(n>1?n-1:0),a=1;a<n;a++)i[a-1]=arguments[a];var s=this.events[e];N.array(s)&&s.forEach(function(e){N.function(e)&&e.apply(t,i)})}},{key:"on",value:function(e,t){return N.array(this.events[e])||(this.events[e]=[]),this.events[e].push(t),this}},{key:"startSafetyTimer",value:function(e,t){var n=this;this.player.debug.log("Safety timer invoked from: ".concat(t)),this.safetyTimer=setTimeout(function(){n.cancel(),n.clearSafetyTimer("startSafetyTimer()")},e)}},{key:"clearSafetyTimer",value:function(e){N.nullOrUndefined(this.safetyTimer)||(this.player.debug.log("Safety timer cleared from: ".concat(e)),clearTimeout(this.safetyTimer),this.safetyTimer=null)}},{key:"enabled",get:function(){var e=this.config;return this.player.isHTML5&&this.player.isVideo&&e.enabled&&(!N.empty(e.publisherId)||N.url(e.tagUrl))}},{key:"tagUrl",get:function(){var e=this.config;if(N.url(e.tagUrl))return e.tagUrl;var t={AV_PUBLISHERID:"58c25bb0073ef448b1087ad6",AV_CHANNELID:"5a0458dc28a06145e4519d21",AV_URL:window.location.hostname,cb:Date.now(),AV_WIDTH:640,AV_HEIGHT:480,AV_CDIM2:this.publisherId};return"".concat("https://go.aniview.com/api/adserver6/vast/","?").concat(Se(t))}}]),t}(),Je=function(){function t(n){e(this,t),this.player=n,this.thumbnails=[],this.loaded=!1,this.lastMouseMoveTime=Date.now(),this.mouseDown=!1,this.loadedImages=[],this.elements={thumb:{},scrubbing:{}},this.load()}return n(t,[{key:"load",value:function(){var e=this;this.player.elements.display.seekTooltip&&(this.player.elements.display.seekTooltip.hidden=this.enabled),this.enabled&&this.getThumbnails().then(function(){e.enabled&&(e.render(),e.determineContainerAutoSizing(),e.loaded=!0)})}},{key:"getThumbnails",value:function(){var e=this;return new Promise(function(t){var n=e.player.config.previewThumbnails.src;if(N.empty(n))throw new Error("Missing previewThumbnails.src config attribute");var i=(N.string(n)?[n]:n).map(function(t){return e.getThumbnail(t)});Promise.all(i).then(function(){e.thumbnails.sort(function(e,t){return e.height-t.height}),e.player.debug.log("Preview thumbnails",e.thumbnails),t()})})}},{key:"getThumbnail",value:function(e){var t=this;return new Promise(function(n){ve(e).then(function(i){var s,r,o={frames:(s=i,r=[],s.split(/\r\n\r\n|\n\n|\r\r/).forEach(function(e){var t={};e.split(/\r\n|\n|\r/).forEach(function(e){if(N.number(t.startTime)){if(!N.empty(e.trim())&&N.empty(t.text)){var n=e.trim().split("#xywh="),i=a(n,1);if(t.text=i[0],n[1]){var s=a(n[1].split(","),4);t.x=s[0],t.y=s[1],t.w=s[2],t.h=s[3]}}}else{var r=e.match(/([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})( ?--> ?)([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})/);r&&(t.startTime=60*Number(r[1]||0)*60+60*Number(r[2])+Number(r[3])+Number("0.".concat(r[4])),t.endTime=60*Number(r[6]||0)*60+60*Number(r[7])+Number(r[8])+Number("0.".concat(r[9])))}}),t.text&&r.push(t)}),r),height:null,urlPrefix:""};o.frames[0].text.startsWith("/")||o.frames[0].text.startsWith("http://")||o.frames[0].text.startsWith("https://")||(o.urlPrefix=e.substring(0,e.lastIndexOf("/")+1));var l=new Image;l.onload=function(){o.height=l.naturalHeight,o.width=l.naturalWidth,t.thumbnails.push(o),n()},l.src=o.urlPrefix+o.frames[0].text})})}},{key:"startMove",value:function(e){if(this.loaded&&N.event(e)&&["touchmove","mousemove"].includes(e.type)&&this.player.media.duration){if("touchmove"===e.type)this.seekTime=this.player.media.duration*(this.player.elements.inputs.seek.value/100);else{var t=this.player.elements.progress.getBoundingClientRect(),n=100/t.width*(e.pageX-t.left);this.seekTime=this.player.media.duration*(n/100),this.seekTime<0&&(this.seekTime=0),this.seekTime>this.player.media.duration-1&&(this.seekTime=this.player.media.duration-1),this.mousePosX=e.pageX,this.elements.thumb.time.innerText=Ce(this.seekTime)}this.showImageAtCurrentTime()}}},{key:"endMove",value:function(){this.toggleThumbContainer(!1,!0)}},{key:"startScrubbing",value:function(e){!1!==e.button&&0!==e.button||(this.mouseDown=!0,this.player.media.duration&&(this.toggleScrubbingContainer(!0),this.toggleThumbContainer(!1,!0),this.showImageAtCurrentTime()))}},{key:"endScrubbing",value:function(){var e=this;this.mouseDown=!1,Math.ceil(this.lastTime)===Math.ceil(this.player.media.currentTime)?this.toggleScrubbingContainer(!1):q.call(this.player,this.player.media,"timeupdate",function(){e.mouseDown||e.toggleScrubbingContainer(!1)})}},{key:"listeners",value:function(){var e=this;this.player.on("play",function(){e.toggleThumbContainer(!1,!0)}),this.player.on("seeked",function(){e.toggleThumbContainer(!1)}),this.player.on("timeupdate",function(){e.lastTime=e.player.media.currentTime})}},{key:"render",value:function(){this.elements.thumb.container=B("div",{class:this.player.config.classNames.previewThumbnails.thumbContainer}),this.elements.thumb.imageContainer=B("div",{class:this.player.config.classNames.previewThumbnails.imageContainer}),this.elements.thumb.container.appendChild(this.elements.thumb.imageContainer);var e=B("div",{class:this.player.config.classNames.previewThumbnails.timeContainer});this.elements.thumb.time=B("span",{},"00:00"),e.appendChild(this.elements.thumb.time),this.elements.thumb.container.appendChild(e),N.element(this.player.elements.progress)&&this.player.elements.progress.appendChild(this.elements.thumb.container),this.elements.scrubbing.container=B("div",{class:this.player.config.classNames.previewThumbnails.scrubbingContainer}),this.player.elements.wrapper.appendChild(this.elements.scrubbing.container)}},{key:"showImageAtCurrentTime",value:function(){var e=this;this.mouseDown?this.setScrubbingContainerSize():this.setThumbContainerSizeAndPos();var t=this.thumbnails[0].frames.findIndex(function(t){return e.seekTime>=t.startTime&&e.seekTime<=t.endTime}),n=t>=0,i=0;this.mouseDown||this.toggleThumbContainer(n),n&&(this.thumbnails.forEach(function(n,a){e.loadedImages.includes(n.frames[t].text)&&(i=a)}),t!==this.showingThumb&&(this.showingThumb=t,this.loadImage(i)))}},{key:"loadImage",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,n=this.showingThumb,i=this.thumbnails[t],a=i.urlPrefix,s=i.frames[n],r=i.frames[n].text,o=a+r;if(this.currentImageElement&&this.currentImageElement.dataset.filename===r)this.showImage(this.currentImageElement,s,t,n,r,!1),this.currentImageElement.dataset.index=n,this.removeOldImages(this.currentImageElement);else{this.loadingImage&&this.usingSprites&&(this.loadingImage.onload=null);var l=new Image;l.src=o,l.dataset.index=n,l.dataset.filename=r,this.showingThumbFilename=r,this.player.debug.log("Loading image: ".concat(o)),l.onload=function(){return e.showImage(l,s,t,n,r,!0)},this.loadingImage=l,this.removeOldImages(l)}}},{key:"showImage",value:function(e,t,n,i,a){var s=!(arguments.length>5&&void 0!==arguments[5])||arguments[5];this.player.debug.log("Showing thumb: ".concat(a,". num: ").concat(i,". qual: ").concat(n,". newimg: ").concat(s)),this.setImageSizeAndOffset(e,t),s&&(this.currentImageContainer.appendChild(e),this.currentImageElement=e,this.loadedImages.includes(a)||this.loadedImages.push(a)),this.preloadNearby(i,!0).then(this.preloadNearby(i,!1)).then(this.getHigherQuality(n,e,t,a))}},{key:"removeOldImages",value:function(e){var t=this;Array.from(this.currentImageContainer.children).forEach(function(n){if("img"===n.tagName.toLowerCase()){var i=t.usingSprites?500:1e3;if(n.dataset.index!==e.dataset.index&&!n.dataset.deleting){n.dataset.deleting=!0;var a=t.currentImageContainer;setTimeout(function(){a.removeChild(n),t.player.debug.log("Removing thumb: ".concat(n.dataset.filename))},i)}}})}},{key:"preloadNearby",value:function(e){var t=this,n=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];return new Promise(function(i){setTimeout(function(){var a=t.thumbnails[0].frames[e].text;if(t.showingThumbFilename===a){var s;s=n?t.thumbnails[0].frames.slice(e):t.thumbnails[0].frames.slice(0,e).reverse();var r=!1;s.forEach(function(e){var n=e.text;if(n!==a&&!t.loadedImages.includes(n)){r=!0,t.player.debug.log("Preloading thumb filename: ".concat(n));var s=t.thumbnails[0].urlPrefix+n,o=new Image;o.src=s,o.onload=function(){t.player.debug.log("Preloaded thumb filename: ".concat(n)),t.loadedImages.includes(n)||t.loadedImages.push(n),i()}}}),r||i()}},300)})}},{key:"getHigherQuality",value:function(e,t,n,i){var a=this;if(e<this.thumbnails.length-1){var s=t.naturalHeight;this.usingSprites&&(s=n.h),s<this.thumbContainerHeight&&setTimeout(function(){a.showingThumbFilename===i&&(a.player.debug.log("Showing higher quality thumb for: ".concat(i)),a.loadImage(e+1))},300)}}},{key:"toggleThumbContainer",value:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=this.player.config.classNames.previewThumbnails.thumbContainerShown;this.elements.thumb.container.classList.toggle(n,e),!e&&t&&(this.showingThumb=null,this.showingThumbFilename=null)}},{key:"toggleScrubbingContainer",value:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=this.player.config.classNames.previewThumbnails.scrubbingContainerShown;this.elements.scrubbing.container.classList.toggle(t,e),e||(this.showingThumb=null,this.showingThumbFilename=null)}},{key:"determineContainerAutoSizing",value:function(){this.elements.thumb.imageContainer.clientHeight>20&&(this.sizeSpecifiedInCSS=!0)}},{key:"setThumbContainerSizeAndPos",value:function(){if(!this.sizeSpecifiedInCSS){var e=Math.floor(this.thumbContainerHeight*this.thumbAspectRatio);this.elements.thumb.imageContainer.style.height="".concat(this.thumbContainerHeight,"px"),this.elements.thumb.imageContainer.style.width="".concat(e,"px")}this.setThumbContainerPos()}},{key:"setThumbContainerPos",value:function(){var e=this.player.elements.progress.getBoundingClientRect(),t=this.player.elements.container.getBoundingClientRect(),n=this.elements.thumb.container,i=t.left-e.left+10,a=t.right-e.left-n.clientWidth-10,s=this.mousePosX-e.left-n.clientWidth/2;s<i&&(s=i),s>a&&(s=a),n.style.left="".concat(s,"px")}},{key:"setScrubbingContainerSize",value:function(){this.elements.scrubbing.container.style.width="".concat(this.player.media.clientWidth,"px"),this.elements.scrubbing.container.style.height="".concat(this.player.media.clientWidth/this.thumbAspectRatio,"px")}},{key:"setImageSizeAndOffset",value:function(e,t){if(this.usingSprites){var n=this.thumbContainerHeight/t.h;e.style.height="".concat(Math.floor(e.naturalHeight*n),"px"),e.style.width="".concat(Math.floor(e.naturalWidth*n),"px"),e.style.left="-".concat(t.x*n,"px"),e.style.top="-".concat(t.y*n,"px")}}},{key:"enabled",get:function(){return this.player.isHTML5&&this.player.isVideo&&this.player.config.previewThumbnails.enabled}},{key:"currentImageContainer",get:function(){return this.mouseDown?this.elements.scrubbing.container:this.elements.thumb.imageContainer}},{key:"usingSprites",get:function(){return Object.keys(this.thumbnails[0].frames[0]).includes("w")}},{key:"thumbAspectRatio",get:function(){return this.usingSprites?this.thumbnails[0].frames[0].w/this.thumbnails[0].frames[0].h:this.thumbnails[0].width/this.thumbnails[0].height}},{key:"thumbContainerHeight",get:function(){return this.mouseDown?Math.floor(this.player.media.clientWidth/this.thumbAspectRatio):Math.floor(this.player.media.clientWidth/this.thumbAspectRatio/4)}},{key:"currentImageElement",get:function(){return this.mouseDown?this.currentScrubbingImageElement:this.currentThumbnailImageElement},set:function(e){this.mouseDown?this.currentScrubbingImageElement=e:this.currentThumbnailImageElement=e}}]),t}(),$e={insertElements:function(e,t){var n=this;N.string(t)?U(e,this.media,{src:t}):N.array(t)&&t.forEach(function(t){U(e,n.media,t)})},change:function(e){var t=this;D(e,"sources.length")?(le.cancelRequests.call(this),this.destroy.call(this,function(){t.options.quality=[],W(t.media),t.media=null,N.element(t.elements.container)&&t.elements.container.removeAttribute("class");var n=e.sources,i=e.type,s=a(n,1)[0],r=s.provider,o=void 0===r?Le.html5:r,l=s.src,c="html5"===o?i:"div",u="html5"===o?{}:{src:l};Object.assign(t,{provider:o,type:i,supported:ie.check(i,o,t.config.playsinline),media:B(c,u)}),t.elements.container.appendChild(t.media),N.boolean(e.autoplay)&&(t.config.autoplay=e.autoplay),t.isHTML5&&(t.config.crossorigin&&t.media.setAttribute("crossorigin",""),t.config.autoplay&&t.media.setAttribute("autoplay",""),N.empty(e.poster)||(t.poster=e.poster),t.config.loop.active&&t.media.setAttribute("loop",""),t.config.muted&&t.media.setAttribute("muted",""),t.config.playsinline&&t.media.setAttribute("playsinline","")),Fe.addStyleHook.call(t),t.isHTML5&&$e.insertElements.call(t,"source",n),t.config.title=e.title,Qe.setup.call(t),t.isHTML5&&Object.keys(e).includes("tracks")&&$e.insertElements.call(t,"track",e.tracks),(t.isHTML5||t.isEmbed&&!t.supported.ui)&&Fe.build.call(t),t.isHTML5&&t.media.load(),t.previewThumbnails&&t.previewThumbnails.load(),t.fullscreen.update()},!0)):this.debug.warn("Invalid source format")}};var Ge,Ze=function(){function t(n,i){var a=this;if(e(this,t),this.timers={},this.ready=!1,this.loading=!1,this.failed=!1,this.touch=ie.touch,this.media=n,N.string(this.media)&&(this.media=document.querySelectorAll(this.media)),(window.jQuery&&this.media instanceof jQuery||N.nodeList(this.media)||N.array(this.media))&&(this.media=this.media[0]),this.config=F({},Ne,t.defaults,i||{},function(){try{return JSON.parse(a.media.getAttribute("data-plyr-config"))}catch(e){return{}}}()),this.elements={container:null,captions:null,buttons:{},display:{},progress:{},inputs:{},settings:{popup:null,menu:null,panels:{},buttons:{}}},this.captions={active:null,currentTrack:-1,meta:new WeakMap},this.fullscreen={active:!1},this.options={speed:[],quality:[]},this.debug=new Oe(this.config.debug),this.debug.log("Config",this.config),this.debug.log("Support",ie),!N.nullOrUndefined(this.media)&&N.element(this.media))if(this.media.plyr)this.debug.warn("Target already setup");else if(this.config.enabled)if(ie.check().api){var s=this.media.cloneNode(!0);s.autoplay=!1,this.elements.original=s;var r=this.media.tagName.toLowerCase(),o=null,l=null;switch(r){case"div":if(o=this.media.querySelector("iframe"),N.element(o)){if(l=Ee(o.getAttribute("src")),this.provider=function(e){return/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(e)?Le.youtube:/^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(e)?Le.vimeo:null}(l.toString()),this.elements.container=this.media,this.media=o,this.elements.container.className="",l.search.length){var c=["1","true"];c.includes(l.searchParams.get("autoplay"))&&(this.config.autoplay=!0),c.includes(l.searchParams.get("loop"))&&(this.config.loop.active=!0),this.isYouTube?(this.config.playsinline=c.includes(l.searchParams.get("playsinline")),this.config.youtube.hl=l.searchParams.get("hl")):this.config.playsinline=!0}}else this.provider=this.media.getAttribute(this.config.attributes.embed.provider),this.media.removeAttribute(this.config.attributes.embed.provider);if(N.empty(this.provider)||!Object.keys(Le).includes(this.provider))return void this.debug.error("Setup failed: Invalid provider");this.type=Ie.video;break;case"video":case"audio":this.type=r,this.provider=Le.html5,this.media.hasAttribute("crossorigin")&&(this.config.crossorigin=!0),this.media.hasAttribute("autoplay")&&(this.config.autoplay=!0),(this.media.hasAttribute("playsinline")||this.media.hasAttribute("webkit-playsinline"))&&(this.config.playsinline=!0),this.media.hasAttribute("muted")&&(this.config.muted=!0),this.media.hasAttribute("loop")&&(this.config.loop.active=!0);break;default:return void this.debug.error("Setup failed: unsupported type")}this.supported=ie.check(this.type,this.provider,this.config.playsinline),this.supported.api?(this.eventListeners=[],this.listeners=new Re(this),this.storage=new ye(this),this.media.plyr=this,N.element(this.elements.container)||(this.elements.container=B("div",{tabindex:0}),R(this.media,this.elements.container)),Fe.addStyleHook.call(this),Qe.setup.call(this),this.config.debug&&O.call(this,this.elements.container,this.config.events.join(" "),function(e){a.debug.log("event: ".concat(e.type))}),(this.isHTML5||this.isEmbed&&!this.supported.ui)&&Fe.build.call(this),this.listeners.container(),this.listeners.global(),this.fullscreen=new He(this),this.config.ads.enabled&&(this.ads=new Xe(this)),this.isHTML5&&this.config.autoplay&&setTimeout(function(){return a.play()},10),this.lastSeekTime=0,this.config.previewThumbnails.enabled&&(this.previewThumbnails=new Je(this))):this.debug.error("Setup failed: no support")}else this.debug.error("Setup failed: no support");else this.debug.error("Setup failed: disabled by config");else this.debug.error("Setup failed: no suitable element passed")}return n(t,[{key:"play",value:function(){var e=this;return N.function(this.media.play)?(this.ads&&this.ads.enabled&&this.ads.managerPromise.then(function(){return e.ads.play()}).catch(function(){return e.media.play()}),this.media.play()):null}},{key:"pause",value:function(){this.playing&&N.function(this.media.pause)&&this.media.pause()}},{key:"togglePlay",value:function(e){(N.boolean(e)?e:!this.playing)?this.play():this.pause()}},{key:"stop",value:function(){this.isHTML5?(this.pause(),this.restart()):N.function(this.media.stop)&&this.media.stop()}},{key:"restart",value:function(){this.currentTime=0}},{key:"rewind",value:function(e){this.currentTime=this.currentTime-(N.number(e)?e:this.config.seekTime)}},{key:"forward",value:function(e){this.currentTime=this.currentTime+(N.number(e)?e:this.config.seekTime)}},{key:"increaseVolume",value:function(e){var t=this.media.muted?0:this.volume;this.volume=t+(N.number(e)?e:0)}},{key:"decreaseVolume",value:function(e){this.increaseVolume(-e)}},{key:"toggleCaptions",value:function(e){Pe.toggle.call(this,e,!1)}},{key:"airplay",value:function(){ie.airplay&&this.media.webkitShowPlaybackTargetPicker()}},{key:"toggleControls",value:function(e){if(this.supported.ui&&!this.isAudio){var t=J(this.elements.container,this.config.classNames.hideControls),n=void 0===e?void 0:!e,i=X(this.elements.container,this.config.classNames.hideControls,n);if(i&&this.config.controls.includes("settings")&&!N.empty(this.config.settings)&&Ae.toggleMenu.call(this,!1),i!==t){var a=i?"controlshidden":"controlsshown";H.call(this,this.media,a)}return!i}return!1}},{key:"on",value:function(e,t){O.call(this,this.elements.container,e,t)}},{key:"once",value:function(e,t){q.call(this,this.elements.container,e,t)}},{key:"off",value:function(e,t){j(this.elements.container,e,t)}},{key:"destroy",value:function(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(this.ready){var i=function(){document.body.style.overflow="",t.embed=null,n?(Object.keys(t.elements).length&&(W(t.elements.buttons.play),W(t.elements.captions),W(t.elements.controls),W(t.elements.wrapper),t.elements.buttons.play=null,t.elements.captions=null,t.elements.controls=null,t.elements.wrapper=null),N.function(e)&&e()):(function(){this&&this.eventListeners&&(this.eventListeners.forEach(function(e){var t=e.element,n=e.type,i=e.callback,a=e.options;t.removeEventListener(n,i,a)}),this.eventListeners=[])}.call(t),K(t.elements.original,t.elements.container),H.call(t,t.elements.original,"destroyed",!0),N.function(e)&&e.call(t.elements.original),t.ready=!1,setTimeout(function(){t.elements=null,t.media=null},200))};this.stop(),clearTimeout(this.timers.loading),clearTimeout(this.timers.controls),clearTimeout(this.timers.resized),this.isHTML5?(Fe.toggleNativeControls.call(this,!0),i()):this.isYouTube?(clearInterval(this.timers.buffering),clearInterval(this.timers.playing),null!==this.embed&&N.function(this.embed.destroy)&&this.embed.destroy(),i()):this.isVimeo&&(null!==this.embed&&this.embed.unload().then(i),setTimeout(i,200))}}},{key:"supports",value:function(e){return ie.mime.call(this,e)}},{key:"isHTML5",get:function(){return this.provider===Le.html5}},{key:"isEmbed",get:function(){return this.isYouTube||this.isVimeo}},{key:"isYouTube",get:function(){return this.provider===Le.youtube}},{key:"isVimeo",get:function(){return this.provider===Le.vimeo}},{key:"isVideo",get:function(){return this.type===Ie.video}},{key:"isAudio",get:function(){return this.type===Ie.audio}},{key:"playing",get:function(){return Boolean(this.ready&&!this.paused&&!this.ended)}},{key:"paused",get:function(){return Boolean(this.media.paused)}},{key:"stopped",get:function(){return Boolean(this.paused&&0===this.currentTime)}},{key:"ended",get:function(){return Boolean(this.media.ended)}},{key:"currentTime",set:function(e){if(this.duration){var t=N.number(e)&&e>0;this.media.currentTime=t?Math.min(e,this.duration):0,this.debug.log("Seeking to ".concat(this.currentTime," seconds"))}},get:function(){return Number(this.media.currentTime)}},{key:"buffered",get:function(){var e=this.media.buffered;return N.number(e)?e:e&&e.length&&this.duration>0?e.end(0)/this.duration:0}},{key:"seeking",get:function(){return Boolean(this.media.seeking)}},{key:"duration",get:function(){var e=parseFloat(this.config.duration),t=(this.media||{}).duration,n=N.number(t)&&t!==1/0?t:0;return e||n}},{key:"volume",set:function(e){var t=e;N.string(t)&&(t=Number(t)),N.number(t)||(t=this.storage.get("volume")),N.number(t)||(t=this.config.volume),t>1&&(t=1),t<0&&(t=0),this.config.volume=t,this.media.volume=t,!N.empty(e)&&this.muted&&t>0&&(this.muted=!1)},get:function(){return Number(this.media.volume)}},{key:"muted",set:function(e){var t=e;N.boolean(t)||(t=this.storage.get("muted")),N.boolean(t)||(t=this.config.muted),this.config.muted=t,this.media.muted=t},get:function(){return Boolean(this.media.muted)}},{key:"hasAudio",get:function(){return!this.isHTML5||(!!this.isAudio||(Boolean(this.media.mozHasAudio)||Boolean(this.media.webkitAudioDecodedByteCount)||Boolean(this.media.audioTracks&&this.media.audioTracks.length)))}},{key:"speed",set:function(e){var t=this,n=null;N.number(e)&&(n=e),N.number(n)||(n=this.storage.get("speed")),N.number(n)||(n=this.config.speed.selected);var i=this.minimumSpeed,a=this.maximumSpeed;n=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:255;return Math.min(Math.max(e,t),n)}(n,i,a),this.config.speed.selected=n,setTimeout(function(){t.media.playbackRate=n},0)},get:function(){return Number(this.media.playbackRate)}},{key:"minimumSpeed",get:function(){return this.isYouTube?Math.min.apply(Math,s(this.options.speed)):this.isVimeo?.5:.0625}},{key:"maximumSpeed",get:function(){return this.isYouTube?Math.max.apply(Math,s(this.options.speed)):this.isVimeo?2:16}},{key:"quality",set:function(e){var t=this.config.quality,n=this.options.quality;if(n.length){var i=[!N.empty(e)&&Number(e),this.storage.get("quality"),t.selected,t.default].find(N.number),a=!0;if(!n.includes(i)){var s=function(e,t){return N.array(e)&&e.length?e.reduce(function(e,n){return Math.abs(n-t)<Math.abs(e-t)?n:e}):null}(n,i);this.debug.warn("Unsupported quality option: ".concat(i,", using ").concat(s," instead")),i=s,a=!1}t.selected=i,this.media.quality=i,a&&this.storage.set({quality:i})}},get:function(){return this.media.quality}},{key:"loop",set:function(e){var t=N.boolean(e)?e:this.config.loop.active;this.config.loop.active=t,this.media.loop=t},get:function(){return Boolean(this.media.loop)}},{key:"source",set:function(e){$e.change.call(this,e)},get:function(){return this.media.currentSrc}},{key:"download",get:function(){var e=this.config.urls.download;return N.url(e)?e:this.source},set:function(e){N.url(e)&&(this.config.urls.download=e,Ae.setDownloadUrl.call(this))}},{key:"poster",set:function(e){this.isVideo?Fe.setPoster.call(this,e,!1).catch(function(){}):this.debug.warn("Poster can only be set for video")},get:function(){return this.isVideo?this.media.getAttribute("poster"):null}},{key:"ratio",get:function(){if(!this.isVideo)return null;var e=se(re.call(this));return N.array(e)?e.join(":"):e},set:function(e){this.isVideo?N.string(e)&&ae(e)?(this.config.ratio=e,oe.call(this)):this.debug.error("Invalid aspect ratio specified (".concat(e,")")):this.debug.warn("Aspect ratio can only be set for video")}},{key:"autoplay",set:function(e){var t=N.boolean(e)?e:this.config.autoplay;this.config.autoplay=t},get:function(){return Boolean(this.config.autoplay)}},{key:"currentTrack",set:function(e){Pe.set.call(this,e,!1)},get:function(){var e=this.captions,t=e.toggled,n=e.currentTrack;return t?n:-1}},{key:"language",set:function(e){Pe.setLanguage.call(this,e,!1)},get:function(){return(Pe.getCurrentTrack.call(this)||{}).language}},{key:"pip",set:function(e){if(ie.pip){var t=N.boolean(e)?e:!this.pip;N.function(this.media.webkitSetPresentationMode)&&this.media.webkitSetPresentationMode(t?Me:xe),N.function(this.media.requestPictureInPicture)&&(!this.pip&&t?this.media.requestPictureInPicture():this.pip&&!t&&document.exitPictureInPicture())}},get:function(){return ie.pip?N.empty(this.media.webkitPresentationMode)?this.media===document.pictureInPictureElement:this.media.webkitPresentationMode===Me:null}}],[{key:"supported",value:function(e,t,n){return ie.check(e,t,n)}},{key:"loadSprite",value:function(e,t){return be(e,t)}},{key:"setup",value:function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=null;return N.string(e)?i=Array.from(document.querySelectorAll(e)):N.nodeList(e)?i=Array.from(e):N.array(e)&&(i=e.filter(N.element)),N.empty(i)?null:i.map(function(e){return new t(e,n)})}}]),t}();return Ze.defaults=(Ge=Ne,JSON.parse(JSON.stringify(Ge))),Ze});
//# sourceMappingURL=plyr.min.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),

/***/ 1520:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1582);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("9cb06484", content, true, {});

/***/ }),

/***/ 1522:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1630), __esModule: true };

/***/ }),

/***/ 1530:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main__ = __webpack_require__(1638);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main__["a" /* default */]);

/***/ }),

/***/ 1541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getAnswerFields;
/* harmony export (immutable) */ __webpack_exports__["b"] = convertQuestions;
/* harmony export (immutable) */ __webpack_exports__["a"] = convertAnswers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_function__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__convert_fields_option__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__convert_fields_question__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__convert_fields_option_types__ = __webpack_require__(1614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__convert_fields_question_types__ = __webpack_require__(1615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__convert_fields_answer__ = __webpack_require__(1709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__convert_fields_answer_types__ = __webpack_require__(1710);











function getAnswerFields(type) {
  var $answerModel = Object(__WEBPACK_IMPORTED_MODULE_2__utils_function__["b" /* copyJson */])(__WEBPACK_IMPORTED_MODULE_8__convert_fields_answer__["a" /* default */]);
  var answer = {};
  __WEBPACK_IMPORTED_MODULE_9__convert_fields_answer_types__["a" /* default */][type].forEach(function (field) {
    answer[field] = $answerModel[field];
  });
  return answer;
}

function convertQuestions(questions) {
  var $questions = [];

  questions.forEach(function (question) {
    // 深复制一个模型
    var $questionModel = Object(__WEBPACK_IMPORTED_MODULE_2__utils_function__["b" /* copyJson */])(__WEBPACK_IMPORTED_MODULE_5__convert_fields_question__["a" /* default */]);
    // 当前问题
    var $question = {};
    // 当前选项
    var $options = [];
    // 获得问题的类型
    var type = Object(__WEBPACK_IMPORTED_MODULE_3__type__["a" /* getConvertType */])(question.type);
    // 获得该类型的问题拥有的字段
    var questionFields = __WEBPACK_IMPORTED_MODULE_7__convert_fields_question_types__["a" /* default */][type];
    // 获得该类型的选项拥有的字段
    var optionFields = __WEBPACK_IMPORTED_MODULE_6__convert_fields_option_types__["a" /* default */][type];
    if (question.allow_screen_capture === undefined) {
      question.allow_screen_capture = 1;
    }

    if (question.allow_media_download === undefined) {
      question.allow_media_download = 1;
    }

    // 从 question 模型中取得字段的默认值
    questionFields.forEach(function (key) {
      $question[key] = Object(__WEBPACK_IMPORTED_MODULE_2__utils_function__["d" /* getExist */])(question[key], $questionModel[key]);
      switch (key) {
        case 'id':
          $question[key] = question.stepId;
          break;
        case 'type':
          $question[key] = type;
          break;
        case 'text':
          if (question.desc) {
            $question[key] = Object(__WEBPACK_IMPORTED_MODULE_2__utils_function__["d" /* getExist */])(question.desc, $question[key]);
          }
          break;
        case 'textPrefix':
          if (question.descPrefix) {
            $question[key] = Object(__WEBPACK_IMPORTED_MODULE_2__utils_function__["d" /* getExist */])(question.descPrefix, $question[key]);
          }
          break;
        case 'referIds':
          $question[key] = Object(__WEBPACK_IMPORTED_MODULE_2__utils_function__["d" /* getExist */])(question.referIds || undefined, $question[key]);
          // 兼容旧版单个ID
          if (question.referStepId && !$question[key].includes(question.referStepId)) {
            $question[key].push(question.referStepId);
          }
          break;
        case 'images':
          var images = [];
          question.images.forEach(function (src) {
            images.push({
              type: 'photo',
              src: src
            });
          });
          $question[key] = images;
          break;
        case 'minDuration':
          if (question.evidenceType === 'video' && question.videoDuration > 0) {
            $question[key] = question.videoDuration;
          } else if (question.evidenceType === 'record' && question.recordDuration > 0) {
            $question[key] = question.recordDuration;
          } else {
            $question[key] = $question[key];
          }
          break;
        case 'localFile':
          // 表意问题，取反处理，强制使用爱零工相机===不允许使用本地文件
          if (question.hasOwnProperty('forceCamera')) {
            question.forceCamera = !question.forceCamera;
          }
          $question[key] = Object(__WEBPACK_IMPORTED_MODULE_2__utils_function__["d" /* getExist */])(question.forceCamera, $question[key]);
          break;
        case 'jumpTargetId':
          if (question.default_jump) {
            $question[key] = question.default_jump;
          }
          break;
        case 'needEvidence':
          $question[key] = Object(__WEBPACK_IMPORTED_MODULE_2__utils_function__["d" /* getExist */])(question.needPhoto, $question[key]);
          break;
        case 'options':
          $question[key] = question.moptions || question.mtext || question.pictureMultipleOptions || $question[key];
          break;
      }
    });

    // 从 option 模型中取得字段的默认值
    if (optionFields.length) {
      $question.options.forEach(function (option) {
        // 深复制一个模型
        var $optionModel = Object(__WEBPACK_IMPORTED_MODULE_2__utils_function__["b" /* copyJson */])(__WEBPACK_IMPORTED_MODULE_4__convert_fields_option__["a" /* default */]);
        var $option = {};
        optionFields.forEach(function (key) {
          $option[key] = Object(__WEBPACK_IMPORTED_MODULE_2__utils_function__["d" /* getExist */])(option[key], $optionModel[key]);
          switch (key) {
            case 'id':
              $option[key] = Object(__WEBPACK_IMPORTED_MODULE_2__utils_function__["d" /* getExist */])(option.optionId, option.id);
              break;
            case 'referIds':
              $option[key] = Object(__WEBPACK_IMPORTED_MODULE_2__utils_function__["d" /* getExist */])(option.referIds || undefined, $option[key]);
              // 兼容旧版单个ID
              if (option.referStepId && !$option[key].includes(option.referStepId)) {
                $option[key].push(option.referStepId);
              }
              break;
            // 图片多选题
            case 'images':
              var images = [];
              option.titlePictures.forEach(function (src) {
                images.push({
                  type: 'photo',
                  src: src
                });
              });
              $option[key] = images;
              break;
            case 'exampleImages':
              var exampleImages = [];
              option.examplePhotos.forEach(function (src) {
                exampleImages.push({
                  type: 'photo',
                  src: src
                });
              });
              $option[key] = exampleImages;
              break;
            case 'mutexOptions':
              if (option.exclusiveOption) {
                $option[key] = option.exclusiveOption;
              }
              break;
            case 'nextSelectDelay':
              if (option.mStepDelay) {
                $option[key] = option.mStepDelay;
              }
              break;
            case 'localFile':
              // 表意问题，取反处理，强制使用爱零工相机===不允许使用本地文件
              if (option.hasOwnProperty('forceCamera')) {
                option.forceCamera = !option.forceCamera;
              }
              $option[key] = Object(__WEBPACK_IMPORTED_MODULE_2__utils_function__["d" /* getExist */])(option.forceCamera, $option[key]);
              break;
            case 'needEvidence':
              $option[key] = Object(__WEBPACK_IMPORTED_MODULE_2__utils_function__["d" /* getExist */])(option.needPhoto, $option[key]);
              break;
          }
        });

        // 打散逻辑跳转集合到选项中
        if (question['conditional_jump'] && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(question['conditional_jump']).length) {
          var jumpTargetId = question['conditional_jump'][$option.id];
          if (jumpTargetId) {
            $option.jumpTargetId = jumpTargetId;
          }
        }
        $options.push($option);
      });
    }

    // 选项存在则赋值
    if ($options.length) {
      $question.options = $options;
    }

    // 完成
    $questions.push($question);
  });

  return $questions;
}

/**
 * 根据题目类型，获得选择题的答案
 * @param type
 * @param answer
 * @returns {*[]|Array}
 */
function getAnswerSelectedOptionId(type, answer) {
  switch (type) {
    case 'select':
      if (answer.selectedOptionId) {
        return [answer.selectedOptionId];
      }
      break;
    case 'multiselect':
      if (answer.mOptionIds && answer.mOptionIds.length) {
        return answer.mOptionIds;
      }
      break;
    case 'imageMultiselect':
      if (answer.pictureMultipleOptionIds && answer.pictureMultipleOptionIds.length) {
        return answer.pictureMultipleOptionIds;
      }
      break;
  }
  return [];
}

function convertAnswers(questions, answers) {
  var $answers = [];

  questions.forEach(function (question, index) {
    // 深复制一个模型
    var $answerModel = Object(__WEBPACK_IMPORTED_MODULE_2__utils_function__["b" /* copyJson */])(__WEBPACK_IMPORTED_MODULE_8__convert_fields_answer__["a" /* default */]);

    // 获得答案字段模型
    var answerFields = __WEBPACK_IMPORTED_MODULE_9__convert_fields_answer_types__["a" /* default */][question.type];

    // 获得当前题目的答案
    var answer = answers[index];

    // 转换后的答案
    var $answer = {};

    // 从 answer 模型中取得字段的默认值
    answerFields.forEach(function (key) {
      $answer[key] = Object(__WEBPACK_IMPORTED_MODULE_2__utils_function__["d" /* getExist */])(answer[key], $answerModel[key]);
      switch (key) {
        case 'errorMessage':
          $answer[key] = answer.errormessage;
          break;
        case 'selectedOptionId':
          $answer[key] = getAnswerSelectedOptionId(question.type, answer);
          break;
        case 'text':
          $answer[key] = answer.textAnswer;
          break;
        case 'texts':
          var texts = [];
          question.options.forEach(function (_ref) {
            var id = _ref.id;

            var text = '';
            if (answer.mTextAnswer && answer.mTextAnswer[id] && answer.mTextAnswer[id].textAnswer) {
              text = answer.mTextAnswer[id].textAnswer;
            }
            texts.push(text);
          });
          $answer[key] = texts;
          break;
        case 'evidences':
          var evidences = [];
          switch (question.evidenceType) {
            case 'photo':
              answer.photos.forEach(function (src) {
                evidences.push({
                  type: 'photo',
                  src: src
                });
              });
              break;
            case 'video':
              answer.videos.forEach(function (_ref2) {
                var thumbUrl = _ref2.thumbUrl,
                    videoUrl = _ref2.videoUrl;

                evidences.push({
                  type: 'video',
                  src: videoUrl,
                  cover: thumbUrl
                });
              });
              break;
            case 'record':
              answer.records.forEach(function (val) {
                evidences.push({
                  type: 'record',
                  src: val
                });
              });
              break;
            case 'qrcode':
              answer.qrcodes.forEach(function (val) {
                evidences.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, val, {
                  type: 'qrcode',
                  src: val.image_url
                }));
              });
              break;
          }
          $answer[key] = evidences;
          break;
      }
    });

    $answers.push($answer);
  });

  return $answers;
}

/* harmony default export */ __webpack_exports__["c"] = ({ convertQuestions: convertQuestions, convertAnswers: convertAnswers });

/***/ }),

/***/ 1543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_downloadjs__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CropperImage__ = __webpack_require__(1530);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  mixins: [],
  data: function data() {
    return {
      request: null,
      name: null,
      callback: Function.prototype,
      visible: false,
      type: null,
      copyType: null,
      files: [], // 当前操作的数据列表
      copySourceFiles: [], // 拷贝数据的来源列表
      checkedFiles: [], // 选中的数据列表
      stageFiles: [], // 因为操作暂存的数据列表
      cutPasteStageFiles: [], // 因为剪切操作暂存的数据列表
      top: 0,
      left: 0,
      parentElement: document.body,
      zIndex: 0,
      uploadData: {},
      uploadApi: 'uploadOrderReviewDirectFile',
      scope: '',
      readOnly: false,
      pasteMax: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_max_safe_integer___default.a
    };
  },

  computed: {},
  watch: {
    visible: function visible(val) {}
  },
  created: function created() {
    this.$nextTick(function () {});
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {
    setScope: function setScope(scope) {
      this.scope = scope;
    },
    setType: function setType(type) {
      this.type = type;
    },
    setFiles: function setFiles() {
      var files = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.files = files;
    },
    setCopyType: function setCopyType(type) {
      this.copyType = type;
    },
    setStageFiles: function setStageFiles() {
      var files = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      // 清空数据
      this.stageFiles.splice(0, this.stageFiles.length);
      this.cutPasteStageFiles.splice(0, this.cutPasteStageFiles.length);
      // 暂存数据
      this.stageFiles.push.apply(this.stageFiles, files);
      // 允许裁剪时
      if (!this.readOnly) {
        this.cutPasteStageFiles.push.apply(this.cutPasteStageFiles, files);
      }

      // TODO: 为了二维码的复制 这里暂时存到本地
      if (this.type === 'photo') {
        localStorage.setItem('copyForQrcode', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(files));
      }

      // TODO: 为了切换审核历史也能发复制 这里暂时存到本地
      localStorage.setItem('copyForReloadReviewData', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(files));
      localStorage.setItem('copyForReloadReviewDataType', this.type);
    },
    appendElement: function appendElement(element) {
      // 置入的父级容器
      if (element.constructor === String) {
        element = document.querySelector(element);
      }
      if (this.parentElement !== element) {
        this.parentElement = element;
        this.parentElement.appendChild(this.$el);
      }
    },
    show: function show(left, top) {
      // 获得容器的相对屏幕的位置信息
      var position = this.parentElement.getBoundingClientRect();
      // 获得绝对坐标
      this.top = top - position.top + this.parentElement.scrollTop - 2;
      this.left = left - position.left + this.parentElement.scrollLeft + 2;
      this.visible = true;
    },
    hide: function hide() {
      this.visible = false;
    },
    checked: function checked(file) {
      var index = this.checkedFiles.indexOf(file);
      if (index === -1) {
        this.checkedFiles.push(file);
      } else {
        this.checkedFiles.splice(index, 1);
      }
    },
    empty: function empty() {
      this.checkedFiles.splice(0, this.checkedFiles.length);
    },

    // 获取blob的文件后缀
    getExtByBlob: function getExtByBlob(blob) {
      return blob.type.split('/').pop();
    },
    modify: function modify() {
      var _this = this;

      var file = this.checkedFiles[0];
      Object(__WEBPACK_IMPORTED_MODULE_6__CropperImage__["a" /* default */])({
        url: file.src,
        callback: function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(blob, exif) {
            var params, res, uploadUrl, contentType, fileUrl;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    params = {
                      orderid: _this.uploadData.orderid,
                      ext: _this.getExtByBlob(blob),
                      content_type: blob.type
                    };
                    _context.next = 3;
                    return request.common(_this.uploadApi, params);

                  case 3:
                    res = _context.sent;

                    if (!(res.status === 200)) {
                      _context.next = 13;
                      break;
                    }

                    uploadUrl = res.data.signedUrl;
                    contentType = res.data.content_type;
                    fileUrl = res.data.url;
                    _context.next = 10;
                    return fetch(uploadUrl, {
                      method: 'PUT',
                      headers: new Headers({
                        'Content-Type': contentType
                      }),
                      body: blob
                    });

                  case 10:
                    file.src = fileUrl;
                    _context.next = 14;
                    break;

                  case 13:
                    _this.$message.error('图片保存失败');

                  case 14:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }));

          return function callback(_x3, _x4) {
            return _ref.apply(this, arguments);
          };
        }()
      });
      // this.copySourceFiles = this.files
      // this.setStageFiles(this.checkedFiles)
      this.empty();
      this.hide();
    },
    copy: function copy() {
      this.copyType = this.type;
      this.copySourceFiles = this.files;
      this.setStageFiles(this.checkedFiles);
      this.$message.success('\u590D\u5236\u4E86' + this.stageFiles.length + '\u4E2A\u9009\u9879');
      this.empty();
      this.hide();
    },
    cutPaste: function cutPaste() {
      var _this2 = this;

      if (this.stageFiles.length > this.pasteMax) {
        this.$message.error('剪贴失败，粘贴数量超出目标容量');
      } else {
        // 删除复制来源数据列表
        this.cutPasteStageFiles.forEach(function (file) {
          var index = _this2.copySourceFiles.indexOf(file);
          _this2.copySourceFiles.splice(index, 1);
        });
        // 添加复制的数据到当前列表
        var list = this.cutPasteStageFiles.filter(function (item) {
          return item.type === 'photo';
        }).map(function (item) {
          return item.src;
        });
        if (this.type === 'qrcode' && list.length > 0) {
          this.pasteToQrcodeData(list);
        } else {
          this.files.push.apply(this.files, JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.cutPasteStageFiles)));
        }
        this.$message.success('\u526A\u8D34\u4E86' + this.cutPasteStageFiles.length + '\u4E2A\u9009\u9879');
        this.setStageFiles();
      }
      this.hide();
    },
    paste: function paste() {
      if (this.stageFiles.length > this.pasteMax) {
        this.$message.error('粘贴失败，粘贴数量超出目标容量');
      } else {
        var list = this.stageFiles.filter(function (item) {
          return item.type === 'photo';
        }).map(function (item) {
          return item.src;
        });
        if (this.type === 'qrcode' && list.length > 0) {
          this.pasteToQrcodeData(list);
        } else {
          this.files.push.apply(this.files, JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.stageFiles)));
        }
        this.$message.success('\u7C98\u8D34\u4E86' + this.stageFiles.length + '\u4E2A\u9009\u9879');
      }
      this.hide();
    },
    pasteToQrcodeData: function pasteToQrcodeData(list) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(list.map(this.decodeQRFromFileUrl)).then(function (values) {
        var qrcodes = values.filter(function (value) {
          return value.length > 0;
        });
        if (qrcodes.length > 0) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(qrcodes.map(function (value) {
            return _this3.recognizeQrcodeData({ data: value, server_image_recognize: 0 });
          })).then(function (datas) {
            var files = datas.map(function (value, index) {
              return {
                data: value.data,
                image_url: list[index],
                status: value.status,
                type: _this3.type,
                src: list[index]
              };
            });
            if (list.length > 0) {
              _this3.files.push.apply(_this3.files, files);
            }
          });
        } else {
          _this3.$message.error('无法识别二维码信息');
        }
      });
    },
    remove: function remove() {
      var _this4 = this;

      this.$confirm('\u6B64\u64CD\u4F5C\u5C06\u5220\u9664' + this.checkedFiles.length + '\u9879\u6587\u4EF6, \u662F\u5426\u7EE7\u7EED?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.checkedFiles.forEach(function (file) {
          var index = _this4.files.indexOf(file);
          _this4.files.splice(index, 1);
        });
        _this4.empty();
        _this4.$message.success('删除成功!');
      }).catch(function () {
        _this4.$message.info('已取消删除');
      });
      this.hide();
    },
    download: function download() {
      this.checkedFiles.forEach(function (_ref2) {
        var src = _ref2.src;

        __WEBPACK_IMPORTED_MODULE_5_downloadjs___default()(filter.ossHost(src));
      });
      this.empty();
      this.hide();
    },


    // 识别二维码服务
    decodeQRFromFileUrl: function decodeQRFromFileUrl(fileUrl) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = JSON;
                _context2.next = 3;
                return request.common('getQrcodeContentData', { url: fileUrl }).then(function (res) {
                  return res.data;
                });

              case 3:
                _context2.t1 = _context2.sent;
                res = _context2.t0.parse.call(_context2.t0, _context2.t1);

                if (!(res.code === 0 && res.data.contents && res.data.contents.length > 0)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt('return', res.data.contents[0]);

              case 7:
                return _context2.abrupt('return', '');

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    recognizeQrcodeData: function recognizeQrcodeData(data) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', request.common('getRecognizeQrcodeData', data).then(function (res) {
                  return res.data;
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    }
  }
});

/***/ }),

/***/ 1544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CropperImage__ = __webpack_require__(1609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_piexifjs__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_piexifjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_piexifjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__piexif_helper_js__ = __webpack_require__(1651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_base64_blob__ = __webpack_require__(1652);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [],
  components: { CropperImage: __WEBPACK_IMPORTED_MODULE_3__CropperImage__["a" /* default */] },
  data: function data() {
    return {
      url: null,
      callback: Function.prototype,
      visible: false,
      exif: {
        datetime: null,
        gpsLongitude: null,
        gpsLatitude: null
      }
    };
  },

  computed: {
    lastUrl: function lastUrl() {
      var url = filter.ossHost(this.url);
      this.readExif(url);
      return url;
    }
  },
  watch: {
    visible: function visible(val) {
      if (!val) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {
    onConfirm: function onConfirm() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var base64, blob;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                base64 = _this.$refs.cropperImage.toDataURL();
                // 往图片中写入exif

                base64 = __WEBPACK_IMPORTED_MODULE_4_piexifjs___default.a.insert(__WEBPACK_IMPORTED_MODULE_4_piexifjs___default.a.dump(_this.createExif()), base64);
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_6_base64_blob__["a" /* base64ToBlob */])(base64);

              case 4:
                blob = _context.sent;

                _this.callback(blob, _this.exif);
                _this.visible = false;

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    displayExif: function displayExif(exif) {
      var helper = new __WEBPACK_IMPORTED_MODULE_5__piexif_helper_js__["a" /* default */](exif);
      this.exif.datetime = this.exif.datetime || helper.DateTimeOriginal() || helper.DateTime();
      this.exif.gpsLongitude = helper.GPSLongitude();
      this.exif.gpsLatitude = helper.GPSLatitude();
    },
    readExif: function readExif(url) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref, file, exif;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (url) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _context2.next = 4;
                return axios.create().get(url, {
                  responseType: 'blob'
                });

              case 4:
                _ref = _context2.sent;
                file = _ref.data;

                if (!(file.type === 'image/jpeg')) {
                  _context2.next = 13;
                  break;
                }

                _context2.t0 = __WEBPACK_IMPORTED_MODULE_4_piexifjs___default.a;
                _context2.next = 10;
                return Object(__WEBPACK_IMPORTED_MODULE_6_base64_blob__["b" /* blobToBase64 */])(file);

              case 10:
                _context2.t1 = _context2.sent;
                exif = _context2.t0.load.call(_context2.t0, _context2.t1);

                _this2.displayExif(exif);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    createExif: function createExif() {
      var helper = new __WEBPACK_IMPORTED_MODULE_5__piexif_helper_js__["a" /* default */]();
      helper.DateTimeOriginal(this.exif.datetime);
      helper.DateTime(this.exif.datetime);
      helper.GPSLongitude(this.exif.gpsLongitude);
      helper.GPSLatitude(this.exif.gpsLatitude);
      return helper.exif;
    }
  }
});

/***/ }),

/***/ 1545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cropperjs_dist_cropper_css__ = __webpack_require__(1648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cropperjs_dist_cropper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_cropperjs_dist_cropper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_cropperjs__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_cropperjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_cropperjs__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CropperImage',
  props: {
    url: String
  },
  data: function data() {
    return {
      isCrop: false,
      loading: false
    };
  },

  watch: {
    url: function url(value) {
      if (value) {
        this.destroy();
        this.create();
      }
    }
  },
  created: function created() {
    this.create();
  },
  mounted: function mounted() {},
  updated: function updated() {},
  destroyed: function destroyed() {
    this.destroy();
  },

  methods: {
    create: function create() {
      var _this = this;

      this.loading = true;
      this.$nextTick(function () {
        _this.cropper = new __WEBPACK_IMPORTED_MODULE_3_cropperjs___default.a(_this.$refs.image, {
          autoCrop: false,
          dragMode: 'move',
          crop: function crop(e) {
            // console.log(e.detail.x)
            // console.log(e.detail.y)
            // console.log(e.detail.width)
            // console.log(e.detail.height)
            // console.log(e.detail.rotate)
            // console.log(e.detail.scaleX)
            // console.log(e.detail.scaleY)
          }
        });
        _this.$refs.image.addEventListener('ready', function () {
          _this.loading = false;
        });
      });
    },
    destroy: function destroy() {
      this.cropper && this.cropper.destroy();
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
    },
    move: function move() {
      this.isCrop = false;
      this.cropper.clear().setDragMode('move');
    },
    crop: function crop() {
      if (this.isCrop) {
        this.cropper.clear();
        this.isCrop = false;
      } else {
        this.cropper.crop();
        this.isCrop = true;
      }
    },
    toDataURL: function toDataURL() {
      return this.cropper.getCroppedCanvas().toDataURL('image/jpeg');
    },
    toBlob: function toBlob() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var canvas = _this2.cropper.getCroppedCanvas();
        canvas.toBlob(function (blob) {
          resolve(blob);
        }, 'image/jpeg');
      });
    }
  }

});

/***/ }),

/***/ 1546:
/***/ (function(module, exports, __webpack_require__) {

/* piexifjs

The MIT License (MIT)

Copyright (c) 2014, 2015 hMatoba(https://github.com/hMatoba)

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

(function () {
    "use strict";
    var that = {};
    that.version = "1.0.4";

    that.remove = function (jpeg) {
        var b64 = false;
        if (jpeg.slice(0, 2) == "\xff\xd8") {
        } else if (jpeg.slice(0, 23) == "data:image/jpeg;base64," || jpeg.slice(0, 22) == "data:image/jpg;base64,") {
            jpeg = atob(jpeg.split(",")[1]);
            b64 = true;
        } else {
            throw new Error("Given data is not jpeg.");
        }
        
        var segments = splitIntoSegments(jpeg);
        var newSegments = segments.filter(function(seg){
          return  !(seg.slice(0, 2) == "\xff\xe1" &&
                   seg.slice(4, 10) == "Exif\x00\x00"); 
        });
        
        var new_data = newSegments.join("");
        if (b64) {
            new_data = "data:image/jpeg;base64," + btoa(new_data);
        }

        return new_data;
    };


    that.insert = function (exif, jpeg) {
        var b64 = false;
        if (exif.slice(0, 6) != "\x45\x78\x69\x66\x00\x00") {
            throw new Error("Given data is not exif.");
        }
        if (jpeg.slice(0, 2) == "\xff\xd8") {
        } else if (jpeg.slice(0, 23) == "data:image/jpeg;base64," || jpeg.slice(0, 22) == "data:image/jpg;base64,") {
            jpeg = atob(jpeg.split(",")[1]);
            b64 = true;
        } else {
            throw new Error("Given data is not jpeg.");
        }

        var exifStr = "\xff\xe1" + pack(">H", [exif.length + 2]) + exif;
        var segments = splitIntoSegments(jpeg);
        var new_data = mergeSegments(segments, exifStr);
        if (b64) {
            new_data = "data:image/jpeg;base64," + btoa(new_data);
        }

        return new_data;
    };


    that.load = function (data) {
        var input_data;
        if (typeof (data) == "string") {
            if (data.slice(0, 2) == "\xff\xd8") {
                input_data = data;
            } else if (data.slice(0, 23) == "data:image/jpeg;base64," || data.slice(0, 22) == "data:image/jpg;base64,") {
                input_data = atob(data.split(",")[1]);
            } else if (data.slice(0, 4) == "Exif") {
                input_data = data.slice(6);
            } else {
                throw new Error("'load' gots invalid file data.");
            }
        } else {
            throw new Error("'load' gots invalid type argument.");
        }

        var exifDict = {};
        var exif_dict = {
            "0th": {},
            "Exif": {},
            "GPS": {},
            "Interop": {},
            "1st": {},
            "thumbnail": null
        };
        var exifReader = new ExifReader(input_data);
        if (exifReader.tiftag === null) {
            return exif_dict;
        }

        if (exifReader.tiftag.slice(0, 2) == "\x49\x49") {
            exifReader.endian_mark = "<";
        } else {
            exifReader.endian_mark = ">";
        }

        var pointer = unpack(exifReader.endian_mark + "L",
            exifReader.tiftag.slice(4, 8))[0];
        exif_dict["0th"] = exifReader.get_ifd(pointer, "0th");

        var first_ifd_pointer = exif_dict["0th"]["first_ifd_pointer"];
        delete exif_dict["0th"]["first_ifd_pointer"];

        if (34665 in exif_dict["0th"]) {
            pointer = exif_dict["0th"][34665];
            exif_dict["Exif"] = exifReader.get_ifd(pointer, "Exif");
        }
        if (34853 in exif_dict["0th"]) {
            pointer = exif_dict["0th"][34853];
            exif_dict["GPS"] = exifReader.get_ifd(pointer, "GPS");
        }
        if (40965 in exif_dict["Exif"]) {
            pointer = exif_dict["Exif"][40965];
            exif_dict["Interop"] = exifReader.get_ifd(pointer, "Interop");
        }
        if (first_ifd_pointer != "\x00\x00\x00\x00") {
            pointer = unpack(exifReader.endian_mark + "L",
                first_ifd_pointer)[0];
            exif_dict["1st"] = exifReader.get_ifd(pointer, "1st");
            if ((513 in exif_dict["1st"]) && (514 in exif_dict["1st"])) {
                var end = exif_dict["1st"][513] + exif_dict["1st"][514];
                var thumb = exifReader.tiftag.slice(exif_dict["1st"][513], end);
                exif_dict["thumbnail"] = thumb;
            }
        }

        return exif_dict;
    };


    that.dump = function (exif_dict_original) {
        var TIFF_HEADER_LENGTH = 8;

        var exif_dict = copy(exif_dict_original);
        var header = "Exif\x00\x00\x4d\x4d\x00\x2a\x00\x00\x00\x08";
        var exif_is = false;
        var gps_is = false;
        var interop_is = false;
        var first_is = false;

        var zeroth_ifd,
            exif_ifd,
            interop_ifd,
            gps_ifd,
            first_ifd;
        
        if ("0th" in exif_dict) {
            zeroth_ifd = exif_dict["0th"];
        } else {
            zeroth_ifd = {};
        }
        
        if ((("Exif" in exif_dict) && (Object.keys(exif_dict["Exif"]).length)) ||
            (("Interop" in exif_dict) && (Object.keys(exif_dict["Interop"]).length))) {
            zeroth_ifd[34665] = 1;
            exif_is = true;
            exif_ifd = exif_dict["Exif"];
            if (("Interop" in exif_dict) && Object.keys(exif_dict["Interop"]).length) {
                exif_ifd[40965] = 1;
                interop_is = true;
                interop_ifd = exif_dict["Interop"];
            } else if (Object.keys(exif_ifd).indexOf(that.ExifIFD.InteroperabilityTag.toString()) > -1) {
                delete exif_ifd[40965];
            }
        } else if (Object.keys(zeroth_ifd).indexOf(that.ImageIFD.ExifTag.toString()) > -1) {
            delete zeroth_ifd[34665];
        }

        if (("GPS" in exif_dict) && (Object.keys(exif_dict["GPS"]).length)) {
            zeroth_ifd[that.ImageIFD.GPSTag] = 1;
            gps_is = true;
            gps_ifd = exif_dict["GPS"];
        } else if (Object.keys(zeroth_ifd).indexOf(that.ImageIFD.GPSTag.toString()) > -1) {
            delete zeroth_ifd[that.ImageIFD.GPSTag];
        }
        
        if (("1st" in exif_dict) &&
            ("thumbnail" in exif_dict) &&
            (exif_dict["thumbnail"] != null)) {
            first_is = true;
            exif_dict["1st"][513] = 1;
            exif_dict["1st"][514] = 1;
            first_ifd = exif_dict["1st"];
        }
        
        var zeroth_set = _dict_to_bytes(zeroth_ifd, "0th", 0);
        var zeroth_length = (zeroth_set[0].length + exif_is * 12 + gps_is * 12 + 4 +
            zeroth_set[1].length);

        var exif_set,
            exif_bytes = "",
            exif_length = 0,
            gps_set,
            gps_bytes = "",
            gps_length = 0,
            interop_set,
            interop_bytes = "",
            interop_length = 0,
            first_set,
            first_bytes = "",
            thumbnail;
        if (exif_is) {
            exif_set = _dict_to_bytes(exif_ifd, "Exif", zeroth_length);
            exif_length = exif_set[0].length + interop_is * 12 + exif_set[1].length;
        }
        if (gps_is) {
            gps_set = _dict_to_bytes(gps_ifd, "GPS", zeroth_length + exif_length);
            gps_bytes = gps_set.join("");
            gps_length = gps_bytes.length;
        }
        if (interop_is) {
            var offset = zeroth_length + exif_length + gps_length;
            interop_set = _dict_to_bytes(interop_ifd, "Interop", offset);
            interop_bytes = interop_set.join("");
            interop_length = interop_bytes.length;
        }
        if (first_is) {
            var offset = zeroth_length + exif_length + gps_length + interop_length;
            first_set = _dict_to_bytes(first_ifd, "1st", offset);
            thumbnail = _get_thumbnail(exif_dict["thumbnail"]);
            if (thumbnail.length > 64000) {
                throw new Error("Given thumbnail is too large. max 64kB");
            }
        }

        var exif_pointer = "",
            gps_pointer = "",
            interop_pointer = "",
            first_ifd_pointer = "\x00\x00\x00\x00";
        if (exif_is) {
            var pointer_value = TIFF_HEADER_LENGTH + zeroth_length;
            var pointer_str = pack(">L", [pointer_value]);
            var key = 34665;
            var key_str = pack(">H", [key]);
            var type_str = pack(">H", [TYPES["Long"]]);
            var length_str = pack(">L", [1]);
            exif_pointer = key_str + type_str + length_str + pointer_str;
        }
        if (gps_is) {
            var pointer_value = TIFF_HEADER_LENGTH + zeroth_length + exif_length;
            var pointer_str = pack(">L", [pointer_value]);
            var key = 34853;
            var key_str = pack(">H", [key]);
            var type_str = pack(">H", [TYPES["Long"]]);
            var length_str = pack(">L", [1]);
            gps_pointer = key_str + type_str + length_str + pointer_str;
        }
        if (interop_is) {
            var pointer_value = (TIFF_HEADER_LENGTH +
                zeroth_length + exif_length + gps_length);
            var pointer_str = pack(">L", [pointer_value]);
            var key = 40965;
            var key_str = pack(">H", [key]);
            var type_str = pack(">H", [TYPES["Long"]]);
            var length_str = pack(">L", [1]);
            interop_pointer = key_str + type_str + length_str + pointer_str;
        }
        if (first_is) {
            var pointer_value = (TIFF_HEADER_LENGTH + zeroth_length +
                exif_length + gps_length + interop_length);
            first_ifd_pointer = pack(">L", [pointer_value]);
            var thumbnail_pointer = (pointer_value + first_set[0].length + 24 +
                4 + first_set[1].length);
            var thumbnail_p_bytes = ("\x02\x01\x00\x04\x00\x00\x00\x01" +
                pack(">L", [thumbnail_pointer]));
            var thumbnail_length_bytes = ("\x02\x02\x00\x04\x00\x00\x00\x01" +
                pack(">L", [thumbnail.length]));
            first_bytes = (first_set[0] + thumbnail_p_bytes +
                thumbnail_length_bytes + "\x00\x00\x00\x00" +
                first_set[1] + thumbnail);
        }

        var zeroth_bytes = (zeroth_set[0] + exif_pointer + gps_pointer +
            first_ifd_pointer + zeroth_set[1]);
        if (exif_is) {
            exif_bytes = exif_set[0] + interop_pointer + exif_set[1];
        }

        return (header + zeroth_bytes + exif_bytes + gps_bytes +
            interop_bytes + first_bytes);
    };


    function copy(obj) {
        return JSON.parse(JSON.stringify(obj));
    }


    function _get_thumbnail(jpeg) {
        var segments = splitIntoSegments(jpeg);
        while (("\xff\xe0" <= segments[1].slice(0, 2)) && (segments[1].slice(0, 2) <= "\xff\xef")) {
            segments = [segments[0]].concat(segments.slice(2));
        }
        return segments.join("");
    }


    function _pack_byte(array) {
        return pack(">" + nStr("B", array.length), array);
    }


    function _pack_short(array) {
        return pack(">" + nStr("H", array.length), array);
    }


    function _pack_long(array) {
        return pack(">" + nStr("L", array.length), array);
    }


    function _value_to_bytes(raw_value, value_type, offset) {
        var four_bytes_over = "";
        var value_str = "";
        var length,
            new_value,
            num,
            den;

        if (value_type == "Byte") {
            length = raw_value.length;
            if (length <= 4) {
                value_str = (_pack_byte(raw_value) +
                    nStr("\x00", 4 - length));
            } else {
                value_str = pack(">L", [offset]);
                four_bytes_over = _pack_byte(raw_value);
            }
        } else if (value_type == "Short") {
            length = raw_value.length;
            if (length <= 2) {
                value_str = (_pack_short(raw_value) +
                    nStr("\x00\x00", 2 - length));
            } else {
                value_str = pack(">L", [offset]);
                four_bytes_over = _pack_short(raw_value);
            }
        } else if (value_type == "Long") {
            length = raw_value.length;
            if (length <= 1) {
                value_str = _pack_long(raw_value);
            } else {
                value_str = pack(">L", [offset]);
                four_bytes_over = _pack_long(raw_value);
            }
        } else if (value_type == "Ascii") {
            new_value = raw_value + "\x00";
            length = new_value.length;
            if (length > 4) {
                value_str = pack(">L", [offset]);
                four_bytes_over = new_value;
            } else {
                value_str = new_value + nStr("\x00", 4 - length);
            }
        } else if (value_type == "Rational") {
            if (typeof (raw_value[0]) == "number") {
                length = 1;
                num = raw_value[0];
                den = raw_value[1];
                new_value = pack(">L", [num]) + pack(">L", [den]);
            } else {
                length = raw_value.length;
                new_value = "";
                for (var n = 0; n < length; n++) {
                    num = raw_value[n][0];
                    den = raw_value[n][1];
                    new_value += (pack(">L", [num]) +
                        pack(">L", [den]));
                }
            }
            value_str = pack(">L", [offset]);
            four_bytes_over = new_value;
        } else if (value_type == "SRational") {
            if (typeof (raw_value[0]) == "number") {
                length = 1;
                num = raw_value[0];
                den = raw_value[1];
                new_value = pack(">l", [num]) + pack(">l", [den]);
            } else {
                length = raw_value.length;
                new_value = "";
                for (var n = 0; n < length; n++) {
                    num = raw_value[n][0];
                    den = raw_value[n][1];
                    new_value += (pack(">l", [num]) +
                        pack(">l", [den]));
                }
            }
            value_str = pack(">L", [offset]);
            four_bytes_over = new_value;
        } else if (value_type == "Undefined") {
            length = raw_value.length;
            if (length > 4) {
                value_str = pack(">L", [offset]);
                four_bytes_over = raw_value;
            } else {
                value_str = raw_value + nStr("\x00", 4 - length);
            }
        }

        var length_str = pack(">L", [length]);

        return [length_str, value_str, four_bytes_over];
    }

    function _dict_to_bytes(ifd_dict, ifd, ifd_offset) {
        var TIFF_HEADER_LENGTH = 8;
        var tag_count = Object.keys(ifd_dict).length;
        var entry_header = pack(">H", [tag_count]);
        var entries_length;
        if (["0th", "1st"].indexOf(ifd) > -1) {
            entries_length = 2 + tag_count * 12 + 4;
        } else {
            entries_length = 2 + tag_count * 12;
        }
        var entries = "";
        var values = "";
        var key;

        for (var key in ifd_dict) {
            if (typeof (key) == "string") {
                key = parseInt(key);
            }
            if ((ifd == "0th") && ([34665, 34853].indexOf(key) > -1)) {
                continue;
            } else if ((ifd == "Exif") && (key == 40965)) {
                continue;
            } else if ((ifd == "1st") && ([513, 514].indexOf(key) > -1)) {
                continue;
            }

            var raw_value = ifd_dict[key];
            var key_str = pack(">H", [key]);
            var value_type = TAGS[ifd][key]["type"];
            var type_str = pack(">H", [TYPES[value_type]]);

            if (typeof (raw_value) == "number") {
                raw_value = [raw_value];
            }
            var offset = TIFF_HEADER_LENGTH + entries_length + ifd_offset + values.length;
            var b = _value_to_bytes(raw_value, value_type, offset);
            var length_str = b[0];
            var value_str = b[1];
            var four_bytes_over = b[2];

            entries += key_str + type_str + length_str + value_str;
            values += four_bytes_over;
        }

        return [entry_header + entries, values];
    }



    function ExifReader(data) {
        var segments,
            app1;
        if (data.slice(0, 2) == "\xff\xd8") { // JPEG
            segments = splitIntoSegments(data);
            app1 = getExifSeg(segments);
            if (app1) {
                this.tiftag = app1.slice(10);
            } else {
                this.tiftag = null;
            }
        } else if (["\x49\x49", "\x4d\x4d"].indexOf(data.slice(0, 2)) > -1) { // TIFF
            this.tiftag = data;
        } else if (data.slice(0, 4) == "Exif") { // Exif
            this.tiftag = data.slice(6);
        } else {
            throw new Error("Given file is neither JPEG nor TIFF.");
        }
    }

    ExifReader.prototype = {
        get_ifd: function (pointer, ifd_name) {
            var ifd_dict = {};
            var tag_count = unpack(this.endian_mark + "H",
                this.tiftag.slice(pointer, pointer + 2))[0];
            var offset = pointer + 2;
            var t;
            if (["0th", "1st"].indexOf(ifd_name) > -1) {
                t = "Image";
            } else {
                t = ifd_name;
            }

            for (var x = 0; x < tag_count; x++) {
                pointer = offset + 12 * x;
                var tag = unpack(this.endian_mark + "H",
                    this.tiftag.slice(pointer, pointer + 2))[0];
                var value_type = unpack(this.endian_mark + "H",
                    this.tiftag.slice(pointer + 2, pointer + 4))[0];
                var value_num = unpack(this.endian_mark + "L",
                    this.tiftag.slice(pointer + 4, pointer + 8))[0];
                var value = this.tiftag.slice(pointer + 8, pointer + 12);

                var v_set = [value_type, value_num, value];
                if (tag in TAGS[t]) {
                    ifd_dict[tag] = this.convert_value(v_set);
                }
            }

            if (ifd_name == "0th") {
                pointer = offset + 12 * tag_count;
                ifd_dict["first_ifd_pointer"] = this.tiftag.slice(pointer, pointer + 4);
            }

            return ifd_dict;
        },

        convert_value: function (val) {
            var data = null;
            var t = val[0];
            var length = val[1];
            var value = val[2];
            var pointer;

            if (t == 1) { // BYTE
                if (length > 4) {
                    pointer = unpack(this.endian_mark + "L", value)[0];
                    data = unpack(this.endian_mark + nStr("B", length),
                        this.tiftag.slice(pointer, pointer + length));
                } else {
                    data = unpack(this.endian_mark + nStr("B", length), value.slice(0, length));
                }
            } else if (t == 2) { // ASCII
                if (length > 4) {
                    pointer = unpack(this.endian_mark + "L", value)[0];
                    data = this.tiftag.slice(pointer, pointer + length - 1);
                } else {
                    data = value.slice(0, length - 1);
                }
            } else if (t == 3) { // SHORT
                if (length > 2) {
                    pointer = unpack(this.endian_mark + "L", value)[0];
                    data = unpack(this.endian_mark + nStr("H", length),
                        this.tiftag.slice(pointer, pointer + length * 2));
                } else {
                    data = unpack(this.endian_mark + nStr("H", length),
                        value.slice(0, length * 2));
                }
            } else if (t == 4) { // LONG
                if (length > 1) {
                    pointer = unpack(this.endian_mark + "L", value)[0];
                    data = unpack(this.endian_mark + nStr("L", length),
                        this.tiftag.slice(pointer, pointer + length * 4));
                } else {
                    data = unpack(this.endian_mark + nStr("L", length),
                        value);
                }
            } else if (t == 5) { // RATIONAL
                pointer = unpack(this.endian_mark + "L", value)[0];
                if (length > 1) {
                    data = [];
                    for (var x = 0; x < length; x++) {
                        data.push([unpack(this.endian_mark + "L",
                                this.tiftag.slice(pointer + x * 8, pointer + 4 + x * 8))[0],
                                   unpack(this.endian_mark + "L",
                                this.tiftag.slice(pointer + 4 + x * 8, pointer + 8 + x * 8))[0]
                                   ]);
                    }
                } else {
                    data = [unpack(this.endian_mark + "L",
                            this.tiftag.slice(pointer, pointer + 4))[0],
                            unpack(this.endian_mark + "L",
                            this.tiftag.slice(pointer + 4, pointer + 8))[0]
                            ];
                }
            } else if (t == 7) { // UNDEFINED BYTES
                if (length > 4) {
                    pointer = unpack(this.endian_mark + "L", value)[0];
                    data = this.tiftag.slice(pointer, pointer + length);
                } else {
                    data = value.slice(0, length);
                }
            } else if (t == 9) { // SLONG
                if (length > 1) {
                    pointer = unpack(this.endian_mark + "L", value)[0];
                    data = unpack(this.endian_mark + nStr("l", length),
                        this.tiftag.slice(pointer, pointer + length * 4));
                } else {
                    data = unpack(this.endian_mark + nStr("l", length),
                        value);
                }
            } else if (t == 10) { // SRATIONAL
                pointer = unpack(this.endian_mark + "L", value)[0];
                if (length > 1) {
                    data = [];
                    for (var x = 0; x < length; x++) {
                        data.push([unpack(this.endian_mark + "l",
                                this.tiftag.slice(pointer + x * 8, pointer + 4 + x * 8))[0],
                                   unpack(this.endian_mark + "l",
                                this.tiftag.slice(pointer + 4 + x * 8, pointer + 8 + x * 8))[0]
                                  ]);
                    }
                } else {
                    data = [unpack(this.endian_mark + "l",
                            this.tiftag.slice(pointer, pointer + 4))[0],
                            unpack(this.endian_mark + "l",
                            this.tiftag.slice(pointer + 4, pointer + 8))[0]
                           ];
                }
            } else {
                throw new Error("Exif might be wrong. Got incorrect value " +
                    "type to decode. type:" + t);
            }

            if ((data instanceof Array) && (data.length == 1)) {
                return data[0];
            } else {
                return data;
            }
        },
    };


    if (typeof window !== "undefined" && typeof window.btoa === "function") {
        var btoa = window.btoa;
    }
    if (typeof btoa === "undefined") {
        var btoa = function (input) {        var output = "";
            var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
            var i = 0;
            var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

            while (i < input.length) {

                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                keyStr.charAt(enc1) + keyStr.charAt(enc2) +
                keyStr.charAt(enc3) + keyStr.charAt(enc4);

            }

            return output;
        };
    }
    
    
    if (typeof window !== "undefined" && typeof window.atob === "function") {
        var atob = window.atob;
    }
    if (typeof atob === "undefined") {
        var atob = function (input) {
            var output = "";
            var chr1, chr2, chr3;
            var enc1, enc2, enc3, enc4;
            var i = 0;
            var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

            while (i < input.length) {

                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 != 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 != 64) {
                    output = output + String.fromCharCode(chr3);
                }

            }

            return output;
        };
    }


    function getImageSize(imageArray) {
        var segments = slice2Segments(imageArray);
        var seg,
            width,
            height,
            SOF = [192, 193, 194, 195, 197, 198, 199, 201, 202, 203, 205, 206, 207];

        for (var x = 0; x < segments.length; x++) {
            seg = segments[x];
            if (SOF.indexOf(seg[1]) >= 0) {
                height = seg[5] * 256 + seg[6];
                width = seg[7] * 256 + seg[8];
                break;
            }
        }
        return [width, height];
    }


    function pack(mark, array) {
        if (!(array instanceof Array)) {
            throw new Error("'pack' error. Got invalid type argument.");
        }
        if ((mark.length - 1) != array.length) {
            throw new Error("'pack' error. " + (mark.length - 1) + " marks, " + array.length + " elements.");
        }

        var littleEndian;
        if (mark[0] == "<") {
            littleEndian = true;
        } else if (mark[0] == ">") {
            littleEndian = false;
        } else {
            throw new Error("");
        }
        var packed = "";
        var p = 1;
        var val = null;
        var c = null;
        var valStr = null;

        while (c = mark[p]) {
            if (c.toLowerCase() == "b") {
                val = array[p - 1];
                if ((c == "b") && (val < 0)) {
                    val += 0x100;
                }
                if ((val > 0xff) || (val < 0)) {
                    throw new Error("'pack' error.");
                } else {
                    valStr = String.fromCharCode(val);
                }
            } else if (c == "H") {
                val = array[p - 1];
                if ((val > 0xffff) || (val < 0)) {
                    throw new Error("'pack' error.");
                } else {
                    valStr = String.fromCharCode(Math.floor((val % 0x10000) / 0x100)) +
                        String.fromCharCode(val % 0x100);
                    if (littleEndian) {
                        valStr = valStr.split("").reverse().join("");
                    }
                }
            } else if (c.toLowerCase() == "l") {
                val = array[p - 1];
                if ((c == "l") && (val < 0)) {
                    val += 0x100000000;
                }
                if ((val > 0xffffffff) || (val < 0)) {
                    throw new Error("'pack' error.");
                } else {
                    valStr = String.fromCharCode(Math.floor(val / 0x1000000)) +
                        String.fromCharCode(Math.floor((val % 0x1000000) / 0x10000)) +
                        String.fromCharCode(Math.floor((val % 0x10000) / 0x100)) +
                        String.fromCharCode(val % 0x100);
                    if (littleEndian) {
                        valStr = valStr.split("").reverse().join("");
                    }
                }
            } else {
                throw new Error("'pack' error.");
            }

            packed += valStr;
            p += 1;
        }

        return packed;
    }

    function unpack(mark, str) {
        if (typeof (str) != "string") {
            throw new Error("'unpack' error. Got invalid type argument.");
        }
        var l = 0;
        for (var markPointer = 1; markPointer < mark.length; markPointer++) {
            if (mark[markPointer].toLowerCase() == "b") {
                l += 1;
            } else if (mark[markPointer].toLowerCase() == "h") {
                l += 2;
            } else if (mark[markPointer].toLowerCase() == "l") {
                l += 4;
            } else {
                throw new Error("'unpack' error. Got invalid mark.");
            }
        }

        if (l != str.length) {
            throw new Error("'unpack' error. Mismatch between symbol and string length. " + l + ":" + str.length);
        }

        var littleEndian;
        if (mark[0] == "<") {
            littleEndian = true;
        } else if (mark[0] == ">") {
            littleEndian = false;
        } else {
            throw new Error("'unpack' error.");
        }
        var unpacked = [];
        var strPointer = 0;
        var p = 1;
        var val = null;
        var c = null;
        var length = null;
        var sliced = "";

        while (c = mark[p]) {
            if (c.toLowerCase() == "b") {
                length = 1;
                sliced = str.slice(strPointer, strPointer + length);
                val = sliced.charCodeAt(0);
                if ((c == "b") && (val >= 0x80)) {
                    val -= 0x100;
                }
            } else if (c == "H") {
                length = 2;
                sliced = str.slice(strPointer, strPointer + length);
                if (littleEndian) {
                    sliced = sliced.split("").reverse().join("");
                }
                val = sliced.charCodeAt(0) * 0x100 +
                    sliced.charCodeAt(1);
            } else if (c.toLowerCase() == "l") {
                length = 4;
                sliced = str.slice(strPointer, strPointer + length);
                if (littleEndian) {
                    sliced = sliced.split("").reverse().join("");
                }
                val = sliced.charCodeAt(0) * 0x1000000 +
                    sliced.charCodeAt(1) * 0x10000 +
                    sliced.charCodeAt(2) * 0x100 +
                    sliced.charCodeAt(3);
                if ((c == "l") && (val >= 0x80000000)) {
                    val -= 0x100000000;
                }
            } else {
                throw new Error("'unpack' error. " + c);
            }

            unpacked.push(val);
            strPointer += length;
            p += 1;
        }

        return unpacked;
    }

    function nStr(ch, num) {
        var str = "";
        for (var i = 0; i < num; i++) {
            str += ch;
        }
        return str;
    }

    function splitIntoSegments(data) {
        if (data.slice(0, 2) != "\xff\xd8") {
            throw new Error("Given data isn't JPEG.");
        }

        var head = 2;
        var segments = ["\xff\xd8"];
        while (true) {
            if (data.slice(head, head + 2) == "\xff\xda") {
                segments.push(data.slice(head));
                break;
            } else {
                var length = unpack(">H", data.slice(head + 2, head + 4))[0];
                var endPoint = head + length + 2;
                segments.push(data.slice(head, endPoint));
                head = endPoint;
            }

            if (head >= data.length) {
                throw new Error("Wrong JPEG data.");
            }
        }
        return segments;
    }


    function getExifSeg(segments) {
        var seg;
        for (var i = 0; i < segments.length; i++) {
            seg = segments[i];
            if (seg.slice(0, 2) == "\xff\xe1" &&
                   seg.slice(4, 10) == "Exif\x00\x00") {
                return seg;
            }
        }
        return null;
    }


    function mergeSegments(segments, exif) {
        var hasExifSegment = false;
        var additionalAPP1ExifSegments = [];

        segments.forEach(function(segment, i) {
            // Replace first occurence of APP1:Exif segment
            if (segment.slice(0, 2) == "\xff\xe1" &&
                segment.slice(4, 10) == "Exif\x00\x00"
            ) {
                if (!hasExifSegment) {
                    segments[i] = exif;
                    hasExifSegment = true;
                } else {
                    additionalAPP1ExifSegments.unshift(i);
                }
            }
        });

        // Remove additional occurences of APP1:Exif segment
        additionalAPP1ExifSegments.forEach(function(segmentIndex) {
            segments.splice(segmentIndex, 1);
        });

        if (!hasExifSegment && exif) {
            segments = [segments[0], exif].concat(segments.slice(1));
        }

        return segments.join("");
    }


    function toHex(str) {
        var hexStr = "";
        for (var i = 0; i < str.length; i++) {
            var h = str.charCodeAt(i);
            var hex = ((h < 10) ? "0" : "") + h.toString(16);
            hexStr += hex + " ";
        }
        return hexStr;
    }


    var TYPES = {
        "Byte": 1,
        "Ascii": 2,
        "Short": 3,
        "Long": 4,
        "Rational": 5,
        "Undefined": 7,
        "SLong": 9,
        "SRational": 10
    };


    var TAGS = {
        'Image': {
            11: {
                'name': 'ProcessingSoftware',
                'type': 'Ascii'
            },
            254: {
                'name': 'NewSubfileType',
                'type': 'Long'
            },
            255: {
                'name': 'SubfileType',
                'type': 'Short'
            },
            256: {
                'name': 'ImageWidth',
                'type': 'Long'
            },
            257: {
                'name': 'ImageLength',
                'type': 'Long'
            },
            258: {
                'name': 'BitsPerSample',
                'type': 'Short'
            },
            259: {
                'name': 'Compression',
                'type': 'Short'
            },
            262: {
                'name': 'PhotometricInterpretation',
                'type': 'Short'
            },
            263: {
                'name': 'Threshholding',
                'type': 'Short'
            },
            264: {
                'name': 'CellWidth',
                'type': 'Short'
            },
            265: {
                'name': 'CellLength',
                'type': 'Short'
            },
            266: {
                'name': 'FillOrder',
                'type': 'Short'
            },
            269: {
                'name': 'DocumentName',
                'type': 'Ascii'
            },
            270: {
                'name': 'ImageDescription',
                'type': 'Ascii'
            },
            271: {
                'name': 'Make',
                'type': 'Ascii'
            },
            272: {
                'name': 'Model',
                'type': 'Ascii'
            },
            273: {
                'name': 'StripOffsets',
                'type': 'Long'
            },
            274: {
                'name': 'Orientation',
                'type': 'Short'
            },
            277: {
                'name': 'SamplesPerPixel',
                'type': 'Short'
            },
            278: {
                'name': 'RowsPerStrip',
                'type': 'Long'
            },
            279: {
                'name': 'StripByteCounts',
                'type': 'Long'
            },
            282: {
                'name': 'XResolution',
                'type': 'Rational'
            },
            283: {
                'name': 'YResolution',
                'type': 'Rational'
            },
            284: {
                'name': 'PlanarConfiguration',
                'type': 'Short'
            },
            290: {
                'name': 'GrayResponseUnit',
                'type': 'Short'
            },
            291: {
                'name': 'GrayResponseCurve',
                'type': 'Short'
            },
            292: {
                'name': 'T4Options',
                'type': 'Long'
            },
            293: {
                'name': 'T6Options',
                'type': 'Long'
            },
            296: {
                'name': 'ResolutionUnit',
                'type': 'Short'
            },
            301: {
                'name': 'TransferFunction',
                'type': 'Short'
            },
            305: {
                'name': 'Software',
                'type': 'Ascii'
            },
            306: {
                'name': 'DateTime',
                'type': 'Ascii'
            },
            315: {
                'name': 'Artist',
                'type': 'Ascii'
            },
            316: {
                'name': 'HostComputer',
                'type': 'Ascii'
            },
            317: {
                'name': 'Predictor',
                'type': 'Short'
            },
            318: {
                'name': 'WhitePoint',
                'type': 'Rational'
            },
            319: {
                'name': 'PrimaryChromaticities',
                'type': 'Rational'
            },
            320: {
                'name': 'ColorMap',
                'type': 'Short'
            },
            321: {
                'name': 'HalftoneHints',
                'type': 'Short'
            },
            322: {
                'name': 'TileWidth',
                'type': 'Short'
            },
            323: {
                'name': 'TileLength',
                'type': 'Short'
            },
            324: {
                'name': 'TileOffsets',
                'type': 'Short'
            },
            325: {
                'name': 'TileByteCounts',
                'type': 'Short'
            },
            330: {
                'name': 'SubIFDs',
                'type': 'Long'
            },
            332: {
                'name': 'InkSet',
                'type': 'Short'
            },
            333: {
                'name': 'InkNames',
                'type': 'Ascii'
            },
            334: {
                'name': 'NumberOfInks',
                'type': 'Short'
            },
            336: {
                'name': 'DotRange',
                'type': 'Byte'
            },
            337: {
                'name': 'TargetPrinter',
                'type': 'Ascii'
            },
            338: {
                'name': 'ExtraSamples',
                'type': 'Short'
            },
            339: {
                'name': 'SampleFormat',
                'type': 'Short'
            },
            340: {
                'name': 'SMinSampleValue',
                'type': 'Short'
            },
            341: {
                'name': 'SMaxSampleValue',
                'type': 'Short'
            },
            342: {
                'name': 'TransferRange',
                'type': 'Short'
            },
            343: {
                'name': 'ClipPath',
                'type': 'Byte'
            },
            344: {
                'name': 'XClipPathUnits',
                'type': 'Long'
            },
            345: {
                'name': 'YClipPathUnits',
                'type': 'Long'
            },
            346: {
                'name': 'Indexed',
                'type': 'Short'
            },
            347: {
                'name': 'JPEGTables',
                'type': 'Undefined'
            },
            351: {
                'name': 'OPIProxy',
                'type': 'Short'
            },
            512: {
                'name': 'JPEGProc',
                'type': 'Long'
            },
            513: {
                'name': 'JPEGInterchangeFormat',
                'type': 'Long'
            },
            514: {
                'name': 'JPEGInterchangeFormatLength',
                'type': 'Long'
            },
            515: {
                'name': 'JPEGRestartInterval',
                'type': 'Short'
            },
            517: {
                'name': 'JPEGLosslessPredictors',
                'type': 'Short'
            },
            518: {
                'name': 'JPEGPointTransforms',
                'type': 'Short'
            },
            519: {
                'name': 'JPEGQTables',
                'type': 'Long'
            },
            520: {
                'name': 'JPEGDCTables',
                'type': 'Long'
            },
            521: {
                'name': 'JPEGACTables',
                'type': 'Long'
            },
            529: {
                'name': 'YCbCrCoefficients',
                'type': 'Rational'
            },
            530: {
                'name': 'YCbCrSubSampling',
                'type': 'Short'
            },
            531: {
                'name': 'YCbCrPositioning',
                'type': 'Short'
            },
            532: {
                'name': 'ReferenceBlackWhite',
                'type': 'Rational'
            },
            700: {
                'name': 'XMLPacket',
                'type': 'Byte'
            },
            18246: {
                'name': 'Rating',
                'type': 'Short'
            },
            18249: {
                'name': 'RatingPercent',
                'type': 'Short'
            },
            32781: {
                'name': 'ImageID',
                'type': 'Ascii'
            },
            33421: {
                'name': 'CFARepeatPatternDim',
                'type': 'Short'
            },
            33422: {
                'name': 'CFAPattern',
                'type': 'Byte'
            },
            33423: {
                'name': 'BatteryLevel',
                'type': 'Rational'
            },
            33432: {
                'name': 'Copyright',
                'type': 'Ascii'
            },
            33434: {
                'name': 'ExposureTime',
                'type': 'Rational'
            },
            34377: {
                'name': 'ImageResources',
                'type': 'Byte'
            },
            34665: {
                'name': 'ExifTag',
                'type': 'Long'
            },
            34675: {
                'name': 'InterColorProfile',
                'type': 'Undefined'
            },
            34853: {
                'name': 'GPSTag',
                'type': 'Long'
            },
            34857: {
                'name': 'Interlace',
                'type': 'Short'
            },
            34858: {
                'name': 'TimeZoneOffset',
                'type': 'Long'
            },
            34859: {
                'name': 'SelfTimerMode',
                'type': 'Short'
            },
            37387: {
                'name': 'FlashEnergy',
                'type': 'Rational'
            },
            37388: {
                'name': 'SpatialFrequencyResponse',
                'type': 'Undefined'
            },
            37389: {
                'name': 'Noise',
                'type': 'Undefined'
            },
            37390: {
                'name': 'FocalPlaneXResolution',
                'type': 'Rational'
            },
            37391: {
                'name': 'FocalPlaneYResolution',
                'type': 'Rational'
            },
            37392: {
                'name': 'FocalPlaneResolutionUnit',
                'type': 'Short'
            },
            37393: {
                'name': 'ImageNumber',
                'type': 'Long'
            },
            37394: {
                'name': 'SecurityClassification',
                'type': 'Ascii'
            },
            37395: {
                'name': 'ImageHistory',
                'type': 'Ascii'
            },
            37397: {
                'name': 'ExposureIndex',
                'type': 'Rational'
            },
            37398: {
                'name': 'TIFFEPStandardID',
                'type': 'Byte'
            },
            37399: {
                'name': 'SensingMethod',
                'type': 'Short'
            },
            40091: {
                'name': 'XPTitle',
                'type': 'Byte'
            },
            40092: {
                'name': 'XPComment',
                'type': 'Byte'
            },
            40093: {
                'name': 'XPAuthor',
                'type': 'Byte'
            },
            40094: {
                'name': 'XPKeywords',
                'type': 'Byte'
            },
            40095: {
                'name': 'XPSubject',
                'type': 'Byte'
            },
            50341: {
                'name': 'PrintImageMatching',
                'type': 'Undefined'
            },
            50706: {
                'name': 'DNGVersion',
                'type': 'Byte'
            },
            50707: {
                'name': 'DNGBackwardVersion',
                'type': 'Byte'
            },
            50708: {
                'name': 'UniqueCameraModel',
                'type': 'Ascii'
            },
            50709: {
                'name': 'LocalizedCameraModel',
                'type': 'Byte'
            },
            50710: {
                'name': 'CFAPlaneColor',
                'type': 'Byte'
            },
            50711: {
                'name': 'CFALayout',
                'type': 'Short'
            },
            50712: {
                'name': 'LinearizationTable',
                'type': 'Short'
            },
            50713: {
                'name': 'BlackLevelRepeatDim',
                'type': 'Short'
            },
            50714: {
                'name': 'BlackLevel',
                'type': 'Rational'
            },
            50715: {
                'name': 'BlackLevelDeltaH',
                'type': 'SRational'
            },
            50716: {
                'name': 'BlackLevelDeltaV',
                'type': 'SRational'
            },
            50717: {
                'name': 'WhiteLevel',
                'type': 'Short'
            },
            50718: {
                'name': 'DefaultScale',
                'type': 'Rational'
            },
            50719: {
                'name': 'DefaultCropOrigin',
                'type': 'Short'
            },
            50720: {
                'name': 'DefaultCropSize',
                'type': 'Short'
            },
            50721: {
                'name': 'ColorMatrix1',
                'type': 'SRational'
            },
            50722: {
                'name': 'ColorMatrix2',
                'type': 'SRational'
            },
            50723: {
                'name': 'CameraCalibration1',
                'type': 'SRational'
            },
            50724: {
                'name': 'CameraCalibration2',
                'type': 'SRational'
            },
            50725: {
                'name': 'ReductionMatrix1',
                'type': 'SRational'
            },
            50726: {
                'name': 'ReductionMatrix2',
                'type': 'SRational'
            },
            50727: {
                'name': 'AnalogBalance',
                'type': 'Rational'
            },
            50728: {
                'name': 'AsShotNeutral',
                'type': 'Short'
            },
            50729: {
                'name': 'AsShotWhiteXY',
                'type': 'Rational'
            },
            50730: {
                'name': 'BaselineExposure',
                'type': 'SRational'
            },
            50731: {
                'name': 'BaselineNoise',
                'type': 'Rational'
            },
            50732: {
                'name': 'BaselineSharpness',
                'type': 'Rational'
            },
            50733: {
                'name': 'BayerGreenSplit',
                'type': 'Long'
            },
            50734: {
                'name': 'LinearResponseLimit',
                'type': 'Rational'
            },
            50735: {
                'name': 'CameraSerialNumber',
                'type': 'Ascii'
            },
            50736: {
                'name': 'LensInfo',
                'type': 'Rational'
            },
            50737: {
                'name': 'ChromaBlurRadius',
                'type': 'Rational'
            },
            50738: {
                'name': 'AntiAliasStrength',
                'type': 'Rational'
            },
            50739: {
                'name': 'ShadowScale',
                'type': 'SRational'
            },
            50740: {
                'name': 'DNGPrivateData',
                'type': 'Byte'
            },
            50741: {
                'name': 'MakerNoteSafety',
                'type': 'Short'
            },
            50778: {
                'name': 'CalibrationIlluminant1',
                'type': 'Short'
            },
            50779: {
                'name': 'CalibrationIlluminant2',
                'type': 'Short'
            },
            50780: {
                'name': 'BestQualityScale',
                'type': 'Rational'
            },
            50781: {
                'name': 'RawDataUniqueID',
                'type': 'Byte'
            },
            50827: {
                'name': 'OriginalRawFileName',
                'type': 'Byte'
            },
            50828: {
                'name': 'OriginalRawFileData',
                'type': 'Undefined'
            },
            50829: {
                'name': 'ActiveArea',
                'type': 'Short'
            },
            50830: {
                'name': 'MaskedAreas',
                'type': 'Short'
            },
            50831: {
                'name': 'AsShotICCProfile',
                'type': 'Undefined'
            },
            50832: {
                'name': 'AsShotPreProfileMatrix',
                'type': 'SRational'
            },
            50833: {
                'name': 'CurrentICCProfile',
                'type': 'Undefined'
            },
            50834: {
                'name': 'CurrentPreProfileMatrix',
                'type': 'SRational'
            },
            50879: {
                'name': 'ColorimetricReference',
                'type': 'Short'
            },
            50931: {
                'name': 'CameraCalibrationSignature',
                'type': 'Byte'
            },
            50932: {
                'name': 'ProfileCalibrationSignature',
                'type': 'Byte'
            },
            50934: {
                'name': 'AsShotProfileName',
                'type': 'Byte'
            },
            50935: {
                'name': 'NoiseReductionApplied',
                'type': 'Rational'
            },
            50936: {
                'name': 'ProfileName',
                'type': 'Byte'
            },
            50937: {
                'name': 'ProfileHueSatMapDims',
                'type': 'Long'
            },
            50938: {
                'name': 'ProfileHueSatMapData1',
                'type': 'Float'
            },
            50939: {
                'name': 'ProfileHueSatMapData2',
                'type': 'Float'
            },
            50940: {
                'name': 'ProfileToneCurve',
                'type': 'Float'
            },
            50941: {
                'name': 'ProfileEmbedPolicy',
                'type': 'Long'
            },
            50942: {
                'name': 'ProfileCopyright',
                'type': 'Byte'
            },
            50964: {
                'name': 'ForwardMatrix1',
                'type': 'SRational'
            },
            50965: {
                'name': 'ForwardMatrix2',
                'type': 'SRational'
            },
            50966: {
                'name': 'PreviewApplicationName',
                'type': 'Byte'
            },
            50967: {
                'name': 'PreviewApplicationVersion',
                'type': 'Byte'
            },
            50968: {
                'name': 'PreviewSettingsName',
                'type': 'Byte'
            },
            50969: {
                'name': 'PreviewSettingsDigest',
                'type': 'Byte'
            },
            50970: {
                'name': 'PreviewColorSpace',
                'type': 'Long'
            },
            50971: {
                'name': 'PreviewDateTime',
                'type': 'Ascii'
            },
            50972: {
                'name': 'RawImageDigest',
                'type': 'Undefined'
            },
            50973: {
                'name': 'OriginalRawFileDigest',
                'type': 'Undefined'
            },
            50974: {
                'name': 'SubTileBlockSize',
                'type': 'Long'
            },
            50975: {
                'name': 'RowInterleaveFactor',
                'type': 'Long'
            },
            50981: {
                'name': 'ProfileLookTableDims',
                'type': 'Long'
            },
            50982: {
                'name': 'ProfileLookTableData',
                'type': 'Float'
            },
            51008: {
                'name': 'OpcodeList1',
                'type': 'Undefined'
            },
            51009: {
                'name': 'OpcodeList2',
                'type': 'Undefined'
            },
            51022: {
                'name': 'OpcodeList3',
                'type': 'Undefined'
            }
        },
        'Exif': {
            33434: {
                'name': 'ExposureTime',
                'type': 'Rational'
            },
            33437: {
                'name': 'FNumber',
                'type': 'Rational'
            },
            34850: {
                'name': 'ExposureProgram',
                'type': 'Short'
            },
            34852: {
                'name': 'SpectralSensitivity',
                'type': 'Ascii'
            },
            34855: {
                'name': 'ISOSpeedRatings',
                'type': 'Short'
            },
            34856: {
                'name': 'OECF',
                'type': 'Undefined'
            },
            34864: {
                'name': 'SensitivityType',
                'type': 'Short'
            },
            34865: {
                'name': 'StandardOutputSensitivity',
                'type': 'Long'
            },
            34866: {
                'name': 'RecommendedExposureIndex',
                'type': 'Long'
            },
            34867: {
                'name': 'ISOSpeed',
                'type': 'Long'
            },
            34868: {
                'name': 'ISOSpeedLatitudeyyy',
                'type': 'Long'
            },
            34869: {
                'name': 'ISOSpeedLatitudezzz',
                'type': 'Long'
            },
            36864: {
                'name': 'ExifVersion',
                'type': 'Undefined'
            },
            36867: {
                'name': 'DateTimeOriginal',
                'type': 'Ascii'
            },
            36868: {
                'name': 'DateTimeDigitized',
                'type': 'Ascii'
            },
            37121: {
                'name': 'ComponentsConfiguration',
                'type': 'Undefined'
            },
            37122: {
                'name': 'CompressedBitsPerPixel',
                'type': 'Rational'
            },
            37377: {
                'name': 'ShutterSpeedValue',
                'type': 'SRational'
            },
            37378: {
                'name': 'ApertureValue',
                'type': 'Rational'
            },
            37379: {
                'name': 'BrightnessValue',
                'type': 'SRational'
            },
            37380: {
                'name': 'ExposureBiasValue',
                'type': 'SRational'
            },
            37381: {
                'name': 'MaxApertureValue',
                'type': 'Rational'
            },
            37382: {
                'name': 'SubjectDistance',
                'type': 'Rational'
            },
            37383: {
                'name': 'MeteringMode',
                'type': 'Short'
            },
            37384: {
                'name': 'LightSource',
                'type': 'Short'
            },
            37385: {
                'name': 'Flash',
                'type': 'Short'
            },
            37386: {
                'name': 'FocalLength',
                'type': 'Rational'
            },
            37396: {
                'name': 'SubjectArea',
                'type': 'Short'
            },
            37500: {
                'name': 'MakerNote',
                'type': 'Undefined'
            },
            37510: {
                'name': 'UserComment',
                'type': 'Ascii'
            },
            37520: {
                'name': 'SubSecTime',
                'type': 'Ascii'
            },
            37521: {
                'name': 'SubSecTimeOriginal',
                'type': 'Ascii'
            },
            37522: {
                'name': 'SubSecTimeDigitized',
                'type': 'Ascii'
            },
            40960: {
                'name': 'FlashpixVersion',
                'type': 'Undefined'
            },
            40961: {
                'name': 'ColorSpace',
                'type': 'Short'
            },
            40962: {
                'name': 'PixelXDimension',
                'type': 'Long'
            },
            40963: {
                'name': 'PixelYDimension',
                'type': 'Long'
            },
            40964: {
                'name': 'RelatedSoundFile',
                'type': 'Ascii'
            },
            40965: {
                'name': 'InteroperabilityTag',
                'type': 'Long'
            },
            41483: {
                'name': 'FlashEnergy',
                'type': 'Rational'
            },
            41484: {
                'name': 'SpatialFrequencyResponse',
                'type': 'Undefined'
            },
            41486: {
                'name': 'FocalPlaneXResolution',
                'type': 'Rational'
            },
            41487: {
                'name': 'FocalPlaneYResolution',
                'type': 'Rational'
            },
            41488: {
                'name': 'FocalPlaneResolutionUnit',
                'type': 'Short'
            },
            41492: {
                'name': 'SubjectLocation',
                'type': 'Short'
            },
            41493: {
                'name': 'ExposureIndex',
                'type': 'Rational'
            },
            41495: {
                'name': 'SensingMethod',
                'type': 'Short'
            },
            41728: {
                'name': 'FileSource',
                'type': 'Undefined'
            },
            41729: {
                'name': 'SceneType',
                'type': 'Undefined'
            },
            41730: {
                'name': 'CFAPattern',
                'type': 'Undefined'
            },
            41985: {
                'name': 'CustomRendered',
                'type': 'Short'
            },
            41986: {
                'name': 'ExposureMode',
                'type': 'Short'
            },
            41987: {
                'name': 'WhiteBalance',
                'type': 'Short'
            },
            41988: {
                'name': 'DigitalZoomRatio',
                'type': 'Rational'
            },
            41989: {
                'name': 'FocalLengthIn35mmFilm',
                'type': 'Short'
            },
            41990: {
                'name': 'SceneCaptureType',
                'type': 'Short'
            },
            41991: {
                'name': 'GainControl',
                'type': 'Short'
            },
            41992: {
                'name': 'Contrast',
                'type': 'Short'
            },
            41993: {
                'name': 'Saturation',
                'type': 'Short'
            },
            41994: {
                'name': 'Sharpness',
                'type': 'Short'
            },
            41995: {
                'name': 'DeviceSettingDescription',
                'type': 'Undefined'
            },
            41996: {
                'name': 'SubjectDistanceRange',
                'type': 'Short'
            },
            42016: {
                'name': 'ImageUniqueID',
                'type': 'Ascii'
            },
            42032: {
                'name': 'CameraOwnerName',
                'type': 'Ascii'
            },
            42033: {
                'name': 'BodySerialNumber',
                'type': 'Ascii'
            },
            42034: {
                'name': 'LensSpecification',
                'type': 'Rational'
            },
            42035: {
                'name': 'LensMake',
                'type': 'Ascii'
            },
            42036: {
                'name': 'LensModel',
                'type': 'Ascii'
            },
            42037: {
                'name': 'LensSerialNumber',
                'type': 'Ascii'
            },
            42240: {
                'name': 'Gamma',
                'type': 'Rational'
            }
        },
        'GPS': {
            0: {
                'name': 'GPSVersionID',
                'type': 'Byte'
            },
            1: {
                'name': 'GPSLatitudeRef',
                'type': 'Ascii'
            },
            2: {
                'name': 'GPSLatitude',
                'type': 'Rational'
            },
            3: {
                'name': 'GPSLongitudeRef',
                'type': 'Ascii'
            },
            4: {
                'name': 'GPSLongitude',
                'type': 'Rational'
            },
            5: {
                'name': 'GPSAltitudeRef',
                'type': 'Byte'
            },
            6: {
                'name': 'GPSAltitude',
                'type': 'Rational'
            },
            7: {
                'name': 'GPSTimeStamp',
                'type': 'Rational'
            },
            8: {
                'name': 'GPSSatellites',
                'type': 'Ascii'
            },
            9: {
                'name': 'GPSStatus',
                'type': 'Ascii'
            },
            10: {
                'name': 'GPSMeasureMode',
                'type': 'Ascii'
            },
            11: {
                'name': 'GPSDOP',
                'type': 'Rational'
            },
            12: {
                'name': 'GPSSpeedRef',
                'type': 'Ascii'
            },
            13: {
                'name': 'GPSSpeed',
                'type': 'Rational'
            },
            14: {
                'name': 'GPSTrackRef',
                'type': 'Ascii'
            },
            15: {
                'name': 'GPSTrack',
                'type': 'Rational'
            },
            16: {
                'name': 'GPSImgDirectionRef',
                'type': 'Ascii'
            },
            17: {
                'name': 'GPSImgDirection',
                'type': 'Rational'
            },
            18: {
                'name': 'GPSMapDatum',
                'type': 'Ascii'
            },
            19: {
                'name': 'GPSDestLatitudeRef',
                'type': 'Ascii'
            },
            20: {
                'name': 'GPSDestLatitude',
                'type': 'Rational'
            },
            21: {
                'name': 'GPSDestLongitudeRef',
                'type': 'Ascii'
            },
            22: {
                'name': 'GPSDestLongitude',
                'type': 'Rational'
            },
            23: {
                'name': 'GPSDestBearingRef',
                'type': 'Ascii'
            },
            24: {
                'name': 'GPSDestBearing',
                'type': 'Rational'
            },
            25: {
                'name': 'GPSDestDistanceRef',
                'type': 'Ascii'
            },
            26: {
                'name': 'GPSDestDistance',
                'type': 'Rational'
            },
            27: {
                'name': 'GPSProcessingMethod',
                'type': 'Undefined'
            },
            28: {
                'name': 'GPSAreaInformation',
                'type': 'Undefined'
            },
            29: {
                'name': 'GPSDateStamp',
                'type': 'Ascii'
            },
            30: {
                'name': 'GPSDifferential',
                'type': 'Short'
            },
            31: {
                'name': 'GPSHPositioningError',
                'type': 'Rational'
            }
        },
        'Interop': {
            1: {
                'name': 'InteroperabilityIndex',
                'type': 'Ascii'
            }
        },
    };
    TAGS["0th"] = TAGS["Image"];
    TAGS["1st"] = TAGS["Image"];
    that.TAGS = TAGS;

    
    that.ImageIFD = {
        ProcessingSoftware:11,
        NewSubfileType:254,
        SubfileType:255,
        ImageWidth:256,
        ImageLength:257,
        BitsPerSample:258,
        Compression:259,
        PhotometricInterpretation:262,
        Threshholding:263,
        CellWidth:264,
        CellLength:265,
        FillOrder:266,
        DocumentName:269,
        ImageDescription:270,
        Make:271,
        Model:272,
        StripOffsets:273,
        Orientation:274,
        SamplesPerPixel:277,
        RowsPerStrip:278,
        StripByteCounts:279,
        XResolution:282,
        YResolution:283,
        PlanarConfiguration:284,
        GrayResponseUnit:290,
        GrayResponseCurve:291,
        T4Options:292,
        T6Options:293,
        ResolutionUnit:296,
        TransferFunction:301,
        Software:305,
        DateTime:306,
        Artist:315,
        HostComputer:316,
        Predictor:317,
        WhitePoint:318,
        PrimaryChromaticities:319,
        ColorMap:320,
        HalftoneHints:321,
        TileWidth:322,
        TileLength:323,
        TileOffsets:324,
        TileByteCounts:325,
        SubIFDs:330,
        InkSet:332,
        InkNames:333,
        NumberOfInks:334,
        DotRange:336,
        TargetPrinter:337,
        ExtraSamples:338,
        SampleFormat:339,
        SMinSampleValue:340,
        SMaxSampleValue:341,
        TransferRange:342,
        ClipPath:343,
        XClipPathUnits:344,
        YClipPathUnits:345,
        Indexed:346,
        JPEGTables:347,
        OPIProxy:351,
        JPEGProc:512,
        JPEGInterchangeFormat:513,
        JPEGInterchangeFormatLength:514,
        JPEGRestartInterval:515,
        JPEGLosslessPredictors:517,
        JPEGPointTransforms:518,
        JPEGQTables:519,
        JPEGDCTables:520,
        JPEGACTables:521,
        YCbCrCoefficients:529,
        YCbCrSubSampling:530,
        YCbCrPositioning:531,
        ReferenceBlackWhite:532,
        XMLPacket:700,
        Rating:18246,
        RatingPercent:18249,
        ImageID:32781,
        CFARepeatPatternDim:33421,
        CFAPattern:33422,
        BatteryLevel:33423,
        Copyright:33432,
        ExposureTime:33434,
        ImageResources:34377,
        ExifTag:34665,
        InterColorProfile:34675,
        GPSTag:34853,
        Interlace:34857,
        TimeZoneOffset:34858,
        SelfTimerMode:34859,
        FlashEnergy:37387,
        SpatialFrequencyResponse:37388,
        Noise:37389,
        FocalPlaneXResolution:37390,
        FocalPlaneYResolution:37391,
        FocalPlaneResolutionUnit:37392,
        ImageNumber:37393,
        SecurityClassification:37394,
        ImageHistory:37395,
        ExposureIndex:37397,
        TIFFEPStandardID:37398,
        SensingMethod:37399,
        XPTitle:40091,
        XPComment:40092,
        XPAuthor:40093,
        XPKeywords:40094,
        XPSubject:40095,
        PrintImageMatching:50341,
        DNGVersion:50706,
        DNGBackwardVersion:50707,
        UniqueCameraModel:50708,
        LocalizedCameraModel:50709,
        CFAPlaneColor:50710,
        CFALayout:50711,
        LinearizationTable:50712,
        BlackLevelRepeatDim:50713,
        BlackLevel:50714,
        BlackLevelDeltaH:50715,
        BlackLevelDeltaV:50716,
        WhiteLevel:50717,
        DefaultScale:50718,
        DefaultCropOrigin:50719,
        DefaultCropSize:50720,
        ColorMatrix1:50721,
        ColorMatrix2:50722,
        CameraCalibration1:50723,
        CameraCalibration2:50724,
        ReductionMatrix1:50725,
        ReductionMatrix2:50726,
        AnalogBalance:50727,
        AsShotNeutral:50728,
        AsShotWhiteXY:50729,
        BaselineExposure:50730,
        BaselineNoise:50731,
        BaselineSharpness:50732,
        BayerGreenSplit:50733,
        LinearResponseLimit:50734,
        CameraSerialNumber:50735,
        LensInfo:50736,
        ChromaBlurRadius:50737,
        AntiAliasStrength:50738,
        ShadowScale:50739,
        DNGPrivateData:50740,
        MakerNoteSafety:50741,
        CalibrationIlluminant1:50778,
        CalibrationIlluminant2:50779,
        BestQualityScale:50780,
        RawDataUniqueID:50781,
        OriginalRawFileName:50827,
        OriginalRawFileData:50828,
        ActiveArea:50829,
        MaskedAreas:50830,
        AsShotICCProfile:50831,
        AsShotPreProfileMatrix:50832,
        CurrentICCProfile:50833,
        CurrentPreProfileMatrix:50834,
        ColorimetricReference:50879,
        CameraCalibrationSignature:50931,
        ProfileCalibrationSignature:50932,
        AsShotProfileName:50934,
        NoiseReductionApplied:50935,
        ProfileName:50936,
        ProfileHueSatMapDims:50937,
        ProfileHueSatMapData1:50938,
        ProfileHueSatMapData2:50939,
        ProfileToneCurve:50940,
        ProfileEmbedPolicy:50941,
        ProfileCopyright:50942,
        ForwardMatrix1:50964,
        ForwardMatrix2:50965,
        PreviewApplicationName:50966,
        PreviewApplicationVersion:50967,
        PreviewSettingsName:50968,
        PreviewSettingsDigest:50969,
        PreviewColorSpace:50970,
        PreviewDateTime:50971,
        RawImageDigest:50972,
        OriginalRawFileDigest:50973,
        SubTileBlockSize:50974,
        RowInterleaveFactor:50975,
        ProfileLookTableDims:50981,
        ProfileLookTableData:50982,
        OpcodeList1:51008,
        OpcodeList2:51009,
        OpcodeList3:51022,
        NoiseProfile:51041,
    };

    
    that.ExifIFD = {
        ExposureTime:33434,
        FNumber:33437,
        ExposureProgram:34850,
        SpectralSensitivity:34852,
        ISOSpeedRatings:34855,
        OECF:34856,
        SensitivityType:34864,
        StandardOutputSensitivity:34865,
        RecommendedExposureIndex:34866,
        ISOSpeed:34867,
        ISOSpeedLatitudeyyy:34868,
        ISOSpeedLatitudezzz:34869,
        ExifVersion:36864,
        DateTimeOriginal:36867,
        DateTimeDigitized:36868,
        ComponentsConfiguration:37121,
        CompressedBitsPerPixel:37122,
        ShutterSpeedValue:37377,
        ApertureValue:37378,
        BrightnessValue:37379,
        ExposureBiasValue:37380,
        MaxApertureValue:37381,
        SubjectDistance:37382,
        MeteringMode:37383,
        LightSource:37384,
        Flash:37385,
        FocalLength:37386,
        SubjectArea:37396,
        MakerNote:37500,
        UserComment:37510,
        SubSecTime:37520,
        SubSecTimeOriginal:37521,
        SubSecTimeDigitized:37522,
        FlashpixVersion:40960,
        ColorSpace:40961,
        PixelXDimension:40962,
        PixelYDimension:40963,
        RelatedSoundFile:40964,
        InteroperabilityTag:40965,
        FlashEnergy:41483,
        SpatialFrequencyResponse:41484,
        FocalPlaneXResolution:41486,
        FocalPlaneYResolution:41487,
        FocalPlaneResolutionUnit:41488,
        SubjectLocation:41492,
        ExposureIndex:41493,
        SensingMethod:41495,
        FileSource:41728,
        SceneType:41729,
        CFAPattern:41730,
        CustomRendered:41985,
        ExposureMode:41986,
        WhiteBalance:41987,
        DigitalZoomRatio:41988,
        FocalLengthIn35mmFilm:41989,
        SceneCaptureType:41990,
        GainControl:41991,
        Contrast:41992,
        Saturation:41993,
        Sharpness:41994,
        DeviceSettingDescription:41995,
        SubjectDistanceRange:41996,
        ImageUniqueID:42016,
        CameraOwnerName:42032,
        BodySerialNumber:42033,
        LensSpecification:42034,
        LensMake:42035,
        LensModel:42036,
        LensSerialNumber:42037,
        Gamma:42240,
    };


    that.GPSIFD = {
        GPSVersionID:0,
        GPSLatitudeRef:1,
        GPSLatitude:2,
        GPSLongitudeRef:3,
        GPSLongitude:4,
        GPSAltitudeRef:5,
        GPSAltitude:6,
        GPSTimeStamp:7,
        GPSSatellites:8,
        GPSStatus:9,
        GPSMeasureMode:10,
        GPSDOP:11,
        GPSSpeedRef:12,
        GPSSpeed:13,
        GPSTrackRef:14,
        GPSTrack:15,
        GPSImgDirectionRef:16,
        GPSImgDirection:17,
        GPSMapDatum:18,
        GPSDestLatitudeRef:19,
        GPSDestLatitude:20,
        GPSDestLongitudeRef:21,
        GPSDestLongitude:22,
        GPSDestBearingRef:23,
        GPSDestBearing:24,
        GPSDestDistanceRef:25,
        GPSDestDistance:26,
        GPSProcessingMethod:27,
        GPSAreaInformation:28,
        GPSDateStamp:29,
        GPSDifferential:30,
        GPSHPositioningError:31,
    };


    that.InteropIFD = {
        InteroperabilityIndex:1,
    };

    that.GPSHelper = {
        degToDmsRational:function (degFloat) {
            var degAbs = Math.abs(degFloat);
            var minFloat = degAbs % 1 * 60;
            var secFloat = minFloat % 1 * 60;
            var deg = Math.floor(degAbs);
            var min = Math.floor(minFloat);
            var sec = Math.round(secFloat * 100);

            return [[deg, 1], [min, 1], [sec, 100]];
        },

        dmsRationalToDeg:function (dmsArray, ref) {
            var sign = (ref === 'S' || ref === 'W') ? -1.0 : 1.0;
            var deg = dmsArray[0][0] / dmsArray[0][1] +
                      dmsArray[1][0] / dmsArray[1][1] / 60.0 +
                      dmsArray[2][0] / dmsArray[2][1] / 3600.0;

            return deg * sign;
        }
    };
    
    
    if (true) {
        if (typeof module !== 'undefined' && module.exports) {
            exports = module.exports = that;
        }
        exports.piexif = that;
    } else {
        window.piexif = that;
    }

})();


/***/ }),

/***/ 1551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getExist;
/* harmony export (immutable) */ __webpack_exports__["a"] = arraySwap;
/* harmony export (immutable) */ __webpack_exports__["b"] = copyJson;
/* harmony export (immutable) */ __webpack_exports__["c"] = dateNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/**
 * 获得两个变量中存在的变量
 * @param var1
 * @param var2
 * @returns {*}
 */
function getExist(var1, var2) {
  if (var1 === undefined) {
    return var2;
  }
  return var1;
}

function arraySwap(array, oldIndex, newIndex) {
  array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
  return array;
}

function copyJson(data) {
  return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
}

function dateNumber() {
  return new Date().toJSON()
  // 2018-07-31T07:48:48.653Z
  .substr(0, 19)
  // 2018-07-31T07:48:48
  .replace(/[^0-9]/ig, '');
  // 20180731074848
}

/***/ }),

/***/ 1568:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module, global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _gsScope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TweenLite; });
/* unused harmony export globals */
/* unused harmony export default */
/* unused harmony export SimpleTimeline */
/* unused harmony export Animation */
/* unused harmony export Ease */
/* unused harmony export Linear */
/* unused harmony export Power0 */
/* unused harmony export Power1 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Power2; });
/* unused harmony export Power3 */
/* unused harmony export Power4 */
/* unused harmony export TweenPlugin */
/* unused harmony export EventDispatcher */
/*!
 * VERSION: 2.1.3
 * DATE: 2019-05-17
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 *
 * @author: Jack Doyle, jack@greensock.com
 */
/* eslint-disable */

/* ES6 changes:
	- declare and export _gsScope at top.
	- set var TweenLite = the result of the main function
	- export default TweenLite at the bottom
	- return TweenLite at the bottom of the main function
	- pass in _gsScope as the first parameter of the main function (which is actually at the bottom)
	- remove the "export to multiple environments" in Definition().
 */
var _gsScope = (typeof(window) !== "undefined") ? window : (typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || {};

var TweenLite = (function(window) {

		"use strict";
		var _exports = {},
			_doc = window.document,
			_globals = window.GreenSockGlobals = window.GreenSockGlobals || window;
		if (_globals.TweenLite) {
			return _globals.TweenLite; //in case the core set of classes is already loaded, don't instantiate twice.
		}
		var _namespace = function(ns) {
				var a = ns.split("."),
					p = _globals, i;
				for (i = 0; i < a.length; i++) {
					p[a[i]] = p = p[a[i]] || {};
				}
				return p;
			},
			gs = _namespace("com.greensock"),
			_tinyNum = 0.00000001,
			_slice = function(a) { //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
				var b = [],
					l = a.length,
					i;
				for (i = 0; i !== l; b.push(a[i++])) {}
				return b;
			},
			_emptyFunc = function() {},
			_isArray = (function() { //works around issues in iframe environments where the Array global isn't shared, thus if the object originates in a different window/iframe, "(obj instanceof Array)" will evaluate false. We added some speed optimizations to avoid Object.prototype.toString.call() unless it's absolutely necessary because it's VERY slow (like 20x slower)
				var toString = Object.prototype.toString,
					array = toString.call([]);
				return function(obj) {
					return obj != null && (obj instanceof Array || (typeof(obj) === "object" && !!obj.push && toString.call(obj) === array));
				};
			}()),
			a, i, p, _ticker, _tickerActive,
			_defLookup = {},

			/**
			 * @constructor
			 * Defines a GreenSock class, optionally with an array of dependencies that must be instantiated first and passed into the definition.
			 * This allows users to load GreenSock JS files in any order even if they have interdependencies (like CSSPlugin extends TweenPlugin which is
			 * inside TweenLite.js, but if CSSPlugin is loaded first, it should wait to run its code until TweenLite.js loads and instantiates TweenPlugin
			 * and then pass TweenPlugin to CSSPlugin's definition). This is all done automatically and internally.
			 *
			 * Every definition will be added to a "com.greensock" global object (typically window, but if a window.GreenSockGlobals object is found,
			 * it will go there as of v1.7). For example, TweenLite will be found at window.com.greensock.TweenLite and since it's a global class that should be available anywhere,
			 * it is ALSO referenced at window.TweenLite. However some classes aren't considered global, like the base com.greensock.core.Animation class, so
			 * those will only be at the package like window.com.greensock.core.Animation. Again, if you define a GreenSockGlobals object on the window, everything
			 * gets tucked neatly inside there instead of on the window directly. This allows you to do advanced things like load multiple versions of GreenSock
			 * files and put them into distinct objects (imagine a banner ad uses a newer version but the main site uses an older one). In that case, you could
			 * sandbox the banner one like:
			 *
			 * <script>
			 *     var gs = window.GreenSockGlobals = {}; //the newer version we're about to load could now be referenced in a "gs" object, like gs.TweenLite.to(...). Use whatever alias you want as long as it's unique, "gs" or "banner" or whatever.
			 * </script>
			 * <script src="js/greensock/v1.7/TweenMax.js"></script>
			 * <script>
			 *     window.GreenSockGlobals = window._gsQueue = window._gsDefine = null; //reset it back to null (along with the special _gsQueue variable) so that the next load of TweenMax affects the window and we can reference things directly like TweenLite.to(...)
			 * </script>
			 * <script src="js/greensock/v1.6/TweenMax.js"></script>
			 * <script>
			 *     gs.TweenLite.to(...); //would use v1.7
			 *     TweenLite.to(...); //would use v1.6
			 * </script>
			 *
			 * @param {!string} ns The namespace of the class definition, leaving off "com.greensock." as that's assumed. For example, "TweenLite" or "plugins.CSSPlugin" or "easing.Back".
			 * @param {!Array.<string>} dependencies An array of dependencies (described as their namespaces minus "com.greensock." prefix). For example ["TweenLite","plugins.TweenPlugin","core.Animation"]
			 * @param {!function():Object} func The function that should be called and passed the resolved dependencies which will return the actual class for this definition.
			 * @param {boolean=} global If true, the class will be added to the global scope (typically window unless you define a window.GreenSockGlobals object)
			 */
			Definition = function(ns, dependencies, func, global) {
				this.sc = (_defLookup[ns]) ? _defLookup[ns].sc : []; //subclasses
				_defLookup[ns] = this;
				this.gsClass = null;
				this.func = func;
				var _classes = [];
				this.check = function(init) {
					var i = dependencies.length,
						missing = i,
						cur, a, n, cl;
					while (--i > -1) {
						if ((cur = _defLookup[dependencies[i]] || new Definition(dependencies[i], [])).gsClass) {
							_classes[i] = cur.gsClass;
							missing--;
						} else if (init) {
							cur.sc.push(this);
						}
					}
					if (missing === 0 && func) {
						a = ("com.greensock." + ns).split(".");
						n = a.pop();
						cl = _namespace(a.join("."))[n] = this.gsClass = func.apply(func, _classes);

						//exports to multiple environments
						if (global) {
							_globals[n] = _exports[n] = cl; //provides a way to avoid global namespace pollution. By default, the main classes like TweenLite, Power1, Strong, etc. are added to window unless a GreenSockGlobals is defined. So if you want to have things added to a custom object instead, just do something like window.GreenSockGlobals = {} before loading any GreenSock files. You can even set up an alias like window.GreenSockGlobals = windows.gs = {} so that you can access everything like gs.TweenLite. Also remember that ALL classes are added to the window.com.greensock object (in their respective packages, like com.greensock.easing.Power1, com.greensock.TweenLite, etc.)
							/*
							if (typeof(module) !== "undefined" && module.exports) { //node
								if (ns === moduleName) {
									module.exports = _exports[moduleName] = cl;
									for (i in _exports) {
										cl[i] = _exports[i];
									}
								} else if (_exports[moduleName]) {
									_exports[moduleName][n] = cl;
								}
							} else if (typeof(define) === "function" && define.amd){ //AMD
								define((window.GreenSockAMDPath ? window.GreenSockAMDPath + "/" : "") + ns.split(".").pop(), [], function() { return cl; });
							}
							*/
						}
						for (i = 0; i < this.sc.length; i++) {
							this.sc[i].check();
						}
					}
				};
				this.check(true);
			},

			//used to create Definition instances (which basically registers a class that has dependencies).
			_gsDefine = window._gsDefine = function(ns, dependencies, func, global) {
				return new Definition(ns, dependencies, func, global);
			},

			//a quick way to create a class that doesn't have any dependencies. Returns the class, but first registers it in the GreenSock namespace so that other classes can grab it (other classes might be dependent on the class).
			_class = gs._class = function(ns, func, global) {
				func = func || function() {};
				_gsDefine(ns, [], function(){ return func; }, global);
				return func;
			};

		_gsDefine.globals = _globals;



/*
 * ----------------------------------------------------------------
 * Ease
 * ----------------------------------------------------------------
 */
		var _baseParams = [0, 0, 1, 1],
			Ease = _class("easing.Ease", function(func, extraParams, type, power) {
				this._func = func;
				this._type = type || 0;
				this._power = power || 0;
				this._params = extraParams ? _baseParams.concat(extraParams) : _baseParams;
			}, true),
			_easeMap = Ease.map = {},
			_easeReg = Ease.register = function(ease, names, types, create) {
				var na = names.split(","),
					i = na.length,
					ta = (types || "easeIn,easeOut,easeInOut").split(","),
					e, name, j, type;
				while (--i > -1) {
					name = na[i];
					e = create ? _class("easing."+name, null, true) : gs.easing[name] || {};
					j = ta.length;
					while (--j > -1) {
						type = ta[j];
						_easeMap[name + "." + type] = _easeMap[type + name] = e[type] = ease.getRatio ? ease : ease[type] || new ease();
					}
				}
			};

		p = Ease.prototype;
		p._calcEnd = false;
		p.getRatio = function(p) {
			if (this._func) {
				this._params[0] = p;
				return this._func.apply(null, this._params);
			}
			var t = this._type,
				pw = this._power,
				r = (t === 1) ? 1 - p : (t === 2) ? p : (p < 0.5) ? p * 2 : (1 - p) * 2;
			if (pw === 1) {
				r *= r;
			} else if (pw === 2) {
				r *= r * r;
			} else if (pw === 3) {
				r *= r * r * r;
			} else if (pw === 4) {
				r *= r * r * r * r;
			}
			return (t === 1) ? 1 - r : (t === 2) ? r : (p < 0.5) ? r / 2 : 1 - (r / 2);
		};

		//create all the standard eases like Linear, Quad, Cubic, Quart, Quint, Strong, Power0, Power1, Power2, Power3, and Power4 (each with easeIn, easeOut, and easeInOut)
		a = ["Linear","Quad","Cubic","Quart","Quint,Strong"];
		i = a.length;
		while (--i > -1) {
			p = a[i]+",Power"+i;
			_easeReg(new Ease(null,null,1,i), p, "easeOut", true);
			_easeReg(new Ease(null,null,2,i), p, "easeIn" + ((i === 0) ? ",easeNone" : ""));
			_easeReg(new Ease(null,null,3,i), p, "easeInOut");
		}
		_easeMap.linear = gs.easing.Linear.easeIn;
		_easeMap.swing = gs.easing.Quad.easeInOut; //for jQuery folks


/*
 * ----------------------------------------------------------------
 * EventDispatcher
 * ----------------------------------------------------------------
 */
		var EventDispatcher = _class("events.EventDispatcher", function(target) {
			this._listeners = {};
			this._eventTarget = target || this;
		});
		p = EventDispatcher.prototype;

		p.addEventListener = function(type, callback, scope, useParam, priority) {
			priority = priority || 0;
			var list = this._listeners[type],
				index = 0,
				listener, i;
			if (this === _ticker && !_tickerActive) {
				_ticker.wake();
			}
			if (list == null) {
				this._listeners[type] = list = [];
			}
			i = list.length;
			while (--i > -1) {
				listener = list[i];
				if (listener.c === callback && listener.s === scope) {
					list.splice(i, 1);
				} else if (index === 0 && listener.pr < priority) {
					index = i + 1;
				}
			}
			list.splice(index, 0, {c:callback, s:scope, up:useParam, pr:priority});
		};

		p.removeEventListener = function(type, callback) {
			var list = this._listeners[type], i;
			if (list) {
				i = list.length;
				while (--i > -1) {
					if (list[i].c === callback) {
						list.splice(i, 1);
						return;
					}
				}
			}
		};

		p.dispatchEvent = function(type) {
			var list = this._listeners[type],
				i, t, listener;
			if (list) {
				i = list.length;
				if (i > 1) {
					list = list.slice(0); //in case addEventListener() is called from within a listener/callback (otherwise the index could change, resulting in a skip)
				}
				t = this._eventTarget;
				while (--i > -1) {
					listener = list[i];
					if (listener) {
						if (listener.up) {
							listener.c.call(listener.s || t, {type:type, target:t});
						} else {
							listener.c.call(listener.s || t);
						}
					}
				}
			}
		};


/*
 * ----------------------------------------------------------------
 * Ticker
 * ----------------------------------------------------------------
 */
 		var _reqAnimFrame = window.requestAnimationFrame,
			_cancelAnimFrame = window.cancelAnimationFrame,
			_getTime = Date.now || function() {return new Date().getTime();},
			_lastUpdate = _getTime();

		//now try to determine the requestAnimationFrame and cancelAnimationFrame functions and if none are found, we'll use a setTimeout()/clearTimeout() polyfill.
		a = ["ms","moz","webkit","o"];
		i = a.length;
		while (--i > -1 && !_reqAnimFrame) {
			_reqAnimFrame = window[a[i] + "RequestAnimationFrame"];
			_cancelAnimFrame = window[a[i] + "CancelAnimationFrame"] || window[a[i] + "CancelRequestAnimationFrame"];
		}

		_class("Ticker", function(fps, useRAF) {
			var _self = this,
				_startTime = _getTime(),
				_useRAF = (useRAF !== false && _reqAnimFrame) ? "auto" : false,
				_lagThreshold = 500,
				_adjustedLag = 33,
				_tickWord = "tick", //helps reduce gc burden
				_fps, _req, _id, _gap, _nextTime,
				_tick = function(manual) {
					var elapsed = _getTime() - _lastUpdate,
						overlap, dispatch;
					if (elapsed > _lagThreshold) {
						_startTime += elapsed - _adjustedLag;
					}
					_lastUpdate += elapsed;
					_self.time = (_lastUpdate - _startTime) / 1000;
					overlap = _self.time - _nextTime;
					if (!_fps || overlap > 0 || manual === true) {
						_self.frame++;
						_nextTime += overlap + (overlap >= _gap ? 0.004 : _gap - overlap);
						dispatch = true;
					}
					if (manual !== true) { //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
						_id = _req(_tick);
					}
					if (dispatch) {
						_self.dispatchEvent(_tickWord);
					}
				};

			EventDispatcher.call(_self);
			_self.time = _self.frame = 0;
			_self.tick = function() {
				_tick(true);
			};

			_self.lagSmoothing = function(threshold, adjustedLag) {
				if (!arguments.length) { //if lagSmoothing() is called with no arguments, treat it like a getter that returns a boolean indicating if it's enabled or not. This is purposely undocumented and is for internal use.
					return (_lagThreshold < 1 / _tinyNum);
				}
				_lagThreshold = threshold || (1 / _tinyNum); //zero should be interpreted as basically unlimited
				_adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
			};

			_self.sleep = function() {
				if (_id == null) {
					return;
				}
				if (!_useRAF || !_cancelAnimFrame) {
					clearTimeout(_id);
				} else {
					_cancelAnimFrame(_id);
				}
				_req = _emptyFunc;
				_id = null;
				if (_self === _ticker) {
					_tickerActive = false;
				}
			};

			_self.wake = function(seamless) {
				if (_id !== null) {
					_self.sleep();
				} else if (seamless) {
					_startTime += -_lastUpdate + (_lastUpdate = _getTime());
				} else if (_self.frame > 10) { //don't trigger lagSmoothing if we're just waking up, and make sure that at least 10 frames have elapsed because of the iOS bug that we work around below with the 1.5-second setTimout().
					_lastUpdate = _getTime() - _lagThreshold + 5;
				}
				_req = (_fps === 0) ? _emptyFunc : (!_useRAF || !_reqAnimFrame) ? function(f) { return setTimeout(f, ((_nextTime - _self.time) * 1000 + 1) | 0); } : _reqAnimFrame;
				if (_self === _ticker) {
					_tickerActive = true;
				}
				_tick(2);
			};

			_self.fps = function(value) {
				if (!arguments.length) {
					return _fps;
				}
				_fps = value;
				_gap = 1 / (_fps || 60);
				_nextTime = this.time + _gap;
				_self.wake();
			};

			_self.useRAF = function(value) {
				if (!arguments.length) {
					return _useRAF;
				}
				_self.sleep();
				_useRAF = value;
				_self.fps(_fps);
			};
			_self.fps(fps);

			//a bug in iOS 6 Safari occasionally prevents the requestAnimationFrame from working initially, so we use a 1.5-second timeout that automatically falls back to setTimeout() if it senses this condition.
			setTimeout(function() {
				if (_useRAF === "auto" && _self.frame < 5 && (_doc || {}).visibilityState !== "hidden") {
					_self.useRAF(false);
				}
			}, 1500);
		});

		p = gs.Ticker.prototype = new gs.events.EventDispatcher();
		p.constructor = gs.Ticker;


/*
 * ----------------------------------------------------------------
 * Animation
 * ----------------------------------------------------------------
 */
		var Animation = _class("core.Animation", function(duration, vars) {
				this.vars = vars = vars || {};
				this._duration = this._totalDuration = duration || 0;
				this._delay = Number(vars.delay) || 0;
				this._timeScale = 1;
				this._active = !!vars.immediateRender;
				this.data = vars.data;
				this._reversed = !!vars.reversed;

				if (!_rootTimeline) {
					return;
				}
				if (!_tickerActive) { //some browsers (like iOS 6 Safari) shut down JavaScript execution when the tab is disabled and they [occasionally] neglect to start up requestAnimationFrame again when returning - this code ensures that the engine starts up again properly.
					_ticker.wake();
				}

				var tl = this.vars.useFrames ? _rootFramesTimeline : _rootTimeline;
				tl.add(this, tl._time);

				if (this.vars.paused) {
					this.paused(true);
				}
			});

		_ticker = Animation.ticker = new gs.Ticker();
		p = Animation.prototype;
		p._dirty = p._gc = p._initted = p._paused = false;
		p._totalTime = p._time = 0;
		p._rawPrevTime = -1;
		p._next = p._last = p._onUpdate = p._timeline = p.timeline = null;
		p._paused = false;


		//some browsers (like iOS) occasionally drop the requestAnimationFrame event when the user switches to a different tab and then comes back again, so we use a 2-second setTimeout() to sense if/when that condition occurs and then wake() the ticker.
		var _checkTimeout = function() {
				if (_tickerActive && _getTime() - _lastUpdate > 2000 && ((_doc || {}).visibilityState !== "hidden" || !_ticker.lagSmoothing())) { //note: if the tab is hidden, we should still wake if lagSmoothing has been disabled.
					_ticker.wake();
				}
				var t = setTimeout(_checkTimeout, 2000);
				if (t.unref) {
					// allows a node process to exit even if the timeout’s callback hasn't been invoked. Without it, the node process could hang as this function is called every two seconds.
					t.unref();
				}
			};
		_checkTimeout();


		p.play = function(from, suppressEvents) {
			if (from != null) {
				this.seek(from, suppressEvents);
			}
			return this.reversed(false).paused(false);
		};

		p.pause = function(atTime, suppressEvents) {
			if (atTime != null) {
				this.seek(atTime, suppressEvents);
			}
			return this.paused(true);
		};

		p.resume = function(from, suppressEvents) {
			if (from != null) {
				this.seek(from, suppressEvents);
			}
			return this.paused(false);
		};

		p.seek = function(time, suppressEvents) {
			return this.totalTime(Number(time), suppressEvents !== false);
		};

		p.restart = function(includeDelay, suppressEvents) {
			return this.reversed(false).paused(false).totalTime(includeDelay ? -this._delay : 0, (suppressEvents !== false), true);
		};

		p.reverse = function(from, suppressEvents) {
			if (from != null) {
				this.seek((from || this.totalDuration()), suppressEvents);
			}
			return this.reversed(true).paused(false);
		};

		p.render = function(time, suppressEvents, force) {
			//stub - we override this method in subclasses.
		};

		p.invalidate = function() {
			this._time = this._totalTime = 0;
			this._initted = this._gc = false;
			this._rawPrevTime = -1;
			if (this._gc || !this.timeline) {
				this._enabled(true);
			}
			return this;
		};

		p.isActive = function() {
			var tl = this._timeline, //the 2 root timelines won't have a _timeline; they're always active.
				startTime = this._startTime,
				rawTime;
			return (!tl || (!this._gc && !this._paused && tl.isActive() && (rawTime = tl.rawTime(true)) >= startTime && rawTime < startTime + this.totalDuration() / this._timeScale - _tinyNum));
		};

		p._enabled = function (enabled, ignoreTimeline) {
			if (!_tickerActive) {
				_ticker.wake();
			}
			this._gc = !enabled;
			this._active = this.isActive();
			if (ignoreTimeline !== true) {
				if (enabled && !this.timeline) {
					this._timeline.add(this, this._startTime - this._delay);
				} else if (!enabled && this.timeline) {
					this._timeline._remove(this, true);
				}
			}
			return false;
		};


		p._kill = function(vars, target) {
			return this._enabled(false, false);
		};

		p.kill = function(vars, target) {
			this._kill(vars, target);
			return this;
		};

		p._uncache = function(includeSelf) {
			var tween = includeSelf ? this : this.timeline;
			while (tween) {
				tween._dirty = true;
				tween = tween.timeline;
			}
			return this;
		};

		p._swapSelfInParams = function(params) {
			var i = params.length,
				copy = params.concat();
			while (--i > -1) {
				if (params[i] === "{self}") {
					copy[i] = this;
				}
			}
			return copy;
		};

		p._callback = function(type) {
			var v = this.vars,
				callback = v[type],
				params = v[type + "Params"],
				scope = v[type + "Scope"] || v.callbackScope || this,
				l = params ? params.length : 0;
			switch (l) { //speed optimization; call() is faster than apply() so use it when there are only a few parameters (which is by far most common). Previously we simply did var v = this.vars; v[type].apply(v[type + "Scope"] || v.callbackScope || this, v[type + "Params"] || _blankArray);
				case 0: callback.call(scope); break;
				case 1: callback.call(scope, params[0]); break;
				case 2: callback.call(scope, params[0], params[1]); break;
				default: callback.apply(scope, params);
			}
		};

//----Animation getters/setters --------------------------------------------------------

		p.eventCallback = function(type, callback, params, scope) {
			if ((type || "").substr(0,2) === "on") {
				var v = this.vars;
				if (arguments.length === 1) {
					return v[type];
				}
				if (callback == null) {
					delete v[type];
				} else {
					v[type] = callback;
					v[type + "Params"] = (_isArray(params) && params.join("").indexOf("{self}") !== -1) ? this._swapSelfInParams(params) : params;
					v[type + "Scope"] = scope;
				}
				if (type === "onUpdate") {
					this._onUpdate = callback;
				}
			}
			return this;
		};

		p.delay = function(value) {
			if (!arguments.length) {
				return this._delay;
			}
			if (this._timeline.smoothChildTiming) {
				this.startTime( this._startTime + value - this._delay );
			}
			this._delay = value;
			return this;
		};

		p.duration = function(value) {
			if (!arguments.length) {
				this._dirty = false;
				return this._duration;
			}
			this._duration = this._totalDuration = value;
			this._uncache(true); //true in case it's a TweenMax or TimelineMax that has a repeat - we'll need to refresh the totalDuration.
			if (this._timeline.smoothChildTiming) if (this._time > 0) if (this._time < this._duration) if (value !== 0) {
				this.totalTime(this._totalTime * (value / this._duration), true);
			}
			return this;
		};

		p.totalDuration = function(value) {
			this._dirty = false;
			return (!arguments.length) ? this._totalDuration : this.duration(value);
		};

		p.time = function(value, suppressEvents) {
			if (!arguments.length) {
				return this._time;
			}
			if (this._dirty) {
				this.totalDuration();
			}
			return this.totalTime((value > this._duration) ? this._duration : value, suppressEvents);
		};

		p.totalTime = function(time, suppressEvents, uncapped) {
			if (!_tickerActive) {
				_ticker.wake();
			}
			if (!arguments.length) {
				return this._totalTime;
			}
			if (this._timeline) {
				if (time < 0 && !uncapped) {
					time += this.totalDuration();
				}
				if (this._timeline.smoothChildTiming) {
					if (this._dirty) {
						this.totalDuration();
					}
					var totalDuration = this._totalDuration,
						tl = this._timeline;
					if (time > totalDuration && !uncapped) {
						time = totalDuration;
					}
					this._startTime = (this._paused ? this._pauseTime : tl._time) - ((!this._reversed ? time : totalDuration - time) / this._timeScale);
					if (!tl._dirty) { //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
						this._uncache(false);
					}
					//in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The startTime of that child would get pushed out, but one of the ancestors may have completed.
					if (tl._timeline) {
						while (tl._timeline) {
							if (tl._timeline._time !== (tl._startTime + tl._totalTime) / tl._timeScale) {
								tl.totalTime(tl._totalTime, true);
							}
							tl = tl._timeline;
						}
					}
				}
				if (this._gc) {
					this._enabled(true, false);
				}
				if (this._totalTime !== time || this._duration === 0) {
					if (_lazyTweens.length) {
						_lazyRender();
					}
					this.render(time, suppressEvents, false);
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
						_lazyRender();
					}
				}
			}
			return this;
		};

		p.progress = p.totalProgress = function(value, suppressEvents) {
			var duration = this.duration();
			return (!arguments.length) ? (duration ? this._time / duration : this.ratio) : this.totalTime(duration * value, suppressEvents);
		};

		p.startTime = function(value) {
			if (!arguments.length) {
				return this._startTime;
			}
			if (value !== this._startTime) {
				this._startTime = value;
				if (this.timeline) if (this.timeline._sortChildren) {
					this.timeline.add(this, value - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
				}
			}
			return this;
		};

		p.endTime = function(includeRepeats) {
			return this._startTime + ((includeRepeats != false) ? this.totalDuration() : this.duration()) / this._timeScale;
		};

		p.timeScale = function(value) {
			if (!arguments.length) {
				return this._timeScale;
			}
			var pauseTime, t;
			value = value || _tinyNum; //can't allow zero because it'll throw the math off
			if (this._timeline && this._timeline.smoothChildTiming) {
				pauseTime = this._pauseTime;
				t = (pauseTime || pauseTime === 0) ? pauseTime : this._timeline.totalTime();
				this._startTime = t - ((t - this._startTime) * this._timeScale / value);
			}
			this._timeScale = value;
			t = this.timeline;
			while (t && t.timeline) { //must update the duration/totalDuration of all ancestor timelines immediately in case in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
				t._dirty = true;
				t.totalDuration();
				t = t.timeline;
			}
			return this;
		};

		p.reversed = function(value) {
			if (!arguments.length) {
				return this._reversed;
			}
			if (value != this._reversed) {
				this._reversed = value;
				this.totalTime(((this._timeline && !this._timeline.smoothChildTiming) ? this.totalDuration() - this._totalTime : this._totalTime), true);
			}
			return this;
		};

		p.paused = function(value) {
			if (!arguments.length) {
				return this._paused;
			}
			var tl = this._timeline,
				raw, elapsed;
			if (value != this._paused) if (tl) {
				if (!_tickerActive && !value) {
					_ticker.wake();
				}
				raw = tl.rawTime();
				elapsed = raw - this._pauseTime;
				if (!value && tl.smoothChildTiming) {
					this._startTime += elapsed;
					this._uncache(false);
				}
				this._pauseTime = value ? raw : null;
				this._paused = value;
				this._active = this.isActive();
				if (!value && elapsed !== 0 && this._initted && this.duration()) {
					raw = tl.smoothChildTiming ? this._totalTime : (raw - this._startTime) / this._timeScale;
					this.render(raw, (raw === this._totalTime), true); //in case the target's properties changed via some other tween or manual update by the user, we should force a render.
				}
			}
			if (this._gc && !value) {
				this._enabled(true, false);
			}
			return this;
		};


/*
 * ----------------------------------------------------------------
 * SimpleTimeline
 * ----------------------------------------------------------------
 */
		var SimpleTimeline = _class("core.SimpleTimeline", function(vars) {
			Animation.call(this, 0, vars);
			this.autoRemoveChildren = this.smoothChildTiming = true;
		});

		p = SimpleTimeline.prototype = new Animation();
		p.constructor = SimpleTimeline;
		p.kill()._gc = false;
		p._first = p._last = p._recent = null;
		p._sortChildren = false;

		p.add = p.insert = function(child, position, align, stagger) {
			var prevTween, st;
			child._startTime = Number(position || 0) + child._delay;
			if (child._paused) if (this !== child._timeline) { //we only adjust the _pauseTime if it wasn't in this timeline already. Remember, sometimes a tween will be inserted again into the same timeline when its startTime is changed so that the tweens in the TimelineLite/Max are re-ordered properly in the linked list (so everything renders in the proper order).
				child._pauseTime = this.rawTime() - (child._timeline.rawTime() - child._pauseTime);
			}
			if (child.timeline) {
				child.timeline._remove(child, true); //removes from existing timeline so that it can be properly added to this one.
			}
			child.timeline = child._timeline = this;
			if (child._gc) {
				child._enabled(true, true);
			}
			prevTween = this._last;
			if (this._sortChildren) {
				st = child._startTime;
				while (prevTween && prevTween._startTime > st) {
					prevTween = prevTween._prev;
				}
			}
			if (prevTween) {
				child._next = prevTween._next;
				prevTween._next = child;
			} else {
				child._next = this._first;
				this._first = child;
			}
			if (child._next) {
				child._next._prev = child;
			} else {
				this._last = child;
			}
			child._prev = prevTween;
			this._recent = child;
			if (this._timeline) {
				this._uncache(true);
			}
			return this;
		};

		p._remove = function(tween, skipDisable) {
			if (tween.timeline === this) {
				if (!skipDisable) {
					tween._enabled(false, true);
				}

				if (tween._prev) {
					tween._prev._next = tween._next;
				} else if (this._first === tween) {
					this._first = tween._next;
				}
				if (tween._next) {
					tween._next._prev = tween._prev;
				} else if (this._last === tween) {
					this._last = tween._prev;
				}
				tween._next = tween._prev = tween.timeline = null;
				if (tween === this._recent) {
					this._recent = this._last;
				}

				if (this._timeline) {
					this._uncache(true);
				}
			}
			return this;
		};

		p.render = function(time, suppressEvents, force) {
			var tween = this._first,
				next;
			this._totalTime = this._time = this._rawPrevTime = time;
			while (tween) {
				next = tween._next; //record it here because the value could change after rendering...
				if (tween._active || (time >= tween._startTime && !tween._paused && !tween._gc)) {
					if (!tween._reversed) {
						tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
					} else {
						tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
					}
				}
				tween = next;
			}
		};

		p.rawTime = function() {
			if (!_tickerActive) {
				_ticker.wake();
			}
			return this._totalTime;
		};

/*
 * ----------------------------------------------------------------
 * TweenLite
 * ----------------------------------------------------------------
 */
		var TweenLite = _class("TweenLite", function(target, duration, vars) {
				Animation.call(this, duration, vars);
				this.render = TweenLite.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)

				if (target == null) {
					throw "Cannot tween a null target.";
				}

				this.target = target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;

				var isSelector = (target.jquery || (target.length && target !== window && target[0] && (target[0] === window || (target[0].nodeType && target[0].style && !target.nodeType)))),
					overwrite = this.vars.overwrite,
					i, targ, targets;

				this._overwrite = overwrite = (overwrite == null) ? _overwriteLookup[TweenLite.defaultOverwrite] : (typeof(overwrite) === "number") ? overwrite >> 0 : _overwriteLookup[overwrite];

				if ((isSelector || target instanceof Array || (target.push && _isArray(target))) && typeof(target[0]) !== "number") {
					this._targets = targets = _slice(target);  //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					this._propLookup = [];
					this._siblings = [];
					for (i = 0; i < targets.length; i++) {
						targ = targets[i];
						if (!targ) {
							targets.splice(i--, 1);
							continue;
						} else if (typeof(targ) === "string") {
							targ = targets[i--] = TweenLite.selector(targ); //in case it's an array of strings
							if (typeof(targ) === "string") {
								targets.splice(i+1, 1); //to avoid an endless loop (can't imagine why the selector would return a string, but just in case)
							}
							continue;
						} else if (targ.length && targ !== window && targ[0] && (targ[0] === window || (targ[0].nodeType && targ[0].style && !targ.nodeType))) { //in case the user is passing in an array of selector objects (like jQuery objects), we need to check one more level and pull things out if necessary. Also note that <select> elements pass all the criteria regarding length and the first child having style, so we must also check to ensure the target isn't an HTML node itself.
							targets.splice(i--, 1);
							this._targets = targets = targets.concat(_slice(targ));
							continue;
						}
						this._siblings[i] = _register(targ, this, false);
						if (overwrite === 1) if (this._siblings[i].length > 1) {
							_applyOverwrite(targ, this, null, 1, this._siblings[i]);
						}
					}

				} else {
					this._propLookup = {};
					this._siblings = _register(target, this, false);
					if (overwrite === 1) if (this._siblings.length > 1) {
						_applyOverwrite(target, this, null, 1, this._siblings);
					}
				}
				if (this.vars.immediateRender || (duration === 0 && this._delay === 0 && this.vars.immediateRender !== false)) {
					this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
					this.render(Math.min(0, -this._delay)); //in case delay is negative
				}
			}, true),
			_isSelector = function(v) {
				return (v && v.length && v !== window && v[0] && (v[0] === window || (v[0].nodeType && v[0].style && !v.nodeType))); //we cannot check "nodeType" if the target is window from within an iframe, otherwise it will trigger a security error in some browsers like Firefox.
			},
			_autoCSS = function(vars, target) {
				var css = {},
					p;
				for (p in vars) {
					if (!_reservedProps[p] && (!(p in target) || p === "transform" || p === "x" || p === "y" || p === "width" || p === "height" || p === "className" || p === "border") && (!_plugins[p] || (_plugins[p] && _plugins[p]._autoCSS))) { //note: <img> elements contain read-only "x" and "y" properties. We should also prioritize editing css width/height rather than the element's properties.
						css[p] = vars[p];
						delete vars[p];
					}
				}
				vars.css = css;
			};

		p = TweenLite.prototype = new Animation();
		p.constructor = TweenLite;
		p.kill()._gc = false;

//----TweenLite defaults, overwrite management, and root updates ----------------------------------------------------

		p.ratio = 0;
		p._firstPT = p._targets = p._overwrittenProps = p._startAt = null;
		p._notifyPluginsOfEnabled = p._lazy = false;

		TweenLite.version = "2.1.3";
		TweenLite.defaultEase = p._ease = new Ease(null, null, 1, 1);
		TweenLite.defaultOverwrite = "auto";
		TweenLite.ticker = _ticker;
		TweenLite.autoSleep = 120;
		TweenLite.lagSmoothing = function(threshold, adjustedLag) {
			_ticker.lagSmoothing(threshold, adjustedLag);
		};

		TweenLite.selector = window.$ || window.jQuery || function(e) {
			var selector = window.$ || window.jQuery;
			if (selector) {
				TweenLite.selector = selector;
				return selector(e);
			}
			if (!_doc) { //in some dev environments (like Angular 6), GSAP gets loaded before the document is defined! So re-query it here if/when necessary.
				_doc = window.document;
			}
			return (!_doc) ? e : (_doc.querySelectorAll ? _doc.querySelectorAll(e) : _doc.getElementById((e.charAt(0) === "#") ? e.substr(1) : e));
		};

		var _lazyTweens = [],
			_lazyLookup = {},
			_numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
			_relExp = /[\+-]=-?[\.\d]/,
			//_nonNumbersExp = /(?:([\-+](?!(\d|=)))|[^\d\-+=e]|(e(?![\-+][\d])))+/ig,
			_setRatio = function(v) {
				var pt = this._firstPT,
					min = 0.000001,
					val;
				while (pt) {
					val = !pt.blob ? pt.c * v + pt.s : (v === 1 && this.end != null) ? this.end : v ? this.join("") : this.start;
					if (pt.m) {
						val = pt.m.call(this._tween, val, this._target || pt.t, this._tween);
					} else if (val < min) if (val > -min && !pt.blob) { //prevents issues with converting very small numbers to strings in the browser
						val = 0;
					}
					if (!pt.f) {
						pt.t[pt.p] = val;
					} else if (pt.fp) {
						pt.t[pt.p](pt.fp, val);
					} else {
						pt.t[pt.p](val);
					}
					pt = pt._next;
				}
			},
			_blobRound = function(v) {
				return (((v * 1000) | 0) / 1000) + "";
			},
			//compares two strings (start/end), finds the numbers that are different and spits back an array representing the whole value but with the changing values isolated as elements. For example, "rgb(0,0,0)" and "rgb(100,50,0)" would become ["rgb(", 0, ",", 50, ",0)"]. Notice it merges the parts that are identical (performance optimization). The array also has a linked list of PropTweens attached starting with _firstPT that contain the tweening data (t, p, s, c, f, etc.). It also stores the starting value as a "start" property so that we can revert to it if/when necessary, like when a tween rewinds fully. If the quantity of numbers differs between the start and end, it will always prioritize the end value(s). The pt parameter is optional - it's for a PropTween that will be appended to the end of the linked list and is typically for actually setting the value after all of the elements have been updated (with array.join("")).
			_blobDif = function(start, end, filter, pt) {
				var a = [],
					charIndex = 0,
					s = "",
					color = 0,
					startNums, endNums, num, i, l, nonNumbers, currentNum;
				a.start = start;
				a.end = end;
				start = a[0] = start + ""; //ensure values are strings
				end = a[1] = end + "";
				if (filter) {
					filter(a); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
					start = a[0];
					end = a[1];
				}
				a.length = 0;
				startNums = start.match(_numbersExp) || [];
				endNums = end.match(_numbersExp) || [];
				if (pt) {
					pt._next = null;
					pt.blob = 1;
					a._firstPT = a._applyPT = pt; //apply last in the linked list (which means inserting it first)
				}
				l = endNums.length;
				for (i = 0; i < l; i++) {
					currentNum = endNums[i];
					nonNumbers = end.substr(charIndex, end.indexOf(currentNum, charIndex)-charIndex);
					s += (nonNumbers || !i) ? nonNumbers : ","; //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
					charIndex += nonNumbers.length;
					if (color) { //sense rgba() values and round them.
						color = (color + 1) % 5;
					} else if (nonNumbers.substr(-5) === "rgba(") {
						color = 1;
					}
					if (currentNum === startNums[i] || startNums.length <= i) {
						s += currentNum;
					} else {
						if (s) {
							a.push(s);
							s = "";
						}
						num = parseFloat(startNums[i]);
						a.push(num);
						a._firstPT = {_next: a._firstPT, t:a, p: a.length-1, s:num, c:((currentNum.charAt(1) === "=") ? parseInt(currentNum.charAt(0) + "1", 10) * parseFloat(currentNum.substr(2)) : (parseFloat(currentNum) - num)) || 0, f:0, m:(color && color < 4) ? Math.round : _blobRound}; //limiting to 3 decimal places and casting as a string can really help performance when array.join() is called!
						//note: we don't set _prev because we'll never need to remove individual PropTweens from this list.
					}
					charIndex += currentNum.length;
				}
				s += end.substr(charIndex);
				if (s) {
					a.push(s);
				}
				a.setRatio = _setRatio;
				if (_relExp.test(end)) { //if the end string contains relative values, delete it so that on the final render (in _setRatio()), we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
					a.end = null;
				}
				return a;
			},
			//note: "funcParam" is only necessary for function-based getters/setters that require an extra parameter like getAttribute("width") and setAttribute("width", value). In this example, funcParam would be "width". Used by AttrPlugin for example.
			_addPropTween = function(target, prop, start, end, overwriteProp, mod, funcParam, stringFilter, index) {
				if (typeof(end) === "function") {
					end = end(index || 0, target);
				}
				var type = typeof(target[prop]),
					getterName = (type !== "function") ? "" : ((prop.indexOf("set") || typeof(target["get" + prop.substr(3)]) !== "function") ? prop : "get" + prop.substr(3)),
					s = (start !== "get") ? start : !getterName ? target[prop] : funcParam ? target[getterName](funcParam) : target[getterName](),
					isRelative = (typeof(end) === "string" && end.charAt(1) === "="),
					pt = {t:target, p:prop, s:s, f:(type === "function"), pg:0, n:overwriteProp || prop, m:(!mod ? 0 : (typeof(mod) === "function") ? mod : Math.round), pr:0, c:isRelative ? parseInt(end.charAt(0) + "1", 10) * parseFloat(end.substr(2)) : (parseFloat(end) - s) || 0},
					blob;

				if (typeof(s) !== "number" || (typeof(end) !== "number" && !isRelative)) {
					if (funcParam || isNaN(s) || (!isRelative && isNaN(end)) || typeof(s) === "boolean" || typeof(end) === "boolean") {
						//a blob (string that has multiple numbers in it)
						pt.fp = funcParam;
						blob = _blobDif(s, (isRelative ? (parseFloat(pt.s) + pt.c) + (pt.s + "").replace(/[0-9\-\.]/g, "") : end), stringFilter || TweenLite.defaultStringFilter, pt);
						pt = {t: blob, p: "setRatio", s: 0, c: 1, f: 2, pg: 0, n: overwriteProp || prop, pr: 0, m: 0}; //"2" indicates it's a Blob property tween. Needed for RoundPropsPlugin for example.
					} else {
						pt.s = parseFloat(s);
						if (!isRelative) {
							pt.c = (parseFloat(end) - pt.s) || 0;
						}
					}
				}
				if (pt.c) { //only add it to the linked list if there's a change.
					if ((pt._next = this._firstPT)) {
						pt._next._prev = pt;
					}
					this._firstPT = pt;
					return pt;
				}
			},
			_internals = TweenLite._internals = {isArray:_isArray, isSelector:_isSelector, lazyTweens:_lazyTweens, blobDif:_blobDif}, //gives us a way to expose certain private values to other GreenSock classes without contaminating tha main TweenLite object.
			_plugins = TweenLite._plugins = {},
			_tweenLookup = _internals.tweenLookup = {},
			_tweenLookupNum = 0,
			_reservedProps = _internals.reservedProps = {ease:1, delay:1, overwrite:1, onComplete:1, onCompleteParams:1, onCompleteScope:1, useFrames:1, runBackwards:1, startAt:1, onUpdate:1, onUpdateParams:1, onUpdateScope:1, onStart:1, onStartParams:1, onStartScope:1, onReverseComplete:1, onReverseCompleteParams:1, onReverseCompleteScope:1, onRepeat:1, onRepeatParams:1, onRepeatScope:1, easeParams:1, yoyo:1, immediateRender:1, repeat:1, repeatDelay:1, data:1, paused:1, reversed:1, autoCSS:1, lazy:1, onOverwrite:1, callbackScope:1, stringFilter:1, id:1, yoyoEase:1, stagger:1},
			_overwriteLookup = {none:0, all:1, auto:2, concurrent:3, allOnStart:4, preexisting:5, "true":1, "false":0},
			_rootFramesTimeline = Animation._rootFramesTimeline = new SimpleTimeline(),
			_rootTimeline = Animation._rootTimeline = new SimpleTimeline(),
			_nextGCFrame = 30,
			_lazyRender = _internals.lazyRender = function() {
				var l = _lazyTweens.length,
					i, tween;
				_lazyLookup = {};
				for (i = 0; i < l; i++) {
					tween = _lazyTweens[i];
					if (tween && tween._lazy !== false) {
						tween.render(tween._lazy[0], tween._lazy[1], true);
						tween._lazy = false;
					}
				}
				_lazyTweens.length = 0;
			};

		_rootTimeline._startTime = _ticker.time;
		_rootFramesTimeline._startTime = _ticker.frame;
		_rootTimeline._active = _rootFramesTimeline._active = true;
		setTimeout(_lazyRender, 1); //on some mobile devices, there isn't a "tick" before code runs which means any lazy renders wouldn't run before the next official "tick".

		Animation._updateRoot = TweenLite.render = function() {
				var i, a, p;
				if (_lazyTweens.length) { //if code is run outside of the requestAnimationFrame loop, there may be tweens queued AFTER the engine refreshed, so we need to ensure any pending renders occur before we refresh again.
					_lazyRender();
				}
				_rootTimeline.render((_ticker.time - _rootTimeline._startTime) * _rootTimeline._timeScale, false, false);
				_rootFramesTimeline.render((_ticker.frame - _rootFramesTimeline._startTime) * _rootFramesTimeline._timeScale, false, false);
				if (_lazyTweens.length) {
					_lazyRender();
				}
				if (_ticker.frame >= _nextGCFrame) { //dump garbage every 120 frames or whatever the user sets TweenLite.autoSleep to
					_nextGCFrame = _ticker.frame + (parseInt(TweenLite.autoSleep, 10) || 120);
					for (p in _tweenLookup) {
						a = _tweenLookup[p].tweens;
						i = a.length;
						while (--i > -1) {
							if (a[i]._gc) {
								a.splice(i, 1);
							}
						}
						if (a.length === 0) {
							delete _tweenLookup[p];
						}
					}
					//if there are no more tweens in the root timelines, or if they're all paused, make the _timer sleep to reduce load on the CPU slightly
					p = _rootTimeline._first;
					if (!p || p._paused) if (TweenLite.autoSleep && !_rootFramesTimeline._first && _ticker._listeners.tick.length === 1) {
						while (p && p._paused) {
							p = p._next;
						}
						if (!p) {
							_ticker.sleep();
						}
					}
				}
			};

		_ticker.addEventListener("tick", Animation._updateRoot);

		var _register = function(target, tween, scrub) {
				var id = target._gsTweenID, a, i;
				if (!_tweenLookup[id || (target._gsTweenID = id = "t" + (_tweenLookupNum++))]) {
					_tweenLookup[id] = {target:target, tweens:[]};
				}
				if (tween) {
					a = _tweenLookup[id].tweens;
					a[(i = a.length)] = tween;
					if (scrub) {
						while (--i > -1) {
							if (a[i] === tween) {
								a.splice(i, 1);
							}
						}
					}
				}
				return _tweenLookup[id].tweens;
			},
			_onOverwrite = function(overwrittenTween, overwritingTween, target, killedProps) {
				var func = overwrittenTween.vars.onOverwrite, r1, r2;
				if (func) {
					r1 = func(overwrittenTween, overwritingTween, target, killedProps);
				}
				func = TweenLite.onOverwrite;
				if (func) {
					r2 = func(overwrittenTween, overwritingTween, target, killedProps);
				}
				return (r1 !== false && r2 !== false);
			},
			_applyOverwrite = function(target, tween, props, mode, siblings) {
				var i, changed, curTween, l;
				if (mode === 1 || mode >= 4) {
					l = siblings.length;
					for (i = 0; i < l; i++) {
						if ((curTween = siblings[i]) !== tween) {
							if (!curTween._gc) {
								if (curTween._kill(null, target, tween)) {
									changed = true;
								}
							}
						} else if (mode === 5) {
							break;
						}
					}
					return changed;
				}
				//NOTE: Add tiny amount to overcome floating point errors that can cause the startTime to be VERY slightly off (when a tween's time() is set for example)
				var startTime = tween._startTime + _tinyNum,
					overlaps = [],
					oCount = 0,
					zeroDur = (tween._duration === 0),
					globalStart;
				i = siblings.length;
				while (--i > -1) {
					if ((curTween = siblings[i]) === tween || curTween._gc || curTween._paused) {
						//ignore
					} else if (curTween._timeline !== tween._timeline) {
						globalStart = globalStart || _checkOverlap(tween, 0, zeroDur);
						if (_checkOverlap(curTween, globalStart, zeroDur) === 0) {
							overlaps[oCount++] = curTween;
						}
					} else if (curTween._startTime <= startTime) if (curTween._startTime + curTween.totalDuration() / curTween._timeScale > startTime) if (!((zeroDur || !curTween._initted) && startTime - curTween._startTime <= _tinyNum * 2)) {
						overlaps[oCount++] = curTween;
					}
				}

				i = oCount;
				while (--i > -1) {
					curTween = overlaps[i];
					l = curTween._firstPT; //we need to discern if there were property tweens originally; if they all get removed in the next line's _kill() call, the tween should be killed. See https://github.com/greensock/GreenSock-JS/issues/278
					if (mode === 2) if (curTween._kill(props, target, tween)) {
						changed = true;
					}
					if (mode !== 2 || (!curTween._firstPT && curTween._initted && l)) {
						if (mode !== 2 && !_onOverwrite(curTween, tween)) {
							continue;
						}
						if (curTween._enabled(false, false)) { //if all property tweens have been overwritten, kill the tween.
							changed = true;
						}
					}
				}
				return changed;
			},
			_checkOverlap = function(tween, reference, zeroDur) {
				var tl = tween._timeline,
					ts = tl._timeScale,
					t = tween._startTime;
				while (tl._timeline) {
					t += tl._startTime;
					ts *= tl._timeScale;
					if (tl._paused) {
						return -100;
					}
					tl = tl._timeline;
				}
				t /= ts;
				return (t > reference) ? t - reference : ((zeroDur && t === reference) || (!tween._initted && t - reference < 2 * _tinyNum)) ? _tinyNum : ((t += tween.totalDuration() / tween._timeScale / ts) > reference + _tinyNum) ? 0 : t - reference - _tinyNum;
			};


//---- TweenLite instance methods -----------------------------------------------------------------------------

		p._init = function() {
			var v = this.vars,
				op = this._overwrittenProps,
				dur = this._duration,
				immediate = !!v.immediateRender,
				ease = v.ease,
				startAt = this._startAt,
				i, initPlugins, pt, p, startVars, l;
			if (v.startAt) {
				if (startAt) {
					startAt.render(-1, true); //if we've run a startAt previously (when the tween instantiated), we should revert it so that the values re-instantiate correctly particularly for relative tweens. Without this, a TweenLite.fromTo(obj, 1, {x:"+=100"}, {x:"-=100"}), for example, would actually jump to +=200 because the startAt would run twice, doubling the relative change.
					startAt.kill();
				}
				startVars = {};
				for (p in v.startAt) { //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, 1, from, to).fromTo(e, 1, to, from);
					startVars[p] = v.startAt[p];
				}
				startVars.data = "isStart";
				startVars.overwrite = false;
				startVars.immediateRender = true;
				startVars.lazy = (immediate && v.lazy !== false);
				startVars.startAt = startVars.delay = null; //no nesting of startAt objects allowed (otherwise it could cause an infinite loop).
				startVars.onUpdate = v.onUpdate;
				startVars.onUpdateParams = v.onUpdateParams;
				startVars.onUpdateScope = v.onUpdateScope || v.callbackScope || this;
				this._startAt = TweenLite.to(this.target || {}, 0, startVars);
				if (immediate) {
					if (this._time > 0) {
						this._startAt = null; //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in TimelineLite/Max instances where immediateRender was false (which is the default in the convenience methods like from()).
					} else if (dur !== 0) {
						return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a TimelineLite or TimelineMax, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
					}
				}
			} else if (v.runBackwards && dur !== 0) {
				//from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
				if (startAt) {
					startAt.render(-1, true);
					startAt.kill();
					this._startAt = null;
				} else {
					if (this._time !== 0) { //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
						immediate = false;
					}
					pt = {};
					for (p in v) { //copy props into a new object and skip any reserved props, otherwise onComplete or onUpdate or onStart could fire. We should, however, permit autoCSS to go through.
						if (!_reservedProps[p] || p === "autoCSS") {
							pt[p] = v[p];
						}
					}
					pt.overwrite = 0;
					pt.data = "isFromStart"; //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
					pt.lazy = (immediate && v.lazy !== false);
					pt.immediateRender = immediate; //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
					this._startAt = TweenLite.to(this.target, 0, pt);
					if (!immediate) {
						this._startAt._init(); //ensures that the initial values are recorded
						this._startAt._enabled(false); //no need to have the tween render on the next cycle. Disable it because we'll always manually control the renders of the _startAt tween.
						if (this.vars.immediateRender) {
							this._startAt = null;
						}
					} else if (this._time === 0) {
						return;
					}
				}
			}
			this._ease = ease = (!ease) ? TweenLite.defaultEase : (ease instanceof Ease) ? ease : (typeof(ease) === "function") ? new Ease(ease, v.easeParams) : _easeMap[ease] || TweenLite.defaultEase;
			if (v.easeParams instanceof Array && ease.config) {
				this._ease = ease.config.apply(ease, v.easeParams);
			}
			this._easeType = this._ease._type;
			this._easePower = this._ease._power;
			this._firstPT = null;

			if (this._targets) {
				l = this._targets.length;
				for (i = 0; i < l; i++) {
					if ( this._initProps( this._targets[i], (this._propLookup[i] = {}), this._siblings[i], (op ? op[i] : null), i) ) {
						initPlugins = true;
					}
				}
			} else {
				initPlugins = this._initProps(this.target, this._propLookup, this._siblings, op, 0);
			}

			if (initPlugins) {
				TweenLite._onPluginEvent("_onInitAllProps", this); //reorders the array in order of priority. Uses a static TweenPlugin method in order to minimize file size in TweenLite
			}
			if (op) if (!this._firstPT) if (typeof(this.target) !== "function") { //if all tweening properties have been overwritten, kill the tween. If the target is a function, it's probably a delayedCall so let it live.
				this._enabled(false, false);
			}
			if (v.runBackwards) {
				pt = this._firstPT;
				while (pt) {
					pt.s += pt.c;
					pt.c = -pt.c;
					pt = pt._next;
				}
			}
			this._onUpdate = v.onUpdate;
			this._initted = true;
		};

		p._initProps = function(target, propLookup, siblings, overwrittenProps, index) {
			var p, i, initPlugins, plugin, pt, v;
			if (target == null) {
				return false;
			}
			if (_lazyLookup[target._gsTweenID]) {
				_lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
			}

			if (!this.vars.css) if (target.style) if (target !== window && target.nodeType) if (_plugins.css) if (this.vars.autoCSS !== false) { //it's so common to use TweenLite/Max to animate the css of DOM elements, we assume that if the target is a DOM element, that's what is intended (a convenience so that users don't have to wrap things in css:{}, although we still recommend it for a slight performance boost and better specificity). Note: we cannot check "nodeType" on the window inside an iframe.
				_autoCSS(this.vars, target);
			}
			for (p in this.vars) {
				v = this.vars[p];
				if (_reservedProps[p]) {
					if (v) if ((v instanceof Array) || (v.push && _isArray(v))) if (v.join("").indexOf("{self}") !== -1) {
						this.vars[p] = v = this._swapSelfInParams(v, this);
					}

				} else if (_plugins[p] && (plugin = new _plugins[p]())._onInitTween(target, this.vars[p], this, index)) {

					//t - target 		[object]
					//p - property 		[string]
					//s - start			[number]
					//c - change		[number]
					//f - isFunction	[boolean]
					//n - name			[string]
					//pg - isPlugin 	[boolean]
					//pr - priority		[number]
					//m - mod           [function | 0]
					this._firstPT = pt = {_next:this._firstPT, t:plugin, p:"setRatio", s:0, c:1, f:1, n:p, pg:1, pr:plugin._priority, m:0};
					i = plugin._overwriteProps.length;
					while (--i > -1) {
						propLookup[plugin._overwriteProps[i]] = this._firstPT;
					}
					if (plugin._priority || plugin._onInitAllProps) {
						initPlugins = true;
					}
					if (plugin._onDisable || plugin._onEnable) {
						this._notifyPluginsOfEnabled = true;
					}
					if (pt._next) {
						pt._next._prev = pt;
					}

				} else {
					propLookup[p] = _addPropTween.call(this, target, p, "get", v, p, 0, null, this.vars.stringFilter, index);
				}
			}

			if (overwrittenProps) if (this._kill(overwrittenProps, target)) { //another tween may have tried to overwrite properties of this tween before init() was called (like if two tweens start at the same time, the one created second will run first)
				return this._initProps(target, propLookup, siblings, overwrittenProps, index);
			}
			if (this._overwrite > 1) if (this._firstPT) if (siblings.length > 1) if (_applyOverwrite(target, this, propLookup, this._overwrite, siblings)) {
				this._kill(propLookup, target);
				return this._initProps(target, propLookup, siblings, overwrittenProps, index);
			}
			if (this._firstPT) if ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration)) { //zero duration tweens don't lazy render by default; everything else does.
				_lazyLookup[target._gsTweenID] = true;
			}
			return initPlugins;
		};

		p.render = function(time, suppressEvents, force) {
			var self = this,
				prevTime = self._time,
				duration = self._duration,
				prevRawPrevTime = self._rawPrevTime,
				isComplete, callback, pt, rawPrevTime;
			if (time >= duration - _tinyNum && time >= 0) { //to work around occasional floating point math artifacts.
				self._totalTime = self._time = duration;
				self.ratio = self._ease._calcEnd ? self._ease.getRatio(1) : 1;
				if (!self._reversed ) {
					isComplete = true;
					callback = "onComplete";
					force = (force || self._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
				}
				if (duration === 0) if (self._initted || !self.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
					if (self._startTime === self._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
						time = 0;
					}
					if (prevRawPrevTime < 0 || (time <= 0 && time >= -_tinyNum) || (prevRawPrevTime === _tinyNum && self.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
						force = true;
						if (prevRawPrevTime > _tinyNum) {
							callback = "onReverseComplete";
						}
					}
					self._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
				}

			} else if (time < _tinyNum) { //to work around occasional floating point math artifacts, round super small values to 0.
				self._totalTime = self._time = 0;
				self.ratio = self._ease._calcEnd ? self._ease.getRatio(0) : 0;
				if (prevTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
					callback = "onReverseComplete";
					isComplete = self._reversed;
				}
				if (time > -_tinyNum) {
					time = 0;
				} else if (time < 0) {
					self._active = false;
					if (duration === 0) if (self._initted || !self.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (prevRawPrevTime >= 0 && !(prevRawPrevTime === _tinyNum && self.data === "isPause")) {
							force = true;
						}
						self._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
				}
				if (!self._initted || (self._startAt && self._startAt.progress())) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately. Also, we check progress() because if startAt has already rendered at its end, we should force a render at its beginning. Otherwise, if you put the playhead directly on top of where a fromTo({immediateRender:false}) starts, and then move it backwards, the from() won't revert its values.
					force = true;
				}
			} else {
				self._totalTime = self._time = time;

				if (self._easeType) {
					var r = time / duration, type = self._easeType, pow = self._easePower;
					if (type === 1 || (type === 3 && r >= 0.5)) {
						r = 1 - r;
					}
					if (type === 3) {
						r *= 2;
					}
					if (pow === 1) {
						r *= r;
					} else if (pow === 2) {
						r *= r * r;
					} else if (pow === 3) {
						r *= r * r * r;
					} else if (pow === 4) {
						r *= r * r * r * r;
					}
					self.ratio = (type === 1) ? 1 - r : (type === 2) ? r : (time / duration < 0.5) ? r / 2 : 1 - (r / 2);
				} else {
					self.ratio = self._ease.getRatio(time / duration);
				}
			}

			if (self._time === prevTime && !force) {
				return;
			} else if (!self._initted) {
				self._init();
				if (!self._initted || self._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
					return;
				} else if (!force && self._firstPT && ((self.vars.lazy !== false && self._duration) || (self.vars.lazy && !self._duration))) {
					self._time = self._totalTime = prevTime;
					self._rawPrevTime = prevRawPrevTime;
					_lazyTweens.push(self);
					self._lazy = [time, suppressEvents];
					return;
				}
				//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
				if (self._time && !isComplete) {
					self.ratio = self._ease.getRatio(self._time / duration);
				} else if (isComplete && self._ease._calcEnd) {
					self.ratio = self._ease.getRatio((self._time === 0) ? 0 : 1);
				}
			}
			if (self._lazy !== false) { //in case a lazy render is pending, we should flush it because the new render is occurring now (imagine a lazy tween instantiating and then immediately the user calls tween.seek(tween.duration()), skipping to the end - the end render would be forced, and then if we didn't flush the lazy render, it'd fire AFTER the seek(), rendering it at the wrong time.
				self._lazy = false;
			}
			if (!self._active) if (!self._paused && self._time !== prevTime && time >= 0) {
				self._active = true;  //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
			}
			if (prevTime === 0) {
				if (self._startAt) {
					if (time >= 0) {
						self._startAt.render(time, true, force);
					} else if (!callback) {
						callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
					}
				}
				if (self.vars.onStart) if (self._time !== 0 || duration === 0) if (!suppressEvents) {
					self._callback("onStart");
				}
			}
			pt = self._firstPT;
			while (pt) {
				if (pt.f) {
					pt.t[pt.p](pt.c * self.ratio + pt.s);
				} else {
					pt.t[pt.p] = pt.c * self.ratio + pt.s;
				}
				pt = pt._next;
			}

			if (self._onUpdate) {
				if (time < 0) if (self._startAt && time !== -0.0001) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
					self._startAt.render(time, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
				}
				if (!suppressEvents) if (self._time !== prevTime || isComplete || force) {
					self._callback("onUpdate");
				}
			}
			if (callback) if (!self._gc || force) { //check _gc because there's a chance that kill() could be called in an onUpdate
				if (time < 0 && self._startAt && !self._onUpdate && time !== -0.0001) { //-0.0001 is a special value that we use when looping back to the beginning of a repeated TimelineMax, in which case we shouldn't render the _startAt values.
					self._startAt.render(time, true, force);
				}
				if (isComplete) {
					if (self._timeline.autoRemoveChildren) {
						self._enabled(false, false);
					}
					self._active = false;
				}
				if (!suppressEvents && self.vars[callback]) {
					self._callback(callback);
				}
				if (duration === 0 && self._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
					self._rawPrevTime = 0;
				}
			}
		};

		p._kill = function(vars, target, overwritingTween) {
			if (vars === "all") {
				vars = null;
			}
			if (vars == null) if (target == null || target === this.target) {
				this._lazy = false;
				return this._enabled(false, false);
			}
			target = (typeof(target) !== "string") ? (target || this._targets || this.target) : TweenLite.selector(target) || target;
			var simultaneousOverwrite = (overwritingTween && this._time && overwritingTween._startTime === this._startTime && this._timeline === overwritingTween._timeline),
				firstPT = this._firstPT,
				i, overwrittenProps, p, pt, propLookup, changed, killProps, record, killed;
			if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
				i = target.length;
				while (--i > -1) {
					if (this._kill(vars, target[i], overwritingTween)) {
						changed = true;
					}
				}
			} else {
				if (this._targets) {
					i = this._targets.length;
					while (--i > -1) {
						if (target === this._targets[i]) {
							propLookup = this._propLookup[i] || {};
							this._overwrittenProps = this._overwrittenProps || [];
							overwrittenProps = this._overwrittenProps[i] = vars ? this._overwrittenProps[i] || {} : "all";
							break;
						}
					}
				} else if (target !== this.target) {
					return false;
				} else {
					propLookup = this._propLookup;
					overwrittenProps = this._overwrittenProps = vars ? this._overwrittenProps || {} : "all";
				}

				if (propLookup) {
					killProps = vars || propLookup;
					record = (vars !== overwrittenProps && overwrittenProps !== "all" && vars !== propLookup && (typeof(vars) !== "object" || !vars._tempKill)); //_tempKill is a super-secret way to delete a particular tweening property but NOT have it remembered as an official overwritten property (like in BezierPlugin)
					if (overwritingTween && (TweenLite.onOverwrite || this.vars.onOverwrite)) {
						for (p in killProps) {
							if (propLookup[p]) {
								if (!killed) {
									killed = [];
								}
								killed.push(p);
							}
						}
						if ((killed || !vars) && !_onOverwrite(this, overwritingTween, target, killed)) { //if the onOverwrite returned false, that means the user wants to override the overwriting (cancel it).
							return false;
						}
					}

					for (p in killProps) {
						if ((pt = propLookup[p])) {
							if (simultaneousOverwrite) { //if another tween overwrites this one and they both start at exactly the same time, yet this tween has already rendered once (for example, at 0.001) because it's first in the queue, we should revert the values to where they were at 0 so that the starting values aren't contaminated on the overwriting tween.
								if (pt.f) {
									pt.t[pt.p](pt.s);
								} else {
									pt.t[pt.p] = pt.s;
								}
								changed = true;
							}
							if (pt.pg && pt.t._kill(killProps)) {
								changed = true; //some plugins need to be notified so they can perform cleanup tasks first
							}
							if (!pt.pg || pt.t._overwriteProps.length === 0) {
								if (pt._prev) {
									pt._prev._next = pt._next;
								} else if (pt === this._firstPT) {
									this._firstPT = pt._next;
								}
								if (pt._next) {
									pt._next._prev = pt._prev;
								}
								pt._next = pt._prev = null;
							}
							delete propLookup[p];
						}
						if (record) {
							overwrittenProps[p] = 1;
						}
					}
					if (!this._firstPT && this._initted && firstPT) { //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
						this._enabled(false, false);
					}
				}
			}
			return changed;
		};

		p.invalidate = function() {
			if (this._notifyPluginsOfEnabled) {
				TweenLite._onPluginEvent("_onDisable", this);
			}
			var t = this._time;
			this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null;
			this._notifyPluginsOfEnabled = this._active = this._lazy = false;
			this._propLookup = (this._targets) ? {} : [];
			Animation.prototype.invalidate.call(this);
			if (this.vars.immediateRender) {
				this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
				this.render(t, false, this.vars.lazy !== false);
			}
			return this;
		};

		p._enabled = function(enabled, ignoreTimeline) {
			if (!_tickerActive) {
				_ticker.wake();
			}
			if (enabled && this._gc) {
				var targets = this._targets,
					i;
				if (targets) {
					i = targets.length;
					while (--i > -1) {
						this._siblings[i] = _register(targets[i], this, true);
					}
				} else {
					this._siblings = _register(this.target, this, true);
				}
			}
			Animation.prototype._enabled.call(this, enabled, ignoreTimeline);
			if (this._notifyPluginsOfEnabled) if (this._firstPT) {
				return TweenLite._onPluginEvent((enabled ? "_onEnable" : "_onDisable"), this);
			}
			return false;
		};


//----TweenLite static methods -----------------------------------------------------

		TweenLite.to = function(target, duration, vars) {
			return new TweenLite(target, duration, vars);
		};

		TweenLite.from = function(target, duration, vars) {
			vars.runBackwards = true;
			vars.immediateRender = (vars.immediateRender != false);
			return new TweenLite(target, duration, vars);
		};

		TweenLite.fromTo = function(target, duration, fromVars, toVars) {
			toVars.startAt = fromVars;
			toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
			return new TweenLite(target, duration, toVars);
		};

		TweenLite.delayedCall = function(delay, callback, params, scope, useFrames) {
			return new TweenLite(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, lazy:false, useFrames:useFrames, overwrite:0});
		};

		TweenLite.set = function(target, vars) {
			return new TweenLite(target, 0, vars);
		};

		TweenLite.getTweensOf = function(target, onlyActive) {
			if (target == null) { return []; }
			target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;
			var i, a, j, t;
			if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
				i = target.length;
				a = [];
				while (--i > -1) {
					a = a.concat(TweenLite.getTweensOf(target[i], onlyActive));
				}
				i = a.length;
				//now get rid of any duplicates (tweens of arrays of objects could cause duplicates)
				while (--i > -1) {
					t = a[i];
					j = i;
					while (--j > -1) {
						if (t === a[j]) {
							a.splice(i, 1);
						}
					}
				}
			} else if (target._gsTweenID) {
				a = _register(target).concat();
				i = a.length;
				while (--i > -1) {
					if (a[i]._gc || (onlyActive && !a[i].isActive())) {
						a.splice(i, 1);
					}
				}
			}
			return a || [];
		};

		TweenLite.killTweensOf = TweenLite.killDelayedCallsTo = function(target, onlyActive, vars) {
			if (typeof(onlyActive) === "object") {
				vars = onlyActive; //for backwards compatibility (before "onlyActive" parameter was inserted)
				onlyActive = false;
			}
			var a = TweenLite.getTweensOf(target, onlyActive),
				i = a.length;
			while (--i > -1) {
				a[i]._kill(vars, target);
			}
		};



/*
 * ----------------------------------------------------------------
 * TweenPlugin   (could easily be split out as a separate file/class, but included for ease of use (so that people don't need to include another script call before loading plugins which is easy to forget)
 * ----------------------------------------------------------------
 */
		var TweenPlugin = _class("plugins.TweenPlugin", function(props, priority) {
					this._overwriteProps = (props || "").split(",");
					this._propName = this._overwriteProps[0];
					this._priority = priority || 0;
					this._super = TweenPlugin.prototype;
				}, true);

		p = TweenPlugin.prototype;
		TweenPlugin.version = "1.19.0";
		TweenPlugin.API = 2;
		p._firstPT = null;
		p._addTween = _addPropTween;
		p.setRatio = _setRatio;

		p._kill = function(lookup) {
			var a = this._overwriteProps,
				pt = this._firstPT,
				i;
			if (lookup[this._propName] != null) {
				this._overwriteProps = [];
			} else {
				i = a.length;
				while (--i > -1) {
					if (lookup[a[i]] != null) {
						a.splice(i, 1);
					}
				}
			}
			while (pt) {
				if (lookup[pt.n] != null) {
					if (pt._next) {
						pt._next._prev = pt._prev;
					}
					if (pt._prev) {
						pt._prev._next = pt._next;
						pt._prev = null;
					} else if (this._firstPT === pt) {
						this._firstPT = pt._next;
					}
				}
				pt = pt._next;
			}
			return false;
		};

		p._mod = p._roundProps = function(lookup) {
			var pt = this._firstPT,
				val;
			while (pt) {
				val = lookup[this._propName] || (pt.n != null && lookup[ pt.n.split(this._propName + "_").join("") ]);
				if (val && typeof(val) === "function") { //some properties that are very plugin-specific add a prefix named after the _propName plus an underscore, so we need to ignore that extra stuff here.
					if (pt.f === 2) {
						pt.t._applyPT.m = val;
					} else {
						pt.m = val;
					}
				}
				pt = pt._next;
			}
		};

		TweenLite._onPluginEvent = function(type, tween) {
			var pt = tween._firstPT,
				changed, pt2, first, last, next;
			if (type === "_onInitAllProps") {
				//sorts the PropTween linked list in order of priority because some plugins need to render earlier/later than others, like MotionBlurPlugin applies its effects after all x/y/alpha tweens have rendered on each frame.
				while (pt) {
					next = pt._next;
					pt2 = first;
					while (pt2 && pt2.pr > pt.pr) {
						pt2 = pt2._next;
					}
					if ((pt._prev = pt2 ? pt2._prev : last)) {
						pt._prev._next = pt;
					} else {
						first = pt;
					}
					if ((pt._next = pt2)) {
						pt2._prev = pt;
					} else {
						last = pt;
					}
					pt = next;
				}
				pt = tween._firstPT = first;
			}
			while (pt) {
				if (pt.pg) if (typeof(pt.t[type]) === "function") if (pt.t[type]()) {
					changed = true;
				}
				pt = pt._next;
			}
			return changed;
		};

		TweenPlugin.activate = function(plugins) {
			var i = plugins.length;
			while (--i > -1) {
				if (plugins[i].API === TweenPlugin.API) {
					_plugins[(new plugins[i]())._propName] = plugins[i];
				}
			}
			return true;
		};

		//provides a more concise way to define plugins that have no dependencies besides TweenPlugin and TweenLite, wrapping common boilerplate stuff into one function (added in 1.9.0). You don't NEED to use this to define a plugin - the old way still works and can be useful in certain (rare) situations.
		_gsDefine.plugin = function(config) {
			if (!config || !config.propName || !config.init || !config.API) { throw "illegal plugin definition."; }
			var propName = config.propName,
				priority = config.priority || 0,
				overwriteProps = config.overwriteProps,
				map = {init:"_onInitTween", set:"setRatio", kill:"_kill", round:"_mod", mod:"_mod", initAll:"_onInitAllProps"},
				Plugin = _class("plugins." + propName.charAt(0).toUpperCase() + propName.substr(1) + "Plugin",
					function() {
						TweenPlugin.call(this, propName, priority);
						this._overwriteProps = overwriteProps || [];
					}, (config.global === true)),
				p = Plugin.prototype = new TweenPlugin(propName),
				prop;
			p.constructor = Plugin;
			Plugin.API = config.API;
			for (prop in map) {
				if (typeof(config[prop]) === "function") {
					p[map[prop]] = config[prop];
				}
			}
			Plugin.version = config.version;
			TweenPlugin.activate([Plugin]);
			return Plugin;
		};


		//now run through all the dependencies discovered and if any are missing, log that to the console as a warning. This is why it's best to have TweenLite load last - it can check all the dependencies for you.
		a = window._gsQueue;
		if (a) {
			for (i = 0; i < a.length; i++) {
				a[i]();
			}
			for (p in _defLookup) {
				if (!_defLookup[p].func) {
					window.console.log("GSAP encountered missing dependency: " + p);
				}
			}
		}

		_tickerActive = false; //ensures that the first official animation forces a ticker.tick() to update the time when it is instantiated

		return TweenLite;

})(_gsScope, "TweenLite");

var globals = _gsScope.GreenSockGlobals;
var nonGlobals = globals.com.greensock;

var SimpleTimeline = nonGlobals.core.SimpleTimeline;
var Animation = nonGlobals.core.Animation;
var Ease = globals.Ease;
var Linear = globals.Linear;
var Power0 = Linear;
var Power1 = globals.Power1;
var Power2 = globals.Power2;
var Power3 = globals.Power3;
var Power4 = globals.Power4;
var TweenPlugin = globals.TweenPlugin;
var EventDispatcher = nonGlobals.events.EventDispatcher;

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1732)(module), __webpack_require__(65)))

/***/ }),

/***/ 1570:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_SjQuestionFile_vue__ = __webpack_require__(1747);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_SjQuestionFile_vue__["a" /* default */]);

/***/ }),

/***/ 1571:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sj_question_file_src_SjQuestionFileItem_vue__ = __webpack_require__(1751);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__sj_question_file_src_SjQuestionFileItem_vue__["a" /* default */]);

/***/ }),

/***/ 1572:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sj_question_file_src_SjQuestionFileAdd_vue__ = __webpack_require__(1755);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__sj_question_file_src_SjQuestionFileAdd_vue__["a" /* default */]);

/***/ }),

/***/ 1576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getConvertType;
/* harmony export (immutable) */ __webpack_exports__["b"] = getRecoveryType;
/**
 * 类型转换的对照数组
 */
var types = [{
  old: 'mtext',
  new: 'multitext'
}, {
  old: 'options',
  new: 'select'
}, {
  old: 'moptions',
  new: 'multiselect'
}, {
  old: 'pictureMultipleOptions',
  new: 'imageMultiselect'
}];

function getConvertType(type) {
  for (var i = 0; i < types.length; i++) {
    if (types[i].old === type) {
      return types[i].new;
    }
  }
  return type;
}

function getRecoveryType(type) {
  for (var i = 0; i < types.length; i++) {
    if (types[i].new === type) {
      return types[i].old;
    }
  }
  return type;
}

/* unused harmony default export */ var _unused_webpack_default_export = ({ getConvertType: getConvertType, getRecoveryType: getRecoveryType });

/***/ }),

/***/ 1582:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "@keyframes plyr-progress{to{background-position:25px 0}}@keyframes plyr-popup{0%{opacity:.5;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}@keyframes plyr-fade-in{0%{opacity:0}to{opacity:1}}.plyr{-moz-osx-font-smoothing:auto;-webkit-font-smoothing:subpixel-antialiased;direction:ltr;font-family:Avenir,Avenir Next,Helvetica Neue,Segoe UI,Helvetica,Arial,sans-serif;font-variant-numeric:tabular-nums;font-weight:500;line-height:1.7;max-width:100%;min-width:200px;position:relative;text-shadow:none;transition:box-shadow .3s ease}.plyr audio,.plyr video{border-radius:inherit;height:auto;vertical-align:middle;width:100%}.plyr button{font:inherit;line-height:inherit;width:auto}.plyr:focus{outline:0}.plyr--full-ui{box-sizing:border-box}.plyr--full-ui *,.plyr--full-ui :after,.plyr--full-ui :before{box-sizing:inherit}.plyr--full-ui a,.plyr--full-ui button,.plyr--full-ui input,.plyr--full-ui label{touch-action:manipulation}.plyr__badge{background:#4a5764;border-radius:2px;color:#fff;font-size:9px;line-height:1;padding:3px 4px}.plyr--full-ui ::-webkit-media-text-track-container{display:none}.plyr__captions{animation:plyr-fade-in .3s ease;bottom:0;color:#fff;display:none;font-size:14px;left:0;padding:10px;position:absolute;text-align:center;transition:transform .4s ease-in-out;width:100%}.plyr__captions .plyr__caption{background:rgba(0,0,0,.8);border-radius:2px;-webkit-box-decoration-break:clone;box-decoration-break:clone;line-height:185%;padding:.2em .5em;white-space:pre-wrap}.plyr__captions .plyr__caption div{display:inline}.plyr__captions span:empty{display:none}@media (min-width:480px){.plyr__captions{font-size:16px;padding:20px}}@media (min-width:768px){.plyr__captions{font-size:18px}}.plyr--captions-active .plyr__captions{display:block}.plyr:not(.plyr--hide-controls) .plyr__controls:not(:empty)~.plyr__captions{transform:translateY(-40px)}.plyr__control{background:0 0;border:0;border-radius:3px;color:inherit;cursor:pointer;flex-shrink:0;overflow:visible;padding:7px;position:relative;transition:all .3s ease}.plyr__control svg{display:block;fill:currentColor;height:18px;pointer-events:none;width:18px}.plyr__control:focus{outline:0}.plyr__control.plyr__tab-focus{box-shadow:0 0 0 5px rgba(0,179,255,.5);outline:0}a.plyr__control{text-decoration:none}.plyr__control.plyr__control--pressed .icon--not-pressed,.plyr__control.plyr__control--pressed .label--not-pressed,.plyr__control:not(.plyr__control--pressed) .icon--pressed,.plyr__control:not(.plyr__control--pressed) .label--pressed,a.plyr__control:after,a.plyr__control:before{display:none}.plyr--audio .plyr__control.plyr__tab-focus,.plyr--audio .plyr__control:hover,.plyr--audio .plyr__control[aria-expanded=true],.plyr--video .plyr__control.plyr__tab-focus,.plyr--video .plyr__control:hover,.plyr--video .plyr__control[aria-expanded=true]{background:#00b3ff;color:#fff}.plyr__control--overlaid{background:rgba(0,179,255,.8);border:0;border-radius:100%;color:#fff;display:none;left:50%;padding:15px;position:absolute;top:50%;transform:translate(-50%,-50%);z-index:2}.plyr__control--overlaid svg{left:2px;position:relative}.plyr__control--overlaid:focus,.plyr__control--overlaid:hover{background:#00b3ff}.plyr--playing .plyr__control--overlaid{opacity:0;visibility:hidden}.plyr--full-ui.plyr--video .plyr__control--overlaid{display:block}.plyr--full-ui ::-webkit-media-controls{display:none}.plyr__controls{align-items:center;display:flex;justify-content:flex-end;text-align:center}.plyr__controls .plyr__progress__container{flex:1;min-width:0}.plyr__controls .plyr__controls__item{margin-left:2.5px}.plyr__controls .plyr__controls__item:first-child{margin-left:0;margin-right:auto}.plyr__controls .plyr__controls__item.plyr__progress__container{padding-left:2.5px}.plyr__controls .plyr__controls__item.plyr__time{padding:0 5px}.plyr__controls .plyr__controls__item.plyr__progress__container:first-child,.plyr__controls .plyr__controls__item.plyr__time+.plyr__time,.plyr__controls .plyr__controls__item.plyr__time:first-child{padding-left:0}.plyr__controls .plyr__controls__item.plyr__volume{padding-right:5px}.plyr__controls .plyr__controls__item.plyr__volume:first-child{padding-right:0}.plyr__controls:empty{display:none}.plyr--audio .plyr__controls{background:#fff;border-radius:inherit;color:#4a5764;padding:10px}.plyr--video .plyr__controls{background:linear-gradient(transparent,rgba(0,0,0,.7));border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;bottom:0;color:#fff;left:0;padding:20px 5px 5px;position:absolute;right:0;transition:opacity .4s ease-in-out,transform .4s ease-in-out;z-index:3}@media (min-width:480px){.plyr--video .plyr__controls{padding:35px 10px 10px}}.plyr--video.plyr--hide-controls .plyr__controls{opacity:0;pointer-events:none;transform:translateY(100%)}.plyr [data-plyr=airplay],.plyr [data-plyr=captions],.plyr [data-plyr=fullscreen],.plyr [data-plyr=pip]{display:none}.plyr--airplay-supported [data-plyr=airplay],.plyr--captions-enabled [data-plyr=captions],.plyr--fullscreen-enabled [data-plyr=fullscreen],.plyr--pip-supported [data-plyr=pip]{display:inline-block}.plyr__menu{display:flex;position:relative}.plyr__menu .plyr__control svg{transition:transform .3s ease}.plyr__menu .plyr__control[aria-expanded=true] svg{transform:rotate(90deg)}.plyr__menu .plyr__control[aria-expanded=true] .plyr__tooltip{display:none}.plyr__menu__container{animation:plyr-popup .2s ease;background:hsla(0,0%,100%,.9);border-radius:4px;bottom:100%;box-shadow:0 1px 2px rgba(0,0,0,.15);color:#4a5764;font-size:16px;margin-bottom:10px;position:absolute;right:-3px;text-align:left;white-space:nowrap;z-index:3}.plyr__menu__container>div{overflow:hidden;transition:height .35s cubic-bezier(.4,0,.2,1),width .35s cubic-bezier(.4,0,.2,1)}.plyr__menu__container:after{border:4px solid transparent;border-top-color:hsla(0,0%,100%,.9);content:\"\";height:0;position:absolute;right:15px;top:100%;width:0}.plyr__menu__container [role=menu]{padding:7px}.plyr__menu__container [role=menuitem],.plyr__menu__container [role=menuitemradio]{margin-top:2px}.plyr__menu__container [role=menuitem]:first-child,.plyr__menu__container [role=menuitemradio]:first-child{margin-top:0}.plyr__menu__container .plyr__control{align-items:center;color:#4a5764;display:flex;font-size:14px;padding:4px 11px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%}.plyr__menu__container .plyr__control>span{align-items:inherit;display:flex;width:100%}.plyr__menu__container .plyr__control:after{border:4px solid transparent;content:\"\";position:absolute;top:50%;transform:translateY(-50%)}.plyr__menu__container .plyr__control--forward{padding-right:28px}.plyr__menu__container .plyr__control--forward:after{border-left-color:rgba(74,87,100,.8);right:5px}.plyr__menu__container .plyr__control--forward.plyr__tab-focus:after,.plyr__menu__container .plyr__control--forward:hover:after{border-left-color:currentColor}.plyr__menu__container .plyr__control--back{font-weight:500;margin:7px;margin-bottom:3px;padding-left:28px;position:relative;width:calc(100% - 14px)}.plyr__menu__container .plyr__control--back:after{border-right-color:rgba(74,87,100,.8);left:7px}.plyr__menu__container .plyr__control--back:before{background:#c1c9d1;box-shadow:0 1px 0 #fff;content:\"\";height:1px;left:0;margin-top:4px;overflow:hidden;position:absolute;right:0;top:100%}.plyr__menu__container .plyr__control--back.plyr__tab-focus:after,.plyr__menu__container .plyr__control--back:hover:after{border-right-color:currentColor}.plyr__menu__container .plyr__control[role=menuitemradio]{padding-left:7px}.plyr__menu__container .plyr__control[role=menuitemradio]:after,.plyr__menu__container .plyr__control[role=menuitemradio]:before{border-radius:100%}.plyr__menu__container .plyr__control[role=menuitemradio]:before{background:rgba(0,0,0,.1);content:\"\";display:block;flex-shrink:0;height:16px;margin-right:10px;transition:all .3s ease;width:16px}.plyr__menu__container .plyr__control[role=menuitemradio]:after{background:#fff;border:0;height:6px;left:12px;opacity:0;top:50%;transform:translateY(-50%) scale(0);transition:transform .3s ease,opacity .3s ease;width:6px}.plyr__menu__container .plyr__control[role=menuitemradio][aria-checked=true]:before{background:#00b3ff}.plyr__menu__container .plyr__control[role=menuitemradio][aria-checked=true]:after{opacity:1;transform:translateY(-50%) scale(1)}.plyr__menu__container .plyr__control[role=menuitemradio].plyr__tab-focus:before,.plyr__menu__container .plyr__control[role=menuitemradio]:hover:before{background:rgba(0,0,0,.1)}.plyr__menu__container .plyr__menu__value{align-items:center;display:flex;margin-left:auto;margin-right:-5px;overflow:hidden;padding-left:25px;pointer-events:none}.plyr--full-ui input[type=range]{-webkit-appearance:none;background:0 0;border:0;border-radius:26px;color:#00b3ff;display:block;height:19px;margin:0;padding:0;transition:box-shadow .3s ease;width:100%}.plyr--full-ui input[type=range]::-webkit-slider-runnable-track{background:0 0;border:0;border-radius:2.5px;height:5px;transition:box-shadow .3s ease;-webkit-user-select:none;user-select:none;background-image:linear-gradient(90deg,currentColor var(--value,0),transparent var(--value,0))}.plyr--full-ui input[type=range]::-webkit-slider-thumb{background:#fff;border:0;border-radius:100%;box-shadow:0 1px 1px rgba(0,0,0,.15),0 0 0 1px rgba(35,41,47,.2);height:13px;position:relative;transition:all .2s ease;width:13px;-webkit-appearance:none;margin-top:-4px}.plyr--full-ui input[type=range]::-moz-range-track{background:0 0;border:0;border-radius:2.5px;height:5px;transition:box-shadow .3s ease;-moz-user-select:none;user-select:none}.plyr--full-ui input[type=range]::-moz-range-thumb{background:#fff;border:0;border-radius:100%;box-shadow:0 1px 1px rgba(0,0,0,.15),0 0 0 1px rgba(35,41,47,.2);height:13px;position:relative;transition:all .2s ease;width:13px}.plyr--full-ui input[type=range]::-moz-range-progress{background:currentColor;border-radius:2.5px;height:5px}.plyr--full-ui input[type=range]::-ms-track{color:transparent}.plyr--full-ui input[type=range]::-ms-fill-upper,.plyr--full-ui input[type=range]::-ms-track{background:0 0;border:0;border-radius:2.5px;height:5px;transition:box-shadow .3s ease;-ms-user-select:none;user-select:none}.plyr--full-ui input[type=range]::-ms-fill-lower{background:0 0;border:0;border-radius:2.5px;height:5px;transition:box-shadow .3s ease;-ms-user-select:none;user-select:none;background:currentColor}.plyr--full-ui input[type=range]::-ms-thumb{background:#fff;border:0;border-radius:100%;box-shadow:0 1px 1px rgba(0,0,0,.15),0 0 0 1px rgba(35,41,47,.2);height:13px;position:relative;transition:all .2s ease;width:13px;margin-top:0}.plyr--full-ui input[type=range]::-ms-tooltip{display:none}.plyr--full-ui input[type=range]:focus{outline:0}.plyr--full-ui input[type=range]::-moz-focus-outer{border:0}.plyr--full-ui input[type=range].plyr__tab-focus::-webkit-slider-runnable-track{box-shadow:0 0 0 5px rgba(0,179,255,.5);outline:0}.plyr--full-ui input[type=range].plyr__tab-focus::-moz-range-track{box-shadow:0 0 0 5px rgba(0,179,255,.5);outline:0}.plyr--full-ui input[type=range].plyr__tab-focus::-ms-track{box-shadow:0 0 0 5px rgba(0,179,255,.5);outline:0}.plyr--full-ui.plyr--video input[type=range]::-webkit-slider-runnable-track{background-color:hsla(0,0%,100%,.25)}.plyr--full-ui.plyr--video input[type=range]::-moz-range-track{background-color:hsla(0,0%,100%,.25)}.plyr--full-ui.plyr--video input[type=range]::-ms-track{background-color:hsla(0,0%,100%,.25)}.plyr--full-ui.plyr--video input[type=range]:active::-webkit-slider-thumb{box-shadow:0 1px 1px rgba(0,0,0,.15),0 0 0 1px rgba(35,41,47,.2),0 0 0 3px hsla(0,0%,100%,.5)}.plyr--full-ui.plyr--video input[type=range]:active::-moz-range-thumb{box-shadow:0 1px 1px rgba(0,0,0,.15),0 0 0 1px rgba(35,41,47,.2),0 0 0 3px hsla(0,0%,100%,.5)}.plyr--full-ui.plyr--video input[type=range]:active::-ms-thumb{box-shadow:0 1px 1px rgba(0,0,0,.15),0 0 0 1px rgba(35,41,47,.2),0 0 0 3px hsla(0,0%,100%,.5)}.plyr--full-ui.plyr--audio input[type=range]::-webkit-slider-runnable-track{background-color:rgba(193,201,209,.66)}.plyr--full-ui.plyr--audio input[type=range]::-moz-range-track{background-color:rgba(193,201,209,.66)}.plyr--full-ui.plyr--audio input[type=range]::-ms-track{background-color:rgba(193,201,209,.66)}.plyr--full-ui.plyr--audio input[type=range]:active::-webkit-slider-thumb{box-shadow:0 1px 1px rgba(0,0,0,.15),0 0 0 1px rgba(35,41,47,.2),0 0 0 3px rgba(0,0,0,.1)}.plyr--full-ui.plyr--audio input[type=range]:active::-moz-range-thumb{box-shadow:0 1px 1px rgba(0,0,0,.15),0 0 0 1px rgba(35,41,47,.2),0 0 0 3px rgba(0,0,0,.1)}.plyr--full-ui.plyr--audio input[type=range]:active::-ms-thumb{box-shadow:0 1px 1px rgba(0,0,0,.15),0 0 0 1px rgba(35,41,47,.2),0 0 0 3px rgba(0,0,0,.1)}.plyr__poster{background-color:#000;background-position:50% 50%;background-repeat:no-repeat;background-size:contain;height:100%;left:0;opacity:0;position:absolute;top:0;transition:opacity .2s ease;width:100%;z-index:1}.plyr--stopped.plyr__poster-enabled .plyr__poster{opacity:1}.plyr__time{font-size:14px}.plyr__time+.plyr__time:before{content:\"\\2044\";margin-right:10px}@media (max-width:767px){.plyr__time+.plyr__time{display:none}}.plyr--video .plyr__time{text-shadow:0 1px 1px rgba(0,0,0,.15)}.plyr__tooltip{background:hsla(0,0%,100%,.9);border-radius:3px;bottom:100%;box-shadow:0 1px 2px rgba(0,0,0,.15);color:#4a5764;font-size:14px;font-weight:500;left:50%;line-height:1.3;margin-bottom:10px;opacity:0;padding:5px 7.5px;pointer-events:none;position:absolute;transform:translate(-50%,10px) scale(.8);transform-origin:50% 100%;transition:transform .2s ease .1s,opacity .2s ease .1s;white-space:nowrap;z-index:2}.plyr__tooltip:before{border-left:4px solid transparent;border-right:4px solid transparent;border-top:4px solid hsla(0,0%,100%,.9);bottom:-4px;content:\"\";height:0;left:50%;position:absolute;transform:translateX(-50%);width:0;z-index:2}.plyr .plyr__control.plyr__tab-focus .plyr__tooltip,.plyr .plyr__control:hover .plyr__tooltip,.plyr__tooltip--visible{opacity:1;transform:translate(-50%) scale(1)}.plyr .plyr__control:hover .plyr__tooltip{z-index:3}.plyr__controls>.plyr__control:first-child+.plyr__control .plyr__tooltip,.plyr__controls>.plyr__control:first-child .plyr__tooltip{left:0;transform:translateY(10px) scale(.8);transform-origin:0 100%}.plyr__controls>.plyr__control:first-child+.plyr__control .plyr__tooltip:before,.plyr__controls>.plyr__control:first-child .plyr__tooltip:before{left:16px}.plyr__controls>.plyr__control:last-child .plyr__tooltip{left:auto;right:0;transform:translateY(10px) scale(.8);transform-origin:100% 100%}.plyr__controls>.plyr__control:last-child .plyr__tooltip:before{left:auto;right:16px;transform:translateX(50%)}.plyr__controls>.plyr__control:first-child+.plyr__control.plyr__tab-focus .plyr__tooltip,.plyr__controls>.plyr__control:first-child+.plyr__control .plyr__tooltip--visible,.plyr__controls>.plyr__control:first-child+.plyr__control:hover .plyr__tooltip,.plyr__controls>.plyr__control:first-child.plyr__tab-focus .plyr__tooltip,.plyr__controls>.plyr__control:first-child .plyr__tooltip--visible,.plyr__controls>.plyr__control:first-child:hover .plyr__tooltip,.plyr__controls>.plyr__control:last-child.plyr__tab-focus .plyr__tooltip,.plyr__controls>.plyr__control:last-child .plyr__tooltip--visible,.plyr__controls>.plyr__control:last-child:hover .plyr__tooltip{transform:translate(0) scale(1)}.plyr--video{background:#000;overflow:hidden}.plyr--video.plyr--menu-open{overflow:visible}.plyr__video-wrapper{background:#000;border-radius:inherit;overflow:hidden;position:relative;z-index:0}.plyr__video-embed,.plyr__video-wrapper--fixed-ratio{height:0;padding-bottom:56.25%}.plyr__video-embed iframe,.plyr__video-wrapper--fixed-ratio video{border:0;height:100%;left:0;position:absolute;top:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%}.plyr--full-ui .plyr__video-embed>.plyr__video-embed__container{padding-bottom:240%;position:relative;transform:translateY(-38.28125%)}.plyr__progress{left:6.5px;margin-right:13px;position:relative}.plyr__progress__buffer,.plyr__progress input[type=range]{margin-left:-6.5px;margin-right:-6.5px;width:calc(100% + 13px)}.plyr__progress input[type=range]{position:relative;z-index:2}.plyr__progress .plyr__tooltip{font-size:14px;left:0}.plyr__progress__buffer{-webkit-appearance:none;background:0 0;border:0;border-radius:100px;height:5px;left:0;margin-top:-2.5px;padding:0;position:absolute;top:50%}.plyr__progress__buffer::-webkit-progress-bar{background:0 0}.plyr__progress__buffer::-webkit-progress-value{background:currentColor;border-radius:100px;min-width:5px;transition:width .2s ease}.plyr__progress__buffer::-moz-progress-bar{background:currentColor;border-radius:100px;min-width:5px;transition:width .2s ease}.plyr__progress__buffer::-ms-fill{border-radius:100px;transition:width .2s ease}.plyr--video .plyr__progress__buffer{box-shadow:0 1px 1px rgba(0,0,0,.15);color:hsla(0,0%,100%,.25)}.plyr--audio .plyr__progress__buffer{color:rgba(193,201,209,.66)}.plyr--loading .plyr__progress__buffer{animation:plyr-progress 1s linear infinite;background-image:linear-gradient(-45deg,rgba(35,41,47,.6) 25%,transparent 0,transparent 50%,rgba(35,41,47,.6) 0,rgba(35,41,47,.6) 75%,transparent 0,transparent);background-repeat:repeat-x;background-size:25px 25px;color:transparent}.plyr--video.plyr--loading .plyr__progress__buffer{background-color:hsla(0,0%,100%,.25)}.plyr--audio.plyr--loading .plyr__progress__buffer{background-color:rgba(193,201,209,.66)}.plyr__volume{align-items:center;display:flex;flex:1;position:relative}.plyr__volume input[type=range]{margin-left:5px;position:relative;z-index:2}@media (min-width:480px){.plyr__volume{max-width:90px}}@media (min-width:768px){.plyr__volume{max-width:110px}}.plyr--is-ios.plyr--vimeo [data-plyr=mute],.plyr--is-ios .plyr__volume{display:none!important}.plyr:fullscreen{background:#000;border-radius:0!important;height:100%;margin:0;width:100%}.plyr:fullscreen video{height:100%}.plyr:fullscreen .plyr__video-wrapper{height:100%;position:static}.plyr:fullscreen.plyr--vimeo .plyr__video-wrapper{height:0;position:relative;top:50%;transform:translateY(-50%)}.plyr:fullscreen .plyr__control .icon--exit-fullscreen{display:block}.plyr:fullscreen .plyr__control .icon--exit-fullscreen+svg{display:none}.plyr:fullscreen.plyr--hide-controls{cursor:none}@media (min-width:1024px){.plyr:-webkit-full-screen .plyr__captions{font-size:21px}.plyr:-ms-fullscreen .plyr__captions{font-size:21px}.plyr:fullscreen .plyr__captions{font-size:21px}}.plyr:-webkit-full-screen{background:#000;border-radius:0!important;height:100%;margin:0;width:100%}.plyr:-webkit-full-screen video{height:100%}.plyr:-webkit-full-screen .plyr__video-wrapper{height:100%;position:static}.plyr:-webkit-full-screen.plyr--vimeo .plyr__video-wrapper{height:0;position:relative;top:50%;transform:translateY(-50%)}.plyr:-webkit-full-screen .plyr__control .icon--exit-fullscreen{display:block}.plyr:-webkit-full-screen .plyr__control .icon--exit-fullscreen+svg{display:none}.plyr:-webkit-full-screen.plyr--hide-controls{cursor:none}@media (min-width:1024px){.plyr:-webkit-full-screen .plyr__captions{font-size:21px}}.plyr:-moz-full-screen{background:#000;border-radius:0!important;height:100%;margin:0;width:100%}.plyr:-moz-full-screen video{height:100%}.plyr:-moz-full-screen .plyr__video-wrapper{height:100%;position:static}.plyr:-moz-full-screen.plyr--vimeo .plyr__video-wrapper{height:0;position:relative;top:50%;transform:translateY(-50%)}.plyr:-moz-full-screen .plyr__control .icon--exit-fullscreen{display:block}.plyr:-moz-full-screen .plyr__control .icon--exit-fullscreen+svg{display:none}.plyr:-moz-full-screen.plyr--hide-controls{cursor:none}@media (min-width:1024px){.plyr:-moz-full-screen .plyr__captions{font-size:21px}}.plyr:-ms-fullscreen{background:#000;border-radius:0!important;height:100%;margin:0;width:100%}.plyr:-ms-fullscreen video{height:100%}.plyr:-ms-fullscreen .plyr__video-wrapper{height:100%;position:static}.plyr:-ms-fullscreen.plyr--vimeo .plyr__video-wrapper{height:0;position:relative;top:50%;transform:translateY(-50%)}.plyr:-ms-fullscreen .plyr__control .icon--exit-fullscreen{display:block}.plyr:-ms-fullscreen .plyr__control .icon--exit-fullscreen+svg{display:none}.plyr:-ms-fullscreen.plyr--hide-controls{cursor:none}@media (min-width:1024px){.plyr:-ms-fullscreen .plyr__captions{font-size:21px}}.plyr--fullscreen-fallback{background:#000;border-radius:0!important;height:100%;margin:0;width:100%;bottom:0;left:0;position:fixed;right:0;top:0;z-index:10000000}.plyr--fullscreen-fallback video{height:100%}.plyr--fullscreen-fallback .plyr__video-wrapper{height:100%;position:static}.plyr--fullscreen-fallback.plyr--vimeo .plyr__video-wrapper{height:0;position:relative;top:50%;transform:translateY(-50%)}.plyr--fullscreen-fallback .plyr__control .icon--exit-fullscreen{display:block}.plyr--fullscreen-fallback .plyr__control .icon--exit-fullscreen+svg{display:none}.plyr--fullscreen-fallback.plyr--hide-controls{cursor:none}@media (min-width:1024px){.plyr--fullscreen-fallback .plyr__captions{font-size:21px}}.plyr__ads{border-radius:inherit;bottom:0;cursor:pointer;left:0;overflow:hidden;position:absolute;right:0;top:0;z-index:-1}.plyr__ads>div,.plyr__ads>div iframe{height:100%;position:absolute;width:100%}.plyr__ads:after{background:rgba(35,41,47,.8);border-radius:2px;bottom:10px;color:#fff;content:attr(data-badge-text);font-size:11px;padding:2px 6px;pointer-events:none;position:absolute;right:10px;z-index:3}.plyr__ads:after:empty{display:none}.plyr__cues{background:currentColor;display:block;height:5px;left:0;margin:-2.5px 0 0;opacity:.8;position:absolute;top:50%;width:3px;z-index:3}.plyr__preview-thumb{background-color:hsla(0,0%,100%,.9);border-radius:3px;bottom:100%;box-shadow:0 1px 2px rgba(0,0,0,.15);margin-bottom:10px;opacity:0;padding:3px;pointer-events:none;position:absolute;transform:translateY(10px) scale(.8);transform-origin:50% 100%;transition:transform .2s ease .1s,opacity .2s ease .1s;z-index:2}.plyr__preview-thumb--is-shown{opacity:1;transform:translate(0) scale(1)}.plyr__preview-thumb:before{border-left:4px solid transparent;border-right:4px solid transparent;border-top:4px solid hsla(0,0%,100%,.9);bottom:-4px;content:\"\";height:0;left:50%;position:absolute;transform:translateX(-50%);width:0;z-index:2}.plyr__preview-thumb__image-container{background:#c1c9d1;border-radius:2px;overflow:hidden;position:relative;z-index:0}.plyr__preview-thumb__image-container img{height:100%;left:0;max-height:none;max-width:none;position:absolute;top:0;width:100%}.plyr__preview-thumb__time-container{bottom:6px;left:0;position:absolute;right:0;white-space:nowrap;z-index:3}.plyr__preview-thumb__time-container span{background-color:rgba(0,0,0,.55);border-radius:2px;color:#fff;font-size:14px;padding:3px 6px}.plyr__preview-scrubbing{bottom:0;filter:blur(1px);height:100%;left:0;margin:auto;opacity:0;overflow:hidden;position:absolute;right:0;top:0;transition:opacity .3s ease;width:100%;z-index:1}.plyr__preview-scrubbing--is-shown{opacity:1}.plyr__preview-scrubbing img{height:100%;left:0;max-height:none;max-width:none;object-fit:contain;position:absolute;top:0;width:100%}.plyr--no-transition{transition:none!important}.plyr__sr-only{clip:rect(1px,1px,1px,1px);overflow:hidden;border:0!important;height:1px!important;padding:0!important;position:absolute!important;width:1px!important}.plyr [hidden]{display:none!important}", "", {"version":3,"sources":["/workspace/node_modules/plyr/dist/plyr.css"],"names":[],"mappings":"AAAA,yBAAyB,GAAG,0BAA0B,CAAC,CAAC,sBAAsB,GAAG,WAAW,0BAA0B,CAAC,GAAG,UAAU,uBAAuB,CAAC,CAAC,wBAAwB,GAAK,SAAS,CAAC,GAAG,SAAS,CAAC,CAAC,MAAM,6BAA6B,4CAA4C,cAAc,kFAAwF,kCAAkC,gBAAgB,gBAAgB,eAAe,gBAAgB,kBAAkB,iBAAiB,8BAA8B,CAAC,wBAAwB,sBAAsB,YAAY,sBAAsB,UAAU,CAAC,aAAa,aAAa,oBAAoB,UAAU,CAAC,YAAY,SAAS,CAAC,eAAe,qBAAqB,CAAC,8DAAgE,kBAAkB,CAAC,iFAAiF,yBAAyB,CAAC,aAAa,mBAAmB,kBAAkB,WAAW,cAAc,cAAc,eAAe,CAAC,oDAAoD,YAAY,CAAC,gBAAgB,gCAAgC,SAAS,WAAW,aAAa,eAAe,OAAO,aAAa,kBAAkB,kBAAkB,qCAAqC,UAAU,CAAC,+BAA+B,0BAA0B,kBAAkB,mCAAmC,2BAA2B,iBAAiB,kBAAkB,oBAAoB,CAAC,mCAAmC,cAAc,CAAC,2BAA2B,YAAY,CAAC,yBAAyB,gBAAgB,eAAe,YAAY,CAAC,CAAC,yBAAyB,gBAAgB,cAAc,CAAC,CAAC,uCAAuC,aAAa,CAAC,4EAA4E,2BAA2B,CAAC,eAAe,eAAe,SAAS,kBAAkB,cAAc,eAAe,cAAc,iBAAiB,YAAY,kBAAkB,uBAAuB,CAAC,mBAAmB,cAAc,kBAAkB,YAAY,oBAAoB,UAAU,CAAC,qBAAqB,SAAS,CAAC,+BAA+B,wCAAwC,SAAS,CAAC,gBAAgB,oBAAoB,CAAC,AAA4D,uRAA0O,YAAY,CAAC,AAA4J,4PAA8H,mBAAmB,UAAU,CAAC,yBAAyB,8BAA8B,SAAS,mBAAmB,WAAW,aAAa,SAAS,aAAa,kBAAkB,QAAQ,+BAA+B,SAAS,CAAC,6BAA6B,SAAS,iBAAiB,CAAC,8DAA8D,kBAAkB,CAAC,wCAAwC,UAAU,iBAAiB,CAAC,oDAAoD,aAAa,CAAC,wCAAwC,YAAY,CAAC,gBAAgB,mBAAmB,aAAa,yBAAyB,iBAAiB,CAAC,2CAA2C,OAAO,WAAW,CAAC,sCAAsC,iBAAiB,CAAC,kDAAkD,cAAc,iBAAiB,CAAC,gEAAgE,kBAAkB,CAAC,iDAAiD,aAAa,CAAC,sMAAsM,cAAc,CAAC,mDAAmD,iBAAiB,CAAC,+DAA+D,eAAe,CAAC,sBAAsB,YAAY,CAAC,6BAA6B,gBAAgB,sBAAsB,cAAc,YAAY,CAAC,6BAA6B,uDAAyD,kCAAkC,mCAAmC,SAAS,WAAW,OAAO,qBAAqB,kBAAkB,QAAQ,6DAA6D,SAAS,CAAC,yBAAyB,6BAA6B,sBAAsB,CAAC,CAAC,iDAAiD,UAAU,oBAAoB,0BAA0B,CAAC,wGAAwG,YAAY,CAAC,gLAAgL,oBAAoB,CAAC,YAAY,aAAa,iBAAiB,CAAC,+BAA+B,6BAA6B,CAAC,mDAAmD,uBAAuB,CAAC,8DAA8D,YAAY,CAAC,uBAAuB,8BAA8B,8BAAgC,kBAAkB,YAAY,qCAAqC,cAAc,eAAe,mBAAmB,kBAAkB,WAAW,gBAAgB,mBAAmB,SAAS,CAAC,2BAA2B,gBAAgB,iFAAiF,CAAC,6BAA8B,6BAA6B,oCAAsC,WAAW,SAAS,kBAAkB,WAAW,SAAS,OAAO,CAAC,mCAAmC,WAAW,CAAC,mFAAmF,cAAc,CAAC,2GAA2G,YAAY,CAAC,sCAAsC,mBAAmB,cAAc,aAAa,eAAe,iBAAiB,yBAAyB,sBAAsB,qBAAqB,iBAAiB,UAAU,CAAC,2CAA2C,oBAAoB,aAAa,UAAU,CAAC,4CAA6C,6BAA6B,WAAW,kBAAkB,QAAQ,0BAA0B,CAAC,+CAA+C,kBAAkB,CAAC,qDAAsD,qCAAqC,SAAS,CAAC,gIAAkI,8BAA8B,CAAC,4CAA4C,gBAAgB,WAAW,kBAAkB,kBAAkB,kBAAkB,uBAAuB,CAAC,kDAAmD,sCAAsC,QAAQ,CAAC,mDAAoD,mBAAmB,wBAAwB,WAAW,WAAW,OAAO,eAAe,gBAAgB,kBAAkB,QAAQ,QAAQ,CAAC,0HAA4H,+BAA+B,CAAC,0DAA0D,gBAAgB,CAAC,iIAAmI,kBAAkB,CAAC,iEAAkE,0BAA0B,WAAW,cAAc,cAAc,YAAY,kBAAkB,wBAAwB,UAAU,CAAC,gEAAiE,gBAAgB,SAAS,WAAW,UAAU,UAAU,QAAQ,oCAAoC,+CAA+C,SAAS,CAAC,oFAAqF,kBAAkB,CAAC,mFAAoF,UAAU,mCAAmC,CAAC,wJAA0J,yBAAyB,CAAC,0CAA0C,mBAAmB,aAAa,iBAAiB,kBAAkB,gBAAgB,kBAAkB,mBAAmB,CAAC,iCAAiC,wBAAwB,eAAe,SAAS,mBAAmB,cAAc,cAAc,YAAY,SAAS,UAAU,+BAA+B,UAAU,CAAC,gEAAgE,eAAe,SAAS,oBAAoB,WAAW,+BAA+B,yBAAyB,iBAAiB,8FAAiG,CAAC,uDAAuD,gBAAgB,SAAS,mBAAmB,iEAAiE,YAAY,kBAAkB,wBAAwB,WAAW,wBAAwB,eAAe,CAAC,mDAAmD,eAAe,SAAS,oBAAoB,WAAW,+BAA+B,sBAAsB,gBAAgB,CAAC,mDAAmD,gBAAgB,SAAS,mBAAmB,iEAAiE,YAAY,kBAAkB,wBAAwB,UAAU,CAAC,sDAAsD,wBAAwB,oBAAoB,UAAU,CAAC,4CAAwK,iBAAiB,CAAC,6FAA9I,eAAe,SAAS,oBAAoB,WAAW,+BAA+B,qBAAqB,gBAAiB,CAA+L,iDAAiD,eAAe,SAAS,oBAAoB,WAAW,+BAA+B,qBAAqB,iBAAiB,uBAAuB,CAAC,4CAA4C,gBAAgB,SAAS,mBAAmB,iEAAiE,YAAY,kBAAkB,wBAAwB,WAAW,YAAY,CAAC,8CAA8C,YAAY,CAAC,uCAAuC,SAAS,CAAC,mDAAmD,QAAQ,CAAC,gFAAgF,wCAAwC,SAAS,CAAC,mEAAmE,wCAAwC,SAAS,CAAC,4DAA4D,wCAAwC,SAAS,CAAC,4EAA4E,oCAAsC,CAAC,+DAA+D,oCAAsC,CAAC,wDAAwD,oCAAsC,CAAC,0EAA0E,6FAA+F,CAAC,sEAAsE,6FAA+F,CAAC,+DAA+D,6FAA+F,CAAC,4EAA4E,sCAAsC,CAAC,+DAA+D,sCAAsC,CAAC,wDAAwD,sCAAsC,CAAC,0EAA0E,yFAAyF,CAAC,sEAAsE,yFAAyF,CAAC,+DAA+D,yFAAyF,CAAC,cAAc,sBAAsB,4BAA4B,4BAA4B,wBAAwB,YAAY,OAAO,UAAU,kBAAkB,MAAM,4BAA4B,WAAW,SAAS,CAAC,kDAAkD,SAAS,CAAC,YAAY,cAAc,CAAC,+BAAgC,gBAAgB,iBAAiB,CAAC,yBAAyB,wBAAwB,YAAY,CAAC,CAAC,yBAAyB,qCAAqC,CAAC,eAAe,8BAAgC,kBAAkB,YAAY,qCAAqC,cAAc,eAAe,gBAAgB,SAAS,gBAAgB,mBAAmB,UAAU,kBAAkB,oBAAoB,kBAAkB,yCAAyC,0BAA0B,uDAAuD,mBAAmB,SAAS,CAAC,sBAAuB,kCAAkC,mCAAmC,wCAA0C,YAAY,WAAW,SAAS,SAAS,kBAAkB,2BAA2B,QAAQ,SAAS,CAAC,sHAAsH,UAAU,kCAAoC,CAAC,0CAA0C,SAAS,CAAC,mIAAmI,OAAO,qCAAsC,uBAAuB,CAAC,iJAAmJ,SAAS,CAAC,yDAAyD,UAAU,QAAQ,qCAAsC,0BAA0B,CAAC,gEAAiE,UAAU,WAAW,yBAAyB,CAAC,ipBAAipB,+BAAiC,CAAC,aAAa,gBAAgB,eAAe,CAAC,6BAA6B,gBAAgB,CAAC,qBAAqB,gBAAgB,sBAAsB,gBAAgB,kBAAkB,SAAS,CAAC,qDAAqD,SAAS,qBAAqB,CAAC,kEAAkE,SAAS,YAAY,OAAO,kBAAkB,MAAM,yBAAyB,sBAAsB,qBAAqB,iBAAiB,UAAU,CAAC,gEAAgE,oBAAoB,kBAAkB,gCAAgC,CAAC,gBAAgB,WAAW,kBAAkB,iBAAiB,CAAC,0DAA0D,mBAAmB,oBAAoB,uBAAuB,CAAC,kCAAkC,kBAAkB,SAAS,CAAC,+BAA+B,eAAe,MAAM,CAAC,wBAAwB,wBAAwB,eAAe,SAAS,oBAAoB,WAAW,OAAO,kBAAkB,UAAU,kBAAkB,OAAO,CAAC,8CAA8C,cAAc,CAAC,gDAAgD,wBAAwB,oBAAoB,cAAc,yBAAyB,CAAC,2CAA2C,wBAAwB,oBAAoB,cAAc,yBAAyB,CAAC,kCAAkC,oBAAoB,yBAAyB,CAAC,qCAAqC,qCAAqC,yBAA2B,CAAC,qCAAqC,2BAA2B,CAAC,uCAAuC,2CAA2C,iKAAuK,2BAA2B,0BAA0B,iBAAiB,CAAC,mDAAmD,oCAAsC,CAAC,mDAAmD,sCAAsC,CAAC,cAAc,mBAAmB,aAAa,OAAO,iBAAiB,CAAC,gCAAgC,gBAAgB,kBAAkB,SAAS,CAAC,yBAAyB,cAAc,cAAc,CAAC,CAAC,yBAAyB,cAAc,eAAe,CAAC,CAAC,AAAmD,uEAA2C,sBAAsB,CAAC,AAAmM,iBAAiB,gBAAgB,0BAA0B,YAAY,SAAS,UAAU,CAAC,AAAmF,uBAAuB,WAAW,CAAC,AAAiJ,sCAAsC,YAAY,eAAe,CAAC,AAA6O,kDAAkD,SAAS,kBAAkB,QAAQ,0BAA0B,CAAC,AAAuJ,uDAAuD,aAAa,CAAC,AAA6J,2DAA2D,YAAY,CAAC,AAA+G,qCAAqC,WAAW,CAAC,0BAA0B,0CAA0C,cAAc,CAAC,qCAAqC,cAAc,CAAC,iCAAiC,cAAc,CAAC,CAAC,0BAA0B,gBAAgB,0BAA0B,YAAY,SAAS,UAAU,CAAC,gCAAgC,WAAW,CAAC,+CAA+C,YAAY,eAAe,CAAC,2DAA2D,SAAS,kBAAkB,QAAQ,0BAA0B,CAAC,gEAAgE,aAAa,CAAC,oEAAoE,YAAY,CAAC,8CAA8C,WAAW,CAAC,0BAA0B,0CAA0C,cAAc,CAAC,CAAC,uBAAuB,gBAAgB,0BAA0B,YAAY,SAAS,UAAU,CAAC,6BAA6B,WAAW,CAAC,4CAA4C,YAAY,eAAe,CAAC,wDAAwD,SAAS,kBAAkB,QAAQ,0BAA0B,CAAC,6DAA6D,aAAa,CAAC,iEAAiE,YAAY,CAAC,2CAA2C,WAAW,CAAC,0BAA0B,uCAAuC,cAAc,CAAC,CAAC,qBAAqB,gBAAgB,0BAA0B,YAAY,SAAS,UAAU,CAAC,2BAA2B,WAAW,CAAC,0CAA0C,YAAY,eAAe,CAAC,sDAAsD,SAAS,kBAAkB,QAAQ,0BAA0B,CAAC,2DAA2D,aAAa,CAAC,+DAA+D,YAAY,CAAC,yCAAyC,WAAW,CAAC,0BAA0B,qCAAqC,cAAc,CAAC,CAAC,2BAA2B,gBAAgB,0BAA0B,YAAY,SAAS,WAAW,SAAS,OAAO,eAAe,QAAQ,MAAM,gBAAgB,CAAC,iCAAiC,WAAW,CAAC,gDAAgD,YAAY,eAAe,CAAC,4DAA4D,SAAS,kBAAkB,QAAQ,0BAA0B,CAAC,iEAAiE,aAAa,CAAC,qEAAqE,YAAY,CAAC,+CAA+C,WAAW,CAAC,0BAA0B,2CAA2C,cAAc,CAAC,CAAC,WAAW,sBAAsB,SAAS,eAAe,OAAO,gBAAgB,kBAAkB,QAAQ,MAAM,UAAU,CAAC,qCAAqC,YAAY,kBAAkB,UAAU,CAAC,iBAAkB,6BAA6B,kBAAkB,YAAY,WAAW,8BAA8B,eAAe,gBAAgB,oBAAoB,kBAAkB,WAAW,SAAS,CAAC,uBAAwB,YAAY,CAAC,YAAY,wBAAwB,cAAc,WAAW,OAAO,kBAAkB,WAAW,kBAAkB,QAAQ,UAAU,SAAS,CAAC,qBAAqB,oCAAsC,kBAAkB,YAAY,qCAAqC,mBAAmB,UAAU,YAAY,oBAAoB,kBAAkB,qCAAsC,0BAA0B,uDAAuD,SAAS,CAAC,+BAA+B,UAAU,+BAAiC,CAAC,4BAA6B,kCAAkC,mCAAmC,wCAA0C,YAAY,WAAW,SAAS,SAAS,kBAAkB,2BAA2B,QAAQ,SAAS,CAAC,sCAAsC,mBAAmB,kBAAkB,gBAAgB,kBAAkB,SAAS,CAAC,0CAA0C,YAAY,OAAO,gBAAgB,eAAe,kBAAkB,MAAM,UAAU,CAAC,qCAAqC,WAAW,OAAO,kBAAkB,QAAQ,mBAAmB,SAAS,CAAC,0CAA0C,iCAAiC,kBAAkB,WAAW,eAAe,eAAe,CAAC,yBAAyB,SAAS,iBAAiB,YAAY,OAAO,YAAY,UAAU,gBAAgB,kBAAkB,QAAQ,MAAM,4BAA4B,WAAW,SAAS,CAAC,mCAAmC,SAAS,CAAC,6BAA6B,YAAY,OAAO,gBAAgB,eAAe,mBAAmB,kBAAkB,MAAM,UAAU,CAAC,qBAAqB,yBAAyB,CAAC,eAAe,2BAA2B,gBAAgB,mBAAmB,qBAAqB,oBAAoB,4BAA4B,mBAAmB,CAAC,eAAe,sBAAsB,CAAC","file":"plyr.css","sourcesContent":["@keyframes plyr-progress{to{background-position:25px 0}}@keyframes plyr-popup{0%{opacity:.5;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}@keyframes plyr-fade-in{from{opacity:0}to{opacity:1}}.plyr{-moz-osx-font-smoothing:auto;-webkit-font-smoothing:subpixel-antialiased;direction:ltr;font-family:Avenir,\"Avenir Next\",\"Helvetica Neue\",\"Segoe UI\",Helvetica,Arial,sans-serif;font-variant-numeric:tabular-nums;font-weight:500;line-height:1.7;max-width:100%;min-width:200px;position:relative;text-shadow:none;transition:box-shadow .3s ease}.plyr audio,.plyr video{border-radius:inherit;height:auto;vertical-align:middle;width:100%}.plyr button{font:inherit;line-height:inherit;width:auto}.plyr:focus{outline:0}.plyr--full-ui{box-sizing:border-box}.plyr--full-ui *,.plyr--full-ui ::after,.plyr--full-ui ::before{box-sizing:inherit}.plyr--full-ui a,.plyr--full-ui button,.plyr--full-ui input,.plyr--full-ui label{touch-action:manipulation}.plyr__badge{background:#4a5764;border-radius:2px;color:#fff;font-size:9px;line-height:1;padding:3px 4px}.plyr--full-ui ::-webkit-media-text-track-container{display:none}.plyr__captions{animation:plyr-fade-in .3s ease;bottom:0;color:#fff;display:none;font-size:14px;left:0;padding:10px;position:absolute;text-align:center;transition:transform .4s ease-in-out;width:100%}.plyr__captions .plyr__caption{background:rgba(0,0,0,.8);border-radius:2px;-webkit-box-decoration-break:clone;box-decoration-break:clone;line-height:185%;padding:.2em .5em;white-space:pre-wrap}.plyr__captions .plyr__caption div{display:inline}.plyr__captions span:empty{display:none}@media (min-width:480px){.plyr__captions{font-size:16px;padding:20px}}@media (min-width:768px){.plyr__captions{font-size:18px}}.plyr--captions-active .plyr__captions{display:block}.plyr:not(.plyr--hide-controls) .plyr__controls:not(:empty)~.plyr__captions{transform:translateY(-40px)}.plyr__control{background:0 0;border:0;border-radius:3px;color:inherit;cursor:pointer;flex-shrink:0;overflow:visible;padding:7px;position:relative;transition:all .3s ease}.plyr__control svg{display:block;fill:currentColor;height:18px;pointer-events:none;width:18px}.plyr__control:focus{outline:0}.plyr__control.plyr__tab-focus{box-shadow:0 0 0 5px rgba(0,179,255,.5);outline:0}a.plyr__control{text-decoration:none}a.plyr__control::after,a.plyr__control::before{display:none}.plyr__control.plyr__control--pressed .icon--not-pressed,.plyr__control.plyr__control--pressed .label--not-pressed,.plyr__control:not(.plyr__control--pressed) .icon--pressed,.plyr__control:not(.plyr__control--pressed) .label--pressed{display:none}.plyr--audio .plyr__control.plyr__tab-focus,.plyr--audio .plyr__control:hover,.plyr--audio .plyr__control[aria-expanded=true]{background:#00b3ff;color:#fff}.plyr--video .plyr__control.plyr__tab-focus,.plyr--video .plyr__control:hover,.plyr--video .plyr__control[aria-expanded=true]{background:#00b3ff;color:#fff}.plyr__control--overlaid{background:rgba(0,179,255,.8);border:0;border-radius:100%;color:#fff;display:none;left:50%;padding:15px;position:absolute;top:50%;transform:translate(-50%,-50%);z-index:2}.plyr__control--overlaid svg{left:2px;position:relative}.plyr__control--overlaid:focus,.plyr__control--overlaid:hover{background:#00b3ff}.plyr--playing .plyr__control--overlaid{opacity:0;visibility:hidden}.plyr--full-ui.plyr--video .plyr__control--overlaid{display:block}.plyr--full-ui ::-webkit-media-controls{display:none}.plyr__controls{align-items:center;display:flex;justify-content:flex-end;text-align:center}.plyr__controls .plyr__progress__container{flex:1;min-width:0}.plyr__controls .plyr__controls__item{margin-left:2.5px}.plyr__controls .plyr__controls__item:first-child{margin-left:0;margin-right:auto}.plyr__controls .plyr__controls__item.plyr__progress__container{padding-left:2.5px}.plyr__controls .plyr__controls__item.plyr__time{padding:0 5px}.plyr__controls .plyr__controls__item.plyr__progress__container:first-child,.plyr__controls .plyr__controls__item.plyr__time+.plyr__time,.plyr__controls .plyr__controls__item.plyr__time:first-child{padding-left:0}.plyr__controls .plyr__controls__item.plyr__volume{padding-right:5px}.plyr__controls .plyr__controls__item.plyr__volume:first-child{padding-right:0}.plyr__controls:empty{display:none}.plyr--audio .plyr__controls{background:#fff;border-radius:inherit;color:#4a5764;padding:10px}.plyr--video .plyr__controls{background:linear-gradient(rgba(0,0,0,0),rgba(0,0,0,.7));border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;bottom:0;color:#fff;left:0;padding:20px 5px 5px;position:absolute;right:0;transition:opacity .4s ease-in-out,transform .4s ease-in-out;z-index:3}@media (min-width:480px){.plyr--video .plyr__controls{padding:35px 10px 10px}}.plyr--video.plyr--hide-controls .plyr__controls{opacity:0;pointer-events:none;transform:translateY(100%)}.plyr [data-plyr=airplay],.plyr [data-plyr=captions],.plyr [data-plyr=fullscreen],.plyr [data-plyr=pip]{display:none}.plyr--airplay-supported [data-plyr=airplay],.plyr--captions-enabled [data-plyr=captions],.plyr--fullscreen-enabled [data-plyr=fullscreen],.plyr--pip-supported [data-plyr=pip]{display:inline-block}.plyr__menu{display:flex;position:relative}.plyr__menu .plyr__control svg{transition:transform .3s ease}.plyr__menu .plyr__control[aria-expanded=true] svg{transform:rotate(90deg)}.plyr__menu .plyr__control[aria-expanded=true] .plyr__tooltip{display:none}.plyr__menu__container{animation:plyr-popup .2s ease;background:rgba(255,255,255,.9);border-radius:4px;bottom:100%;box-shadow:0 1px 2px rgba(0,0,0,.15);color:#4a5764;font-size:16px;margin-bottom:10px;position:absolute;right:-3px;text-align:left;white-space:nowrap;z-index:3}.plyr__menu__container>div{overflow:hidden;transition:height .35s cubic-bezier(.4,0,.2,1),width .35s cubic-bezier(.4,0,.2,1)}.plyr__menu__container::after{border:4px solid transparent;border-top-color:rgba(255,255,255,.9);content:'';height:0;position:absolute;right:15px;top:100%;width:0}.plyr__menu__container [role=menu]{padding:7px}.plyr__menu__container [role=menuitem],.plyr__menu__container [role=menuitemradio]{margin-top:2px}.plyr__menu__container [role=menuitem]:first-child,.plyr__menu__container [role=menuitemradio]:first-child{margin-top:0}.plyr__menu__container .plyr__control{align-items:center;color:#4a5764;display:flex;font-size:14px;padding:4px 11px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%}.plyr__menu__container .plyr__control>span{align-items:inherit;display:flex;width:100%}.plyr__menu__container .plyr__control::after{border:4px solid transparent;content:'';position:absolute;top:50%;transform:translateY(-50%)}.plyr__menu__container .plyr__control--forward{padding-right:28px}.plyr__menu__container .plyr__control--forward::after{border-left-color:rgba(74,87,100,.8);right:5px}.plyr__menu__container .plyr__control--forward.plyr__tab-focus::after,.plyr__menu__container .plyr__control--forward:hover::after{border-left-color:currentColor}.plyr__menu__container .plyr__control--back{font-weight:500;margin:7px;margin-bottom:3px;padding-left:28px;position:relative;width:calc(100% - 14px)}.plyr__menu__container .plyr__control--back::after{border-right-color:rgba(74,87,100,.8);left:7px}.plyr__menu__container .plyr__control--back::before{background:#c1c9d1;box-shadow:0 1px 0 #fff;content:'';height:1px;left:0;margin-top:4px;overflow:hidden;position:absolute;right:0;top:100%}.plyr__menu__container .plyr__control--back.plyr__tab-focus::after,.plyr__menu__container .plyr__control--back:hover::after{border-right-color:currentColor}.plyr__menu__container .plyr__control[role=menuitemradio]{padding-left:7px}.plyr__menu__container .plyr__control[role=menuitemradio]::after,.plyr__menu__container .plyr__control[role=menuitemradio]::before{border-radius:100%}.plyr__menu__container .plyr__control[role=menuitemradio]::before{background:rgba(0,0,0,.1);content:'';display:block;flex-shrink:0;height:16px;margin-right:10px;transition:all .3s ease;width:16px}.plyr__menu__container .plyr__control[role=menuitemradio]::after{background:#fff;border:0;height:6px;left:12px;opacity:0;top:50%;transform:translateY(-50%) scale(0);transition:transform .3s ease,opacity .3s ease;width:6px}.plyr__menu__container .plyr__control[role=menuitemradio][aria-checked=true]::before{background:#00b3ff}.plyr__menu__container .plyr__control[role=menuitemradio][aria-checked=true]::after{opacity:1;transform:translateY(-50%) scale(1)}.plyr__menu__container .plyr__control[role=menuitemradio].plyr__tab-focus::before,.plyr__menu__container .plyr__control[role=menuitemradio]:hover::before{background:rgba(0,0,0,.1)}.plyr__menu__container .plyr__menu__value{align-items:center;display:flex;margin-left:auto;margin-right:-5px;overflow:hidden;padding-left:25px;pointer-events:none}.plyr--full-ui input[type=range]{-webkit-appearance:none;background:0 0;border:0;border-radius:26px;color:#00b3ff;display:block;height:19px;margin:0;padding:0;transition:box-shadow .3s ease;width:100%}.plyr--full-ui input[type=range]::-webkit-slider-runnable-track{background:0 0;border:0;border-radius:2.5px;height:5px;transition:box-shadow .3s ease;-webkit-user-select:none;user-select:none;background-image:linear-gradient(to right,currentColor var(--value,0),transparent var(--value,0))}.plyr--full-ui input[type=range]::-webkit-slider-thumb{background:#fff;border:0;border-radius:100%;box-shadow:0 1px 1px rgba(0,0,0,.15),0 0 0 1px rgba(35,41,47,.2);height:13px;position:relative;transition:all .2s ease;width:13px;-webkit-appearance:none;margin-top:-4px}.plyr--full-ui input[type=range]::-moz-range-track{background:0 0;border:0;border-radius:2.5px;height:5px;transition:box-shadow .3s ease;-moz-user-select:none;user-select:none}.plyr--full-ui input[type=range]::-moz-range-thumb{background:#fff;border:0;border-radius:100%;box-shadow:0 1px 1px rgba(0,0,0,.15),0 0 0 1px rgba(35,41,47,.2);height:13px;position:relative;transition:all .2s ease;width:13px}.plyr--full-ui input[type=range]::-moz-range-progress{background:currentColor;border-radius:2.5px;height:5px}.plyr--full-ui input[type=range]::-ms-track{background:0 0;border:0;border-radius:2.5px;height:5px;transition:box-shadow .3s ease;-ms-user-select:none;user-select:none;color:transparent}.plyr--full-ui input[type=range]::-ms-fill-upper{background:0 0;border:0;border-radius:2.5px;height:5px;transition:box-shadow .3s ease;-ms-user-select:none;user-select:none}.plyr--full-ui input[type=range]::-ms-fill-lower{background:0 0;border:0;border-radius:2.5px;height:5px;transition:box-shadow .3s ease;-ms-user-select:none;user-select:none;background:currentColor}.plyr--full-ui input[type=range]::-ms-thumb{background:#fff;border:0;border-radius:100%;box-shadow:0 1px 1px rgba(0,0,0,.15),0 0 0 1px rgba(35,41,47,.2);height:13px;position:relative;transition:all .2s ease;width:13px;margin-top:0}.plyr--full-ui input[type=range]::-ms-tooltip{display:none}.plyr--full-ui input[type=range]:focus{outline:0}.plyr--full-ui input[type=range]::-moz-focus-outer{border:0}.plyr--full-ui input[type=range].plyr__tab-focus::-webkit-slider-runnable-track{box-shadow:0 0 0 5px rgba(0,179,255,.5);outline:0}.plyr--full-ui input[type=range].plyr__tab-focus::-moz-range-track{box-shadow:0 0 0 5px rgba(0,179,255,.5);outline:0}.plyr--full-ui input[type=range].plyr__tab-focus::-ms-track{box-shadow:0 0 0 5px rgba(0,179,255,.5);outline:0}.plyr--full-ui.plyr--video input[type=range]::-webkit-slider-runnable-track{background-color:rgba(255,255,255,.25)}.plyr--full-ui.plyr--video input[type=range]::-moz-range-track{background-color:rgba(255,255,255,.25)}.plyr--full-ui.plyr--video input[type=range]::-ms-track{background-color:rgba(255,255,255,.25)}.plyr--full-ui.plyr--video input[type=range]:active::-webkit-slider-thumb{box-shadow:0 1px 1px rgba(0,0,0,.15),0 0 0 1px rgba(35,41,47,.2),0 0 0 3px rgba(255,255,255,.5)}.plyr--full-ui.plyr--video input[type=range]:active::-moz-range-thumb{box-shadow:0 1px 1px rgba(0,0,0,.15),0 0 0 1px rgba(35,41,47,.2),0 0 0 3px rgba(255,255,255,.5)}.plyr--full-ui.plyr--video input[type=range]:active::-ms-thumb{box-shadow:0 1px 1px rgba(0,0,0,.15),0 0 0 1px rgba(35,41,47,.2),0 0 0 3px rgba(255,255,255,.5)}.plyr--full-ui.plyr--audio input[type=range]::-webkit-slider-runnable-track{background-color:rgba(193,201,209,.66)}.plyr--full-ui.plyr--audio input[type=range]::-moz-range-track{background-color:rgba(193,201,209,.66)}.plyr--full-ui.plyr--audio input[type=range]::-ms-track{background-color:rgba(193,201,209,.66)}.plyr--full-ui.plyr--audio input[type=range]:active::-webkit-slider-thumb{box-shadow:0 1px 1px rgba(0,0,0,.15),0 0 0 1px rgba(35,41,47,.2),0 0 0 3px rgba(0,0,0,.1)}.plyr--full-ui.plyr--audio input[type=range]:active::-moz-range-thumb{box-shadow:0 1px 1px rgba(0,0,0,.15),0 0 0 1px rgba(35,41,47,.2),0 0 0 3px rgba(0,0,0,.1)}.plyr--full-ui.plyr--audio input[type=range]:active::-ms-thumb{box-shadow:0 1px 1px rgba(0,0,0,.15),0 0 0 1px rgba(35,41,47,.2),0 0 0 3px rgba(0,0,0,.1)}.plyr__poster{background-color:#000;background-position:50% 50%;background-repeat:no-repeat;background-size:contain;height:100%;left:0;opacity:0;position:absolute;top:0;transition:opacity .2s ease;width:100%;z-index:1}.plyr--stopped.plyr__poster-enabled .plyr__poster{opacity:1}.plyr__time{font-size:14px}.plyr__time+.plyr__time::before{content:'\\2044';margin-right:10px}@media (max-width:767px){.plyr__time+.plyr__time{display:none}}.plyr--video .plyr__time{text-shadow:0 1px 1px rgba(0,0,0,.15)}.plyr__tooltip{background:rgba(255,255,255,.9);border-radius:3px;bottom:100%;box-shadow:0 1px 2px rgba(0,0,0,.15);color:#4a5764;font-size:14px;font-weight:500;left:50%;line-height:1.3;margin-bottom:10px;opacity:0;padding:5px 7.5px;pointer-events:none;position:absolute;transform:translate(-50%,10px) scale(.8);transform-origin:50% 100%;transition:transform .2s .1s ease,opacity .2s .1s ease;white-space:nowrap;z-index:2}.plyr__tooltip::before{border-left:4px solid transparent;border-right:4px solid transparent;border-top:4px solid rgba(255,255,255,.9);bottom:-4px;content:'';height:0;left:50%;position:absolute;transform:translateX(-50%);width:0;z-index:2}.plyr .plyr__control.plyr__tab-focus .plyr__tooltip,.plyr .plyr__control:hover .plyr__tooltip,.plyr__tooltip--visible{opacity:1;transform:translate(-50%,0) scale(1)}.plyr .plyr__control:hover .plyr__tooltip{z-index:3}.plyr__controls>.plyr__control:first-child .plyr__tooltip,.plyr__controls>.plyr__control:first-child+.plyr__control .plyr__tooltip{left:0;transform:translate(0,10px) scale(.8);transform-origin:0 100%}.plyr__controls>.plyr__control:first-child .plyr__tooltip::before,.plyr__controls>.plyr__control:first-child+.plyr__control .plyr__tooltip::before{left:16px}.plyr__controls>.plyr__control:last-child .plyr__tooltip{left:auto;right:0;transform:translate(0,10px) scale(.8);transform-origin:100% 100%}.plyr__controls>.plyr__control:last-child .plyr__tooltip::before{left:auto;right:16px;transform:translateX(50%)}.plyr__controls>.plyr__control:first-child .plyr__tooltip--visible,.plyr__controls>.plyr__control:first-child+.plyr__control .plyr__tooltip--visible,.plyr__controls>.plyr__control:first-child+.plyr__control.plyr__tab-focus .plyr__tooltip,.plyr__controls>.plyr__control:first-child+.plyr__control:hover .plyr__tooltip,.plyr__controls>.plyr__control:first-child.plyr__tab-focus .plyr__tooltip,.plyr__controls>.plyr__control:first-child:hover .plyr__tooltip,.plyr__controls>.plyr__control:last-child .plyr__tooltip--visible,.plyr__controls>.plyr__control:last-child.plyr__tab-focus .plyr__tooltip,.plyr__controls>.plyr__control:last-child:hover .plyr__tooltip{transform:translate(0,0) scale(1)}.plyr--video{background:#000;overflow:hidden}.plyr--video.plyr--menu-open{overflow:visible}.plyr__video-wrapper{background:#000;border-radius:inherit;overflow:hidden;position:relative;z-index:0}.plyr__video-embed,.plyr__video-wrapper--fixed-ratio{height:0;padding-bottom:56.25%}.plyr__video-embed iframe,.plyr__video-wrapper--fixed-ratio video{border:0;height:100%;left:0;position:absolute;top:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%}.plyr--full-ui .plyr__video-embed>.plyr__video-embed__container{padding-bottom:240%;position:relative;transform:translateY(-38.28125%)}.plyr__progress{left:6.5px;margin-right:13px;position:relative}.plyr__progress input[type=range],.plyr__progress__buffer{margin-left:-6.5px;margin-right:-6.5px;width:calc(100% + 13px)}.plyr__progress input[type=range]{position:relative;z-index:2}.plyr__progress .plyr__tooltip{font-size:14px;left:0}.plyr__progress__buffer{-webkit-appearance:none;background:0 0;border:0;border-radius:100px;height:5px;left:0;margin-top:-2.5px;padding:0;position:absolute;top:50%}.plyr__progress__buffer::-webkit-progress-bar{background:0 0}.plyr__progress__buffer::-webkit-progress-value{background:currentColor;border-radius:100px;min-width:5px;transition:width .2s ease}.plyr__progress__buffer::-moz-progress-bar{background:currentColor;border-radius:100px;min-width:5px;transition:width .2s ease}.plyr__progress__buffer::-ms-fill{border-radius:100px;transition:width .2s ease}.plyr--video .plyr__progress__buffer{box-shadow:0 1px 1px rgba(0,0,0,.15);color:rgba(255,255,255,.25)}.plyr--audio .plyr__progress__buffer{color:rgba(193,201,209,.66)}.plyr--loading .plyr__progress__buffer{animation:plyr-progress 1s linear infinite;background-image:linear-gradient(-45deg,rgba(35,41,47,.6) 25%,transparent 25%,transparent 50%,rgba(35,41,47,.6) 50%,rgba(35,41,47,.6) 75%,transparent 75%,transparent);background-repeat:repeat-x;background-size:25px 25px;color:transparent}.plyr--video.plyr--loading .plyr__progress__buffer{background-color:rgba(255,255,255,.25)}.plyr--audio.plyr--loading .plyr__progress__buffer{background-color:rgba(193,201,209,.66)}.plyr__volume{align-items:center;display:flex;flex:1;position:relative}.plyr__volume input[type=range]{margin-left:5px;position:relative;z-index:2}@media (min-width:480px){.plyr__volume{max-width:90px}}@media (min-width:768px){.plyr__volume{max-width:110px}}.plyr--is-ios .plyr__volume{display:none!important}.plyr--is-ios.plyr--vimeo [data-plyr=mute]{display:none!important}.plyr:-webkit-full-screen{background:#000;border-radius:0!important;height:100%;margin:0;width:100%}.plyr:-ms-fullscreen{background:#000;border-radius:0!important;height:100%;margin:0;width:100%}.plyr:fullscreen{background:#000;border-radius:0!important;height:100%;margin:0;width:100%}.plyr:-webkit-full-screen video{height:100%}.plyr:-ms-fullscreen video{height:100%}.plyr:fullscreen video{height:100%}.plyr:-webkit-full-screen .plyr__video-wrapper{height:100%;position:static}.plyr:-ms-fullscreen .plyr__video-wrapper{height:100%;position:static}.plyr:fullscreen .plyr__video-wrapper{height:100%;position:static}.plyr:-webkit-full-screen.plyr--vimeo .plyr__video-wrapper{height:0;position:relative;top:50%;transform:translateY(-50%)}.plyr:-ms-fullscreen.plyr--vimeo .plyr__video-wrapper{height:0;position:relative;top:50%;transform:translateY(-50%)}.plyr:fullscreen.plyr--vimeo .plyr__video-wrapper{height:0;position:relative;top:50%;transform:translateY(-50%)}.plyr:-webkit-full-screen .plyr__control .icon--exit-fullscreen{display:block}.plyr:-ms-fullscreen .plyr__control .icon--exit-fullscreen{display:block}.plyr:fullscreen .plyr__control .icon--exit-fullscreen{display:block}.plyr:-webkit-full-screen .plyr__control .icon--exit-fullscreen+svg{display:none}.plyr:-ms-fullscreen .plyr__control .icon--exit-fullscreen+svg{display:none}.plyr:fullscreen .plyr__control .icon--exit-fullscreen+svg{display:none}.plyr:-webkit-full-screen.plyr--hide-controls{cursor:none}.plyr:-ms-fullscreen.plyr--hide-controls{cursor:none}.plyr:fullscreen.plyr--hide-controls{cursor:none}@media (min-width:1024px){.plyr:-webkit-full-screen .plyr__captions{font-size:21px}.plyr:-ms-fullscreen .plyr__captions{font-size:21px}.plyr:fullscreen .plyr__captions{font-size:21px}}.plyr:-webkit-full-screen{background:#000;border-radius:0!important;height:100%;margin:0;width:100%}.plyr:-webkit-full-screen video{height:100%}.plyr:-webkit-full-screen .plyr__video-wrapper{height:100%;position:static}.plyr:-webkit-full-screen.plyr--vimeo .plyr__video-wrapper{height:0;position:relative;top:50%;transform:translateY(-50%)}.plyr:-webkit-full-screen .plyr__control .icon--exit-fullscreen{display:block}.plyr:-webkit-full-screen .plyr__control .icon--exit-fullscreen+svg{display:none}.plyr:-webkit-full-screen.plyr--hide-controls{cursor:none}@media (min-width:1024px){.plyr:-webkit-full-screen .plyr__captions{font-size:21px}}.plyr:-moz-full-screen{background:#000;border-radius:0!important;height:100%;margin:0;width:100%}.plyr:-moz-full-screen video{height:100%}.plyr:-moz-full-screen .plyr__video-wrapper{height:100%;position:static}.plyr:-moz-full-screen.plyr--vimeo .plyr__video-wrapper{height:0;position:relative;top:50%;transform:translateY(-50%)}.plyr:-moz-full-screen .plyr__control .icon--exit-fullscreen{display:block}.plyr:-moz-full-screen .plyr__control .icon--exit-fullscreen+svg{display:none}.plyr:-moz-full-screen.plyr--hide-controls{cursor:none}@media (min-width:1024px){.plyr:-moz-full-screen .plyr__captions{font-size:21px}}.plyr:-ms-fullscreen{background:#000;border-radius:0!important;height:100%;margin:0;width:100%}.plyr:-ms-fullscreen video{height:100%}.plyr:-ms-fullscreen .plyr__video-wrapper{height:100%;position:static}.plyr:-ms-fullscreen.plyr--vimeo .plyr__video-wrapper{height:0;position:relative;top:50%;transform:translateY(-50%)}.plyr:-ms-fullscreen .plyr__control .icon--exit-fullscreen{display:block}.plyr:-ms-fullscreen .plyr__control .icon--exit-fullscreen+svg{display:none}.plyr:-ms-fullscreen.plyr--hide-controls{cursor:none}@media (min-width:1024px){.plyr:-ms-fullscreen .plyr__captions{font-size:21px}}.plyr--fullscreen-fallback{background:#000;border-radius:0!important;height:100%;margin:0;width:100%;bottom:0;left:0;position:fixed;right:0;top:0;z-index:10000000}.plyr--fullscreen-fallback video{height:100%}.plyr--fullscreen-fallback .plyr__video-wrapper{height:100%;position:static}.plyr--fullscreen-fallback.plyr--vimeo .plyr__video-wrapper{height:0;position:relative;top:50%;transform:translateY(-50%)}.plyr--fullscreen-fallback .plyr__control .icon--exit-fullscreen{display:block}.plyr--fullscreen-fallback .plyr__control .icon--exit-fullscreen+svg{display:none}.plyr--fullscreen-fallback.plyr--hide-controls{cursor:none}@media (min-width:1024px){.plyr--fullscreen-fallback .plyr__captions{font-size:21px}}.plyr__ads{border-radius:inherit;bottom:0;cursor:pointer;left:0;overflow:hidden;position:absolute;right:0;top:0;z-index:-1}.plyr__ads>div,.plyr__ads>div iframe{height:100%;position:absolute;width:100%}.plyr__ads::after{background:rgba(35,41,47,.8);border-radius:2px;bottom:10px;color:#fff;content:attr(data-badge-text);font-size:11px;padding:2px 6px;pointer-events:none;position:absolute;right:10px;z-index:3}.plyr__ads::after:empty{display:none}.plyr__cues{background:currentColor;display:block;height:5px;left:0;margin:-2.5px 0 0;opacity:.8;position:absolute;top:50%;width:3px;z-index:3}.plyr__preview-thumb{background-color:rgba(255,255,255,.9);border-radius:3px;bottom:100%;box-shadow:0 1px 2px rgba(0,0,0,.15);margin-bottom:10px;opacity:0;padding:3px;pointer-events:none;position:absolute;transform:translate(0,10px) scale(.8);transform-origin:50% 100%;transition:transform .2s .1s ease,opacity .2s .1s ease;z-index:2}.plyr__preview-thumb--is-shown{opacity:1;transform:translate(0,0) scale(1)}.plyr__preview-thumb::before{border-left:4px solid transparent;border-right:4px solid transparent;border-top:4px solid rgba(255,255,255,.9);bottom:-4px;content:'';height:0;left:50%;position:absolute;transform:translateX(-50%);width:0;z-index:2}.plyr__preview-thumb__image-container{background:#c1c9d1;border-radius:2px;overflow:hidden;position:relative;z-index:0}.plyr__preview-thumb__image-container img{height:100%;left:0;max-height:none;max-width:none;position:absolute;top:0;width:100%}.plyr__preview-thumb__time-container{bottom:6px;left:0;position:absolute;right:0;white-space:nowrap;z-index:3}.plyr__preview-thumb__time-container span{background-color:rgba(0,0,0,.55);border-radius:2px;color:#fff;font-size:14px;padding:3px 6px}.plyr__preview-scrubbing{bottom:0;filter:blur(1px);height:100%;left:0;margin:auto;opacity:0;overflow:hidden;position:absolute;right:0;top:0;transition:opacity .3s ease;width:100%;z-index:1}.plyr__preview-scrubbing--is-shown{opacity:1}.plyr__preview-scrubbing img{height:100%;left:0;max-height:none;max-width:none;object-fit:contain;position:absolute;top:0;width:100%}.plyr--no-transition{transition:none!important}.plyr__sr-only{clip:rect(1px,1px,1px,1px);overflow:hidden;border:0!important;height:1px!important;padding:0!important;position:absolute!important;width:1px!important}.plyr [hidden]{display:none!important}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1583:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1584), __esModule: true };

/***/ }),

/***/ 1584:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1585);
var $Object = __webpack_require__(12).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),

/***/ 1585:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(28);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(240) });


/***/ }),

/***/ 1587:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_question_editor_packages_sj_question_file__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_question_editor_packages_sj_question_file_item__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_question_editor_packages_sj_question_file_add__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_question_editor_packages_sj_question_file_progress__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_question_review_components_ContextMenu__ = __webpack_require__(1507);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { SjQuestionFileProgress: __WEBPACK_IMPORTED_MODULE_6__views_question_editor_packages_sj_question_file_progress__["a" /* default */], SjQuestionFileAdd: __WEBPACK_IMPORTED_MODULE_5__views_question_editor_packages_sj_question_file_add__["a" /* default */], SjQuestionFileItem: __WEBPACK_IMPORTED_MODULE_4__views_question_editor_packages_sj_question_file_item__["a" /* default */], SjQuestionFile: __WEBPACK_IMPORTED_MODULE_3__views_question_editor_packages_sj_question_file__["a" /* default */] },
  mixins: [],
  inject: ['playVideo', 'uploadVideo'],
  props: {
    value: Array,
    disabled: Boolean,
    title: {
      type: String,
      default: '添加指引视频'
    },
    showHoverIcons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      progress: [
        // percentage: 0,
      ],
      checkedFiles: []
    };
  },

  computed: {
    files: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {
    view: function view(file) {
      this.playVideo(file);
    },
    upload: function upload() {
      var _this = this;

      this.uploadVideo().then(function (data) {
        var videoProgress = 0;
        var posterProgress = 0;
        var progress = {
          percentage: 0,
          file: data.file
          // 显示进度条
        };_this.progress.push(progress);
        // 生成请求数据
        var video = new FormData();
        video.append('file', data.file);
        var poster = new FormData();
        poster.append('file', data.poster);
        request.all.alert([request('uploadStepTemplateFile', video, {
          onUploadProgress: function onUploadProgress(progressEvent) {
            videoProgress = progressEvent.loaded / progressEvent.total * 100 | 0;
            progress.percentage = (videoProgress + posterProgress) / 2;
          }
        }), request('uploadStepTemplateFile', poster, {
          onUploadProgress: function onUploadProgress(progressEvent) {
            posterProgress = progressEvent.loaded / progressEvent.total * 100 | 0;
            progress.percentage = (videoProgress + posterProgress) / 2;
          }
        })]).then(function (_ref) {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
              src = _ref2[0].data,
              poster = _ref2[1].data;

          _this.files.push({ src: src, poster: poster });
        }).finally(function () {
          _this.progress.splice(_this.progress.indexOf(progress), 1);
        });
      });
    },
    remove: function remove(index) {
      this.files.splice(index, 1);
    },
    onContextmenu: function onContextmenu(_ref3, index) {
      var clientX = _ref3.clientX,
          clientY = _ref3.clientY;

      // 匹配右击菜单作用域
      Object(__WEBPACK_IMPORTED_MODULE_7__views_question_review_components_ContextMenu__["a" /* default */])().scope !== this.uniqueId && Object(__WEBPACK_IMPORTED_MODULE_7__views_question_review_components_ContextMenu__["a" /* default */])().empty();
      // 判断右击是否在项目上
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(index) && index >= 0) {
        var file = this.files[index];
        if (!this.checkedFiles.includes(file)) {
          Object(__WEBPACK_IMPORTED_MODULE_7__views_question_review_components_ContextMenu__["a" /* default */])().empty();
          Object(__WEBPACK_IMPORTED_MODULE_7__views_question_review_components_ContextMenu__["a" /* default */])().checked(file);
          this.checkedFiles = Object(__WEBPACK_IMPORTED_MODULE_7__views_question_review_components_ContextMenu__["a" /* default */])().checkedFiles;
        }
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_7__views_question_review_components_ContextMenu__["a" /* default */])().empty();
      }
      // 限制拷贝数量
      Object(__WEBPACK_IMPORTED_MODULE_7__views_question_review_components_ContextMenu__["a" /* default */])({ pasteMax: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a });
      Object(__WEBPACK_IMPORTED_MODULE_7__views_question_review_components_ContextMenu__["a" /* default */])().setScope(this.uniqueId);
      Object(__WEBPACK_IMPORTED_MODULE_7__views_question_review_components_ContextMenu__["a" /* default */])().setType(this.type);
      Object(__WEBPACK_IMPORTED_MODULE_7__views_question_review_components_ContextMenu__["a" /* default */])().setFiles(this.files);
      Object(__WEBPACK_IMPORTED_MODULE_7__views_question_review_components_ContextMenu__["a" /* default */])().show(clientX, clientY);
    }
  }
});

/***/ }),

/***/ 1588:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SjQuestionFile',
  components: {},
  mixins: [],
  provide: function provide() {
    return {
      sjQuestionFile: this
    };
  },

  inject: [],
  props: {
    model: Array,
    disabled: Boolean
  },
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {}
});

/***/ }),

/***/ 1589:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  mixins: [],
  props: {
    poster: String,
    icon: String,
    disabled: Boolean,
    selected: Boolean,
    showHoverIcons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  beforeCreate: function beforeCreate() {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {}
});

/***/ }),

/***/ 1590:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  mixins: [],
  props: {
    icon: {
      type: String,
      default: 'sj-icon-add-image'
    },
    disabled: Boolean
  },
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {}
});

/***/ }),

/***/ 1591:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sj_question_file_src_SjQuestionFileProgress_vue__ = __webpack_require__(1759);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__sj_question_file_src_SjQuestionFileProgress_vue__["a" /* default */]);

/***/ }),

/***/ 1592:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  mixins: [],
  inheritAttrs: false,
  props: {},
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {}
});

/***/ }),

/***/ 1609:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CropperImage_vue__ = __webpack_require__(1545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ab1921c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CropperImage_vue__ = __webpack_require__(1650);
function injectStyle (ssrContext) {
  __webpack_require__(1646)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ab1921c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CropperImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ab1921c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CropperImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1614:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 不同题目类型选项拥有的字段
 */

// 全部都有的字段
var basics = ['id', 'title'];

var choice = ['jumpTargetId', 'settlementType', 'settlementAmount', 'settlementAmountRatio', 'intelligentCall'];

/* harmony default export */ __webpack_exports__["a"] = ({
  info: [],
  text: [],
  multitext: [].concat(basics, ['inputType', 'inputMin', 'inputMax', 'required', 'dataLabel']).sort(),
  multiselect: [].concat(basics, choice, ['mutexOptions', 'dataLabel']).sort(),
  imageMultiselect: [].concat(basics, choice, ['mutexOptions', 'images', 'dataLabel']).sort(),
  select: [].concat(basics, choice, ['dataLabel', 'exampleImages', 'exampleText', 'needEvidence', 'localFile', 'referIds', 'nextSelectDelay', 'autoIncreaseTaskGroupTarget', 'takePhotoAuxiliaryLine', 'priorityReview']).sort()
});

/***/ }),

/***/ 1615:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 不同题型的字段
 */

// 全部都有的字段
var basicFields = ['id', 'title', 'titleAlias', 'type', 'images', 'text', 'textPrefix', 'jumpTargetId', 'delay', 'guideText', 'guideVideo', 'guideAudio', 'forceGuideVideo', 'forceGuideAudio', 'auditText', 'keyin_ids', 'ondutyCheck', 'throughRecordKeyQuestion', 'allow_screen_capture', 'allow_media_download'];
// 多次重用组合
var reusing = ['referIds', 'needEvidence', 'localFile', 'clarity', 'minDuration', 'evidenceQuality', 'evidenceType', 'imageRecognitionType', 'takePhotoAuxiliaryLine', 'allowReusePhoto', 'allowCrossSubjectRecord', 'reportedTablesAssociationStepId'];

var hasEvidenceFields = ['takePhotoScene'];

/* harmony default export */ __webpack_exports__["a"] = ({
  info: [].concat(basicFields, reusing, hasEvidenceFields, ['dataLabel', 'intelligentCall']).sort(),
  text: [].concat(basicFields, reusing, hasEvidenceFields, ['inputType', 'inputMin', 'inputMax', 'dataLabel', 'intelligentCall']).sort(),
  multitext: [].concat(basicFields, ['referIds', 'options', 'intelligentCall']).sort(),
  multiselect: [].concat(basicFields, reusing, hasEvidenceFields, ['options']).sort(),
  imageMultiselect: [].concat(basicFields, reusing, hasEvidenceFields, ['options']).sort(),
  select: [].concat(basicFields, hasEvidenceFields, ['clarity', 'minDuration', 'evidenceQuality', 'evidenceType', 'allowReusePhoto', 'allowCrossSubjectRecord', 'imageRecognitionType', 'options', 'dataLabel', 'reportedTablesAssociationStepId']).sort()
});

/***/ }),

/***/ 1629:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
 * Quill Editor v1.3.7
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Quill"] = factory();
	else
		root["Quill"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 109);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var container_1 = __webpack_require__(17);
var format_1 = __webpack_require__(18);
var leaf_1 = __webpack_require__(19);
var scroll_1 = __webpack_require__(45);
var inline_1 = __webpack_require__(46);
var block_1 = __webpack_require__(47);
var embed_1 = __webpack_require__(48);
var text_1 = __webpack_require__(49);
var attributor_1 = __webpack_require__(12);
var class_1 = __webpack_require__(32);
var style_1 = __webpack_require__(33);
var store_1 = __webpack_require__(31);
var Registry = __webpack_require__(1);
var Parchment = {
    Scope: Registry.Scope,
    create: Registry.create,
    find: Registry.find,
    query: Registry.query,
    register: Registry.register,
    Container: container_1.default,
    Format: format_1.default,
    Leaf: leaf_1.default,
    Embed: embed_1.default,
    Scroll: scroll_1.default,
    Block: block_1.default,
    Inline: inline_1.default,
    Text: text_1.default,
    Attributor: {
        Attribute: attributor_1.default,
        Class: class_1.default,
        Style: style_1.default,
        Store: store_1.default,
    },
};
exports.default = Parchment;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ParchmentError = /** @class */ (function (_super) {
    __extends(ParchmentError, _super);
    function ParchmentError(message) {
        var _this = this;
        message = '[Parchment] ' + message;
        _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _this.constructor.name;
        return _this;
    }
    return ParchmentError;
}(Error));
exports.ParchmentError = ParchmentError;
var attributes = {};
var classes = {};
var tags = {};
var types = {};
exports.DATA_KEY = '__blot';
var Scope;
(function (Scope) {
    Scope[Scope["TYPE"] = 3] = "TYPE";
    Scope[Scope["LEVEL"] = 12] = "LEVEL";
    Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
    Scope[Scope["BLOT"] = 14] = "BLOT";
    Scope[Scope["INLINE"] = 7] = "INLINE";
    Scope[Scope["BLOCK"] = 11] = "BLOCK";
    Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
    Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
    Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
    Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
    Scope[Scope["ANY"] = 15] = "ANY";
})(Scope = exports.Scope || (exports.Scope = {}));
function create(input, value) {
    var match = query(input);
    if (match == null) {
        throw new ParchmentError("Unable to create " + input + " blot");
    }
    var BlotClass = match;
    var node = 
    // @ts-ignore
    input instanceof Node || input['nodeType'] === Node.TEXT_NODE ? input : BlotClass.create(value);
    return new BlotClass(node, value);
}
exports.create = create;
function find(node, bubble) {
    if (bubble === void 0) { bubble = false; }
    if (node == null)
        return null;
    // @ts-ignore
    if (node[exports.DATA_KEY] != null)
        return node[exports.DATA_KEY].blot;
    if (bubble)
        return find(node.parentNode, bubble);
    return null;
}
exports.find = find;
function query(query, scope) {
    if (scope === void 0) { scope = Scope.ANY; }
    var match;
    if (typeof query === 'string') {
        match = types[query] || attributes[query];
        // @ts-ignore
    }
    else if (query instanceof Text || query['nodeType'] === Node.TEXT_NODE) {
        match = types['text'];
    }
    else if (typeof query === 'number') {
        if (query & Scope.LEVEL & Scope.BLOCK) {
            match = types['block'];
        }
        else if (query & Scope.LEVEL & Scope.INLINE) {
            match = types['inline'];
        }
    }
    else if (query instanceof HTMLElement) {
        var names = (query.getAttribute('class') || '').split(/\s+/);
        for (var i in names) {
            match = classes[names[i]];
            if (match)
                break;
        }
        match = match || tags[query.tagName];
    }
    if (match == null)
        return null;
    // @ts-ignore
    if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope)
        return match;
    return null;
}
exports.query = query;
function register() {
    var Definitions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        Definitions[_i] = arguments[_i];
    }
    if (Definitions.length > 1) {
        return Definitions.map(function (d) {
            return register(d);
        });
    }
    var Definition = Definitions[0];
    if (typeof Definition.blotName !== 'string' && typeof Definition.attrName !== 'string') {
        throw new ParchmentError('Invalid definition');
    }
    else if (Definition.blotName === 'abstract') {
        throw new ParchmentError('Cannot register abstract class');
    }
    types[Definition.blotName || Definition.attrName] = Definition;
    if (typeof Definition.keyName === 'string') {
        attributes[Definition.keyName] = Definition;
    }
    else {
        if (Definition.className != null) {
            classes[Definition.className] = Definition;
        }
        if (Definition.tagName != null) {
            if (Array.isArray(Definition.tagName)) {
                Definition.tagName = Definition.tagName.map(function (tagName) {
                    return tagName.toUpperCase();
                });
            }
            else {
                Definition.tagName = Definition.tagName.toUpperCase();
            }
            var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [Definition.tagName];
            tagNames.forEach(function (tag) {
                if (tags[tag] == null || Definition.className == null) {
                    tags[tag] = Definition;
                }
            });
        }
    }
    return Definition;
}
exports.register = register;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var diff = __webpack_require__(51);
var equal = __webpack_require__(11);
var extend = __webpack_require__(3);
var op = __webpack_require__(20);


var NULL_CHARACTER = String.fromCharCode(0);  // Placeholder char for embed in diff()


var Delta = function (ops) {
  // Assume we are given a well formed ops
  if (Array.isArray(ops)) {
    this.ops = ops;
  } else if (ops != null && Array.isArray(ops.ops)) {
    this.ops = ops.ops;
  } else {
    this.ops = [];
  }
};


Delta.prototype.insert = function (text, attributes) {
  var newOp = {};
  if (text.length === 0) return this;
  newOp.insert = text;
  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
    newOp.attributes = attributes;
  }
  return this.push(newOp);
};

Delta.prototype['delete'] = function (length) {
  if (length <= 0) return this;
  return this.push({ 'delete': length });
};

Delta.prototype.retain = function (length, attributes) {
  if (length <= 0) return this;
  var newOp = { retain: length };
  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
    newOp.attributes = attributes;
  }
  return this.push(newOp);
};

Delta.prototype.push = function (newOp) {
  var index = this.ops.length;
  var lastOp = this.ops[index - 1];
  newOp = extend(true, {}, newOp);
  if (typeof lastOp === 'object') {
    if (typeof newOp['delete'] === 'number' && typeof lastOp['delete'] === 'number') {
      this.ops[index - 1] = { 'delete': lastOp['delete'] + newOp['delete'] };
      return this;
    }
    // Since it does not matter if we insert before or after deleting at the same index,
    // always prefer to insert first
    if (typeof lastOp['delete'] === 'number' && newOp.insert != null) {
      index -= 1;
      lastOp = this.ops[index - 1];
      if (typeof lastOp !== 'object') {
        this.ops.unshift(newOp);
        return this;
      }
    }
    if (equal(newOp.attributes, lastOp.attributes)) {
      if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
        this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
        return this;
      } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
        this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
        return this;
      }
    }
  }
  if (index === this.ops.length) {
    this.ops.push(newOp);
  } else {
    this.ops.splice(index, 0, newOp);
  }
  return this;
};

Delta.prototype.chop = function () {
  var lastOp = this.ops[this.ops.length - 1];
  if (lastOp && lastOp.retain && !lastOp.attributes) {
    this.ops.pop();
  }
  return this;
};

Delta.prototype.filter = function (predicate) {
  return this.ops.filter(predicate);
};

Delta.prototype.forEach = function (predicate) {
  this.ops.forEach(predicate);
};

Delta.prototype.map = function (predicate) {
  return this.ops.map(predicate);
};

Delta.prototype.partition = function (predicate) {
  var passed = [], failed = [];
  this.forEach(function(op) {
    var target = predicate(op) ? passed : failed;
    target.push(op);
  });
  return [passed, failed];
};

Delta.prototype.reduce = function (predicate, initial) {
  return this.ops.reduce(predicate, initial);
};

Delta.prototype.changeLength = function () {
  return this.reduce(function (length, elem) {
    if (elem.insert) {
      return length + op.length(elem);
    } else if (elem.delete) {
      return length - elem.delete;
    }
    return length;
  }, 0);
};

Delta.prototype.length = function () {
  return this.reduce(function (length, elem) {
    return length + op.length(elem);
  }, 0);
};

Delta.prototype.slice = function (start, end) {
  start = start || 0;
  if (typeof end !== 'number') end = Infinity;
  var ops = [];
  var iter = op.iterator(this.ops);
  var index = 0;
  while (index < end && iter.hasNext()) {
    var nextOp;
    if (index < start) {
      nextOp = iter.next(start - index);
    } else {
      nextOp = iter.next(end - index);
      ops.push(nextOp);
    }
    index += op.length(nextOp);
  }
  return new Delta(ops);
};


Delta.prototype.compose = function (other) {
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  var ops = [];
  var firstOther = otherIter.peek();
  if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
    var firstLeft = firstOther.retain;
    while (thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft) {
      firstLeft -= thisIter.peekLength();
      ops.push(thisIter.next());
    }
    if (firstOther.retain - firstLeft > 0) {
      otherIter.next(firstOther.retain - firstLeft);
    }
  }
  var delta = new Delta(ops);
  while (thisIter.hasNext() || otherIter.hasNext()) {
    if (otherIter.peekType() === 'insert') {
      delta.push(otherIter.next());
    } else if (thisIter.peekType() === 'delete') {
      delta.push(thisIter.next());
    } else {
      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
      var thisOp = thisIter.next(length);
      var otherOp = otherIter.next(length);
      if (typeof otherOp.retain === 'number') {
        var newOp = {};
        if (typeof thisOp.retain === 'number') {
          newOp.retain = length;
        } else {
          newOp.insert = thisOp.insert;
        }
        // Preserve null when composing with a retain, otherwise remove it for inserts
        var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
        if (attributes) newOp.attributes = attributes;
        delta.push(newOp);

        // Optimization if rest of other is just retain
        if (!otherIter.hasNext() && equal(delta.ops[delta.ops.length - 1], newOp)) {
          var rest = new Delta(thisIter.rest());
          return delta.concat(rest).chop();
        }

      // Other op should be delete, we could be an insert or retain
      // Insert + delete cancels out
      } else if (typeof otherOp['delete'] === 'number' && typeof thisOp.retain === 'number') {
        delta.push(otherOp);
      }
    }
  }
  return delta.chop();
};

Delta.prototype.concat = function (other) {
  var delta = new Delta(this.ops.slice());
  if (other.ops.length > 0) {
    delta.push(other.ops[0]);
    delta.ops = delta.ops.concat(other.ops.slice(1));
  }
  return delta;
};

Delta.prototype.diff = function (other, index) {
  if (this.ops === other.ops) {
    return new Delta();
  }
  var strings = [this, other].map(function (delta) {
    return delta.map(function (op) {
      if (op.insert != null) {
        return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
      }
      var prep = (delta === other) ? 'on' : 'with';
      throw new Error('diff() called ' + prep + ' non-document');
    }).join('');
  });
  var delta = new Delta();
  var diffResult = diff(strings[0], strings[1], index);
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  diffResult.forEach(function (component) {
    var length = component[1].length;
    while (length > 0) {
      var opLength = 0;
      switch (component[0]) {
        case diff.INSERT:
          opLength = Math.min(otherIter.peekLength(), length);
          delta.push(otherIter.next(opLength));
          break;
        case diff.DELETE:
          opLength = Math.min(length, thisIter.peekLength());
          thisIter.next(opLength);
          delta['delete'](opLength);
          break;
        case diff.EQUAL:
          opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
          var thisOp = thisIter.next(opLength);
          var otherOp = otherIter.next(opLength);
          if (equal(thisOp.insert, otherOp.insert)) {
            delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
          } else {
            delta.push(otherOp)['delete'](opLength);
          }
          break;
      }
      length -= opLength;
    }
  });
  return delta.chop();
};

Delta.prototype.eachLine = function (predicate, newline) {
  newline = newline || '\n';
  var iter = op.iterator(this.ops);
  var line = new Delta();
  var i = 0;
  while (iter.hasNext()) {
    if (iter.peekType() !== 'insert') return;
    var thisOp = iter.peek();
    var start = op.length(thisOp) - iter.peekLength();
    var index = typeof thisOp.insert === 'string' ?
      thisOp.insert.indexOf(newline, start) - start : -1;
    if (index < 0) {
      line.push(iter.next());
    } else if (index > 0) {
      line.push(iter.next(index));
    } else {
      if (predicate(line, iter.next(1).attributes || {}, i) === false) {
        return;
      }
      i += 1;
      line = new Delta();
    }
  }
  if (line.length() > 0) {
    predicate(line, {}, i);
  }
};

Delta.prototype.transform = function (other, priority) {
  priority = !!priority;
  if (typeof other === 'number') {
    return this.transformPosition(other, priority);
  }
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  var delta = new Delta();
  while (thisIter.hasNext() || otherIter.hasNext()) {
    if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) {
      delta.retain(op.length(thisIter.next()));
    } else if (otherIter.peekType() === 'insert') {
      delta.push(otherIter.next());
    } else {
      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
      var thisOp = thisIter.next(length);
      var otherOp = otherIter.next(length);
      if (thisOp['delete']) {
        // Our delete either makes their delete redundant or removes their retain
        continue;
      } else if (otherOp['delete']) {
        delta.push(otherOp);
      } else {
        // We retain either their retain or insert
        delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
      }
    }
  }
  return delta.chop();
};

Delta.prototype.transformPosition = function (index, priority) {
  priority = !!priority;
  var thisIter = op.iterator(this.ops);
  var offset = 0;
  while (thisIter.hasNext() && offset <= index) {
    var length = thisIter.peekLength();
    var nextType = thisIter.peekType();
    thisIter.next();
    if (nextType === 'delete') {
      index -= Math.min(length, index - offset);
      continue;
    } else if (nextType === 'insert' && (offset < index || !priority)) {
      index += length;
    }
    offset += length;
  }
  return index;
};


module.exports = Delta;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

'use strict';

var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

module.exports = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NEWLINE_LENGTH = 1;

var BlockEmbed = function (_Parchment$Embed) {
  _inherits(BlockEmbed, _Parchment$Embed);

  function BlockEmbed() {
    _classCallCheck(this, BlockEmbed);

    return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
  }

  _createClass(BlockEmbed, [{
    key: 'attach',
    value: function attach() {
      _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'attach', this).call(this);
      this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
    }
  }, {
    key: 'delta',
    value: function delta() {
      return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
      if (attribute != null) {
        this.attributes.attribute(attribute, value);
      }
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      this.format(name, value);
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (typeof value === 'string' && value.endsWith('\n')) {
        var block = _parchment2.default.create(Block.blotName);
        this.parent.insertBefore(block, index === 0 ? this : this.next);
        block.insertAt(0, value.slice(0, -1));
      } else {
        _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'insertAt', this).call(this, index, value, def);
      }
    }
  }]);

  return BlockEmbed;
}(_parchment2.default.Embed);

BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
// It is important for cursor behavior BlockEmbeds use tags that are block level elements


var Block = function (_Parchment$Block) {
  _inherits(Block, _Parchment$Block);

  function Block(domNode) {
    _classCallCheck(this, Block);

    var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));

    _this2.cache = {};
    return _this2;
  }

  _createClass(Block, [{
    key: 'delta',
    value: function delta() {
      if (this.cache.delta == null) {
        this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function (delta, leaf) {
          if (leaf.length() === 0) {
            return delta;
          } else {
            return delta.insert(leaf.value(), bubbleFormats(leaf));
          }
        }, new _quillDelta2.default()).insert('\n', bubbleFormats(this));
      }
      return this.cache.delta;
    }
  }, {
    key: 'deleteAt',
    value: function deleteAt(index, length) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'deleteAt', this).call(this, index, length);
      this.cache = {};
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (length <= 0) return;
      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
        if (index + length === this.length()) {
          this.format(name, value);
        }
      } else {
        _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'formatAt', this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
      }
      this.cache = {};
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null) return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, index, value, def);
      if (value.length === 0) return;
      var lines = value.split('\n');
      var text = lines.shift();
      if (text.length > 0) {
        if (index < this.length() - 1 || this.children.tail == null) {
          _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, Math.min(index, this.length() - 1), text);
        } else {
          this.children.tail.insertAt(this.children.tail.length(), text);
        }
        this.cache = {};
      }
      var block = this;
      lines.reduce(function (index, line) {
        block = block.split(index, true);
        block.insertAt(0, line);
        return line.length;
      }, index + text.length);
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      var head = this.children.head;
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertBefore', this).call(this, blot, ref);
      if (head instanceof _break2.default) {
        head.remove();
      }
      this.cache = {};
    }
  }, {
    key: 'length',
    value: function length() {
      if (this.cache.length == null) {
        this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'length', this).call(this) + NEWLINE_LENGTH;
      }
      return this.cache.length;
    }
  }, {
    key: 'moveChildren',
    value: function moveChildren(target, ref) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'moveChildren', this).call(this, target, ref);
      this.cache = {};
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'optimize', this).call(this, context);
      this.cache = {};
    }
  }, {
    key: 'path',
    value: function path(index) {
      return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'path', this).call(this, index, true);
    }
  }, {
    key: 'removeChild',
    value: function removeChild(child) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'removeChild', this).call(this, child);
      this.cache = {};
    }
  }, {
    key: 'split',
    value: function split(index) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
        var clone = this.clone();
        if (index === 0) {
          this.parent.insertBefore(clone, this);
          return this;
        } else {
          this.parent.insertBefore(clone, this.next);
          return clone;
        }
      } else {
        var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'split', this).call(this, index, force);
        this.cache = {};
        return next;
      }
    }
  }]);

  return Block;
}(_parchment2.default.Block);

Block.blotName = 'block';
Block.tagName = 'P';
Block.defaultChild = 'break';
Block.allowedChildren = [_inline2.default, _parchment2.default.Embed, _text2.default];

function bubbleFormats(blot) {
  var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (blot == null) return formats;
  if (typeof blot.formats === 'function') {
    formats = (0, _extend2.default)(formats, blot.formats());
  }
  if (blot.parent == null || blot.parent.blotName == 'scroll' || blot.parent.statics.scope !== blot.statics.scope) {
    return formats;
  }
  return bubbleFormats(blot.parent, formats);
}

exports.bubbleFormats = bubbleFormats;
exports.BlockEmbed = BlockEmbed;
exports.default = Block;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.overload = exports.expandConfig = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(50);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _editor = __webpack_require__(14);

var _editor2 = _interopRequireDefault(_editor);

var _emitter3 = __webpack_require__(8);

var _emitter4 = _interopRequireDefault(_emitter3);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _selection = __webpack_require__(15);

var _selection2 = _interopRequireDefault(_selection);

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _theme = __webpack_require__(34);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = (0, _logger2.default)('quill');

var Quill = function () {
  _createClass(Quill, null, [{
    key: 'debug',
    value: function debug(limit) {
      if (limit === true) {
        limit = 'log';
      }
      _logger2.default.level(limit);
    }
  }, {
    key: 'find',
    value: function find(node) {
      return node.__quill || _parchment2.default.find(node);
    }
  }, {
    key: 'import',
    value: function _import(name) {
      if (this.imports[name] == null) {
        debug.error('Cannot import ' + name + '. Are you sure it was registered?');
      }
      return this.imports[name];
    }
  }, {
    key: 'register',
    value: function register(path, target) {
      var _this = this;

      var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (typeof path !== 'string') {
        var name = path.attrName || path.blotName;
        if (typeof name === 'string') {
          // register(Blot | Attributor, overwrite)
          this.register('formats/' + name, path, target);
        } else {
          Object.keys(path).forEach(function (key) {
            _this.register(key, path[key], target);
          });
        }
      } else {
        if (this.imports[path] != null && !overwrite) {
          debug.warn('Overwriting ' + path + ' with', target);
        }
        this.imports[path] = target;
        if ((path.startsWith('blots/') || path.startsWith('formats/')) && target.blotName !== 'abstract') {
          _parchment2.default.register(target);
        } else if (path.startsWith('modules') && typeof target.register === 'function') {
          target.register();
        }
      }
    }
  }]);

  function Quill(container) {
    var _this2 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Quill);

    this.options = expandConfig(container, options);
    this.container = this.options.container;
    if (this.container == null) {
      return debug.error('Invalid Quill container', container);
    }
    if (this.options.debug) {
      Quill.debug(this.options.debug);
    }
    var html = this.container.innerHTML.trim();
    this.container.classList.add('ql-container');
    this.container.innerHTML = '';
    this.container.__quill = this;
    this.root = this.addContainer('ql-editor');
    this.root.classList.add('ql-blank');
    this.root.setAttribute('data-gramm', false);
    this.scrollingContainer = this.options.scrollingContainer || this.root;
    this.emitter = new _emitter4.default();
    this.scroll = _parchment2.default.create(this.root, {
      emitter: this.emitter,
      whitelist: this.options.formats
    });
    this.editor = new _editor2.default(this.scroll);
    this.selection = new _selection2.default(this.scroll, this.emitter);
    this.theme = new this.options.theme(this, this.options);
    this.keyboard = this.theme.addModule('keyboard');
    this.clipboard = this.theme.addModule('clipboard');
    this.history = this.theme.addModule('history');
    this.theme.init();
    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type) {
      if (type === _emitter4.default.events.TEXT_CHANGE) {
        _this2.root.classList.toggle('ql-blank', _this2.editor.isBlank());
      }
    });
    this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function (source, mutations) {
      var range = _this2.selection.lastRange;
      var index = range && range.length === 0 ? range.index : undefined;
      modify.call(_this2, function () {
        return _this2.editor.update(null, mutations, index);
      }, source);
    });
    var contents = this.clipboard.convert('<div class=\'ql-editor\' style="white-space: normal;">' + html + '<p><br></p></div>');
    this.setContents(contents);
    this.history.clear();
    if (this.options.placeholder) {
      this.root.setAttribute('data-placeholder', this.options.placeholder);
    }
    if (this.options.readOnly) {
      this.disable();
    }
  }

  _createClass(Quill, [{
    key: 'addContainer',
    value: function addContainer(container) {
      var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (typeof container === 'string') {
        var className = container;
        container = document.createElement('div');
        container.classList.add(className);
      }
      this.container.insertBefore(container, refNode);
      return container;
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.selection.setRange(null);
    }
  }, {
    key: 'deleteText',
    value: function deleteText(index, length, source) {
      var _this3 = this;

      var _overload = overload(index, length, source);

      var _overload2 = _slicedToArray(_overload, 4);

      index = _overload2[0];
      length = _overload2[1];
      source = _overload2[3];

      return modify.call(this, function () {
        return _this3.editor.deleteText(index, length);
      }, source, index, -1 * length);
    }
  }, {
    key: 'disable',
    value: function disable() {
      this.enable(false);
    }
  }, {
    key: 'enable',
    value: function enable() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.scroll.enable(enabled);
      this.container.classList.toggle('ql-disabled', !enabled);
    }
  }, {
    key: 'focus',
    value: function focus() {
      var scrollTop = this.scrollingContainer.scrollTop;
      this.selection.focus();
      this.scrollingContainer.scrollTop = scrollTop;
      this.scrollIntoView();
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      var _this4 = this;

      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        var range = _this4.getSelection(true);
        var change = new _quillDelta2.default();
        if (range == null) {
          return change;
        } else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
          change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
        } else if (range.length === 0) {
          _this4.selection.format(name, value);
          return change;
        } else {
          change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
        }
        _this4.setSelection(range, _emitter4.default.sources.SILENT);
        return change;
      }, source);
    }
  }, {
    key: 'formatLine',
    value: function formatLine(index, length, name, value, source) {
      var _this5 = this;

      var formats = void 0;

      var _overload3 = overload(index, length, name, value, source);

      var _overload4 = _slicedToArray(_overload3, 4);

      index = _overload4[0];
      length = _overload4[1];
      formats = _overload4[2];
      source = _overload4[3];

      return modify.call(this, function () {
        return _this5.editor.formatLine(index, length, formats);
      }, source, index, 0);
    }
  }, {
    key: 'formatText',
    value: function formatText(index, length, name, value, source) {
      var _this6 = this;

      var formats = void 0;

      var _overload5 = overload(index, length, name, value, source);

      var _overload6 = _slicedToArray(_overload5, 4);

      index = _overload6[0];
      length = _overload6[1];
      formats = _overload6[2];
      source = _overload6[3];

      return modify.call(this, function () {
        return _this6.editor.formatText(index, length, formats);
      }, source, index, 0);
    }
  }, {
    key: 'getBounds',
    value: function getBounds(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var bounds = void 0;
      if (typeof index === 'number') {
        bounds = this.selection.getBounds(index, length);
      } else {
        bounds = this.selection.getBounds(index.index, index.length);
      }
      var containerBounds = this.container.getBoundingClientRect();
      return {
        bottom: bounds.bottom - containerBounds.top,
        height: bounds.height,
        left: bounds.left - containerBounds.left,
        right: bounds.right - containerBounds.left,
        top: bounds.top - containerBounds.top,
        width: bounds.width
      };
    }
  }, {
    key: 'getContents',
    value: function getContents() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

      var _overload7 = overload(index, length);

      var _overload8 = _slicedToArray(_overload7, 2);

      index = _overload8[0];
      length = _overload8[1];

      return this.editor.getContents(index, length);
    }
  }, {
    key: 'getFormat',
    value: function getFormat() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (typeof index === 'number') {
        return this.editor.getFormat(index, length);
      } else {
        return this.editor.getFormat(index.index, index.length);
      }
    }
  }, {
    key: 'getIndex',
    value: function getIndex(blot) {
      return blot.offset(this.scroll);
    }
  }, {
    key: 'getLength',
    value: function getLength() {
      return this.scroll.length();
    }
  }, {
    key: 'getLeaf',
    value: function getLeaf(index) {
      return this.scroll.leaf(index);
    }
  }, {
    key: 'getLine',
    value: function getLine(index) {
      return this.scroll.line(index);
    }
  }, {
    key: 'getLines',
    value: function getLines() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

      if (typeof index !== 'number') {
        return this.scroll.lines(index.index, index.length);
      } else {
        return this.scroll.lines(index, length);
      }
    }
  }, {
    key: 'getModule',
    value: function getModule(name) {
      return this.theme.modules[name];
    }
  }, {
    key: 'getSelection',
    value: function getSelection() {
      var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (focus) this.focus();
      this.update(); // Make sure we access getRange with editor in consistent state
      return this.selection.getRange()[0];
    }
  }, {
    key: 'getText',
    value: function getText() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

      var _overload9 = overload(index, length);

      var _overload10 = _slicedToArray(_overload9, 2);

      index = _overload10[0];
      length = _overload10[1];

      return this.editor.getText(index, length);
    }
  }, {
    key: 'hasFocus',
    value: function hasFocus() {
      return this.selection.hasFocus();
    }
  }, {
    key: 'insertEmbed',
    value: function insertEmbed(index, embed, value) {
      var _this7 = this;

      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;

      return modify.call(this, function () {
        return _this7.editor.insertEmbed(index, embed, value);
      }, source, index);
    }
  }, {
    key: 'insertText',
    value: function insertText(index, text, name, value, source) {
      var _this8 = this;

      var formats = void 0;

      var _overload11 = overload(index, 0, name, value, source);

      var _overload12 = _slicedToArray(_overload11, 4);

      index = _overload12[0];
      formats = _overload12[2];
      source = _overload12[3];

      return modify.call(this, function () {
        return _this8.editor.insertText(index, text, formats);
      }, source, index, text.length);
    }
  }, {
    key: 'isEnabled',
    value: function isEnabled() {
      return !this.container.classList.contains('ql-disabled');
    }
  }, {
    key: 'off',
    value: function off() {
      return this.emitter.off.apply(this.emitter, arguments);
    }
  }, {
    key: 'on',
    value: function on() {
      return this.emitter.on.apply(this.emitter, arguments);
    }
  }, {
    key: 'once',
    value: function once() {
      return this.emitter.once.apply(this.emitter, arguments);
    }
  }, {
    key: 'pasteHTML',
    value: function pasteHTML(index, html, source) {
      this.clipboard.dangerouslyPasteHTML(index, html, source);
    }
  }, {
    key: 'removeFormat',
    value: function removeFormat(index, length, source) {
      var _this9 = this;

      var _overload13 = overload(index, length, source);

      var _overload14 = _slicedToArray(_overload13, 4);

      index = _overload14[0];
      length = _overload14[1];
      source = _overload14[3];

      return modify.call(this, function () {
        return _this9.editor.removeFormat(index, length);
      }, source, index);
    }
  }, {
    key: 'scrollIntoView',
    value: function scrollIntoView() {
      this.selection.scrollIntoView(this.scrollingContainer);
    }
  }, {
    key: 'setContents',
    value: function setContents(delta) {
      var _this10 = this;

      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        delta = new _quillDelta2.default(delta);
        var length = _this10.getLength();
        var deleted = _this10.editor.deleteText(0, length);
        var applied = _this10.editor.applyDelta(delta);
        var lastOp = applied.ops[applied.ops.length - 1];
        if (lastOp != null && typeof lastOp.insert === 'string' && lastOp.insert[lastOp.insert.length - 1] === '\n') {
          _this10.editor.deleteText(_this10.getLength() - 1, 1);
          applied.delete(1);
        }
        var ret = deleted.compose(applied);
        return ret;
      }, source);
    }
  }, {
    key: 'setSelection',
    value: function setSelection(index, length, source) {
      if (index == null) {
        this.selection.setRange(null, length || Quill.sources.API);
      } else {
        var _overload15 = overload(index, length, source);

        var _overload16 = _slicedToArray(_overload15, 4);

        index = _overload16[0];
        length = _overload16[1];
        source = _overload16[3];

        this.selection.setRange(new _selection.Range(index, length), source);
        if (source !== _emitter4.default.sources.SILENT) {
          this.selection.scrollIntoView(this.scrollingContainer);
        }
      }
    }
  }, {
    key: 'setText',
    value: function setText(text) {
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      var delta = new _quillDelta2.default().insert(text);
      return this.setContents(delta, source);
    }
  }, {
    key: 'update',
    value: function update() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;

      var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
      this.selection.update(source);
      return change;
    }
  }, {
    key: 'updateContents',
    value: function updateContents(delta) {
      var _this11 = this;

      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        delta = new _quillDelta2.default(delta);
        return _this11.editor.applyDelta(delta, source);
      }, source, true);
    }
  }]);

  return Quill;
}();

Quill.DEFAULTS = {
  bounds: null,
  formats: null,
  modules: {},
  placeholder: '',
  readOnly: false,
  scrollingContainer: null,
  strict: true,
  theme: 'default'
};
Quill.events = _emitter4.default.events;
Quill.sources = _emitter4.default.sources;
// eslint-disable-next-line no-undef
Quill.version =  false ? 'dev' : "1.3.7";

Quill.imports = {
  'delta': _quillDelta2.default,
  'parchment': _parchment2.default,
  'core/module': _module2.default,
  'core/theme': _theme2.default
};

function expandConfig(container, userConfig) {
  userConfig = (0, _extend2.default)(true, {
    container: container,
    modules: {
      clipboard: true,
      keyboard: true,
      history: true
    }
  }, userConfig);
  if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) {
    userConfig.theme = _theme2.default;
  } else {
    userConfig.theme = Quill.import('themes/' + userConfig.theme);
    if (userConfig.theme == null) {
      throw new Error('Invalid theme ' + userConfig.theme + '. Did you register it?');
    }
  }
  var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
  [themeConfig, userConfig].forEach(function (config) {
    config.modules = config.modules || {};
    Object.keys(config.modules).forEach(function (module) {
      if (config.modules[module] === true) {
        config.modules[module] = {};
      }
    });
  });
  var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
  var moduleConfig = moduleNames.reduce(function (config, name) {
    var moduleClass = Quill.import('modules/' + name);
    if (moduleClass == null) {
      debug.error('Cannot load ' + name + ' module. Are you sure you registered it?');
    } else {
      config[name] = moduleClass.DEFAULTS || {};
    }
    return config;
  }, {});
  // Special case toolbar shorthand
  if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) {
    userConfig.modules.toolbar = {
      container: userConfig.modules.toolbar
    };
  }
  userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, { modules: moduleConfig }, themeConfig, userConfig);
  ['bounds', 'container', 'scrollingContainer'].forEach(function (key) {
    if (typeof userConfig[key] === 'string') {
      userConfig[key] = document.querySelector(userConfig[key]);
    }
  });
  userConfig.modules = Object.keys(userConfig.modules).reduce(function (config, name) {
    if (userConfig.modules[name]) {
      config[name] = userConfig.modules[name];
    }
    return config;
  }, {});
  return userConfig;
}

// Handle selection preservation and TEXT_CHANGE emission
// common to modification APIs
function modify(modifier, source, index, shift) {
  if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) {
    return new _quillDelta2.default();
  }
  var range = index == null ? null : this.getSelection();
  var oldDelta = this.editor.delta;
  var change = modifier();
  if (range != null) {
    if (index === true) index = range.index;
    if (shift == null) {
      range = shiftRange(range, change, source);
    } else if (shift !== 0) {
      range = shiftRange(range, index, shift, source);
    }
    this.setSelection(range, _emitter4.default.sources.SILENT);
  }
  if (change.length() > 0) {
    var _emitter;

    var args = [_emitter4.default.events.TEXT_CHANGE, change, oldDelta, source];
    (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
    if (source !== _emitter4.default.sources.SILENT) {
      var _emitter2;

      (_emitter2 = this.emitter).emit.apply(_emitter2, args);
    }
  }
  return change;
}

function overload(index, length, name, value, source) {
  var formats = {};
  if (typeof index.index === 'number' && typeof index.length === 'number') {
    // Allow for throwaway end (used by insertText/insertEmbed)
    if (typeof length !== 'number') {
      source = value, value = name, name = length, length = index.length, index = index.index;
    } else {
      length = index.length, index = index.index;
    }
  } else if (typeof length !== 'number') {
    source = value, value = name, name = length, length = 0;
  }
  // Handle format being object, two format name/value strings or excluded
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    formats = name;
    source = value;
  } else if (typeof name === 'string') {
    if (value != null) {
      formats[name] = value;
    } else {
      source = name;
    }
  }
  // Handle optional source
  source = source || _emitter4.default.sources.API;
  return [index, length, formats, source];
}

function shiftRange(range, index, length, source) {
  if (range == null) return null;
  var start = void 0,
      end = void 0;
  if (index instanceof _quillDelta2.default) {
    var _map = [range.index, range.index + range.length].map(function (pos) {
      return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
    });

    var _map2 = _slicedToArray(_map, 2);

    start = _map2[0];
    end = _map2[1];
  } else {
    var _map3 = [range.index, range.index + range.length].map(function (pos) {
      if (pos < index || pos === index && source === _emitter4.default.sources.USER) return pos;
      if (length >= 0) {
        return pos + length;
      } else {
        return Math.max(index, pos + length);
      }
    });

    var _map4 = _slicedToArray(_map3, 2);

    start = _map4[0];
    end = _map4[1];
  }
  return new _selection.Range(start, end - start);
}

exports.expandConfig = expandConfig;
exports.overload = overload;
exports.default = Quill;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Inline = function (_Parchment$Inline) {
  _inherits(Inline, _Parchment$Inline);

  function Inline() {
    _classCallCheck(this, Inline);

    return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
  }

  _createClass(Inline, [{
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
        var blot = this.isolate(index, length);
        if (value) {
          blot.wrap(name, value);
        }
      } else {
        _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'formatAt', this).call(this, index, length, name, value);
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'optimize', this).call(this, context);
      if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
        var parent = this.parent.isolate(this.offset(), this.length());
        this.moveChildren(parent);
        parent.wrap(this);
      }
    }
  }], [{
    key: 'compare',
    value: function compare(self, other) {
      var selfIndex = Inline.order.indexOf(self);
      var otherIndex = Inline.order.indexOf(other);
      if (selfIndex >= 0 || otherIndex >= 0) {
        return selfIndex - otherIndex;
      } else if (self === other) {
        return 0;
      } else if (self < other) {
        return -1;
      } else {
        return 1;
      }
    }
  }]);

  return Inline;
}(_parchment2.default.Inline);

Inline.allowedChildren = [Inline, _parchment2.default.Embed, _text2.default];
// Lower index means deeper in the DOM tree, since not found (-1) is for embeds
Inline.order = ['cursor', 'inline', // Must be lower
'underline', 'strike', 'italic', 'bold', 'script', 'link', 'code' // Must be higher
];

exports.default = Inline;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextBlot = function (_Parchment$Text) {
  _inherits(TextBlot, _Parchment$Text);

  function TextBlot() {
    _classCallCheck(this, TextBlot);

    return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
  }

  return TextBlot;
}(_parchment2.default.Text);

exports.default = TextBlot;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _eventemitter = __webpack_require__(54);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:events');

var EVENTS = ['selectionchange', 'mousedown', 'mouseup', 'click'];

EVENTS.forEach(function (eventName) {
  document.addEventListener(eventName, function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    [].slice.call(document.querySelectorAll('.ql-container')).forEach(function (node) {
      // TODO use WeakMap
      if (node.__quill && node.__quill.emitter) {
        var _node$__quill$emitter;

        (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
      }
    });
  });
});

var Emitter = function (_EventEmitter) {
  _inherits(Emitter, _EventEmitter);

  function Emitter() {
    _classCallCheck(this, Emitter);

    var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));

    _this.listeners = {};
    _this.on('error', debug.error);
    return _this;
  }

  _createClass(Emitter, [{
    key: 'emit',
    value: function emit() {
      debug.log.apply(debug, arguments);
      _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), 'emit', this).apply(this, arguments);
    }
  }, {
    key: 'handleDOM',
    value: function handleDOM(event) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      (this.listeners[event.type] || []).forEach(function (_ref) {
        var node = _ref.node,
            handler = _ref.handler;

        if (event.target === node || node.contains(event.target)) {
          handler.apply(undefined, [event].concat(args));
        }
      });
    }
  }, {
    key: 'listenDOM',
    value: function listenDOM(eventName, node, handler) {
      if (!this.listeners[eventName]) {
        this.listeners[eventName] = [];
      }
      this.listeners[eventName].push({ node: node, handler: handler });
    }
  }]);

  return Emitter;
}(_eventemitter2.default);

Emitter.events = {
  EDITOR_CHANGE: 'editor-change',
  SCROLL_BEFORE_UPDATE: 'scroll-before-update',
  SCROLL_OPTIMIZE: 'scroll-optimize',
  SCROLL_UPDATE: 'scroll-update',
  SELECTION_CHANGE: 'selection-change',
  TEXT_CHANGE: 'text-change'
};
Emitter.sources = {
  API: 'api',
  SILENT: 'silent',
  USER: 'user'
};

exports.default = Emitter;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Module = function Module(quill) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _classCallCheck(this, Module);

  this.quill = quill;
  this.options = options;
};

Module.DEFAULTS = {};

exports.default = Module;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var levels = ['error', 'warn', 'log', 'info'];
var level = 'warn';

function debug(method) {
  if (levels.indexOf(method) <= levels.indexOf(level)) {
    var _console;

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
  }
}

function namespace(ns) {
  return levels.reduce(function (logger, method) {
    logger[method] = debug.bind(console, method, ns);
    return logger;
  }, {});
}

debug.level = namespace.level = function (newLevel) {
  level = newLevel;
};

exports.default = namespace;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(52);
var isArguments = __webpack_require__(53);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Registry = __webpack_require__(1);
var Attributor = /** @class */ (function () {
    function Attributor(attrName, keyName, options) {
        if (options === void 0) { options = {}; }
        this.attrName = attrName;
        this.keyName = keyName;
        var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
        if (options.scope != null) {
            // Ignore type bits, force attribute bit
            this.scope = (options.scope & Registry.Scope.LEVEL) | attributeBit;
        }
        else {
            this.scope = Registry.Scope.ATTRIBUTE;
        }
        if (options.whitelist != null)
            this.whitelist = options.whitelist;
    }
    Attributor.keys = function (node) {
        return [].map.call(node.attributes, function (item) {
            return item.name;
        });
    };
    Attributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        node.setAttribute(this.keyName, value);
        return true;
    };
    Attributor.prototype.canAdd = function (node, value) {
        var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
        if (match == null)
            return false;
        if (this.whitelist == null)
            return true;
        if (typeof value === 'string') {
            return this.whitelist.indexOf(value.replace(/["']/g, '')) > -1;
        }
        else {
            return this.whitelist.indexOf(value) > -1;
        }
    };
    Attributor.prototype.remove = function (node) {
        node.removeAttribute(this.keyName);
    };
    Attributor.prototype.value = function (node) {
        var value = node.getAttribute(this.keyName);
        if (this.canAdd(node, value) && value) {
            return value;
        }
        return '';
    };
    return Attributor;
}());
exports.default = Attributor;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Code = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Code = function (_Inline) {
  _inherits(Code, _Inline);

  function Code() {
    _classCallCheck(this, Code);

    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
  }

  return Code;
}(_inline2.default);

Code.blotName = 'code';
Code.tagName = 'CODE';

var CodeBlock = function (_Block) {
  _inherits(CodeBlock, _Block);

  function CodeBlock() {
    _classCallCheck(this, CodeBlock);

    return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
  }

  _createClass(CodeBlock, [{
    key: 'delta',
    value: function delta() {
      var _this3 = this;

      var text = this.domNode.textContent;
      if (text.endsWith('\n')) {
        // Should always be true
        text = text.slice(0, -1);
      }
      return text.split('\n').reduce(function (delta, frag) {
        return delta.insert(frag).insert('\n', _this3.formats());
      }, new _quillDelta2.default());
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      if (name === this.statics.blotName && value) return;

      var _descendant = this.descendant(_text2.default, this.length() - 1),
          _descendant2 = _slicedToArray(_descendant, 1),
          text = _descendant2[0];

      if (text != null) {
        text.deleteAt(text.length() - 1, 1);
      }
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'format', this).call(this, name, value);
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (length === 0) return;
      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) {
        return;
      }
      var nextNewline = this.newlineIndex(index);
      if (nextNewline < 0 || nextNewline >= index + length) return;
      var prevNewline = this.newlineIndex(index, true) + 1;
      var isolateLength = nextNewline - prevNewline + 1;
      var blot = this.isolate(prevNewline, isolateLength);
      var next = blot.next;
      blot.format(name, value);
      if (next instanceof CodeBlock) {
        next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
      }
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null) return;

      var _descendant3 = this.descendant(_text2.default, index),
          _descendant4 = _slicedToArray(_descendant3, 2),
          text = _descendant4[0],
          offset = _descendant4[1];

      text.insertAt(offset, value);
    }
  }, {
    key: 'length',
    value: function length() {
      var length = this.domNode.textContent.length;
      if (!this.domNode.textContent.endsWith('\n')) {
        return length + 1;
      }
      return length;
    }
  }, {
    key: 'newlineIndex',
    value: function newlineIndex(searchIndex) {
      var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!reverse) {
        var offset = this.domNode.textContent.slice(searchIndex).indexOf('\n');
        return offset > -1 ? searchIndex + offset : -1;
      } else {
        return this.domNode.textContent.slice(0, searchIndex).lastIndexOf('\n');
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      if (!this.domNode.textContent.endsWith('\n')) {
        this.appendChild(_parchment2.default.create('text', '\n'));
      }
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'optimize', this).call(this, context);
      var next = this.next;
      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
        next.optimize(context);
        next.moveChildren(this);
        next.remove();
      }
    }
  }, {
    key: 'replace',
    value: function replace(target) {
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'replace', this).call(this, target);
      [].slice.call(this.domNode.querySelectorAll('*')).forEach(function (node) {
        var blot = _parchment2.default.find(node);
        if (blot == null) {
          node.parentNode.removeChild(node);
        } else if (blot instanceof _parchment2.default.Embed) {
          blot.remove();
        } else {
          blot.unwrap();
        }
      });
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), 'create', this).call(this, value);
      domNode.setAttribute('spellcheck', false);
      return domNode;
    }
  }, {
    key: 'formats',
    value: function formats() {
      return true;
    }
  }]);

  return CodeBlock;
}(_block2.default);

CodeBlock.blotName = 'code-block';
CodeBlock.tagName = 'PRE';
CodeBlock.TAB = '  ';

exports.Code = Code;
exports.default = CodeBlock;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _op = __webpack_require__(20);

var _op2 = _interopRequireDefault(_op);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _cursor = __webpack_require__(24);

var _cursor2 = _interopRequireDefault(_cursor);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __webpack_require__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ASCII = /^[ -~]*$/;

var Editor = function () {
  function Editor(scroll) {
    _classCallCheck(this, Editor);

    this.scroll = scroll;
    this.delta = this.getDelta();
  }

  _createClass(Editor, [{
    key: 'applyDelta',
    value: function applyDelta(delta) {
      var _this = this;

      var consumeNextNewline = false;
      this.scroll.update();
      var scrollLength = this.scroll.length();
      this.scroll.batchStart();
      delta = normalizeDelta(delta);
      delta.reduce(function (index, op) {
        var length = op.retain || op.delete || op.insert.length || 1;
        var attributes = op.attributes || {};
        if (op.insert != null) {
          if (typeof op.insert === 'string') {
            var text = op.insert;
            if (text.endsWith('\n') && consumeNextNewline) {
              consumeNextNewline = false;
              text = text.slice(0, -1);
            }
            if (index >= scrollLength && !text.endsWith('\n')) {
              consumeNextNewline = true;
            }
            _this.scroll.insertAt(index, text);

            var _scroll$line = _this.scroll.line(index),
                _scroll$line2 = _slicedToArray(_scroll$line, 2),
                line = _scroll$line2[0],
                offset = _scroll$line2[1];

            var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
            if (line instanceof _block2.default) {
              var _line$descendant = line.descendant(_parchment2.default.Leaf, offset),
                  _line$descendant2 = _slicedToArray(_line$descendant, 1),
                  leaf = _line$descendant2[0];

              formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
            }
            attributes = _op2.default.attributes.diff(formats, attributes) || {};
          } else if (_typeof(op.insert) === 'object') {
            var key = Object.keys(op.insert)[0]; // There should only be one key
            if (key == null) return index;
            _this.scroll.insertAt(index, key, op.insert[key]);
          }
          scrollLength += length;
        }
        Object.keys(attributes).forEach(function (name) {
          _this.scroll.formatAt(index, length, name, attributes[name]);
        });
        return index + length;
      }, 0);
      delta.reduce(function (index, op) {
        if (typeof op.delete === 'number') {
          _this.scroll.deleteAt(index, op.delete);
          return index;
        }
        return index + (op.retain || op.insert.length || 1);
      }, 0);
      this.scroll.batchEnd();
      return this.update(delta);
    }
  }, {
    key: 'deleteText',
    value: function deleteText(index, length) {
      this.scroll.deleteAt(index, length);
      return this.update(new _quillDelta2.default().retain(index).delete(length));
    }
  }, {
    key: 'formatLine',
    value: function formatLine(index, length) {
      var _this2 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.scroll.update();
      Object.keys(formats).forEach(function (format) {
        if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format]) return;
        var lines = _this2.scroll.lines(index, Math.max(length, 1));
        var lengthRemaining = length;
        lines.forEach(function (line) {
          var lineLength = line.length();
          if (!(line instanceof _code2.default)) {
            line.format(format, formats[format]);
          } else {
            var codeIndex = index - line.offset(_this2.scroll);
            var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
            line.formatAt(codeIndex, codeLength, format, formats[format]);
          }
          lengthRemaining -= lineLength;
        });
      });
      this.scroll.optimize();
      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'formatText',
    value: function formatText(index, length) {
      var _this3 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      Object.keys(formats).forEach(function (format) {
        _this3.scroll.formatAt(index, length, format, formats[format]);
      });
      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'getContents',
    value: function getContents(index, length) {
      return this.delta.slice(index, index + length);
    }
  }, {
    key: 'getDelta',
    value: function getDelta() {
      return this.scroll.lines().reduce(function (delta, line) {
        return delta.concat(line.delta());
      }, new _quillDelta2.default());
    }
  }, {
    key: 'getFormat',
    value: function getFormat(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var lines = [],
          leaves = [];
      if (length === 0) {
        this.scroll.path(index).forEach(function (path) {
          var _path = _slicedToArray(path, 1),
              blot = _path[0];

          if (blot instanceof _block2.default) {
            lines.push(blot);
          } else if (blot instanceof _parchment2.default.Leaf) {
            leaves.push(blot);
          }
        });
      } else {
        lines = this.scroll.lines(index, length);
        leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
      }
      var formatsArr = [lines, leaves].map(function (blots) {
        if (blots.length === 0) return {};
        var formats = (0, _block.bubbleFormats)(blots.shift());
        while (Object.keys(formats).length > 0) {
          var blot = blots.shift();
          if (blot == null) return formats;
          formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
        }
        return formats;
      });
      return _extend2.default.apply(_extend2.default, formatsArr);
    }
  }, {
    key: 'getText',
    value: function getText(index, length) {
      return this.getContents(index, length).filter(function (op) {
        return typeof op.insert === 'string';
      }).map(function (op) {
        return op.insert;
      }).join('');
    }
  }, {
    key: 'insertEmbed',
    value: function insertEmbed(index, embed, value) {
      this.scroll.insertAt(index, embed, value);
      return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
    }
  }, {
    key: 'insertText',
    value: function insertText(index, text) {
      var _this4 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      this.scroll.insertAt(index, text);
      Object.keys(formats).forEach(function (format) {
        _this4.scroll.formatAt(index, text.length, format, formats[format]);
      });
      return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'isBlank',
    value: function isBlank() {
      if (this.scroll.children.length == 0) return true;
      if (this.scroll.children.length > 1) return false;
      var block = this.scroll.children.head;
      if (block.statics.blotName !== _block2.default.blotName) return false;
      if (block.children.length > 1) return false;
      return block.children.head instanceof _break2.default;
    }
  }, {
    key: 'removeFormat',
    value: function removeFormat(index, length) {
      var text = this.getText(index, length);

      var _scroll$line3 = this.scroll.line(index + length),
          _scroll$line4 = _slicedToArray(_scroll$line3, 2),
          line = _scroll$line4[0],
          offset = _scroll$line4[1];

      var suffixLength = 0,
          suffix = new _quillDelta2.default();
      if (line != null) {
        if (!(line instanceof _code2.default)) {
          suffixLength = line.length() - offset;
        } else {
          suffixLength = line.newlineIndex(offset) - offset + 1;
        }
        suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
      }
      var contents = this.getContents(index, length + suffixLength);
      var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
      var delta = new _quillDelta2.default().retain(index).concat(diff);
      return this.applyDelta(delta);
    }
  }, {
    key: 'update',
    value: function update(change) {
      var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      var oldDelta = this.delta;
      if (mutations.length === 1 && mutations[0].type === 'characterData' && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
        // Optimization for character changes
        var textBlot = _parchment2.default.find(mutations[0].target);
        var formats = (0, _block.bubbleFormats)(textBlot);
        var index = textBlot.offset(this.scroll);
        var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, '');
        var oldText = new _quillDelta2.default().insert(oldValue);
        var newText = new _quillDelta2.default().insert(textBlot.value());
        var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
        change = diffDelta.reduce(function (delta, op) {
          if (op.insert) {
            return delta.insert(op.insert, formats);
          } else {
            return delta.push(op);
          }
        }, new _quillDelta2.default());
        this.delta = oldDelta.compose(change);
      } else {
        this.delta = this.getDelta();
        if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) {
          change = oldDelta.diff(this.delta, cursorIndex);
        }
      }
      return change;
    }
  }]);

  return Editor;
}();

function combineFormats(formats, combined) {
  return Object.keys(combined).reduce(function (merged, name) {
    if (formats[name] == null) return merged;
    if (combined[name] === formats[name]) {
      merged[name] = combined[name];
    } else if (Array.isArray(combined[name])) {
      if (combined[name].indexOf(formats[name]) < 0) {
        merged[name] = combined[name].concat([formats[name]]);
      }
    } else {
      merged[name] = [combined[name], formats[name]];
    }
    return merged;
  }, {});
}

function normalizeDelta(delta) {
  return delta.reduce(function (delta, op) {
    if (op.insert === 1) {
      var attributes = (0, _clone2.default)(op.attributes);
      delete attributes['image'];
      return delta.insert({ image: op.attributes.image }, attributes);
    }
    if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
      op = (0, _clone2.default)(op);
      if (op.attributes.list) {
        op.attributes.list = 'ordered';
      } else {
        op.attributes.list = 'bullet';
        delete op.attributes.bullet;
      }
    }
    if (typeof op.insert === 'string') {
      var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      return delta.insert(text, op.attributes);
    }
    return delta.push(op);
  }, new _quillDelta2.default());
}

exports.default = Editor;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Range = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __webpack_require__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _emitter3 = __webpack_require__(8);

var _emitter4 = _interopRequireDefault(_emitter3);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = (0, _logger2.default)('quill:selection');

var Range = function Range(index) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  _classCallCheck(this, Range);

  this.index = index;
  this.length = length;
};

var Selection = function () {
  function Selection(scroll, emitter) {
    var _this = this;

    _classCallCheck(this, Selection);

    this.emitter = emitter;
    this.scroll = scroll;
    this.composing = false;
    this.mouseDown = false;
    this.root = this.scroll.domNode;
    this.cursor = _parchment2.default.create('cursor', this);
    // savedRange is last non-null range
    this.lastRange = this.savedRange = new Range(0, 0);
    this.handleComposition();
    this.handleDragging();
    this.emitter.listenDOM('selectionchange', document, function () {
      if (!_this.mouseDown) {
        setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
      }
    });
    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type, delta) {
      if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) {
        _this.update(_emitter4.default.sources.SILENT);
      }
    });
    this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function () {
      if (!_this.hasFocus()) return;
      var native = _this.getNativeRange();
      if (native == null) return;
      if (native.start.node === _this.cursor.textNode) return; // cursor.restore() will handle
      // TODO unclear if this has negative side effects
      _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function () {
        try {
          _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
        } catch (ignored) {}
      });
    });
    this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function (mutations, context) {
      if (context.range) {
        var _context$range = context.range,
            startNode = _context$range.startNode,
            startOffset = _context$range.startOffset,
            endNode = _context$range.endNode,
            endOffset = _context$range.endOffset;

        _this.setNativeRange(startNode, startOffset, endNode, endOffset);
      }
    });
    this.update(_emitter4.default.sources.SILENT);
  }

  _createClass(Selection, [{
    key: 'handleComposition',
    value: function handleComposition() {
      var _this2 = this;

      this.root.addEventListener('compositionstart', function () {
        _this2.composing = true;
      });
      this.root.addEventListener('compositionend', function () {
        _this2.composing = false;
        if (_this2.cursor.parent) {
          var range = _this2.cursor.restore();
          if (!range) return;
          setTimeout(function () {
            _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
          }, 1);
        }
      });
    }
  }, {
    key: 'handleDragging',
    value: function handleDragging() {
      var _this3 = this;

      this.emitter.listenDOM('mousedown', document.body, function () {
        _this3.mouseDown = true;
      });
      this.emitter.listenDOM('mouseup', document.body, function () {
        _this3.mouseDown = false;
        _this3.update(_emitter4.default.sources.USER);
      });
    }
  }, {
    key: 'focus',
    value: function focus() {
      if (this.hasFocus()) return;
      this.root.focus();
      this.setRange(this.savedRange);
    }
  }, {
    key: 'format',
    value: function format(_format, value) {
      if (this.scroll.whitelist != null && !this.scroll.whitelist[_format]) return;
      this.scroll.update();
      var nativeRange = this.getNativeRange();
      if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;
      if (nativeRange.start.node !== this.cursor.textNode) {
        var blot = _parchment2.default.find(nativeRange.start.node, false);
        if (blot == null) return;
        // TODO Give blot ability to not split
        if (blot instanceof _parchment2.default.Leaf) {
          var after = blot.split(nativeRange.start.offset);
          blot.parent.insertBefore(this.cursor, after);
        } else {
          blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
        }
        this.cursor.attach();
      }
      this.cursor.format(_format, value);
      this.scroll.optimize();
      this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
      this.update();
    }
  }, {
    key: 'getBounds',
    value: function getBounds(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var scrollLength = this.scroll.length();
      index = Math.min(index, scrollLength - 1);
      length = Math.min(index + length, scrollLength - 1) - index;
      var node = void 0,
          _scroll$leaf = this.scroll.leaf(index),
          _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2),
          leaf = _scroll$leaf2[0],
          offset = _scroll$leaf2[1];
      if (leaf == null) return null;

      var _leaf$position = leaf.position(offset, true);

      var _leaf$position2 = _slicedToArray(_leaf$position, 2);

      node = _leaf$position2[0];
      offset = _leaf$position2[1];

      var range = document.createRange();
      if (length > 0) {
        range.setStart(node, offset);

        var _scroll$leaf3 = this.scroll.leaf(index + length);

        var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);

        leaf = _scroll$leaf4[0];
        offset = _scroll$leaf4[1];

        if (leaf == null) return null;

        var _leaf$position3 = leaf.position(offset, true);

        var _leaf$position4 = _slicedToArray(_leaf$position3, 2);

        node = _leaf$position4[0];
        offset = _leaf$position4[1];

        range.setEnd(node, offset);
        return range.getBoundingClientRect();
      } else {
        var side = 'left';
        var rect = void 0;
        if (node instanceof Text) {
          if (offset < node.data.length) {
            range.setStart(node, offset);
            range.setEnd(node, offset + 1);
          } else {
            range.setStart(node, offset - 1);
            range.setEnd(node, offset);
            side = 'right';
          }
          rect = range.getBoundingClientRect();
        } else {
          rect = leaf.domNode.getBoundingClientRect();
          if (offset > 0) side = 'right';
        }
        return {
          bottom: rect.top + rect.height,
          height: rect.height,
          left: rect[side],
          right: rect[side],
          top: rect.top,
          width: 0
        };
      }
    }
  }, {
    key: 'getNativeRange',
    value: function getNativeRange() {
      var selection = document.getSelection();
      if (selection == null || selection.rangeCount <= 0) return null;
      var nativeRange = selection.getRangeAt(0);
      if (nativeRange == null) return null;
      var range = this.normalizeNative(nativeRange);
      debug.info('getNativeRange', range);
      return range;
    }
  }, {
    key: 'getRange',
    value: function getRange() {
      var normalized = this.getNativeRange();
      if (normalized == null) return [null, null];
      var range = this.normalizedToRange(normalized);
      return [range, normalized];
    }
  }, {
    key: 'hasFocus',
    value: function hasFocus() {
      return document.activeElement === this.root;
    }
  }, {
    key: 'normalizedToRange',
    value: function normalizedToRange(range) {
      var _this4 = this;

      var positions = [[range.start.node, range.start.offset]];
      if (!range.native.collapsed) {
        positions.push([range.end.node, range.end.offset]);
      }
      var indexes = positions.map(function (position) {
        var _position = _slicedToArray(position, 2),
            node = _position[0],
            offset = _position[1];

        var blot = _parchment2.default.find(node, true);
        var index = blot.offset(_this4.scroll);
        if (offset === 0) {
          return index;
        } else if (blot instanceof _parchment2.default.Container) {
          return index + blot.length();
        } else {
          return index + blot.index(node, offset);
        }
      });
      var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
      var start = Math.min.apply(Math, [end].concat(_toConsumableArray(indexes)));
      return new Range(start, end - start);
    }
  }, {
    key: 'normalizeNative',
    value: function normalizeNative(nativeRange) {
      if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {
        return null;
      }
      var range = {
        start: { node: nativeRange.startContainer, offset: nativeRange.startOffset },
        end: { node: nativeRange.endContainer, offset: nativeRange.endOffset },
        native: nativeRange
      };
      [range.start, range.end].forEach(function (position) {
        var node = position.node,
            offset = position.offset;
        while (!(node instanceof Text) && node.childNodes.length > 0) {
          if (node.childNodes.length > offset) {
            node = node.childNodes[offset];
            offset = 0;
          } else if (node.childNodes.length === offset) {
            node = node.lastChild;
            offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
          } else {
            break;
          }
        }
        position.node = node, position.offset = offset;
      });
      return range;
    }
  }, {
    key: 'rangeToNative',
    value: function rangeToNative(range) {
      var _this5 = this;

      var indexes = range.collapsed ? [range.index] : [range.index, range.index + range.length];
      var args = [];
      var scrollLength = this.scroll.length();
      indexes.forEach(function (index, i) {
        index = Math.min(scrollLength - 1, index);
        var node = void 0,
            _scroll$leaf5 = _this5.scroll.leaf(index),
            _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2),
            leaf = _scroll$leaf6[0],
            offset = _scroll$leaf6[1];
        var _leaf$position5 = leaf.position(offset, i !== 0);

        var _leaf$position6 = _slicedToArray(_leaf$position5, 2);

        node = _leaf$position6[0];
        offset = _leaf$position6[1];

        args.push(node, offset);
      });
      if (args.length < 2) {
        args = args.concat(args);
      }
      return args;
    }
  }, {
    key: 'scrollIntoView',
    value: function scrollIntoView(scrollingContainer) {
      var range = this.lastRange;
      if (range == null) return;
      var bounds = this.getBounds(range.index, range.length);
      if (bounds == null) return;
      var limit = this.scroll.length() - 1;

      var _scroll$line = this.scroll.line(Math.min(range.index, limit)),
          _scroll$line2 = _slicedToArray(_scroll$line, 1),
          first = _scroll$line2[0];

      var last = first;
      if (range.length > 0) {
        var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));

        var _scroll$line4 = _slicedToArray(_scroll$line3, 1);

        last = _scroll$line4[0];
      }
      if (first == null || last == null) return;
      var scrollBounds = scrollingContainer.getBoundingClientRect();
      if (bounds.top < scrollBounds.top) {
        scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
      } else if (bounds.bottom > scrollBounds.bottom) {
        scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
      }
    }
  }, {
    key: 'setNativeRange',
    value: function setNativeRange(startNode, startOffset) {
      var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
      var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
      var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
      if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {
        return;
      }
      var selection = document.getSelection();
      if (selection == null) return;
      if (startNode != null) {
        if (!this.hasFocus()) this.root.focus();
        var native = (this.getNativeRange() || {}).native;
        if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {

          if (startNode.tagName == "BR") {
            startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
            startNode = startNode.parentNode;
          }
          if (endNode.tagName == "BR") {
            endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
            endNode = endNode.parentNode;
          }
          var range = document.createRange();
          range.setStart(startNode, startOffset);
          range.setEnd(endNode, endOffset);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      } else {
        selection.removeAllRanges();
        this.root.blur();
        document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
      }
    }
  }, {
    key: 'setRange',
    value: function setRange(range) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

      if (typeof force === 'string') {
        source = force;
        force = false;
      }
      debug.info('setRange', range);
      if (range != null) {
        var args = this.rangeToNative(range);
        this.setNativeRange.apply(this, _toConsumableArray(args).concat([force]));
      } else {
        this.setNativeRange(null);
      }
      this.update(source);
    }
  }, {
    key: 'update',
    value: function update() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;

      var oldRange = this.lastRange;

      var _getRange = this.getRange(),
          _getRange2 = _slicedToArray(_getRange, 2),
          lastRange = _getRange2[0],
          nativeRange = _getRange2[1];

      this.lastRange = lastRange;
      if (this.lastRange != null) {
        this.savedRange = this.lastRange;
      }
      if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
        var _emitter;

        if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
          this.cursor.restore();
        }
        var args = [_emitter4.default.events.SELECTION_CHANGE, (0, _clone2.default)(this.lastRange), (0, _clone2.default)(oldRange), source];
        (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
        if (source !== _emitter4.default.sources.SILENT) {
          var _emitter2;

          (_emitter2 = this.emitter).emit.apply(_emitter2, args);
        }
      }
    }
  }]);

  return Selection;
}();

function contains(parent, descendant) {
  try {
    // Firefox inserts inaccessible nodes around video elements
    descendant.parentNode;
  } catch (e) {
    return false;
  }
  // IE11 has bug with Text nodes
  // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
  if (descendant instanceof Text) {
    descendant = descendant.parentNode;
  }
  return parent.contains(descendant);
}

exports.Range = Range;
exports.default = Selection;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Break = function (_Parchment$Embed) {
  _inherits(Break, _Parchment$Embed);

  function Break() {
    _classCallCheck(this, Break);

    return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
  }

  _createClass(Break, [{
    key: 'insertInto',
    value: function insertInto(parent, ref) {
      if (parent.children.length === 0) {
        _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), 'insertInto', this).call(this, parent, ref);
      } else {
        this.remove();
      }
    }
  }, {
    key: 'length',
    value: function length() {
      return 0;
    }
  }, {
    key: 'value',
    value: function value() {
      return '';
    }
  }], [{
    key: 'value',
    value: function value() {
      return undefined;
    }
  }]);

  return Break;
}(_parchment2.default.Embed);

Break.blotName = 'break';
Break.tagName = 'BR';

exports.default = Break;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var linked_list_1 = __webpack_require__(44);
var shadow_1 = __webpack_require__(30);
var Registry = __webpack_require__(1);
var ContainerBlot = /** @class */ (function (_super) {
    __extends(ContainerBlot, _super);
    function ContainerBlot(domNode) {
        var _this = _super.call(this, domNode) || this;
        _this.build();
        return _this;
    }
    ContainerBlot.prototype.appendChild = function (other) {
        this.insertBefore(other);
    };
    ContainerBlot.prototype.attach = function () {
        _super.prototype.attach.call(this);
        this.children.forEach(function (child) {
            child.attach();
        });
    };
    ContainerBlot.prototype.build = function () {
        var _this = this;
        this.children = new linked_list_1.default();
        // Need to be reversed for if DOM nodes already in order
        [].slice
            .call(this.domNode.childNodes)
            .reverse()
            .forEach(function (node) {
            try {
                var child = makeBlot(node);
                _this.insertBefore(child, _this.children.head || undefined);
            }
            catch (err) {
                if (err instanceof Registry.ParchmentError)
                    return;
                else
                    throw err;
            }
        });
    };
    ContainerBlot.prototype.deleteAt = function (index, length) {
        if (index === 0 && length === this.length()) {
            return this.remove();
        }
        this.children.forEachAt(index, length, function (child, offset, length) {
            child.deleteAt(offset, length);
        });
    };
    ContainerBlot.prototype.descendant = function (criteria, index) {
        var _a = this.children.find(index), child = _a[0], offset = _a[1];
        if ((criteria.blotName == null && criteria(child)) ||
            (criteria.blotName != null && child instanceof criteria)) {
            return [child, offset];
        }
        else if (child instanceof ContainerBlot) {
            return child.descendant(criteria, offset);
        }
        else {
            return [null, -1];
        }
    };
    ContainerBlot.prototype.descendants = function (criteria, index, length) {
        if (index === void 0) { index = 0; }
        if (length === void 0) { length = Number.MAX_VALUE; }
        var descendants = [];
        var lengthLeft = length;
        this.children.forEachAt(index, length, function (child, index, length) {
            if ((criteria.blotName == null && criteria(child)) ||
                (criteria.blotName != null && child instanceof criteria)) {
                descendants.push(child);
            }
            if (child instanceof ContainerBlot) {
                descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
            }
            lengthLeft -= length;
        });
        return descendants;
    };
    ContainerBlot.prototype.detach = function () {
        this.children.forEach(function (child) {
            child.detach();
        });
        _super.prototype.detach.call(this);
    };
    ContainerBlot.prototype.formatAt = function (index, length, name, value) {
        this.children.forEachAt(index, length, function (child, offset, length) {
            child.formatAt(offset, length, name, value);
        });
    };
    ContainerBlot.prototype.insertAt = function (index, value, def) {
        var _a = this.children.find(index), child = _a[0], offset = _a[1];
        if (child) {
            child.insertAt(offset, value, def);
        }
        else {
            var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
            this.appendChild(blot);
        }
    };
    ContainerBlot.prototype.insertBefore = function (childBlot, refBlot) {
        if (this.statics.allowedChildren != null &&
            !this.statics.allowedChildren.some(function (child) {
                return childBlot instanceof child;
            })) {
            throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
        }
        childBlot.insertInto(this, refBlot);
    };
    ContainerBlot.prototype.length = function () {
        return this.children.reduce(function (memo, child) {
            return memo + child.length();
        }, 0);
    };
    ContainerBlot.prototype.moveChildren = function (targetParent, refNode) {
        this.children.forEach(function (child) {
            targetParent.insertBefore(child, refNode);
        });
    };
    ContainerBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        if (this.children.length === 0) {
            if (this.statics.defaultChild != null) {
                var child = Registry.create(this.statics.defaultChild);
                this.appendChild(child);
                child.optimize(context);
            }
            else {
                this.remove();
            }
        }
    };
    ContainerBlot.prototype.path = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        var _a = this.children.find(index, inclusive), child = _a[0], offset = _a[1];
        var position = [[this, index]];
        if (child instanceof ContainerBlot) {
            return position.concat(child.path(offset, inclusive));
        }
        else if (child != null) {
            position.push([child, offset]);
        }
        return position;
    };
    ContainerBlot.prototype.removeChild = function (child) {
        this.children.remove(child);
    };
    ContainerBlot.prototype.replace = function (target) {
        if (target instanceof ContainerBlot) {
            target.moveChildren(this);
        }
        _super.prototype.replace.call(this, target);
    };
    ContainerBlot.prototype.split = function (index, force) {
        if (force === void 0) { force = false; }
        if (!force) {
            if (index === 0)
                return this;
            if (index === this.length())
                return this.next;
        }
        var after = this.clone();
        this.parent.insertBefore(after, this.next);
        this.children.forEachAt(index, this.length(), function (child, offset, length) {
            child = child.split(offset, force);
            after.appendChild(child);
        });
        return after;
    };
    ContainerBlot.prototype.unwrap = function () {
        this.moveChildren(this.parent, this.next);
        this.remove();
    };
    ContainerBlot.prototype.update = function (mutations, context) {
        var _this = this;
        var addedNodes = [];
        var removedNodes = [];
        mutations.forEach(function (mutation) {
            if (mutation.target === _this.domNode && mutation.type === 'childList') {
                addedNodes.push.apply(addedNodes, mutation.addedNodes);
                removedNodes.push.apply(removedNodes, mutation.removedNodes);
            }
        });
        removedNodes.forEach(function (node) {
            // Check node has actually been removed
            // One exception is Chrome does not immediately remove IFRAMEs
            // from DOM but MutationRecord is correct in its reported removal
            if (node.parentNode != null &&
                // @ts-ignore
                node.tagName !== 'IFRAME' &&
                document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
                return;
            }
            var blot = Registry.find(node);
            if (blot == null)
                return;
            if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) {
                blot.detach();
            }
        });
        addedNodes
            .filter(function (node) {
            return node.parentNode == _this.domNode;
        })
            .sort(function (a, b) {
            if (a === b)
                return 0;
            if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) {
                return 1;
            }
            return -1;
        })
            .forEach(function (node) {
            var refBlot = null;
            if (node.nextSibling != null) {
                refBlot = Registry.find(node.nextSibling);
            }
            var blot = makeBlot(node);
            if (blot.next != refBlot || blot.next == null) {
                if (blot.parent != null) {
                    blot.parent.removeChild(_this);
                }
                _this.insertBefore(blot, refBlot || undefined);
            }
        });
    };
    return ContainerBlot;
}(shadow_1.default));
function makeBlot(node) {
    var blot = Registry.find(node);
    if (blot == null) {
        try {
            blot = Registry.create(node);
        }
        catch (e) {
            blot = Registry.create(Registry.Scope.INLINE);
            [].slice.call(node.childNodes).forEach(function (child) {
                // @ts-ignore
                blot.domNode.appendChild(child);
            });
            if (node.parentNode) {
                node.parentNode.replaceChild(blot.domNode, node);
            }
            blot.attach();
        }
    }
    return blot;
}
exports.default = ContainerBlot;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
var store_1 = __webpack_require__(31);
var container_1 = __webpack_require__(17);
var Registry = __webpack_require__(1);
var FormatBlot = /** @class */ (function (_super) {
    __extends(FormatBlot, _super);
    function FormatBlot(domNode) {
        var _this = _super.call(this, domNode) || this;
        _this.attributes = new store_1.default(_this.domNode);
        return _this;
    }
    FormatBlot.formats = function (domNode) {
        if (typeof this.tagName === 'string') {
            return true;
        }
        else if (Array.isArray(this.tagName)) {
            return domNode.tagName.toLowerCase();
        }
        return undefined;
    };
    FormatBlot.prototype.format = function (name, value) {
        var format = Registry.query(name);
        if (format instanceof attributor_1.default) {
            this.attributes.attribute(format, value);
        }
        else if (value) {
            if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) {
                this.replaceWith(name, value);
            }
        }
    };
    FormatBlot.prototype.formats = function () {
        var formats = this.attributes.values();
        var format = this.statics.formats(this.domNode);
        if (format != null) {
            formats[this.statics.blotName] = format;
        }
        return formats;
    };
    FormatBlot.prototype.replaceWith = function (name, value) {
        var replacement = _super.prototype.replaceWith.call(this, name, value);
        this.attributes.copy(replacement);
        return replacement;
    };
    FormatBlot.prototype.update = function (mutations, context) {
        var _this = this;
        _super.prototype.update.call(this, mutations, context);
        if (mutations.some(function (mutation) {
            return mutation.target === _this.domNode && mutation.type === 'attributes';
        })) {
            this.attributes.build();
        }
    };
    FormatBlot.prototype.wrap = function (name, value) {
        var wrapper = _super.prototype.wrap.call(this, name, value);
        if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) {
            this.attributes.move(wrapper);
        }
        return wrapper;
    };
    return FormatBlot;
}(container_1.default));
exports.default = FormatBlot;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var shadow_1 = __webpack_require__(30);
var Registry = __webpack_require__(1);
var LeafBlot = /** @class */ (function (_super) {
    __extends(LeafBlot, _super);
    function LeafBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LeafBlot.value = function (domNode) {
        return true;
    };
    LeafBlot.prototype.index = function (node, offset) {
        if (this.domNode === node ||
            this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return Math.min(offset, 1);
        }
        return -1;
    };
    LeafBlot.prototype.position = function (index, inclusive) {
        var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
        if (index > 0)
            offset += 1;
        return [this.parent.domNode, offset];
    };
    LeafBlot.prototype.value = function () {
        var _a;
        return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
    };
    LeafBlot.scope = Registry.Scope.INLINE_BLOT;
    return LeafBlot;
}(shadow_1.default));
exports.default = LeafBlot;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var equal = __webpack_require__(11);
var extend = __webpack_require__(3);


var lib = {
  attributes: {
    compose: function (a, b, keepNull) {
      if (typeof a !== 'object') a = {};
      if (typeof b !== 'object') b = {};
      var attributes = extend(true, {}, b);
      if (!keepNull) {
        attributes = Object.keys(attributes).reduce(function (copy, key) {
          if (attributes[key] != null) {
            copy[key] = attributes[key];
          }
          return copy;
        }, {});
      }
      for (var key in a) {
        if (a[key] !== undefined && b[key] === undefined) {
          attributes[key] = a[key];
        }
      }
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    },

    diff: function(a, b) {
      if (typeof a !== 'object') a = {};
      if (typeof b !== 'object') b = {};
      var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function (attributes, key) {
        if (!equal(a[key], b[key])) {
          attributes[key] = b[key] === undefined ? null : b[key];
        }
        return attributes;
      }, {});
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    },

    transform: function (a, b, priority) {
      if (typeof a !== 'object') return b;
      if (typeof b !== 'object') return undefined;
      if (!priority) return b;  // b simply overwrites us without priority
      var attributes = Object.keys(b).reduce(function (attributes, key) {
        if (a[key] === undefined) attributes[key] = b[key];  // null is a valid value
        return attributes;
      }, {});
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
  },

  iterator: function (ops) {
    return new Iterator(ops);
  },

  length: function (op) {
    if (typeof op['delete'] === 'number') {
      return op['delete'];
    } else if (typeof op.retain === 'number') {
      return op.retain;
    } else {
      return typeof op.insert === 'string' ? op.insert.length : 1;
    }
  }
};


function Iterator(ops) {
  this.ops = ops;
  this.index = 0;
  this.offset = 0;
};

Iterator.prototype.hasNext = function () {
  return this.peekLength() < Infinity;
};

Iterator.prototype.next = function (length) {
  if (!length) length = Infinity;
  var nextOp = this.ops[this.index];
  if (nextOp) {
    var offset = this.offset;
    var opLength = lib.length(nextOp)
    if (length >= opLength - offset) {
      length = opLength - offset;
      this.index += 1;
      this.offset = 0;
    } else {
      this.offset += length;
    }
    if (typeof nextOp['delete'] === 'number') {
      return { 'delete': length };
    } else {
      var retOp = {};
      if (nextOp.attributes) {
        retOp.attributes = nextOp.attributes;
      }
      if (typeof nextOp.retain === 'number') {
        retOp.retain = length;
      } else if (typeof nextOp.insert === 'string') {
        retOp.insert = nextOp.insert.substr(offset, length);
      } else {
        // offset should === 0, length should === 1
        retOp.insert = nextOp.insert;
      }
      return retOp;
    }
  } else {
    return { retain: Infinity };
  }
};

Iterator.prototype.peek = function () {
  return this.ops[this.index];
};

Iterator.prototype.peekLength = function () {
  if (this.ops[this.index]) {
    // Should never return 0 if our index is being managed correctly
    return lib.length(this.ops[this.index]) - this.offset;
  } else {
    return Infinity;
  }
};

Iterator.prototype.peekType = function () {
  if (this.ops[this.index]) {
    if (typeof this.ops[this.index]['delete'] === 'number') {
      return 'delete';
    } else if (typeof this.ops[this.index].retain === 'number') {
      return 'retain';
    } else {
      return 'insert';
    }
  }
  return 'retain';
};

Iterator.prototype.rest = function () {
  if (!this.hasNext()) {
    return [];
  } else if (this.offset === 0) {
    return this.ops.slice(this.index);
  } else {
    var offset = this.offset;
    var index = this.index;
    var next = this.next();
    var rest = this.ops.slice(this.index);
    this.offset = offset;
    this.index = index;
    return [next].concat(rest);
  }
};


module.exports = lib;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

var clone = (function() {
'use strict';

function _instanceof(obj, type) {
  return type != null && obj instanceof type;
}

var nativeMap;
try {
  nativeMap = Map;
} catch(_) {
  // maybe a reference error because no `Map`. Give it a dummy value that no
  // value will ever be an instanceof.
  nativeMap = function() {};
}

var nativeSet;
try {
  nativeSet = Set;
} catch(_) {
  nativeSet = function() {};
}

var nativePromise;
try {
  nativePromise = Promise;
} catch(_) {
  nativePromise = function() {};
}

/**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/
function clone(parent, circular, depth, prototype, includeNonEnumerable) {
  if (typeof circular === 'object') {
    depth = circular.depth;
    prototype = circular.prototype;
    includeNonEnumerable = circular.includeNonEnumerable;
    circular = circular.circular;
  }
  // maintain two arrays for circular references, where corresponding parents
  // and children have the same index
  var allParents = [];
  var allChildren = [];

  var useBuffer = typeof Buffer != 'undefined';

  if (typeof circular == 'undefined')
    circular = true;

  if (typeof depth == 'undefined')
    depth = Infinity;

  // recurse this function so we don't reset allParents and allChildren
  function _clone(parent, depth) {
    // cloning null always returns null
    if (parent === null)
      return null;

    if (depth === 0)
      return parent;

    var child;
    var proto;
    if (typeof parent != 'object') {
      return parent;
    }

    if (_instanceof(parent, nativeMap)) {
      child = new nativeMap();
    } else if (_instanceof(parent, nativeSet)) {
      child = new nativeSet();
    } else if (_instanceof(parent, nativePromise)) {
      child = new nativePromise(function (resolve, reject) {
        parent.then(function(value) {
          resolve(_clone(value, depth - 1));
        }, function(err) {
          reject(_clone(err, depth - 1));
        });
      });
    } else if (clone.__isArray(parent)) {
      child = [];
    } else if (clone.__isRegExp(parent)) {
      child = new RegExp(parent.source, __getRegExpFlags(parent));
      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
    } else if (clone.__isDate(parent)) {
      child = new Date(parent.getTime());
    } else if (useBuffer && Buffer.isBuffer(parent)) {
      if (Buffer.allocUnsafe) {
        // Node.js >= 4.5.0
        child = Buffer.allocUnsafe(parent.length);
      } else {
        // Older Node.js versions
        child = new Buffer(parent.length);
      }
      parent.copy(child);
      return child;
    } else if (_instanceof(parent, Error)) {
      child = Object.create(parent);
    } else {
      if (typeof prototype == 'undefined') {
        proto = Object.getPrototypeOf(parent);
        child = Object.create(proto);
      }
      else {
        child = Object.create(prototype);
        proto = prototype;
      }
    }

    if (circular) {
      var index = allParents.indexOf(parent);

      if (index != -1) {
        return allChildren[index];
      }
      allParents.push(parent);
      allChildren.push(child);
    }

    if (_instanceof(parent, nativeMap)) {
      parent.forEach(function(value, key) {
        var keyChild = _clone(key, depth - 1);
        var valueChild = _clone(value, depth - 1);
        child.set(keyChild, valueChild);
      });
    }
    if (_instanceof(parent, nativeSet)) {
      parent.forEach(function(value) {
        var entryChild = _clone(value, depth - 1);
        child.add(entryChild);
      });
    }

    for (var i in parent) {
      var attrs;
      if (proto) {
        attrs = Object.getOwnPropertyDescriptor(proto, i);
      }

      if (attrs && attrs.set == null) {
        continue;
      }
      child[i] = _clone(parent[i], depth - 1);
    }

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(parent);
      for (var i = 0; i < symbols.length; i++) {
        // Don't need to worry about cloning a symbol because it is a primitive,
        // like a number or string.
        var symbol = symbols[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
          continue;
        }
        child[symbol] = _clone(parent[symbol], depth - 1);
        if (!descriptor.enumerable) {
          Object.defineProperty(child, symbol, {
            enumerable: false
          });
        }
      }
    }

    if (includeNonEnumerable) {
      var allPropertyNames = Object.getOwnPropertyNames(parent);
      for (var i = 0; i < allPropertyNames.length; i++) {
        var propertyName = allPropertyNames[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
        if (descriptor && descriptor.enumerable) {
          continue;
        }
        child[propertyName] = _clone(parent[propertyName], depth - 1);
        Object.defineProperty(child, propertyName, {
          enumerable: false
        });
      }
    }

    return child;
  }

  return _clone(parent, depth);
}

/**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */
clone.clonePrototype = function clonePrototype(parent) {
  if (parent === null)
    return null;

  var c = function () {};
  c.prototype = parent;
  return new c();
};

// private utility functions

function __objToStr(o) {
  return Object.prototype.toString.call(o);
}
clone.__objToStr = __objToStr;

function __isDate(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Date]';
}
clone.__isDate = __isDate;

function __isArray(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Array]';
}
clone.__isArray = __isArray;

function __isRegExp(o) {
  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
}
clone.__isRegExp = __isRegExp;

function __getRegExpFlags(re) {
  var flags = '';
  if (re.global) flags += 'g';
  if (re.ignoreCase) flags += 'i';
  if (re.multiline) flags += 'm';
  return flags;
}
clone.__getRegExpFlags = __getRegExpFlags;

return clone;
})();

if (typeof module === 'object' && module.exports) {
  module.exports = clone;
}


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _container = __webpack_require__(25);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function isLine(blot) {
  return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
}

var Scroll = function (_Parchment$Scroll) {
  _inherits(Scroll, _Parchment$Scroll);

  function Scroll(domNode, config) {
    _classCallCheck(this, Scroll);

    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));

    _this.emitter = config.emitter;
    if (Array.isArray(config.whitelist)) {
      _this.whitelist = config.whitelist.reduce(function (whitelist, format) {
        whitelist[format] = true;
        return whitelist;
      }, {});
    }
    // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
    _this.domNode.addEventListener('DOMNodeInserted', function () {});
    _this.optimize();
    _this.enable();
    return _this;
  }

  _createClass(Scroll, [{
    key: 'batchStart',
    value: function batchStart() {
      this.batch = true;
    }
  }, {
    key: 'batchEnd',
    value: function batchEnd() {
      this.batch = false;
      this.optimize();
    }
  }, {
    key: 'deleteAt',
    value: function deleteAt(index, length) {
      var _line = this.line(index),
          _line2 = _slicedToArray(_line, 2),
          first = _line2[0],
          offset = _line2[1];

      var _line3 = this.line(index + length),
          _line4 = _slicedToArray(_line3, 1),
          last = _line4[0];

      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'deleteAt', this).call(this, index, length);
      if (last != null && first !== last && offset > 0) {
        if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
          this.optimize();
          return;
        }
        if (first instanceof _code2.default) {
          var newlineIndex = first.newlineIndex(first.length(), true);
          if (newlineIndex > -1) {
            first = first.split(newlineIndex + 1);
            if (first === last) {
              this.optimize();
              return;
            }
          }
        } else if (last instanceof _code2.default) {
          var _newlineIndex = last.newlineIndex(0);
          if (_newlineIndex > -1) {
            last.split(_newlineIndex + 1);
          }
        }
        var ref = last.children.head instanceof _break2.default ? null : last.children.head;
        first.moveChildren(last, ref);
        first.remove();
      }
      this.optimize();
    }
  }, {
    key: 'enable',
    value: function enable() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.domNode.setAttribute('contenteditable', enabled);
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, format, value) {
      if (this.whitelist != null && !this.whitelist[format]) return;
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'formatAt', this).call(this, index, length, format, value);
      this.optimize();
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null && this.whitelist != null && !this.whitelist[value]) return;
      if (index >= this.length()) {
        if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
          var blot = _parchment2.default.create(this.statics.defaultChild);
          this.appendChild(blot);
          if (def == null && value.endsWith('\n')) {
            value = value.slice(0, -1);
          }
          blot.insertAt(0, value, def);
        } else {
          var embed = _parchment2.default.create(value, def);
          this.appendChild(embed);
        }
      } else {
        _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertAt', this).call(this, index, value, def);
      }
      this.optimize();
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
        var wrapper = _parchment2.default.create(this.statics.defaultChild);
        wrapper.appendChild(blot);
        blot = wrapper;
      }
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertBefore', this).call(this, blot, ref);
    }
  }, {
    key: 'leaf',
    value: function leaf(index) {
      return this.path(index).pop() || [null, -1];
    }
  }, {
    key: 'line',
    value: function line(index) {
      if (index === this.length()) {
        return this.line(index - 1);
      }
      return this.descendant(isLine, index);
    }
  }, {
    key: 'lines',
    value: function lines() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

      var getLines = function getLines(blot, index, length) {
        var lines = [],
            lengthLeft = length;
        blot.children.forEachAt(index, length, function (child, index, length) {
          if (isLine(child)) {
            lines.push(child);
          } else if (child instanceof _parchment2.default.Container) {
            lines = lines.concat(getLines(child, index, lengthLeft));
          }
          lengthLeft -= length;
        });
        return lines;
      };
      return getLines(this, index, length);
    }
  }, {
    key: 'optimize',
    value: function optimize() {
      var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.batch === true) return;
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'optimize', this).call(this, mutations, context);
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
      }
    }
  }, {
    key: 'path',
    value: function path(index) {
      return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'path', this).call(this, index).slice(1); // Exclude self
    }
  }, {
    key: 'update',
    value: function update(mutations) {
      if (this.batch === true) return;
      var source = _emitter2.default.sources.USER;
      if (typeof mutations === 'string') {
        source = mutations;
      }
      if (!Array.isArray(mutations)) {
        mutations = this.observer.takeRecords();
      }
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
      }
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'update', this).call(this, mutations.concat([])); // pass copy
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
      }
    }
  }]);

  return Scroll;
}(_parchment2.default.Scroll);

Scroll.blotName = 'scroll';
Scroll.className = 'ql-editor';
Scroll.tagName = 'DIV';
Scroll.defaultChild = 'block';
Scroll.allowedChildren = [_block2.default, _block.BlockEmbed, _container2.default];

exports.default = Scroll;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHORTKEY = exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __webpack_require__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _op = __webpack_require__(20);

var _op2 = _interopRequireDefault(_op);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:keyboard');

var SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';

var Keyboard = function (_Module) {
  _inherits(Keyboard, _Module);

  _createClass(Keyboard, null, [{
    key: 'match',
    value: function match(evt, binding) {
      binding = normalize(binding);
      if (['altKey', 'ctrlKey', 'metaKey', 'shiftKey'].some(function (key) {
        return !!binding[key] !== evt[key] && binding[key] !== null;
      })) {
        return false;
      }
      return binding.key === (evt.which || evt.keyCode);
    }
  }]);

  function Keyboard(quill, options) {
    _classCallCheck(this, Keyboard);

    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));

    _this.bindings = {};
    Object.keys(_this.options.bindings).forEach(function (name) {
      if (name === 'list autofill' && quill.scroll.whitelist != null && !quill.scroll.whitelist['list']) {
        return;
      }
      if (_this.options.bindings[name]) {
        _this.addBinding(_this.options.bindings[name]);
      }
    });
    _this.addBinding({ key: Keyboard.keys.ENTER, shiftKey: null }, handleEnter);
    _this.addBinding({ key: Keyboard.keys.ENTER, metaKey: null, ctrlKey: null, altKey: null }, function () {});
    if (/Firefox/i.test(navigator.userAgent)) {
      // Need to handle delete and backspace for Firefox in the general case #1171
      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true }, handleBackspace);
      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true }, handleDelete);
    } else {
      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true, prefix: /^.?$/ }, handleBackspace);
      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true, suffix: /^.?$/ }, handleDelete);
    }
    _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: false }, handleDeleteRange);
    _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: false }, handleDeleteRange);
    _this.addBinding({ key: Keyboard.keys.BACKSPACE, altKey: null, ctrlKey: null, metaKey: null, shiftKey: null }, { collapsed: true, offset: 0 }, handleBackspace);
    _this.listen();
    return _this;
  }

  _createClass(Keyboard, [{
    key: 'addBinding',
    value: function addBinding(key) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var binding = normalize(key);
      if (binding == null || binding.key == null) {
        return debug.warn('Attempted to add invalid keyboard binding', binding);
      }
      if (typeof context === 'function') {
        context = { handler: context };
      }
      if (typeof handler === 'function') {
        handler = { handler: handler };
      }
      binding = (0, _extend2.default)(binding, context, handler);
      this.bindings[binding.key] = this.bindings[binding.key] || [];
      this.bindings[binding.key].push(binding);
    }
  }, {
    key: 'listen',
    value: function listen() {
      var _this2 = this;

      this.quill.root.addEventListener('keydown', function (evt) {
        if (evt.defaultPrevented) return;
        var which = evt.which || evt.keyCode;
        var bindings = (_this2.bindings[which] || []).filter(function (binding) {
          return Keyboard.match(evt, binding);
        });
        if (bindings.length === 0) return;
        var range = _this2.quill.getSelection();
        if (range == null || !_this2.quill.hasFocus()) return;

        var _quill$getLine = _this2.quill.getLine(range.index),
            _quill$getLine2 = _slicedToArray(_quill$getLine, 2),
            line = _quill$getLine2[0],
            offset = _quill$getLine2[1];

        var _quill$getLeaf = _this2.quill.getLeaf(range.index),
            _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2),
            leafStart = _quill$getLeaf2[0],
            offsetStart = _quill$getLeaf2[1];

        var _ref = range.length === 0 ? [leafStart, offsetStart] : _this2.quill.getLeaf(range.index + range.length),
            _ref2 = _slicedToArray(_ref, 2),
            leafEnd = _ref2[0],
            offsetEnd = _ref2[1];

        var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : '';
        var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : '';
        var curContext = {
          collapsed: range.length === 0,
          empty: range.length === 0 && line.length() <= 1,
          format: _this2.quill.getFormat(range),
          offset: offset,
          prefix: prefixText,
          suffix: suffixText
        };
        var prevented = bindings.some(function (binding) {
          if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
          if (binding.empty != null && binding.empty !== curContext.empty) return false;
          if (binding.offset != null && binding.offset !== curContext.offset) return false;
          if (Array.isArray(binding.format)) {
            // any format is present
            if (binding.format.every(function (name) {
              return curContext.format[name] == null;
            })) {
              return false;
            }
          } else if (_typeof(binding.format) === 'object') {
            // all formats must match
            if (!Object.keys(binding.format).every(function (name) {
              if (binding.format[name] === true) return curContext.format[name] != null;
              if (binding.format[name] === false) return curContext.format[name] == null;
              return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
            })) {
              return false;
            }
          }
          if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
          if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
          return binding.handler.call(_this2, range, curContext) !== true;
        });
        if (prevented) {
          evt.preventDefault();
        }
      });
    }
  }]);

  return Keyboard;
}(_module2.default);

Keyboard.keys = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  ESCAPE: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46
};

Keyboard.DEFAULTS = {
  bindings: {
    'bold': makeFormatHandler('bold'),
    'italic': makeFormatHandler('italic'),
    'underline': makeFormatHandler('underline'),
    'indent': {
      // highlight tab or tab at beginning of list, indent or blockquote
      key: Keyboard.keys.TAB,
      format: ['blockquote', 'indent', 'list'],
      handler: function handler(range, context) {
        if (context.collapsed && context.offset !== 0) return true;
        this.quill.format('indent', '+1', _quill2.default.sources.USER);
      }
    },
    'outdent': {
      key: Keyboard.keys.TAB,
      shiftKey: true,
      format: ['blockquote', 'indent', 'list'],
      // highlight tab or tab at beginning of list, indent or blockquote
      handler: function handler(range, context) {
        if (context.collapsed && context.offset !== 0) return true;
        this.quill.format('indent', '-1', _quill2.default.sources.USER);
      }
    },
    'outdent backspace': {
      key: Keyboard.keys.BACKSPACE,
      collapsed: true,
      shiftKey: null,
      metaKey: null,
      ctrlKey: null,
      altKey: null,
      format: ['indent', 'list'],
      offset: 0,
      handler: function handler(range, context) {
        if (context.format.indent != null) {
          this.quill.format('indent', '-1', _quill2.default.sources.USER);
        } else if (context.format.list != null) {
          this.quill.format('list', false, _quill2.default.sources.USER);
        }
      }
    },
    'indent code-block': makeCodeBlockHandler(true),
    'outdent code-block': makeCodeBlockHandler(false),
    'remove tab': {
      key: Keyboard.keys.TAB,
      shiftKey: true,
      collapsed: true,
      prefix: /\t$/,
      handler: function handler(range) {
        this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
      }
    },
    'tab': {
      key: Keyboard.keys.TAB,
      handler: function handler(range) {
        this.quill.history.cutoff();
        var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert('\t');
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.history.cutoff();
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
      }
    },
    'list empty enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['list'],
      empty: true,
      handler: function handler(range, context) {
        this.quill.format('list', false, _quill2.default.sources.USER);
        if (context.format.indent) {
          this.quill.format('indent', false, _quill2.default.sources.USER);
        }
      }
    },
    'checklist enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: { list: 'checked' },
      handler: function handler(range) {
        var _quill$getLine3 = this.quill.getLine(range.index),
            _quill$getLine4 = _slicedToArray(_quill$getLine3, 2),
            line = _quill$getLine4[0],
            offset = _quill$getLine4[1];

        var formats = (0, _extend2.default)({}, line.formats(), { list: 'checked' });
        var delta = new _quillDelta2.default().retain(range.index).insert('\n', formats).retain(line.length() - offset - 1).retain(1, { list: 'unchecked' });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
        this.quill.scrollIntoView();
      }
    },
    'header enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['header'],
      suffix: /^$/,
      handler: function handler(range, context) {
        var _quill$getLine5 = this.quill.getLine(range.index),
            _quill$getLine6 = _slicedToArray(_quill$getLine5, 2),
            line = _quill$getLine6[0],
            offset = _quill$getLine6[1];

        var delta = new _quillDelta2.default().retain(range.index).insert('\n', context.format).retain(line.length() - offset - 1).retain(1, { header: null });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
        this.quill.scrollIntoView();
      }
    },
    'list autofill': {
      key: ' ',
      collapsed: true,
      format: { list: false },
      prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
      handler: function handler(range, context) {
        var length = context.prefix.length;

        var _quill$getLine7 = this.quill.getLine(range.index),
            _quill$getLine8 = _slicedToArray(_quill$getLine7, 2),
            line = _quill$getLine8[0],
            offset = _quill$getLine8[1];

        if (offset > length) return true;
        var value = void 0;
        switch (context.prefix.trim()) {
          case '[]':case '[ ]':
            value = 'unchecked';
            break;
          case '[x]':
            value = 'checked';
            break;
          case '-':case '*':
            value = 'bullet';
            break;
          default:
            value = 'ordered';
        }
        this.quill.insertText(range.index, ' ', _quill2.default.sources.USER);
        this.quill.history.cutoff();
        var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, { list: value });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.history.cutoff();
        this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
      }
    },
    'code exit': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['code-block'],
      prefix: /\n\n$/,
      suffix: /^\s+$/,
      handler: function handler(range) {
        var _quill$getLine9 = this.quill.getLine(range.index),
            _quill$getLine10 = _slicedToArray(_quill$getLine9, 2),
            line = _quill$getLine10[0],
            offset = _quill$getLine10[1];

        var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, { 'code-block': null }).delete(1);
        this.quill.updateContents(delta, _quill2.default.sources.USER);
      }
    },
    'embed left': makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
    'embed left shift': makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
    'embed right': makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
    'embed right shift': makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
  }
};

function makeEmbedArrowHandler(key, shiftKey) {
  var _ref3;

  var where = key === Keyboard.keys.LEFT ? 'prefix' : 'suffix';
  return _ref3 = {
    key: key,
    shiftKey: shiftKey,
    altKey: null
  }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, 'handler', function handler(range) {
    var index = range.index;
    if (key === Keyboard.keys.RIGHT) {
      index += range.length + 1;
    }

    var _quill$getLeaf3 = this.quill.getLeaf(index),
        _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1),
        leaf = _quill$getLeaf4[0];

    if (!(leaf instanceof _parchment2.default.Embed)) return true;
    if (key === Keyboard.keys.LEFT) {
      if (shiftKey) {
        this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
      } else {
        this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
      }
    } else {
      if (shiftKey) {
        this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
      } else {
        this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
      }
    }
    return false;
  }), _ref3;
}

function handleBackspace(range, context) {
  if (range.index === 0 || this.quill.getLength() <= 1) return;

  var _quill$getLine11 = this.quill.getLine(range.index),
      _quill$getLine12 = _slicedToArray(_quill$getLine11, 1),
      line = _quill$getLine12[0];

  var formats = {};
  if (context.offset === 0) {
    var _quill$getLine13 = this.quill.getLine(range.index - 1),
        _quill$getLine14 = _slicedToArray(_quill$getLine13, 1),
        prev = _quill$getLine14[0];

    if (prev != null && prev.length() > 1) {
      var curFormats = line.formats();
      var prevFormats = this.quill.getFormat(range.index - 1, 1);
      formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
    }
  }
  // Check for astral symbols
  var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
  this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
  }
  this.quill.focus();
}

function handleDelete(range, context) {
  // Check for astral symbols
  var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
  if (range.index >= this.quill.getLength() - length) return;
  var formats = {},
      nextLength = 0;

  var _quill$getLine15 = this.quill.getLine(range.index),
      _quill$getLine16 = _slicedToArray(_quill$getLine15, 1),
      line = _quill$getLine16[0];

  if (context.offset >= line.length() - 1) {
    var _quill$getLine17 = this.quill.getLine(range.index + 1),
        _quill$getLine18 = _slicedToArray(_quill$getLine17, 1),
        next = _quill$getLine18[0];

    if (next) {
      var curFormats = line.formats();
      var nextFormats = this.quill.getFormat(range.index, 1);
      formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
      nextLength = next.length();
    }
  }
  this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
  }
}

function handleDeleteRange(range) {
  var lines = this.quill.getLines(range);
  var formats = {};
  if (lines.length > 1) {
    var firstFormats = lines[0].formats();
    var lastFormats = lines[lines.length - 1].formats();
    formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
  }
  this.quill.deleteText(range, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
  }
  this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
  this.quill.focus();
}

function handleEnter(range, context) {
  var _this3 = this;

  if (range.length > 0) {
    this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
  }
  var lineFormats = Object.keys(context.format).reduce(function (lineFormats, format) {
    if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) {
      lineFormats[format] = context.format[format];
    }
    return lineFormats;
  }, {});
  this.quill.insertText(range.index, '\n', lineFormats, _quill2.default.sources.USER);
  // Earlier scroll.deleteAt might have messed up our selection,
  // so insertText's built in selection preservation is not reliable
  this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
  this.quill.focus();
  Object.keys(context.format).forEach(function (name) {
    if (lineFormats[name] != null) return;
    if (Array.isArray(context.format[name])) return;
    if (name === 'link') return;
    _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
  });
}

function makeCodeBlockHandler(indent) {
  return {
    key: Keyboard.keys.TAB,
    shiftKey: !indent,
    format: { 'code-block': true },
    handler: function handler(range) {
      var CodeBlock = _parchment2.default.query('code-block');
      var index = range.index,
          length = range.length;

      var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index),
          _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
          block = _quill$scroll$descend2[0],
          offset = _quill$scroll$descend2[1];

      if (block == null) return;
      var scrollIndex = this.quill.getIndex(block);
      var start = block.newlineIndex(offset, true) + 1;
      var end = block.newlineIndex(scrollIndex + offset + length);
      var lines = block.domNode.textContent.slice(start, end).split('\n');
      offset = 0;
      lines.forEach(function (line, i) {
        if (indent) {
          block.insertAt(start + offset, CodeBlock.TAB);
          offset += CodeBlock.TAB.length;
          if (i === 0) {
            index += CodeBlock.TAB.length;
          } else {
            length += CodeBlock.TAB.length;
          }
        } else if (line.startsWith(CodeBlock.TAB)) {
          block.deleteAt(start + offset, CodeBlock.TAB.length);
          offset -= CodeBlock.TAB.length;
          if (i === 0) {
            index -= CodeBlock.TAB.length;
          } else {
            length -= CodeBlock.TAB.length;
          }
        }
        offset += line.length + 1;
      });
      this.quill.update(_quill2.default.sources.USER);
      this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
    }
  };
}

function makeFormatHandler(format) {
  return {
    key: format[0].toUpperCase(),
    shortKey: true,
    handler: function handler(range, context) {
      this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
    }
  };
}

function normalize(binding) {
  if (typeof binding === 'string' || typeof binding === 'number') {
    return normalize({ key: binding });
  }
  if ((typeof binding === 'undefined' ? 'undefined' : _typeof(binding)) === 'object') {
    binding = (0, _clone2.default)(binding, false);
  }
  if (typeof binding.key === 'string') {
    if (Keyboard.keys[binding.key.toUpperCase()] != null) {
      binding.key = Keyboard.keys[binding.key.toUpperCase()];
    } else if (binding.key.length === 1) {
      binding.key = binding.key.toUpperCase().charCodeAt(0);
    } else {
      return null;
    }
  }
  if (binding.shortKey) {
    binding[SHORTKEY] = binding.shortKey;
    delete binding.shortKey;
  }
  return binding;
}

exports.default = Keyboard;
exports.SHORTKEY = SHORTKEY;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Cursor = function (_Parchment$Embed) {
  _inherits(Cursor, _Parchment$Embed);

  _createClass(Cursor, null, [{
    key: 'value',
    value: function value() {
      return undefined;
    }
  }]);

  function Cursor(domNode, selection) {
    _classCallCheck(this, Cursor);

    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));

    _this.selection = selection;
    _this.textNode = document.createTextNode(Cursor.CONTENTS);
    _this.domNode.appendChild(_this.textNode);
    _this._length = 0;
    return _this;
  }

  _createClass(Cursor, [{
    key: 'detach',
    value: function detach() {
      // super.detach() will also clear domNode.__blot
      if (this.parent != null) this.parent.removeChild(this);
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      if (this._length !== 0) {
        return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'format', this).call(this, name, value);
      }
      var target = this,
          index = 0;
      while (target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT) {
        index += target.offset(target.parent);
        target = target.parent;
      }
      if (target != null) {
        this._length = Cursor.CONTENTS.length;
        target.optimize();
        target.formatAt(index, Cursor.CONTENTS.length, name, value);
        this._length = 0;
      }
    }
  }, {
    key: 'index',
    value: function index(node, offset) {
      if (node === this.textNode) return 0;
      return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'index', this).call(this, node, offset);
    }
  }, {
    key: 'length',
    value: function length() {
      return this._length;
    }
  }, {
    key: 'position',
    value: function position() {
      return [this.textNode, this.textNode.data.length];
    }
  }, {
    key: 'remove',
    value: function remove() {
      _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'remove', this).call(this);
      this.parent = null;
    }
  }, {
    key: 'restore',
    value: function restore() {
      if (this.selection.composing || this.parent == null) return;
      var textNode = this.textNode;
      var range = this.selection.getNativeRange();
      var restoreText = void 0,
          start = void 0,
          end = void 0;
      if (range != null && range.start.node === textNode && range.end.node === textNode) {
        var _ref = [textNode, range.start.offset, range.end.offset];
        restoreText = _ref[0];
        start = _ref[1];
        end = _ref[2];
      }
      // Link format will insert text outside of anchor tag
      while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
      }
      if (this.textNode.data !== Cursor.CONTENTS) {
        var text = this.textNode.data.split(Cursor.CONTENTS).join('');
        if (this.next instanceof _text2.default) {
          restoreText = this.next.domNode;
          this.next.insertAt(0, text);
          this.textNode.data = Cursor.CONTENTS;
        } else {
          this.textNode.data = text;
          this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
          this.textNode = document.createTextNode(Cursor.CONTENTS);
          this.domNode.appendChild(this.textNode);
        }
      }
      this.remove();
      if (start != null) {
        var _map = [start, end].map(function (offset) {
          return Math.max(0, Math.min(restoreText.data.length, offset - 1));
        });

        var _map2 = _slicedToArray(_map, 2);

        start = _map2[0];
        end = _map2[1];

        return {
          startNode: restoreText,
          startOffset: start,
          endNode: restoreText,
          endOffset: end
        };
      }
    }
  }, {
    key: 'update',
    value: function update(mutations, context) {
      var _this2 = this;

      if (mutations.some(function (mutation) {
        return mutation.type === 'characterData' && mutation.target === _this2.textNode;
      })) {
        var range = this.restore();
        if (range) context.range = range;
      }
    }
  }, {
    key: 'value',
    value: function value() {
      return '';
    }
  }]);

  return Cursor;
}(_parchment2.default.Embed);

Cursor.blotName = 'cursor';
Cursor.className = 'ql-cursor';
Cursor.tagName = 'span';
Cursor.CONTENTS = '\uFEFF'; // Zero width no break space


exports.default = Cursor;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Container = function (_Parchment$Container) {
  _inherits(Container, _Parchment$Container);

  function Container() {
    _classCallCheck(this, Container);

    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
  }

  return Container;
}(_parchment2.default.Container);

Container.allowedChildren = [_block2.default, _block.BlockEmbed, Container];

exports.default = Container;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorAttributor = function (_Parchment$Attributor) {
  _inherits(ColorAttributor, _Parchment$Attributor);

  function ColorAttributor() {
    _classCallCheck(this, ColorAttributor);

    return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
  }

  _createClass(ColorAttributor, [{
    key: 'value',
    value: function value(domNode) {
      var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), 'value', this).call(this, domNode);
      if (!value.startsWith('rgb(')) return value;
      value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
      return '#' + value.split(',').map(function (component) {
        return ('00' + parseInt(component).toString(16)).slice(-2);
      }).join('');
    }
  }]);

  return ColorAttributor;
}(_parchment2.default.Attributor.Style);

var ColorClass = new _parchment2.default.Attributor.Class('color', 'ql-color', {
  scope: _parchment2.default.Scope.INLINE
});
var ColorStyle = new ColorAttributor('color', 'color', {
  scope: _parchment2.default.Scope.INLINE
});

exports.ColorAttributor = ColorAttributor;
exports.ColorClass = ColorClass;
exports.ColorStyle = ColorStyle;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitize = exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Link = function (_Inline) {
  _inherits(Link, _Inline);

  function Link() {
    _classCallCheck(this, Link);

    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
  }

  _createClass(Link, [{
    key: 'format',
    value: function format(name, value) {
      if (name !== this.statics.blotName || !value) return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), 'format', this).call(this, name, value);
      value = this.constructor.sanitize(value);
      this.domNode.setAttribute('href', value);
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), 'create', this).call(this, value);
      value = this.sanitize(value);
      node.setAttribute('href', value);
      node.setAttribute('rel', 'noopener noreferrer');
      node.setAttribute('target', '_blank');
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return domNode.getAttribute('href');
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
    }
  }]);

  return Link;
}(_inline2.default);

Link.blotName = 'link';
Link.tagName = 'A';
Link.SANITIZED_URL = 'about:blank';
Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];

function _sanitize(url, protocols) {
  var anchor = document.createElement('a');
  anchor.href = url;
  var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
  return protocols.indexOf(protocol) > -1;
}

exports.default = Link;
exports.sanitize = _sanitize;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _keyboard = __webpack_require__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

var _dropdown = __webpack_require__(107);

var _dropdown2 = _interopRequireDefault(_dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var optionsCounter = 0;

function toggleAriaAttribute(element, attribute) {
  element.setAttribute(attribute, !(element.getAttribute(attribute) === 'true'));
}

var Picker = function () {
  function Picker(select) {
    var _this = this;

    _classCallCheck(this, Picker);

    this.select = select;
    this.container = document.createElement('span');
    this.buildPicker();
    this.select.style.display = 'none';
    this.select.parentNode.insertBefore(this.container, this.select);

    this.label.addEventListener('mousedown', function () {
      _this.togglePicker();
    });
    this.label.addEventListener('keydown', function (event) {
      switch (event.keyCode) {
        // Allows the "Enter" key to open the picker
        case _keyboard2.default.keys.ENTER:
          _this.togglePicker();
          break;

        // Allows the "Escape" key to close the picker
        case _keyboard2.default.keys.ESCAPE:
          _this.escape();
          event.preventDefault();
          break;
        default:
      }
    });
    this.select.addEventListener('change', this.update.bind(this));
  }

  _createClass(Picker, [{
    key: 'togglePicker',
    value: function togglePicker() {
      this.container.classList.toggle('ql-expanded');
      // Toggle aria-expanded and aria-hidden to make the picker accessible
      toggleAriaAttribute(this.label, 'aria-expanded');
      toggleAriaAttribute(this.options, 'aria-hidden');
    }
  }, {
    key: 'buildItem',
    value: function buildItem(option) {
      var _this2 = this;

      var item = document.createElement('span');
      item.tabIndex = '0';
      item.setAttribute('role', 'button');

      item.classList.add('ql-picker-item');
      if (option.hasAttribute('value')) {
        item.setAttribute('data-value', option.getAttribute('value'));
      }
      if (option.textContent) {
        item.setAttribute('data-label', option.textContent);
      }
      item.addEventListener('click', function () {
        _this2.selectItem(item, true);
      });
      item.addEventListener('keydown', function (event) {
        switch (event.keyCode) {
          // Allows the "Enter" key to select an item
          case _keyboard2.default.keys.ENTER:
            _this2.selectItem(item, true);
            event.preventDefault();
            break;

          // Allows the "Escape" key to close the picker
          case _keyboard2.default.keys.ESCAPE:
            _this2.escape();
            event.preventDefault();
            break;
          default:
        }
      });

      return item;
    }
  }, {
    key: 'buildLabel',
    value: function buildLabel() {
      var label = document.createElement('span');
      label.classList.add('ql-picker-label');
      label.innerHTML = _dropdown2.default;
      label.tabIndex = '0';
      label.setAttribute('role', 'button');
      label.setAttribute('aria-expanded', 'false');
      this.container.appendChild(label);
      return label;
    }
  }, {
    key: 'buildOptions',
    value: function buildOptions() {
      var _this3 = this;

      var options = document.createElement('span');
      options.classList.add('ql-picker-options');

      // Don't want screen readers to read this until options are visible
      options.setAttribute('aria-hidden', 'true');
      options.tabIndex = '-1';

      // Need a unique id for aria-controls
      options.id = 'ql-picker-options-' + optionsCounter;
      optionsCounter += 1;
      this.label.setAttribute('aria-controls', options.id);

      this.options = options;

      [].slice.call(this.select.options).forEach(function (option) {
        var item = _this3.buildItem(option);
        options.appendChild(item);
        if (option.selected === true) {
          _this3.selectItem(item);
        }
      });
      this.container.appendChild(options);
    }
  }, {
    key: 'buildPicker',
    value: function buildPicker() {
      var _this4 = this;

      [].slice.call(this.select.attributes).forEach(function (item) {
        _this4.container.setAttribute(item.name, item.value);
      });
      this.container.classList.add('ql-picker');
      this.label = this.buildLabel();
      this.buildOptions();
    }
  }, {
    key: 'escape',
    value: function escape() {
      var _this5 = this;

      // Close menu and return focus to trigger label
      this.close();
      // Need setTimeout for accessibility to ensure that the browser executes
      // focus on the next process thread and after any DOM content changes
      setTimeout(function () {
        return _this5.label.focus();
      }, 1);
    }
  }, {
    key: 'close',
    value: function close() {
      this.container.classList.remove('ql-expanded');
      this.label.setAttribute('aria-expanded', 'false');
      this.options.setAttribute('aria-hidden', 'true');
    }
  }, {
    key: 'selectItem',
    value: function selectItem(item) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var selected = this.container.querySelector('.ql-selected');
      if (item === selected) return;
      if (selected != null) {
        selected.classList.remove('ql-selected');
      }
      if (item == null) return;
      item.classList.add('ql-selected');
      this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
      if (item.hasAttribute('data-value')) {
        this.label.setAttribute('data-value', item.getAttribute('data-value'));
      } else {
        this.label.removeAttribute('data-value');
      }
      if (item.hasAttribute('data-label')) {
        this.label.setAttribute('data-label', item.getAttribute('data-label'));
      } else {
        this.label.removeAttribute('data-label');
      }
      if (trigger) {
        if (typeof Event === 'function') {
          this.select.dispatchEvent(new Event('change'));
        } else if ((typeof Event === 'undefined' ? 'undefined' : _typeof(Event)) === 'object') {
          // IE11
          var event = document.createEvent('Event');
          event.initEvent('change', true, true);
          this.select.dispatchEvent(event);
        }
        this.close();
      }
    }
  }, {
    key: 'update',
    value: function update() {
      var option = void 0;
      if (this.select.selectedIndex > -1) {
        var item = this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
        option = this.select.options[this.select.selectedIndex];
        this.selectItem(item);
      } else {
        this.selectItem(null);
      }
      var isActive = option != null && option !== this.select.querySelector('option[selected]');
      this.label.classList.toggle('ql-active', isActive);
    }
  }]);

  return Picker;
}();

exports.default = Picker;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _container = __webpack_require__(25);

var _container2 = _interopRequireDefault(_container);

var _cursor = __webpack_require__(24);

var _cursor2 = _interopRequireDefault(_cursor);

var _embed = __webpack_require__(35);

var _embed2 = _interopRequireDefault(_embed);

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

var _scroll = __webpack_require__(22);

var _scroll2 = _interopRequireDefault(_scroll);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

var _clipboard = __webpack_require__(55);

var _clipboard2 = _interopRequireDefault(_clipboard);

var _history = __webpack_require__(42);

var _history2 = _interopRequireDefault(_history);

var _keyboard = __webpack_require__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_quill2.default.register({
  'blots/block': _block2.default,
  'blots/block/embed': _block.BlockEmbed,
  'blots/break': _break2.default,
  'blots/container': _container2.default,
  'blots/cursor': _cursor2.default,
  'blots/embed': _embed2.default,
  'blots/inline': _inline2.default,
  'blots/scroll': _scroll2.default,
  'blots/text': _text2.default,

  'modules/clipboard': _clipboard2.default,
  'modules/history': _history2.default,
  'modules/keyboard': _keyboard2.default
});

_parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);

exports.default = _quill2.default;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Registry = __webpack_require__(1);
var ShadowBlot = /** @class */ (function () {
    function ShadowBlot(domNode) {
        this.domNode = domNode;
        // @ts-ignore
        this.domNode[Registry.DATA_KEY] = { blot: this };
    }
    Object.defineProperty(ShadowBlot.prototype, "statics", {
        // Hack for accessing inherited static methods
        get: function () {
            return this.constructor;
        },
        enumerable: true,
        configurable: true
    });
    ShadowBlot.create = function (value) {
        if (this.tagName == null) {
            throw new Registry.ParchmentError('Blot definition missing tagName');
        }
        var node;
        if (Array.isArray(this.tagName)) {
            if (typeof value === 'string') {
                value = value.toUpperCase();
                if (parseInt(value).toString() === value) {
                    value = parseInt(value);
                }
            }
            if (typeof value === 'number') {
                node = document.createElement(this.tagName[value - 1]);
            }
            else if (this.tagName.indexOf(value) > -1) {
                node = document.createElement(value);
            }
            else {
                node = document.createElement(this.tagName[0]);
            }
        }
        else {
            node = document.createElement(this.tagName);
        }
        if (this.className) {
            node.classList.add(this.className);
        }
        return node;
    };
    ShadowBlot.prototype.attach = function () {
        if (this.parent != null) {
            this.scroll = this.parent.scroll;
        }
    };
    ShadowBlot.prototype.clone = function () {
        var domNode = this.domNode.cloneNode(false);
        return Registry.create(domNode);
    };
    ShadowBlot.prototype.detach = function () {
        if (this.parent != null)
            this.parent.removeChild(this);
        // @ts-ignore
        delete this.domNode[Registry.DATA_KEY];
    };
    ShadowBlot.prototype.deleteAt = function (index, length) {
        var blot = this.isolate(index, length);
        blot.remove();
    };
    ShadowBlot.prototype.formatAt = function (index, length, name, value) {
        var blot = this.isolate(index, length);
        if (Registry.query(name, Registry.Scope.BLOT) != null && value) {
            blot.wrap(name, value);
        }
        else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
            var parent = Registry.create(this.statics.scope);
            blot.wrap(parent);
            parent.format(name, value);
        }
    };
    ShadowBlot.prototype.insertAt = function (index, value, def) {
        var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
        var ref = this.split(index);
        this.parent.insertBefore(blot, ref);
    };
    ShadowBlot.prototype.insertInto = function (parentBlot, refBlot) {
        if (refBlot === void 0) { refBlot = null; }
        if (this.parent != null) {
            this.parent.children.remove(this);
        }
        var refDomNode = null;
        parentBlot.children.insertBefore(this, refBlot);
        if (refBlot != null) {
            refDomNode = refBlot.domNode;
        }
        if (this.domNode.parentNode != parentBlot.domNode ||
            this.domNode.nextSibling != refDomNode) {
            parentBlot.domNode.insertBefore(this.domNode, refDomNode);
        }
        this.parent = parentBlot;
        this.attach();
    };
    ShadowBlot.prototype.isolate = function (index, length) {
        var target = this.split(index);
        target.split(length);
        return target;
    };
    ShadowBlot.prototype.length = function () {
        return 1;
    };
    ShadowBlot.prototype.offset = function (root) {
        if (root === void 0) { root = this.parent; }
        if (this.parent == null || this == root)
            return 0;
        return this.parent.children.offset(this) + this.parent.offset(root);
    };
    ShadowBlot.prototype.optimize = function (context) {
        // TODO clean up once we use WeakMap
        // @ts-ignore
        if (this.domNode[Registry.DATA_KEY] != null) {
            // @ts-ignore
            delete this.domNode[Registry.DATA_KEY].mutations;
        }
    };
    ShadowBlot.prototype.remove = function () {
        if (this.domNode.parentNode != null) {
            this.domNode.parentNode.removeChild(this.domNode);
        }
        this.detach();
    };
    ShadowBlot.prototype.replace = function (target) {
        if (target.parent == null)
            return;
        target.parent.insertBefore(this, target.next);
        target.remove();
    };
    ShadowBlot.prototype.replaceWith = function (name, value) {
        var replacement = typeof name === 'string' ? Registry.create(name, value) : name;
        replacement.replace(this);
        return replacement;
    };
    ShadowBlot.prototype.split = function (index, force) {
        return index === 0 ? this : this.next;
    };
    ShadowBlot.prototype.update = function (mutations, context) {
        // Nothing to do by default
    };
    ShadowBlot.prototype.wrap = function (name, value) {
        var wrapper = typeof name === 'string' ? Registry.create(name, value) : name;
        if (this.parent != null) {
            this.parent.insertBefore(wrapper, this.next);
        }
        wrapper.appendChild(this);
        return wrapper;
    };
    ShadowBlot.blotName = 'abstract';
    return ShadowBlot;
}());
exports.default = ShadowBlot;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
var class_1 = __webpack_require__(32);
var style_1 = __webpack_require__(33);
var Registry = __webpack_require__(1);
var AttributorStore = /** @class */ (function () {
    function AttributorStore(domNode) {
        this.attributes = {};
        this.domNode = domNode;
        this.build();
    }
    AttributorStore.prototype.attribute = function (attribute, value) {
        // verb
        if (value) {
            if (attribute.add(this.domNode, value)) {
                if (attribute.value(this.domNode) != null) {
                    this.attributes[attribute.attrName] = attribute;
                }
                else {
                    delete this.attributes[attribute.attrName];
                }
            }
        }
        else {
            attribute.remove(this.domNode);
            delete this.attributes[attribute.attrName];
        }
    };
    AttributorStore.prototype.build = function () {
        var _this = this;
        this.attributes = {};
        var attributes = attributor_1.default.keys(this.domNode);
        var classes = class_1.default.keys(this.domNode);
        var styles = style_1.default.keys(this.domNode);
        attributes
            .concat(classes)
            .concat(styles)
            .forEach(function (name) {
            var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
            if (attr instanceof attributor_1.default) {
                _this.attributes[attr.attrName] = attr;
            }
        });
    };
    AttributorStore.prototype.copy = function (target) {
        var _this = this;
        Object.keys(this.attributes).forEach(function (key) {
            var value = _this.attributes[key].value(_this.domNode);
            target.format(key, value);
        });
    };
    AttributorStore.prototype.move = function (target) {
        var _this = this;
        this.copy(target);
        Object.keys(this.attributes).forEach(function (key) {
            _this.attributes[key].remove(_this.domNode);
        });
        this.attributes = {};
    };
    AttributorStore.prototype.values = function () {
        var _this = this;
        return Object.keys(this.attributes).reduce(function (attributes, name) {
            attributes[name] = _this.attributes[name].value(_this.domNode);
            return attributes;
        }, {});
    };
    return AttributorStore;
}());
exports.default = AttributorStore;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
function match(node, prefix) {
    var className = node.getAttribute('class') || '';
    return className.split(/\s+/).filter(function (name) {
        return name.indexOf(prefix + "-") === 0;
    });
}
var ClassAttributor = /** @class */ (function (_super) {
    __extends(ClassAttributor, _super);
    function ClassAttributor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClassAttributor.keys = function (node) {
        return (node.getAttribute('class') || '').split(/\s+/).map(function (name) {
            return name
                .split('-')
                .slice(0, -1)
                .join('-');
        });
    };
    ClassAttributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        this.remove(node);
        node.classList.add(this.keyName + "-" + value);
        return true;
    };
    ClassAttributor.prototype.remove = function (node) {
        var matches = match(node, this.keyName);
        matches.forEach(function (name) {
            node.classList.remove(name);
        });
        if (node.classList.length === 0) {
            node.removeAttribute('class');
        }
    };
    ClassAttributor.prototype.value = function (node) {
        var result = match(node, this.keyName)[0] || '';
        var value = result.slice(this.keyName.length + 1); // +1 for hyphen
        return this.canAdd(node, value) ? value : '';
    };
    return ClassAttributor;
}(attributor_1.default));
exports.default = ClassAttributor;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
function camelize(name) {
    var parts = name.split('-');
    var rest = parts
        .slice(1)
        .map(function (part) {
        return part[0].toUpperCase() + part.slice(1);
    })
        .join('');
    return parts[0] + rest;
}
var StyleAttributor = /** @class */ (function (_super) {
    __extends(StyleAttributor, _super);
    function StyleAttributor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StyleAttributor.keys = function (node) {
        return (node.getAttribute('style') || '').split(';').map(function (value) {
            var arr = value.split(':');
            return arr[0].trim();
        });
    };
    StyleAttributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        // @ts-ignore
        node.style[camelize(this.keyName)] = value;
        return true;
    };
    StyleAttributor.prototype.remove = function (node) {
        // @ts-ignore
        node.style[camelize(this.keyName)] = '';
        if (!node.getAttribute('style')) {
            node.removeAttribute('style');
        }
    };
    StyleAttributor.prototype.value = function (node) {
        // @ts-ignore
        var value = node.style[camelize(this.keyName)];
        return this.canAdd(node, value) ? value : '';
    };
    return StyleAttributor;
}(attributor_1.default));
exports.default = StyleAttributor;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Theme = function () {
  function Theme(quill, options) {
    _classCallCheck(this, Theme);

    this.quill = quill;
    this.options = options;
    this.modules = {};
  }

  _createClass(Theme, [{
    key: 'init',
    value: function init() {
      var _this = this;

      Object.keys(this.options.modules).forEach(function (name) {
        if (_this.modules[name] == null) {
          _this.addModule(name);
        }
      });
    }
  }, {
    key: 'addModule',
    value: function addModule(name) {
      var moduleClass = this.quill.constructor.import('modules/' + name);
      this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
      return this.modules[name];
    }
  }]);

  return Theme;
}();

Theme.DEFAULTS = {
  modules: {}
};
Theme.themes = {
  'default': Theme
};

exports.default = Theme;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GUARD_TEXT = '\uFEFF';

var Embed = function (_Parchment$Embed) {
  _inherits(Embed, _Parchment$Embed);

  function Embed(node) {
    _classCallCheck(this, Embed);

    var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, node));

    _this.contentNode = document.createElement('span');
    _this.contentNode.setAttribute('contenteditable', false);
    [].slice.call(_this.domNode.childNodes).forEach(function (childNode) {
      _this.contentNode.appendChild(childNode);
    });
    _this.leftGuard = document.createTextNode(GUARD_TEXT);
    _this.rightGuard = document.createTextNode(GUARD_TEXT);
    _this.domNode.appendChild(_this.leftGuard);
    _this.domNode.appendChild(_this.contentNode);
    _this.domNode.appendChild(_this.rightGuard);
    return _this;
  }

  _createClass(Embed, [{
    key: 'index',
    value: function index(node, offset) {
      if (node === this.leftGuard) return 0;
      if (node === this.rightGuard) return 1;
      return _get(Embed.prototype.__proto__ || Object.getPrototypeOf(Embed.prototype), 'index', this).call(this, node, offset);
    }
  }, {
    key: 'restore',
    value: function restore(node) {
      var range = void 0,
          textNode = void 0;
      var text = node.data.split(GUARD_TEXT).join('');
      if (node === this.leftGuard) {
        if (this.prev instanceof _text2.default) {
          var prevLength = this.prev.length();
          this.prev.insertAt(prevLength, text);
          range = {
            startNode: this.prev.domNode,
            startOffset: prevLength + text.length
          };
        } else {
          textNode = document.createTextNode(text);
          this.parent.insertBefore(_parchment2.default.create(textNode), this);
          range = {
            startNode: textNode,
            startOffset: text.length
          };
        }
      } else if (node === this.rightGuard) {
        if (this.next instanceof _text2.default) {
          this.next.insertAt(0, text);
          range = {
            startNode: this.next.domNode,
            startOffset: text.length
          };
        } else {
          textNode = document.createTextNode(text);
          this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
          range = {
            startNode: textNode,
            startOffset: text.length
          };
        }
      }
      node.data = GUARD_TEXT;
      return range;
    }
  }, {
    key: 'update',
    value: function update(mutations, context) {
      var _this2 = this;

      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData' && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
          var range = _this2.restore(mutation.target);
          if (range) context.range = range;
        }
      });
    }
  }]);

  return Embed;
}(_parchment2.default.Embed);

exports.default = Embed;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: ['right', 'center', 'justify']
};

var AlignAttribute = new _parchment2.default.Attributor.Attribute('align', 'align', config);
var AlignClass = new _parchment2.default.Attributor.Class('align', 'ql-align', config);
var AlignStyle = new _parchment2.default.Attributor.Style('align', 'text-align', config);

exports.AlignAttribute = AlignAttribute;
exports.AlignClass = AlignClass;
exports.AlignStyle = AlignStyle;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackgroundStyle = exports.BackgroundClass = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _color = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackgroundClass = new _parchment2.default.Attributor.Class('background', 'ql-bg', {
  scope: _parchment2.default.Scope.INLINE
});
var BackgroundStyle = new _color.ColorAttributor('background', 'background-color', {
  scope: _parchment2.default.Scope.INLINE
});

exports.BackgroundClass = BackgroundClass;
exports.BackgroundStyle = BackgroundStyle;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: ['rtl']
};

var DirectionAttribute = new _parchment2.default.Attributor.Attribute('direction', 'dir', config);
var DirectionClass = new _parchment2.default.Attributor.Class('direction', 'ql-direction', config);
var DirectionStyle = new _parchment2.default.Attributor.Style('direction', 'direction', config);

exports.DirectionAttribute = DirectionAttribute;
exports.DirectionClass = DirectionClass;
exports.DirectionStyle = DirectionStyle;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontClass = exports.FontStyle = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var config = {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['serif', 'monospace']
};

var FontClass = new _parchment2.default.Attributor.Class('font', 'ql-font', config);

var FontStyleAttributor = function (_Parchment$Attributor) {
  _inherits(FontStyleAttributor, _Parchment$Attributor);

  function FontStyleAttributor() {
    _classCallCheck(this, FontStyleAttributor);

    return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
  }

  _createClass(FontStyleAttributor, [{
    key: 'value',
    value: function value(node) {
      return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), 'value', this).call(this, node).replace(/["']/g, '');
    }
  }]);

  return FontStyleAttributor;
}(_parchment2.default.Attributor.Style);

var FontStyle = new FontStyleAttributor('font', 'font-family', config);

exports.FontStyle = FontStyle;
exports.FontClass = FontClass;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SizeStyle = exports.SizeClass = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SizeClass = new _parchment2.default.Attributor.Class('size', 'ql-size', {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['small', 'large', 'huge']
});
var SizeStyle = new _parchment2.default.Attributor.Style('size', 'font-size', {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['10px', '18px', '32px']
});

exports.SizeClass = SizeClass;
exports.SizeStyle = SizeStyle;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  'align': {
    '': __webpack_require__(76),
    'center': __webpack_require__(77),
    'right': __webpack_require__(78),
    'justify': __webpack_require__(79)
  },
  'background': __webpack_require__(80),
  'blockquote': __webpack_require__(81),
  'bold': __webpack_require__(82),
  'clean': __webpack_require__(83),
  'code': __webpack_require__(58),
  'code-block': __webpack_require__(58),
  'color': __webpack_require__(84),
  'direction': {
    '': __webpack_require__(85),
    'rtl': __webpack_require__(86)
  },
  'float': {
    'center': __webpack_require__(87),
    'full': __webpack_require__(88),
    'left': __webpack_require__(89),
    'right': __webpack_require__(90)
  },
  'formula': __webpack_require__(91),
  'header': {
    '1': __webpack_require__(92),
    '2': __webpack_require__(93)
  },
  'italic': __webpack_require__(94),
  'image': __webpack_require__(95),
  'indent': {
    '+1': __webpack_require__(96),
    '-1': __webpack_require__(97)
  },
  'link': __webpack_require__(98),
  'list': {
    'ordered': __webpack_require__(99),
    'bullet': __webpack_require__(100),
    'check': __webpack_require__(101)
  },
  'script': {
    'sub': __webpack_require__(102),
    'super': __webpack_require__(103)
  },
  'strike': __webpack_require__(104),
  'underline': __webpack_require__(105),
  'video': __webpack_require__(106)
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLastChangeIndex = exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var History = function (_Module) {
  _inherits(History, _Module);

  function History(quill, options) {
    _classCallCheck(this, History);

    var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));

    _this.lastRecorded = 0;
    _this.ignoreChange = false;
    _this.clear();
    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (eventName, delta, oldDelta, source) {
      if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;
      if (!_this.options.userOnly || source === _quill2.default.sources.USER) {
        _this.record(delta, oldDelta);
      } else {
        _this.transform(delta);
      }
    });
    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true }, _this.undo.bind(_this));
    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true, shiftKey: true }, _this.redo.bind(_this));
    if (/Win/i.test(navigator.platform)) {
      _this.quill.keyboard.addBinding({ key: 'Y', shortKey: true }, _this.redo.bind(_this));
    }
    return _this;
  }

  _createClass(History, [{
    key: 'change',
    value: function change(source, dest) {
      if (this.stack[source].length === 0) return;
      var delta = this.stack[source].pop();
      this.stack[dest].push(delta);
      this.lastRecorded = 0;
      this.ignoreChange = true;
      this.quill.updateContents(delta[source], _quill2.default.sources.USER);
      this.ignoreChange = false;
      var index = getLastChangeIndex(delta[source]);
      this.quill.setSelection(index);
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.stack = { undo: [], redo: [] };
    }
  }, {
    key: 'cutoff',
    value: function cutoff() {
      this.lastRecorded = 0;
    }
  }, {
    key: 'record',
    value: function record(changeDelta, oldDelta) {
      if (changeDelta.ops.length === 0) return;
      this.stack.redo = [];
      var undoDelta = this.quill.getContents().diff(oldDelta);
      var timestamp = Date.now();
      if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
        var delta = this.stack.undo.pop();
        undoDelta = undoDelta.compose(delta.undo);
        changeDelta = delta.redo.compose(changeDelta);
      } else {
        this.lastRecorded = timestamp;
      }
      this.stack.undo.push({
        redo: changeDelta,
        undo: undoDelta
      });
      if (this.stack.undo.length > this.options.maxStack) {
        this.stack.undo.shift();
      }
    }
  }, {
    key: 'redo',
    value: function redo() {
      this.change('redo', 'undo');
    }
  }, {
    key: 'transform',
    value: function transform(delta) {
      this.stack.undo.forEach(function (change) {
        change.undo = delta.transform(change.undo, true);
        change.redo = delta.transform(change.redo, true);
      });
      this.stack.redo.forEach(function (change) {
        change.undo = delta.transform(change.undo, true);
        change.redo = delta.transform(change.redo, true);
      });
    }
  }, {
    key: 'undo',
    value: function undo() {
      this.change('undo', 'redo');
    }
  }]);

  return History;
}(_module2.default);

History.DEFAULTS = {
  delay: 1000,
  maxStack: 100,
  userOnly: false
};

function endsWithNewlineChange(delta) {
  var lastOp = delta.ops[delta.ops.length - 1];
  if (lastOp == null) return false;
  if (lastOp.insert != null) {
    return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
  }
  if (lastOp.attributes != null) {
    return Object.keys(lastOp.attributes).some(function (attr) {
      return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
    });
  }
  return false;
}

function getLastChangeIndex(delta) {
  var deleteLength = delta.reduce(function (length, op) {
    length += op.delete || 0;
    return length;
  }, 0);
  var changeIndex = delta.length() - deleteLength;
  if (endsWithNewlineChange(delta)) {
    changeIndex -= 1;
  }
  return changeIndex;
}

exports.default = History;
exports.getLastChangeIndex = getLastChangeIndex;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BaseTooltip = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _keyboard = __webpack_require__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

var _theme = __webpack_require__(34);

var _theme2 = _interopRequireDefault(_theme);

var _colorPicker = __webpack_require__(59);

var _colorPicker2 = _interopRequireDefault(_colorPicker);

var _iconPicker = __webpack_require__(60);

var _iconPicker2 = _interopRequireDefault(_iconPicker);

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

var _tooltip = __webpack_require__(61);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ALIGNS = [false, 'center', 'right', 'justify'];

var COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];

var FONTS = [false, 'serif', 'monospace'];

var HEADERS = ['1', '2', '3', false];

var SIZES = ['small', false, 'large', 'huge'];

var BaseTheme = function (_Theme) {
  _inherits(BaseTheme, _Theme);

  function BaseTheme(quill, options) {
    _classCallCheck(this, BaseTheme);

    var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));

    var listener = function listener(e) {
      if (!document.body.contains(quill.root)) {
        return document.body.removeEventListener('click', listener);
      }
      if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) {
        _this.tooltip.hide();
      }
      if (_this.pickers != null) {
        _this.pickers.forEach(function (picker) {
          if (!picker.container.contains(e.target)) {
            picker.close();
          }
        });
      }
    };
    quill.emitter.listenDOM('click', document.body, listener);
    return _this;
  }

  _createClass(BaseTheme, [{
    key: 'addModule',
    value: function addModule(name) {
      var module = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), 'addModule', this).call(this, name);
      if (name === 'toolbar') {
        this.extendToolbar(module);
      }
      return module;
    }
  }, {
    key: 'buildButtons',
    value: function buildButtons(buttons, icons) {
      buttons.forEach(function (button) {
        var className = button.getAttribute('class') || '';
        className.split(/\s+/).forEach(function (name) {
          if (!name.startsWith('ql-')) return;
          name = name.slice('ql-'.length);
          if (icons[name] == null) return;
          if (name === 'direction') {
            button.innerHTML = icons[name][''] + icons[name]['rtl'];
          } else if (typeof icons[name] === 'string') {
            button.innerHTML = icons[name];
          } else {
            var value = button.value || '';
            if (value != null && icons[name][value]) {
              button.innerHTML = icons[name][value];
            }
          }
        });
      });
    }
  }, {
    key: 'buildPickers',
    value: function buildPickers(selects, icons) {
      var _this2 = this;

      this.pickers = selects.map(function (select) {
        if (select.classList.contains('ql-align')) {
          if (select.querySelector('option') == null) {
            fillSelect(select, ALIGNS);
          }
          return new _iconPicker2.default(select, icons.align);
        } else if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
          var format = select.classList.contains('ql-background') ? 'background' : 'color';
          if (select.querySelector('option') == null) {
            fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
          }
          return new _colorPicker2.default(select, icons[format]);
        } else {
          if (select.querySelector('option') == null) {
            if (select.classList.contains('ql-font')) {
              fillSelect(select, FONTS);
            } else if (select.classList.contains('ql-header')) {
              fillSelect(select, HEADERS);
            } else if (select.classList.contains('ql-size')) {
              fillSelect(select, SIZES);
            }
          }
          return new _picker2.default(select);
        }
      });
      var update = function update() {
        _this2.pickers.forEach(function (picker) {
          picker.update();
        });
      };
      this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
    }
  }]);

  return BaseTheme;
}(_theme2.default);

BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        formula: function formula() {
          this.quill.theme.tooltip.edit('formula');
        },
        image: function image() {
          var _this3 = this;

          var fileInput = this.container.querySelector('input.ql-image[type=file]');
          if (fileInput == null) {
            fileInput = document.createElement('input');
            fileInput.setAttribute('type', 'file');
            fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
            fileInput.classList.add('ql-image');
            fileInput.addEventListener('change', function () {
              if (fileInput.files != null && fileInput.files[0] != null) {
                var reader = new FileReader();
                reader.onload = function (e) {
                  var range = _this3.quill.getSelection(true);
                  _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({ image: e.target.result }), _emitter2.default.sources.USER);
                  _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
                  fileInput.value = "";
                };
                reader.readAsDataURL(fileInput.files[0]);
              }
            });
            this.container.appendChild(fileInput);
          }
          fileInput.click();
        },
        video: function video() {
          this.quill.theme.tooltip.edit('video');
        }
      }
    }
  }
});

var BaseTooltip = function (_Tooltip) {
  _inherits(BaseTooltip, _Tooltip);

  function BaseTooltip(quill, boundsContainer) {
    _classCallCheck(this, BaseTooltip);

    var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));

    _this4.textbox = _this4.root.querySelector('input[type="text"]');
    _this4.listen();
    return _this4;
  }

  _createClass(BaseTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this5 = this;

      this.textbox.addEventListener('keydown', function (event) {
        if (_keyboard2.default.match(event, 'enter')) {
          _this5.save();
          event.preventDefault();
        } else if (_keyboard2.default.match(event, 'escape')) {
          _this5.cancel();
          event.preventDefault();
        }
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.hide();
    }
  }, {
    key: 'edit',
    value: function edit() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
      var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.root.classList.remove('ql-hidden');
      this.root.classList.add('ql-editing');
      if (preview != null) {
        this.textbox.value = preview;
      } else if (mode !== this.root.getAttribute('data-mode')) {
        this.textbox.value = '';
      }
      this.position(this.quill.getBounds(this.quill.selection.savedRange));
      this.textbox.select();
      this.textbox.setAttribute('placeholder', this.textbox.getAttribute('data-' + mode) || '');
      this.root.setAttribute('data-mode', mode);
    }
  }, {
    key: 'restoreFocus',
    value: function restoreFocus() {
      var scrollTop = this.quill.scrollingContainer.scrollTop;
      this.quill.focus();
      this.quill.scrollingContainer.scrollTop = scrollTop;
    }
  }, {
    key: 'save',
    value: function save() {
      var value = this.textbox.value;
      switch (this.root.getAttribute('data-mode')) {
        case 'link':
          {
            var scrollTop = this.quill.root.scrollTop;
            if (this.linkRange) {
              this.quill.formatText(this.linkRange, 'link', value, _emitter2.default.sources.USER);
              delete this.linkRange;
            } else {
              this.restoreFocus();
              this.quill.format('link', value, _emitter2.default.sources.USER);
            }
            this.quill.root.scrollTop = scrollTop;
            break;
          }
        case 'video':
          {
            value = extractVideoUrl(value);
          } // eslint-disable-next-line no-fallthrough
        case 'formula':
          {
            if (!value) break;
            var range = this.quill.getSelection(true);
            if (range != null) {
              var index = range.index + range.length;
              this.quill.insertEmbed(index, this.root.getAttribute('data-mode'), value, _emitter2.default.sources.USER);
              if (this.root.getAttribute('data-mode') === 'formula') {
                this.quill.insertText(index + 1, ' ', _emitter2.default.sources.USER);
              }
              this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
            }
            break;
          }
        default:
      }
      this.textbox.value = '';
      this.hide();
    }
  }]);

  return BaseTooltip;
}(_tooltip2.default);

function extractVideoUrl(url) {
  var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
  if (match) {
    return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?showinfo=0';
  }
  if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
    // eslint-disable-line no-cond-assign
    return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
  }
  return url;
}

function fillSelect(select, values) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  values.forEach(function (value) {
    var option = document.createElement('option');
    if (value === defaultValue) {
      option.setAttribute('selected', 'selected');
    } else {
      option.setAttribute('value', value);
    }
    select.appendChild(option);
  });
}

exports.BaseTooltip = BaseTooltip;
exports.default = BaseTheme;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LinkedList = /** @class */ (function () {
    function LinkedList() {
        this.head = this.tail = null;
        this.length = 0;
    }
    LinkedList.prototype.append = function () {
        var nodes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
        }
        this.insertBefore(nodes[0], null);
        if (nodes.length > 1) {
            this.append.apply(this, nodes.slice(1));
        }
    };
    LinkedList.prototype.contains = function (node) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            if (cur === node)
                return true;
        }
        return false;
    };
    LinkedList.prototype.insertBefore = function (node, refNode) {
        if (!node)
            return;
        node.next = refNode;
        if (refNode != null) {
            node.prev = refNode.prev;
            if (refNode.prev != null) {
                refNode.prev.next = node;
            }
            refNode.prev = node;
            if (refNode === this.head) {
                this.head = node;
            }
        }
        else if (this.tail != null) {
            this.tail.next = node;
            node.prev = this.tail;
            this.tail = node;
        }
        else {
            node.prev = null;
            this.head = this.tail = node;
        }
        this.length += 1;
    };
    LinkedList.prototype.offset = function (target) {
        var index = 0, cur = this.head;
        while (cur != null) {
            if (cur === target)
                return index;
            index += cur.length();
            cur = cur.next;
        }
        return -1;
    };
    LinkedList.prototype.remove = function (node) {
        if (!this.contains(node))
            return;
        if (node.prev != null)
            node.prev.next = node.next;
        if (node.next != null)
            node.next.prev = node.prev;
        if (node === this.head)
            this.head = node.next;
        if (node === this.tail)
            this.tail = node.prev;
        this.length -= 1;
    };
    LinkedList.prototype.iterator = function (curNode) {
        if (curNode === void 0) { curNode = this.head; }
        // TODO use yield when we can
        return function () {
            var ret = curNode;
            if (curNode != null)
                curNode = curNode.next;
            return ret;
        };
    };
    LinkedList.prototype.find = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        var cur, next = this.iterator();
        while ((cur = next())) {
            var length = cur.length();
            if (index < length ||
                (inclusive && index === length && (cur.next == null || cur.next.length() !== 0))) {
                return [cur, index];
            }
            index -= length;
        }
        return [null, 0];
    };
    LinkedList.prototype.forEach = function (callback) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            callback(cur);
        }
    };
    LinkedList.prototype.forEachAt = function (index, length, callback) {
        if (length <= 0)
            return;
        var _a = this.find(index), startNode = _a[0], offset = _a[1];
        var cur, curIndex = index - offset, next = this.iterator(startNode);
        while ((cur = next()) && curIndex < index + length) {
            var curLength = cur.length();
            if (index > curIndex) {
                callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
            }
            else {
                callback(cur, 0, Math.min(curLength, index + length - curIndex));
            }
            curIndex += curLength;
        }
    };
    LinkedList.prototype.map = function (callback) {
        return this.reduce(function (memo, cur) {
            memo.push(callback(cur));
            return memo;
        }, []);
    };
    LinkedList.prototype.reduce = function (callback, memo) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            memo = callback(memo, cur);
        }
        return memo;
    };
    return LinkedList;
}());
exports.default = LinkedList;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var container_1 = __webpack_require__(17);
var Registry = __webpack_require__(1);
var OBSERVER_CONFIG = {
    attributes: true,
    characterData: true,
    characterDataOldValue: true,
    childList: true,
    subtree: true,
};
var MAX_OPTIMIZE_ITERATIONS = 100;
var ScrollBlot = /** @class */ (function (_super) {
    __extends(ScrollBlot, _super);
    function ScrollBlot(node) {
        var _this = _super.call(this, node) || this;
        _this.scroll = _this;
        _this.observer = new MutationObserver(function (mutations) {
            _this.update(mutations);
        });
        _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
        _this.attach();
        return _this;
    }
    ScrollBlot.prototype.detach = function () {
        _super.prototype.detach.call(this);
        this.observer.disconnect();
    };
    ScrollBlot.prototype.deleteAt = function (index, length) {
        this.update();
        if (index === 0 && length === this.length()) {
            this.children.forEach(function (child) {
                child.remove();
            });
        }
        else {
            _super.prototype.deleteAt.call(this, index, length);
        }
    };
    ScrollBlot.prototype.formatAt = function (index, length, name, value) {
        this.update();
        _super.prototype.formatAt.call(this, index, length, name, value);
    };
    ScrollBlot.prototype.insertAt = function (index, value, def) {
        this.update();
        _super.prototype.insertAt.call(this, index, value, def);
    };
    ScrollBlot.prototype.optimize = function (mutations, context) {
        var _this = this;
        if (mutations === void 0) { mutations = []; }
        if (context === void 0) { context = {}; }
        _super.prototype.optimize.call(this, context);
        // We must modify mutations directly, cannot make copy and then modify
        var records = [].slice.call(this.observer.takeRecords());
        // Array.push currently seems to be implemented by a non-tail recursive function
        // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
        while (records.length > 0)
            mutations.push(records.pop());
        // TODO use WeakMap
        var mark = function (blot, markParent) {
            if (markParent === void 0) { markParent = true; }
            if (blot == null || blot === _this)
                return;
            if (blot.domNode.parentNode == null)
                return;
            // @ts-ignore
            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations = [];
            }
            if (markParent)
                mark(blot.parent);
        };
        var optimize = function (blot) {
            // Post-order traversal
            if (
            // @ts-ignore
            blot.domNode[Registry.DATA_KEY] == null ||
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations == null) {
                return;
            }
            if (blot instanceof container_1.default) {
                blot.children.forEach(optimize);
            }
            blot.optimize(context);
        };
        var remaining = mutations;
        for (var i = 0; remaining.length > 0; i += 1) {
            if (i >= MAX_OPTIMIZE_ITERATIONS) {
                throw new Error('[Parchment] Maximum optimize iterations reached');
            }
            remaining.forEach(function (mutation) {
                var blot = Registry.find(mutation.target, true);
                if (blot == null)
                    return;
                if (blot.domNode === mutation.target) {
                    if (mutation.type === 'childList') {
                        mark(Registry.find(mutation.previousSibling, false));
                        [].forEach.call(mutation.addedNodes, function (node) {
                            var child = Registry.find(node, false);
                            mark(child, false);
                            if (child instanceof container_1.default) {
                                child.children.forEach(function (grandChild) {
                                    mark(grandChild, false);
                                });
                            }
                        });
                    }
                    else if (mutation.type === 'attributes') {
                        mark(blot.prev);
                    }
                }
                mark(blot);
            });
            this.children.forEach(optimize);
            remaining = [].slice.call(this.observer.takeRecords());
            records = remaining.slice();
            while (records.length > 0)
                mutations.push(records.pop());
        }
    };
    ScrollBlot.prototype.update = function (mutations, context) {
        var _this = this;
        if (context === void 0) { context = {}; }
        mutations = mutations || this.observer.takeRecords();
        // TODO use WeakMap
        mutations
            .map(function (mutation) {
            var blot = Registry.find(mutation.target, true);
            if (blot == null)
                return null;
            // @ts-ignore
            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations = [mutation];
                return blot;
            }
            else {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
                return null;
            }
        })
            .forEach(function (blot) {
            if (blot == null ||
                blot === _this ||
                //@ts-ignore
                blot.domNode[Registry.DATA_KEY] == null)
                return;
            // @ts-ignore
            blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
        });
        // @ts-ignore
        if (this.domNode[Registry.DATA_KEY].mutations != null) {
            // @ts-ignore
            _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
        }
        this.optimize(mutations, context);
    };
    ScrollBlot.blotName = 'scroll';
    ScrollBlot.defaultChild = 'block';
    ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
    ScrollBlot.tagName = 'DIV';
    return ScrollBlot;
}(container_1.default));
exports.default = ScrollBlot;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var format_1 = __webpack_require__(18);
var Registry = __webpack_require__(1);
// Shallow object comparison
function isEqual(obj1, obj2) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length)
        return false;
    // @ts-ignore
    for (var prop in obj1) {
        // @ts-ignore
        if (obj1[prop] !== obj2[prop])
            return false;
    }
    return true;
}
var InlineBlot = /** @class */ (function (_super) {
    __extends(InlineBlot, _super);
    function InlineBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InlineBlot.formats = function (domNode) {
        if (domNode.tagName === InlineBlot.tagName)
            return undefined;
        return _super.formats.call(this, domNode);
    };
    InlineBlot.prototype.format = function (name, value) {
        var _this = this;
        if (name === this.statics.blotName && !value) {
            this.children.forEach(function (child) {
                if (!(child instanceof format_1.default)) {
                    child = child.wrap(InlineBlot.blotName, true);
                }
                _this.attributes.copy(child);
            });
            this.unwrap();
        }
        else {
            _super.prototype.format.call(this, name, value);
        }
    };
    InlineBlot.prototype.formatAt = function (index, length, name, value) {
        if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
            var blot = this.isolate(index, length);
            blot.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    InlineBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        var formats = this.formats();
        if (Object.keys(formats).length === 0) {
            return this.unwrap(); // unformatted span
        }
        var next = this.next;
        if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
            next.moveChildren(this);
            next.remove();
        }
    };
    InlineBlot.blotName = 'inline';
    InlineBlot.scope = Registry.Scope.INLINE_BLOT;
    InlineBlot.tagName = 'SPAN';
    return InlineBlot;
}(format_1.default));
exports.default = InlineBlot;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var format_1 = __webpack_require__(18);
var Registry = __webpack_require__(1);
var BlockBlot = /** @class */ (function (_super) {
    __extends(BlockBlot, _super);
    function BlockBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BlockBlot.formats = function (domNode) {
        var tagName = Registry.query(BlockBlot.blotName).tagName;
        if (domNode.tagName === tagName)
            return undefined;
        return _super.formats.call(this, domNode);
    };
    BlockBlot.prototype.format = function (name, value) {
        if (Registry.query(name, Registry.Scope.BLOCK) == null) {
            return;
        }
        else if (name === this.statics.blotName && !value) {
            this.replaceWith(BlockBlot.blotName);
        }
        else {
            _super.prototype.format.call(this, name, value);
        }
    };
    BlockBlot.prototype.formatAt = function (index, length, name, value) {
        if (Registry.query(name, Registry.Scope.BLOCK) != null) {
            this.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    BlockBlot.prototype.insertAt = function (index, value, def) {
        if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
            // Insert text or inline
            _super.prototype.insertAt.call(this, index, value, def);
        }
        else {
            var after = this.split(index);
            var blot = Registry.create(value, def);
            after.parent.insertBefore(blot, after);
        }
    };
    BlockBlot.prototype.update = function (mutations, context) {
        if (navigator.userAgent.match(/Trident/)) {
            this.build();
        }
        else {
            _super.prototype.update.call(this, mutations, context);
        }
    };
    BlockBlot.blotName = 'block';
    BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
    BlockBlot.tagName = 'P';
    return BlockBlot;
}(format_1.default));
exports.default = BlockBlot;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var leaf_1 = __webpack_require__(19);
var EmbedBlot = /** @class */ (function (_super) {
    __extends(EmbedBlot, _super);
    function EmbedBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmbedBlot.formats = function (domNode) {
        return undefined;
    };
    EmbedBlot.prototype.format = function (name, value) {
        // super.formatAt wraps, which is what we want in general,
        // but this allows subclasses to overwrite for formats
        // that just apply to particular embeds
        _super.prototype.formatAt.call(this, 0, this.length(), name, value);
    };
    EmbedBlot.prototype.formatAt = function (index, length, name, value) {
        if (index === 0 && length === this.length()) {
            this.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    EmbedBlot.prototype.formats = function () {
        return this.statics.formats(this.domNode);
    };
    return EmbedBlot;
}(leaf_1.default));
exports.default = EmbedBlot;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var leaf_1 = __webpack_require__(19);
var Registry = __webpack_require__(1);
var TextBlot = /** @class */ (function (_super) {
    __extends(TextBlot, _super);
    function TextBlot(node) {
        var _this = _super.call(this, node) || this;
        _this.text = _this.statics.value(_this.domNode);
        return _this;
    }
    TextBlot.create = function (value) {
        return document.createTextNode(value);
    };
    TextBlot.value = function (domNode) {
        var text = domNode.data;
        // @ts-ignore
        if (text['normalize'])
            text = text['normalize']();
        return text;
    };
    TextBlot.prototype.deleteAt = function (index, length) {
        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
    };
    TextBlot.prototype.index = function (node, offset) {
        if (this.domNode === node) {
            return offset;
        }
        return -1;
    };
    TextBlot.prototype.insertAt = function (index, value, def) {
        if (def == null) {
            this.text = this.text.slice(0, index) + value + this.text.slice(index);
            this.domNode.data = this.text;
        }
        else {
            _super.prototype.insertAt.call(this, index, value, def);
        }
    };
    TextBlot.prototype.length = function () {
        return this.text.length;
    };
    TextBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        this.text = this.statics.value(this.domNode);
        if (this.text.length === 0) {
            this.remove();
        }
        else if (this.next instanceof TextBlot && this.next.prev === this) {
            this.insertAt(this.length(), this.next.value());
            this.next.remove();
        }
    };
    TextBlot.prototype.position = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        return [this.domNode, index];
    };
    TextBlot.prototype.split = function (index, force) {
        if (force === void 0) { force = false; }
        if (!force) {
            if (index === 0)
                return this;
            if (index === this.length())
                return this.next;
        }
        var after = Registry.create(this.domNode.splitText(index));
        this.parent.insertBefore(after, this.next);
        this.text = this.statics.value(this.domNode);
        return after;
    };
    TextBlot.prototype.update = function (mutations, context) {
        var _this = this;
        if (mutations.some(function (mutation) {
            return mutation.type === 'characterData' && mutation.target === _this.domNode;
        })) {
            this.text = this.statics.value(this.domNode);
        }
    };
    TextBlot.prototype.value = function () {
        return this.text;
    };
    TextBlot.blotName = 'text';
    TextBlot.scope = Registry.Scope.INLINE_BLOT;
    return TextBlot;
}(leaf_1.default));
exports.default = TextBlot;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elem = document.createElement('div');
elem.classList.toggle('test-class', false);
if (elem.classList.contains('test-class')) {
  var _toggle = DOMTokenList.prototype.toggle;
  DOMTokenList.prototype.toggle = function (token, force) {
    if (arguments.length > 1 && !this.contains(token) === !force) {
      return force;
    } else {
      return _toggle.call(this, token);
    }
  };
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString, position) {
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
  };
}

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function (searchString, position) {
    var subjectString = this.toString();
    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
      position = subjectString.length;
    }
    position -= searchString.length;
    var lastIndex = subjectString.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
  };
}

if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, "find", {
    value: function value(predicate) {
      if (this === null) {
        throw new TypeError('Array.prototype.find called on null or undefined');
      }
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }
      var list = Object(this);
      var length = list.length >>> 0;
      var thisArg = arguments[1];
      var value;

      for (var i = 0; i < length; i++) {
        value = list[i];
        if (predicate.call(thisArg, value, i, list)) {
          return value;
        }
      }
      return undefined;
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // Disable resizing in Firefox
  document.execCommand("enableObjectResizing", false, false);
  // Disable automatic linkifying in IE11
  document.execCommand("autoUrlDetect", false, false);
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

/**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */
var DIFF_DELETE = -1;
var DIFF_INSERT = 1;
var DIFF_EQUAL = 0;


/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int} cursor_pos Expected edit position in text1 (optional)
 * @return {Array} Array of diff tuples.
 */
function diff_main(text1, text2, cursor_pos) {
  // Check for equality (speedup).
  if (text1 == text2) {
    if (text1) {
      return [[DIFF_EQUAL, text1]];
    }
    return [];
  }

  // Check cursor_pos within bounds
  if (cursor_pos < 0 || text1.length < cursor_pos) {
    cursor_pos = null;
  }

  // Trim off common prefix (speedup).
  var commonlength = diff_commonPrefix(text1, text2);
  var commonprefix = text1.substring(0, commonlength);
  text1 = text1.substring(commonlength);
  text2 = text2.substring(commonlength);

  // Trim off common suffix (speedup).
  commonlength = diff_commonSuffix(text1, text2);
  var commonsuffix = text1.substring(text1.length - commonlength);
  text1 = text1.substring(0, text1.length - commonlength);
  text2 = text2.substring(0, text2.length - commonlength);

  // Compute the diff on the middle block.
  var diffs = diff_compute_(text1, text2);

  // Restore the prefix and suffix.
  if (commonprefix) {
    diffs.unshift([DIFF_EQUAL, commonprefix]);
  }
  if (commonsuffix) {
    diffs.push([DIFF_EQUAL, commonsuffix]);
  }
  diff_cleanupMerge(diffs);
  if (cursor_pos != null) {
    diffs = fix_cursor(diffs, cursor_pos);
  }
  diffs = fix_emoji(diffs);
  return diffs;
};


/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */
function diff_compute_(text1, text2) {
  var diffs;

  if (!text1) {
    // Just add some text (speedup).
    return [[DIFF_INSERT, text2]];
  }

  if (!text2) {
    // Just delete some text (speedup).
    return [[DIFF_DELETE, text1]];
  }

  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  var i = longtext.indexOf(shorttext);
  if (i != -1) {
    // Shorter text is inside the longer text (speedup).
    diffs = [[DIFF_INSERT, longtext.substring(0, i)],
             [DIFF_EQUAL, shorttext],
             [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
    // Swap insertions for deletions if diff is reversed.
    if (text1.length > text2.length) {
      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
    }
    return diffs;
  }

  if (shorttext.length == 1) {
    // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
  }

  // Check to see if the problem can be split in two.
  var hm = diff_halfMatch_(text1, text2);
  if (hm) {
    // A half-match was found, sort out the return data.
    var text1_a = hm[0];
    var text1_b = hm[1];
    var text2_a = hm[2];
    var text2_b = hm[3];
    var mid_common = hm[4];
    // Send both pairs off for separate processing.
    var diffs_a = diff_main(text1_a, text2_a);
    var diffs_b = diff_main(text1_b, text2_b);
    // Merge the results.
    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
  }

  return diff_bisect_(text1, text2);
};


/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */
function diff_bisect_(text1, text2) {
  // Cache the text lengths to prevent multiple calls.
  var text1_length = text1.length;
  var text2_length = text2.length;
  var max_d = Math.ceil((text1_length + text2_length) / 2);
  var v_offset = max_d;
  var v_length = 2 * max_d;
  var v1 = new Array(v_length);
  var v2 = new Array(v_length);
  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
  // integers and undefined.
  for (var x = 0; x < v_length; x++) {
    v1[x] = -1;
    v2[x] = -1;
  }
  v1[v_offset + 1] = 0;
  v2[v_offset + 1] = 0;
  var delta = text1_length - text2_length;
  // If the total number of characters is odd, then the front path will collide
  // with the reverse path.
  var front = (delta % 2 != 0);
  // Offsets for start and end of k loop.
  // Prevents mapping of space beyond the grid.
  var k1start = 0;
  var k1end = 0;
  var k2start = 0;
  var k2end = 0;
  for (var d = 0; d < max_d; d++) {
    // Walk the front path one step.
    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
      var k1_offset = v_offset + k1;
      var x1;
      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
        x1 = v1[k1_offset + 1];
      } else {
        x1 = v1[k1_offset - 1] + 1;
      }
      var y1 = x1 - k1;
      while (x1 < text1_length && y1 < text2_length &&
             text1.charAt(x1) == text2.charAt(y1)) {
        x1++;
        y1++;
      }
      v1[k1_offset] = x1;
      if (x1 > text1_length) {
        // Ran off the right of the graph.
        k1end += 2;
      } else if (y1 > text2_length) {
        // Ran off the bottom of the graph.
        k1start += 2;
      } else if (front) {
        var k2_offset = v_offset + delta - k1;
        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
          // Mirror x2 onto top-left coordinate system.
          var x2 = text1_length - v2[k2_offset];
          if (x1 >= x2) {
            // Overlap detected.
            return diff_bisectSplit_(text1, text2, x1, y1);
          }
        }
      }
    }

    // Walk the reverse path one step.
    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
      var k2_offset = v_offset + k2;
      var x2;
      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
        x2 = v2[k2_offset + 1];
      } else {
        x2 = v2[k2_offset - 1] + 1;
      }
      var y2 = x2 - k2;
      while (x2 < text1_length && y2 < text2_length &&
             text1.charAt(text1_length - x2 - 1) ==
             text2.charAt(text2_length - y2 - 1)) {
        x2++;
        y2++;
      }
      v2[k2_offset] = x2;
      if (x2 > text1_length) {
        // Ran off the left of the graph.
        k2end += 2;
      } else if (y2 > text2_length) {
        // Ran off the top of the graph.
        k2start += 2;
      } else if (!front) {
        var k1_offset = v_offset + delta - k2;
        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
          var x1 = v1[k1_offset];
          var y1 = v_offset + x1 - k1_offset;
          // Mirror x2 onto top-left coordinate system.
          x2 = text1_length - x2;
          if (x1 >= x2) {
            // Overlap detected.
            return diff_bisectSplit_(text1, text2, x1, y1);
          }
        }
      }
    }
  }
  // Diff took too long and hit the deadline or
  // number of diffs equals number of characters, no commonality at all.
  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
};


/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */
function diff_bisectSplit_(text1, text2, x, y) {
  var text1a = text1.substring(0, x);
  var text2a = text2.substring(0, y);
  var text1b = text1.substring(x);
  var text2b = text2.substring(y);

  // Compute both diffs serially.
  var diffs = diff_main(text1a, text2a);
  var diffsb = diff_main(text1b, text2b);

  return diffs.concat(diffsb);
};


/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */
function diff_commonPrefix(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerstart = 0;
  while (pointermin < pointermid) {
    if (text1.substring(pointerstart, pointermid) ==
        text2.substring(pointerstart, pointermid)) {
      pointermin = pointermid;
      pointerstart = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */
function diff_commonSuffix(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 ||
      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerend = 0;
  while (pointermin < pointermid) {
    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
      pointermin = pointermid;
      pointerend = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */
function diff_halfMatch_(text1, text2) {
  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
    return null;  // Pointless.
  }

  /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */
  function diff_halfMatchI_(longtext, shorttext, i) {
    // Start with a 1/4 length substring at position i as a seed.
    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
    var j = -1;
    var best_common = '';
    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
      var prefixLength = diff_commonPrefix(longtext.substring(i),
                                           shorttext.substring(j));
      var suffixLength = diff_commonSuffix(longtext.substring(0, i),
                                           shorttext.substring(0, j));
      if (best_common.length < suffixLength + prefixLength) {
        best_common = shorttext.substring(j - suffixLength, j) +
            shorttext.substring(j, j + prefixLength);
        best_longtext_a = longtext.substring(0, i - suffixLength);
        best_longtext_b = longtext.substring(i + prefixLength);
        best_shorttext_a = shorttext.substring(0, j - suffixLength);
        best_shorttext_b = shorttext.substring(j + prefixLength);
      }
    }
    if (best_common.length * 2 >= longtext.length) {
      return [best_longtext_a, best_longtext_b,
              best_shorttext_a, best_shorttext_b, best_common];
    } else {
      return null;
    }
  }

  // First check if the second quarter is the seed for a half-match.
  var hm1 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 4));
  // Check again based on the third quarter.
  var hm2 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 2));
  var hm;
  if (!hm1 && !hm2) {
    return null;
  } else if (!hm2) {
    hm = hm1;
  } else if (!hm1) {
    hm = hm2;
  } else {
    // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
  }

  // A half-match was found, sort out the return data.
  var text1_a, text1_b, text2_a, text2_b;
  if (text1.length > text2.length) {
    text1_a = hm[0];
    text1_b = hm[1];
    text2_a = hm[2];
    text2_b = hm[3];
  } else {
    text2_a = hm[0];
    text2_b = hm[1];
    text1_a = hm[2];
    text1_b = hm[3];
  }
  var mid_common = hm[4];
  return [text1_a, text1_b, text2_a, text2_b, mid_common];
};


/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 */
function diff_cleanupMerge(diffs) {
  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
  var pointer = 0;
  var count_delete = 0;
  var count_insert = 0;
  var text_delete = '';
  var text_insert = '';
  var commonlength;
  while (pointer < diffs.length) {
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:
        count_insert++;
        text_insert += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_EQUAL:
        // Upon reaching an equality, check for prior redundancies.
        if (count_delete + count_insert > 1) {
          if (count_delete !== 0 && count_insert !== 0) {
            // Factor out any common prefixies.
            commonlength = diff_commonPrefix(text_insert, text_delete);
            if (commonlength !== 0) {
              if ((pointer - count_delete - count_insert) > 0 &&
                  diffs[pointer - count_delete - count_insert - 1][0] ==
                  DIFF_EQUAL) {
                diffs[pointer - count_delete - count_insert - 1][1] +=
                    text_insert.substring(0, commonlength);
              } else {
                diffs.splice(0, 0, [DIFF_EQUAL,
                                    text_insert.substring(0, commonlength)]);
                pointer++;
              }
              text_insert = text_insert.substring(commonlength);
              text_delete = text_delete.substring(commonlength);
            }
            // Factor out any common suffixies.
            commonlength = diff_commonSuffix(text_insert, text_delete);
            if (commonlength !== 0) {
              diffs[pointer][1] = text_insert.substring(text_insert.length -
                  commonlength) + diffs[pointer][1];
              text_insert = text_insert.substring(0, text_insert.length -
                  commonlength);
              text_delete = text_delete.substring(0, text_delete.length -
                  commonlength);
            }
          }
          // Delete the offending records and add the merged ones.
          if (count_delete === 0) {
            diffs.splice(pointer - count_insert,
                count_delete + count_insert, [DIFF_INSERT, text_insert]);
          } else if (count_insert === 0) {
            diffs.splice(pointer - count_delete,
                count_delete + count_insert, [DIFF_DELETE, text_delete]);
          } else {
            diffs.splice(pointer - count_delete - count_insert,
                count_delete + count_insert, [DIFF_DELETE, text_delete],
                [DIFF_INSERT, text_insert]);
          }
          pointer = pointer - count_delete - count_insert +
                    (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
          // Merge this equality with the previous one.
          diffs[pointer - 1][1] += diffs[pointer][1];
          diffs.splice(pointer, 1);
        } else {
          pointer++;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
  }
  if (diffs[diffs.length - 1][1] === '') {
    diffs.pop();  // Remove the dummy entry at the end.
  }

  // Second pass: look for single edits surrounded on both sides by equalities
  // which can be shifted sideways to eliminate an equality.
  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
  var changes = false;
  pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
        diffs[pointer + 1][0] == DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      if (diffs[pointer][1].substring(diffs[pointer][1].length -
          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
        // Shift the edit over the previous equality.
        diffs[pointer][1] = diffs[pointer - 1][1] +
            diffs[pointer][1].substring(0, diffs[pointer][1].length -
                                        diffs[pointer - 1][1].length);
        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
        diffs.splice(pointer - 1, 1);
        changes = true;
      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
          diffs[pointer + 1][1]) {
        // Shift the edit over the next equality.
        diffs[pointer - 1][1] += diffs[pointer + 1][1];
        diffs[pointer][1] =
            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
            diffs[pointer + 1][1];
        diffs.splice(pointer + 1, 1);
        changes = true;
      }
    }
    pointer++;
  }
  // If shifts were made, the diff needs reordering and another shift sweep.
  if (changes) {
    diff_cleanupMerge(diffs);
  }
};


var diff = diff_main;
diff.INSERT = DIFF_INSERT;
diff.DELETE = DIFF_DELETE;
diff.EQUAL = DIFF_EQUAL;

module.exports = diff;

/*
 * Modify a diff such that the cursor position points to the start of a change:
 * E.g.
 *   cursor_normalize_diff([[DIFF_EQUAL, 'abc']], 1)
 *     => [1, [[DIFF_EQUAL, 'a'], [DIFF_EQUAL, 'bc']]]
 *   cursor_normalize_diff([[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xyz']], 2)
 *     => [2, [[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xy'], [DIFF_DELETE, 'z']]]
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} A tuple [cursor location in the modified diff, modified diff]
 */
function cursor_normalize_diff (diffs, cursor_pos) {
  if (cursor_pos === 0) {
    return [DIFF_EQUAL, diffs];
  }
  for (var current_pos = 0, i = 0; i < diffs.length; i++) {
    var d = diffs[i];
    if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
      var next_pos = current_pos + d[1].length;
      if (cursor_pos === next_pos) {
        return [i + 1, diffs];
      } else if (cursor_pos < next_pos) {
        // copy to prevent side effects
        diffs = diffs.slice();
        // split d into two diff changes
        var split_pos = cursor_pos - current_pos;
        var d_left = [d[0], d[1].slice(0, split_pos)];
        var d_right = [d[0], d[1].slice(split_pos)];
        diffs.splice(i, 1, d_left, d_right);
        return [i + 1, diffs];
      } else {
        current_pos = next_pos;
      }
    }
  }
  throw new Error('cursor_pos is out of bounds!')
}

/*
 * Modify a diff such that the edit position is "shifted" to the proposed edit location (cursor_position).
 *
 * Case 1)
 *   Check if a naive shift is possible:
 *     [0, X], [ 1, Y] -> [ 1, Y], [0, X]    (if X + Y === Y + X)
 *     [0, X], [-1, Y] -> [-1, Y], [0, X]    (if X + Y === Y + X) - holds same result
 * Case 2)
 *   Check if the following shifts are possible:
 *     [0, 'pre'], [ 1, 'prefix'] -> [ 1, 'pre'], [0, 'pre'], [ 1, 'fix']
 *     [0, 'pre'], [-1, 'prefix'] -> [-1, 'pre'], [0, 'pre'], [-1, 'fix']
 *         ^            ^
 *         d          d_next
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} Array of diff tuples
 */
function fix_cursor (diffs, cursor_pos) {
  var norm = cursor_normalize_diff(diffs, cursor_pos);
  var ndiffs = norm[1];
  var cursor_pointer = norm[0];
  var d = ndiffs[cursor_pointer];
  var d_next = ndiffs[cursor_pointer + 1];

  if (d == null) {
    // Text was deleted from end of original string,
    // cursor is now out of bounds in new string
    return diffs;
  } else if (d[0] !== DIFF_EQUAL) {
    // A modification happened at the cursor location.
    // This is the expected outcome, so we can return the original diff.
    return diffs;
  } else {
    if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
      // Case 1)
      // It is possible to perform a naive shift
      ndiffs.splice(cursor_pointer, 2, d_next, d)
      return merge_tuples(ndiffs, cursor_pointer, 2)
    } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
      // Case 2)
      // d[1] is a prefix of d_next[1]
      // We can assume that d_next[0] !== 0, since d[0] === 0
      // Shift edit locations..
      ndiffs.splice(cursor_pointer, 2, [d_next[0], d[1]], [0, d[1]]);
      var suffix = d_next[1].slice(d[1].length);
      if (suffix.length > 0) {
        ndiffs.splice(cursor_pointer + 2, 0, [d_next[0], suffix]);
      }
      return merge_tuples(ndiffs, cursor_pointer, 3)
    } else {
      // Not possible to perform any modification
      return diffs;
    }
  }
}

/*
 * Check diff did not split surrogate pairs.
 * Ex. [0, '\uD83D'], [-1, '\uDC36'], [1, '\uDC2F'] -> [-1, '\uD83D\uDC36'], [1, '\uD83D\uDC2F']
 *     '\uD83D\uDC36' === '🐶', '\uD83D\uDC2F' === '🐯'
 *
 * @param {Array} diffs Array of diff tuples
 * @return {Array} Array of diff tuples
 */
function fix_emoji (diffs) {
  var compact = false;
  var starts_with_pair_end = function(str) {
    return str.charCodeAt(0) >= 0xDC00 && str.charCodeAt(0) <= 0xDFFF;
  }
  var ends_with_pair_start = function(str) {
    return str.charCodeAt(str.length-1) >= 0xD800 && str.charCodeAt(str.length-1) <= 0xDBFF;
  }
  for (var i = 2; i < diffs.length; i += 1) {
    if (diffs[i-2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i-2][1]) &&
        diffs[i-1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i-1][1]) &&
        diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
      compact = true;

      diffs[i-1][1] = diffs[i-2][1].slice(-1) + diffs[i-1][1];
      diffs[i][1] = diffs[i-2][1].slice(-1) + diffs[i][1];

      diffs[i-2][1] = diffs[i-2][1].slice(0, -1);
    }
  }
  if (!compact) {
    return diffs;
  }
  var fixed_diffs = [];
  for (var i = 0; i < diffs.length; i += 1) {
    if (diffs[i][1].length > 0) {
      fixed_diffs.push(diffs[i]);
    }
  }
  return fixed_diffs;
}

/*
 * Try to merge tuples with their neigbors in a given range.
 * E.g. [0, 'a'], [0, 'b'] -> [0, 'ab']
 *
 * @param {Array} diffs Array of diff tuples.
 * @param {Int} start Position of the first element to merge (diffs[start] is also merged with diffs[start - 1]).
 * @param {Int} length Number of consecutive elements to check.
 * @return {Array} Array of merged diff tuples.
 */
function merge_tuples (diffs, start, length) {
  // Check from (start-1) to (start+length).
  for (var i = start + length - 1; i >= 0 && i >= start - 1; i--) {
    if (i + 1 < diffs.length) {
      var left_d = diffs[i];
      var right_d = diffs[i+1];
      if (left_d[0] === right_d[1]) {
        diffs.splice(i, 2, [left_d[0], left_d[1] + right_d[1]]);
      }
    }
  }
  return diffs;
}


/***/ }),
/* 52 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 53 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

'use strict';

var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
         listeners.fn === fn
      && (!once || listeners.once)
      && (!context || listeners.context === context)
    ) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
           listeners[i].fn !== fn
        || (once && !listeners[i].once)
        || (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if ('undefined' !== typeof module) {
  module.exports = EventEmitter;
}


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend2 = __webpack_require__(3);

var _extend3 = _interopRequireDefault(_extend2);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

var _align = __webpack_require__(36);

var _background = __webpack_require__(37);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _color = __webpack_require__(26);

var _direction = __webpack_require__(38);

var _font = __webpack_require__(39);

var _size = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:clipboard');

var DOM_KEY = '__ql-matcher';

var CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ['br', matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchSpacing], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ['li', matchIndent], ['b', matchAlias.bind(matchAlias, 'bold')], ['i', matchAlias.bind(matchAlias, 'italic')], ['style', matchIgnore]];

var ATTRIBUTE_ATTRIBUTORS = [_align.AlignAttribute, _direction.DirectionAttribute].reduce(function (memo, attr) {
  memo[attr.keyName] = attr;
  return memo;
}, {});

var STYLE_ATTRIBUTORS = [_align.AlignStyle, _background.BackgroundStyle, _color.ColorStyle, _direction.DirectionStyle, _font.FontStyle, _size.SizeStyle].reduce(function (memo, attr) {
  memo[attr.keyName] = attr;
  return memo;
}, {});

var Clipboard = function (_Module) {
  _inherits(Clipboard, _Module);

  function Clipboard(quill, options) {
    _classCallCheck(this, Clipboard);

    var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));

    _this.quill.root.addEventListener('paste', _this.onPaste.bind(_this));
    _this.container = _this.quill.addContainer('ql-clipboard');
    _this.container.setAttribute('contenteditable', true);
    _this.container.setAttribute('tabindex', -1);
    _this.matchers = [];
    CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          selector = _ref2[0],
          matcher = _ref2[1];

      if (!options.matchVisual && matcher === matchSpacing) return;
      _this.addMatcher(selector, matcher);
    });
    return _this;
  }

  _createClass(Clipboard, [{
    key: 'addMatcher',
    value: function addMatcher(selector, matcher) {
      this.matchers.push([selector, matcher]);
    }
  }, {
    key: 'convert',
    value: function convert(html) {
      if (typeof html === 'string') {
        this.container.innerHTML = html.replace(/\>\r?\n +\</g, '><'); // Remove spaces between tags
        return this.convert();
      }
      var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
      if (formats[_code2.default.blotName]) {
        var text = this.container.innerText;
        this.container.innerHTML = '';
        return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
      }

      var _prepareMatching = this.prepareMatching(),
          _prepareMatching2 = _slicedToArray(_prepareMatching, 2),
          elementMatchers = _prepareMatching2[0],
          textMatchers = _prepareMatching2[1];

      var delta = traverse(this.container, elementMatchers, textMatchers);
      // Remove trailing newline
      if (deltaEndsWith(delta, '\n') && delta.ops[delta.ops.length - 1].attributes == null) {
        delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
      }
      debug.log('convert', this.container.innerHTML, delta);
      this.container.innerHTML = '';
      return delta;
    }
  }, {
    key: 'dangerouslyPasteHTML',
    value: function dangerouslyPasteHTML(index, html) {
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;

      if (typeof index === 'string') {
        this.quill.setContents(this.convert(index), html);
        this.quill.setSelection(0, _quill2.default.sources.SILENT);
      } else {
        var paste = this.convert(html);
        this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
        this.quill.setSelection(index + paste.length(), _quill2.default.sources.SILENT);
      }
    }
  }, {
    key: 'onPaste',
    value: function onPaste(e) {
      var _this2 = this;

      if (e.defaultPrevented || !this.quill.isEnabled()) return;
      var range = this.quill.getSelection();
      var delta = new _quillDelta2.default().retain(range.index);
      var scrollTop = this.quill.scrollingContainer.scrollTop;
      this.container.focus();
      this.quill.selection.update(_quill2.default.sources.SILENT);
      setTimeout(function () {
        delta = delta.concat(_this2.convert()).delete(range.length);
        _this2.quill.updateContents(delta, _quill2.default.sources.USER);
        // range.length contributes to delta.length()
        _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
        _this2.quill.scrollingContainer.scrollTop = scrollTop;
        _this2.quill.focus();
      }, 1);
    }
  }, {
    key: 'prepareMatching',
    value: function prepareMatching() {
      var _this3 = this;

      var elementMatchers = [],
          textMatchers = [];
      this.matchers.forEach(function (pair) {
        var _pair = _slicedToArray(pair, 2),
            selector = _pair[0],
            matcher = _pair[1];

        switch (selector) {
          case Node.TEXT_NODE:
            textMatchers.push(matcher);
            break;
          case Node.ELEMENT_NODE:
            elementMatchers.push(matcher);
            break;
          default:
            [].forEach.call(_this3.container.querySelectorAll(selector), function (node) {
              // TODO use weakmap
              node[DOM_KEY] = node[DOM_KEY] || [];
              node[DOM_KEY].push(matcher);
            });
            break;
        }
      });
      return [elementMatchers, textMatchers];
    }
  }]);

  return Clipboard;
}(_module2.default);

Clipboard.DEFAULTS = {
  matchers: [],
  matchVisual: true
};

function applyFormat(delta, format, value) {
  if ((typeof format === 'undefined' ? 'undefined' : _typeof(format)) === 'object') {
    return Object.keys(format).reduce(function (delta, key) {
      return applyFormat(delta, key, format[key]);
    }, delta);
  } else {
    return delta.reduce(function (delta, op) {
      if (op.attributes && op.attributes[format]) {
        return delta.push(op);
      } else {
        return delta.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
      }
    }, new _quillDelta2.default());
  }
}

function computeStyle(node) {
  if (node.nodeType !== Node.ELEMENT_NODE) return {};
  var DOM_KEY = '__ql-computed-style';
  return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
}

function deltaEndsWith(delta, text) {
  var endText = "";
  for (var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i) {
    var op = delta.ops[i];
    if (typeof op.insert !== 'string') break;
    endText = op.insert + endText;
  }
  return endText.slice(-1 * text.length) === text;
}

function isLine(node) {
  if (node.childNodes.length === 0) return false; // Exclude embed blocks
  var style = computeStyle(node);
  return ['block', 'list-item'].indexOf(style.display) > -1;
}

function traverse(node, elementMatchers, textMatchers) {
  // Post-order
  if (node.nodeType === node.TEXT_NODE) {
    return textMatchers.reduce(function (delta, matcher) {
      return matcher(node, delta);
    }, new _quillDelta2.default());
  } else if (node.nodeType === node.ELEMENT_NODE) {
    return [].reduce.call(node.childNodes || [], function (delta, childNode) {
      var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
      if (childNode.nodeType === node.ELEMENT_NODE) {
        childrenDelta = elementMatchers.reduce(function (childrenDelta, matcher) {
          return matcher(childNode, childrenDelta);
        }, childrenDelta);
        childrenDelta = (childNode[DOM_KEY] || []).reduce(function (childrenDelta, matcher) {
          return matcher(childNode, childrenDelta);
        }, childrenDelta);
      }
      return delta.concat(childrenDelta);
    }, new _quillDelta2.default());
  } else {
    return new _quillDelta2.default();
  }
}

function matchAlias(format, node, delta) {
  return applyFormat(delta, format, true);
}

function matchAttributor(node, delta) {
  var attributes = _parchment2.default.Attributor.Attribute.keys(node);
  var classes = _parchment2.default.Attributor.Class.keys(node);
  var styles = _parchment2.default.Attributor.Style.keys(node);
  var formats = {};
  attributes.concat(classes).concat(styles).forEach(function (name) {
    var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
    if (attr != null) {
      formats[attr.attrName] = attr.value(node);
      if (formats[attr.attrName]) return;
    }
    attr = ATTRIBUTE_ATTRIBUTORS[name];
    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
      formats[attr.attrName] = attr.value(node) || undefined;
    }
    attr = STYLE_ATTRIBUTORS[name];
    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
      attr = STYLE_ATTRIBUTORS[name];
      formats[attr.attrName] = attr.value(node) || undefined;
    }
  });
  if (Object.keys(formats).length > 0) {
    delta = applyFormat(delta, formats);
  }
  return delta;
}

function matchBlot(node, delta) {
  var match = _parchment2.default.query(node);
  if (match == null) return delta;
  if (match.prototype instanceof _parchment2.default.Embed) {
    var embed = {};
    var value = match.value(node);
    if (value != null) {
      embed[match.blotName] = value;
      delta = new _quillDelta2.default().insert(embed, match.formats(node));
    }
  } else if (typeof match.formats === 'function') {
    delta = applyFormat(delta, match.blotName, match.formats(node));
  }
  return delta;
}

function matchBreak(node, delta) {
  if (!deltaEndsWith(delta, '\n')) {
    delta.insert('\n');
  }
  return delta;
}

function matchIgnore() {
  return new _quillDelta2.default();
}

function matchIndent(node, delta) {
  var match = _parchment2.default.query(node);
  if (match == null || match.blotName !== 'list-item' || !deltaEndsWith(delta, '\n')) {
    return delta;
  }
  var indent = -1,
      parent = node.parentNode;
  while (!parent.classList.contains('ql-clipboard')) {
    if ((_parchment2.default.query(parent) || {}).blotName === 'list') {
      indent += 1;
    }
    parent = parent.parentNode;
  }
  if (indent <= 0) return delta;
  return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, { indent: indent }));
}

function matchNewline(node, delta) {
  if (!deltaEndsWith(delta, '\n')) {
    if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) {
      delta.insert('\n');
    }
  }
  return delta;
}

function matchSpacing(node, delta) {
  if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, '\n\n')) {
    var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
    if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) {
      delta.insert('\n');
    }
  }
  return delta;
}

function matchStyles(node, delta) {
  var formats = {};
  var style = node.style || {};
  if (style.fontStyle && computeStyle(node).fontStyle === 'italic') {
    formats.italic = true;
  }
  if (style.fontWeight && (computeStyle(node).fontWeight.startsWith('bold') || parseInt(computeStyle(node).fontWeight) >= 700)) {
    formats.bold = true;
  }
  if (Object.keys(formats).length > 0) {
    delta = applyFormat(delta, formats);
  }
  if (parseFloat(style.textIndent || 0) > 0) {
    // Could be 0.5in
    delta = new _quillDelta2.default().insert('\t').concat(delta);
  }
  return delta;
}

function matchText(node, delta) {
  var text = node.data;
  // Word represents empty line with <o:p>&nbsp;</o:p>
  if (node.parentNode.tagName === 'O:P') {
    return delta.insert(text.trim());
  }
  if (text.trim().length === 0 && node.parentNode.classList.contains('ql-clipboard')) {
    return delta;
  }
  if (!computeStyle(node.parentNode).whiteSpace.startsWith('pre')) {
    // eslint-disable-next-line func-style
    var replacer = function replacer(collapse, match) {
      match = match.replace(/[^\u00a0]/g, ''); // \u00a0 is nbsp;
      return match.length < 1 && collapse ? ' ' : match;
    };
    text = text.replace(/\r\n/g, ' ').replace(/\n/g, ' ');
    text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
    if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) {
      text = text.replace(/^\s+/, replacer.bind(replacer, false));
    }
    if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) {
      text = text.replace(/\s+$/, replacer.bind(replacer, false));
    }
  }
  return delta.insert(text);
}

exports.default = Clipboard;
exports.matchAttributor = matchAttributor;
exports.matchBlot = matchBlot;
exports.matchNewline = matchNewline;
exports.matchSpacing = matchSpacing;
exports.matchText = matchText;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Bold = function (_Inline) {
  _inherits(Bold, _Inline);

  function Bold() {
    _classCallCheck(this, Bold);

    return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
  }

  _createClass(Bold, [{
    key: 'optimize',
    value: function optimize(context) {
      _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), 'optimize', this).call(this, context);
      if (this.domNode.tagName !== this.statics.tagName[0]) {
        this.replaceWith(this.statics.blotName);
      }
    }
  }], [{
    key: 'create',
    value: function create() {
      return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), 'create', this).call(this);
    }
  }, {
    key: 'formats',
    value: function formats() {
      return true;
    }
  }]);

  return Bold;
}(_inline2.default);

Bold.blotName = 'bold';
Bold.tagName = ['STRONG', 'B'];

exports.default = Bold;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addControls = exports.default = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:toolbar');

var Toolbar = function (_Module) {
  _inherits(Toolbar, _Module);

  function Toolbar(quill, options) {
    _classCallCheck(this, Toolbar);

    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));

    if (Array.isArray(_this.options.container)) {
      var container = document.createElement('div');
      addControls(container, _this.options.container);
      quill.container.parentNode.insertBefore(container, quill.container);
      _this.container = container;
    } else if (typeof _this.options.container === 'string') {
      _this.container = document.querySelector(_this.options.container);
    } else {
      _this.container = _this.options.container;
    }
    if (!(_this.container instanceof HTMLElement)) {
      var _ret;

      return _ret = debug.error('Container required for toolbar', _this.options), _possibleConstructorReturn(_this, _ret);
    }
    _this.container.classList.add('ql-toolbar');
    _this.controls = [];
    _this.handlers = {};
    Object.keys(_this.options.handlers).forEach(function (format) {
      _this.addHandler(format, _this.options.handlers[format]);
    });
    [].forEach.call(_this.container.querySelectorAll('button, select'), function (input) {
      _this.attach(input);
    });
    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (type, range) {
      if (type === _quill2.default.events.SELECTION_CHANGE) {
        _this.update(range);
      }
    });
    _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
      var _this$quill$selection = _this.quill.selection.getRange(),
          _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1),
          range = _this$quill$selection2[0]; // quill.getSelection triggers update


      _this.update(range);
    });
    return _this;
  }

  _createClass(Toolbar, [{
    key: 'addHandler',
    value: function addHandler(format, handler) {
      this.handlers[format] = handler;
    }
  }, {
    key: 'attach',
    value: function attach(input) {
      var _this2 = this;

      var format = [].find.call(input.classList, function (className) {
        return className.indexOf('ql-') === 0;
      });
      if (!format) return;
      format = format.slice('ql-'.length);
      if (input.tagName === 'BUTTON') {
        input.setAttribute('type', 'button');
      }
      if (this.handlers[format] == null) {
        if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
          debug.warn('ignoring attaching to disabled format', format, input);
          return;
        }
        if (_parchment2.default.query(format) == null) {
          debug.warn('ignoring attaching to nonexistent format', format, input);
          return;
        }
      }
      var eventName = input.tagName === 'SELECT' ? 'change' : 'click';
      input.addEventListener(eventName, function (e) {
        var value = void 0;
        if (input.tagName === 'SELECT') {
          if (input.selectedIndex < 0) return;
          var selected = input.options[input.selectedIndex];
          if (selected.hasAttribute('selected')) {
            value = false;
          } else {
            value = selected.value || false;
          }
        } else {
          if (input.classList.contains('ql-active')) {
            value = false;
          } else {
            value = input.value || !input.hasAttribute('value');
          }
          e.preventDefault();
        }
        _this2.quill.focus();

        var _quill$selection$getR = _this2.quill.selection.getRange(),
            _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1),
            range = _quill$selection$getR2[0];

        if (_this2.handlers[format] != null) {
          _this2.handlers[format].call(_this2, value);
        } else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
          value = prompt('Enter ' + format);
          if (!value) return;
          _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
        } else {
          _this2.quill.format(format, value, _quill2.default.sources.USER);
        }
        _this2.update(range);
      });
      // TODO use weakmap
      this.controls.push([format, input]);
    }
  }, {
    key: 'update',
    value: function update(range) {
      var formats = range == null ? {} : this.quill.getFormat(range);
      this.controls.forEach(function (pair) {
        var _pair = _slicedToArray(pair, 2),
            format = _pair[0],
            input = _pair[1];

        if (input.tagName === 'SELECT') {
          var option = void 0;
          if (range == null) {
            option = null;
          } else if (formats[format] == null) {
            option = input.querySelector('option[selected]');
          } else if (!Array.isArray(formats[format])) {
            var value = formats[format];
            if (typeof value === 'string') {
              value = value.replace(/\"/g, '\\"');
            }
            option = input.querySelector('option[value="' + value + '"]');
          }
          if (option == null) {
            input.value = ''; // TODO make configurable?
            input.selectedIndex = -1;
          } else {
            option.selected = true;
          }
        } else {
          if (range == null) {
            input.classList.remove('ql-active');
          } else if (input.hasAttribute('value')) {
            // both being null should match (default values)
            // '1' should match with 1 (headers)
            var isActive = formats[format] === input.getAttribute('value') || formats[format] != null && formats[format].toString() === input.getAttribute('value') || formats[format] == null && !input.getAttribute('value');
            input.classList.toggle('ql-active', isActive);
          } else {
            input.classList.toggle('ql-active', formats[format] != null);
          }
        }
      });
    }
  }]);

  return Toolbar;
}(_module2.default);

Toolbar.DEFAULTS = {};

function addButton(container, format, value) {
  var input = document.createElement('button');
  input.setAttribute('type', 'button');
  input.classList.add('ql-' + format);
  if (value != null) {
    input.value = value;
  }
  container.appendChild(input);
}

function addControls(container, groups) {
  if (!Array.isArray(groups[0])) {
    groups = [groups];
  }
  groups.forEach(function (controls) {
    var group = document.createElement('span');
    group.classList.add('ql-formats');
    controls.forEach(function (control) {
      if (typeof control === 'string') {
        addButton(group, control);
      } else {
        var format = Object.keys(control)[0];
        var value = control[format];
        if (Array.isArray(value)) {
          addSelect(group, format, value);
        } else {
          addButton(group, format, value);
        }
      }
    });
    container.appendChild(group);
  });
}

function addSelect(container, format, values) {
  var input = document.createElement('select');
  input.classList.add('ql-' + format);
  values.forEach(function (value) {
    var option = document.createElement('option');
    if (value !== false) {
      option.setAttribute('value', value);
    } else {
      option.setAttribute('selected', 'selected');
    }
    input.appendChild(option);
  });
  container.appendChild(input);
}

Toolbar.DEFAULTS = {
  container: null,
  handlers: {
    clean: function clean() {
      var _this3 = this;

      var range = this.quill.getSelection();
      if (range == null) return;
      if (range.length == 0) {
        var formats = this.quill.getFormat();
        Object.keys(formats).forEach(function (name) {
          // Clean functionality in existing apps only clean inline formats
          if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) {
            _this3.quill.format(name, false);
          }
        });
      } else {
        this.quill.removeFormat(range, _quill2.default.sources.USER);
      }
    },
    direction: function direction(value) {
      var align = this.quill.getFormat()['align'];
      if (value === 'rtl' && align == null) {
        this.quill.format('align', 'right', _quill2.default.sources.USER);
      } else if (!value && align === 'right') {
        this.quill.format('align', false, _quill2.default.sources.USER);
      }
      this.quill.format('direction', value, _quill2.default.sources.USER);
    },
    indent: function indent(value) {
      var range = this.quill.getSelection();
      var formats = this.quill.getFormat(range);
      var indent = parseInt(formats.indent || 0);
      if (value === '+1' || value === '-1') {
        var modifier = value === '+1' ? 1 : -1;
        if (formats.direction === 'rtl') modifier *= -1;
        this.quill.format('indent', indent + modifier, _quill2.default.sources.USER);
      }
    },
    link: function link(value) {
      if (value === true) {
        value = prompt('Enter link URL:');
      }
      this.quill.format('link', value, _quill2.default.sources.USER);
    },
    list: function list(value) {
      var range = this.quill.getSelection();
      var formats = this.quill.getFormat(range);
      if (value === 'check') {
        if (formats['list'] === 'checked' || formats['list'] === 'unchecked') {
          this.quill.format('list', false, _quill2.default.sources.USER);
        } else {
          this.quill.format('list', 'unchecked', _quill2.default.sources.USER);
        }
      } else {
        this.quill.format('list', value, _quill2.default.sources.USER);
      }
    }
  }
};

exports.default = Toolbar;
exports.addControls = addControls;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"></polyline> <polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>";

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorPicker = function (_Picker) {
  _inherits(ColorPicker, _Picker);

  function ColorPicker(select, label) {
    _classCallCheck(this, ColorPicker);

    var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));

    _this.label.innerHTML = label;
    _this.container.classList.add('ql-color-picker');
    [].slice.call(_this.container.querySelectorAll('.ql-picker-item'), 0, 7).forEach(function (item) {
      item.classList.add('ql-primary');
    });
    return _this;
  }

  _createClass(ColorPicker, [{
    key: 'buildItem',
    value: function buildItem(option) {
      var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'buildItem', this).call(this, option);
      item.style.backgroundColor = option.getAttribute('value') || '';
      return item;
    }
  }, {
    key: 'selectItem',
    value: function selectItem(item, trigger) {
      _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'selectItem', this).call(this, item, trigger);
      var colorLabel = this.label.querySelector('.ql-color-label');
      var value = item ? item.getAttribute('data-value') || '' : '';
      if (colorLabel) {
        if (colorLabel.tagName === 'line') {
          colorLabel.style.stroke = value;
        } else {
          colorLabel.style.fill = value;
        }
      }
    }
  }]);

  return ColorPicker;
}(_picker2.default);

exports.default = ColorPicker;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconPicker = function (_Picker) {
  _inherits(IconPicker, _Picker);

  function IconPicker(select, icons) {
    _classCallCheck(this, IconPicker);

    var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));

    _this.container.classList.add('ql-icon-picker');
    [].forEach.call(_this.container.querySelectorAll('.ql-picker-item'), function (item) {
      item.innerHTML = icons[item.getAttribute('data-value') || ''];
    });
    _this.defaultItem = _this.container.querySelector('.ql-selected');
    _this.selectItem(_this.defaultItem);
    return _this;
  }

  _createClass(IconPicker, [{
    key: 'selectItem',
    value: function selectItem(item, trigger) {
      _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), 'selectItem', this).call(this, item, trigger);
      item = item || this.defaultItem;
      this.label.innerHTML = item.innerHTML;
    }
  }]);

  return IconPicker;
}(_picker2.default);

exports.default = IconPicker;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Tooltip = function () {
  function Tooltip(quill, boundsContainer) {
    var _this = this;

    _classCallCheck(this, Tooltip);

    this.quill = quill;
    this.boundsContainer = boundsContainer || document.body;
    this.root = quill.addContainer('ql-tooltip');
    this.root.innerHTML = this.constructor.TEMPLATE;
    if (this.quill.root === this.quill.scrollingContainer) {
      this.quill.root.addEventListener('scroll', function () {
        _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + 'px';
      });
    }
    this.hide();
  }

  _createClass(Tooltip, [{
    key: 'hide',
    value: function hide() {
      this.root.classList.add('ql-hidden');
    }
  }, {
    key: 'position',
    value: function position(reference) {
      var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
      // root.scrollTop should be 0 if scrollContainer !== root
      var top = reference.bottom + this.quill.root.scrollTop;
      this.root.style.left = left + 'px';
      this.root.style.top = top + 'px';
      this.root.classList.remove('ql-flip');
      var containerBounds = this.boundsContainer.getBoundingClientRect();
      var rootBounds = this.root.getBoundingClientRect();
      var shift = 0;
      if (rootBounds.right > containerBounds.right) {
        shift = containerBounds.right - rootBounds.right;
        this.root.style.left = left + shift + 'px';
      }
      if (rootBounds.left < containerBounds.left) {
        shift = containerBounds.left - rootBounds.left;
        this.root.style.left = left + shift + 'px';
      }
      if (rootBounds.bottom > containerBounds.bottom) {
        var height = rootBounds.bottom - rootBounds.top;
        var verticalShift = reference.bottom - reference.top + height;
        this.root.style.top = top - verticalShift + 'px';
        this.root.classList.add('ql-flip');
      }
      return shift;
    }
  }, {
    key: 'show',
    value: function show() {
      this.root.classList.remove('ql-editing');
      this.root.classList.remove('ql-hidden');
    }
  }]);

  return Tooltip;
}();

exports.default = Tooltip;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _base = __webpack_require__(43);

var _base2 = _interopRequireDefault(_base);

var _link = __webpack_require__(27);

var _link2 = _interopRequireDefault(_link);

var _selection = __webpack_require__(15);

var _icons = __webpack_require__(41);

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TOOLBAR_CONFIG = [[{ header: ['1', '2', '3', false] }], ['bold', 'italic', 'underline', 'link'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']];

var SnowTheme = function (_BaseTheme) {
  _inherits(SnowTheme, _BaseTheme);

  function SnowTheme(quill, options) {
    _classCallCheck(this, SnowTheme);

    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
      options.modules.toolbar.container = TOOLBAR_CONFIG;
    }

    var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));

    _this.quill.container.classList.add('ql-snow');
    return _this;
  }

  _createClass(SnowTheme, [{
    key: 'extendToolbar',
    value: function extendToolbar(toolbar) {
      toolbar.container.classList.add('ql-snow');
      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
      this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
      if (toolbar.container.querySelector('.ql-link')) {
        this.quill.keyboard.addBinding({ key: 'K', shortKey: true }, function (range, context) {
          toolbar.handlers['link'].call(toolbar, !context.format.link);
        });
      }
    }
  }]);

  return SnowTheme;
}(_base2.default);

SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link: function link(value) {
          if (value) {
            var range = this.quill.getSelection();
            if (range == null || range.length == 0) return;
            var preview = this.quill.getText(range);
            if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
              preview = 'mailto:' + preview;
            }
            var tooltip = this.quill.theme.tooltip;
            tooltip.edit('link', preview);
          } else {
            this.quill.format('link', false);
          }
        }
      }
    }
  }
});

var SnowTooltip = function (_BaseTooltip) {
  _inherits(SnowTooltip, _BaseTooltip);

  function SnowTooltip(quill, bounds) {
    _classCallCheck(this, SnowTooltip);

    var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));

    _this2.preview = _this2.root.querySelector('a.ql-preview');
    return _this2;
  }

  _createClass(SnowTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this3 = this;

      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'listen', this).call(this);
      this.root.querySelector('a.ql-action').addEventListener('click', function (event) {
        if (_this3.root.classList.contains('ql-editing')) {
          _this3.save();
        } else {
          _this3.edit('link', _this3.preview.textContent);
        }
        event.preventDefault();
      });
      this.root.querySelector('a.ql-remove').addEventListener('click', function (event) {
        if (_this3.linkRange != null) {
          var range = _this3.linkRange;
          _this3.restoreFocus();
          _this3.quill.formatText(range, 'link', false, _emitter2.default.sources.USER);
          delete _this3.linkRange;
        }
        event.preventDefault();
        _this3.hide();
      });
      this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function (range, oldRange, source) {
        if (range == null) return;
        if (range.length === 0 && source === _emitter2.default.sources.USER) {
          var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index),
              _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
              link = _quill$scroll$descend2[0],
              offset = _quill$scroll$descend2[1];

          if (link != null) {
            _this3.linkRange = new _selection.Range(range.index - offset, link.length());
            var preview = _link2.default.formats(link.domNode);
            _this3.preview.textContent = preview;
            _this3.preview.setAttribute('href', preview);
            _this3.show();
            _this3.position(_this3.quill.getBounds(_this3.linkRange));
            return;
          }
        } else {
          delete _this3.linkRange;
        }
        _this3.hide();
      });
    }
  }, {
    key: 'show',
    value: function show() {
      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'show', this).call(this);
      this.root.removeAttribute('data-mode');
    }
  }]);

  return SnowTooltip;
}(_base.BaseTooltip);

SnowTooltip.TEMPLATE = ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join('');

exports.default = SnowTheme;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _core = __webpack_require__(29);

var _core2 = _interopRequireDefault(_core);

var _align = __webpack_require__(36);

var _direction = __webpack_require__(38);

var _indent = __webpack_require__(64);

var _blockquote = __webpack_require__(65);

var _blockquote2 = _interopRequireDefault(_blockquote);

var _header = __webpack_require__(66);

var _header2 = _interopRequireDefault(_header);

var _list = __webpack_require__(67);

var _list2 = _interopRequireDefault(_list);

var _background = __webpack_require__(37);

var _color = __webpack_require__(26);

var _font = __webpack_require__(39);

var _size = __webpack_require__(40);

var _bold = __webpack_require__(56);

var _bold2 = _interopRequireDefault(_bold);

var _italic = __webpack_require__(68);

var _italic2 = _interopRequireDefault(_italic);

var _link = __webpack_require__(27);

var _link2 = _interopRequireDefault(_link);

var _script = __webpack_require__(69);

var _script2 = _interopRequireDefault(_script);

var _strike = __webpack_require__(70);

var _strike2 = _interopRequireDefault(_strike);

var _underline = __webpack_require__(71);

var _underline2 = _interopRequireDefault(_underline);

var _image = __webpack_require__(72);

var _image2 = _interopRequireDefault(_image);

var _video = __webpack_require__(73);

var _video2 = _interopRequireDefault(_video);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _formula = __webpack_require__(74);

var _formula2 = _interopRequireDefault(_formula);

var _syntax = __webpack_require__(75);

var _syntax2 = _interopRequireDefault(_syntax);

var _toolbar = __webpack_require__(57);

var _toolbar2 = _interopRequireDefault(_toolbar);

var _icons = __webpack_require__(41);

var _icons2 = _interopRequireDefault(_icons);

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

var _colorPicker = __webpack_require__(59);

var _colorPicker2 = _interopRequireDefault(_colorPicker);

var _iconPicker = __webpack_require__(60);

var _iconPicker2 = _interopRequireDefault(_iconPicker);

var _tooltip = __webpack_require__(61);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _bubble = __webpack_require__(108);

var _bubble2 = _interopRequireDefault(_bubble);

var _snow = __webpack_require__(62);

var _snow2 = _interopRequireDefault(_snow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_core2.default.register({
  'attributors/attribute/direction': _direction.DirectionAttribute,

  'attributors/class/align': _align.AlignClass,
  'attributors/class/background': _background.BackgroundClass,
  'attributors/class/color': _color.ColorClass,
  'attributors/class/direction': _direction.DirectionClass,
  'attributors/class/font': _font.FontClass,
  'attributors/class/size': _size.SizeClass,

  'attributors/style/align': _align.AlignStyle,
  'attributors/style/background': _background.BackgroundStyle,
  'attributors/style/color': _color.ColorStyle,
  'attributors/style/direction': _direction.DirectionStyle,
  'attributors/style/font': _font.FontStyle,
  'attributors/style/size': _size.SizeStyle
}, true);

_core2.default.register({
  'formats/align': _align.AlignClass,
  'formats/direction': _direction.DirectionClass,
  'formats/indent': _indent.IndentClass,

  'formats/background': _background.BackgroundStyle,
  'formats/color': _color.ColorStyle,
  'formats/font': _font.FontClass,
  'formats/size': _size.SizeClass,

  'formats/blockquote': _blockquote2.default,
  'formats/code-block': _code2.default,
  'formats/header': _header2.default,
  'formats/list': _list2.default,

  'formats/bold': _bold2.default,
  'formats/code': _code.Code,
  'formats/italic': _italic2.default,
  'formats/link': _link2.default,
  'formats/script': _script2.default,
  'formats/strike': _strike2.default,
  'formats/underline': _underline2.default,

  'formats/image': _image2.default,
  'formats/video': _video2.default,

  'formats/list/item': _list.ListItem,

  'modules/formula': _formula2.default,
  'modules/syntax': _syntax2.default,
  'modules/toolbar': _toolbar2.default,

  'themes/bubble': _bubble2.default,
  'themes/snow': _snow2.default,

  'ui/icons': _icons2.default,
  'ui/picker': _picker2.default,
  'ui/icon-picker': _iconPicker2.default,
  'ui/color-picker': _colorPicker2.default,
  'ui/tooltip': _tooltip2.default
}, true);

exports.default = _core2.default;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndentClass = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IdentAttributor = function (_Parchment$Attributor) {
  _inherits(IdentAttributor, _Parchment$Attributor);

  function IdentAttributor() {
    _classCallCheck(this, IdentAttributor);

    return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
  }

  _createClass(IdentAttributor, [{
    key: 'add',
    value: function add(node, value) {
      if (value === '+1' || value === '-1') {
        var indent = this.value(node) || 0;
        value = value === '+1' ? indent + 1 : indent - 1;
      }
      if (value === 0) {
        this.remove(node);
        return true;
      } else {
        return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'add', this).call(this, node, value);
      }
    }
  }, {
    key: 'canAdd',
    value: function canAdd(node, value) {
      return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, value) || _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, parseInt(value));
    }
  }, {
    key: 'value',
    value: function value(node) {
      return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'value', this).call(this, node)) || undefined; // Don't return NaN
    }
  }]);

  return IdentAttributor;
}(_parchment2.default.Attributor.Class);

var IndentClass = new IdentAttributor('indent', 'ql-indent', {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
});

exports.IndentClass = IndentClass;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Blockquote = function (_Block) {
  _inherits(Blockquote, _Block);

  function Blockquote() {
    _classCallCheck(this, Blockquote);

    return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
  }

  return Blockquote;
}(_block2.default);

Blockquote.blotName = 'blockquote';
Blockquote.tagName = 'blockquote';

exports.default = Blockquote;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_Block) {
  _inherits(Header, _Block);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, null, [{
    key: 'formats',
    value: function formats(domNode) {
      return this.tagName.indexOf(domNode.tagName) + 1;
    }
  }]);

  return Header;
}(_block2.default);

Header.blotName = 'header';
Header.tagName = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

exports.default = Header;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListItem = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _container = __webpack_require__(25);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItem = function (_Block) {
  _inherits(ListItem, _Block);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
  }

  _createClass(ListItem, [{
    key: 'format',
    value: function format(name, value) {
      if (name === List.blotName && !value) {
        this.replaceWith(_parchment2.default.create(this.statics.scope));
      } else {
        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'format', this).call(this, name, value);
      }
    }
  }, {
    key: 'remove',
    value: function remove() {
      if (this.prev == null && this.next == null) {
        this.parent.remove();
      } else {
        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'remove', this).call(this);
      }
    }
  }, {
    key: 'replaceWith',
    value: function replaceWith(name, value) {
      this.parent.isolate(this.offset(this.parent), this.length());
      if (name === this.parent.statics.blotName) {
        this.parent.replaceWith(name, value);
        return this;
      } else {
        this.parent.unwrap();
        return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'replaceWith', this).call(this, name, value);
      }
    }
  }], [{
    key: 'formats',
    value: function formats(domNode) {
      return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), 'formats', this).call(this, domNode);
    }
  }]);

  return ListItem;
}(_block2.default);

ListItem.blotName = 'list-item';
ListItem.tagName = 'LI';

var List = function (_Container) {
  _inherits(List, _Container);

  _createClass(List, null, [{
    key: 'create',
    value: function create(value) {
      var tagName = value === 'ordered' ? 'OL' : 'UL';
      var node = _get(List.__proto__ || Object.getPrototypeOf(List), 'create', this).call(this, tagName);
      if (value === 'checked' || value === 'unchecked') {
        node.setAttribute('data-checked', value === 'checked');
      }
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      if (domNode.tagName === 'OL') return 'ordered';
      if (domNode.tagName === 'UL') {
        if (domNode.hasAttribute('data-checked')) {
          return domNode.getAttribute('data-checked') === 'true' ? 'checked' : 'unchecked';
        } else {
          return 'bullet';
        }
      }
      return undefined;
    }
  }]);

  function List(domNode) {
    _classCallCheck(this, List);

    var _this2 = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, domNode));

    var listEventHandler = function listEventHandler(e) {
      if (e.target.parentNode !== domNode) return;
      var format = _this2.statics.formats(domNode);
      var blot = _parchment2.default.find(e.target);
      if (format === 'checked') {
        blot.format('list', 'unchecked');
      } else if (format === 'unchecked') {
        blot.format('list', 'checked');
      }
    };

    domNode.addEventListener('touchstart', listEventHandler);
    domNode.addEventListener('mousedown', listEventHandler);
    return _this2;
  }

  _createClass(List, [{
    key: 'format',
    value: function format(name, value) {
      if (this.children.length > 0) {
        this.children.tail.format(name, value);
      }
    }
  }, {
    key: 'formats',
    value: function formats() {
      // We don't inherit from FormatBlot
      return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      if (blot instanceof ListItem) {
        _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'insertBefore', this).call(this, blot, ref);
      } else {
        var index = ref == null ? this.length() : ref.offset(this);
        var after = this.split(index);
        after.parent.insertBefore(blot, after);
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'optimize', this).call(this, context);
      var next = this.next;
      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('data-checked') === this.domNode.getAttribute('data-checked')) {
        next.moveChildren(this);
        next.remove();
      }
    }
  }, {
    key: 'replace',
    value: function replace(target) {
      if (target.statics.blotName !== this.statics.blotName) {
        var item = _parchment2.default.create(this.statics.defaultChild);
        target.moveChildren(item);
        this.appendChild(item);
      }
      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'replace', this).call(this, target);
    }
  }]);

  return List;
}(_container2.default);

List.blotName = 'list';
List.scope = _parchment2.default.Scope.BLOCK_BLOT;
List.tagName = ['OL', 'UL'];
List.defaultChild = 'list-item';
List.allowedChildren = [ListItem];

exports.ListItem = ListItem;
exports.default = List;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bold = __webpack_require__(56);

var _bold2 = _interopRequireDefault(_bold);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Italic = function (_Bold) {
  _inherits(Italic, _Bold);

  function Italic() {
    _classCallCheck(this, Italic);

    return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
  }

  return Italic;
}(_bold2.default);

Italic.blotName = 'italic';
Italic.tagName = ['EM', 'I'];

exports.default = Italic;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Script = function (_Inline) {
  _inherits(Script, _Inline);

  function Script() {
    _classCallCheck(this, Script);

    return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
  }

  _createClass(Script, null, [{
    key: 'create',
    value: function create(value) {
      if (value === 'super') {
        return document.createElement('sup');
      } else if (value === 'sub') {
        return document.createElement('sub');
      } else {
        return _get(Script.__proto__ || Object.getPrototypeOf(Script), 'create', this).call(this, value);
      }
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      if (domNode.tagName === 'SUB') return 'sub';
      if (domNode.tagName === 'SUP') return 'super';
      return undefined;
    }
  }]);

  return Script;
}(_inline2.default);

Script.blotName = 'script';
Script.tagName = ['SUB', 'SUP'];

exports.default = Script;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Strike = function (_Inline) {
  _inherits(Strike, _Inline);

  function Strike() {
    _classCallCheck(this, Strike);

    return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
  }

  return Strike;
}(_inline2.default);

Strike.blotName = 'strike';
Strike.tagName = 'S';

exports.default = Strike;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Underline = function (_Inline) {
  _inherits(Underline, _Inline);

  function Underline() {
    _classCallCheck(this, Underline);

    return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
  }

  return Underline;
}(_inline2.default);

Underline.blotName = 'underline';
Underline.tagName = 'U';

exports.default = Underline;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _link = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ATTRIBUTES = ['alt', 'height', 'width'];

var Image = function (_Parchment$Embed) {
  _inherits(Image, _Parchment$Embed);

  function Image() {
    _classCallCheck(this, Image);

    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
  }

  _createClass(Image, [{
    key: 'format',
    value: function format(name, value) {
      if (ATTRIBUTES.indexOf(name) > -1) {
        if (value) {
          this.domNode.setAttribute(name, value);
        } else {
          this.domNode.removeAttribute(name);
        }
      } else {
        _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), 'format', this).call(this, name, value);
      }
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), 'create', this).call(this, value);
      if (typeof value === 'string') {
        node.setAttribute('src', this.sanitize(value));
      }
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return ATTRIBUTES.reduce(function (formats, attribute) {
        if (domNode.hasAttribute(attribute)) {
          formats[attribute] = domNode.getAttribute(attribute);
        }
        return formats;
      }, {});
    }
  }, {
    key: 'match',
    value: function match(url) {
      return (/\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url)
      );
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return (0, _link.sanitize)(url, ['http', 'https', 'data']) ? url : '//:0';
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('src');
    }
  }]);

  return Image;
}(_parchment2.default.Embed);

Image.blotName = 'image';
Image.tagName = 'IMG';

exports.default = Image;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _block = __webpack_require__(4);

var _link = __webpack_require__(27);

var _link2 = _interopRequireDefault(_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ATTRIBUTES = ['height', 'width'];

var Video = function (_BlockEmbed) {
  _inherits(Video, _BlockEmbed);

  function Video() {
    _classCallCheck(this, Video);

    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
  }

  _createClass(Video, [{
    key: 'format',
    value: function format(name, value) {
      if (ATTRIBUTES.indexOf(name) > -1) {
        if (value) {
          this.domNode.setAttribute(name, value);
        } else {
          this.domNode.removeAttribute(name);
        }
      } else {
        _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), 'format', this).call(this, name, value);
      }
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), 'create', this).call(this, value);
      node.setAttribute('frameborder', '0');
      node.setAttribute('allowfullscreen', true);
      node.setAttribute('src', this.sanitize(value));
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return ATTRIBUTES.reduce(function (formats, attribute) {
        if (domNode.hasAttribute(attribute)) {
          formats[attribute] = domNode.getAttribute(attribute);
        }
        return formats;
      }, {});
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return _link2.default.sanitize(url);
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('src');
    }
  }]);

  return Video;
}(_block.BlockEmbed);

Video.blotName = 'video';
Video.className = 'ql-video';
Video.tagName = 'IFRAME';

exports.default = Video;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FormulaBlot = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _embed = __webpack_require__(35);

var _embed2 = _interopRequireDefault(_embed);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormulaBlot = function (_Embed) {
  _inherits(FormulaBlot, _Embed);

  function FormulaBlot() {
    _classCallCheck(this, FormulaBlot);

    return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
  }

  _createClass(FormulaBlot, null, [{
    key: 'create',
    value: function create(value) {
      var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), 'create', this).call(this, value);
      if (typeof value === 'string') {
        window.katex.render(value, node, {
          throwOnError: false,
          errorColor: '#f00'
        });
        node.setAttribute('data-value', value);
      }
      return node;
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('data-value');
    }
  }]);

  return FormulaBlot;
}(_embed2.default);

FormulaBlot.blotName = 'formula';
FormulaBlot.className = 'ql-formula';
FormulaBlot.tagName = 'SPAN';

var Formula = function (_Module) {
  _inherits(Formula, _Module);

  _createClass(Formula, null, [{
    key: 'register',
    value: function register() {
      _quill2.default.register(FormulaBlot, true);
    }
  }]);

  function Formula() {
    _classCallCheck(this, Formula);

    var _this2 = _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).call(this));

    if (window.katex == null) {
      throw new Error('Formula module requires KaTeX.');
    }
    return _this2;
  }

  return Formula;
}(_module2.default);

exports.FormulaBlot = FormulaBlot;
exports.default = Formula;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CodeToken = exports.CodeBlock = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SyntaxCodeBlock = function (_CodeBlock) {
  _inherits(SyntaxCodeBlock, _CodeBlock);

  function SyntaxCodeBlock() {
    _classCallCheck(this, SyntaxCodeBlock);

    return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
  }

  _createClass(SyntaxCodeBlock, [{
    key: 'replaceWith',
    value: function replaceWith(block) {
      this.domNode.textContent = this.domNode.textContent;
      this.attach();
      _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), 'replaceWith', this).call(this, block);
    }
  }, {
    key: 'highlight',
    value: function highlight(_highlight) {
      var text = this.domNode.textContent;
      if (this.cachedText !== text) {
        if (text.trim().length > 0 || this.cachedText == null) {
          this.domNode.innerHTML = _highlight(text);
          this.domNode.normalize();
          this.attach();
        }
        this.cachedText = text;
      }
    }
  }]);

  return SyntaxCodeBlock;
}(_code2.default);

SyntaxCodeBlock.className = 'ql-syntax';

var CodeToken = new _parchment2.default.Attributor.Class('token', 'hljs', {
  scope: _parchment2.default.Scope.INLINE
});

var Syntax = function (_Module) {
  _inherits(Syntax, _Module);

  _createClass(Syntax, null, [{
    key: 'register',
    value: function register() {
      _quill2.default.register(CodeToken, true);
      _quill2.default.register(SyntaxCodeBlock, true);
    }
  }]);

  function Syntax(quill, options) {
    _classCallCheck(this, Syntax);

    var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));

    if (typeof _this2.options.highlight !== 'function') {
      throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
    }
    var timer = null;
    _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        _this2.highlight();
        timer = null;
      }, _this2.options.interval);
    });
    _this2.highlight();
    return _this2;
  }

  _createClass(Syntax, [{
    key: 'highlight',
    value: function highlight() {
      var _this3 = this;

      if (this.quill.selection.composing) return;
      this.quill.update(_quill2.default.sources.USER);
      var range = this.quill.getSelection();
      this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function (code) {
        code.highlight(_this3.options.highlight);
      });
      this.quill.update(_quill2.default.sources.SILENT);
      if (range != null) {
        this.quill.setSelection(range, _quill2.default.sources.SILENT);
      }
    }
  }]);

  return Syntax;
}(_module2.default);

Syntax.DEFAULTS = {
  highlight: function () {
    if (window.hljs == null) return null;
    return function (text) {
      var result = window.hljs.highlightAuto(text);
      return result.value;
    };
  }(),
  interval: 1000
};

exports.CodeBlock = SyntaxCodeBlock;
exports.CodeToken = CodeToken;
exports.default = Syntax;

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>";

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>";

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>";

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>";

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <g class=\"ql-fill ql-color-label\"> <polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\"5.5 13 9 5 12.5 13\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>";

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=4 y=5></rect> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=11 y=5></rect> <path class=\"ql-even ql-fill ql-stroke\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\"ql-even ql-fill ql-stroke\" d=M14,8c0,4.031-3,5-3,5></path> </svg>";

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>";

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>";

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-color-label ql-stroke ql-transparent\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\"5.5 11 9 3 12.5 11\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>";

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"></polygon> <line class=\"ql-stroke ql-fill\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>";

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"></polygon> <line class=\"ql-stroke ql-fill\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>";

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform=\"translate(24 18) rotate(-180)\"/> </svg>";

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>";

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>";

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>";

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>";

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"></polyline> </svg>";

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"></polyline> </svg>";

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"5 7 5 11 3 9 5 7\"></polyline> </svg>";

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\"ql-even ql-stroke\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\"ql-even ql-stroke\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>";

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\"ql-stroke ql-thin\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\"ql-stroke ql-thin\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\"ql-stroke ql-thin\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>";

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>";

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points=\"3 4 4 5 6 3\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points=\"3 14 4 15 6 13\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"3 9 4 10 6 8\"></polyline> </svg>";

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>";

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>";

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-stroke ql-thin\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>";

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>";

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>";

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BubbleTooltip = undefined;

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _base = __webpack_require__(43);

var _base2 = _interopRequireDefault(_base);

var _selection = __webpack_require__(15);

var _icons = __webpack_require__(41);

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TOOLBAR_CONFIG = [['bold', 'italic', 'link'], [{ header: 1 }, { header: 2 }, 'blockquote']];

var BubbleTheme = function (_BaseTheme) {
  _inherits(BubbleTheme, _BaseTheme);

  function BubbleTheme(quill, options) {
    _classCallCheck(this, BubbleTheme);

    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
      options.modules.toolbar.container = TOOLBAR_CONFIG;
    }

    var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));

    _this.quill.container.classList.add('ql-bubble');
    return _this;
  }

  _createClass(BubbleTheme, [{
    key: 'extendToolbar',
    value: function extendToolbar(toolbar) {
      this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
      this.tooltip.root.appendChild(toolbar.container);
      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
    }
  }]);

  return BubbleTheme;
}(_base2.default);

BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link: function link(value) {
          if (!value) {
            this.quill.format('link', false);
          } else {
            this.quill.theme.tooltip.edit();
          }
        }
      }
    }
  }
});

var BubbleTooltip = function (_BaseTooltip) {
  _inherits(BubbleTooltip, _BaseTooltip);

  function BubbleTooltip(quill, bounds) {
    _classCallCheck(this, BubbleTooltip);

    var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));

    _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function (type, range, oldRange, source) {
      if (type !== _emitter2.default.events.SELECTION_CHANGE) return;
      if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
        _this2.show();
        // Lock our width so we will expand beyond our offsetParent boundaries
        _this2.root.style.left = '0px';
        _this2.root.style.width = '';
        _this2.root.style.width = _this2.root.offsetWidth + 'px';
        var lines = _this2.quill.getLines(range.index, range.length);
        if (lines.length === 1) {
          _this2.position(_this2.quill.getBounds(range));
        } else {
          var lastLine = lines[lines.length - 1];
          var index = _this2.quill.getIndex(lastLine);
          var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
          var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
          _this2.position(_bounds);
        }
      } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) {
        _this2.hide();
      }
    });
    return _this2;
  }

  _createClass(BubbleTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this3 = this;

      _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'listen', this).call(this);
      this.root.querySelector('.ql-close').addEventListener('click', function () {
        _this3.root.classList.remove('ql-editing');
      });
      this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function () {
        // Let selection be restored by toolbar handlers before repositioning
        setTimeout(function () {
          if (_this3.root.classList.contains('ql-hidden')) return;
          var range = _this3.quill.getSelection();
          if (range != null) {
            _this3.position(_this3.quill.getBounds(range));
          }
        }, 1);
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.show();
    }
  }, {
    key: 'position',
    value: function position(reference) {
      var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'position', this).call(this, reference);
      var arrow = this.root.querySelector('.ql-tooltip-arrow');
      arrow.style.marginLeft = '';
      if (shift === 0) return shift;
      arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + 'px';
    }
  }]);

  return BubbleTooltip;
}(_base.BaseTooltip);

BubbleTooltip.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', '</div>'].join('');

exports.BubbleTooltip = BubbleTooltip;
exports.default = BubbleTheme;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(63);


/***/ })
/******/ ])["default"];
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1359).Buffer))

/***/ }),

/***/ 1630:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1631);
module.exports = 0x1fffffffffffff;


/***/ }),

/***/ 1631:
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(28);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),

/***/ 1632:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ContextMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_vue__ = __webpack_require__(1633);



var MainConstructor = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.extend(__WEBPACK_IMPORTED_MODULE_1__main_vue__["a" /* default */]);

var instance = void 0;

var initInstance = function initInstance() {
  instance = new MainConstructor({
    el: document.createElement('div')
  });
  document.body.appendChild(instance.$el);
};

/**
 *
 * @param options
 * @param newInstance 在不同的页面可能有不同形式的右键菜单，这些菜单没有任何关联，因此挂载时需要先清除它们
 * @returns {*}
 * @constructor
 */
var ContextMenu = function ContextMenu() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var newInstance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (newInstance || !instance) {
    initInstance();
  }
  for (var key in options) {
    if (instance.hasOwnProperty(key)) {
      instance[key] = options[key];
    }
  }
  return instance;
};

ContextMenu.destroy = function () {
  if (instance) {
    instance.$el.remove();
    instance.$destroy();
    instance = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ContextMenu);


/***/ }),

/***/ 1633:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(1543);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af72ffc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(1655);
function injectStyle (ssrContext) {
  __webpack_require__(1634)
  this["$style"] = __webpack_require__(1636)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6af72ffc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af72ffc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1634:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1635);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("519046ed", content, true, {});

/***/ }),

/***/ 1635:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".context-menu[data-v-6af72ffc]{background-color:hsla(0,0%,100%,.95);-webkit-box-shadow:0 1px 3px rgba(0,0,0,.3);box-shadow:0 1px 3px rgba(0,0,0,.3);-webkit-box-sizing:border-box;box-sizing:border-box;position:absolute;border-radius:3px;margin-top:0;margin-bottom:0;padding:0;list-style-type:none}.context-menu li[data-v-6af72ffc]{border-bottom:1px solid #f2f6fc}.context-menu li[data-v-6af72ffc]:first-child{border-radius:3px 3px 0 0}.context-menu li[data-v-6af72ffc]:last-child{border-radius:0 0 3px 3px;border-bottom-width:0}.context-menu li[data-v-6af72ffc]:hover{background-color:rgba(235,238,245,.95)}.context-menu button[data-v-6af72ffc]{padding:5px 10px;width:100%;text-align:left}.context-menu small[data-v-6af72ffc]{color:#c0c4cc;font-weight:400}", "", {"version":3,"sources":["/workspace/src/views/question-review/components/ContextMenu/src/main.vue"],"names":[],"mappings":"AACA,+BAA+B,qCAAwC,4CAA6C,oCAAqC,8BAA8B,sBAAsB,kBAAkB,kBAAkB,aAAe,gBAAkB,UAAY,oBAAoB,CACjT,AACD,kCAAkC,+BAA+B,CAChE,AACD,8CAA8C,yBAA6B,CAC1E,AACD,6CAA6C,0BAA8B,qBAAuB,CACjG,AACD,wCAAwC,sCAAuC,CAC9E,AACD,sCAAsC,iBAAiB,WAAW,eAAe,CAChF,AACD,qCAAqC,cAAc,eAAkB,CACpE","file":"main.vue","sourcesContent":["\n.context-menu[data-v-6af72ffc]{background-color:rgba(255,255,255,0.95);-webkit-box-shadow:0 1px 3px rgba(0,0,0,0.3);box-shadow:0 1px 3px rgba(0,0,0,0.3);-webkit-box-sizing:border-box;box-sizing:border-box;position:absolute;border-radius:3px;margin-top:0px;margin-bottom:0px;padding:0px;list-style-type:none\n}\n.context-menu li[data-v-6af72ffc]{border-bottom:1px solid #f2f6fc\n}\n.context-menu li[data-v-6af72ffc]:first-child{border-radius:3px 3px 0px 0px\n}\n.context-menu li[data-v-6af72ffc]:last-child{border-radius:0px 0px 3px 3px;border-bottom-width:0px\n}\n.context-menu li[data-v-6af72ffc]:hover{background-color:rgba(235,238,245,0.95)\n}\n.context-menu button[data-v-6af72ffc]{padding:5px 10px;width:100%;text-align:left\n}\n.context-menu small[data-v-6af72ffc]{color:#c0c4cc;font-weight:normal\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1636:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1637);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("1296a5fe", content, true, {});

/***/ }),

/***/ 1637:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1638:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CropperImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_vue__ = __webpack_require__(1639);



var MainConstructor = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.extend(__WEBPACK_IMPORTED_MODULE_1__main_vue__["a" /* default */]);

var instance = void 0;

var initInstance = function initInstance() {
  instance = new MainConstructor({
    el: document.createElement('div')
  });
  document.body.appendChild(instance.$el);
};

var CropperImage = function CropperImage() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!instance) {
    initInstance();
  }
  for (var key in options) {
    if (instance.hasOwnProperty(key)) {
      instance[key] = options[key];
    }
  }
  instance.visible = true;
};

CropperImage.destroy = function () {
  if (instance) {
    instance.$el.remove();
    instance.$destroy();
    instance = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (CropperImage);


/***/ }),

/***/ 1639:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(1544);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c12aa73e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(1654);
function injectStyle (ssrContext) {
  __webpack_require__(1640)
  __webpack_require__(1642)
  this["$style"] = __webpack_require__(1644)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c12aa73e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c12aa73e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1640:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1641);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2760c540", content, true, {});

/***/ }),

/***/ 1641:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".cropper-dialog .el-dialog__body{padding-top:0;padding-bottom:15px;height:calc(100% - 139px);overflow:auto}", "", {"version":3,"sources":["/workspace/src/views/question-review/components/CropperImage/src/main.vue"],"names":[],"mappings":"AACA,iCAAiC,cAAc,oBAAoB,0BAA0B,aAAa,CACzG","file":"main.vue","sourcesContent":["\n.cropper-dialog .el-dialog__body{padding-top:0;padding-bottom:15px;height:calc(100% - 139px);overflow:auto\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1642:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1643);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("4df218f6", content, true, {});

/***/ }),

/***/ 1643:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1644:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1645);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("afb38314", content, true, {});

/***/ }),

/***/ 1645:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1646:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1647);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("94d6b262", content, true, {});

/***/ }),

/***/ 1647:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".cropper-button[data-v-0ab1921c]{width:100%;text-align:center;background-color:rgba(0,0,0,.7);position:absolute;bottom:0;left:0}.cropper-button span[data-v-0ab1921c]{font-size:20px;color:#fff;padding:10px;cursor:pointer}.cropper-button span[data-v-0ab1921c]:hover{color:#409eff}", "", {"version":3,"sources":["/workspace/src/views/question-review/components/CropperImage/src/CropperImage.vue"],"names":[],"mappings":"AACA,iCAAiC,WAAW,kBAAkB,gCAAiC,kBAAkB,SAAW,MAAQ,CACnI,AACD,sCAAsC,eAAe,WAAY,aAAa,cAAc,CAC3F,AACD,4CAA4C,aAAa,CACxD","file":"CropperImage.vue","sourcesContent":["\n.cropper-button[data-v-0ab1921c]{width:100%;text-align:center;background-color:rgba(0,0,0,0.7);position:absolute;bottom:0px;left:0px\n}\n.cropper-button span[data-v-0ab1921c]{font-size:20px;color:white;padding:10px;cursor:pointer\n}\n.cropper-button span[data-v-0ab1921c]:hover{color:#409eff\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1648:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(76);

/***/ }),

/***/ 1649:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(75);

/***/ }),

/***/ 1650:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"position":"relative","width":"100%","height":"100%"}},[_c('img',{ref:"image",staticStyle:{"max-width":"100%","max-height":"100%"},attrs:{"src":_vm.url,"alt":_vm.url}}),_vm._v(" "),_c('div',{staticClass:"cropper-button"},[_c('span',{staticClass:"el-icon-rank",on:{"click":function($event){return _vm.move()}}}),_vm._v(" "),_c('span',{staticClass:"sj-icon-crop",on:{"click":function($event){return _vm.crop()}}}),_vm._v(" "),_c('span',{staticClass:"sj-icon-rotate-left",on:{"click":function($event){return _vm.cropper.rotate(90)}}}),_vm._v(" "),_c('span',{staticClass:"sj-icon-rotate-right",on:{"click":function($event){return _vm.cropper.rotate(-90)}}}),_vm._v(" "),_c('span',{staticClass:"el-icon-refresh",on:{"click":function($event){return _vm.cropper.reset()}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1651:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_piexifjs__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_piexifjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_piexifjs__);




function attr(items, key, value) {
  if (valid(value)) {
    items[key] = value;
  } else {
    return items[key];
  }
}

function valid(value) {
  return !(value === undefined || value === null || value === '');
}

var PiexifHelper = function () {
  function PiexifHelper(exif) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PiexifHelper);

    this.exif = exif || {
      '0th': {},
      'Exif': {},
      'GPS': {},
      'Interop': {},
      '1st': {},
      'thumbnail': null
    };
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PiexifHelper, [{
    key: 'DateTime',
    value: function DateTime(value) {
      var items = this.exif['0th'];
      var key = __WEBPACK_IMPORTED_MODULE_2_piexifjs___default.a.ImageIFD.DateTime;
      return attr(items, key, value);
    }
  }, {
    key: 'DateTimeOriginal',
    value: function DateTimeOriginal(value) {
      var items = this.exif.Exif;
      var key = __WEBPACK_IMPORTED_MODULE_2_piexifjs___default.a.ExifIFD.DateTimeOriginal;
      return attr(items, key, value);
    }
  }, {
    key: 'GPSLatitudeRef',
    value: function GPSLatitudeRef(value) {
      var items = this.exif.GPS;
      var key = __WEBPACK_IMPORTED_MODULE_2_piexifjs___default.a.GPSIFD.GPSLatitudeRef;
      return attr(items, key, value);
    }
  }, {
    key: 'GPSLatitude',
    value: function GPSLatitude(value) {
      var items = this.exif.GPS;
      var key = __WEBPACK_IMPORTED_MODULE_2_piexifjs___default.a.GPSIFD.GPSLatitude;
      if (valid(value)) {
        this.GPSLatitudeRef(value < 0 ? 'S' : 'N');
        items[key] = __WEBPACK_IMPORTED_MODULE_2_piexifjs___default.a.GPSHelper.degToDmsRational(value);
      } else if (items[key]) {
        return __WEBPACK_IMPORTED_MODULE_2_piexifjs___default.a.GPSHelper.dmsRationalToDeg(items[key], this.GPSLatitudeRef());
      }
    }
  }, {
    key: 'GPSLongitudeRef',
    value: function GPSLongitudeRef(value) {
      var items = this.exif.GPS;
      var key = __WEBPACK_IMPORTED_MODULE_2_piexifjs___default.a.GPSIFD.GPSLongitudeRef;
      return attr(items, key, value);
    }
  }, {
    key: 'GPSLongitude',
    value: function GPSLongitude(value) {
      var items = this.exif.GPS;
      var key = __WEBPACK_IMPORTED_MODULE_2_piexifjs___default.a.GPSIFD.GPSLongitude;
      if (valid(value)) {
        this.GPSLongitudeRef(value < 0 ? 'W' : 'E');
        items[key] = __WEBPACK_IMPORTED_MODULE_2_piexifjs___default.a.GPSHelper.degToDmsRational(value);
      } else if (items[key]) {
        return __WEBPACK_IMPORTED_MODULE_2_piexifjs___default.a.GPSHelper.dmsRationalToDeg(items[key], this.GPSLongitudeRef());
      }
    }
  }]);

  return PiexifHelper;
}();

/* harmony default export */ __webpack_exports__["a"] = (PiexifHelper);

/***/ }),

/***/ 1652:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return base64ToBlob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return blobToBase64; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_b64_to_blob__ = __webpack_require__(1653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_b64_to_blob___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_b64_to_blob__);
/**
 * Bundle of base64-blob
 * Generated: 2019-07-23
 * Version: 1.4.1
 * License: MIT
 * Author: livelybone(2631541504@qq.com)
 */



/* global Promise */

/**
 * dataURL to blob
 * */
function base64ToBlob(base64) {
  try {
    var arr = base64.split(',');
    var mime = arr[0].match(/:(.*?);/)[1];
    return Promise.resolve(__WEBPACK_IMPORTED_MODULE_0_b64_to_blob___default()(arr[1], mime))
  } catch (e) {
    return Promise.reject(e)
  }
}

/**
 * blob to dataURL
 * */
function blobToBase64(blob) {
  return new Promise(function (res, rej) {
    try {
      var a = new FileReader();
      a.onload = function (e) {
        res(e.target.result);
      };
      a.readAsDataURL(blob);
    } catch (e) {
      rej(e);
    }
  })
}




/***/ }),

/***/ 1653:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, globalName, factory) {
  if (true) {
    // AMD:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === 'object' && module.exports) {
    // Node:
    module.exports = factory();
    // Use module export as simulated ES6 default export:
    module.exports.default = module.exports;
  } else {
    // Browser:
    window[globalName] = factory();
  }
}(this, 'b64toBlob', function() {
  'use strict';

  return function b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      var byteArray = new Uint8Array(byteNumbers);
  
      byteArrays.push(byteArray);
    }
  
    var blob = new Blob(byteArrays, {type: contentType});
    return blob;
  };
}));


/***/ }),

/***/ 1654:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"fullscreen":"","title":"图片修改","custom-class":"cropper-dialog","visible":_vm.visible},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',{staticStyle:{"display":"flex","height":"100%"}},[_c('div',{staticStyle:{"height":"100%","width":"calc(100% - 250px)"}},[_c('CropperImage',{ref:"cropperImage",attrs:{"url":_vm.lastUrl}})],1),_vm._v(" "),_c('div',{staticStyle:{"width":"250px","padding-left":"15px"}},[_c('el-form',{ref:"form",attrs:{"size":"mini","label-position":"top"}},[_c('el-form-item',{attrs:{"label":"拍摄日期"}},[_c('el-date-picker',{attrs:{"type":"datetime","format":"yyyy:MM:dd HH:mm:ss","value-format":"yyyy:MM:dd HH:mm:ss","placeholder":"选择日期时间"},model:{value:(_vm.exif.datetime),callback:function ($$v) {_vm.$set(_vm.exif, "datetime", $$v)},expression:"exif.datetime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"拍摄经度"}},[_c('el-input-number',{attrs:{"min":-180,"max":180,"controls":false},model:{value:(_vm.exif.gpsLongitude),callback:function ($$v) {_vm.$set(_vm.exif, "gpsLongitude", $$v)},expression:"exif.gpsLongitude"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"拍摄纬度"}},[_c('el-input-number',{attrs:{"min":-180,"max":180,"controls":false},model:{value:(_vm.exif.gpsLatitude),callback:function ($$v) {_vm.$set(_vm.exif, "gpsLatitude", $$v)},expression:"exif.gpsLatitude"}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.visible = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.onConfirm()}}},[_vm._v("确认\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1655:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"context-menu",style:(("top:" + _vm.top + "px;left:" + _vm.left + "px;z-index: " + _vm.zIndex)),on:{"click":function($event){$event.stopPropagation();}}},[_c('li',[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFiles.length > 1),expression:"checkedFiles.length > 1"}],attrs:{"type":"text","size":"small","disabled":""}},[_vm._v("已选择"+_vm._s(_vm.checkedFiles.length)+"项\n    ")])],1),_vm._v(" "),_c('li',[_c('el-button',{attrs:{"type":"text","size":"small","disabled":_vm.readOnly || !(_vm.checkedFiles.length === 1 && _vm.checkedFiles[0].type === 'photo')},on:{"click":function($event){return _vm.modify()}}},[_vm._v("修改\n    ")])],1),_vm._v(" "),_c('li',[_c('el-button',{attrs:{"type":"text","size":"small","disabled":_vm.checkedFiles.length === 0},on:{"click":function($event){return _vm.copy()}}},[_vm._v("复制\n    ")])],1),_vm._v(" "),_c('li',[_c('el-button',{attrs:{"type":"text","size":"small","disabled":!_vm.pasteMax || _vm.readOnly || _vm.cutPasteStageFiles.length === 0 || _vm.copyType !== _vm.type},on:{"click":function($event){return _vm.cutPaste()}}},[_vm._v("剪贴\n    ")])],1),_vm._v(" "),_c('li',[_c('el-button',{attrs:{"type":"text","size":"small","disabled":!_vm.pasteMax || _vm.readOnly || _vm.stageFiles.length === 0 || _vm.copyType !== _vm.type},on:{"click":function($event){return _vm.paste()}}},[_vm._v("粘贴\n    ")])],1),_vm._v(" "),_c('li',[_c('el-button',{attrs:{"type":"text","size":"small","disabled":_vm.readOnly || _vm.checkedFiles.length === 0},on:{"click":function($event){return _vm.remove()}}},[_vm._v("删除\n    ")])],1),_vm._v(" "),_c('li',[_c('el-button',{attrs:{"type":"text","size":"small","disabled":_vm.checkedFiles.length === 0},on:{"click":function($event){return _vm.download()}}},[_vm._v("下载\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1671:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 选项的默认值
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  id: '',
  title: '',
  exampleImages: [],
  exampleText: '',
  needEvidence: true,
  localFile: false,
  referIds: [],
  minDuration: '0',
  nextSelectDelay: '0',
  takePhotoAuxiliaryLine: 0,
  mutexOptions: [],
  images: [],
  inputType: 'text',
  inputMin: null,
  inputMax: null,
  required: true,
  jumpTargetId: '',
  settlementType: 0,
  settlementAmount: 0,
  settlementAmountRatio: 1,
  dataLabel: '',
  intelligentCall: false,
  autoIncreaseTaskGroupTarget: false
});

/***/ }),

/***/ 1672:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 题目的默认值
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  id: '',
  title: '',
  titleAlias: '',
  type: '',
  images: [],
  text: '',
  textPrefix: '',
  jumpTargetId: '',
  referIds: [],
  delay: '0',
  needEvidence: true,
  localFile: false,
  clarity: '0',
  minDuration: '0',
  evidenceQuality: '2',
  evidenceType: 'photo',
  imageRecognitionType: [],
  reportedTablesAssociationStepId: '',
  takePhotoAuxiliaryLine: 0,
  takePhotoScene: 0, // 2022-07-13 新增拍照场景（陈列分组拍摄），是 forcePanorama 字段的替代
  allowReusePhoto: false,
  allowCrossSubjectRecord: false,
  inputType: 'text',
  inputMin: null,
  inputMax: null,
  guideText: '',
  guideVideo: [],
  guideAudio: [],
  options: [],
  dataLabel: '',
  forceGuideVideo: false,
  forceGuideAudio: false,
  auditText: '',
  intelligentCall: false,
  keyin_ids: [],
  ondutyCheck: false,
  throughRecordKeyQuestion: false,
  allow_media_download: 2,
  allow_screen_capture: 2
});

/***/ }),

/***/ 1678:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = recoveryQuestions;
/* harmony export (immutable) */ __webpack_exports__["a"] = recoveryAnswers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_function__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__recovery_fields_option__ = __webpack_require__(1734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__recovery_fields_question__ = __webpack_require__(1735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__recovery_fields_option_types__ = __webpack_require__(1736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__recovery_fields_question_types__ = __webpack_require__(1737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__recovery_fields_answer__ = __webpack_require__(1738);









/**
 * 修复数据类型，数字与字符串的转换
 * TODO 由于代码逻辑错误造成部分已存在的数据数据类型不正确
 *
 * @param errorData
 * @param rightData
 * @param field
 * @returns {boolean}
 */
function autoFixDataType(errorData, rightData, field) {
  if ([Number, String].includes(errorData[field].constructor) || [Number, String].includes(rightData[field].constructor)) {
    errorData[field] = rightData[field].constructor(errorData[field]);
    return true;
  }
  return false;
}

function getQuestionValue(question) {
  // 深复制一个模型
  var $questionModel = Object(__WEBPACK_IMPORTED_MODULE_1__utils_function__["b" /* copyJson */])(__WEBPACK_IMPORTED_MODULE_4__recovery_fields_question__["a" /* default */]);
  var $question = {};
  var fields = __WEBPACK_IMPORTED_MODULE_6__recovery_fields_question_types__["a" /* default */][question.type];
  // 获得问题的类型
  var type = Object(__WEBPACK_IMPORTED_MODULE_2__type__["b" /* getRecoveryType */])(question.type);
  fields.forEach(function (field) {
    switch (field) {
      case 'stepId':
        $question[field] = question.id;
        break;
      case 'type':
        $question[field] = type;
        break;
      case 'referStepId':
        $question[field] = Object(__WEBPACK_IMPORTED_MODULE_1__utils_function__["d" /* getExist */])(question.referIds[0], $questionModel[field]);
        break;
      case 'desc':
        $question[field] = question.text;
        break;
      case 'descPrefix':
        $question[field] = question.textPrefix;
        break;
      case 'images':
        $question[field] = question.images.map(function (_ref) {
          var src = _ref.src;
          return src;
        });
        break;
      case 'videoDuration':
        $question[field] = question.evidenceType === 'video' ? question.minDuration : $questionModel[field];
        break;
      case 'recordDuration':
        $question[field] = question.evidenceType === 'record' ? question.minDuration : $questionModel[field];
        break;
      case 'forceCamera':
        $question[field] = !question.localFile;
        break;
      case 'default_jump':
        $question[field] = question.jumpTargetId;
        break;
      case 'conditional_jump':
        $question[field] = {};
        question.options.forEach(function (option) {
          option.jumpTargetId && ($question[field][option.id] = option.jumpTargetId);
        });
        break;
      case 'needPhoto':
        $question[field] = question.needEvidence;
        break;
      case 'moptions':
        $question[field] = question.options;
        break;
      case 'pictureMultipleOptions':
        $question[field] = question.options;
        break;
      case 'mtext':
        $question[field] = question.options;
        break;
      default:
        // 取得默认字段值
        $question[field] = Object(__WEBPACK_IMPORTED_MODULE_1__utils_function__["d" /* getExist */])(question[field], $questionModel[field]);
        break;
    }
    // 数据类型验证，保证数据是可靠的
    // TODO 默认值为NULL 时没有 constructor，需要更完善的类型申明
    if ($questionModel[field] !== null && $question[field].constructor !== $questionModel[field].constructor) {
      var message = 'question "' + field + '" \u6570\u636E\u7C7B\u578B\u5E94\u8BE5\u662F ' + $questionModel[field].constructor.name + ', \u5F53\u524D\u662F ' + $question[field].constructor.name;
      if (autoFixDataType($question, $questionModel, field)) {
        console.error(message);
        console.warn('\u81EA\u52A8\u4FEE\u590D question "' + field + '" \u6570\u636E\u7C7B\u578B\u4E3A ' + $questionModel[field].constructor.name);
      } else {
        throw new Error(message);
      }
    }
  });
  return $question;
}

function getOptionValue(option, type) {
  // 深复制一个模型
  var $optionModel = Object(__WEBPACK_IMPORTED_MODULE_1__utils_function__["b" /* copyJson */])(__WEBPACK_IMPORTED_MODULE_3__recovery_fields_option__["a" /* default */]);
  var $option = {};
  var fields = __WEBPACK_IMPORTED_MODULE_5__recovery_fields_option_types__["a" /* default */][type];
  fields.forEach(function (field) {
    switch (field) {
      case 'optionId':
        $option[field] = option.id;
        break;
      case 'referStepId':
        $option[field] = Object(__WEBPACK_IMPORTED_MODULE_1__utils_function__["d" /* getExist */])(option.referIds[0], $optionModel[field]);
        break;
      case 'titlePictures':
        $option[field] = option.images.map(function (_ref2) {
          var src = _ref2.src;
          return src;
        });
        break;
      case 'examplePhotos':
        $option[field] = option.exampleImages.map(function (_ref3) {
          var src = _ref3.src;
          return src;
        });
        break;
      case 'exclusiveOption':
        $option[field] = option.mutexOptions;
        break;
      case 'mStepDelay':
        $option[field] = option.nextSelectDelay;
        break;
      case 'forceCamera':
        $option[field] = !option.localFile;
        break;
      case 'needPhoto':
        $option[field] = option.needEvidence;
        break;
      case 'settlementAmountRatio':
        // 必须拥有符合的父级设定
        $option[field] = option.settlementType === 1 ? option[field] : $optionModel[field];
        break;
      case 'settlementAmount':
        // 必须拥有符合的父级设定
        $option[field] = option.settlementType === 2 ? option[field] : $optionModel[field];
        break;
      default:
        // 取得默认字段值
        $option[field] = Object(__WEBPACK_IMPORTED_MODULE_1__utils_function__["d" /* getExist */])(option[field], $optionModel[field]);
        break;
    }
    // 数据类型验证，保证数据是可靠的
    // TODO 默认值为NULL 时没有 constructor，需要更完善的类型申明
    if ($optionModel[field] !== null && $option[field].constructor !== $optionModel[field].constructor) {
      var message = 'option "' + field + '" \u6570\u636E\u7C7B\u578B\u5E94\u8BE5\u662F ' + $optionModel[field].constructor.name + ', \u5F53\u524D\u662F ' + $option[field].constructor.name;
      if (autoFixDataType($option, $optionModel, field)) {
        console.error(message);
        console.warn('\u81EA\u52A8\u4FEE\u590D question "' + field + '" \u6570\u636E\u7C7B\u578B\u4E3A ' + $optionModel[field].constructor.name);
      } else {
        throw new Error(message);
      }
    }
  });

  return $option;
}

function recoveryQuestions(questions) {
  var $questions = [];
  questions.forEach(function (question) {
    // 获得问题的类型
    var type = question.type;
    var $type = Object(__WEBPACK_IMPORTED_MODULE_2__type__["b" /* getRecoveryType */])(type);
    var $question = getQuestionValue(question);
    // 选项的转换
    if ($question[$type]) {
      $question[$type] = $question[$type].map(function (option) {
        return getOptionValue(option, type);
      });
    }
    $questions.push($question);
  });
  return $questions;
}

function recoveryAnswers(questions, answers, indexes) {
  var $answers = [];
  questions.forEach(function (question, index) {
    var answer = answers[index];
    var $answer = Object(__WEBPACK_IMPORTED_MODULE_1__utils_function__["b" /* copyJson */])(__WEBPACK_IMPORTED_MODULE_7__recovery_fields_answer__["a" /* default */]);
    $answer.stepId = question.id;

    // 生成有效题目的答案数据
    if (!indexes[question.id].isJumped) {
      var type = question.type,
          evidenceType = question.evidenceType,
          options = question.options;

      var evidences = [];
      var texts = {};
      // 多项填空题
      if (type === 'multitext') {
        answer.texts.forEach(function (vlaue, index) {
          texts[options[index].id] = {
            textAnswer: vlaue
          };
        });
      } else {
        // 证据
        evidences = answer.evidences.map(function (item) {
          if (evidenceType === 'video') {
            return {
              videoUrl: item.src,
              thumbUrl: item.cover
            };
          } else if (evidenceType === 'qrcode') {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
              src: item.image_url
            });
          } else {
            return item.src;
          }
        });
      }
      $answer = {
        'stepId': question.id,
        'isPassed': answer.isPassed,
        'errormessage': answer.errorMessage,
        'comment': answer.comment,
        'textAnswer': answer.text || '',
        'selectedOptionId': type === 'select' && answer.selectedOptionId[0] ? answer.selectedOptionId[0] : '',
        'mOptionIds': type === 'multiselect' ? answer.selectedOptionId : [],
        'pictureMultipleOptionIds': type === 'imageMultiselect' ? answer.selectedOptionId : [],
        'mTextAnswer': texts,
        'photos': evidenceType === 'photo' ? evidences : [],
        'videos': evidenceType === 'video' ? evidences : [],
        'records': evidenceType === 'record' ? evidences : [],
        'qrcodes': evidenceType === 'qrcode' ? evidences : []
      };
    }

    $answers.push($answer);
  });
  return $answers;
}

/* unused harmony default export */ var _unused_webpack_default_export = ({ recoveryQuestions: recoveryQuestions, recoveryAnswers: recoveryAnswers });

/***/ }),

/***/ 1680:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionGuideVideo_vue__ = __webpack_require__(1587);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_396358a6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionGuideVideo_vue__ = __webpack_require__(1763);
function injectStyle (ssrContext) {
  __webpack_require__(1745)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-396358a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionGuideVideo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_396358a6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionGuideVideo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1681:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_question_editor_packages_sj_question_file__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_question_editor_packages_sj_question_file_item__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_question_editor_packages_sj_question_file_add__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_question_editor_packages_sj_question_file_progress__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__ = __webpack_require__(1507);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { SjQuestionFileProgress: __WEBPACK_IMPORTED_MODULE_5__views_question_editor_packages_sj_question_file_progress__["a" /* default */], SjQuestionFileAdd: __WEBPACK_IMPORTED_MODULE_4__views_question_editor_packages_sj_question_file_add__["a" /* default */], SjQuestionFileItem: __WEBPACK_IMPORTED_MODULE_3__views_question_editor_packages_sj_question_file_item__["a" /* default */], SjQuestionFile: __WEBPACK_IMPORTED_MODULE_2__views_question_editor_packages_sj_question_file__["a" /* default */] },
  mixins: [],
  inject: ['playAudio'],
  props: {
    value: Array,
    disabled: Boolean,
    title: {
      type: String,
      default: '添加指引音频'
    },
    showHoverIcons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      progress: [
        // percentage: 0,
      ],
      checkedFiles: []
    };
  },

  computed: {
    files: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {
    view: function view(src) {
      this.playAudio({ src: src });
    },
    upload: function upload() {
      var _this = this;

      var file = this.$refs.selectFile.files[0];
      if (this.validate(file)) {
        // 显示进度条
        var progress = {
          percentage: 0,
          file: file
        };
        this.progress.push(progress);
        // 生成请求数据
        var form = new FormData();
        form.append('file', file);
        request.alert('uploadStepTemplateFile', form, {
          onUploadProgress: function onUploadProgress(progressEvent) {
            progress.percentage = progressEvent.loaded / progressEvent.total * 100 | 0;
          }
        }).then(function (_ref) {
          var data = _ref.data;

          _this.files.push({ src: data });
        }).finally(function () {
          _this.progress.splice(_this.progress.indexOf(progress), 1);
        });
      }
      this.$refs.selectFile.value = null;
    },
    validate: function validate(file) {
      var size = 10;
      var isLtSize = file.size / 1024 / 1024 < size;
      if (!isLtSize) {
        this.$message.error('\u4E0A\u4F20\u97F3\u9891\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 ' + size + 'MB!');
      }
      return isLtSize;
    },
    remove: function remove(index) {
      this.files.splice(index, 1);
    },
    onContextmenu: function onContextmenu(_ref2, index) {
      var clientX = _ref2.clientX,
          clientY = _ref2.clientY;

      // 匹配右击菜单作用域
      Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().scope !== this.uniqueId && Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().empty();
      // 判断右击是否在项目上
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(index) && index >= 0) {
        var file = this.files[index];
        if (!this.checkedFiles.includes(file)) {
          Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().empty();
          Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().checked(file);
          this.checkedFiles = Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().checkedFiles;
        }
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().empty();
      }
      // 限制拷贝数量
      Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])({ pasteMax: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a });
      Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().setScope(this.uniqueId);
      Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().setType(this.type);
      Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().setFiles(this.files);
      Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().show(clientX, clientY);
    }
  }
});

/***/ }),

/***/ 1682:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_viewerjs_dist_viewer_css__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_viewerjs__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_viewerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_viewerjs__);
//
//
//
//
//
//
//
//
//
//
//




// View an image
var viewer = null;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {},
  data: function data() {
    return {
      visible: false,
      action: '',
      files: [],
      index: null
    };
  },

  computed: {},
  watch: {
    visible: function visible() {
      if (this.visible) {
        this.view(this.index);
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {
    this.destroyViewer();
  },

  methods: {
    view: function view(index) {
      var _this = this;

      this.$nextTick(function () {
        _this.createViewer();
        viewer.view(index);
        viewer.show();
      });
    },
    createViewer: function createViewer() {
      this.destroyViewer();
      viewer = new __WEBPACK_IMPORTED_MODULE_1_viewerjs___default.a(this.$el, {
        url: function url(image) {
          return image.alt + '?x-oss-process=image/auto-orient,1';
        },
        hidden: this.onClose
      });
    },
    destroyViewer: function destroyViewer() {
      viewer && viewer.destroy();
    },
    handleAction: function handleAction(action) {
      this.action = action;
      this.doClose();
    },
    onClose: function onClose() {
      if (!this.visible) return;
      this.handleAction('close');
    },
    doClose: function doClose() {
      var _this2 = this;

      if (!this.visible) return;
      this.visible = false;
      setTimeout(function () {
        if (_this2.action) _this2.callback(_this2.action, _this2);
      });
    }
  }
});

/***/ }),

/***/ 1683:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  mixins: [],
  props: {},
  data: function data() {
    return {
      visible: false,
      action: '',
      title: undefined,
      loading: false,
      rules: {
        file: [{
          message: '请选择视频文件',
          type: 'object',
          required: true
        }, {
          type: 'object',
          required: true,
          validator: function validator(rule, value, callback) {
            var size = 50;
            if (value.size / 1024 / 1024 < size) {
              return callback();
            }
            return callback(new Error('\u89C6\u9891\u6587\u4EF6\u4E0D\u80FD\u8D85\u8FC7' + size + 'MB'));
          }
        }],
        poster: [{
          message: '请选择视频封面文件',
          type: 'object',
          required: true
        }, {
          type: 'object',
          required: true,
          validator: function validator(rule, value, callback) {
            var size = 5;
            if (value.size / 1024 / 1024 < size) {
              return callback();
            }
            return callback(new Error('\u89C6\u9891\u5C01\u9762\u6587\u4EF6\u4E0D\u80FD\u8D85\u8FC7' + size + 'MB'));
          }
        }]
      },
      form: {
        file: '',
        poster: ''
      },
      videoList: [],
      posterList: []
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    handleAction: function handleAction(action) {
      this.action = action;
      this.doClose();
    },
    onClose: function onClose() {
      if (!this.visible) return;
      this.handleAction('close');
    },
    doClose: function doClose() {
      var _this = this;

      if (!this.visible) return;
      this.visible = false;
      setTimeout(function () {
        if (_this.action) _this.callback(_this.action, _.clone(_this.form));
        _this.resetFields();
      });
    },
    resetFields: function resetFields() {
      this.$refs.video.clearFiles();
      this.$refs.poster.clearFiles();
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data.form, this.$options.data.call(this).form);
      this.$refs.form.resetFields();
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs.form.validate().then(function () {
        _this2.handleAction('confirm');
      }).catch(function () {
        _this2.$message.error('提交内容填写不正确！');
      });
    },
    changeVideo: function changeVideo(file) {
      if (file) {
        this.videoList = [file];
        this.form.file = file.raw;
      } else {
        this.videoList = [];
        this.form.file = null;
      }
    },
    changePoster: function changePoster(file) {
      if (file) {
        this.posterList = [file];
        this.form.poster = file.raw;
      } else {
        this.posterList = [];
        this.form.poster = null;
      }
    },
    validate: function validate(file) {
      var size = 50;
      var isLtSize = this.form.file.size / 1024 / 1024 < size;
      if (!isLtSize) {
        this.$message.error('\u4E0A\u4F20\u89C6\u9891\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 ' + size + 'MB!');
      }
      return isLtSize;
    }
  }
});

/***/ }),

/***/ 1684:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_plyr__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_plyr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_plyr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plyr_dist_plyr_css__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plyr_dist_plyr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_plyr_dist_plyr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_music_icon_svg__ = __webpack_require__(1912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_music_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__img_music_icon_svg__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// https://github.com/sampotts/plyr

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SjPlyrAudioBox',
  components: {},
  props: {
    file: Object
  },
  data: function data() {
    return {
      visible: false,
      action: '',
      title: ''
    };
  },

  computed: {
    src: function src() {
      return this.file ? filter.ossHost(this.file.src) : '';
    }
  },
  watch: {
    visible: function visible(value) {
      if (this.player) {
        if (value) {
          this.player.currentTime = 0;
          this.player.play();
        } else {
          this.player && this.player.pause();
        }
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.$refs.audio && this.init();
  },
  updated: function updated() {
    this.$refs.audio && this.init();
  },
  destroyed: function destroyed() {
    this.player && this.player.destroy();
  },

  methods: {
    handleAction: function handleAction(action) {
      this.action = action;
      this.doClose();
    },
    onClose: function onClose() {
      if (!this.visible) return;
      this.handleAction('close');
    },
    doClose: function doClose() {
      var _this = this;

      if (!this.visible) return;
      this.visible = false;
      setTimeout(function () {
        if (_this.action) _this.callback(_this.action, _this);
      });
    },
    init: function init() {
      var _this2 = this;

      if (this.player) return;
      this.player = new __WEBPACK_IMPORTED_MODULE_2_plyr___default.a(this.$refs.audio, {
        tooltips: { controls: true },
        volume: 10,
        disableContextMenu: false,
        controls: ['play-large',
        // 'restart',
        // 'rewind',
        'play',
        // 'fast-forward',
        'progress', 'current-time', 'mute', 'volume',
        // 'captions',
        'settings', 'pip', 'airplay', 'download', 'fullscreen'],
        i18n: {
          play: '播放',
          pause: '暂停',
          mute: '静音',
          unmute: '取消静音',
          download: '下载',
          pip: '画中画',
          settings: '设置',
          speed: '速度',
          normal: '正常'
        }
      });
      this.player.on('ready', function (event) {
        if (navigator.userAgent.indexOf('Chrome') > -1) {
          $('.plyr__controls', _this2.$el).append(_this2.$refs.audioPip);
        } else {
          _this2.$refs.audioPip.remove();
        }
      });
    },
    audioPip: function audioPip() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.player.pause();

                if (_this3.playAudio) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return _this3.pictureInPicture();

              case 4:
                _this3.playAudio();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },

    /**
     * 音频画中画实现
     * 参考：https://googlechrome.github.io/samples/picture-in-picture/audio-playlist
     * 次要参考：https://blog.arnellebalane.com/the-picture-in-picture-api-30415372009f
     */
    pictureInPicture: function pictureInPicture() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {

        /* Picture-in-Picture Canvas */

        var showPictureInPictureWindow = function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var image, ctx;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    image = new Image();

                    image.src = __WEBPACK_IMPORTED_MODULE_4__img_music_icon_svg___default.a;
                    _context2.next = 4;
                    return image.decode();

                  case 4:
                    ctx = canvas.getContext('2d');

                    ctx.fillStyle = '#72CAAF';
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

                    _context2.next = 10;
                    return video.play();

                  case 10:
                    _context2.next = 12;
                    return video.requestPictureInPicture();

                  case 12:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, this);
          }));

          return function showPictureInPictureWindow() {
            return _ref.apply(this, arguments);
          };
        }();

        var playAudio = function () {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.prev = 0;

                    audio.src = media.src;
                    audio.currentTime = media.currentTime;
                    // Play audio
                    _context3.next = 5;
                    return audio.play();

                  case 5:
                    _context3.next = 7;
                    return showPictureInPictureWindow(media);

                  case 7:
                    _context3.next = 12;
                    break;

                  case 9:
                    _context3.prev = 9;
                    _context3.t0 = _context3['catch'](0);

                    console.error(_context3.t0);

                  case 12:
                  case 'end':
                    return _context3.stop();
                }
              }
            }, _callee3, this, [[0, 9]]);
          }));

          return function playAudio() {
            return _ref2.apply(this, arguments);
          };
        }();

        var media, audio, canvas, video;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                media = _this4.player.media;
                audio = document.createElement('audio');

                /* Picture-in-Picture Canvas */

                canvas = document.createElement('canvas');

                canvas.width = canvas.height = 512;

                /* Picture-in-Picture Video */

                video = document.createElement('video');

                video.srcObject = canvas.captureStream();
                video.muted = true;

                video.addEventListener('leavepictureinpicture', function () {
                  audio.pause();
                  if (media && media.src === audio.src) {
                    media.currentTime = audio.currentTime;
                    media.play();
                  }
                });

                navigator.mediaSession.metadata = new window.MediaMetadata();

                /* Play & Pause */

                navigator.mediaSession.setActionHandler('play', function () {
                  console.log('play');
                  audio.play();
                  if (document.pictureInPictureElement) {
                    document.pictureInPictureElement.play();
                  }
                });

                navigator.mediaSession.setActionHandler('pause', function () {
                  console.log('pause');
                  audio.pause();
                  if (document.pictureInPictureElement) {
                    document.pictureInPictureElement.pause();
                  }
                });

                _this4.playAudio = playAudio;

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    }
  }
});

/***/ }),

/***/ 1685:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_plyr__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_plyr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_plyr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_plyr_dist_plyr_css__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_plyr_dist_plyr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_plyr_dist_plyr_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// https://github.com/sampotts/plyr

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SjPlyrVideoBox',
  components: {},
  props: {
    file: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      visible: false,
      action: '',
      title: ''
    };
  },

  computed: {},
  watch: {
    visible: function visible(value) {
      if (value) {
        this.view();
      } else {
        this.player && this.player.pause();
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.$refs.video && this.init();
  },
  updated: function updated() {
    this.$refs.video && this.init();
  },
  destroyed: function destroyed() {
    this.player && this.player.destroy();
  },

  methods: {
    handleAction: function handleAction(action) {
      this.action = action;
      this.doClose();
    },
    onClose: function onClose() {
      if (!this.visible) return;
      this.handleAction('close');
    },
    doClose: function doClose() {
      var _this = this;

      if (!this.visible) return;
      this.visible = false;
      setTimeout(function () {
        if (_this.action) _this.callback(_this.action, _this);
      });
    },
    init: function init() {
      var _this2 = this;

      if (this.player) return;
      this.player = new __WEBPACK_IMPORTED_MODULE_0_plyr___default.a(this.$refs.video, {
        tooltips: { controls: true },
        volume: 10,
        disableContextMenu: false,
        controls: ['play-large',
        // 'restart',
        // 'rewind',
        'play',
        // 'fast-forward',
        'progress', 'current-time', 'mute', 'volume',
        // 'captions',
        'settings', 'pip', 'airplay', 'download', 'fullscreen'],
        i18n: {
          play: '播放',
          pause: '暂停',
          mute: '静音',
          unmute: '取消静音',
          download: '下载',
          enterFullscreen: '全屏',
          exitFullscreen: '退出全屏',
          pip: '画中画',
          settings: '设置',
          speed: '速度',
          normal: '正常'
        }
      });
      this.player.on('ready', function (event) {
        _this2.player.rotateAngle = 0;
        $('.plyr__controls', _this2.$el).append(_this2.$refs.videoRotate);
      });
      this.view();
    },
    view: function view() {
      var _this3 = this;

      if (!this.player) return;
      this.$nextTick(function () {
        _this3.ratio();
        _this3.player.source = {
          type: 'video',
          sources: [{
            src: filter.ossConvertMP4(_this3.file.src),
            type: 'video/mp4'
          }, {
            src: filter.ossHost(_this3.file.src),
            type: 'video/mp4'
          }],
          poster: _this3.file.cover
        };
        _this3.player.download = filter.ossHost(_this3.file.src);
        _this3.player.play();
        // 控制视频的高度
        $('video', _this3.$el).add('.plyr', _this3.$el).height(document.body.clientHeight - 165);
      });
    },
    ratio: function ratio() {
      this.player.ratio = $(this.$refs.content).width() + ':' + $(this.$refs.content).height();
    },
    onRotate: function onRotate() {
      // 顺时针旋转90°
      this.player.rotateAngle += 90;
      // 重置旋转角度
      if (this.player.rotateAngle === 360) {
        this.player.rotateAngle = 0;
      }
      var video = $('video', this.$el);
      // 需要旋转
      if (this.player.rotateAngle) {
        var width = video.width();
        var height = video.height();
        // 旋转后需要偏移位置
        var translate = '';
        if (this.player.rotateAngle === 90) {
          translate = 'translate(' + width + 'px)';
        }
        if (this.player.rotateAngle === 180) {
          translate = 'translate(' + height + 'px, ' + width + 'px)';
        }
        if (this.player.rotateAngle === 270) {
          translate = 'translate(0px, ' + height + 'px)';
        }
        // 实现旋转
        video.css({
          width: height + 'px',
          height: width + 'px',
          transform: translate + ' rotate(' + this.player.rotateAngle + 'deg)',
          transformOrigin: 'left top'
        });
      } else {
        video.removeAttr('style');
      }
    }
  }
});

/***/ }),

/***/ 1709:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  comment: '',
  isPassed: '10',
  errorMessage: '',
  selectedOptionId: [],
  text: '',
  texts: [],
  evidences: []
});

/***/ }),

/***/ 1710:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 全部都有的字段
var basics = ['comment', 'isPassed', 'errorMessage'];
// 多次重用组合
var evidences = ['evidences'];
/* harmony default export */ __webpack_exports__["a"] = ({
  info: [].concat(basics, evidences).sort(),
  text: [].concat(basics, evidences, ['text']).sort(),
  multitext: [].concat(basics, ['texts']).sort(),
  multiselect: [].concat(basics, evidences, ['selectedOptionId']).sort(),
  imageMultiselect: [].concat(basics, evidences, ['selectedOptionId']).sort(),
  select: [].concat(basics, evidences, ['selectedOptionId']).sort()
});

/***/ }),

/***/ 1732:
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ 1733:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ScrollToPlugin */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__ = __webpack_require__(1568);
/*!
 * VERSION: 1.9.2
 * DATE: 2019-02-07
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/
/* eslint-disable */




var _doc = (__WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["c" /* _gsScope */].document || {}).documentElement,
		_window = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["c" /* _gsScope */],
		_max = function(element, axis) {
			var dim = (axis === "x") ? "Width" : "Height",
				scroll = "scroll" + dim,
				client = "client" + dim,
				body = document.body;
			return (element === _window || element === _doc || element === body) ? Math.max(_doc[scroll], body[scroll]) - (_window["inner" + dim] || _doc[client] || body[client]) : element[scroll] - element["offset" + dim];
		},
		_unwrapElement = function(value) {
			if (typeof(value) === "string") {
				value = TweenLite.selector(value);
			}
			if (value.length && value !== _window && value[0] && value[0].style && !value.nodeType) {
				value = value[0];
			}
			return (value === _window || (value.nodeType && value.style)) ? value : null;
		},
		_buildGetter = function(e, axis) { //pass in an element and an axis ("x" or "y") and it'll return a getter function for the scroll position of that element (like scrollTop or scrollLeft, although if the element is the window, it'll use the pageXOffset/pageYOffset or the documentElement's scrollTop/scrollLeft or document.body's. Basically this streamlines things and makes a very fast getter across browsers.
			var p = "scroll" + ((axis === "x") ? "Left" : "Top");
			if (e === _window) {
				if (e.pageXOffset != null) {
					p = "page" + axis.toUpperCase() + "Offset";
				} else if (_doc[p] != null) {
					e = _doc;
				} else {
					e = document.body;
				}
			}
			return function() {
				return e[p];
			};
		},
		_getOffset = function(element, container) {
			var rect = _unwrapElement(element).getBoundingClientRect(),
				b = document.body,
				isRoot = (!container || container === _window || container === b),
				cRect = isRoot ? {top:_doc.clientTop - (window.pageYOffset || _doc.scrollTop || b.scrollTop || 0), left:_doc.clientLeft - (window.pageXOffset || _doc.scrollLeft || b.scrollLeft || 0)} : container.getBoundingClientRect(),
				offsets = {x: rect.left - cRect.left, y: rect.top - cRect.top};
			if (!isRoot && container) { //only add the current scroll position if it's not the window/body.
				offsets.x += _buildGetter(container, "x")();
				offsets.y += _buildGetter(container, "y")();
			}
			return offsets;
			/*	PREVIOUS
			var rect = _unwrapElement(element).getBoundingClientRect(),
				isRoot = (!container || container === _window || container === document.body),
				cRect = (isRoot ? _doc : container).getBoundingClientRect(),
				offsets = {x: rect.left - cRect.left, y: rect.top - cRect.top};
			if (!isRoot && container) { //only add the current scroll position if it's not the window/body.
				offsets.x += _buildGetter(container, "x")();
				offsets.y += _buildGetter(container, "y")();
			}
			return offsets;
			*/
		},
		_parseVal = function(value, target, axis, currentVal) {
			var type = typeof(value);
			return !isNaN(value) ? parseFloat(value) : (type === "string" && value.charAt(1) === "=") ? parseInt(value.charAt(0) + "1", 10) * parseFloat(value.substr(2)) + currentVal : (value === "max") ? _max(target, axis) : Math.min(_max(target, axis), _getOffset(value, target)[axis]);
		},

		ScrollToPlugin = __WEBPACK_IMPORTED_MODULE_0__TweenLite_js__["c" /* _gsScope */]._gsDefine.plugin({
			propName: "scrollTo",
			API: 2,
			global: true,
			version:"1.9.2",

			//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
			init: function(target, value, tween) {
				this._wdw = (target === _window);
				this._target = target;
				this._tween = tween;
				if (typeof(value) !== "object") {
					value = {y:value}; //if we don't receive an object as the parameter, assume the user intends "y".
					if (typeof(value.y) === "string" && value.y !== "max" && value.y.charAt(1) !== "=") {
						value.x = value.y;
					}
				} else if (value.nodeType) {
					value = {y:value, x:value};
				}
				this.vars = value;
				this._autoKill = (value.autoKill !== false);
				this.getX = _buildGetter(target, "x");
				this.getY = _buildGetter(target, "y");
				this.x = this.xPrev = this.getX();
				this.y = this.yPrev = this.getY();
				if (value.x != null) {
					this._addTween(this, "x", this.x, _parseVal(value.x, target, "x", this.x) - (value.offsetX || 0), "scrollTo_x", true);
					this._overwriteProps.push("scrollTo_x");
				} else {
					this.skipX = true;
				}
				if (value.y != null) {
					this._addTween(this, "y", this.y, _parseVal(value.y, target, "y", this.y) - (value.offsetY || 0), "scrollTo_y", true);
					this._overwriteProps.push("scrollTo_y");
				} else {
					this.skipY = true;
				}
				return true;
			},

			//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
			set: function(v) {
				this._super.setRatio.call(this, v);

				var x = (this._wdw || !this.skipX) ? this.getX() : this.xPrev,
					y = (this._wdw || !this.skipY) ? this.getY() : this.yPrev,
					yDif = y - this.yPrev,
					xDif = x - this.xPrev,
					threshold = ScrollToPlugin.autoKillThreshold;

				if (this.x < 0) { //can't scroll to a position less than 0! Might happen if someone uses a Back.easeOut or Elastic.easeOut when scrolling back to the top of the page (for example)
					this.x = 0;
				}
				if (this.y < 0) {
					this.y = 0;
				}
				if (this._autoKill) {
					//note: iOS has a bug that throws off the scroll by several pixels, so we need to check if it's within 7 pixels of the previous one that we set instead of just looking for an exact match.
					if (!this.skipX && (xDif > threshold || xDif < -threshold) && x < _max(this._target, "x")) {
						this.skipX = true; //if the user scrolls separately, we should stop tweening!
					}
					if (!this.skipY && (yDif > threshold || yDif < -threshold) && y < _max(this._target, "y")) {
						this.skipY = true; //if the user scrolls separately, we should stop tweening!
					}
					if (this.skipX && this.skipY) {
						this._tween.kill();
						if (this.vars.onAutoKill) {
							this.vars.onAutoKill.apply(this.vars.onAutoKillScope || this._tween, this.vars.onAutoKillParams || []);
						}
					}
				}
				if (this._wdw) {
					_window.scrollTo((!this.skipX) ? this.x : x, (!this.skipY) ? this.y : y);
				} else {
					if (!this.skipY) {
						this._target.scrollTop = this.y;
					}
					if (!this.skipX) {
						this._target.scrollLeft = this.x;
					}
				}
				this.xPrev = this.x;
				this.yPrev = this.y;
			}

		}),
		p = ScrollToPlugin.prototype;

	ScrollToPlugin.max = _max;
	ScrollToPlugin.getOffset = _getOffset;
	ScrollToPlugin.buildGetter = _buildGetter;
	ScrollToPlugin.autoKillThreshold = 7;

	p._kill = function(lookup) {
		if (lookup.scrollTo_x) {
			this.skipX = true;
		}
		if (lookup.scrollTo_y) {
			this.skipY = true;
		}
		return this._super._kill.call(this, lookup);
	};




/***/ }),

/***/ 1734:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 选项的默认值
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  id: '',
  optionId: '',
  title: '',
  examplePhotos: [],
  exampleText: '',
  needPhoto: true,
  evidenceType: 'photo',
  forceCamera: true,
  referStepId: '',
  referIds: [],
  mStepDelay: '0',
  takePhotoAuxiliaryLine: 0,
  forcePanorama: false,
  exclusiveOption: [],
  titlePictures: [],
  required: true,
  inputType: 'text',
  inputMin: null,
  inputMax: null,
  settlementType: 0,
  settlementAmount: 0,
  settlementAmountRatio: 1,
  dataLabel: '',
  intelligentCall: false,
  autoIncreaseTaskGroupTarget: false,
  priorityReview: false
});

/***/ }),

/***/ 1735:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 题目的默认值
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  stepId: '',
  title: '',
  titleAlias: '',
  type: '',
  images: [],
  desc: '',
  descPrefix: '',
  default_jump: '',
  conditional_jump: {},
  referStepId: '',
  referIds: [],
  delay: '0',
  needPhoto: true,
  forceCamera: true,
  clarity: '0',
  videoDuration: '0',
  recordDuration: '0',
  evidenceQuality: '2',
  evidenceType: 'photo',
  imageRecognitionType: [],
  reportedTablesAssociationStepId: '',
  takePhotoAuxiliaryLine: 0,
  forcePanorama: false,
  takePhotoScene: 0, // 2022-07-13 新增拍照场景（陈列分组拍摄），是 forcePanorama 字段的替代
  allowReusePhoto: false,
  allowCrossSubjectRecord: false,
  inputType: 'text',
  inputMin: null,
  inputMax: null,
  options: [],
  moptions: [],
  pictureMultipleOptions: [],
  mtext: [],
  guideText: '',
  guideVideo: [],
  guideAudio: [],
  dataLabel: '',
  forceGuideVideo: false,
  forceGuideAudio: false,
  auditText: '',
  intelligentCall: false,
  keyin_ids: [],
  ondutyCheck: false,
  throughRecordKeyQuestion: false,
  allow_screen_capture: 2,
  allow_media_download: 2
});

/***/ }),

/***/ 1736:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 不同题目类型选项拥有的字段
 */

// 全部都有的字段
var basics = ['title'];

var choice = ['settlementType', 'settlementAmount', 'settlementAmountRatio', 'intelligentCall'];

/* harmony default export */ __webpack_exports__["a"] = ({
  info: [],
  text: [],
  multitext: [].concat(basics, ['id', 'inputType', 'inputMin', 'inputMax', 'required', 'dataLabel']).sort(),
  multiselect: [].concat(basics, choice, ['id', 'exclusiveOption', 'dataLabel']).sort(),
  imageMultiselect: [].concat(basics, choice, ['id', 'exclusiveOption', 'titlePictures', 'dataLabel']).sort(),
  select: [].concat(basics, choice, ['dataLabel', 'optionId', 'examplePhotos', 'exampleText', 'forceCamera', 'forcePanorama', 'referStepId', 'referIds', 'mStepDelay', 'takePhotoAuxiliaryLine', 'needPhoto', 'autoIncreaseTaskGroupTarget', 'priorityReview']).sort()
});

/***/ }),

/***/ 1737:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 不同题型的字段
 */

// 全部都有的字段
var basics = ['stepId', 'title', 'titleAlias', 'type', 'images', 'desc', 'descPrefix', 'default_jump', 'delay', 'guideText', 'guideVideo', 'guideAudio', 'forceGuideVideo', 'forceGuideAudio', 'auditText', 'keyin_ids', 'ondutyCheck', 'throughRecordKeyQuestion', 'allow_screen_capture', 'allow_media_download'];
// 多次重用组合
var reusing = ['referStepId', 'referIds', 'needPhoto', 'forceCamera', 'clarity', 'videoDuration', 'recordDuration', 'evidenceQuality', 'evidenceType', 'imageRecognitionType', 'takePhotoAuxiliaryLine', 'forcePanorama', 'allowReusePhoto', 'allowCrossSubjectRecord', 'reportedTablesAssociationStepId'];

var hasEvidenceFields = ['takePhotoScene'];

/* harmony default export */ __webpack_exports__["a"] = ({
  info: [].concat(basics, reusing, hasEvidenceFields, ['dataLabel', 'intelligentCall']).sort(),
  text: [].concat(basics, reusing, hasEvidenceFields, ['inputType', 'inputMin', 'inputMax', 'dataLabel', 'intelligentCall']).sort(),
  multitext: [].concat(basics, ['referStepId', 'referIds', 'mtext', 'intelligentCall']).sort(),
  multiselect: [].concat(basics, reusing, hasEvidenceFields, ['moptions', 'conditional_jump']).sort(),
  imageMultiselect: [].concat(basics, reusing, hasEvidenceFields, ['pictureMultipleOptions', 'conditional_jump']).sort(),
  select: [].concat(basics, hasEvidenceFields, ['clarity', 'videoDuration', 'recordDuration', 'evidenceQuality', 'evidenceType', 'imageRecognitionType', 'allowReusePhoto', 'allowCrossSubjectRecord', 'conditional_jump', 'options', 'dataLabel', 'reportedTablesAssociationStepId']).sort()
});

/***/ }),

/***/ 1738:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'stepId': '',
  'isPassed': '10',
  'errormessage': '',
  'comment': '',
  'textAnswer': '',
  'selectedOptionId': '',
  'mOptionIds': [],
  'pictureMultipleOptionIds': [],
  'mTextAnswer': {},
  'photos': [],
  'videos': [],
  'records': [],
  'qrcodes': []
});

/***/ }),

/***/ 1743:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1871);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("e8c64eb8", content, true, {});

/***/ }),

/***/ 1744:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1872);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("a2cfd9b8", content, true, {});

/***/ }),

/***/ 1745:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1746);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("44e9b56a", content, true, {});

/***/ }),

/***/ 1746:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionGuideVideo.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1747:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionFile_vue__ = __webpack_require__(1588);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dea17b98_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionFile_vue__ = __webpack_require__(1750);
function injectStyle (ssrContext) {
  __webpack_require__(1748)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionFile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dea17b98_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionFile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1748:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1749);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("69475599", content, true, {});

/***/ }),

/***/ 1749:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".sj-question-file{border-radius:4px;background-color:#fff;min-height:94px;border:1px solid #dcdfe6;-webkit-transition:border-color .2s cubic-bezier(.645,.045,.355,1);transition:border-color .2s cubic-bezier(.645,.045,.355,1)}.sj-question-file.disabled{background-color:#f5f7fa;border-color:#e4e7ed;color:#c0c4cc}.sj-question-file:hover{border-color:#c0c4cc}.sj-question-file:focus{border-color:#409eff}.sj-question-file>ul{margin:0;padding:0;list-style-type:none}.sj-question-file>ul li.sj-question-file-item{float:left;cursor:pointer;margin:10px;width:75px;height:75px}.sj-question-file>ul:after{content:\"\";display:block;clear:both}", "", {"version":3,"sources":["/workspace/src/views/question-editor/packages/sj-question-file/src/SjQuestionFile.vue"],"names":[],"mappings":"AACA,kBAAkB,kBAAkB,sBAAuB,gBAAgB,yBAAyB,mEAA0E,0DAAiE,CAC9O,AACD,2BAA2B,yBAAyB,qBAAqB,aAAa,CACrF,AACD,wBAAwB,oBAAoB,CAC3C,AACD,wBAAwB,oBAAoB,CAC3C,AACD,qBAAqB,SAAS,UAAU,oBAAoB,CAC3D,AACD,8CAA8C,WAAW,eAAe,YAAY,WAAW,WAAW,CACzG,AACD,2BAA4B,WAAW,cAAc,UAAU,CAC9D","file":"SjQuestionFile.vue","sourcesContent":["\n.sj-question-file{border-radius:4px;background-color:white;min-height:94px;border:1px solid #dcdfe6;-webkit-transition:border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);transition:border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1)\n}\n.sj-question-file.disabled{background-color:#f5f7fa;border-color:#e4e7ed;color:#c0c4cc\n}\n.sj-question-file:hover{border-color:#c0c4cc\n}\n.sj-question-file:focus{border-color:#409EFF\n}\n.sj-question-file>ul{margin:0;padding:0;list-style-type:none\n}\n.sj-question-file>ul li.sj-question-file-item{float:left;cursor:pointer;margin:10px;width:75px;height:75px\n}\n.sj-question-file>ul::after{content:\"\";display:block;clear:both\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1750:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['sj-question-file', _vm.disabled?'disabled':''],attrs:{"tabindex":"0"}},[_c('ul',[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1751:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionFileItem_vue__ = __webpack_require__(1589);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43260f76_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionFileItem_vue__ = __webpack_require__(1754);
function injectStyle (ssrContext) {
  __webpack_require__(1752)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionFileItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43260f76_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionFileItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1752:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1753);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("ca689d94", content, true, {});

/***/ }),

/***/ 1753:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".sj-question-file__item{position:relative}.sj-question-file__item.disabled{opacity:.75}.sj-question-file__item:hover{-webkit-box-shadow:0 0 10px rgba(0,0,0,.1);box-shadow:0 0 10px rgba(0,0,0,.1)}.sj-question-file__item.selected{margin:9px!important;border:1px solid #e6a23c}.sj-question-file__item .sj-question-file-item-poster{width:75px;height:75px;background-color:#f5f7fa;text-align:center}.sj-question-file__item .sj-question-file-item-poster img{display:block;width:75px;height:75px}.sj-question-file__item .sj-question-file-item-poster i{color:#dcdfe6;font-size:60px;line-height:75px}.sj-question-file__item .el-upload-list__item-actions{position:absolute;width:100%;height:100%;left:0;top:0;cursor:default;text-align:center;color:#fff;opacity:0;font-size:20px;background-color:rgba(0,0,0,.5);-webkit-transition:opacity .3s;transition:opacity .3s}.sj-question-file__item .el-upload-list__item-actions span{display:none;cursor:pointer}.sj-question-file__item .el-upload-list__item-actions span+span{margin-left:15px}.sj-question-file__item .el-upload-list__item-actions:hover{opacity:1}.sj-question-file__item .el-upload-list__item-actions:hover span{display:inline-block}.sj-question-file__item .el-upload-list__item-actions:after{display:inline-block;content:\"\";height:100%;vertical-align:middle}.sj-question-file__item .el-upload-list__item-delete{position:static;font-size:inherit;color:inherit}", "", {"version":3,"sources":["/workspace/src/views/question-editor/packages/sj-question-file/src/SjQuestionFileItem.vue"],"names":[],"mappings":"AACA,wBAAwB,iBAAiB,CACxC,AACD,iCAAiC,WAAY,CAC5C,AACD,8BAA8B,2CAA4C,kCAAmC,CAC5G,AACD,iCAAiC,qBAAsB,wBAAwB,CAC9E,AACD,sDAAsD,WAAW,YAAY,yBAAyB,iBAAiB,CACtH,AACD,0DAA0D,cAAc,WAAW,WAAW,CAC7F,AACD,wDAAwD,cAAc,eAAe,gBAAgB,CACpG,AACD,sDAAsD,kBAAkB,WAAW,YAAY,OAAO,MAAM,eAAe,kBAAkB,WAAW,UAAU,eAAe,gCAAiC,+BAA+B,sBAAsB,CACtQ,AACD,2DAA2D,aAAa,cAAc,CACrF,AACD,gEAAgE,gBAAgB,CAC/E,AACD,4DAA4D,SAAS,CACpE,AACD,iEAAiE,oBAAoB,CACpF,AACD,4DAA6D,qBAAqB,WAAW,YAAY,qBAAqB,CAC7H,AACD,qDAAqD,gBAAgB,kBAAkB,aAAa,CACnG","file":"SjQuestionFileItem.vue","sourcesContent":["\n.sj-question-file__item{position:relative\n}\n.sj-question-file__item.disabled{opacity:0.75\n}\n.sj-question-file__item:hover{-webkit-box-shadow:0 0 10px rgba(0,0,0,0.1);box-shadow:0 0 10px rgba(0,0,0,0.1)\n}\n.sj-question-file__item.selected{margin:9px !important;border:1px solid #E6A23C\n}\n.sj-question-file__item .sj-question-file-item-poster{width:75px;height:75px;background-color:#f5f7fa;text-align:center\n}\n.sj-question-file__item .sj-question-file-item-poster img{display:block;width:75px;height:75px\n}\n.sj-question-file__item .sj-question-file-item-poster i{color:#DCDFE6;font-size:60px;line-height:75px\n}\n.sj-question-file__item .el-upload-list__item-actions{position:absolute;width:100%;height:100%;left:0;top:0;cursor:default;text-align:center;color:#fff;opacity:0;font-size:20px;background-color:rgba(0,0,0,0.5);-webkit-transition:opacity .3s;transition:opacity .3s\n}\n.sj-question-file__item .el-upload-list__item-actions span{display:none;cursor:pointer\n}\n.sj-question-file__item .el-upload-list__item-actions span+span{margin-left:15px\n}\n.sj-question-file__item .el-upload-list__item-actions:hover{opacity:1\n}\n.sj-question-file__item .el-upload-list__item-actions:hover span{display:inline-block\n}\n.sj-question-file__item .el-upload-list__item-actions::after{display:inline-block;content:\"\";height:100%;vertical-align:middle\n}\n.sj-question-file__item .el-upload-list__item-delete{position:static;font-size:inherit;color:inherit\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1754:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:[
  'sj-question-file-item',
  'sj-question-file__item',
  _vm.disabled?'disabled':'',
  _vm.selected?'selected':''
  ]},[_c('div',{staticClass:"sj-question-file-item-poster"},[_vm._t("default",[(_vm.icon)?_c('i',{class:_vm.icon}):_c('img',{attrs:{"src":_vm._f("ossThumbnail")(_vm.poster,75, 'FFFFFF'),"alt":_vm.poster}})])],2),_vm._v(" "),(_vm.showHoverIcons)?_c('span',{staticClass:"el-upload-list__item-actions"},[_c('span',{staticClass:"el-upload-list__item-preview"},[_c('i',{staticClass:"el-icon-zoom-in",on:{"click":function($event){return _vm.$emit('view', this)}}})]),_vm._v(" "),(!_vm.disabled)?_c('span',{staticClass:"el-upload-list__item-delete"},[_c('i',{staticClass:"el-icon-delete",on:{"click":function($event){return _vm.$emit('remove', this)}}})]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1755:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionFileAdd_vue__ = __webpack_require__(1590);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4501a3c1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionFileAdd_vue__ = __webpack_require__(1758);
function injectStyle (ssrContext) {
  __webpack_require__(1756)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionFileAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4501a3c1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionFileAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1756:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1757);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6123a350", content, true, {});

/***/ }),

/***/ 1757:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".sj-question-file-add button{color:#e4e7ed;font-size:73px;padding:0}.sj-question-file-add button:hover{color:#c0c4cc}", "", {"version":3,"sources":["/workspace/src/views/question-editor/packages/sj-question-file/src/SjQuestionFileAdd.vue"],"names":[],"mappings":"AACA,6BAA6B,cAAc,eAAe,SAAS,CAClE,AACD,mCAAmC,aAAa,CAC/C","file":"SjQuestionFileAdd.vue","sourcesContent":["\n.sj-question-file-add button{color:#E4E7ED;font-size:73px;padding:0\n}\n.sj-question-file-add button:hover{color:#C0C4CC\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1758:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"sj-question-file-item sj-question-file-add"},[_vm._t("default",[_c('el-button',_vm._g({attrs:{"type":"text","icon":_vm.icon,"disabled":_vm.disabled}},_vm.$listeners))])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1759:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionFileProgress_vue__ = __webpack_require__(1592);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31272d2a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionFileProgress_vue__ = __webpack_require__(1762);
function injectStyle (ssrContext) {
  __webpack_require__(1760)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionFileProgress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31272d2a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionFileProgress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1760:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1761);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("10087862", content, true, {});

/***/ }),

/***/ 1761:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionFileProgress.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1762:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"sj-question-file-item sj-question-file-progress"},[_c('el-progress',_vm._g(_vm._b({attrs:{"type":"circle","width":75}},'el-progress',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1763:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"contextmenu":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onContextmenu($event)}}},[_c('sj-question-file',{attrs:{"disabled":_vm.disabled}},[_vm._l((_vm.progress),function(item,index){return _c('sj-question-file-progress',{key:'percentage' + index,attrs:{"percentage":item.percentage}})}),_vm._v(" "),_vm._l((_vm.files),function(file,index){return _c('sj-question-file-item',{key:'file' + index,attrs:{"poster":file.poster,"disabled":_vm.disabled,"show-hover-icons":_vm.showHoverIcons,"selected":_vm.checkedFiles.includes(file)},on:{"view":function($event){return _vm.view(file)},"remove":function($event){return _vm.remove(index)}},nativeOn:{"contextmenu":function($event){$event.preventDefault();$event.stopPropagation();return (function (event){_vm.onContextmenu(event, index)})($event)}}})}),_vm._v(" "),_c('el-tooltip',{attrs:{"effect":"dark","content":_vm.title,"placement":"top"}},[_c('sj-question-file-add',{attrs:{"disabled":_vm.disabled || _vm.files.length > 0},on:{"click":_vm.upload}})],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1764:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(42))(69);

/***/ }),

/***/ 1813:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return searchRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return infoRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return questionRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return questionOptionRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的分步模板ID', 'integer', 'blur', false), { min: 1 })]
};

var formRules = {};

var infoRules = {
  title: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请填写题目标题'))]
};

var questionRules = {
  title: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请填写题目标题'))],
  options: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请至少添加一个选项', 'array'))]
};
var questionOptionRules = {
  title: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请填写选项标题'))],
  images: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请上传图片', 'array'))]
};

/***/ }),

/***/ 1814:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1874), __esModule: true };

/***/ }),

/***/ 1815:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(1362);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),

/***/ 1816:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1876);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1583);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(1362);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),

/***/ 1817:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionGuideAudio_vue__ = __webpack_require__(1681);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10644990_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionGuideAudio_vue__ = __webpack_require__(1883);
function injectStyle (ssrContext) {
  __webpack_require__(1881)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10644990"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionGuideAudio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10644990_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionGuideAudio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1818:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main_js__ = __webpack_require__(1895);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main_js__["a" /* default */]);

/***/ }),

/***/ 1819:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main_js__ = __webpack_require__(1904);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main_js__["a" /* default */]);

/***/ }),

/***/ 1820:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main_js__ = __webpack_require__(1914);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main_js__["a" /* default */]);

/***/ }),

/***/ 1870:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__function__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__format_convert_fields_question__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__format_convert_fields_question_types__ = __webpack_require__(1615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_jump__ = __webpack_require__(2565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_refer__ = __webpack_require__(3424);







var questions = {
  number: 1,
  id: function id() {
    return 'Q' + Object(__WEBPACK_IMPORTED_MODULE_1__function__["c" /* dateNumber */])() + questions.number++;
  },
  make: function make(type) {
    var data = {};
    __WEBPACK_IMPORTED_MODULE_3__format_convert_fields_question_types__["a" /* default */][type].forEach(function (field) {
      data[field] = __WEBPACK_IMPORTED_MODULE_2__format_convert_fields_question__["a" /* default */][field];
    });
    data.id = this.id();
    data.type = type;
    return Object(__WEBPACK_IMPORTED_MODULE_1__function__["b" /* copyJson */])(data);
  },
  insert: function insert(questions, question) {
    var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    // 默认 index
    !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(index) && (index = questions.length);
    questions.splice(index, 0, question);
    return question;
  },
  create: function create(questions, type) {
    var toIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return this.insert(questions, this.make(type), toIndex);
  },
  up: function up(questions, index) {
    if (index) {
      // 交换位置
      return Object(__WEBPACK_IMPORTED_MODULE_1__function__["a" /* arraySwap */])(questions, index, index - 1);
    }
    return false;
  },
  down: function down(questions, index) {
    if (index < questions.length - 1) {
      // 交换位置
      return Object(__WEBPACK_IMPORTED_MODULE_1__function__["a" /* arraySwap */])(questions, index, index + 1);
    }
    return false;
  },
  remove: function remove(questions, index) {
    questions.splice(index, 1);
  },
  copy: function copy(questions, fromIndex, toIndex) {
    var newQuestion = Object(__WEBPACK_IMPORTED_MODULE_1__function__["b" /* copyJson */])(questions[fromIndex]);
    newQuestion.id = this.id();
    questions.splice(toIndex, 0, newQuestion);
    return newQuestion;
  },

  /**
   * 移除依赖这个题目的相关内容
   * @param questions
   * @param questionId
   */
  removeDependency: function removeDependency(questions, questionId) {
    questions.forEach(function (question) {
      if (question.id !== questionId) {
        // 逻辑跳转 ID清除
        if (__WEBPACK_IMPORTED_MODULE_4__utils_jump__["a" /* default */].get(question).includes(questionId)) {
          __WEBPACK_IMPORTED_MODULE_4__utils_jump__["a" /* default */].empty(question, questionId);
        }
        // 参考题目 ID清除
        if (__WEBPACK_IMPORTED_MODULE_5__utils_refer__["a" /* default */].get(question).includes(questionId)) {
          __WEBPACK_IMPORTED_MODULE_5__utils_refer__["a" /* default */].empty(question, questionId);
        }
      }
    });
  },

  /**
   * 移除全部题目中不存在的关联题目ID
   * @param questions
   */
  removeNonexistentTargetId: function removeNonexistentTargetId(questions) {
    var ids = questions.map(function (_ref) {
      var id = _ref.id;
      return id;
    });
    var remove = function remove(array) {
      array.forEach(function (value) {
        if (value.hasOwnProperty('jumpTargetId') && value.jumpTargetId !== 'end' && !ids.includes(value.jumpTargetId)) {
          value.jumpTargetId = '';
        }
        if (value.hasOwnProperty('referIds')) {
          var invalidIds = _.difference(value.referIds, ids);
          if (invalidIds.length) {
            value.referIds = _.difference(value.referIds, invalidIds);
          }
        }
        if (value.options) {
          remove(value.options);
        }
      });
    };
    remove(questions);
  },

  /**
   * 替换/重置单题题目的ID, 并且全部题目中关联ID也替换
   * @param array
   * @param oldId
   * @param newId
   */
  replaceId: function replaceId(array, oldId) {
    var _this = this;

    var newId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.id();

    array.forEach(function (value) {
      // 替换题目ID
      if (value.hasOwnProperty('id') && value.id === oldId) {
        value.id = newId;
      }
      // 替换跳转ID
      if (value.hasOwnProperty('jumpTargetId') && value.jumpTargetId === oldId) {
        value.jumpTargetId = newId;
      }
      // 替换参考ID
      if (value.hasOwnProperty('referIds') && value.referIds.includes(oldId)) {
        value.referIds.splice(value.referIds.indexOf(oldId), 1, newId);
      }
      // 替换选项内的跳转与参考ID
      if (value.hasOwnProperty('options')) {
        _this.replaceId(value.options, oldId, newId);
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (questions);

/***/ }),

/***/ 1871:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "/*!\n * Quill Editor v1.3.7\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */.ql-container{box-sizing:border-box;font-family:Helvetica,Arial,sans-serif;font-size:13px;height:100%;margin:0;position:relative}.ql-container.ql-disabled .ql-tooltip{visibility:hidden}.ql-container.ql-disabled .ql-editor ul[data-checked]>li:before{pointer-events:none}.ql-clipboard{left:-100000px;height:1px;overflow-y:hidden;position:absolute;top:50%}.ql-clipboard p{margin:0;padding:0}.ql-editor{box-sizing:border-box;line-height:1.42;height:100%;outline:none;overflow-y:auto;padding:12px 15px;tab-size:4;-moz-tab-size:4;text-align:left;white-space:pre-wrap;word-wrap:break-word}.ql-editor>*{cursor:text}.ql-editor blockquote,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6,.ql-editor ol,.ql-editor p,.ql-editor pre,.ql-editor ul{margin:0;padding:0;counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol,.ql-editor ul{padding-left:1.5em}.ql-editor ol>li,.ql-editor ul>li{list-style-type:none}.ql-editor ul>li:before{content:\"\\2022\"}.ql-editor ul[data-checked=false],.ql-editor ul[data-checked=true]{pointer-events:none}.ql-editor ul[data-checked=false]>li *,.ql-editor ul[data-checked=true]>li *{pointer-events:all}.ql-editor ul[data-checked=false]>li:before,.ql-editor ul[data-checked=true]>li:before{color:#777;cursor:pointer;pointer-events:all}.ql-editor ul[data-checked=true]>li:before{content:\"\\2611\"}.ql-editor ul[data-checked=false]>li:before{content:\"\\2610\"}.ql-editor li:before{display:inline-block;white-space:nowrap;width:1.2em}.ql-editor li:not(.ql-direction-rtl):before{margin-left:-1.5em;margin-right:.3em;text-align:right}.ql-editor li.ql-direction-rtl:before{margin-left:.3em;margin-right:-1.5em}.ql-editor ol li:not(.ql-direction-rtl),.ql-editor ul li:not(.ql-direction-rtl){padding-left:1.5em}.ql-editor ol li.ql-direction-rtl,.ql-editor ul li.ql-direction-rtl{padding-right:1.5em}.ql-editor ol li{counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;counter-increment:list-0}.ql-editor ol li:before{content:counter(list-0,decimal) \". \"}.ql-editor ol li.ql-indent-1{counter-increment:list-1}.ql-editor ol li.ql-indent-1:before{content:counter(list-1,lower-alpha) \". \"}.ql-editor ol li.ql-indent-1{counter-reset:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-2{counter-increment:list-2}.ql-editor ol li.ql-indent-2:before{content:counter(list-2,lower-roman) \". \"}.ql-editor ol li.ql-indent-2{counter-reset:list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-3{counter-increment:list-3}.ql-editor ol li.ql-indent-3:before{content:counter(list-3,decimal) \". \"}.ql-editor ol li.ql-indent-3{counter-reset:list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-4{counter-increment:list-4}.ql-editor ol li.ql-indent-4:before{content:counter(list-4,lower-alpha) \". \"}.ql-editor ol li.ql-indent-4{counter-reset:list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-5{counter-increment:list-5}.ql-editor ol li.ql-indent-5:before{content:counter(list-5,lower-roman) \". \"}.ql-editor ol li.ql-indent-5{counter-reset:list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-6{counter-increment:list-6}.ql-editor ol li.ql-indent-6:before{content:counter(list-6,decimal) \". \"}.ql-editor ol li.ql-indent-6{counter-reset:list-7 list-8 list-9}.ql-editor ol li.ql-indent-7{counter-increment:list-7}.ql-editor ol li.ql-indent-7:before{content:counter(list-7,lower-alpha) \". \"}.ql-editor ol li.ql-indent-7{counter-reset:list-8 list-9}.ql-editor ol li.ql-indent-8{counter-increment:list-8}.ql-editor ol li.ql-indent-8:before{content:counter(list-8,lower-roman) \". \"}.ql-editor ol li.ql-indent-8{counter-reset:list-9}.ql-editor ol li.ql-indent-9{counter-increment:list-9}.ql-editor ol li.ql-indent-9:before{content:counter(list-9,decimal) \". \"}.ql-editor .ql-indent-1:not(.ql-direction-rtl){padding-left:3em}.ql-editor li.ql-indent-1:not(.ql-direction-rtl){padding-left:4.5em}.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:3em}.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:4.5em}.ql-editor .ql-indent-2:not(.ql-direction-rtl){padding-left:6em}.ql-editor li.ql-indent-2:not(.ql-direction-rtl){padding-left:7.5em}.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:6em}.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:7.5em}.ql-editor .ql-indent-3:not(.ql-direction-rtl){padding-left:9em}.ql-editor li.ql-indent-3:not(.ql-direction-rtl){padding-left:10.5em}.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:9em}.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:10.5em}.ql-editor .ql-indent-4:not(.ql-direction-rtl){padding-left:12em}.ql-editor li.ql-indent-4:not(.ql-direction-rtl){padding-left:13.5em}.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:12em}.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:13.5em}.ql-editor .ql-indent-5:not(.ql-direction-rtl){padding-left:15em}.ql-editor li.ql-indent-5:not(.ql-direction-rtl){padding-left:16.5em}.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:15em}.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:16.5em}.ql-editor .ql-indent-6:not(.ql-direction-rtl){padding-left:18em}.ql-editor li.ql-indent-6:not(.ql-direction-rtl){padding-left:19.5em}.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:18em}.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:19.5em}.ql-editor .ql-indent-7:not(.ql-direction-rtl){padding-left:21em}.ql-editor li.ql-indent-7:not(.ql-direction-rtl){padding-left:22.5em}.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:21em}.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:22.5em}.ql-editor .ql-indent-8:not(.ql-direction-rtl){padding-left:24em}.ql-editor li.ql-indent-8:not(.ql-direction-rtl){padding-left:25.5em}.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:24em}.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:25.5em}.ql-editor .ql-indent-9:not(.ql-direction-rtl){padding-left:27em}.ql-editor li.ql-indent-9:not(.ql-direction-rtl){padding-left:28.5em}.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:27em}.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:28.5em}.ql-editor .ql-video{display:block;max-width:100%}.ql-editor .ql-video.ql-align-center{margin:0 auto}.ql-editor .ql-video.ql-align-right{margin:0 0 0 auto}.ql-editor .ql-bg-black{background-color:#000}.ql-editor .ql-bg-red{background-color:#e60000}.ql-editor .ql-bg-orange{background-color:#f90}.ql-editor .ql-bg-yellow{background-color:#ff0}.ql-editor .ql-bg-green{background-color:#008a00}.ql-editor .ql-bg-blue{background-color:#06c}.ql-editor .ql-bg-purple{background-color:#93f}.ql-editor .ql-color-white{color:#fff}.ql-editor .ql-color-red{color:#e60000}.ql-editor .ql-color-orange{color:#f90}.ql-editor .ql-color-yellow{color:#ff0}.ql-editor .ql-color-green{color:#008a00}.ql-editor .ql-color-blue{color:#06c}.ql-editor .ql-color-purple{color:#93f}.ql-editor .ql-font-serif{font-family:Georgia,Times New Roman,serif}.ql-editor .ql-font-monospace{font-family:Monaco,Courier New,monospace}.ql-editor .ql-size-small{font-size:.75em}.ql-editor .ql-size-large{font-size:1.5em}.ql-editor .ql-size-huge{font-size:2.5em}.ql-editor .ql-direction-rtl{direction:rtl;text-align:inherit}.ql-editor .ql-align-center{text-align:center}.ql-editor .ql-align-justify{text-align:justify}.ql-editor .ql-align-right{text-align:right}.ql-editor.ql-blank:before{color:rgba(0,0,0,.6);content:attr(data-placeholder);font-style:italic;left:15px;pointer-events:none;position:absolute;right:15px}", "", {"version":3,"sources":["/workspace/node_modules/quill/dist/quill.core.css"],"names":[],"mappings":"AAAA;;;;;GAKG,AACH,cACE,sBAAuB,AACvB,uCAA0C,AAC1C,eAAgB,AAChB,YAAa,AACb,SAAY,AACZ,iBAAmB,CACpB,AACD,sCACE,iBAAmB,CACpB,AACD,gEACE,mBAAqB,CACtB,AACD,cACE,eAAgB,AAChB,WAAY,AACZ,kBAAmB,AACnB,kBAAmB,AACnB,OAAS,CACV,AACD,gBACE,SAAU,AACV,SAAW,CACZ,AACD,WACE,sBAAuB,AACvB,iBAAkB,AAClB,YAAa,AACb,aAAc,AACd,gBAAiB,AACjB,kBAAmB,AACnB,WAAY,AACZ,gBAAiB,AACjB,gBAAiB,AACjB,qBAAsB,AACtB,oBAAsB,CACvB,AACD,aACE,WAAa,CACd,AACD,kKAWE,SAAU,AACV,UAAW,AACX,4EAA8E,CAC/E,AACD,4BAEE,kBAAoB,CACrB,AACD,kCAEE,oBAAsB,CACvB,AACD,wBACE,eAAiB,CAClB,AACD,mEAEE,mBAAqB,CACtB,AACD,6EAEE,kBAAoB,CACrB,AACD,uFAEE,WAAY,AACZ,eAAgB,AAChB,kBAAoB,CACrB,AACD,2CACE,eAAiB,CAClB,AACD,4CACE,eAAiB,CAClB,AACD,qBACE,qBAAsB,AACtB,mBAAoB,AACpB,WAAa,CACd,AACD,4CACE,mBAAoB,AACpB,kBAAoB,AACpB,gBAAkB,CACnB,AACD,sCACE,iBAAmB,AACnB,mBAAqB,CACtB,AACD,gFAEE,kBAAoB,CACrB,AACD,oEAEE,mBAAqB,CACtB,AACD,iBACE,6EAA8E,AAC9E,wBAA0B,CAC3B,AACD,wBACE,oCAAuC,CACxC,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,qEAAuE,CACxE,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,8DAAgE,CACjE,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,oCAAuC,CACxC,AACD,6BACE,uDAAyD,CAC1D,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,gDAAkD,CACnD,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,yCAA2C,CAC5C,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,oCAAuC,CACxC,AACD,6BACE,kCAAoC,CACrC,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,2BAA6B,CAC9B,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,oBAAsB,CACvB,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,oCAAuC,CACxC,AACD,+CACE,gBAAkB,CACnB,AACD,iDACE,kBAAoB,CACrB,AACD,wDACE,iBAAmB,CACpB,AACD,0DACE,mBAAqB,CACtB,AACD,+CACE,gBAAkB,CACnB,AACD,iDACE,kBAAoB,CACrB,AACD,wDACE,iBAAmB,CACpB,AACD,0DACE,mBAAqB,CACtB,AACD,+CACE,gBAAkB,CACnB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,iBAAmB,CACpB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,qBACE,cAAe,AACf,cAAgB,CACjB,AACD,qCACE,aAAe,CAChB,AACD,oCACE,iBAAmB,CACpB,AACD,wBACE,qBAAuB,CACxB,AACD,sBACE,wBAA0B,CAC3B,AACD,yBACE,qBAAuB,CACxB,AACD,yBACE,qBAAuB,CACxB,AACD,wBACE,wBAA0B,CAC3B,AACD,uBACE,qBAAuB,CACxB,AACD,yBACE,qBAAuB,CACxB,AACD,2BACE,UAAY,CACb,AACD,yBACE,aAAe,CAChB,AACD,4BACE,UAAY,CACb,AACD,4BACE,UAAY,CACb,AACD,2BACE,aAAe,CAChB,AACD,0BACE,UAAY,CACb,AACD,4BACE,UAAY,CACb,AACD,0BACE,yCAA6C,CAC9C,AACD,8BACE,wCAA4C,CAC7C,AACD,0BACE,eAAkB,CACnB,AACD,0BACE,eAAiB,CAClB,AACD,yBACE,eAAiB,CAClB,AACD,6BACE,cAAe,AACf,kBAAoB,CACrB,AACD,4BACE,iBAAmB,CACpB,AACD,6BACE,kBAAoB,CACrB,AACD,2BACE,gBAAkB,CACnB,AACD,2BACE,qBAAuB,AACvB,+BAAgC,AAChC,kBAAmB,AACnB,UAAW,AACX,oBAAqB,AACrB,kBAAmB,AACnB,UAAY,CACb","file":"quill.core.css","sourcesContent":["/*!\n * Quill Editor v1.3.7\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */\n.ql-container {\n  box-sizing: border-box;\n  font-family: Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  height: 100%;\n  margin: 0px;\n  position: relative;\n}\n.ql-container.ql-disabled .ql-tooltip {\n  visibility: hidden;\n}\n.ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {\n  pointer-events: none;\n}\n.ql-clipboard {\n  left: -100000px;\n  height: 1px;\n  overflow-y: hidden;\n  position: absolute;\n  top: 50%;\n}\n.ql-clipboard p {\n  margin: 0;\n  padding: 0;\n}\n.ql-editor {\n  box-sizing: border-box;\n  line-height: 1.42;\n  height: 100%;\n  outline: none;\n  overflow-y: auto;\n  padding: 12px 15px;\n  tab-size: 4;\n  -moz-tab-size: 4;\n  text-align: left;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n.ql-editor > * {\n  cursor: text;\n}\n.ql-editor p,\n.ql-editor ol,\n.ql-editor ul,\n.ql-editor pre,\n.ql-editor blockquote,\n.ql-editor h1,\n.ql-editor h2,\n.ql-editor h3,\n.ql-editor h4,\n.ql-editor h5,\n.ql-editor h6 {\n  margin: 0;\n  padding: 0;\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol,\n.ql-editor ul {\n  padding-left: 1.5em;\n}\n.ql-editor ol > li,\n.ql-editor ul > li {\n  list-style-type: none;\n}\n.ql-editor ul > li::before {\n  content: '\\2022';\n}\n.ql-editor ul[data-checked=true],\n.ql-editor ul[data-checked=false] {\n  pointer-events: none;\n}\n.ql-editor ul[data-checked=true] > li *,\n.ql-editor ul[data-checked=false] > li * {\n  pointer-events: all;\n}\n.ql-editor ul[data-checked=true] > li::before,\n.ql-editor ul[data-checked=false] > li::before {\n  color: #777;\n  cursor: pointer;\n  pointer-events: all;\n}\n.ql-editor ul[data-checked=true] > li::before {\n  content: '\\2611';\n}\n.ql-editor ul[data-checked=false] > li::before {\n  content: '\\2610';\n}\n.ql-editor li::before {\n  display: inline-block;\n  white-space: nowrap;\n  width: 1.2em;\n}\n.ql-editor li:not(.ql-direction-rtl)::before {\n  margin-left: -1.5em;\n  margin-right: 0.3em;\n  text-align: right;\n}\n.ql-editor li.ql-direction-rtl::before {\n  margin-left: 0.3em;\n  margin-right: -1.5em;\n}\n.ql-editor ol li:not(.ql-direction-rtl),\n.ql-editor ul li:not(.ql-direction-rtl) {\n  padding-left: 1.5em;\n}\n.ql-editor ol li.ql-direction-rtl,\n.ql-editor ul li.ql-direction-rtl {\n  padding-right: 1.5em;\n}\n.ql-editor ol li {\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  counter-increment: list-0;\n}\n.ql-editor ol li:before {\n  content: counter(list-0, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n  counter-increment: list-1;\n}\n.ql-editor ol li.ql-indent-1:before {\n  content: counter(list-1, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-2 {\n  counter-increment: list-2;\n}\n.ql-editor ol li.ql-indent-2:before {\n  content: counter(list-2, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-2 {\n  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-3 {\n  counter-increment: list-3;\n}\n.ql-editor ol li.ql-indent-3:before {\n  content: counter(list-3, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-3 {\n  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-4 {\n  counter-increment: list-4;\n}\n.ql-editor ol li.ql-indent-4:before {\n  content: counter(list-4, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-4 {\n  counter-reset: list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-5 {\n  counter-increment: list-5;\n}\n.ql-editor ol li.ql-indent-5:before {\n  content: counter(list-5, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-5 {\n  counter-reset: list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-6 {\n  counter-increment: list-6;\n}\n.ql-editor ol li.ql-indent-6:before {\n  content: counter(list-6, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-6 {\n  counter-reset: list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-7 {\n  counter-increment: list-7;\n}\n.ql-editor ol li.ql-indent-7:before {\n  content: counter(list-7, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-7 {\n  counter-reset: list-8 list-9;\n}\n.ql-editor ol li.ql-indent-8 {\n  counter-increment: list-8;\n}\n.ql-editor ol li.ql-indent-8:before {\n  content: counter(list-8, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-8 {\n  counter-reset: list-9;\n}\n.ql-editor ol li.ql-indent-9 {\n  counter-increment: list-9;\n}\n.ql-editor ol li.ql-indent-9:before {\n  content: counter(list-9, decimal) '. ';\n}\n.ql-editor .ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 3em;\n}\n.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 4.5em;\n}\n.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 3em;\n}\n.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 4.5em;\n}\n.ql-editor .ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 6em;\n}\n.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 7.5em;\n}\n.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 6em;\n}\n.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 7.5em;\n}\n.ql-editor .ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 9em;\n}\n.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 10.5em;\n}\n.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 9em;\n}\n.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 10.5em;\n}\n.ql-editor .ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 12em;\n}\n.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 13.5em;\n}\n.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 12em;\n}\n.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 13.5em;\n}\n.ql-editor .ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 15em;\n}\n.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 16.5em;\n}\n.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 15em;\n}\n.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 16.5em;\n}\n.ql-editor .ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 18em;\n}\n.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 19.5em;\n}\n.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 18em;\n}\n.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 19.5em;\n}\n.ql-editor .ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 21em;\n}\n.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 22.5em;\n}\n.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 21em;\n}\n.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 22.5em;\n}\n.ql-editor .ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 24em;\n}\n.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 25.5em;\n}\n.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 24em;\n}\n.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 25.5em;\n}\n.ql-editor .ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 27em;\n}\n.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 28.5em;\n}\n.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 27em;\n}\n.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 28.5em;\n}\n.ql-editor .ql-video {\n  display: block;\n  max-width: 100%;\n}\n.ql-editor .ql-video.ql-align-center {\n  margin: 0 auto;\n}\n.ql-editor .ql-video.ql-align-right {\n  margin: 0 0 0 auto;\n}\n.ql-editor .ql-bg-black {\n  background-color: #000;\n}\n.ql-editor .ql-bg-red {\n  background-color: #e60000;\n}\n.ql-editor .ql-bg-orange {\n  background-color: #f90;\n}\n.ql-editor .ql-bg-yellow {\n  background-color: #ff0;\n}\n.ql-editor .ql-bg-green {\n  background-color: #008a00;\n}\n.ql-editor .ql-bg-blue {\n  background-color: #06c;\n}\n.ql-editor .ql-bg-purple {\n  background-color: #93f;\n}\n.ql-editor .ql-color-white {\n  color: #fff;\n}\n.ql-editor .ql-color-red {\n  color: #e60000;\n}\n.ql-editor .ql-color-orange {\n  color: #f90;\n}\n.ql-editor .ql-color-yellow {\n  color: #ff0;\n}\n.ql-editor .ql-color-green {\n  color: #008a00;\n}\n.ql-editor .ql-color-blue {\n  color: #06c;\n}\n.ql-editor .ql-color-purple {\n  color: #93f;\n}\n.ql-editor .ql-font-serif {\n  font-family: Georgia, Times New Roman, serif;\n}\n.ql-editor .ql-font-monospace {\n  font-family: Monaco, Courier New, monospace;\n}\n.ql-editor .ql-size-small {\n  font-size: 0.75em;\n}\n.ql-editor .ql-size-large {\n  font-size: 1.5em;\n}\n.ql-editor .ql-size-huge {\n  font-size: 2.5em;\n}\n.ql-editor .ql-direction-rtl {\n  direction: rtl;\n  text-align: inherit;\n}\n.ql-editor .ql-align-center {\n  text-align: center;\n}\n.ql-editor .ql-align-justify {\n  text-align: justify;\n}\n.ql-editor .ql-align-right {\n  text-align: right;\n}\n.ql-editor.ql-blank::before {\n  color: rgba(0,0,0,0.6);\n  content: attr(data-placeholder);\n  font-style: italic;\n  left: 15px;\n  pointer-events: none;\n  position: absolute;\n  right: 15px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1872:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "/*!\n * Quill Editor v1.3.7\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */.ql-container{box-sizing:border-box;font-family:Helvetica,Arial,sans-serif;font-size:13px;height:100%;margin:0;position:relative}.ql-container.ql-disabled .ql-tooltip{visibility:hidden}.ql-container.ql-disabled .ql-editor ul[data-checked]>li:before{pointer-events:none}.ql-clipboard{left:-100000px;height:1px;overflow-y:hidden;position:absolute;top:50%}.ql-clipboard p{margin:0;padding:0}.ql-editor{box-sizing:border-box;line-height:1.42;height:100%;outline:none;overflow-y:auto;padding:12px 15px;tab-size:4;-moz-tab-size:4;text-align:left;white-space:pre-wrap;word-wrap:break-word}.ql-editor>*{cursor:text}.ql-editor blockquote,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6,.ql-editor ol,.ql-editor p,.ql-editor pre,.ql-editor ul{margin:0;padding:0;counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol,.ql-editor ul{padding-left:1.5em}.ql-editor ol>li,.ql-editor ul>li{list-style-type:none}.ql-editor ul>li:before{content:\"\\2022\"}.ql-editor ul[data-checked=false],.ql-editor ul[data-checked=true]{pointer-events:none}.ql-editor ul[data-checked=false]>li *,.ql-editor ul[data-checked=true]>li *{pointer-events:all}.ql-editor ul[data-checked=false]>li:before,.ql-editor ul[data-checked=true]>li:before{color:#777;cursor:pointer;pointer-events:all}.ql-editor ul[data-checked=true]>li:before{content:\"\\2611\"}.ql-editor ul[data-checked=false]>li:before{content:\"\\2610\"}.ql-editor li:before{display:inline-block;white-space:nowrap;width:1.2em}.ql-editor li:not(.ql-direction-rtl):before{margin-left:-1.5em;margin-right:.3em;text-align:right}.ql-editor li.ql-direction-rtl:before{margin-left:.3em;margin-right:-1.5em}.ql-editor ol li:not(.ql-direction-rtl),.ql-editor ul li:not(.ql-direction-rtl){padding-left:1.5em}.ql-editor ol li.ql-direction-rtl,.ql-editor ul li.ql-direction-rtl{padding-right:1.5em}.ql-editor ol li{counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;counter-increment:list-0}.ql-editor ol li:before{content:counter(list-0,decimal) \". \"}.ql-editor ol li.ql-indent-1{counter-increment:list-1}.ql-editor ol li.ql-indent-1:before{content:counter(list-1,lower-alpha) \". \"}.ql-editor ol li.ql-indent-1{counter-reset:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-2{counter-increment:list-2}.ql-editor ol li.ql-indent-2:before{content:counter(list-2,lower-roman) \". \"}.ql-editor ol li.ql-indent-2{counter-reset:list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-3{counter-increment:list-3}.ql-editor ol li.ql-indent-3:before{content:counter(list-3,decimal) \". \"}.ql-editor ol li.ql-indent-3{counter-reset:list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-4{counter-increment:list-4}.ql-editor ol li.ql-indent-4:before{content:counter(list-4,lower-alpha) \". \"}.ql-editor ol li.ql-indent-4{counter-reset:list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-5{counter-increment:list-5}.ql-editor ol li.ql-indent-5:before{content:counter(list-5,lower-roman) \". \"}.ql-editor ol li.ql-indent-5{counter-reset:list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-6{counter-increment:list-6}.ql-editor ol li.ql-indent-6:before{content:counter(list-6,decimal) \". \"}.ql-editor ol li.ql-indent-6{counter-reset:list-7 list-8 list-9}.ql-editor ol li.ql-indent-7{counter-increment:list-7}.ql-editor ol li.ql-indent-7:before{content:counter(list-7,lower-alpha) \". \"}.ql-editor ol li.ql-indent-7{counter-reset:list-8 list-9}.ql-editor ol li.ql-indent-8{counter-increment:list-8}.ql-editor ol li.ql-indent-8:before{content:counter(list-8,lower-roman) \". \"}.ql-editor ol li.ql-indent-8{counter-reset:list-9}.ql-editor ol li.ql-indent-9{counter-increment:list-9}.ql-editor ol li.ql-indent-9:before{content:counter(list-9,decimal) \". \"}.ql-editor .ql-indent-1:not(.ql-direction-rtl){padding-left:3em}.ql-editor li.ql-indent-1:not(.ql-direction-rtl){padding-left:4.5em}.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:3em}.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:4.5em}.ql-editor .ql-indent-2:not(.ql-direction-rtl){padding-left:6em}.ql-editor li.ql-indent-2:not(.ql-direction-rtl){padding-left:7.5em}.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:6em}.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:7.5em}.ql-editor .ql-indent-3:not(.ql-direction-rtl){padding-left:9em}.ql-editor li.ql-indent-3:not(.ql-direction-rtl){padding-left:10.5em}.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:9em}.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:10.5em}.ql-editor .ql-indent-4:not(.ql-direction-rtl){padding-left:12em}.ql-editor li.ql-indent-4:not(.ql-direction-rtl){padding-left:13.5em}.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:12em}.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:13.5em}.ql-editor .ql-indent-5:not(.ql-direction-rtl){padding-left:15em}.ql-editor li.ql-indent-5:not(.ql-direction-rtl){padding-left:16.5em}.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:15em}.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:16.5em}.ql-editor .ql-indent-6:not(.ql-direction-rtl){padding-left:18em}.ql-editor li.ql-indent-6:not(.ql-direction-rtl){padding-left:19.5em}.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:18em}.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:19.5em}.ql-editor .ql-indent-7:not(.ql-direction-rtl){padding-left:21em}.ql-editor li.ql-indent-7:not(.ql-direction-rtl){padding-left:22.5em}.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:21em}.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:22.5em}.ql-editor .ql-indent-8:not(.ql-direction-rtl){padding-left:24em}.ql-editor li.ql-indent-8:not(.ql-direction-rtl){padding-left:25.5em}.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:24em}.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:25.5em}.ql-editor .ql-indent-9:not(.ql-direction-rtl){padding-left:27em}.ql-editor li.ql-indent-9:not(.ql-direction-rtl){padding-left:28.5em}.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:27em}.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:28.5em}.ql-editor .ql-video{display:block;max-width:100%}.ql-editor .ql-video.ql-align-center{margin:0 auto}.ql-editor .ql-video.ql-align-right{margin:0 0 0 auto}.ql-editor .ql-bg-black{background-color:#000}.ql-editor .ql-bg-red{background-color:#e60000}.ql-editor .ql-bg-orange{background-color:#f90}.ql-editor .ql-bg-yellow{background-color:#ff0}.ql-editor .ql-bg-green{background-color:#008a00}.ql-editor .ql-bg-blue{background-color:#06c}.ql-editor .ql-bg-purple{background-color:#93f}.ql-editor .ql-color-white{color:#fff}.ql-editor .ql-color-red{color:#e60000}.ql-editor .ql-color-orange{color:#f90}.ql-editor .ql-color-yellow{color:#ff0}.ql-editor .ql-color-green{color:#008a00}.ql-editor .ql-color-blue{color:#06c}.ql-editor .ql-color-purple{color:#93f}.ql-editor .ql-font-serif{font-family:Georgia,Times New Roman,serif}.ql-editor .ql-font-monospace{font-family:Monaco,Courier New,monospace}.ql-editor .ql-size-small{font-size:.75em}.ql-editor .ql-size-large{font-size:1.5em}.ql-editor .ql-size-huge{font-size:2.5em}.ql-editor .ql-direction-rtl{direction:rtl;text-align:inherit}.ql-editor .ql-align-center{text-align:center}.ql-editor .ql-align-justify{text-align:justify}.ql-editor .ql-align-right{text-align:right}.ql-editor.ql-blank:before{color:rgba(0,0,0,.6);content:attr(data-placeholder);font-style:italic;left:15px;pointer-events:none;position:absolute;right:15px}.ql-snow.ql-toolbar:after,.ql-snow .ql-toolbar:after{clear:both;content:\"\";display:table}.ql-snow.ql-toolbar button,.ql-snow .ql-toolbar button{background:none;border:none;cursor:pointer;display:inline-block;float:left;height:24px;padding:3px 5px;width:28px}.ql-snow.ql-toolbar button svg,.ql-snow .ql-toolbar button svg{float:left;height:100%}.ql-snow.ql-toolbar button:active:hover,.ql-snow .ql-toolbar button:active:hover{outline:none}.ql-snow.ql-toolbar input.ql-image[type=file],.ql-snow .ql-toolbar input.ql-image[type=file]{display:none}.ql-snow.ql-toolbar .ql-picker-item.ql-selected,.ql-snow .ql-toolbar .ql-picker-item.ql-selected,.ql-snow.ql-toolbar .ql-picker-item:hover,.ql-snow .ql-toolbar .ql-picker-item:hover,.ql-snow.ql-toolbar .ql-picker-label.ql-active,.ql-snow .ql-toolbar .ql-picker-label.ql-active,.ql-snow.ql-toolbar .ql-picker-label:hover,.ql-snow .ql-toolbar .ql-picker-label:hover,.ql-snow.ql-toolbar button.ql-active,.ql-snow .ql-toolbar button.ql-active,.ql-snow.ql-toolbar button:focus,.ql-snow .ql-toolbar button:focus,.ql-snow.ql-toolbar button:hover,.ql-snow .ql-toolbar button:hover{color:#06c}.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar button.ql-active .ql-fill,.ql-snow .ql-toolbar button.ql-active .ql-fill,.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-snow.ql-toolbar button:focus .ql-fill,.ql-snow .ql-toolbar button:focus .ql-fill,.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,.ql-snow.ql-toolbar button:hover .ql-fill,.ql-snow .ql-toolbar button:hover .ql-fill,.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill{fill:#06c}.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-snow.ql-toolbar button.ql-active .ql-stroke,.ql-snow .ql-toolbar button.ql-active .ql-stroke,.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,.ql-snow.ql-toolbar button:focus .ql-stroke,.ql-snow .ql-toolbar button:focus .ql-stroke,.ql-snow.ql-toolbar button:focus .ql-stroke-miter,.ql-snow .ql-toolbar button:focus .ql-stroke-miter,.ql-snow.ql-toolbar button:hover .ql-stroke,.ql-snow .ql-toolbar button:hover .ql-stroke,.ql-snow.ql-toolbar button:hover .ql-stroke-miter,.ql-snow .ql-toolbar button:hover .ql-stroke-miter{stroke:#06c}@media (pointer:coarse){.ql-snow.ql-toolbar button:hover:not(.ql-active),.ql-snow .ql-toolbar button:hover:not(.ql-active){color:#444}.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill{fill:#444}.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter{stroke:#444}}.ql-snow,.ql-snow *{box-sizing:border-box}.ql-snow .ql-hidden{display:none}.ql-snow .ql-out-bottom,.ql-snow .ql-out-top{visibility:hidden}.ql-snow .ql-tooltip{position:absolute;transform:translateY(10px)}.ql-snow .ql-tooltip a{cursor:pointer;text-decoration:none}.ql-snow .ql-tooltip.ql-flip{transform:translateY(-10px)}.ql-snow .ql-formats{display:inline-block;vertical-align:middle}.ql-snow .ql-formats:after{clear:both;content:\"\";display:table}.ql-snow .ql-stroke{fill:none;stroke:#444;stroke-linecap:round;stroke-linejoin:round;stroke-width:2}.ql-snow .ql-stroke-miter{fill:none;stroke:#444;stroke-miterlimit:10;stroke-width:2}.ql-snow .ql-fill,.ql-snow .ql-stroke.ql-fill{fill:#444}.ql-snow .ql-empty{fill:none}.ql-snow .ql-even{fill-rule:evenodd}.ql-snow .ql-stroke.ql-thin,.ql-snow .ql-thin{stroke-width:1}.ql-snow .ql-transparent{opacity:.4}.ql-snow .ql-direction svg:last-child{display:none}.ql-snow .ql-direction.ql-active svg:last-child{display:inline}.ql-snow .ql-direction.ql-active svg:first-child{display:none}.ql-snow .ql-editor h1{font-size:2em}.ql-snow .ql-editor h2{font-size:1.5em}.ql-snow .ql-editor h3{font-size:1.17em}.ql-snow .ql-editor h4{font-size:1em}.ql-snow .ql-editor h5{font-size:.83em}.ql-snow .ql-editor h6{font-size:.67em}.ql-snow .ql-editor a{text-decoration:underline}.ql-snow .ql-editor blockquote{border-left:4px solid #ccc;margin-bottom:5px;margin-top:5px;padding-left:16px}.ql-snow .ql-editor code,.ql-snow .ql-editor pre{background-color:#f0f0f0;border-radius:3px}.ql-snow .ql-editor pre{white-space:pre-wrap;margin-bottom:5px;margin-top:5px;padding:5px 10px}.ql-snow .ql-editor code{font-size:85%;padding:2px 4px}.ql-snow .ql-editor pre.ql-syntax{background-color:#23241f;color:#f8f8f2;overflow:visible}.ql-snow .ql-editor img{max-width:100%}.ql-snow .ql-picker{color:#444;display:inline-block;float:left;font-size:14px;font-weight:500;height:24px;position:relative;vertical-align:middle}.ql-snow .ql-picker-label{cursor:pointer;display:inline-block;height:100%;padding-left:8px;padding-right:2px;position:relative;width:100%}.ql-snow .ql-picker-label:before{display:inline-block;line-height:22px}.ql-snow .ql-picker-options{background-color:#fff;display:none;min-width:100%;padding:4px 8px;position:absolute;white-space:nowrap}.ql-snow .ql-picker-options .ql-picker-item{cursor:pointer;display:block;padding-bottom:5px;padding-top:5px}.ql-snow .ql-picker.ql-expanded .ql-picker-label{color:#ccc;z-index:2}.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill{fill:#ccc}.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke{stroke:#ccc}.ql-snow .ql-picker.ql-expanded .ql-picker-options{display:block;margin-top:-1px;top:100%;z-index:1}.ql-snow .ql-color-picker,.ql-snow .ql-icon-picker{width:28px}.ql-snow .ql-color-picker .ql-picker-label,.ql-snow .ql-icon-picker .ql-picker-label{padding:2px 4px}.ql-snow .ql-color-picker .ql-picker-label svg,.ql-snow .ql-icon-picker .ql-picker-label svg{right:4px}.ql-snow .ql-icon-picker .ql-picker-options{padding:4px 0}.ql-snow .ql-icon-picker .ql-picker-item{height:24px;width:24px;padding:2px 4px}.ql-snow .ql-color-picker .ql-picker-options{padding:3px 5px;width:152px}.ql-snow .ql-color-picker .ql-picker-item{border:1px solid transparent;float:left;height:16px;margin:2px;padding:0;width:16px}.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg{position:absolute;margin-top:-9px;right:0;top:50%;width:18px}.ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=\"\"]):before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=\"\"]):before,.ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=\"\"]):before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=\"\"]):before,.ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=\"\"]):before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=\"\"]):before{content:attr(data-label)}.ql-snow .ql-picker.ql-header{width:98px}.ql-snow .ql-picker.ql-header .ql-picker-item:before,.ql-snow .ql-picker.ql-header .ql-picker-label:before{content:\"Normal\"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"1\"]:before{content:\"Heading 1\"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"2\"]:before{content:\"Heading 2\"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"3\"]:before{content:\"Heading 3\"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"4\"]:before{content:\"Heading 4\"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"5\"]:before{content:\"Heading 5\"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"6\"]:before{content:\"Heading 6\"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]:before{font-size:2em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]:before{font-size:1.5em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]:before{font-size:1.17em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]:before{font-size:1em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]:before{font-size:.83em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]:before{font-size:.67em}.ql-snow .ql-picker.ql-font{width:108px}.ql-snow .ql-picker.ql-font .ql-picker-item:before,.ql-snow .ql-picker.ql-font .ql-picker-label:before{content:\"Sans Serif\"}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]:before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]:before{content:\"Serif\"}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]:before{content:\"Monospace\"}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]:before{font-family:Georgia,Times New Roman,serif}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before{font-family:Monaco,Courier New,monospace}.ql-snow .ql-picker.ql-size{width:98px}.ql-snow .ql-picker.ql-size .ql-picker-item:before,.ql-snow .ql-picker.ql-size .ql-picker-label:before{content:\"Normal\"}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]:before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]:before{content:\"Small\"}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]:before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]:before{content:\"Large\"}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]:before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]:before{content:\"Huge\"}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]:before{font-size:10px}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]:before{font-size:18px}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]:before{font-size:32px}.ql-snow .ql-color-picker.ql-background .ql-picker-item{background-color:#fff}.ql-snow .ql-color-picker.ql-color .ql-picker-item{background-color:#000}.ql-toolbar.ql-snow{border:1px solid #ccc;box-sizing:border-box;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;padding:8px}.ql-toolbar.ql-snow .ql-formats{margin-right:15px}.ql-toolbar.ql-snow .ql-picker-label{border:1px solid transparent}.ql-toolbar.ql-snow .ql-picker-options{border:1px solid transparent;box-shadow:0 2px 8px rgba(0,0,0,.2)}.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label,.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options{border-color:#ccc}.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover{border-color:#000}.ql-toolbar.ql-snow+.ql-container.ql-snow{border-top:0}.ql-snow .ql-tooltip{background-color:#fff;border:1px solid #ccc;box-shadow:0 0 5px #ddd;color:#444;padding:5px 12px;white-space:nowrap}.ql-snow .ql-tooltip:before{content:\"Visit URL:\";line-height:26px;margin-right:8px}.ql-snow .ql-tooltip input[type=text]{display:none;border:1px solid #ccc;font-size:13px;height:26px;margin:0;padding:3px 5px;width:170px}.ql-snow .ql-tooltip a.ql-preview{display:inline-block;max-width:200px;overflow-x:hidden;text-overflow:ellipsis;vertical-align:top}.ql-snow .ql-tooltip a.ql-action:after{border-right:1px solid #ccc;content:\"Edit\";margin-left:16px;padding-right:8px}.ql-snow .ql-tooltip a.ql-remove:before{content:\"Remove\";margin-left:8px}.ql-snow .ql-tooltip a{line-height:26px}.ql-snow .ql-tooltip.ql-editing a.ql-preview,.ql-snow .ql-tooltip.ql-editing a.ql-remove{display:none}.ql-snow .ql-tooltip.ql-editing input[type=text]{display:inline-block}.ql-snow .ql-tooltip.ql-editing a.ql-action:after{border-right:0;content:\"Save\";padding-right:0}.ql-snow .ql-tooltip[data-mode=link]:before{content:\"Enter link:\"}.ql-snow .ql-tooltip[data-mode=formula]:before{content:\"Enter formula:\"}.ql-snow .ql-tooltip[data-mode=video]:before{content:\"Enter video:\"}.ql-snow a{color:#06c}.ql-container.ql-snow{border:1px solid #ccc}", "", {"version":3,"sources":["/workspace/node_modules/quill/dist/quill.snow.css"],"names":[],"mappings":"AAAA;;;;;GAKG,AACH,cACE,sBAAuB,AACvB,uCAA0C,AAC1C,eAAgB,AAChB,YAAa,AACb,SAAY,AACZ,iBAAmB,CACpB,AACD,sCACE,iBAAmB,CACpB,AACD,gEACE,mBAAqB,CACtB,AACD,cACE,eAAgB,AAChB,WAAY,AACZ,kBAAmB,AACnB,kBAAmB,AACnB,OAAS,CACV,AACD,gBACE,SAAU,AACV,SAAW,CACZ,AACD,WACE,sBAAuB,AACvB,iBAAkB,AAClB,YAAa,AACb,aAAc,AACd,gBAAiB,AACjB,kBAAmB,AACnB,WAAY,AACZ,gBAAiB,AACjB,gBAAiB,AACjB,qBAAsB,AACtB,oBAAsB,CACvB,AACD,aACE,WAAa,CACd,AACD,kKAWE,SAAU,AACV,UAAW,AACX,4EAA8E,CAC/E,AACD,4BAEE,kBAAoB,CACrB,AACD,kCAEE,oBAAsB,CACvB,AACD,wBACE,eAAiB,CAClB,AACD,mEAEE,mBAAqB,CACtB,AACD,6EAEE,kBAAoB,CACrB,AACD,uFAEE,WAAY,AACZ,eAAgB,AAChB,kBAAoB,CACrB,AACD,2CACE,eAAiB,CAClB,AACD,4CACE,eAAiB,CAClB,AACD,qBACE,qBAAsB,AACtB,mBAAoB,AACpB,WAAa,CACd,AACD,4CACE,mBAAoB,AACpB,kBAAoB,AACpB,gBAAkB,CACnB,AACD,sCACE,iBAAmB,AACnB,mBAAqB,CACtB,AACD,gFAEE,kBAAoB,CACrB,AACD,oEAEE,mBAAqB,CACtB,AACD,iBACE,6EAA8E,AAC9E,wBAA0B,CAC3B,AACD,wBACE,oCAAuC,CACxC,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,qEAAuE,CACxE,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,8DAAgE,CACjE,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,oCAAuC,CACxC,AACD,6BACE,uDAAyD,CAC1D,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,gDAAkD,CACnD,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,yCAA2C,CAC5C,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,oCAAuC,CACxC,AACD,6BACE,kCAAoC,CACrC,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,2BAA6B,CAC9B,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,oBAAsB,CACvB,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,oCAAuC,CACxC,AACD,+CACE,gBAAkB,CACnB,AACD,iDACE,kBAAoB,CACrB,AACD,wDACE,iBAAmB,CACpB,AACD,0DACE,mBAAqB,CACtB,AACD,+CACE,gBAAkB,CACnB,AACD,iDACE,kBAAoB,CACrB,AACD,wDACE,iBAAmB,CACpB,AACD,0DACE,mBAAqB,CACtB,AACD,+CACE,gBAAkB,CACnB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,iBAAmB,CACpB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,qBACE,cAAe,AACf,cAAgB,CACjB,AACD,qCACE,aAAe,CAChB,AACD,oCACE,iBAAmB,CACpB,AACD,wBACE,qBAAuB,CACxB,AACD,sBACE,wBAA0B,CAC3B,AACD,yBACE,qBAAuB,CACxB,AACD,yBACE,qBAAuB,CACxB,AACD,wBACE,wBAA0B,CAC3B,AACD,uBACE,qBAAuB,CACxB,AACD,yBACE,qBAAuB,CACxB,AACD,2BACE,UAAY,CACb,AACD,yBACE,aAAe,CAChB,AACD,4BACE,UAAY,CACb,AACD,4BACE,UAAY,CACb,AACD,2BACE,aAAe,CAChB,AACD,0BACE,UAAY,CACb,AACD,4BACE,UAAY,CACb,AACD,0BACE,yCAA6C,CAC9C,AACD,8BACE,wCAA4C,CAC7C,AACD,0BACE,eAAkB,CACnB,AACD,0BACE,eAAiB,CAClB,AACD,yBACE,eAAiB,CAClB,AACD,6BACE,cAAe,AACf,kBAAoB,CACrB,AACD,4BACE,iBAAmB,CACpB,AACD,6BACE,kBAAoB,CACrB,AACD,2BACE,gBAAkB,CACnB,AACD,2BACE,qBAAuB,AACvB,+BAAgC,AAChC,kBAAmB,AACnB,UAAW,AACX,oBAAqB,AACrB,kBAAmB,AACnB,UAAY,CACb,AACD,qDAEE,WAAY,AACZ,WAAY,AACZ,aAAe,CAChB,AACD,uDAEE,gBAAiB,AACjB,YAAa,AACb,eAAgB,AAChB,qBAAsB,AACtB,WAAY,AACZ,YAAa,AACb,gBAAiB,AACjB,UAAY,CACb,AACD,+DAEE,WAAY,AACZ,WAAa,CACd,AACD,iFAEE,YAAc,CACf,AACD,6FAEE,YAAc,CACf,AACD,6jBAcE,UAAY,CACb,AACD,kgDA4BE,SAAW,CACZ,AACD,kgDA4BE,WAAa,CACd,AACD,wBACE,mGAEE,UAAY,CACb,AACD,8PAIE,SAAW,CACZ,AACD,8PAIE,WAAa,CACd,CACF,AAID,oBACE,qBAAuB,CACxB,AACD,oBACE,YAAc,CACf,AACD,6CAEE,iBAAmB,CACpB,AACD,qBACE,kBAAmB,AACnB,0BAA4B,CAC7B,AACD,uBACE,eAAgB,AAChB,oBAAsB,CACvB,AACD,6BACE,2BAA6B,CAC9B,AACD,qBACE,qBAAsB,AACtB,qBAAuB,CACxB,AACD,2BACE,WAAY,AACZ,WAAY,AACZ,aAAe,CAChB,AACD,oBACE,UAAW,AACX,YAAa,AACb,qBAAsB,AACtB,sBAAuB,AACvB,cAAgB,CACjB,AACD,0BACE,UAAW,AACX,YAAa,AACb,qBAAsB,AACtB,cAAgB,CACjB,AACD,8CAEE,SAAW,CACZ,AACD,mBACE,SAAW,CACZ,AACD,kBACE,iBAAmB,CACpB,AACD,8CAEE,cAAgB,CACjB,AACD,yBACE,UAAa,CACd,AACD,sCACE,YAAc,CACf,AACD,gDACE,cAAgB,CACjB,AACD,iDACE,YAAc,CACf,AACD,uBACE,aAAe,CAChB,AACD,uBACE,eAAiB,CAClB,AACD,uBACE,gBAAkB,CACnB,AACD,uBACE,aAAe,CAChB,AACD,uBACE,eAAkB,CACnB,AACD,uBACE,eAAkB,CACnB,AACD,sBACE,yBAA2B,CAC5B,AACD,+BACE,2BAA4B,AAC5B,kBAAmB,AACnB,eAAgB,AAChB,iBAAmB,CACpB,AACD,iDAEE,yBAA0B,AAC1B,iBAAmB,CACpB,AACD,wBACE,qBAAsB,AACtB,kBAAmB,AACnB,eAAgB,AAChB,gBAAkB,CACnB,AACD,yBACE,cAAe,AACf,eAAiB,CAClB,AACD,kCACE,yBAA0B,AAC1B,cAAe,AACf,gBAAkB,CACnB,AACD,wBACE,cAAgB,CACjB,AACD,oBACE,WAAY,AACZ,qBAAsB,AACtB,WAAY,AACZ,eAAgB,AAChB,gBAAiB,AACjB,YAAa,AACb,kBAAmB,AACnB,qBAAuB,CACxB,AACD,0BACE,eAAgB,AAChB,qBAAsB,AACtB,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,kBAAmB,AACnB,UAAY,CACb,AACD,iCACE,qBAAsB,AACtB,gBAAkB,CACnB,AACD,4BACE,sBAAuB,AACvB,aAAc,AACd,eAAgB,AAChB,gBAAiB,AACjB,kBAAmB,AACnB,kBAAoB,CACrB,AACD,4CACE,eAAgB,AAChB,cAAe,AACf,mBAAoB,AACpB,eAAiB,CAClB,AACD,iDACE,WAAY,AACZ,SAAW,CACZ,AACD,0DACE,SAAW,CACZ,AACD,4DACE,WAAa,CACd,AACD,mDACE,cAAe,AACf,gBAAiB,AACjB,SAAU,AACV,SAAW,CACZ,AACD,mDAEE,UAAY,CACb,AACD,qFAEE,eAAiB,CAClB,AACD,6FAEE,SAAW,CACZ,AACD,4CACE,aAAiB,CAClB,AACD,yCACE,YAAa,AACb,WAAY,AACZ,eAAiB,CAClB,AACD,6CACE,gBAAiB,AACjB,WAAa,CACd,AACD,0CACE,6BAA8B,AAC9B,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,UAAa,AACb,UAAY,CACb,AACD,mEACE,kBAAmB,AACnB,gBAAiB,AACjB,QAAS,AACT,QAAS,AACT,UAAY,CACb,AACD,+fAME,wBAA0B,CAC3B,AACD,8BACE,UAAY,CACb,AACD,2GAEE,gBAAkB,CACnB,AACD,2IAEE,mBAAqB,CACtB,AACD,2IAEE,mBAAqB,CACtB,AACD,2IAEE,mBAAqB,CACtB,AACD,2IAEE,mBAAqB,CACtB,AACD,2IAEE,mBAAqB,CACtB,AACD,2IAEE,mBAAqB,CACtB,AACD,qEACE,aAAe,CAChB,AACD,qEACE,eAAiB,CAClB,AACD,qEACE,gBAAkB,CACnB,AACD,qEACE,aAAe,CAChB,AACD,qEACE,eAAkB,CACnB,AACD,qEACE,eAAkB,CACnB,AACD,4BACE,WAAa,CACd,AACD,uGAEE,oBAAsB,CACvB,AACD,2IAEE,eAAiB,CAClB,AACD,mJAEE,mBAAqB,CACtB,AACD,qEACE,yCAA6C,CAC9C,AACD,yEACE,wCAA4C,CAC7C,AACD,4BACE,UAAY,CACb,AACD,uGAEE,gBAAkB,CACnB,AACD,2IAEE,eAAiB,CAClB,AACD,2IAEE,eAAiB,CAClB,AACD,yIAEE,cAAgB,CACjB,AACD,qEACE,cAAgB,CACjB,AACD,qEACE,cAAgB,CACjB,AACD,oEACE,cAAgB,CACjB,AACD,wDACE,qBAAuB,CACxB,AACD,mDACE,qBAAuB,CACxB,AACD,oBACE,sBAAuB,AACvB,sBAAuB,AACvB,sDAAgE,AAChE,WAAa,CACd,AACD,gCACE,iBAAmB,CACpB,AACD,qCACE,4BAA8B,CAC/B,AACD,uCACE,6BAA8B,AAC9B,mCAAsC,CACvC,AAID,0HACE,iBAAmB,CACpB,AACD,4HAEE,iBAAmB,CACpB,AACD,0CACE,YAAgB,CACjB,AACD,qBACE,sBAAuB,AACvB,sBAAuB,AACvB,wBAA6B,AAC7B,WAAY,AACZ,iBAAkB,AAClB,kBAAoB,CACrB,AACD,4BACE,qBAAsB,AACtB,iBAAkB,AAClB,gBAAkB,CACnB,AACD,sCACE,aAAc,AACd,sBAAuB,AACvB,eAAgB,AAChB,YAAa,AACb,SAAY,AACZ,gBAAiB,AACjB,WAAa,CACd,AACD,kCACE,qBAAsB,AACtB,gBAAiB,AACjB,kBAAmB,AACnB,uBAAwB,AACxB,kBAAoB,CACrB,AACD,uCACE,4BAA6B,AAC7B,eAAgB,AAChB,iBAAkB,AAClB,iBAAmB,CACpB,AACD,wCACE,iBAAkB,AAClB,eAAiB,CAClB,AACD,uBACE,gBAAkB,CACnB,AACD,yFAEE,YAAc,CACf,AACD,iDACE,oBAAsB,CACvB,AACD,kDACE,eAAkB,AAClB,eAAgB,AAChB,eAAmB,CACpB,AACD,4CACE,qBAAuB,CACxB,AACD,+CACE,wBAA0B,CAC3B,AACD,6CACE,sBAAwB,CACzB,AACD,WACE,UAAY,CACb,AACD,sBACE,qBAAuB,CACxB","file":"quill.snow.css","sourcesContent":["/*!\n * Quill Editor v1.3.7\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */\n.ql-container {\n  box-sizing: border-box;\n  font-family: Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  height: 100%;\n  margin: 0px;\n  position: relative;\n}\n.ql-container.ql-disabled .ql-tooltip {\n  visibility: hidden;\n}\n.ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {\n  pointer-events: none;\n}\n.ql-clipboard {\n  left: -100000px;\n  height: 1px;\n  overflow-y: hidden;\n  position: absolute;\n  top: 50%;\n}\n.ql-clipboard p {\n  margin: 0;\n  padding: 0;\n}\n.ql-editor {\n  box-sizing: border-box;\n  line-height: 1.42;\n  height: 100%;\n  outline: none;\n  overflow-y: auto;\n  padding: 12px 15px;\n  tab-size: 4;\n  -moz-tab-size: 4;\n  text-align: left;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n.ql-editor > * {\n  cursor: text;\n}\n.ql-editor p,\n.ql-editor ol,\n.ql-editor ul,\n.ql-editor pre,\n.ql-editor blockquote,\n.ql-editor h1,\n.ql-editor h2,\n.ql-editor h3,\n.ql-editor h4,\n.ql-editor h5,\n.ql-editor h6 {\n  margin: 0;\n  padding: 0;\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol,\n.ql-editor ul {\n  padding-left: 1.5em;\n}\n.ql-editor ol > li,\n.ql-editor ul > li {\n  list-style-type: none;\n}\n.ql-editor ul > li::before {\n  content: '\\2022';\n}\n.ql-editor ul[data-checked=true],\n.ql-editor ul[data-checked=false] {\n  pointer-events: none;\n}\n.ql-editor ul[data-checked=true] > li *,\n.ql-editor ul[data-checked=false] > li * {\n  pointer-events: all;\n}\n.ql-editor ul[data-checked=true] > li::before,\n.ql-editor ul[data-checked=false] > li::before {\n  color: #777;\n  cursor: pointer;\n  pointer-events: all;\n}\n.ql-editor ul[data-checked=true] > li::before {\n  content: '\\2611';\n}\n.ql-editor ul[data-checked=false] > li::before {\n  content: '\\2610';\n}\n.ql-editor li::before {\n  display: inline-block;\n  white-space: nowrap;\n  width: 1.2em;\n}\n.ql-editor li:not(.ql-direction-rtl)::before {\n  margin-left: -1.5em;\n  margin-right: 0.3em;\n  text-align: right;\n}\n.ql-editor li.ql-direction-rtl::before {\n  margin-left: 0.3em;\n  margin-right: -1.5em;\n}\n.ql-editor ol li:not(.ql-direction-rtl),\n.ql-editor ul li:not(.ql-direction-rtl) {\n  padding-left: 1.5em;\n}\n.ql-editor ol li.ql-direction-rtl,\n.ql-editor ul li.ql-direction-rtl {\n  padding-right: 1.5em;\n}\n.ql-editor ol li {\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  counter-increment: list-0;\n}\n.ql-editor ol li:before {\n  content: counter(list-0, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n  counter-increment: list-1;\n}\n.ql-editor ol li.ql-indent-1:before {\n  content: counter(list-1, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-2 {\n  counter-increment: list-2;\n}\n.ql-editor ol li.ql-indent-2:before {\n  content: counter(list-2, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-2 {\n  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-3 {\n  counter-increment: list-3;\n}\n.ql-editor ol li.ql-indent-3:before {\n  content: counter(list-3, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-3 {\n  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-4 {\n  counter-increment: list-4;\n}\n.ql-editor ol li.ql-indent-4:before {\n  content: counter(list-4, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-4 {\n  counter-reset: list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-5 {\n  counter-increment: list-5;\n}\n.ql-editor ol li.ql-indent-5:before {\n  content: counter(list-5, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-5 {\n  counter-reset: list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-6 {\n  counter-increment: list-6;\n}\n.ql-editor ol li.ql-indent-6:before {\n  content: counter(list-6, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-6 {\n  counter-reset: list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-7 {\n  counter-increment: list-7;\n}\n.ql-editor ol li.ql-indent-7:before {\n  content: counter(list-7, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-7 {\n  counter-reset: list-8 list-9;\n}\n.ql-editor ol li.ql-indent-8 {\n  counter-increment: list-8;\n}\n.ql-editor ol li.ql-indent-8:before {\n  content: counter(list-8, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-8 {\n  counter-reset: list-9;\n}\n.ql-editor ol li.ql-indent-9 {\n  counter-increment: list-9;\n}\n.ql-editor ol li.ql-indent-9:before {\n  content: counter(list-9, decimal) '. ';\n}\n.ql-editor .ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 3em;\n}\n.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 4.5em;\n}\n.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 3em;\n}\n.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 4.5em;\n}\n.ql-editor .ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 6em;\n}\n.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 7.5em;\n}\n.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 6em;\n}\n.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 7.5em;\n}\n.ql-editor .ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 9em;\n}\n.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 10.5em;\n}\n.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 9em;\n}\n.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 10.5em;\n}\n.ql-editor .ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 12em;\n}\n.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 13.5em;\n}\n.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 12em;\n}\n.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 13.5em;\n}\n.ql-editor .ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 15em;\n}\n.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 16.5em;\n}\n.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 15em;\n}\n.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 16.5em;\n}\n.ql-editor .ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 18em;\n}\n.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 19.5em;\n}\n.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 18em;\n}\n.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 19.5em;\n}\n.ql-editor .ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 21em;\n}\n.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 22.5em;\n}\n.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 21em;\n}\n.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 22.5em;\n}\n.ql-editor .ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 24em;\n}\n.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 25.5em;\n}\n.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 24em;\n}\n.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 25.5em;\n}\n.ql-editor .ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 27em;\n}\n.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 28.5em;\n}\n.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 27em;\n}\n.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 28.5em;\n}\n.ql-editor .ql-video {\n  display: block;\n  max-width: 100%;\n}\n.ql-editor .ql-video.ql-align-center {\n  margin: 0 auto;\n}\n.ql-editor .ql-video.ql-align-right {\n  margin: 0 0 0 auto;\n}\n.ql-editor .ql-bg-black {\n  background-color: #000;\n}\n.ql-editor .ql-bg-red {\n  background-color: #e60000;\n}\n.ql-editor .ql-bg-orange {\n  background-color: #f90;\n}\n.ql-editor .ql-bg-yellow {\n  background-color: #ff0;\n}\n.ql-editor .ql-bg-green {\n  background-color: #008a00;\n}\n.ql-editor .ql-bg-blue {\n  background-color: #06c;\n}\n.ql-editor .ql-bg-purple {\n  background-color: #93f;\n}\n.ql-editor .ql-color-white {\n  color: #fff;\n}\n.ql-editor .ql-color-red {\n  color: #e60000;\n}\n.ql-editor .ql-color-orange {\n  color: #f90;\n}\n.ql-editor .ql-color-yellow {\n  color: #ff0;\n}\n.ql-editor .ql-color-green {\n  color: #008a00;\n}\n.ql-editor .ql-color-blue {\n  color: #06c;\n}\n.ql-editor .ql-color-purple {\n  color: #93f;\n}\n.ql-editor .ql-font-serif {\n  font-family: Georgia, Times New Roman, serif;\n}\n.ql-editor .ql-font-monospace {\n  font-family: Monaco, Courier New, monospace;\n}\n.ql-editor .ql-size-small {\n  font-size: 0.75em;\n}\n.ql-editor .ql-size-large {\n  font-size: 1.5em;\n}\n.ql-editor .ql-size-huge {\n  font-size: 2.5em;\n}\n.ql-editor .ql-direction-rtl {\n  direction: rtl;\n  text-align: inherit;\n}\n.ql-editor .ql-align-center {\n  text-align: center;\n}\n.ql-editor .ql-align-justify {\n  text-align: justify;\n}\n.ql-editor .ql-align-right {\n  text-align: right;\n}\n.ql-editor.ql-blank::before {\n  color: rgba(0,0,0,0.6);\n  content: attr(data-placeholder);\n  font-style: italic;\n  left: 15px;\n  pointer-events: none;\n  position: absolute;\n  right: 15px;\n}\n.ql-snow.ql-toolbar:after,\n.ql-snow .ql-toolbar:after {\n  clear: both;\n  content: '';\n  display: table;\n}\n.ql-snow.ql-toolbar button,\n.ql-snow .ql-toolbar button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: inline-block;\n  float: left;\n  height: 24px;\n  padding: 3px 5px;\n  width: 28px;\n}\n.ql-snow.ql-toolbar button svg,\n.ql-snow .ql-toolbar button svg {\n  float: left;\n  height: 100%;\n}\n.ql-snow.ql-toolbar button:active:hover,\n.ql-snow .ql-toolbar button:active:hover {\n  outline: none;\n}\n.ql-snow.ql-toolbar input.ql-image[type=file],\n.ql-snow .ql-toolbar input.ql-image[type=file] {\n  display: none;\n}\n.ql-snow.ql-toolbar button:hover,\n.ql-snow .ql-toolbar button:hover,\n.ql-snow.ql-toolbar button:focus,\n.ql-snow .ql-toolbar button:focus,\n.ql-snow.ql-toolbar button.ql-active,\n.ql-snow .ql-toolbar button.ql-active,\n.ql-snow.ql-toolbar .ql-picker-label:hover,\n.ql-snow .ql-toolbar .ql-picker-label:hover,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active,\n.ql-snow.ql-toolbar .ql-picker-item:hover,\n.ql-snow .ql-toolbar .ql-picker-item:hover,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected {\n  color: #06c;\n}\n.ql-snow.ql-toolbar button:hover .ql-fill,\n.ql-snow .ql-toolbar button:hover .ql-fill,\n.ql-snow.ql-toolbar button:focus .ql-fill,\n.ql-snow .ql-toolbar button:focus .ql-fill,\n.ql-snow.ql-toolbar button.ql-active .ql-fill,\n.ql-snow .ql-toolbar button.ql-active .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {\n  fill: #06c;\n}\n.ql-snow.ql-toolbar button:hover .ql-stroke,\n.ql-snow .ql-toolbar button:hover .ql-stroke,\n.ql-snow.ql-toolbar button:focus .ql-stroke,\n.ql-snow .ql-toolbar button:focus .ql-stroke,\n.ql-snow.ql-toolbar button.ql-active .ql-stroke,\n.ql-snow .ql-toolbar button.ql-active .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n.ql-snow.ql-toolbar button:hover .ql-stroke-miter,\n.ql-snow .ql-toolbar button:hover .ql-stroke-miter,\n.ql-snow.ql-toolbar button:focus .ql-stroke-miter,\n.ql-snow .ql-toolbar button:focus .ql-stroke-miter,\n.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,\n.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {\n  stroke: #06c;\n}\n@media (pointer: coarse) {\n  .ql-snow.ql-toolbar button:hover:not(.ql-active),\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) {\n    color: #444;\n  }\n  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,\n  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {\n    fill: #444;\n  }\n  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {\n    stroke: #444;\n  }\n}\n.ql-snow {\n  box-sizing: border-box;\n}\n.ql-snow * {\n  box-sizing: border-box;\n}\n.ql-snow .ql-hidden {\n  display: none;\n}\n.ql-snow .ql-out-bottom,\n.ql-snow .ql-out-top {\n  visibility: hidden;\n}\n.ql-snow .ql-tooltip {\n  position: absolute;\n  transform: translateY(10px);\n}\n.ql-snow .ql-tooltip a {\n  cursor: pointer;\n  text-decoration: none;\n}\n.ql-snow .ql-tooltip.ql-flip {\n  transform: translateY(-10px);\n}\n.ql-snow .ql-formats {\n  display: inline-block;\n  vertical-align: middle;\n}\n.ql-snow .ql-formats:after {\n  clear: both;\n  content: '';\n  display: table;\n}\n.ql-snow .ql-stroke {\n  fill: none;\n  stroke: #444;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 2;\n}\n.ql-snow .ql-stroke-miter {\n  fill: none;\n  stroke: #444;\n  stroke-miterlimit: 10;\n  stroke-width: 2;\n}\n.ql-snow .ql-fill,\n.ql-snow .ql-stroke.ql-fill {\n  fill: #444;\n}\n.ql-snow .ql-empty {\n  fill: none;\n}\n.ql-snow .ql-even {\n  fill-rule: evenodd;\n}\n.ql-snow .ql-thin,\n.ql-snow .ql-stroke.ql-thin {\n  stroke-width: 1;\n}\n.ql-snow .ql-transparent {\n  opacity: 0.4;\n}\n.ql-snow .ql-direction svg:last-child {\n  display: none;\n}\n.ql-snow .ql-direction.ql-active svg:last-child {\n  display: inline;\n}\n.ql-snow .ql-direction.ql-active svg:first-child {\n  display: none;\n}\n.ql-snow .ql-editor h1 {\n  font-size: 2em;\n}\n.ql-snow .ql-editor h2 {\n  font-size: 1.5em;\n}\n.ql-snow .ql-editor h3 {\n  font-size: 1.17em;\n}\n.ql-snow .ql-editor h4 {\n  font-size: 1em;\n}\n.ql-snow .ql-editor h5 {\n  font-size: 0.83em;\n}\n.ql-snow .ql-editor h6 {\n  font-size: 0.67em;\n}\n.ql-snow .ql-editor a {\n  text-decoration: underline;\n}\n.ql-snow .ql-editor blockquote {\n  border-left: 4px solid #ccc;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  padding-left: 16px;\n}\n.ql-snow .ql-editor code,\n.ql-snow .ql-editor pre {\n  background-color: #f0f0f0;\n  border-radius: 3px;\n}\n.ql-snow .ql-editor pre {\n  white-space: pre-wrap;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  padding: 5px 10px;\n}\n.ql-snow .ql-editor code {\n  font-size: 85%;\n  padding: 2px 4px;\n}\n.ql-snow .ql-editor pre.ql-syntax {\n  background-color: #23241f;\n  color: #f8f8f2;\n  overflow: visible;\n}\n.ql-snow .ql-editor img {\n  max-width: 100%;\n}\n.ql-snow .ql-picker {\n  color: #444;\n  display: inline-block;\n  float: left;\n  font-size: 14px;\n  font-weight: 500;\n  height: 24px;\n  position: relative;\n  vertical-align: middle;\n}\n.ql-snow .ql-picker-label {\n  cursor: pointer;\n  display: inline-block;\n  height: 100%;\n  padding-left: 8px;\n  padding-right: 2px;\n  position: relative;\n  width: 100%;\n}\n.ql-snow .ql-picker-label::before {\n  display: inline-block;\n  line-height: 22px;\n}\n.ql-snow .ql-picker-options {\n  background-color: #fff;\n  display: none;\n  min-width: 100%;\n  padding: 4px 8px;\n  position: absolute;\n  white-space: nowrap;\n}\n.ql-snow .ql-picker-options .ql-picker-item {\n  cursor: pointer;\n  display: block;\n  padding-bottom: 5px;\n  padding-top: 5px;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n  color: #ccc;\n  z-index: 2;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {\n  fill: #ccc;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {\n  stroke: #ccc;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n  display: block;\n  margin-top: -1px;\n  top: 100%;\n  z-index: 1;\n}\n.ql-snow .ql-color-picker,\n.ql-snow .ql-icon-picker {\n  width: 28px;\n}\n.ql-snow .ql-color-picker .ql-picker-label,\n.ql-snow .ql-icon-picker .ql-picker-label {\n  padding: 2px 4px;\n}\n.ql-snow .ql-color-picker .ql-picker-label svg,\n.ql-snow .ql-icon-picker .ql-picker-label svg {\n  right: 4px;\n}\n.ql-snow .ql-icon-picker .ql-picker-options {\n  padding: 4px 0px;\n}\n.ql-snow .ql-icon-picker .ql-picker-item {\n  height: 24px;\n  width: 24px;\n  padding: 2px 4px;\n}\n.ql-snow .ql-color-picker .ql-picker-options {\n  padding: 3px 5px;\n  width: 152px;\n}\n.ql-snow .ql-color-picker .ql-picker-item {\n  border: 1px solid transparent;\n  float: left;\n  height: 16px;\n  margin: 2px;\n  padding: 0px;\n  width: 16px;\n}\n.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {\n  position: absolute;\n  margin-top: -9px;\n  right: 0;\n  top: 50%;\n  width: 18px;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {\n  content: attr(data-label);\n}\n.ql-snow .ql-picker.ql-header {\n  width: 98px;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item::before {\n  content: 'Normal';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"1\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before {\n  content: 'Heading 1';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"2\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before {\n  content: 'Heading 2';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"3\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before {\n  content: 'Heading 3';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"4\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before {\n  content: 'Heading 4';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"5\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before {\n  content: 'Heading 5';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"6\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before {\n  content: 'Heading 6';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before {\n  font-size: 2em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before {\n  font-size: 1.5em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before {\n  font-size: 1.17em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before {\n  font-size: 1em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before {\n  font-size: 0.83em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before {\n  font-size: 0.67em;\n}\n.ql-snow .ql-picker.ql-font {\n  width: 108px;\n}\n.ql-snow .ql-picker.ql-font .ql-picker-label::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item::before {\n  content: 'Sans Serif';\n}\n.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {\n  content: 'Serif';\n}\n.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {\n  content: 'Monospace';\n}\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {\n  font-family: Georgia, Times New Roman, serif;\n}\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {\n  font-family: Monaco, Courier New, monospace;\n}\n.ql-snow .ql-picker.ql-size {\n  width: 98px;\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item::before {\n  content: 'Normal';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {\n  content: 'Small';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {\n  content: 'Large';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {\n  content: 'Huge';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {\n  font-size: 10px;\n}\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {\n  font-size: 18px;\n}\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {\n  font-size: 32px;\n}\n.ql-snow .ql-color-picker.ql-background .ql-picker-item {\n  background-color: #fff;\n}\n.ql-snow .ql-color-picker.ql-color .ql-picker-item {\n  background-color: #000;\n}\n.ql-toolbar.ql-snow {\n  border: 1px solid #ccc;\n  box-sizing: border-box;\n  font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n  padding: 8px;\n}\n.ql-toolbar.ql-snow .ql-formats {\n  margin-right: 15px;\n}\n.ql-toolbar.ql-snow .ql-picker-label {\n  border: 1px solid transparent;\n}\n.ql-toolbar.ql-snow .ql-picker-options {\n  border: 1px solid transparent;\n  box-shadow: rgba(0,0,0,0.2) 0 2px 8px;\n}\n.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n  border-color: #ccc;\n}\n.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n  border-color: #ccc;\n}\n.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,\n.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {\n  border-color: #000;\n}\n.ql-toolbar.ql-snow + .ql-container.ql-snow {\n  border-top: 0px;\n}\n.ql-snow .ql-tooltip {\n  background-color: #fff;\n  border: 1px solid #ccc;\n  box-shadow: 0px 0px 5px #ddd;\n  color: #444;\n  padding: 5px 12px;\n  white-space: nowrap;\n}\n.ql-snow .ql-tooltip::before {\n  content: \"Visit URL:\";\n  line-height: 26px;\n  margin-right: 8px;\n}\n.ql-snow .ql-tooltip input[type=text] {\n  display: none;\n  border: 1px solid #ccc;\n  font-size: 13px;\n  height: 26px;\n  margin: 0px;\n  padding: 3px 5px;\n  width: 170px;\n}\n.ql-snow .ql-tooltip a.ql-preview {\n  display: inline-block;\n  max-width: 200px;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  vertical-align: top;\n}\n.ql-snow .ql-tooltip a.ql-action::after {\n  border-right: 1px solid #ccc;\n  content: 'Edit';\n  margin-left: 16px;\n  padding-right: 8px;\n}\n.ql-snow .ql-tooltip a.ql-remove::before {\n  content: 'Remove';\n  margin-left: 8px;\n}\n.ql-snow .ql-tooltip a {\n  line-height: 26px;\n}\n.ql-snow .ql-tooltip.ql-editing a.ql-preview,\n.ql-snow .ql-tooltip.ql-editing a.ql-remove {\n  display: none;\n}\n.ql-snow .ql-tooltip.ql-editing input[type=text] {\n  display: inline-block;\n}\n.ql-snow .ql-tooltip.ql-editing a.ql-action::after {\n  border-right: 0px;\n  content: 'Save';\n  padding-right: 0px;\n}\n.ql-snow .ql-tooltip[data-mode=link]::before {\n  content: \"Enter link:\";\n}\n.ql-snow .ql-tooltip[data-mode=formula]::before {\n  content: \"Enter formula:\";\n}\n.ql-snow .ql-tooltip[data-mode=video]::before {\n  content: \"Enter video:\";\n}\n.ql-snow a {\n  color: #06c;\n}\n.ql-container.ql-snow {\n  border: 1px solid #ccc;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1873:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(1814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(1815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(1816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_quill__ = __webpack_require__(1629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_quill__);





// require sources


var Quill = window.Quill || __WEBPACK_IMPORTED_MODULE_5_quill___default.a;

var Inline = Quill.import('blots/inline');

var Font = function (_Inline) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Font, _Inline);

  function Font() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Font);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Font.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Font)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Font, null, [{
    key: 'create',
    value: function create(_ref) {
      var style = _ref.style;

      var node = document.createElement('span');
      node.setAttribute('style', style);
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(node) {
      var style = '';
      if (node.getAttribute('color')) {
        style += 'color:' + node.color + ';';
      }
      return { style: style };
    }
  }]);

  return Font;
}(Inline);

Font.blotName = 'font';
Font.tagName = 'font';

Quill.register(Font);

/***/ }),

/***/ 1874:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1875);
module.exports = __webpack_require__(12).Object.getPrototypeOf;


/***/ }),

/***/ 1875:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(78);
var $getPrototypeOf = __webpack_require__(260);

__webpack_require__(261)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ 1876:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1877), __esModule: true };

/***/ }),

/***/ 1877:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1878);
module.exports = __webpack_require__(12).Object.setPrototypeOf;


/***/ }),

/***/ 1878:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(28);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1879).set });


/***/ }),

/***/ 1879:
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(55);
var anObject = __webpack_require__(41);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(64)(Function.call, __webpack_require__(1367).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ 1880:
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e(__webpack_require__(1629)):"function"==typeof define&&define.amd?define(["quill"],e):"object"==typeof exports?exports.VueQuillEditor=e(require("quill")):t.VueQuillEditor=e(t.Quill)}(this,function(t){return function(t){function e(i){if(n[i])return n[i].exports;var l=n[i]={i:i,l:!1,exports:{}};return t[i].call(l.exports,l,l.exports,e),l.l=!0,l.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,i){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:i})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="/",e(e.s=2)}([function(e,n){e.exports=t},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=n(4),l=n.n(i),o=n(6),r=n(5),u=r(l.a,o.a,!1,null,null,null);e.default=u.exports},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0}),e.install=e.quillEditor=e.Quill=void 0;var l=n(0),o=i(l),r=n(1),u=i(r),s=window.Quill||o.default,a=function(t,e){e&&(u.default.props.globalOptions.default=function(){return e}),t.component(u.default.name,u.default)},c={Quill:s,quillEditor:u.default,install:a};e.default=c,e.Quill=s,e.quillEditor=u.default,e.install=a},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={theme:"snow",boundary:document.body,modules:{toolbar:[["bold","italic","underline","strike"],["blockquote","code-block"],[{header:1},{header:2}],[{list:"ordered"},{list:"bullet"}],[{script:"sub"},{script:"super"}],[{indent:"-1"},{indent:"+1"}],[{direction:"rtl"}],[{size:["small",!1,"large","huge"]}],[{header:[1,2,3,4,5,6,!1]}],[{color:[]},{background:[]}],[{font:[]}],[{align:[]}],["clean"],["link","image","video"]]},placeholder:"Insert text here ...",readOnly:!1}},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var l=n(0),o=i(l),r=n(3),u=i(r),s=window.Quill||o.default;"function"!=typeof Object.assign&&Object.defineProperty(Object,"assign",{value:function(t,e){if(null==t)throw new TypeError("Cannot convert undefined or null to object");for(var n=Object(t),i=1;i<arguments.length;i++){var l=arguments[i];if(null!=l)for(var o in l)Object.prototype.hasOwnProperty.call(l,o)&&(n[o]=l[o])}return n},writable:!0,configurable:!0}),e.default={name:"quill-editor",data:function(){return{_options:{},_content:"",defaultOptions:u.default}},props:{content:String,value:String,disabled:{type:Boolean,default:!1},options:{type:Object,required:!1,default:function(){return{}}},globalOptions:{type:Object,required:!1,default:function(){return{}}}},mounted:function(){this.initialize()},beforeDestroy:function(){this.quill=null,delete this.quill},methods:{initialize:function(){var t=this;this.$el&&(this._options=Object.assign({},this.defaultOptions,this.globalOptions,this.options),this.quill=new s(this.$refs.editor,this._options),this.quill.enable(!1),(this.value||this.content)&&this.quill.pasteHTML(this.value||this.content),this.disabled||this.quill.enable(!0),this.quill.on("selection-change",function(e){e?t.$emit("focus",t.quill):t.$emit("blur",t.quill)}),this.quill.on("text-change",function(e,n,i){var l=t.$refs.editor.children[0].innerHTML,o=t.quill,r=t.quill.getText();"<p><br></p>"===l&&(l=""),t._content=l,t.$emit("input",t._content),t.$emit("change",{html:l,text:r,quill:o})}),this.$emit("ready",this.quill))}},watch:{content:function(t,e){this.quill&&(t&&t!==this._content?(this._content=t,this.quill.pasteHTML(t)):t||this.quill.setText(""))},value:function(t,e){this.quill&&(t&&t!==this._content?(this._content=t,this.quill.pasteHTML(t)):t||this.quill.setText(""))},disabled:function(t,e){this.quill&&this.quill.enable(!t)}}}},function(t,e){t.exports=function(t,e,n,i,l,o){var r,u=t=t||{},s=typeof t.default;"object"!==s&&"function"!==s||(r=t,u=t.default);var a="function"==typeof u?u.options:u;e&&(a.render=e.render,a.staticRenderFns=e.staticRenderFns,a._compiled=!0),n&&(a.functional=!0),l&&(a._scopeId=l);var c;if(o?(c=function(t){t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,t||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),i&&i.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(o)},a._ssrRegister=c):i&&(c=i),c){var d=a.functional,f=d?a.render:a.beforeCreate;d?(a._injectStyles=c,a.render=function(t,e){return c.call(e),f(t,e)}):a.beforeCreate=f?[].concat(f,c):[c]}return{esModule:r,exports:u,options:a}}},function(t,e,n){"use strict";var i=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"quill-editor"},[t._t("toolbar"),t._v(" "),n("div",{ref:"editor"})],2)},l=[],o={render:i,staticRenderFns:l};e.a=o}])});

/***/ }),

/***/ 1881:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1882);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("32934d1e", content, true, {});

/***/ }),

/***/ 1882:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionGuideAudio.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1883:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"contextmenu":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onContextmenu($event)}}},[_c('sj-question-file',{attrs:{"disabled":_vm.disabled}},[_vm._l((_vm.progress),function(item,index){return _c('sj-question-file-progress',{key:'percentage' + index,attrs:{"percentage":item.percentage}})}),_vm._v(" "),_vm._l((_vm.files),function(file,index){return _c('sj-question-file-item',{key:'file' + index,attrs:{"icon":"el-icon-service","disabled":_vm.disabled,"show-hover-icons":_vm.showHoverIcons,"selected":_vm.checkedFiles.includes(file)},on:{"view":function($event){return _vm.view(file.src)},"remove":function($event){return _vm.remove(index)}},nativeOn:{"contextmenu":function($event){$event.preventDefault();$event.stopPropagation();return (function (event){_vm.onContextmenu(event, index)})($event)}}})}),_vm._v(" "),_c('el-tooltip',{attrs:{"effect":"dark","content":_vm.title,"placement":"top"}},[_c('sj-question-file-add',{attrs:{"disabled":_vm.disabled || _vm.files.length > 0},on:{"click":function($event){return _vm.$refs.selectFile.click()}}})],1)],2),_vm._v(" "),(!_vm.disabled)?_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"selectFile",attrs:{"type":"file","accept":".mp3"},on:{"change":_vm.upload}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1884:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(42))(5);

/***/ }),

/***/ 1885:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main_js__ = __webpack_require__(1886);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main_js__["a" /* default */]);

/***/ }),

/***/ 1886:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ImageViewBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_vue__ = __webpack_require__(1887);



var defaults = {};

var MainConstructor = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.extend(__WEBPACK_IMPORTED_MODULE_1__main_vue__["a" /* default */]);

var instance = void 0,
    currentBox = void 0;

var defaultCallback = function defaultCallback(action) {
  if (currentBox) {
    var callback = currentBox.callback;
    if (typeof callback === 'function') {
      callback(action);
    }
    if (currentBox.resolve) {
      if (action === 'confirm') {
        currentBox.resolve(action);
      } else if (currentBox.reject && (action === 'cancel' || action === 'close')) {
        currentBox.reject(action);
      }
    }
  }
};

var initInstance = function initInstance() {
  instance = new MainConstructor({
    el: document.createElement('div')
  });

  instance.callback = defaultCallback;
};

var showBox = function showBox() {
  if (!instance) {
    initInstance();
  }

  instance.action = '';

  if (!instance.visible || instance.closeTimer) {
    if (currentBox) {
      var options = currentBox.options;
      for (var prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop];
        }
      }

      if (options.callback === undefined) {
        instance.callback = defaultCallback;
      }

      var oldCb = instance.callback;
      instance.callback = function (action, instance) {
        oldCb(action, instance);
      };

      document.body.appendChild(instance.$el);

      __WEBPACK_IMPORTED_MODULE_0_vue___default.a.nextTick(function () {
        instance.visible = true;
      });
    }
  }
};

var ImageViewBox = function ImageViewBox(options, callback) {
  if (__WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$isServer) return;
  if (options.constructor === Array) {
    options = {
      files: options
    };
    if (typeof arguments[1] === 'number') {
      options.index = arguments[1];
    }
  } else if (options.callback && !callback) {
    callback = options.callback;
  }

  currentBox = {
    options: _.merge({}, defaults, ImageViewBox.defaults, options),
    callback: callback
  };

  showBox();
};

ImageViewBox.setDefaults = function (defaults) {
  ImageViewBox.defaults = defaults;
};

ImageViewBox.open = function (files, index, options) {
  return ImageViewBox(_.merge({
    files: files,
    index: index
  }, options));
};

ImageViewBox.close = function () {
  instance.doClose();
  instance.visible = false;
  currentBox = null;
};

ImageViewBox.destroy = function () {
  if (instance) {
    instance.$el.remove();
    instance.$destroy();
    instance = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ImageViewBox);



/***/ }),

/***/ 1887:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(1682);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e9bcfb1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(1894);
function injectStyle (ssrContext) {
  __webpack_require__(1888)
  __webpack_require__(1890)
  this["$style"] = __webpack_require__(1892)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e9bcfb1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e9bcfb1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1888:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1889);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("a510c2b0", content, true, {});

/***/ }),

/***/ 1889:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1890:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1891);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("d79080d4", content, true, {});

/***/ }),

/***/ 1891:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1892:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1893);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("12c3a25e", content, true, {});

/***/ }),

/***/ 1893:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1894:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticStyle:{"display":"none"}},_vm._l((_vm.files),function(ref){
var src = ref.src;
return _c('li',[_c('img',{ref:"img",refInFor:true,attrs:{"src":_vm._f("ossThumbnail")(src,75),"alt":src}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1895:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SjQuestionUploadVideoBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main_vue__ = __webpack_require__(1896);




var defaults = {};

var MainConstructor = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.extend(__WEBPACK_IMPORTED_MODULE_2__main_vue__["a" /* default */]);

var instance = void 0,
    currentBox = void 0;

var defaultCallback = function defaultCallback(action, data) {
  if (currentBox) {
    var callback = currentBox.callback;
    if (typeof callback === 'function') {
      callback(data);
    }
    if (currentBox.resolve) {
      if (action === 'confirm') {
        currentBox.resolve(data);
      } else if (currentBox.reject && (action === 'cancel' || action === 'close')) {
        currentBox.reject(action);
      }
    }
  }
};

var initInstance = function initInstance() {
  instance = new MainConstructor({
    el: document.createElement('div')
  });

  instance.callback = defaultCallback;
};

var showBox = function showBox() {
  if (!instance) {
    initInstance();
  }

  instance.action = '';

  if (!instance.visible || instance.closeTimer) {
    if (currentBox) {
      var options = currentBox.options;
      for (var prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop];
        }
      }

      if (options.callback === undefined) {
        instance.callback = defaultCallback;
      }

      var oldCb = instance.callback;
      instance.callback = function (action, instance) {
        oldCb(action, instance);
      };

      document.body.appendChild(instance.$el);

      __WEBPACK_IMPORTED_MODULE_1_vue___default.a.nextTick(function () {
        instance.visible = true;
      });
    }
  }
};

var SjQuestionUploadVideoBox = function SjQuestionUploadVideoBox(options, callback) {
  if (__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$isServer) return;
  if (typeof options === 'string') {
    options = {
      message: options
    };
    if (typeof arguments[1] === 'string') {
      options.title = arguments[1];
    }
  } else if (options.callback && !callback) {
    callback = options.callback;
  }

  if (typeof __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a !== 'undefined') {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      // eslint-disable-line
      currentBox = {
        options: _.merge({}, defaults, SjQuestionUploadVideoBox.defaults, options),
        callback: callback,
        resolve: resolve,
        reject: reject
      };

      showBox();
    });
  } else {
    currentBox = {
      options: _.merge({}, defaults, SjQuestionUploadVideoBox.defaults, options),
      callback: callback
    };

    showBox();
  }
};

SjQuestionUploadVideoBox.setDefaults = function (defaults) {
  SjQuestionUploadVideoBox.defaults = defaults;
};

SjQuestionUploadVideoBox.open = function (message, title) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return SjQuestionUploadVideoBox(_.merge({
    title: title,
    message: message
  }, options));
};

SjQuestionUploadVideoBox.close = function () {
  instance.doClose();
  instance.visible = false;
  currentBox = null;
};

SjQuestionUploadVideoBox.destroy = function () {
  if (instance) {
    instance.$el.remove();
    instance.$destroy();
    instance = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (SjQuestionUploadVideoBox);


/***/ }),

/***/ 1896:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(1683);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5774176_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(1903);
function injectStyle (ssrContext) {
  __webpack_require__(1897)
  __webpack_require__(1899)
  this["$style"] = __webpack_require__(1901)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a5774176"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5774176_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1897:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1898);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("64b85b46", content, true, {});

/***/ }),

/***/ 1898:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1899:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1900);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("cb345bc6", content, true, {});

/***/ }),

/***/ 1900:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1901:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1902);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("89ac15da", content, true, {});

/***/ }),

/***/ 1902:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1903:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"视频上传","width":"600px","close-on-click-modal":false,"visible":_vm.visible},on:{"update:visible":function($event){_vm.visible=$event},"close":_vm.onClose},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onSubmit()}}},[_c('el-form',{ref:"form",staticStyle:{"padding-right":"50px","margin-bottom":"-20px"},attrs:{"model":_vm.form,"rules":_vm.rules,"size":"small","label-width":"70px"}},[_c('el-form-item',{attrs:{"label":"视频","prop":"file"}},[_c('el-upload',{ref:"video",attrs:{"action":"","accept":".mp4","file-list":_vm.videoList,"auto-upload":false,"on-change":_vm.changeVideo}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击上传\n        ")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("只能上传mp4文件，且不超过50MB\n        ")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"封面","prop":"poster"}},[_c('el-upload',{ref:"poster",attrs:{"action":"","accept":".jpg,.jpeg,.png,.gif","file-list":_vm.posterList,"auto-upload":false,"on-change":_vm.changePoster}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击上传\n        ")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("只能上传jpg/png/gif文件，且不超过2MB\n        ")])],1)],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){return _vm.handleAction('cancel')}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":_vm.loading},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v("确 定")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1904:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SjPlyrAudioBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main_vue__ = __webpack_require__(1905);




var defaults = {};

var MainConstructor = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.extend(__WEBPACK_IMPORTED_MODULE_2__main_vue__["a" /* default */]);

var instance = void 0,
    currentBox = void 0;

var defaultCallback = function defaultCallback(action) {
  if (currentBox) {
    var callback = currentBox.callback;
    if (typeof callback === 'function') {
      callback(action);
    }
    if (currentBox.resolve) {
      if (action === 'confirm') {
        currentBox.resolve(action);
      } else if (currentBox.reject && (action === 'cancel' || action === 'close')) {
        currentBox.reject(action);
      }
    }
  }
};

var initInstance = function initInstance() {
  instance = new MainConstructor({
    el: document.createElement('div')
  });

  instance.callback = defaultCallback;
};

var showBox = function showBox() {
  if (!instance) {
    initInstance();
  }

  instance.action = '';

  if (!instance.visible || instance.closeTimer) {
    if (currentBox) {
      var options = currentBox.options;
      for (var prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop];
        }
      }

      if (options.callback === undefined) {
        instance.callback = defaultCallback;
      }

      var oldCb = instance.callback;
      instance.callback = function (action, instance) {
        oldCb(action, instance);
      };

      document.body.appendChild(instance.$el);

      __WEBPACK_IMPORTED_MODULE_1_vue___default.a.nextTick(function () {
        instance.visible = true;
      });
    }
  }
};

var SjPlyrAudioBox = function SjPlyrAudioBox(options, callback) {
  if (__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$isServer) return;
  if (typeof options === 'string') {
    options = {
      message: options
    };
    if (typeof arguments[1] === 'string') {
      options.title = arguments[1];
    }
  } else if (options.callback && !callback) {
    callback = options.callback;
  }

  if (typeof __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a !== 'undefined') {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      // eslint-disable-line
      currentBox = {
        options: _.merge({}, defaults, SjPlyrAudioBox.defaults, options),
        callback: callback,
        resolve: resolve,
        reject: reject
      };

      showBox();
    });
  } else {
    currentBox = {
      options: _.merge({}, defaults, SjPlyrAudioBox.defaults, options),
      callback: callback
    };

    showBox();
  }
};

SjPlyrAudioBox.setDefaults = function (defaults) {
  SjPlyrAudioBox.defaults = defaults;
};

SjPlyrAudioBox.open = function (file) {
  var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '录音播放';
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return SjPlyrAudioBox(_.merge({
    title: title,
    file: file
  }, options));
};

SjPlyrAudioBox.close = function () {
  instance.doClose();
  instance.visible = false;
  currentBox = null;
};

SjPlyrAudioBox.destroy = function () {
  if (instance) {
    instance.$el.remove();
    instance.$destroy();
    instance = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (SjPlyrAudioBox);


/***/ }),

/***/ 1905:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(1684);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61e5ba02_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(1913);
function injectStyle (ssrContext) {
  __webpack_require__(1906)
  __webpack_require__(1908)
  this["$style"] = __webpack_require__(1910)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61e5ba02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61e5ba02_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1906:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1907);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("bdb1f0ee", content, true, {});

/***/ }),

/***/ 1907:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1908:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1909);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("019b295e", content, true, {});

/***/ }),

/***/ 1909:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1910:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1911);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("0fcbaeff", content, true, {});

/***/ }),

/***/ 1911:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1912:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgMjI2IDIyNiIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNi45NSwxNi45NSkgc2NhbGUoMC44NSwwLjg1KSI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJub256ZXJvIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgc3Ryb2tlLWxpbmVjYXA9ImJ1dHQiIHN0cm9rZS1saW5lam9pbj0ibWl0ZXIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWRhc2hhcnJheT0iIiBzdHJva2UtZGFzaG9mZnNldD0iMCIgZm9udC1mYW1pbHk9Im5vbmUiIGZvbnQtd2VpZ2h0PSJub25lIiBmb250LXNpemU9Im5vbmUiIHRleHQtYW5jaG9yPSJub25lIiBzdHlsZT0ibWl4LWJsZW5kLW1vZGU6IG5vcm1hbCI+PHBhdGggZD0iTTAsMjI2di0yMjZoMjI2djIyNnoiIGZpbGw9Im5vbmUiIHN0cm9rZT0ibm9uZSIvPjxnIHN0cm9rZT0ibm9uZSI+PGcgaWQ9InN1cmZhY2UxIj48cGF0aCBkPSJNMjA4LjM0Mzc1LDEwOS40Njg3NWMwLDU0LjYxMDIzIC00NC4yNjQ3Nyw5OC44NzUgLTk4Ljg3NSw5OC44NzVjLTU0LjYxMDIzLDAgLTk4Ljg3NSwtNDQuMjY0NzcgLTk4Ljg3NSwtOTguODc1YzAsLTU0LjYxMDIzIDQ0LjI2NDc3LC05OC44NzUgOTguODc1LC05OC44NzVjNTQuNjEwMjMsMCA5OC44NzUsNDQuMjY0NzcgOTguODc1LDk4Ljg3NXoiIGZpbGw9IiNjNWU0ZmEiLz48cGF0aCBkPSJNNDQuODg1NSwxODQuNjQ1NzVjOS4zNTIyOSw4LjkxMDg5IDIwLjM3MzY2LDE1Ljg5MDYzIDMyLjQxNTc3LDIwLjU1Mjk4bDEyMC40NDg3MywtMTIwLjQ0ODczdi0yMi43MDQ4M2MtMy43MjQzNiwtNi4xNzk2OSAtOC4xMjQ2MywtMTEuOTMxNzcgLTEzLjEwNDI1LC0xNy4xNTk2N3oiIGZpbGw9IiNlM2YyZmYiLz48cGF0aCBkPSJNMzguMDAyMzIsMTc3LjQwMzkzbDEzOC41NjAxOCwtMTM4LjU2MDE4aC0yMS4xODc1bC0xMjYuMzUyNTQsMTI2LjM1MjU0YzIuNjc2MDMsNC4yODk5MiA1LjY4MzExLDguMzcyOTMgOC45Nzk4NiwxMi4yMDc2NHoiIGZpbGw9IiNlM2YyZmYiLz48cGF0aCBkPSJNMjcuNTA1MTMsMTUyLjU4ODYybDExNy4yNzYxMiwtMTE3LjI3NjEybC0xMC41OTM3NSwtNy4wNjI1bC0xMTEuNzMwOTYsMTExLjczMDk2YzEuMzkzMTksNC4zMTc1IDMuMDc2MDUsOC41MjQ2NiA1LjA0ODU5LDEyLjYwNzY3eiIgZmlsbD0iI2UzZjJmZiIvPjxwYXRoIGQ9Ik0xMDkuNDY4NzUsMTAuNTkzNzVjLTU0LjYxMDIzLDAgLTk4Ljg3NSw0NC4yNjQ3NyAtOTguODc1LDk4Ljg3NWMwLDU0LjYxMDIzIDQ0LjI2NDc3LDk4Ljg3NSA5OC44NzUsOTguODc1YzU0LjYxMDIzLDAgOTguODc1LC00NC4yNjQ3NyA5OC44NzUsLTk4Ljg3NWMwLC01NC42MTAyMyAtNDQuMjY0NzcsLTk4Ljg3NSAtOTguODc1LC05OC44NzV6TTEwOS40Njg3NSwxODcuMTU2MjVjLTM0LjkyNjI3LDAgLTY1LjU2MjYyLC0yMy4yOTc5NyAtNzQuODg3MzMsLTU2Ljk2ODk5Yy05LjMxMDkxLC0zMy42NTcyMyA0Ljk3OTYxLC02OS4zOTczNCAzNC45NDAwNiwtODcuMzU3MDZjMjkuOTYwNDUsLTE3Ljk1OTcyIDY4LjIyNDg2LC0xMy43MTExOCA5My41MjI5NSwxMC4zODY4NGwyLjQwMDE1LDIuMzU4NzZjMC45MTA0LDAuOTUxNzggMS43OTMyMSwxLjkxNzM2IDIuNjQ4NDQsMi44OTY3M2MxOS45NzM2MywyMi45NjY5MiAyNC43MDQ5NSw1NS40OTMwNCAxMi4wODM1LDgzLjIwNTA4Yy0xMi42MjE0NiwyNy42OTgyNCAtNDAuMjY0NTMsNDUuNDc4NjQgLTcwLjcwNzc3LDQ1LjQ3ODY0eiIgZmlsbD0iIzcyY2FhZiIvPjxwYXRoIGQ9Ik0xMDkuNDY4NzUsMTg3LjE1NjI1Yy00Mi44OTkxNywwIC03Ny42ODc1LC0zNC43ODgzMyAtNzcuNjg3NSwtNzcuNjg3NWgtNS44NjI0M2MtNC4xOTMzNiwtMC4wMTM3OSAtOC4xNzk4MSwxLjgzNDU5IC0xMC44Njk2Myw1LjA0ODU5Yy0yLjY4OTgyLDMuMjEzOTkgLTMuODIwOTIsNy40NjI1MiAtMy4wNzYwNSwxMS41ODY5MWM4LjA2OTQ2LDQ3LjUzMzkzIDQ5LjI1ODE4LDgyLjMyMjI3IDk3LjQ4MTgxLDgyLjMyMjI3YzQ4LjIyMzYzLDAgODkuMzk4NTYsLTM0Ljc4ODMzIDk3LjQ4MTgxLC04Mi4zMjIyN2MwLjczMTA4LC00LjEyNDM5IC0wLjM4NjIzLC04LjM1OTEzIC0zLjA3NjA1LC0xMS41NzMxMmMtMi42NzYwMywtMy4yMTM5OSAtNi42NDg2OCwtNS4wNjIzOCAtMTAuODQyMDQsLTUuMDYyMzhoLTUuODYyNDNjMCw0Mi44OTkxNyAtMzQuNzg4MzMsNzcuNjg3NSAtNzcuNjg3NSw3Ny42ODc1eiIgZmlsbD0iIzY2YmZhMSIvPjxwYXRoIGQ9Ik0xNDcuMDcxMDUsOTQuNTAyMzJjMC43ODYyNSwtMC42NzU5IDEuMjQxNDUsLTEuNjU1MjcgMS4yNDE0NSwtMi42ODk4MnYtMjQuNzE4NzVjMC4wMjc1OSwtMS43NTE4MyAtMS4yNDE0NSwtMy4yNTUzNyAtMi45NjU3LC0zLjUzMTI1bC00Mi4zNzUsLTcuMDYyNWMtMS4wMjA3NSwtMC4xNzkzMiAtMi4wNjkwOSwwLjExMDM1IC0yLjg1NTM0LDAuNzcyNDZjLTAuODEzODQsMC42ODk3IC0xLjI2OTA0LDEuNjk2NjYgLTEuMjQxNDYsMi43NTg3OXY0Ni42Nzg3MWMtMi4zMTczOCwtMC41MjQxNyAtNC42ODk5NCwtMC43NzI0NiAtNy4wNjI1LC0wLjc3MjQ2Yy0xNS41NzMzNiwwIC0yOC4yNSwxMS4wOTAzMyAtMjguMjUsMjQuNzE4NzVjMCwxMy42Mjg0MiAxMi42NzY2NCwyNC43MTg3NSAyOC4yNSwyNC43MTg3NWMxNS41NzMzNiwwIDI4LjI1LC0xMS4wOTAzMyAyOC4yNSwtMjQuNzE4NzV2LTM5LjM2NzkybDI0LjE1MzIsNC4wNTU0MmMxLjAzNDU1LDAuMTUxNzMgMi4wODI4OSwtMC4xNTE3MyAyLjg1NTM1LC0wLjg0MTQzeiIgZmlsbD0iI2ZhZWZkZSIvPjxwYXRoIGQ9Ik0xMDkuNDY4NzUsNy4wNjI1Yy01Ni41NTUxOCwwIC0xMDIuNDA2MjUsNDUuODUxMDcgLTEwMi40MDYyNSwxMDIuNDA2MjVjMCw1Ni41NTUxOCA0NS44NTEwNywxMDIuNDA2MjUgMTAyLjQwNjI1LDEwMi40MDYyNWM1Ni41NTUxOCwwIDEwMi40MDYyNSwtNDUuODUxMDcgMTAyLjQwNjI1LC0xMDIuNDA2MjVjMCwtNTYuNTU1MTggLTQ1Ljg1MTA3LC0xMDIuNDA2MjUgLTEwMi40MDYyNSwtMTAyLjQwNjI1ek0xMDkuNDY4NzUsMjA0LjgxMjVjLTUyLjY1MTQ5LDAgLTk1LjM0Mzc1LC00Mi42OTIyNiAtOTUuMzQzNzUsLTk1LjM0Mzc1YzAsLTUyLjY1MTQ5IDQyLjY5MjI2LC05NS4zNDM3NSA5NS4zNDM3NSwtOTUuMzQzNzVjNTIuNjUxNDksMCA5NS4zNDM3NSw0Mi42OTIyNiA5NS4zNDM3NSw5NS4zNDM3NWMwLDUyLjY1MTQ5IC00Mi42OTIyNiw5NS4zNDM3NSAtOTUuMzQzNzUsOTUuMzQzNzV6IiBmaWxsPSIjOGQ2YzlmIi8+PHBhdGggZD0iTTEwOS40Njg3NSwxNzYuNTYyNWMtMS45NDQ5NSwwIC0zLjUzMTI1LDEuNTg2MyAtMy41MzEyNSwzLjUzMTI1djcuMDYyNWMwLDEuOTQ0OTUgMS41ODYzLDMuNTMxMjUgMy41MzEyNSwzLjUzMTI1YzEuOTQ0OTUsMCAzLjUzMTI1LC0xLjU4NjMgMy41MzEyNSwtMy41MzEyNXYtNy4wNjI1YzAsLTEuOTQ0OTUgLTEuNTg2MywtMy41MzEyNSAtMy41MzEyNSwtMy41MzEyNXoiIGZpbGw9IiM4ZDZjOWYiLz48cGF0aCBkPSJNMTMwLjY1NjI1LDE3Ni44MzgzOGMtMC41NTE3NiwtMS44MDcwMSAtMi40NTUzMiwtMi44NjkxNCAtNC4yODk5MiwtMi4zNzI1NmMtMS44NDgzOSwwLjQ5NjU4IC0yLjk1MTksMi4zNTg3NyAtMi41MjQyOSw0LjIyMDk1bDEuODM0NTksNi44MTQyMWMwLjUyNDE3LDEuODg5NzcgMi40NjkxMiwzLjAwNzA4IDQuMzU4ODksMi40ODI5MWMxLjg4OTc3LC0wLjUxMDM4IDMuMDA3MDgsLTIuNDY5MTIgMi40OTY3LC00LjM1ODg5eiIgZmlsbD0iIzhkNmM5ZiIvPjxwYXRoIGQ9Ik03Ni44MDQ2OSwxNjcuODAzMzRjLTAuODEzODQsLTAuNDY4OTkgLTEuNzc5NDIsLTAuNTkzMTQgLTIuNjg5ODIsLTAuMzU4NjRjLTAuOTEwNCwwLjI0ODI5IC0xLjY4Mjg2LDAuODU1MjIgLTIuMTUxODYsMS42NjkwN2wtMy41MzEyNSw2LjExMDcyYy0wLjg2OTAyLDEuNjY5MDcgLTAuMjc1ODgsMy43MzgxNiAxLjM2NTYsNC42ODk5NGMxLjY0MTQ4LDAuOTUxNzggMy43MzgxNiwwLjQyNzYxIDQuNzQ1MTIsLTEuMTU4NjlsMy41MzEyNSwtNi4xMTA3MmMwLjQ4Mjc5LC0wLjgxMzg0IDAuNjA2OTMsLTEuNzc5NDIgMC4zNzI0NCwtMi42ODk4MmMtMC4yMzQ1LC0wLjg5NjYxIC0wLjgyNzY0LC0xLjY4Mjg2IC0xLjY0MTQ4LC0yLjE1MTg2eiIgZmlsbD0iIzhkNmM5ZiIvPjxwYXRoIGQ9Ik0xNDYuOTc0NDksMTY5LjExMzc3Yy0xLjAyMDc1LC0xLjYwMDEgLTMuMTE3NDMsLTIuMTEwNDcgLTQuNzQ1MTIsLTEuMTU4NjljLTEuNjQxNDgsMC45Mzc5OSAtMi4yNDg0MSwzLjAwNzA4IC0xLjM2NTYsNC42ODk5NGwzLjUzMTI1LDYuMTEwNzJjMC41OTMxNCwxLjE0NDkgMS43Nzk0MiwxLjg3NTk4IDMuMDc2MDUsMS44ODk3N2MxLjI5NjYzLDAuMDEzNzkgMi40OTY3LC0wLjY3NTkgMy4xMzEyMywtMS44MDcwMWMwLjYzNDUyLC0xLjEzMTEgMC41OTMxNCwtMi41MjQyOSAtMC4wOTY1NiwtMy42MTQwMXoiIGZpbGw9IiM4ZDZjOWYiLz48cGF0aCBkPSJNOTIuNTU3MzcsMTc0LjM0MTY4Yy0xLjg4OTc3LC0wLjQ5NjU4IC0zLjgwNzEzLDAuNjIwNzMgLTQuMzE3NTEsMi40OTY3bC0xLjgzNDU5LDYuNzg2NjJjLTAuMzcyNDQsMS4yMjc2NiAtMC4wNTUxOCwyLjU3OTQ3IDAuODU1MjMsMy41MDM2NmMwLjg5NjYxLDAuOTI0MTkgMi4yMzQ2MiwxLjI4Mjg0IDMuNDc2MDcsMC45Mzc5OWMxLjI0MTQ1LC0wLjM0NDg1IDIuMTkzMjMsLTEuMzUxODEgMi40ODI5MSwtMi42MDcwNmwxLjg0ODM5LC02LjgxNDIxYzAuNDgyNzksLTEuODc1OTggLTAuNjM0NTIsLTMuODA3MTMgLTIuNTEwNSwtNC4zMDM3MXoiIGZpbGw9IiM4ZDZjOWYiLz48cGF0aCBkPSJNMTQ3LjA3MTA1LDk0LjUwMjMyYzAuNzg2MjUsLTAuNjc1OSAxLjI0MTQ1LC0xLjY1NTI3IDEuMjQxNDUsLTIuNjg5ODJ2LTI0LjcxODc1YzAuMDI3NTksLTEuNzUxODMgLTEuMjQxNDUsLTMuMjU1MzcgLTIuOTY1NywtMy41MzEyNWwtNDIuMzc1LC03LjA2MjVjLTEuMDIwNzUsLTAuMTc5MzIgLTIuMDY5MDksMC4xMTAzNSAtMi44NTUzNCwwLjc3MjQ2Yy0wLjgxMzg0LDAuNjg5NyAtMS4yNjkwNCwxLjY5NjY2IC0xLjI0MTQ2LDIuNzU4Nzl2NDYuNjc4NzFjLTIuMzE3MzgsLTAuNTI0MTcgLTQuNjg5OTQsLTAuNzcyNDYgLTcuMDYyNSwtMC43NzI0NmMtMTUuNTczMzYsMCAtMjguMjUsMTEuMDkwMzMgLTI4LjI1LDI0LjcxODc1YzAsMTMuNjI4NDIgMTIuNjc2NjQsMjQuNzE4NzUgMjguMjUsMjQuNzE4NzVjMTUuNTczMzYsMCAyOC4yNSwtMTEuMDkwMzMgMjguMjUsLTI0LjcxODc1di0zOS4zNjc5MmwyNC4xNTMyLDQuMDU1NDJjMS4wMzQ1NSwwLjE1MTczIDIuMDgyODksLTAuMTUxNzMgMi44NTUzNSwtMC44NDE0M3pNMTQxLjI1LDg3LjY0NjczbC0yNC4xNTMyLC00LjAyNzgzYy0xLjAzNDU0LC0wLjE2NTUzIC0yLjA4Mjg4LDAuMTI0MTQgLTIuODY5MTQsMC44MTM4NGMtMC43ODYyNSwwLjY3NTkxIC0xLjI0MTQ1LDEuNjY5MDcgLTEuMjI3NjYsMi43MTc0MXY0My41MDYxYzAsOS43NTIzMiAtOS41MDQwMywxNy42NTYyNSAtMjEuMTg3NSwxNy42NTYyNWMtMTEuNjgzNDcsMCAtMjEuMTg3NSwtNy45MDM5MyAtMjEuMTg3NSwtMTcuNjU2MjVjMCwtOS43NTIzMiA5LjUwNDAzLC0xNy42NTYyNSAyMS4xODc1LC0xNy42NTYyNWMzLjE3MjYxLDAgNi4zMTc2MywwLjYwNjkzIDkuMjU1NzQsMS44MDcwMWMxLjA4OTcyLDAuNDQxNDEgMi4zMzExOCwwLjMxNzI2IDMuMzEwNTUsLTAuMzQ0ODVjMC45NzkzNywtMC42NjIxMSAxLjU1ODcxLC0xLjc2NTYyIDEuNTU4NzEsLTIuOTUxOTF2LTQ3LjMxMzIzbDM1LjMxMjUsNS45MDM4MXoiIGZpbGw9IiM4ZDZjOWYiLz48cGF0aCBkPSJNMTM1LjQyODk2LDM5Ljk3NDg2YzIuNTI0MjksMC45NTE3OCA0Ljk5MzQxLDIuMDI3NzEgNy40MDczNSwzLjI0MTU3YzAuNDk2NTgsMC4yNjIwOSAxLjAzNDU1LDAuMzg2MjMgMS41ODYzLDAuNDAwMDNjMS42Mjc2OCwtMC4wMTM4IDMuMDQ4NDYsLTEuMTMxMTEgMy40MjA5LC0yLjcxNzQxYzAuMzcyNDMsLTEuNTg2MyAtMC4zNzI0NCwtMy4yMTM5OSAtMS44MjA4LC0zLjk1ODg2Yy0yLjY0ODQ0LC0xLjMyNDIyIC01LjM1MjA1LC0yLjUxMDUgLTguMTI0NjQsLTMuNTMxMjVjLTEuNzkzMjEsLTAuNTUxNzYgLTMuNjk2NzgsMC4zNzI0MyAtNC4zNTg4OSwyLjEzODA2Yy0wLjY0ODMxLDEuNzUxODMgMC4xNjU1MywzLjcxMDU3IDEuODg5NzcsNC40NTU0NXoiIGZpbGw9IiM4ZDZjOWYiLz48cGF0aCBkPSJNNTcuMDI0MTcsNTcuMDI0MTdjMTYuODY5OTksLTE2Ljc4NzIzIDQwLjczMzUyLC0yNC41MTE4NCA2NC4yMzg0LC0yMC43NTk4OWMxLjk0NDk1LDAuMzE3MjYgMy43Nzk1NCwtMS4wMjA3NSA0LjA5NjgsLTIuOTY1N2MwLjMxNzI2LC0xLjk0NDk1IC0xLjAyMDc1LC0zLjc3OTU0IC0yLjk2NTcsLTQuMDk2OGMtMzQuODE1OTIsLTUuNjU1NTIgLTY5LjMxNDU3LDExLjgwNzYyIC04NS4zNzA3Myw0My4yMzAyM2MtMTYuMDQyMzYsMzEuNDA4ODEgLTkuOTczMDIsNjkuNTkwNDUgMTUuMDIxNjEsOTQuNDg4NTJjMS40MDY5OCwxLjIwMDA3IDMuNDg5ODcsMS4xMTczMSA0LjgwMDI5LC0wLjE3OTMyYzEuMzEwNDMsLTEuMzEwNDMgMS4zNzkzOSwtMy4zOTMzMSAwLjE3OTMyLC00LjgwMDI5Yy0yOC45ODEwOCwtMjguOTY3MjkgLTI4Ljk4MTA4LC03NS45NDk0NiAwLC0xMDQuOTE2NzV6IiBmaWxsPSIjOGQ2YzlmIi8+PHBhdGggZD0iTTE2Ni44OTI5NSw1Mi4wNDQ1NWMtMi4zMzExOCwtMi4zMzExOCAtNC44MDAyOSwtNC41MjQ0MSAtNy4zNzk3NiwtNi41NjU5MmMtMC45NzkzNywtMC44ODI4MSAtMi4zODYzNSwtMS4xNTg2OSAtMy42Mjc4MSwtMC42ODk3Yy0xLjI0MTQ1LDAuNDU1MiAtMi4xMTA0NywxLjU3MjUxIC0yLjI2MjIxLDIuODk2NzNjLTAuMTUxNzMsMS4zMTA0MyAwLjQ0MTQxLDIuNjA3MDYgMS41NDQ5MiwzLjMzODE0YzIuMzU4NzcsMS44NjIxOCA0LjYwNzE4LDMuODc2MSA2Ljc0NTI0LDYuMDAwMzdjMjguOTUzNDksMjguOTY3MjkgMjguOTUzNDksNzUuOTIxODggMCwxMDQuODg5MTZjLTEuMDA2OTYsMC44NTUyMiAtMS40NDgzNywyLjIwNzAzIC0xLjE0NDksMy41MDM2NmMwLjMxNzI2LDEuMjgyODQgMS4zMjQyMiwyLjI4OTggMi42MDcwNSwyLjYwNzA1YzEuMjk2NjMsMC4zMDM0NyAyLjY0ODQ0LC0wLjEyNDE0IDMuNTE3NDYsLTEuMTMxMWMzMS42OTg0OCwtMzEuNzI2MDcgMzEuNjk4NDgsLTgzLjEyMjMyIDAsLTExNC44NDgzOXoiIGZpbGw9IiM4ZDZjOWYiLz48L2c+PC9nPjwvZz48L2c+PC9zdmc+Cg=="

/***/ }),

/***/ 1913:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.visible,"width":"500px"},on:{"update:visible":function($event){_vm.visible=$event},"close":_vm.onClose}},[_c('div',{staticStyle:{"margin":"-20px -10px"}},[_c('audio',{ref:"audio",attrs:{"src":_vm.src,"controls":"","autoplay":""}},[_vm._v("\n      您的浏览器不支持 audio 标签。\n    ")])]),_vm._v(" "),_c('button',{ref:"audioPip",staticClass:"plyr__controls__item plyr__control",staticStyle:{"display":"inline-block"},attrs:{"type":"button","data-plyr":"pip"},on:{"click":_vm.audioPip}},[_c('svg',{attrs:{"role":"presentation","focusable":"false"}},[_c('use',{attrs:{"xlink:href":"#plyr-pip"}})]),_vm._v(" "),_c('span',{staticClass:"plyr__tooltip"},[_vm._v("画中画")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1914:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SjPlyrVideoBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main_vue__ = __webpack_require__(1915);




var defaults = {};

var MainConstructor = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.extend(__WEBPACK_IMPORTED_MODULE_2__main_vue__["a" /* default */]);

var instance = void 0,
    currentBox = void 0;

var defaultCallback = function defaultCallback(action) {
  if (currentBox) {
    var callback = currentBox.callback;
    if (typeof callback === 'function') {
      callback(action);
    }
    if (currentBox.resolve) {
      if (action === 'confirm') {
        currentBox.resolve(action);
      } else if (currentBox.reject && (action === 'cancel' || action === 'close')) {
        currentBox.reject(action);
      }
    }
  }
};

var initInstance = function initInstance() {
  instance = new MainConstructor({
    el: document.createElement('div')
  });

  instance.callback = defaultCallback;
};

var showBox = function showBox() {
  if (!instance) {
    initInstance();
  }

  instance.action = '';

  if (!instance.visible || instance.closeTimer) {
    if (currentBox) {
      var options = currentBox.options;
      for (var prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop];
        }
      }

      if (options.callback === undefined) {
        instance.callback = defaultCallback;
      }

      var oldCb = instance.callback;
      instance.callback = function (action, instance) {
        oldCb(action, instance);
      };

      document.body.appendChild(instance.$el);

      __WEBPACK_IMPORTED_MODULE_1_vue___default.a.nextTick(function () {
        instance.visible = true;
      });
    }
  }
};

var SjPlyrVideoBox = function SjPlyrVideoBox(options, callback) {
  if (__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$isServer) return;
  if (typeof options === 'string') {
    options = {
      message: options
    };
    if (typeof arguments[1] === 'string') {
      options.title = arguments[1];
    }
  } else if (options.callback && !callback) {
    callback = options.callback;
  }

  if (typeof __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a !== 'undefined') {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      // eslint-disable-line
      currentBox = {
        options: _.merge({}, defaults, SjPlyrVideoBox.defaults, options),
        callback: callback,
        resolve: resolve,
        reject: reject
      };

      showBox();
    });
  } else {
    currentBox = {
      options: _.merge({}, defaults, SjPlyrVideoBox.defaults, options),
      callback: callback
    };

    showBox();
  }
};

SjPlyrVideoBox.setDefaults = function (defaults) {
  SjPlyrVideoBox.defaults = defaults;
};

SjPlyrVideoBox.open = function (file) {
  var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '视频播放';
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return SjPlyrVideoBox(_.merge({
    title: title,
    file: file
  }, options));
};

SjPlyrVideoBox.close = function () {
  instance.doClose();
  instance.visible = false;
  currentBox = null;
};

SjPlyrVideoBox.destroy = function () {
  if (instance) {
    instance.$el.remove();
    instance.$destroy();
    instance = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (SjPlyrVideoBox);


/***/ }),

/***/ 1915:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(1685);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f50239ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(1922);
function injectStyle (ssrContext) {
  __webpack_require__(1916)
  __webpack_require__(1918)
  this["$style"] = __webpack_require__(1920)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f50239ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f50239ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1916:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1917);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("4a69d726", content, true, {});

/***/ }),

/***/ 1917:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1918:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1919);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("f6c82d7a", content, true, {});

/***/ }),

/***/ 1919:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1920:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1921);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("496fbbe3", content, true, {});

/***/ }),

/***/ 1921:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1922:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.visible,"top":"40px","width":"75%"},on:{"update:visible":function($event){_vm.visible=$event},"close":_vm.onClose}},[_c('div',{staticStyle:{"margin":"-20px -10px"}},[_c('video',{ref:"video",attrs:{"autoplay":"","playsinline":"","controls":""}},[_vm._v("\n      您的浏览器不支持 video 标签。\n    ")])]),_vm._v(" "),_c('button',{ref:"videoRotate",staticClass:"plyr__control",attrs:{"type":"button"},on:{"click":_vm.onRotate}},[_c('svg',{attrs:{"role":"presentation"}},[_c('use',{attrs:{"xlink:href":"#plyr-restart"}})]),_vm._v(" "),_c('span',{staticClass:"plyr__tooltip",attrs:{"role":"tooltip"}},[_vm._v("旋转90°")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__format_convert_fields_option__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__format_convert_fields_option_types__ = __webpack_require__(1614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_question_editor_utils_function__ = __webpack_require__(1551);





var options = {
  number: 1,
  id: function id() {
    return 'OPT' + Object(__WEBPACK_IMPORTED_MODULE_3__views_question_editor_utils_function__["c" /* dateNumber */])() + options.number++;
  },
  make: function make(type) {
    var data = {};
    __WEBPACK_IMPORTED_MODULE_2__format_convert_fields_option_types__["a" /* default */][type].forEach(function (field) {
      data[field] = __WEBPACK_IMPORTED_MODULE_1__format_convert_fields_option__["a" /* default */][field];
    });
    data.id = this.id('option');
    return Object(__WEBPACK_IMPORTED_MODULE_3__views_question_editor_utils_function__["b" /* copyJson */])(data);
  },
  insert: function insert(options, option, index) {
    // 默认 index
    !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(index) && (index = options.length);
    options.splice(index, 0, option);
    return option;
  },
  create: function create(options, type, index) {
    return this.insert(options, this.make(type), index);
  },
  up: function up(options, index) {
    if (index) {
      // 交换位置
      return Object(__WEBPACK_IMPORTED_MODULE_3__views_question_editor_utils_function__["a" /* arraySwap */])(options, index, index - 1);
    }
    return false;
  },
  down: function down(options, index) {
    if (index < options.length - 1) {
      // 交换位置
      return Object(__WEBPACK_IMPORTED_MODULE_3__views_question_editor_utils_function__["a" /* arraySwap */])(options, index, index + 1);
    }
    return false;
  },
  remove: function remove(options, index) {
    options.splice(index, 1);
  },
  copy: function copy(options, fromIndex, toIndex) {
    var newOption = Object(__WEBPACK_IMPORTED_MODULE_3__views_question_editor_utils_function__["b" /* copyJson */])(options[fromIndex]);
    newOption.id = this.id();
    options.splice(toIndex, 0, newOption);
    return newOption;
  },

  /**
   * 移除依赖这个选项的相关内容
   * @param options
   * @param optionId
   */
  removeDependency: function removeDependency(options, optionId) {
    options.forEach(function (option) {
      if (option.mutexOptions) {
        var index = option.mutexOptions.indexOf(optionId);
        if (index !== -1) {
          option.mutexOptions.splice(index, 1);
        }
      }
    });
  },
  addDependency: function addDependency(options, option) {
    if (option.mutexOptions) {
      options.forEach(function (_option) {
        if (option.mutexOptions.includes(_option.id)) {
          _option.mutexOptions.push(option.id);
        }
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (options);

/***/ }),

/***/ 2109:
/***/ (function(module, exports, __webpack_require__) {

/*!
 * clipboard.js v2.0.4
 * https://zenorocha.github.io/clipboard.js
 * 
 * Licensed MIT © Zeno Rocha
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ClipboardJS"] = factory();
	else
		root["ClipboardJS"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboardAction = __webpack_require__(1);

var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

var _tinyEmitter = __webpack_require__(3);

var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

var _goodListener = __webpack_require__(4);

var _goodListener2 = _interopRequireDefault(_goodListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */
var Clipboard = function (_Emitter) {
    _inherits(Clipboard, _Emitter);

    /**
     * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
     * @param {Object} options
     */
    function Clipboard(trigger, options) {
        _classCallCheck(this, Clipboard);

        var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

        _this.resolveOptions(options);
        _this.listenClick(trigger);
        return _this;
    }

    /**
     * Defines if attributes would be resolved using internal setter functions
     * or custom functions that were passed in the constructor.
     * @param {Object} options
     */


    _createClass(Clipboard, [{
        key: 'resolveOptions',
        value: function resolveOptions() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
            this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
            this.text = typeof options.text === 'function' ? options.text : this.defaultText;
            this.container = _typeof(options.container) === 'object' ? options.container : document.body;
        }

        /**
         * Adds a click event listener to the passed trigger.
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         */

    }, {
        key: 'listenClick',
        value: function listenClick(trigger) {
            var _this2 = this;

            this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                return _this2.onClick(e);
            });
        }

        /**
         * Defines a new `ClipboardAction` on each click event.
         * @param {Event} e
         */

    }, {
        key: 'onClick',
        value: function onClick(e) {
            var trigger = e.delegateTarget || e.currentTarget;

            if (this.clipboardAction) {
                this.clipboardAction = null;
            }

            this.clipboardAction = new _clipboardAction2.default({
                action: this.action(trigger),
                target: this.target(trigger),
                text: this.text(trigger),
                container: this.container,
                trigger: trigger,
                emitter: this
            });
        }

        /**
         * Default `action` lookup function.
         * @param {Element} trigger
         */

    }, {
        key: 'defaultAction',
        value: function defaultAction(trigger) {
            return getAttributeValue('action', trigger);
        }

        /**
         * Default `target` lookup function.
         * @param {Element} trigger
         */

    }, {
        key: 'defaultTarget',
        value: function defaultTarget(trigger) {
            var selector = getAttributeValue('target', trigger);

            if (selector) {
                return document.querySelector(selector);
            }
        }

        /**
         * Returns the support of the given action, or all actions if no action is
         * given.
         * @param {String} [action]
         */

    }, {
        key: 'defaultText',


        /**
         * Default `text` lookup function.
         * @param {Element} trigger
         */
        value: function defaultText(trigger) {
            return getAttributeValue('text', trigger);
        }

        /**
         * Destroy lifecycle.
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            this.listener.destroy();

            if (this.clipboardAction) {
                this.clipboardAction.destroy();
                this.clipboardAction = null;
            }
        }
    }], [{
        key: 'isSupported',
        value: function isSupported() {
            var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

            var actions = typeof action === 'string' ? [action] : action;
            var support = !!document.queryCommandSupported;

            actions.forEach(function (action) {
                support = support && !!document.queryCommandSupported(action);
            });

            return support;
        }
    }]);

    return Clipboard;
}(_tinyEmitter2.default);

/**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */


function getAttributeValue(suffix, element) {
    var attribute = 'data-clipboard-' + suffix;

    if (!element.hasAttribute(attribute)) {
        return;
    }

    return element.getAttribute(attribute);
}

module.exports = Clipboard;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _select = __webpack_require__(2);

var _select2 = _interopRequireDefault(_select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Inner class which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 */
var ClipboardAction = function () {
    /**
     * @param {Object} options
     */
    function ClipboardAction(options) {
        _classCallCheck(this, ClipboardAction);

        this.resolveOptions(options);
        this.initSelection();
    }

    /**
     * Defines base properties passed from constructor.
     * @param {Object} options
     */


    _createClass(ClipboardAction, [{
        key: 'resolveOptions',
        value: function resolveOptions() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.action = options.action;
            this.container = options.container;
            this.emitter = options.emitter;
            this.target = options.target;
            this.text = options.text;
            this.trigger = options.trigger;

            this.selectedText = '';
        }

        /**
         * Decides which selection strategy is going to be applied based
         * on the existence of `text` and `target` properties.
         */

    }, {
        key: 'initSelection',
        value: function initSelection() {
            if (this.text) {
                this.selectFake();
            } else if (this.target) {
                this.selectTarget();
            }
        }

        /**
         * Creates a fake textarea element, sets its value from `text` property,
         * and makes a selection on it.
         */

    }, {
        key: 'selectFake',
        value: function selectFake() {
            var _this = this;

            var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

            this.removeFake();

            this.fakeHandlerCallback = function () {
                return _this.removeFake();
            };
            this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

            this.fakeElem = document.createElement('textarea');
            // Prevent zooming on iOS
            this.fakeElem.style.fontSize = '12pt';
            // Reset box model
            this.fakeElem.style.border = '0';
            this.fakeElem.style.padding = '0';
            this.fakeElem.style.margin = '0';
            // Move element out of screen horizontally
            this.fakeElem.style.position = 'absolute';
            this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
            // Move element to the same position vertically
            var yPosition = window.pageYOffset || document.documentElement.scrollTop;
            this.fakeElem.style.top = yPosition + 'px';

            this.fakeElem.setAttribute('readonly', '');
            this.fakeElem.value = this.text;

            this.container.appendChild(this.fakeElem);

            this.selectedText = (0, _select2.default)(this.fakeElem);
            this.copyText();
        }

        /**
         * Only removes the fake element after another click event, that way
         * a user can hit `Ctrl+C` to copy because selection still exists.
         */

    }, {
        key: 'removeFake',
        value: function removeFake() {
            if (this.fakeHandler) {
                this.container.removeEventListener('click', this.fakeHandlerCallback);
                this.fakeHandler = null;
                this.fakeHandlerCallback = null;
            }

            if (this.fakeElem) {
                this.container.removeChild(this.fakeElem);
                this.fakeElem = null;
            }
        }

        /**
         * Selects the content from element passed on `target` property.
         */

    }, {
        key: 'selectTarget',
        value: function selectTarget() {
            this.selectedText = (0, _select2.default)(this.target);
            this.copyText();
        }

        /**
         * Executes the copy operation based on the current selection.
         */

    }, {
        key: 'copyText',
        value: function copyText() {
            var succeeded = void 0;

            try {
                succeeded = document.execCommand(this.action);
            } catch (err) {
                succeeded = false;
            }

            this.handleResult(succeeded);
        }

        /**
         * Fires an event based on the copy operation result.
         * @param {Boolean} succeeded
         */

    }, {
        key: 'handleResult',
        value: function handleResult(succeeded) {
            this.emitter.emit(succeeded ? 'success' : 'error', {
                action: this.action,
                text: this.selectedText,
                trigger: this.trigger,
                clearSelection: this.clearSelection.bind(this)
            });
        }

        /**
         * Moves focus away from `target` and back to the trigger, removes current selection.
         */

    }, {
        key: 'clearSelection',
        value: function clearSelection() {
            if (this.trigger) {
                this.trigger.focus();
            }

            window.getSelection().removeAllRanges();
        }

        /**
         * Sets the `action` to be performed which can be either 'copy' or 'cut'.
         * @param {String} action
         */

    }, {
        key: 'destroy',


        /**
         * Destroy lifecycle.
         */
        value: function destroy() {
            this.removeFake();
        }
    }, {
        key: 'action',
        set: function set() {
            var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

            this._action = action;

            if (this._action !== 'copy' && this._action !== 'cut') {
                throw new Error('Invalid "action" value, use either "copy" or "cut"');
            }
        }

        /**
         * Gets the `action` property.
         * @return {String}
         */
        ,
        get: function get() {
            return this._action;
        }

        /**
         * Sets the `target` property using an element
         * that will be have its content copied.
         * @param {Element} target
         */

    }, {
        key: 'target',
        set: function set(target) {
            if (target !== undefined) {
                if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                    if (this.action === 'copy' && target.hasAttribute('disabled')) {
                        throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                    }

                    if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                        throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                    }

                    this._target = target;
                } else {
                    throw new Error('Invalid "target" value, use a valid Element');
                }
            }
        }

        /**
         * Gets the `target` property.
         * @return {String|HTMLElement}
         */
        ,
        get: function get() {
            return this._target;
        }
    }]);

    return ClipboardAction;
}();

module.exports = ClipboardAction;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__(5);
var delegate = __webpack_require__(6);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__(7);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ })
/******/ ]);
});

/***/ }),

/***/ 2561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_question_editor_packages_sj_question_number_src_SjQuestionNumber__ = __webpack_require__(3410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_question_editor_packages_sj_question_src_SjQuestion__ = __webpack_require__(2563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_step_template_components_StepTemplateInfo__ = __webpack_require__(3426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_step_template_components_StepTemplateQuestionAttr__ = __webpack_require__(3434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_step_template_components_StepTemplateQuestionOptionAttr__ = __webpack_require__(3451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_step_template_components_StepTemplateQuestions__ = __webpack_require__(3459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_step_template_components_StepTemplateQuestionType__ = __webpack_require__(3611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_question_editor_format_convert__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_question_editor_format_recovery__ = __webpack_require__(1678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_gsap_TweenLite__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuedraggable__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_question_editor_components_question_cache_box__ = __webpack_require__(3619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_question_editor_components_question_tree_box__ = __webpack_require__(3634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_step_template_components_SendQuestionTo__ = __webpack_require__(3642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_step_template_data_step_template_append_questions__ = __webpack_require__(3650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_step_template_data_step_template_append_questions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__views_step_template_data_step_template_append_questions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_step_template_data_step_template_default_questions__ = __webpack_require__(3651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_step_template_data_step_template_default_questions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__views_step_template_data_step_template_default_questions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_question_editor_utils_checkFix__ = __webpack_require__(3652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_question_editor_utils_validate__ = __webpack_require__(3653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_step_template_components_CheckQuestionFix__ = __webpack_require__(3654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_step_template_components_CopyQuestionTo__ = __webpack_require__(3662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_step_template_components_StepTemplateDataLabels__ = __webpack_require__(3670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_step_template_components_ValidateQuestionWarning__ = __webpack_require__(3674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_clipboard__ = __webpack_require__(2109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_question_editor_components_image_view_box__ = __webpack_require__(1885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_question_editor_components_question_image_upload_box__ = __webpack_require__(3682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_question_editor_packages_sj_question_upload_video_box__ = __webpack_require__(1818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__core_components_sj_plyr_audio_box__ = __webpack_require__(1819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__core_components_sj_plyr_video_box__ = __webpack_require__(1820);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















// import StepTemplateValidator from '@/views/step-template/components/StepTemplateValidator'














var clipboard = void 0;
var actionPanelObserver = null;
var timer = null;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CheckQuestionFix: __WEBPACK_IMPORTED_MODULE_25__views_step_template_components_CheckQuestionFix__["a" /* default */],
    ValidateQuestionWarning: __WEBPACK_IMPORTED_MODULE_28__views_step_template_components_ValidateQuestionWarning__["a" /* default */],
    CopyQuestionTo: __WEBPACK_IMPORTED_MODULE_26__views_step_template_components_CopyQuestionTo__["a" /* default */],
    StepTemplateDataLabels: __WEBPACK_IMPORTED_MODULE_27__views_step_template_components_StepTemplateDataLabels__["a" /* default */],
    SendQuestionTo: __WEBPACK_IMPORTED_MODULE_20__views_step_template_components_SendQuestionTo__["a" /* default */],
    SjQuestion: __WEBPACK_IMPORTED_MODULE_8__views_question_editor_packages_sj_question_src_SjQuestion__["a" /* default */],
    StepTemplateQuestionOptionAttr: __WEBPACK_IMPORTED_MODULE_11__views_step_template_components_StepTemplateQuestionOptionAttr__["a" /* default */],
    SjQuestionNumber: __WEBPACK_IMPORTED_MODULE_7__views_question_editor_packages_sj_question_number_src_SjQuestionNumber__["a" /* default */],
    StepTemplateQuestionAttr: __WEBPACK_IMPORTED_MODULE_10__views_step_template_components_StepTemplateQuestionAttr__["a" /* default */],
    StepTemplateInfo: __WEBPACK_IMPORTED_MODULE_9__views_step_template_components_StepTemplateInfo__["a" /* default */],
    StepTemplateQuestionType: __WEBPACK_IMPORTED_MODULE_13__views_step_template_components_StepTemplateQuestionType__["a" /* default */],
    StepTemplateQuestions: __WEBPACK_IMPORTED_MODULE_12__views_step_template_components_StepTemplateQuestions__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_17_vuedraggable___default.a
  },
  inject: ['scope', 'request', 'create', 'update', 'visibleGuide'],
  provide: function provide() {
    return {
      page: this,
      playAudio: __WEBPACK_IMPORTED_MODULE_33__core_components_sj_plyr_audio_box__["a" /* default */].open,
      playVideo: __WEBPACK_IMPORTED_MODULE_34__core_components_sj_plyr_video_box__["a" /* default */].open,
      playImage: __WEBPACK_IMPORTED_MODULE_30__views_question_editor_components_image_view_box__["a" /* default */].open,
      uploadImage: __WEBPACK_IMPORTED_MODULE_31__views_question_editor_components_question_image_upload_box__["a" /* default */].open,
      uploadVideo: __WEBPACK_IMPORTED_MODULE_32__views_question_editor_packages_sj_question_upload_video_box__["a" /* default */].open
    };
  },
  data: function data() {
    var form = {
      title: '',
      detail: '',
      through_record: true,
      through_record_flag: true,
      extended_steps_start: 0,
      has_sneak_photos: false
    };
    if (this.scope === 'clb') {
      form.salary = 0;
      form.points = 0;
    }
    return {
      id: 0,
      ownUserId: '',
      cacheKey: 'create',
      form: form,
      questions: [],
      lastQuestions: [],
      defaultQuestionIds: [],
      appendQuestionIds: [],
      // 验证失败的题目列表
      validateFailQuestionIds: [],
      buttons: [{
        tip: '上移',
        icon: 'sj-icon-shift-up',
        action: 'up'
      }, {
        tip: '下移',
        icon: 'sj-icon-shift-down',
        action: 'down'
      }, {
        tip: '复制',
        icon: 'sj-icon-copy',
        action: 'copy'
      }, {
        tip: '移除',
        icon: 'el-icon-delete',
        action: 'remove'
      }],
      questionAttrHeight: '',
      sjQuestionItems: [],
      loading: true,
      collapse: {
        base: false,
        guide: false
      },
      disabled: {
        base: false,
        guide: false,
        add: false
      },
      visibleUploadVideoBox: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, Vuex.mapState('stepTemplate', {
    types: function types(state) {
      return state.types;
    },
    focusQuestionIndex: function focusQuestionIndex(state) {
      return state.focusQuestionIndex;
    },
    focusOptionIndex: function focusOptionIndex(state) {
      return state.focusOptionIndex;
    }
  }), Vuex.mapState({
    clientHeight: function clientHeight(state) {
      return state.clientHeight;
    },
    users: function users(state) {
      return state.login.user;
    }
  }), {
    rightHeight: function rightHeight() {
      return this.clientHeight - 106;
    },
    focusQuestion: function focusQuestion() {
      if (this.focusQuestionIndex !== null) {
        return this.questions[this.focusQuestionIndex];
      }
    },
    focusOption: function focusOption() {
      if (this.focusOptionIndex !== null) {
        return this.focusQuestion.options[this.focusOptionIndex];
      }
    },
    hasQuestionFocus: function hasQuestionFocus() {
      return this.focusQuestion && !this.focusOption;
    },
    hasOptionFocus: function hasOptionFocus() {
      return this.focusQuestion && this.focusOption;
    },
    allowSave: function allowSave() {
      return ['', this.users.id].includes(this.ownUserId) || parseInt(this.users.usertype) === 1 || filter.hasPermission(97);
    }
  }),
  watch: {
    questions: {
      handler: function handler(val) {
        !this.loading && val.length && __WEBPACK_IMPORTED_MODULE_18__views_question_editor_components_question_cache_box__["a" /* default */].cache('question-editor', this.cacheKey, val);
      },

      deep: true
    },
    // 开启全程录音后，不能有录音题
    'form.through_record': {
      handler: function handler(val) {
        if (val) {
          this.form.through_record_flag = true;
        } else {
          this.form.through_record_flag = false;
        }
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    next();
    this.onReload();
  },
  created: function created() {},
  mounted: function mounted() {
    this.questionAttrHeight = this.rightHeight - this.$refs.stepTemplateAction.clientHeight - 68;
    this.addListenActionPanelStyle();
    this.copyQuestions();
    document.addEventListener('paste', this.pasteQuestions);
  },
  destroyed: function destroyed() {
    this.removeListenActionPanelStyle();
    __WEBPACK_IMPORTED_MODULE_18__views_question_editor_components_question_cache_box__["a" /* default */].destroy();
    __WEBPACK_IMPORTED_MODULE_19__views_question_editor_components_question_tree_box__["a" /* default */].destroy();
    clipboard.destroy();
    document.removeEventListener('paste', this.pasteQuestions);

    __WEBPACK_IMPORTED_MODULE_33__core_components_sj_plyr_audio_box__["a" /* default */].destroy();
    __WEBPACK_IMPORTED_MODULE_34__core_components_sj_plyr_video_box__["a" /* default */].destroy();
    __WEBPACK_IMPORTED_MODULE_30__views_question_editor_components_image_view_box__["a" /* default */].destroy();
    __WEBPACK_IMPORTED_MODULE_31__views_question_editor_components_question_image_upload_box__["a" /* default */].destroy();
    __WEBPACK_IMPORTED_MODULE_32__views_question_editor_packages_sj_question_upload_video_box__["a" /* default */].destroy();
  },

  methods: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, Vuex.mapMutations('questionEditor', ['convertQuestions', 'recoveryNativeQuestions']), {
    checkPermission: function checkPermission() {
      // 显示任务指引时
      if (this.visibleGuide && !filter.superPermission()) {
        // 97: 编辑分步模板指引权限
        if (!filter.inPermissions(97)) {
          this.disabled.guide = true;
          this.collapse.guide = true;
        }

        // 用户没有修改模板的权限，或者用户不是模板的作者，则禁用模板的编辑功能
        // 93: 编辑分步模板权限
        if (!filter.inPermissions(93) || !['', this.users.id].includes(this.ownUserId)) {
          this.collapse.base = true;
          this.disabled.add = true;
          this.disabled.base = true;
        }
      }
    },

    /**
     * 复制模板数据到剪切板
     */
    copyQuestions: function copyQuestions() {
      var _this = this;

      clipboard = new __WEBPACK_IMPORTED_MODULE_29_clipboard___default.a(this.$refs.copyQuestions, {
        text: function text() {
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()({
            version: 1,
            date: filter.formatDate(),
            converted: true,
            type: 'questions',
            title: _this.form.title,
            detail: _this.form.detail,
            data: _this.questions
          });
        }
      });
      clipboard.on('success', function () {
        _this.$message({
          message: '复制模板数据成功！',
          type: 'success'
        });
      });
      clipboard.on('error', function () {
        _this.$message({
          message: '复制模板数据失败！',
          type: 'error'
        });
      });
    },
    pasteQuestions: function pasteQuestions(event) {
      var _this2 = this;

      var paste = (event.clipboardData || window.clipboardData).getData('text');
      try {
        var data = JSON.parse(paste);
        if (data && (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(data)) === 'object' && data.type === 'questions' && data.data) {
          event.stopPropagation();
          event.preventDefault();
          var title = data.title || '未命名';
          this.$confirm('\u53D1\u73B0[' + title + ']\u5206\u6B65\u6A21\u677F\u6570\u636E\uFF0C\u662F\u5426\u7ACB\u5373\u5199\u5165\u5F53\u524D\u6A21\u677F\uFF1F', '提示', { type: 'warning' }).then(function () {
            if (!data.converted) {
              try {
                data.data = Object(__WEBPACK_IMPORTED_MODULE_14__views_question_editor_format_convert__["b" /* convertQuestions */])(data.data);
              } catch (e) {
                return _this2.$message.error('模板数据转换失败，请检查数据正确性！');
              }
            }
            _this2.questions = data.data;
            _this2.form.title = data.title;
            _this2.form.detail = data.detail;
            _this2.$message.success('模板数据写入成功！');
          });
        }
      } catch (e) {}
    },
    addListenActionPanelStyle: function addListenActionPanelStyle() {
      var _this3 = this;

      // Create an observer instance linked to the callback function
      actionPanelObserver = new MutationObserver(function () {
        _this3.computeQuestionAttrStyle();
      });
      // Start observing the target node for configured mutations
      actionPanelObserver.observe(this.$refs.stepTemplateAction, {
        attributes: true, // configure it to listen to attribute changes
        // childList: true,
        subtree: true,
        attributeFilter: ['style', 'class']
      });
    },
    removeListenActionPanelStyle: function removeListenActionPanelStyle() {
      // Later, you can stop observing
      actionPanelObserver && actionPanelObserver.disconnect();
    },
    computeQuestionAttrStyle: function computeQuestionAttrStyle() {
      var _this4 = this;

      timer && clearTimeout(timer);
      timer = setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_16_gsap_TweenLite__["b" /* TweenLite */].to(_this4.$data, 0.1, {
          questionAttrHeight: _this4.rightHeight - _this4.$refs.stepTemplateAction.clientHeight - 68
        });
      }, 300);
    },
    openCache: function openCache() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_18__views_question_editor_components_question_cache_box__["a" /* default */].open('question-editor', this.cacheKey).then(function (value) {
        _this5.questions = value;
      });
    },
    openTree: function openTree() {
      __WEBPACK_IMPORTED_MODULE_19__views_question_editor_components_question_tree_box__["a" /* default */].open('question-editor', this.questions);
    },
    onLoad: function onLoad() {
      var _this6 = this;

      // 先重置数据为空，防止数据元素被缓存
      this.questions = [];
      var _defaultQuestions = Object(__WEBPACK_IMPORTED_MODULE_14__views_question_editor_format_convert__["b" /* convertQuestions */])(filter.copyJson(__WEBPACK_IMPORTED_MODULE_22__views_step_template_data_step_template_default_questions___default.a));
      var _appendQuestions = Object(__WEBPACK_IMPORTED_MODULE_14__views_question_editor_format_convert__["b" /* convertQuestions */])(filter.copyJson(__WEBPACK_IMPORTED_MODULE_21__views_step_template_data_step_template_append_questions___default.a));
      this.defaultQuestionIds = _defaultQuestions.map(function (_ref) {
        var id = _ref.id;
        return id;
      });
      this.appendQuestionIds = _appendQuestions.map(function (_ref2) {
        var id = _ref2.id;
        return id;
      });
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id);
        this.cacheKey = this.id;
      } else {
        this.$nextTick(function () {
          // 等待重置为空的数据渲染完成后再写入默认数据
          _this6.questions = _defaultQuestions.concat(_appendQuestions);
          _this6.$nextTick(function () {
            _this6.loading = false;
          });
        });
      }
    },
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.onLoad();
    },
    setForm: function setForm(id) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this7.checkPermission();
                _this7.fetchStepData(id);

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this7);
      }))();
    },
    fetchStepData: function fetchStepData(id) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var originData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return request.page(_this8.request.detail, { id: id }).then(function (_ref3) {
                  var data = _ref3.data;

                  return data;
                });

              case 2:
                originData = _context2.sent;

                filter.setLoop(_this8.form, originData);

                originData.json = JSON.parse(originData.json);
                _this8.questions = Object(__WEBPACK_IMPORTED_MODULE_14__views_question_editor_format_convert__["b" /* convertQuestions */])(originData.json);
                _this8.ownUserId = originData.adminid;
                _this8.form.through_record = _this8.form.through_record === '1';
                _this8.form.through_record_flag = _this8.form.through_record_flag === '1';
                _this8.form.has_sneak_photos = _this8.form.has_sneak_photos === '1';
                _this8.$nextTick(function () {
                  _this8.loading = false;
                });

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this8);
      }))();
    },
    getForm: function getForm() {
      return filter.copyJson(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, this.form, { json: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(Object(__WEBPACK_IMPORTED_MODULE_15__views_question_editor_format_recovery__["b" /* recoveryQuestions */])(this.questions)) }));
    },
    onSubmit: function onSubmit() {
      var _this9 = this;

      var isValid = true;
      this.validateFailQuestionIds = [];
      // 验证全部的表单
      var forms = [this.$refs.infoForm, this.$refs.questionForm];
      forms.forEach(function (form) {
        form.validate(function (valid) {
          if (!valid) {
            isValid = false;
          }
        });
      });
      // 只有有一个验证失败
      if (isValid) {
        // let ret = StepTemplateValidator.StepTemplateValidate(JSON.parse(this.getForm().json))
        // if (!ret) {
        //   this.$message.error(StepTemplateValidator.GetErrorMessage())
        //   return false
        // }

        // 查理宝分步模板 问题别名必填
        if (this.scope === 'clb') {
          var errorNo = [];
          this.questions.forEach(function (question, index) {
            if (!question.titleAlias) {
              errorNo.push(index + 1);
            }
          });
          if (errorNo.length) {
            return this.$alert('\u7B2C' + errorNo.join('、') + '\u9898\u7684\u6807\u9898\u522B\u540D\u672A\u586B\u5199\uFF01', '提示', { type: 'warning' });
          }
        }

        var submit = function submit() {
          _this9.id ? _this9.update(_this9.id, _this9.getForm()) : _this9.create(_this9.getForm());
        };
        // 验证题目, 并提示
        var validateSubmit = function validateSubmit() {
          var validateResults = __WEBPACK_IMPORTED_MODULE_24__views_question_editor_utils_validate__["a" /* default */].questions(_this9.questions);
          if (validateResults.length) {
            _this9.$refs.ValidateQuestionWarning.open(validateResults);
            _this9.$refs.ValidateQuestionWarning.submit = submit;
          } else {
            submit();
          }
        };

        var extendedStepsStart = this.$refs.infoForm.form.extended_steps_start;
        // 检查题目错误并提示
        var checkResults = __WEBPACK_IMPORTED_MODULE_23__views_question_editor_utils_checkFix__["a" /* default */].test(this.questions, extendedStepsStart);

        if (checkResults.length) {
          this.$refs.CheckQuestionFix.open(checkResults);
          this.$refs.CheckQuestionFix.submit = function () {
            __WEBPACK_IMPORTED_MODULE_23__views_question_editor_utils_checkFix__["a" /* default */].fix(checkResults);
            validateSubmit();
          };
        } else {
          validateSubmit();
        }
      } else {
        this.$message.error('提交内容填写不正确！');
      }
    },
    collapseAllQuestion: function collapseAllQuestion(bool) {
      this.$refs.questionForm.collapse(bool);
    },
    copyQuestionTo: function copyQuestionTo() {
      var _this10 = this;

      this.$refs.CopyQuestionTo.open(this.questions, function (_ref4) {
        var _questions;

        var toIndex = _ref4.toIndex,
            questions = _ref4.questions;

        if (toIndex !== null) {
          // 添加到 toIndex 题目之后
          toIndex += 1;
        } else if (_this10.questions.length && _this10.appendQuestionIds.includes(_this10.questions[_this10.questions.length - 1].id)) {
          // 不能添加到固定题目之后
          // 添加到最后一题之前
          toIndex = _this10.questions.length - 1;
        } else {
          // 添加到最后
          toIndex = _this10.questions.length;
        }
        (_questions = _this10.questions).splice.apply(_questions, [toIndex, 0].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(questions)));
      });
    },
    showDataLabelModal: function showDataLabelModal() {
      var _this11 = this;

      this.$refs.StepTemplateDataLabels.open(this.questions, function (questions) {
        for (var m in questions) {
          for (var n in _this11.questions) {
            if (questions[m].stepId === _this11.questions[n].stepId) {
              if (questions[m].hasOwnProperty('dataLabel')) {
                _this11.questions[n].dataLabel = questions[m].dataLabel;
                break;
              }

              if (questions[m].hasOwnProperty('options') && questions[m].options.length) {
                for (var o in questions[m].options) {
                  for (var p in _this11.questions[n].options) {
                    if (questions[m].options[o].id === _this11.questions[n].options[p].id) {
                      _this11.questions[n].options[p].dataLabel = questions[m].options[o].dataLabel;
                      break;
                    }
                  }
                }
              }
            }
          }
        }
      });
    }
  }),
  filters: {}
});

/***/ }),

/***/ 2562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuedraggable__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { draggable: __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default.a },
  inheritAttrs: false,
  props: {
    value: Array,
    questionItems: Array,
    dangerIds: Array,
    fixedIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      disabled: false
    };
  },

  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  updated: function updated() {},
  destroyed: function destroyed() {},

  methods: {
    scrollIntoView: function scrollIntoView(index) {
      this.questionItems[index].scrollIntoView();
    }
  },
  filters: {}
});

/***/ }),

/***/ 2563:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestion_vue__ = __webpack_require__(2564);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05a6a790_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestion_vue__ = __webpack_require__(3425);
function injectStyle (ssrContext) {
  __webpack_require__(3418)
  __webpack_require__(3420)
  this["$style"] = __webpack_require__(3422)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05a6a790"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05a6a790_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_question_editor_utils_questions__ = __webpack_require__(1870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_question_editor_utils_options__ = __webpack_require__(2108);

//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  provide: function provide() {
    return {
      SjQuestion: this
    };
  },

  props: {
    model: Array,
    scroll: [String, HTMLElement],
    fixedIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    questions: function questions() {
      return this.model;
    },
    scrollEl: function scrollEl() {
      if (this.scroll.constructor === String) {
        return document.querySelector(this.scroll);
      }
      return this.scroll;
    }
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {
    /**
     * 添加题目
     *
     * @param data
     * @param type
     * @param toIndex
     */
    add: function add(data, type, toIndex) {
      var question = __WEBPACK_IMPORTED_MODULE_1__views_question_editor_utils_questions__["a" /* default */].make(type);
      if (question.options) {
        question.options.push(__WEBPACK_IMPORTED_MODULE_2__views_question_editor_utils_options__["a" /* default */].make(type));
        question.options.push(__WEBPACK_IMPORTED_MODULE_2__views_question_editor_utils_options__["a" /* default */].make(type));
      }
      // 不能添加到固定题目之后
      if (data.length && this.fixedIds.includes(data[data.length - 1].id)) {
        toIndex = data.length - 1;
      }
      // 复制到指定位置
      !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(toIndex) && (toIndex = data.length);
      __WEBPACK_IMPORTED_MODULE_1__views_question_editor_utils_questions__["a" /* default */].insert(data, question, toIndex);
    }
  },
  filters: {}
});

/***/ }),

/***/ 2565:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

var jump = {
  /**
   * 获得跳转目标ID列表
   * @param question
   * @returns {Array}
   */
  get: function get(question) {
    var list = [];
    if (question.jumpTargetId) {
      list.push(question.jumpTargetId);
    }
    if (question.options) {
      question.options.forEach(function (option) {
        if (option.jumpTargetId) {
          list.push(option.jumpTargetId);
        }
      });
    }
    return list;
  },


  /**
   * 判断题目是否存在跳转
   *
   * @param questions
   * @param question
   * @returns {boolean}
   */
  hasJump: function hasJump(questions, question) {
    if (question.jumpTargetId) {
      return true;
    }
    if (question.options) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(question.options), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var option = _step.value;

          if (option.jumpTargetId) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
    return false;
  },


  /**
   * 置空题目中的逻辑跳转
   * @param question
   * @param questionId
   */
  empty: function empty(question, questionId) {
    if (question.jumpTargetId === questionId) {
      question.jumpTargetId = '';
    }

    if (question.options) {
      question.options.forEach(function (option) {
        if (option.jumpTargetId === questionId) {
          option.jumpTargetId = '';
        }
      });
    }

    return question;
  },


  /**
   * 移除题目中无效的逻辑跳转
   * 1、移除题目的 跳转目标INDEX 在 题目INDEX 之前的
   * 2、移除题目列表中 跳转来源INDEX 在 题目INDEX 之后的
   *
   * @param questions
   * @param index
   */
  removeInvalid: function removeInvalid(questions, index) {
    var _this = this;

    var jumps = this.get(questions[index]);
    // 获得跳转目标题目的列表, 去除 end 特殊值
    var validJumps = jumps.filter(function (val) {
      return val !== 'end';
    });
    if (validJumps.length) {
      // 查找当前题目的跳转目标，跳转目标题目在当前题目的后面
      validJumps.forEach(function (questionId) {
        // 获得跳转的目标题目
        var jumpIndex = questions.findIndex(function (_ref) {
          var id = _ref.id;
          return questionId === id;
        });
        // 移除所有跳转，或者移除目标题目在当前题目之前的
        if (jumpIndex < index) {
          // 置空这个跳转ID
          _this.empty(questions[index], questionId);
        }
      });
    }

    // 全部题目查找当前题目是否被当做跳转目标
    // 被当做跳转目标时，当前题目必须在其之后
    for (var i = index + 1; i < questions.length; i++) {
      var question = questions[i];
      if (this.get(questions[index]).includes(questions[index].id)) {
        // 置空这个跳转ID
        this.empty(question, questions[index].id);
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (jump);

/***/ }),

/***/ 2566:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__step_template_rules_js__ = __webpack_require__(1813);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  inject: ['scope'],
  props: {
    value: Object,
    disabled: Boolean
  },
  data: function data() {
    return {
      infoRules: __WEBPACK_IMPORTED_MODULE_1__step_template_rules_js__["b" /* infoRules */]
    };
  },

  computed: {
    form: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, request.map(['getProjectDetail']), {
    validate: function validate(callback) {
      this.$refs.form.validate(callback);
    }
  }),
  filters: {}
});

/***/ }),

/***/ 2567:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_question_editor_format_convert_fields_evidence_types__ = __webpack_require__(3441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_question_editor_format_convert_fields_question_types__ = __webpack_require__(1615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_question_editor_format_take_photo_scenes__ = __webpack_require__(3442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_step_template_components_attrs_AttrInputType__ = __webpack_require__(2568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuedraggable__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__step_template_rules_js__ = __webpack_require__(1813);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AttrInputType: __WEBPACK_IMPORTED_MODULE_5__views_step_template_components_attrs_AttrInputType__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_6_vuedraggable___default.a
  },
  inject: ['scope'],
  props: {
    value: Object,
    index: Number,
    questions: Array,
    disabled: Boolean,
    bodyStyle: [String, Array, Object],
    through_record: Boolean
  },
  data: function data() {
    return {
      formRules: __WEBPACK_IMPORTED_MODULE_7__step_template_rules_js__["a" /* formRules */],
      takePhotoScenes: __WEBPACK_IMPORTED_MODULE_4__views_question_editor_format_take_photo_scenes__
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Vuex.mapState('stepTemplate', {
    types: function types(state) {
      return state.types;
    },
    evidenceType: function evidenceType(state) {
      return state.evidenceType;
    },
    imageRecognitionType: function imageRecognitionType(state) {
      return state.imageRecognitionType;
    },
    takePhotoAuxiliaryLineType: function takePhotoAuxiliaryLineType(state) {
      return state.takePhotoAuxiliaryLineType;
    },
    evidenceQuality: function evidenceQuality(state) {
      return state.evidenceQuality;
    },
    clarity: function clarity(state) {
      return state.clarity;
    }
  }), {
    // 全程录音调整
    evidenceOptionType: function evidenceOptionType() {
      return this.evidenceType;
    },

    question: {
      get: function get() {
        if (this.index === 0) {
          this.value.needEvidence = false;
        }
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    minDuration: {
      get: function get() {
        return this.question.minDuration / 60;
      },
      set: function set(value) {
        this.question.minDuration = (value * 60).toString();
      }
    },
    displayFields: function displayFields() {
      var fields = _.difference(__WEBPACK_IMPORTED_MODULE_3__views_question_editor_format_convert_fields_question_types__["a" /* default */][this.question.type], __WEBPACK_IMPORTED_MODULE_2__views_question_editor_format_convert_fields_evidence_types__["a" /* default */].evidence);
      // 显示证据选项配置
      if (this.question.type === 'select') {
        fields.push.apply(fields, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2__views_question_editor_format_convert_fields_evidence_types__["a" /* default */].selectTypes[this.question.evidenceType]));
      } else if (fields.includes('needEvidence') && this.question.needEvidence) {
        fields.push.apply(fields, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2__views_question_editor_format_convert_fields_evidence_types__["a" /* default */].types[this.question.evidenceType]));
      }
      return fields;
    }
  }),
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    getLabel: function getLabel(item, index) {
      return 'Q' + (index + 1) + '-' + item.title;
    },
    isJump: function isJump(key) {
      return key > this.index;
    },
    isBefore: function isBefore(question, key) {
      return key < this.index && question.type === 'text';
    }
  },
  filters: {}
});

/***/ }),

/***/ 2568:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttrInputType_vue__ = __webpack_require__(2569);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93908510_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttrInputType_vue__ = __webpack_require__(3449);
function injectStyle (ssrContext) {
  __webpack_require__(3443)
  __webpack_require__(3445)
  this["$style"] = __webpack_require__(3447)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-93908510"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttrInputType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93908510_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttrInputType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2569:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mixins_dateTimePicker__ = __webpack_require__(1347);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  mixins: [__WEBPACK_IMPORTED_MODULE_1__core_mixins_dateTimePicker__["a" /* default */]],
  inject: ['scope'],
  props: {
    value: Object,
    disabled: Boolean
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState('stepTemplate', {
    inputType: function inputType(state) {
      return state.inputType;
    }
  })),
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    changeNumber: function changeNumber(value) {
      if (typeof value === 'string') {
        value = value.toString().replace(/[^-\\.\d]/g, '');
      }
      if (value === '' || isNaN(value)) {
        return null;
      }
      return Number(value);
    },
    onChangeInputType: function onChangeInputType() {
      this.value.inputMin = null;
      this.value.inputMax = null;
    }
  },
  filters: {}
});

/***/ }),

/***/ 2570:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__step_template_rules_js__ = __webpack_require__(1813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_question_editor_format_convert_fields_option_types_js__ = __webpack_require__(1614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_step_template_components_attrs_AttrInputType__ = __webpack_require__(2568);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AttrInputType: __WEBPACK_IMPORTED_MODULE_4__views_step_template_components_attrs_AttrInputType__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a
  },
  inject: ['scope'],
  props: {
    value: Object,
    index: Number,
    questions: Array,
    question: Object,
    questionIndex: Number,
    disabled: Boolean,
    bodyStyle: [String, Array, Object]
  },
  data: function data() {
    return {
      formRules: __WEBPACK_IMPORTED_MODULE_2__step_template_rules_js__["a" /* formRules */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState('stepTemplate', {
    types: function types(state) {
      return state.types;
    },
    takePhotoAuxiliaryLineType: function takePhotoAuxiliaryLineType(state) {
      return state.takePhotoAuxiliaryLineType;
    }
  }), {
    option: {
      get: function get() {
        if (this.questionIndex === 0) {
          this.value.needEvidence = false;
        }
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    settlementAmountRatio: {
      get: function get() {
        return this.option.settlementAmountRatio * 100;
      },
      set: function set(value) {
        this.option.settlementAmountRatio = value / 100;
      }
    },
    inputMax: {
      get: function get() {
        return this.option.inputMax;
      },
      set: function set(value) {
        var inputMax = value.toString().replace(/[^\d]/g, '');
        console.log(inputMax === '' ? null : Number(inputMax));
        this.option.inputMax = inputMax === '' ? null : Number(inputMax);
      }
    }
  }),
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    getLabel: function getLabel(item, index) {
      return 'Q' + (index + 1) + '-' + item.title;
    },
    getOptionLabel: function getOptionLabel(item, key) {
      return 'OPT' + (key + 1) + ' ' + item.title;
    },
    isJump: function isJump(key) {
      return key > this.questionIndex;
    },
    onUpdateExclusiveOption: function onUpdateExclusiveOption(mutexOptions) {
      this.cleanExclusiveOption();
      for (var i = 0; i < this.question.options.length; i++) {
        for (var n = 0; n < mutexOptions.length; n++) {
          if (this.question.options[i].id === mutexOptions[n]) {
            this.question.options[i].mutexOptions.push(this.option.id);
          }
        }
      }
    },
    cleanExclusiveOption: function cleanExclusiveOption() {
      for (var i = 0; i < this.question.options.length; i++) {
        for (var n = 0; n < this.question.options[i].mutexOptions.length; n++) {
          if (this.question.options[i].mutexOptions[n] === this.option.id) {
            this.question.options[i].mutexOptions.splice(n, 1);
          }
        }
      }
    },
    includes: function includes(field) {
      return __WEBPACK_IMPORTED_MODULE_3__views_question_editor_format_convert_fields_option_types_js__["a" /* default */][this.question.type].includes(field);
    }
  },
  filters: {}
});

/***/ }),

/***/ 2571:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_question_editor_packages_sj_question_src_SjQuestion__ = __webpack_require__(2563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_step_template_components_StepTemplateQuestion__ = __webpack_require__(3467);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a,
    StepTemplateQuestion: __WEBPACK_IMPORTED_MODULE_3__views_step_template_components_StepTemplateQuestion__["a" /* default */],
    SjQuestion: __WEBPACK_IMPORTED_MODULE_2__views_question_editor_packages_sj_question_src_SjQuestion__["a" /* default */]
  },
  inject: ['page'],
  props: {
    value: Array
    // disabled: Boolean,
  },
  data: function data() {
    return {};
  },

  computed: {
    appendQuestions: function appendQuestions() {
      var _this = this;

      return this.page.questions.filter(function (question) {
        return _this.page.appendQuestionIds.includes(question.id);
      });
    },

    // 因为使用了 computed 所以 vuedraggable 必须使用 v-model 绑定数据
    // 主要为数据的更新方式不同，具体原因见官方文档。
    draggableQuestions: {
      get: function get() {
        return _.difference(this.page.questions, this.appendQuestions);
      },
      set: function set(questions) {
        var _page$questions;

        (_page$questions = this.page.questions).splice.apply(_page$questions, [0, this.page.questions.length].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(questions), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.appendQuestions)));
      }
    }
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    validate: function validate(callback) {
      var _this2 = this;

      var isValid = true;
      this.page.validateFailQuestionIds = [];
      // 验证全部的表单
      this.$refs.form.forEach(function (form) {
        form.validate(function (valid, question) {
          if (!valid) {
            isValid = false;
            _this2.page.validateFailQuestionIds.push(question.id);
          }
        });
      });
      callback(isValid);
    },
    updateSort: function updateSort(_ref) {
      var newIndex = _ref.newIndex;

      this.page.sjQuestionItems[newIndex].removeInvalidJump(this.page.questions, newIndex);
    },
    collapse: function collapse(bool) {
      this.$refs.form.forEach(function (form) {
        form.collapse = bool;
      });
    }
  },
  filters: {}
});

/***/ }),

/***/ 2572:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__step_template_rules_js__ = __webpack_require__(1813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_question_editor_packages_sj_question_src_SjQuestionItem__ = __webpack_require__(3474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_question_editor_packages_sj_question_src_SjQuestionButton__ = __webpack_require__(2574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_question_editor_packages_sj_question_tooltip__ = __webpack_require__(3489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_question_editor_packages_sj_question_input_src_SjQuestionInput__ = __webpack_require__(3498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_question_editor_packages_sj_question_rich_text__ = __webpack_require__(3506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_question_editor_packages_sj_question_rich_text_src_SjQuestionWangRichText__ = __webpack_require__(3525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_question_editor_packages_sj_question_inline_rich_text__ = __webpack_require__(3560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_question_editor_packages_sj_question_option_src_SjQuestionOption__ = __webpack_require__(3577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_question_editor_packages_sj_question_option_src_SjQuestionOptionButton__ = __webpack_require__(3585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_question_editor_packages_sj_question_option_src_SjQuestionOptionItem__ = __webpack_require__(3593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_question_editor_components_SjQuestionGuideVideo__ = __webpack_require__(1680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_question_editor_components_SjQuestionGuideAudio__ = __webpack_require__(1817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_question_editor_components_SjQuestionImage__ = __webpack_require__(3601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_question_editor_components_SjQuestionOneImage__ = __webpack_require__(3605);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SjQuestionOneImage: __WEBPACK_IMPORTED_MODULE_18__views_question_editor_components_SjQuestionOneImage__["a" /* default */],
    SjQuestionImage: __WEBPACK_IMPORTED_MODULE_17__views_question_editor_components_SjQuestionImage__["a" /* default */],
    SjQuestionGuideAudio: __WEBPACK_IMPORTED_MODULE_16__views_question_editor_components_SjQuestionGuideAudio__["a" /* default */],
    SjQuestionGuideVideo: __WEBPACK_IMPORTED_MODULE_15__views_question_editor_components_SjQuestionGuideVideo__["a" /* default */],
    SjQuestionOptionItem: __WEBPACK_IMPORTED_MODULE_14__views_question_editor_packages_sj_question_option_src_SjQuestionOptionItem__["a" /* default */],
    SjQuestionOptionButton: __WEBPACK_IMPORTED_MODULE_13__views_question_editor_packages_sj_question_option_src_SjQuestionOptionButton__["a" /* default */],
    SjQuestionOption: __WEBPACK_IMPORTED_MODULE_12__views_question_editor_packages_sj_question_option_src_SjQuestionOption__["a" /* default */],
    SjQuestionRichText: __WEBPACK_IMPORTED_MODULE_9__views_question_editor_packages_sj_question_rich_text__["a" /* default */],
    SjQuestionWangRichText: __WEBPACK_IMPORTED_MODULE_10__views_question_editor_packages_sj_question_rich_text_src_SjQuestionWangRichText__["a" /* default */],
    SjQuestionInlineRichText: __WEBPACK_IMPORTED_MODULE_11__views_question_editor_packages_sj_question_inline_rich_text__["a" /* default */],
    SjQuestionInput: __WEBPACK_IMPORTED_MODULE_8__views_question_editor_packages_sj_question_input_src_SjQuestionInput__["a" /* default */],
    SjQuestionTooltip: __WEBPACK_IMPORTED_MODULE_7__views_question_editor_packages_sj_question_tooltip__["a" /* default */],
    SjQuestionButton: __WEBPACK_IMPORTED_MODULE_6__views_question_editor_packages_sj_question_src_SjQuestionButton__["a" /* default */],
    SjQuestionItem: __WEBPACK_IMPORTED_MODULE_5__views_question_editor_packages_sj_question_src_SjQuestionItem__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a
  },
  inject: ['page', 'visibleGuide'],
  props: {
    // disabled: Boolean,
    questionIndex: Number
  },
  data: function data() {
    var question = this.page.questions[this.questionIndex];
    var isDefault = this.page.defaultQuestionIds.includes(question.id);
    var isAppend = this.page.appendQuestionIds.includes(question.id);
    var buttons = [{
      tip: '上移',
      icon: 'sj-icon-shift-up',
      action: 'up'
    }, {
      tip: '下移',
      icon: 'sj-icon-shift-down',
      action: 'down'
    }, {
      tip: '复制',
      icon: 'sj-icon-copy',
      action: 'copy'
    }, {
      tip: '移除',
      icon: 'el-icon-delete',
      action: 'remove'
    }];

    if (isAppend) {
      buttons = [buttons[3]];
    }
    return {
      questionRules: __WEBPACK_IMPORTED_MODULE_4__step_template_rules_js__["d" /* questionRules */],
      questionOptionRules: __WEBPACK_IMPORTED_MODULE_4__step_template_rules_js__["c" /* questionOptionRules */],
      buttons: buttons,
      focusClass: '',
      questions: this.page.questions,
      question: question,
      isAppend: isAppend,
      collapse: this.page.collapse.base ? true : isDefault || isAppend,
      collapseGuide: this.page.collapse.guide ? true : isDefault || isAppend
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Vuex.mapState('stepTemplate', {
    types: function types(state) {
      return state.types;
    },
    focusQuestionIndex: function focusQuestionIndex(state) {
      return state.focusQuestionIndex;
    },
    focusOptionIndex: function focusOptionIndex(state) {
      return state.focusOptionIndex;
    }
  }), {
    disabled: function disabled() {
      return this.isAppend || this.page.disabled.base;
    },
    disabledGuide: function disabledGuide() {
      return this.isAppend || this.page.disabled.guide;
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.page.sjQuestionItems[_this.questionIndex] = _this.$refs.sjQuestionItem;
    });
  },
  updated: function updated() {
    this.question = this.questions[this.questionIndex];
    this.page.sjQuestionItems[this.questionIndex] = this.$refs.sjQuestionItem;
    this.onQuestionFocus(this.questionIndex, null);
  },
  destroyed: function destroyed() {},

  methods: {
    validateTitle: function validateTitle(value) {
      this.$refs.questionForm.validateField('title');
    },
    validate: function validate(callback) {
      var isValid = true;
      // 验证全部的表单
      var forms = [this.$refs.questionForm].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.$refs.optionForm || []));
      forms.forEach(function (form) {
        form.validate(function (valid) {
          if (!valid) {
            isValid = false;
          }
        });
      });
      callback(isValid, this.question);
    },
    getOptionIcon: function getOptionIcon(type) {
      var icon = '';
      switch (type) {
        case 'multitext':
          icon = 'el-icon-edit-outline';
          break;
        case 'select':
          icon = 'sj-icon-round-check';
          break;
        case 'multiselect':
          icon = 'sj-icon-square-check';
          break;
        case 'imageMultiselect':
          icon = 'sj-icon-square-check';
          break;
        default:
          icon = '';
          break;
      }
      return icon + ' color-info';
    },
    onQuestionFocus: function onQuestionFocus() {
      var questionIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var optionIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.$store.commit('stepTemplate/setFocusIndex', {
        questionIndex: questionIndex,
        optionIndex: optionIndex
      });
      // 性能原因 不使用 store computed，会导致 update 所有题目组件，实际只需要更新2个
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$parent.$children), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var children = _step.value;

          if (children.questionIndex === questionIndex && !children.focusClass) {
            children.focusClass = 'focus';
          }
          if (children.questionIndex !== questionIndex && children.focusClass) {
            children.focusClass = '';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    sendQuestionTo: function sendQuestionTo() {
      this.page.$refs.SendQuestionTo.open(this.question);
    }
  },
  filters: {}
});

/***/ }),

/***/ 2573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_question_editor_utils_questions__ = __webpack_require__(1870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_question_editor_utils_jump__ = __webpack_require__(2565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap_TweenLite__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap_ScrollToPlugin__ = __webpack_require__(1733);

//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  provide: function provide() {
    return {
      SjQuestionItem: this
    };
  },

  inject: ['SjQuestion'],
  props: {
    prop: Number
  },
  data: function data() {
    return {};
  },

  computed: {
    index: function index() {
      return this.prop;
    },
    question: function question() {
      return this.SjQuestion.questions[this.index];
    },
    hasJump: function hasJump() {
      return __WEBPACK_IMPORTED_MODULE_2__views_question_editor_utils_jump__["a" /* default */].hasJump(this.SjQuestion.questions, this.question);
    },
    jumpIndex: function jumpIndex() {
      var _this = this;

      return this.question.jumpTargetId && this.SjQuestion.questions.findIndex(function (_ref) {
        var id = _ref.id;
        return id === _this.question.jumpTargetId;
      });
    }
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {
    /**
     * 滚动到题目
     */
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_3_gsap_TweenLite__["b" /* TweenLite */].to(_this2.SjQuestion.scrollEl, 0.5, {
          scrollTo: { y: _this2.$el, offsetY: 15 },
          ease: __WEBPACK_IMPORTED_MODULE_3_gsap_TweenLite__["a" /* Power2 */].easeOut
        });
      });
    },

    /**
     * 移除无效的跳转
     */
    removeInvalidJump: function removeInvalidJump(data, index) {
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_2__views_question_editor_utils_jump__["a" /* default */].removeInvalid(data, index);
      });
    },

    /**
     * 上移题目
     */
    up: function up(data) {
      __WEBPACK_IMPORTED_MODULE_1__views_question_editor_utils_questions__["a" /* default */].up(data, this.index);
      this.removeInvalidJump(data, this.index);
      this.scrollIntoView();
    },

    /**
     * 下移题目
     */
    down: function down(data) {
      // 下一题不是固定题目才能继续操作
      if (data[this.index + 1] && this.SjQuestion.fixedIds.includes(data[this.index + 1].id)) {
        return false;
      }
      __WEBPACK_IMPORTED_MODULE_1__views_question_editor_utils_questions__["a" /* default */].down(data, this.index);
      this.removeInvalidJump(data, this.index);
      this.scrollIntoView();
    },

    /**
     * 复制题目
     * @param data
     * @param toIndex
     */
    copy: function copy(data, toIndex) {
      // 不能复制到固定题目之后
      if (data.length && this.SjQuestion.fixedIds.includes(data[data.length - 1].id)) {
        toIndex = data.length - 1;
      }
      // 复制到指定位置
      !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(toIndex) && (toIndex = data.length);
      __WEBPACK_IMPORTED_MODULE_1__views_question_editor_utils_questions__["a" /* default */].copy(data, this.index, toIndex);
      __WEBPACK_IMPORTED_MODULE_2__views_question_editor_utils_jump__["a" /* default */].removeInvalid(data, toIndex);
    },

    /**
     * 移除题目
     */
    remove: function remove(data) {
      __WEBPACK_IMPORTED_MODULE_1__views_question_editor_utils_questions__["a" /* default */].removeDependency(data, this.question.id);
      __WEBPACK_IMPORTED_MODULE_1__views_question_editor_utils_questions__["a" /* default */].remove(data, this.index);
    }
  },
  filters: {}
});

/***/ }),

/***/ 2574:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionButton_vue__ = __webpack_require__(2575);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_252fff99_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionButton_vue__ = __webpack_require__(3488);
function injectStyle (ssrContext) {
  __webpack_require__(3482)
  __webpack_require__(3484)
  this["$style"] = __webpack_require__(3486)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-252fff99"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_252fff99_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2575:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  inject: {
    SjQuestion: {
      default: {}
    },
    SjQuestionItem: {
      default: {}
    }
  },
  inheritAttrs: false,
  props: {
    value: Array,
    action: String,
    options: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    index: function index() {
      return this.SjQuestionItem.index;
    },
    question: function question() {
      return this.SjQuestionItem.question;
    }
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {
    click: function click() {
      this[this.action](this.options);
    },

    /**
     * 上移题目
     */
    up: function up() {
      this.SjQuestionItem.up(this.value);
    },

    /**
     * 下移题目
     */
    down: function down() {
      this.SjQuestionItem.down(this.value);
    },

    /**
     * 复制题目
     * @param params
     */
    copy: function copy() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.SjQuestionItem.copy(this.value, params.toIndex);
    },

    /**
     * 移除题目
     */
    remove: function remove() {
      var _this = this;

      this.$confirm('\u6B64\u64CD\u4F5C\u5C06\u6C38\u4E45\u5220\u9664\u7B2C' + (this.index + 1) + '\u9898, \u662F\u5426\u7EE7\u7EED?', '提示', { type: 'warning' }).then(function () {
        _this.SjQuestionItem.remove(_this.value);
      });
    },

    /**
     * 添加题目
     *
     * @param params
     */
    add: function add() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.SjQuestion.add(this.value, params.type, params.toIndex);
    }
  },
  filters: {}
});

/***/ }),

/***/ 2576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    content: String
  },
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {},
  filters: {}
});

/***/ }),

/***/ 2577:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  inject: [],
  inheritAttrs: false,
  props: {
    value: String
  },
  data: function data() {
    return {};
  },

  computed: {
    currentValue: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {},
  filters: {}
});

/***/ }),

/***/ 2578:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_question_editor_components_question_quill_editor__ = __webpack_require__(2579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_siliconflow_api__ = __webpack_require__(2581);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  inject: ['page', 'SjQuestion'],
  props: {
    value: String,
    disabled: Boolean,
    enableAiOptimize: {
      type: Boolean,
      default: false
    },
    aiContext: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入内容'
    }
  },
  data: function data() {
    return {
      aiLoading: false,
      previewVisible: false,
      previewOriginal: '',
      previewOptimized: ''
    };
  },

  computed: {
    currentValue: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {
    showRichTextEditor: function showRichTextEditor() {
      var _this = this;

      // 禁止编辑
      if (this.disabled) return false;

      var text = this.$el.getBoundingClientRect();
      // 获得容器的相对屏幕的位置信息
      var container = this.SjQuestion.$el;
      var question = container.getBoundingClientRect();
      // 获得文本框的宽度，小于500px时将会产生换行
      var offsetHeight = 35;
      if (text.width < 300) {
        offsetHeight = 83;
      } else if (text.width < 500) {
        offsetHeight = 59;
      }
      // 获得绝对坐标
      var top = text.top - question.top - offsetHeight;
      var left = text.left - question.left;
      __WEBPACK_IMPORTED_MODULE_0__views_question_editor_components_question_quill_editor__["a" /* default */].open(this.currentValue, {
        container: container,
        style: {
          top: top + 'px',
          left: left + 'px',
          width: text.width - 2 + 'px',
          minHeight: 97 + offsetHeight - 2 + 'px'
        },
        callback: function callback(_ref) {
          var html = _ref.html;

          _this.currentValue = html;
        },
        onClick: function onClick(_) {
          return _this.$emit('click', _);
        }
      });
    },
    onAiOptimize: function onAiOptimize() {
      var _this2 = this;

      if (this.aiLoading) return;

      this.aiLoading = true;
      Object(__WEBPACK_IMPORTED_MODULE_1__services_siliconflow_api__["a" /* optimizeRichText */])({
        content: this.currentValue,
        context: this.aiContext
      }).then(function (optimized) {
        _this2.previewOriginal = _this2.currentValue;
        _this2.previewOptimized = optimized;
        _this2.previewVisible = true;
      }).catch(function (error) {
        var message = error.message || 'AI 优化失败，请稍后重试';
        if (message.includes('请先输入描述内容')) {
          _this2.$message.warning(message);
        } else if (message.includes('未配置硅基流动 API Key')) {
          _this2.$message.error(message);
        } else {
          _this2.$message.error(message);
        }
      }).finally(function () {
        _this2.aiLoading = false;
      });
    },
    applyOptimized: function applyOptimized() {
      this.currentValue = this.previewOptimized;
      this.previewVisible = false;
      this.$message.success('已应用 AI 优化内容');
    },
    onPreviewClose: function onPreviewClose() {
      this.previewOriginal = '';
      this.previewOptimized = '';
    }
  },
  filters: {}
});

/***/ }),

/***/ 2579:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main_js__ = __webpack_require__(3514);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main_js__["a" /* default */]);

/***/ }),

/***/ 2580:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill_dist_quill_core_css__ = __webpack_require__(1743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_quill_dist_quill_snow_css__ = __webpack_require__(1744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_quill_dist_quill_snow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_vue_quill_editor_formats_font__ = __webpack_require__(1873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_quill_editor__ = __webpack_require__(1880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PlainClipboard__ = __webpack_require__(3522);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// require styles






var Clipboard = __WEBPACK_IMPORTED_MODULE_3_vue_quill_editor__["Quill"].import('modules/clipboard');

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { QuillEditor: __WEBPACK_IMPORTED_MODULE_3_vue_quill_editor__["quillEditor"] },
  props: {},
  data: function data() {
    return {
      visible: false,
      mount: false,
      content: '',
      options: {
        bounds: '#question-quill-editor' + this._uid,
        placeholder: this.placeholder,
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike', 'link'], [{
            'list': 'ordered'
          }, {
            'list': 'bullet'
          }], [{ 'header': [1, 2, 3, 4, 5, 6, false] }], [{ 'color': ['#f3605b', '#333'] }, { 'background': ['#f3605b', '#333'] }], [{ 'align': [] }], ['clean']]
        }
      },
      style: {},
      disabled: false,
      plainPaste: false
    };
  },

  computed: {},
  watch: {
    visible: function visible(val) {
      // 每一次启动时，根据配置，启用不同的剪切板
      if (val) {
        __WEBPACK_IMPORTED_MODULE_3_vue_quill_editor__["Quill"].register('modules/clipboard', this.plainPaste ? __WEBPACK_IMPORTED_MODULE_4__PlainClipboard__["a" /* default */] : Clipboard, true);
      } else {
        // 恢复成默认的剪切板
        __WEBPACK_IMPORTED_MODULE_3_vue_quill_editor__["Quill"].register('modules/clipboard', Clipboard, true);
      }
    }
  },
  created: function created() {
    document.addEventListener('click', this.hide);
  },
  mounted: function mounted() {},
  updated: function updated() {
    var _this = this;

    if (this.mount) {
      this.$nextTick(function () {
        // 计算编辑器容器最小高度
        $('.ql-container', _this.$refs.editor.$el).height($(_this.$refs.editor.$el).outerHeight() - $('.ql-toolbar', _this.$refs.editor.$el).outerHeight() - 2);
      });
    }
  },
  destroyed: function destroyed() {
    document.removeEventListener('click', this.hide);
  },

  methods: {
    change: function change(_ref) {
      var editor = _ref.editor,
          html = _ref.html,
          text = _ref.text;

      if (this.content !== html) {
        this.content = html;
      }
      this.callback({ editor: editor, html: html, text: text }, this);
    },
    hide: function hide() {
      this.visible = false;
    }
  }
});

/***/ }),

/***/ 2581:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = optimizeRichText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var SILICONFLOW_BASE_URL = 'https://api.siliconflow.cn/v1';
var DEFAULT_MODEL = 'deepseek-ai/DeepSeek-V3';

var SYSTEM_PROMPT = '\u4F60\u662F\u5206\u6B65\u6A21\u677F\u9898\u76EE\u63CF\u8FF0\u6587\u6848\u4F18\u5316\u52A9\u624B\u3002\u8BF7\u4F18\u5316\u7528\u6237\u63D0\u4F9B\u7684\u9898\u76EE\u63CF\u8FF0\uFF0C\u4F7F\u5176\u8868\u8FBE\u66F4\u6E05\u6670\u3001\u4E13\u4E1A\u3001\u7B80\u6D01\uFF0C\u540C\u65F6\u4FDD\u6301\u539F\u610F\u4E0D\u53D8\u3002\n\n\u8F93\u51FA\u5FC5\u987B\u662F\u53EF\u76F4\u63A5\u5199\u5165 Quill \u7F16\u8F91\u5668\u7684 HTML \u5B57\u7B26\u4E32\uFF0C\u4E25\u683C\u9075\u5FAA\u4EE5\u4E0B\u683C\u5F0F\u89C4\u8303\uFF1A\n1. \u82E5\u5185\u5BB9\u5305\u542B\u591A\u4E2A\u6B65\u9AA4\uFF0C\u6BCF\u6B65\u5148\u7528\u72EC\u7ACB\u6BB5\u843D\u6807\u6CE8\u6B65\u9AA4\u53F7\uFF1A<p>\u3010\u7B2C1\u6B65\u3011</p>\u3001<p>\u3010\u7B2C2\u6B65\u3011</p>\u2026\u2026\n2. \u6B65\u9AA4\u8BF4\u660E\u653E\u5728\u7D27\u968F\u5176\u540E\u7684 <p> \u6BB5\u843D\u4E2D\n3. \u6BCF\u53E5\u8BDD\u4E2D\u7684\u5173\u952E\u64CD\u4F5C\u3001\u91CD\u70B9\u8BCD\u4F7F\u7528\u7EA2\u8272\u52A0\u7C97\uFF1A<strong style="color: rgb(255, 0, 0);">\u91CD\u70B9\u5185\u5BB9</strong>\n4. \u62EC\u53F7\u5185\u7684\u8865\u5145\u8BF4\u660E\u3001\u666E\u901A\u6587\u5B57\u4FDD\u6301\u4E0D\u52A0\u7C97\n5. \u6BCF\u4E2A\u903B\u8F91\u6BB5\u843D\u4F7F\u7528 <p>...</p> \u5305\u88F9\uFF0C\u6BB5\u843D\u4E4B\u95F4\u4E0D\u8981\u6362\u884C\u7B26\n6. \u4EC5\u4F7F\u7528\u6807\u7B7E\uFF1Ap\u3001strong\uFF08strong \u5FC5\u987B\u5E26 style="color: rgb(255, 0, 0);"\uFF09\n7. \u4E0D\u8981\u4F7F\u7528 markdown\uFF0C\u4E0D\u8981\u7528\u4EE3\u7801\u5757\u5305\u88F9\uFF0C\u4E0D\u8981\u8F93\u51FA\u7EAF\u6587\u672C\uFF0C\u76F4\u63A5\u8F93\u51FA HTML \u5B57\u7B26\u4E32\n\n\u683C\u5F0F\u793A\u4F8B\uFF1A\n<p>\u3010\u7B2C1\u6B65\u3011</p><p><strong style="color: rgb(255, 0, 0);">\u6253\u5F00\u624B\u673A\u5BFC\u822A\u8F6F\u4EF6</strong>\uFF08\u9AD8\u5FB7\u3001\u767E\u5EA6\u90FD\u53EF\u4EE5\uFF09</p><p>\u3010\u7B2C2\u6B65\u3011</p><p><strong style="color: rgb(255, 0, 0);">\u641C\u7D22\u5E97\u540D\u5173\u952E\u90E8\u5206</strong>(\u5982\u597D\u53C8\u591A\u3001\u8054\u534E\u7B49)</p><p>\u3010\u7B2C3\u6B65\u3011</p><p>\u786E\u8BA4\u5468\u8FB9\u6CA1\u6709\u76EE\u6807\u95E8\u5E97<strong style="color: rgb(255, 0, 0);">\u4FDD\u5B58\u622A\u56FE\u4E0A\u4F20</strong></p>';

function getApiKey() {
  return window._env_ && window._env_.VUE_APP_SILICONFLOW_API_KEY;
}

function getModel() {
  return window._env_ && window._env_.VUE_APP_SILICONFLOW_MODEL || DEFAULT_MODEL;
}

function stripTags(html) {
  if (!html) return '';
  var div = document.createElement('div');
  div.innerHTML = html;
  return (div.textContent || div.innerText || '').trim();
}

function sanitizeAiHtml(content) {
  if (!content) return '';
  var text = content.trim();
  var codeBlockMatch = text.match(/^```(?:html)?\s*([\s\S]*?)\s*```$/i);
  if (codeBlockMatch) {
    text = codeBlockMatch[1].trim();
  }
  return text;
}

function buildUserMessage(_ref) {
  var content = _ref.content,
      context = _ref.context;

  var contextLine = context ? '\u9898\u76EE\u6807\u9898\uFF1A' + stripTags(context) + '\n' : '';
  return contextLine + '\u8BF7\u4F18\u5316\u4EE5\u4E0B\u9898\u76EE\u63CF\u8FF0\uFF0C\u4FDD\u6301\u4E0A\u8FF0 HTML \u683C\u5F0F\u89C4\u8303\uFF1A\n' + content;
}

function optimizeRichText(_ref2) {
  var content = _ref2.content,
      context = _ref2.context;

  var apiKey = getApiKey();
  if (!apiKey) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('未配置硅基流动 API Key'));
  }

  var plainText = stripTags(content);
  if (!plainText) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('请先输入描述内容'));
  }

  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(SILICONFLOW_BASE_URL + '/chat/completions', {
    model: getModel(),
    messages: [{ role: 'system', content: SYSTEM_PROMPT }, { role: 'user', content: buildUserMessage({ content: content, context: context }) }],
    temperature: 0.7,
    max_tokens: 2048
  }, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + apiKey
    }
  }).then(function (response) {
    var result = response.data && response.data.choices && response.data.choices[0];
    var optimized = result && result.message && result.message.content;
    if (!optimized) {
      throw new Error('AI 返回内容为空');
    }
    return sanitizeAiHtml(optimized);
  }).catch(function (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    }
    throw error;
  });
}

/***/ }),

/***/ 2582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_question_editor_components_InputHtml__ = __webpack_require__(3532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_question_editor_components_question_wang_editor__ = __webpack_require__(3540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_siliconflow_api__ = __webpack_require__(2581);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { InputHtml: __WEBPACK_IMPORTED_MODULE_0__views_question_editor_components_InputHtml__["a" /* default */] },
  inject: ['page', 'SjQuestion'],
  props: {
    value: String,
    disabled: Boolean,
    enableAiOptimize: {
      type: Boolean,
      default: false
    },
    aiContext: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入内容'
    }
  },
  data: function data() {
    return {
      aiLoading: false,
      previewVisible: false,
      previewOriginal: '',
      previewOptimized: ''
    };
  },

  computed: {
    currentValue: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {
    showRichTextEditor: function showRichTextEditor() {
      var _this = this;

      var text = this.$el.getBoundingClientRect();
      // 获得容器的相对屏幕的位置信息
      var container = this.SjQuestion.$el;
      var question = container.getBoundingClientRect();
      // 获得文本框的宽度，小于500px时将会产生换行
      var offsetHeight = 32;
      if (text.width < 500) {
        offsetHeight = 63;
      }
      // 获得绝对坐标
      var top = text.top - question.top - offsetHeight;
      var left = text.left - question.left;
      __WEBPACK_IMPORTED_MODULE_1__views_question_editor_components_question_wang_editor__["a" /* default */].open(this.currentValue, {
        container: container,
        style: {
          top: top + 'px',
          left: left + 'px',
          width: text.width - 2 + 'px'
          // minHeight: text.height + offsetHeight - 2 + 'px',
        },
        // txtHeight: text.height + 2 + 'px',
        callback: function callback(_ref) {
          var html = _ref.html;

          _this.currentValue = html;
        }
      });
    },
    onAiOptimize: function onAiOptimize() {
      var _this2 = this;

      if (this.aiLoading) return;

      this.aiLoading = true;
      Object(__WEBPACK_IMPORTED_MODULE_2__services_siliconflow_api__["a" /* optimizeRichText */])({
        content: this.currentValue,
        context: this.aiContext
      }).then(function (optimized) {
        _this2.previewOriginal = _this2.currentValue;
        _this2.previewOptimized = optimized;
        _this2.previewVisible = true;
      }).catch(function (error) {
        var message = error.message || 'AI 优化失败，请稍后重试';
        if (message.includes('请先输入描述内容')) {
          _this2.$message.warning(message);
        } else if (message.includes('未配置硅基流动 API Key')) {
          _this2.$message.error(message);
        } else {
          _this2.$message.error(message);
        }
      }).finally(function () {
        _this2.aiLoading = false;
      });
    },
    applyOptimized: function applyOptimized() {
      this.currentValue = this.previewOptimized;
      this.previewVisible = false;
      this.$message.success('已应用 AI 优化内容');
    },
    onPreviewClose: function onPreviewClose() {
      this.previewOriginal = '';
      this.previewOptimized = '';
    }
  },
  filters: {}
});

/***/ }),

/***/ 2583:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill_dist_quill_core_css__ = __webpack_require__(1743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_quill_dist_quill_snow_css__ = __webpack_require__(1744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_quill_dist_quill_snow_css__);
//
//
//
//
//
//
//
//
//
//

// require styles



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    value: String,
    placeholder: String,
    innerClass: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      html: this.value,
      inputHtml: ''
    };
  },

  computed: {},
  watch: {
    value: function value() {
      if (this.value !== this.inputHtml) {
        this.html = this.value;
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {
    input: function input($event) {
      this.inputHtml = $event.target.innerHTML;
      this.$emit('input', this.inputHtml);
    }
  }
});

/***/ }),

/***/ 2584:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_WangEditorV2Deprecated__ = __webpack_require__(3549);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { WangEditorV2: __WEBPACK_IMPORTED_MODULE_0__components_WangEditorV2Deprecated__["a" /* default */] },
  props: {},
  data: function data() {
    return {
      visible: false,
      content: '',
      style: {},
      txtHeight: '',
      disabled: false
    };
  },

  computed: {
    html: {
      get: function get() {
        return this.content;
      },
      set: function set(html) {
        this.content = html;
        this.callback({ html: html }, this);
      }
    }
  },
  watch: {},
  created: function created() {
    document.addEventListener('click', this.hide);
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {
    document.removeEventListener('click', this.hide);
  },

  methods: {
    hide: function hide() {
      this.visible = false;
    }
  }
});

/***/ }),

/***/ 2585:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_question_editor_components_InlineInputHtml__ = __webpack_require__(3568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_question_editor_components_question_quill_editor__ = __webpack_require__(2579);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { InputHtml: __WEBPACK_IMPORTED_MODULE_0__views_question_editor_components_InlineInputHtml__["a" /* default */] },
  inject: ['page', 'SjQuestion'],
  props: {
    value: String,
    prefixIcon: String,
    disabled: Boolean,
    plainPaste: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    toolbar: {
      type: Array,
      default: function _default() {
        return [[{ 'color': ['', '#F00'] }]];
      }
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    currentValue: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {
    showRichTextEditor: function showRichTextEditor() {
      var _this = this;

      var text = this.$el.getBoundingClientRect();
      // 获得容器的相对屏幕的位置信息
      var container = this.SjQuestion.$el;
      var question = container.getBoundingClientRect();
      // 获得文本框的宽度，小于500px时将会产生换行
      var offsetHeight = 32;
      if (text.width < 500) {
        offsetHeight = 63;
      }
      // 获得绝对坐标
      var top = text.top - question.top - offsetHeight;
      var left = text.left - question.left;
      __WEBPACK_IMPORTED_MODULE_1__views_question_editor_components_question_quill_editor__["a" /* default */].open(this.currentValue, {
        container: container,
        style: {
          top: top + 'px',
          left: left + 'px',
          width: text.width - 2 + 'px',
          height: '70px'
        },
        callback: function callback(_ref) {
          var html = _ref.html;

          _this.currentValue = $(html).html();
        },
        options: {
          bounds: $('#main')[0],
          placeholder: this.placeholder,
          modules: {
            toolbar: this.toolbar
          }
        },
        plainPaste: this.plainPaste
      });
    }
  },
  filters: {}
});

/***/ }),

/***/ 2586:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill_dist_quill_core_css__ = __webpack_require__(1743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_quill_dist_quill_snow_css__ = __webpack_require__(1744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_quill_dist_quill_snow_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// require styles



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    value: String,
    icon: String,
    placeholder: String,
    innerClass: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      html: this.value,
      inputHtml: ''
    };
  },

  computed: {},
  watch: {
    value: function value() {
      if (this.value !== this.inputHtml) {
        this.html = this.value;
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {
    input: function input($event) {
      this.inputHtml = $event.target.innerHTML;
      this.inputHtml = _.replace(this.inputHtml, '<br>', '');
      this.$emit('input', this.inputHtml);
    },
    onPaste: function onPaste(e) {
      if (e.clipboardData && window.getSelection) {
        var text = e.clipboardData.getData('text');
        if (text !== '' && text !== null) {
          var textNode = document.createTextNode(text);
          var range = window.getSelection().getRangeAt(0);
          range.deleteContents();
          range.insertNode(textNode);
        }
      } else {
        this.$message.error('请使用chrome浏览器操作');
      }
    }
  }
});

/***/ }),

/***/ 2587:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_question_editor_utils_options__ = __webpack_require__(2108);

//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  provide: function provide() {
    return {
      SjQuestionOption: this
    };
  },

  props: {
    model: Array
  },
  data: function data() {
    return {};
  },

  computed: {
    options: function options() {
      return this.model;
    }
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {
    /**
     * 添加题目
     *
     * @param data
     * @param type
     * @param toIndex
     */
    add: function add(data, type, toIndex) {
      // 复制到指定位置
      !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(toIndex) && (toIndex = data.length);
      __WEBPACK_IMPORTED_MODULE_1__views_question_editor_utils_options__["a" /* default */].create(data, type, toIndex);
    }
  },
  filters: {}
});

/***/ }),

/***/ 2588:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_question_editor_utils_options__ = __webpack_require__(2108);

//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  inject: {
    SjQuestionOption: {
      default: {}
    },
    SjQuestionOptionItem: {
      default: {}
    }
  },
  inheritAttrs: false,
  props: {
    value: Array,
    action: String,
    options: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    index: function index() {
      return this.SjQuestionOptionItem.index;
    }
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {
    click: function click() {
      this[this.action](this.options);
    },

    /**
     * 上移题目
     */
    up: function up() {
      __WEBPACK_IMPORTED_MODULE_1__views_question_editor_utils_options__["a" /* default */].up(this.value, this.index);
    },

    /**
     * 下移题目
     */
    down: function down() {
      __WEBPACK_IMPORTED_MODULE_1__views_question_editor_utils_options__["a" /* default */].down(this.value, this.index);
    },

    /**
     * 复制题目
     * @param toIndex
     */
    copy: function copy(toIndex) {
      // 复制到指定位置
      !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(toIndex) && (toIndex = this.value.length);
      var option = __WEBPACK_IMPORTED_MODULE_1__views_question_editor_utils_options__["a" /* default */].copy(this.value, this.index, toIndex);
      __WEBPACK_IMPORTED_MODULE_1__views_question_editor_utils_options__["a" /* default */].addDependency(this.value, option);
    },

    /**
     * 移除题目
     */
    remove: function remove() {
      __WEBPACK_IMPORTED_MODULE_1__views_question_editor_utils_options__["a" /* default */].removeDependency(this.value, this.value[this.index].id);
      __WEBPACK_IMPORTED_MODULE_1__views_question_editor_utils_options__["a" /* default */].remove(this.value, this.index);
    },

    /**
     * 添加题目
     *
     * @param type
     * @param toIndex
     */
    add: function add(_ref) {
      var type = _ref.type,
          toIndex = _ref.toIndex;

      this.SjQuestionOption.add(this.value, type, toIndex);
    }
  },
  filters: {}
});

/***/ }),

/***/ 2589:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  provide: function provide() {
    return {
      SjQuestionOptionItem: this
    };
  },

  inject: ['SjQuestion', 'SjQuestionOption'],
  props: {
    prop: Number
  },
  data: function data() {
    return {};
  },

  computed: {
    index: function index() {
      return this.prop;
    },
    option: function option() {
      return this.SjQuestionOption.options[this.index];
    },
    hasJump: function hasJump() {
      return !!this.option.jumpTargetId;
    },
    jumpIndex: function jumpIndex() {
      var _this = this;

      return this.option.jumpTargetId && this.SjQuestion.questions.findIndex(function (_ref) {
        var id = _ref.id;
        return id === _this.option.jumpTargetId;
      });
    }
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {},
  filters: {}
});

/***/ }),

/***/ 2590:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_question_editor_packages_sj_question_file__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_question_editor_packages_sj_question_file_item__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_question_editor_packages_sj_question_file_add__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__ = __webpack_require__(1507);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { SjQuestionFileAdd: __WEBPACK_IMPORTED_MODULE_5__views_question_editor_packages_sj_question_file_add__["a" /* default */], SjQuestionFileItem: __WEBPACK_IMPORTED_MODULE_4__views_question_editor_packages_sj_question_file_item__["a" /* default */], SjQuestionFile: __WEBPACK_IMPORTED_MODULE_3__views_question_editor_packages_sj_question_file__["a" /* default */], draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a },
  mixins: [],
  inject: ['playImage', 'uploadImage'],
  props: {
    value: Array,
    disabled: Boolean
  },
  data: function data() {
    return {
      checkMode: false,
      uniqueId: _.uniqueId(),
      checkedFiles: [],
      uploadApi: 'uploadStepTemplateFile'
    };
  },

  computed: {
    files: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    isMacOS: function isMacOS() {
      return navigator.platform.indexOf('Mac') === 0;
    },
    controlKeyCode: function controlKeyCode() {
      return this.isMacOS ? 91 : 17;
    }
  },
  watch: {},
  created: function created() {
    this.addEventListener();
  },
  mounted: function mounted() {
    Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])({
      uploadApi: this.uploadApi
    }, true).appendElement('.step-template-content-container');
  },
  destroyed: function destroyed() {
    this.removeEventListener();
  },

  methods: {
    onCheck: function onCheck(index) {
      Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().hide();
      if (this.checkMode) {
        Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().setScope(this.uniqueId);
        Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().checked(this.files[index]);
        this.checkedFiles = Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().checkedFiles;
      } else {
        this.onView(index);
      }
    },
    onView: function onView(index) {
      this.playImage(this.value, index);
    },
    upload: function upload() {
      var _this = this;

      this.uploadImage(function (file) {
        var form = new FormData();
        form.append('file', file);
        return request(_this.uploadApi, form).then(function (_ref) {
          var data = _ref.data;

          _this.files.push({ type: 'photo', src: data });
        });
      });
    },
    remove: function remove(index) {
      this.files.splice(index, 1);
    },
    onContextmenu: function onContextmenu(_ref2, index) {
      var clientX = _ref2.clientX,
          clientY = _ref2.clientY;

      // 匹配右击菜单作用域
      Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().scope !== this.uniqueId && Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().empty();
      // 判断右击是否在项目上
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(index) && index >= 0) {
        var file = this.files[index];
        if (!this.checkedFiles.includes(file)) {
          Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().empty();
          Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().checked(file);
          this.checkedFiles = Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().checkedFiles;
        }
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().empty();
      }
      // 限制拷贝数量
      Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])({ pasteMax: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a });
      Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().setScope(this.uniqueId);
      Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().setType(this.type);
      Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().setFiles(this.files);
      Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().show(clientX, clientY);
    },
    addEventListener: function addEventListener() {
      document.addEventListener('keydown', this.keydown);
      document.addEventListener('keyup', this.keyup);
      document.addEventListener('click', this.clickDoc);
      document.addEventListener('visibilitychange', this.visibilityChange);
    },
    removeEventListener: function removeEventListener() {
      document.removeEventListener('keydown', this.keydown);
      document.removeEventListener('keyup', this.keyup);
      document.removeEventListener('click', this.clickDoc);
      document.removeEventListener('visibilitychange', this.visibilityChange);
    },
    clickDoc: function clickDoc() {
      Object(__WEBPACK_IMPORTED_MODULE_6__views_question_review_components_ContextMenu__["a" /* default */])().hide();
    },
    keyup: function keyup(event) {
      var control = this.controlKeyCode;
      switch (event.keyCode || event.which || event.charCode) {
        // Control
        case control:
          this.checkMode = false;
          break;
      }
    },
    keydown: function keydown(event) {
      var control = this.controlKeyCode;
      switch (event.keyCode || event.which || event.charCode) {
        // Control
        case control:
          this.checkMode = true;
          break;
      }
    }
  }
});

/***/ }),

/***/ 2591:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_question_review_components_ContextMenu__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_question_editor_packages_sj_question_file__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_question_editor_packages_sj_question_file_item__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_question_editor_packages_sj_question_file_add__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_question_editor_packages_sj_question_file_progress__ = __webpack_require__(1591);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { SjQuestionFileProgress: __WEBPACK_IMPORTED_MODULE_5__views_question_editor_packages_sj_question_file_progress__["a" /* default */], SjQuestionFileAdd: __WEBPACK_IMPORTED_MODULE_4__views_question_editor_packages_sj_question_file_add__["a" /* default */], SjQuestionFileItem: __WEBPACK_IMPORTED_MODULE_3__views_question_editor_packages_sj_question_file_item__["a" /* default */], SjQuestionFile: __WEBPACK_IMPORTED_MODULE_2__views_question_editor_packages_sj_question_file__["a" /* default */] },
  mixins: [],
  inject: ['playImage'],
  props: {
    value: Array,
    disabled: Boolean
  },
  data: function data() {
    return {
      uniqueId: _.uniqueId(),
      progress: [
        // percentage: 0,
      ],
      uploadApi: 'uploadStepTemplateFile'
    };
  },

  computed: {
    files: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  watch: {},
  created: function created() {
    this.addEventListener();
  },
  mounted: function mounted() {
    Object(__WEBPACK_IMPORTED_MODULE_1__views_question_review_components_ContextMenu__["a" /* default */])({
      uploadApi: this.uploadApi
    }, true).appendElement('.step-template-content-container');
  },
  destroyed: function destroyed() {
    this.removeEventListener();
  },

  methods: {
    view: function view(index) {
      this.playImage(this.value, index);
    },
    upload: function upload() {
      var _this = this;

      var file = this.$refs.selectFile.files[0];
      if (this.validate(file)) {
        // 显示进度条
        var progress = {
          percentage: 0,
          file: file
        };
        this.progress.push(progress);
        // 生成请求数据
        var form = new FormData();
        form.append('file', file);
        request.alert('uploadStepTemplateFile', form, {
          onUploadProgress: function onUploadProgress(progressEvent) {
            progress.percentage = progressEvent.loaded / progressEvent.total * 100 | 0;
          }
        }).then(function (_ref) {
          var data = _ref.data;

          _this.files.push({ type: 'photo', src: data });
        }).finally(function () {
          _this.progress.splice(_this.progress.indexOf(progress), 1);
        });
      }
      this.$refs.selectFile.value = null;
    },
    validate: function validate(file) {
      var size = 5;
      var isLtSize = file.size / 1024 / 1024 < size;
      if (!isLtSize) {
        this.$message.error('\u4E0A\u4F20\u56FE\u7247\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 ' + size + 'MB!');
      }
      return isLtSize;
    },
    remove: function remove(index) {
      this.files.splice(index, 1);
    },
    onContextmenu: function onContextmenu(_ref2, index) {
      var clientX = _ref2.clientX,
          clientY = _ref2.clientY;

      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(index) && index >= 0) {
        var file = this.files[index];
        Object(__WEBPACK_IMPORTED_MODULE_1__views_question_review_components_ContextMenu__["a" /* default */])().empty();
        Object(__WEBPACK_IMPORTED_MODULE_1__views_question_review_components_ContextMenu__["a" /* default */])().checked(file);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1__views_question_review_components_ContextMenu__["a" /* default */])().empty();
      }
      // 限制拷贝数量
      Object(__WEBPACK_IMPORTED_MODULE_1__views_question_review_components_ContextMenu__["a" /* default */])({ pasteMax: ~~!this.files.length });
      Object(__WEBPACK_IMPORTED_MODULE_1__views_question_review_components_ContextMenu__["a" /* default */])().setScope(this.uniqueId);
      Object(__WEBPACK_IMPORTED_MODULE_1__views_question_review_components_ContextMenu__["a" /* default */])().setType(this.type);
      Object(__WEBPACK_IMPORTED_MODULE_1__views_question_review_components_ContextMenu__["a" /* default */])().setFiles(this.files);
      Object(__WEBPACK_IMPORTED_MODULE_1__views_question_review_components_ContextMenu__["a" /* default */])().show(clientX, clientY);
    },
    addEventListener: function addEventListener() {
      document.addEventListener('click', this.clickDoc);
    },
    removeEventListener: function removeEventListener() {
      document.removeEventListener('click', this.clickDoc);
    },
    clickDoc: function clickDoc() {
      Object(__WEBPACK_IMPORTED_MODULE_1__views_question_review_components_ContextMenu__["a" /* default */])().hide();
    }
  }
});

/***/ }),

/***/ 2592:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_question_editor_packages_sj_question_src_SjQuestionButton__ = __webpack_require__(2574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_question_editor_utils_questions__ = __webpack_require__(1870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_question_editor_utils_options__ = __webpack_require__(2108);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SjQuestionButton: __WEBPACK_IMPORTED_MODULE_3__views_question_editor_packages_sj_question_src_SjQuestionButton__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a
  },
  inject: ['page'],
  props: {
    value: Array,
    disabled: Boolean
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Vuex.mapState('stepTemplate', {
    types: function types(state) {
      return state.types;
    }
  }), {
    typeList: function typeList() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.types);
    },

    questions: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  }),
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    clone: function clone(type) {
      var question = __WEBPACK_IMPORTED_MODULE_4__views_question_editor_utils_questions__["a" /* default */].make(type);
      if (question.options) {
        question.options.push(__WEBPACK_IMPORTED_MODULE_5__views_question_editor_utils_options__["a" /* default */].make(type));
        question.options.push(__WEBPACK_IMPORTED_MODULE_5__views_question_editor_utils_options__["a" /* default */].make(type));
      }
      return question;
    }
  },
  filters: {}
});

/***/ }),

/***/ 2593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {},
  data: function data() {
    return {
      visible: false,
      action: '',
      loading: false,
      key: null,
      table: [],
      pagination: {
        current_page: 1,
        per_page: 4,
        total: 0
      }
    };
  },

  computed: {},
  watch: {
    visible: function visible() {
      var _this = this;

      this.table = [];
      if (this.visible) {
        this.cache.table(this.key).then(function (table) {
          if (table) {
            _this.table = table.reverse();
            _this.pagination.total = _this.table.length;
          }
        });
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {
    onRead: function onRead(key) {
      var _this2 = this;

      this.cache.getVersion(key).then(function (value) {
        _this2.handleAction('confirm', value);
      });
    },
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.pagination.current_page = val;
    },
    handleAction: function handleAction(action, value) {
      this.action = action;
      this.doClose(value);
    },
    onClose: function onClose() {
      if (!this.visible) return;
      this.handleAction('close');
    },
    doClose: function doClose(value) {
      var _this3 = this;

      if (!this.visible) return;
      this.visible = false;
      setTimeout(function () {
        if (_this3.action) _this3.callback(_this3.action, value);
      });
    }
  }
});

/***/ }),

/***/ 2594:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__diagram__ = __webpack_require__(3639);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    diagram: __WEBPACK_IMPORTED_MODULE_0__diagram__["a" /* default */]
  },
  props: {},
  data: function data() {
    return {
      visible: false,
      action: '',
      loading: false,
      key: null,
      diagramData: {},
      currentNode: null,
      savedModelText: '',
      counter: 1, // used by addNode
      counter2: 4, // used by modifyStuff
      fullscreen: true // 全屏
    };
  },
  mounted: function mounted() {},

  computed: {
    currentNodeText: {
      get: function get() {
        var node = this.currentNode;
        if (node instanceof window.go.Node) {
          return node.data.text;
        } else {
          return '';
        }
      },
      set: function set(val) {
        var node = this.currentNode;
        if (node instanceof window.go.Node) {
          var model = this.model();
          model.startTransaction();
          model.setDataProperty(node.data, 'text', val);
          model.commitTransaction('edited text');
        }
      }
    }
  },
  methods: {
    // get access to the GoJS Model of the GoJS Diagram
    model: function model() {
      return this.$refs.diag.model();
    },
    // tell the GoJS Diagram to update based on the arbitrarily modified model data
    updateDiagramFromData: function updateDiagramFromData() {
      this.$refs.diag.updateDiagramFromData();
    },
    makeImage: function makeImage() {
      this.$refs.diag.makeAImage();
    },
    // this event listener is declared on the <diagram>
    modelChanged: function modelChanged(e) {
      if (e.isTransactionFinished) {
        // show the model data in the page's TextArea
        this.savedModelText = e.model.toJson();
      }
    },
    handleAction: function handleAction(action, value) {
      this.action = action;
      this.doClose(value);
    },
    onClose: function onClose() {
      if (!this.visible) return;
      this.handleAction('close');
    },
    doClose: function doClose(value) {
      var _this = this;

      if (!this.visible) return;
      this.visible = false;
      setTimeout(function () {
        if (_this.action) _this.callback(_this.action, value);
      });
    }
  }
});

/***/ }),

/***/ 2595:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gojs__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gojs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gojs__);

//
//
//
//
//
//
//




var $ = __WEBPACK_IMPORTED_MODULE_2_gojs___default.a.GraphObject.make;

/* harmony default export */ __webpack_exports__["a"] = ({
  store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */],
  name: '',
  props: ['modelData'],
  data: function data() {
    return {
      diagram: null
    };
  },
  mounted: function mounted() {
    console.log(this.clientHeight);
    var myDiagram = $(window.go.Diagram, this.$refs.myDiagramDIV, {
      // initialContentAlignment: window.go.Spot.Center,
      // 树形图布局
      // layout: $(window.go.TreeLayout, {angle: 90, arrangement: window.go.TreeLayout.ArrangementHorizontal}),
      'toolManager.hoverDelay': 500
    });
    myDiagram.nodeTemplate = $(window.go.Node, 'Auto', new window.go.Binding('location', 'loc', window.go.Point.parse).makeTwoWay(window.go.Point.stringify),
    // new window.go.Binding('location', 'loc'),
    {
      locationSpot: window.go.Spot.Center,
      toEndSegmentLength: 30,
      fromEndSegmentLength: 30
    }, $(window.go.Shape, 'RoundedRectangle', // 节点形状
    {
      parameter1: 20,
      fill: $(window.go.Brush, 'Linear', { 0.0: 'lightskyblue', 1.0: 'Lavender' }),
      stroke: null,
      portId: '',
      // fromLinkable: true,
      // fromLinkableSelfNode: true,
      // fromLinkableDuplicates: true,
      // toLinkable: true,
      // toLinkableSelfNode: true,
      // toLinkableDuplicates: true,
      cursor: 'pointer'
    }),
    // {fill: $(window.go.Brush, 'Linear', {0.0: 'lightskyblue', 1.0: 'Lavender'})}), // 颜色
    $(window.go.TextBlock, // 文本周围的margin
    { margin: 8 }, new window.go.Binding('text').makeTwoWay()), // 文字
    {
      toolTip: $('ToolTip', $(window.go.TextBlock, { margin: 4 }, new window.go.Binding('text', 'tooltip')))
    });

    myDiagram.linkTemplate = $(window.go.Link, {
      // routing: window.go.Link.Normal,
      curve: window.go.Link.Bezier,
      toShortLength: 3
    }, new window.go.Binding('points').makeTwoWay(), new window.go.Binding('curviness'), $(window.go.Shape, new window.go.Binding('stroke', 'color')), $(window.go.Shape, { toArrow: 'Standard' }), // 箭头
    {
      selectionAdornmentTemplate: $(window.go.Adornment, $(window.go.Shape, { isPanelMain: true, stroke: 'lightskyblue', strokeWidth: 2 }), $(window.go.Shape, { toArrow: 'Standard', fill: 'lightskyblue', stroke: null }))
    }, $(window.go.Panel, 'Auto', // option以及线中间擦除
    $(window.go.Shape, 'Diamond', { fill: 'lightskyblue', stroke: 'gray' }),
    // $(window.go.Shape,
    //   {
    //     fill: $(window.go.Brush, 'Radial',
    //       {0: 'rgb(255, 255, 255)', 0.3: 'rgb(255, 255, 255)', 1: 'rgb(255, 255, 255, 0)'}),
    //     stroke: null,
    //   }),
    $(window.go.TextBlock, new window.go.Binding('text', 'text'), new window.go.Binding('visible', 'isSelected').ofObject(), {
      textAlign: 'center',
      margin: 4
    }, new window.go.Binding('text').makeTwoWay())));
    $(window.go.Overview, this.$refs.myOverviewDiv, { observed: myDiagram, contentAlignment: window.go.Spot.Center });
    this.diagram = myDiagram;
    this.updateModel(this.modelData);
  },

  watch: {
    modelData: function modelData(val) {
      this.updateModel(val);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    clientHeight: function clientHeight(state) {
      return state.clientHeight;
    }
  })),
  methods: {
    model: function model() {
      return this.diagram.model;
    },
    updateModel: function updateModel(val) {
      // No GoJS transaction permitted when replacing Diagram.model.
      if (val instanceof window.go.Model) {
        this.diagram.model = val;
      } else {
        var m = new window.go.GraphLinksModel();
        if (val) {
          for (var p in val) {
            m[p] = val[p];
          }
        }
        this.diagram.model = m;
      }
    },
    updateDiagramFromData: function updateDiagramFromData() {
      this.diagram.startTransaction();
      // This is very general but very inefficient.
      // It would be better to modify the diagramData data by calling
      // Model.setDataProperty or Model.addNodeData, et al.
      this.diagram.updateAllRelationshipsFromData();
      this.diagram.updateAllTargetBindings();
      this.diagram.commitTransaction('updated');
    },
    makeAImage: function makeAImage() {
      var img = this.diagram.makeImage({
        background: 'white',
        type: 'image/jpeg',
        maxSize: new window.go.Size(Infinity, Infinity)
      });
      // console.log(img)
      var alink = document.createElement('a');
      alink.href = img.src;
      alink.download = 'template';
      alink.click();
      // console.log(this.diagram.viewportBounds)
    }
  }
});

/***/ }),

/***/ 2596:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_question_editor_format_recovery__ = __webpack_require__(1678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_question_editor_utils_questions__ = __webpack_require__(1870);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  inject: ['request'],
  props: {
    fixedIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      visible: false,
      stripTags: filter.stripTags,
      rules: {
        substep_id: [{ required: true, message: '请选择分步模板', trigger: 'change' }],
        index: [{ required: true, message: '请选择题目', trigger: 'change' }]
      },
      question: {},
      toQuestions: [],
      form: {
        substep_id: null,
        index: null
      }
    };
  },

  computed: {},
  watch: {
    visible: function visible() {
      var _this = this;

      if (!this.visible) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
        this.$nextTick(function () {
          return _this.$refs.form.clearValidate();
        });
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    getStepTemplateTable: function getStepTemplateTable(_) {
      return request(this.request.table, _);
    },
    getStepTemplateDetail: function getStepTemplateDetail(_) {
      return request(this.request.detail, _);
    },
    open: function open(question) {
      this.question = question;
      this.visible = true;
    },
    change: function change(_ref) {
      var _this2 = this;

      var id = _ref.id;

      this.getStepTemplateDetail({ id: id }).then(function (_ref2) {
        var data = _ref2.data;

        _this2.toQuestions = JSON.parse(data.json);
      });
    },
    emptyJumpId: function emptyJumpId(question) {
      if (question.jumpTargetId) question.jumpTargetId = '';
      if (question.options) {
        question.options.forEach(function (option) {
          if (option.jumpTargetId) option.jumpTargetId = '';
        });
      }
    },
    emptyReferId: function emptyReferId(question) {
      if (question.referIds) question.referIds = [];
      if (question.options) {
        question.options.forEach(function (option) {
          if (option.referIds) option.referIds = [];
        });
      }
    },
    resetId: function resetId(question) {
      question.id = __WEBPACK_IMPORTED_MODULE_3__views_question_editor_utils_questions__["a" /* default */].id();
    },
    getForm: function getForm() {
      var question = filter.copyJson(this.question);
      this.emptyJumpId(question);
      this.emptyReferId(question);
      this.resetId(question);
      this.form.question = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(Object(__WEBPACK_IMPORTED_MODULE_2__views_question_editor_format_recovery__["b" /* recoveryQuestions */])([question])[0]);
      return this.form;
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      this.loading = true;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          request.alert('addQuestionToStepTemplate', _this3.getForm()).then(function (res) {
            _this3.$confirm('发送题目成功,是否前往模板查看？', '提示', { type: 'success' }).then(function () {
              _this3.$router.push('/step-template/update/' + _this3.form.substep_id);
            }).finally(function () {
              _this3.visible = false;
            });
          }).finally(function () {
            _this3.loading = false;
          });
        } else {
          _this3.$message.error('提交内容填写不正确！');
        }
      });
    }
  }
});

/***/ }),

/***/ 2597:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {},
  data: function data() {
    return {
      visible: false,
      table: [],
      submit: function submit() {}
    };
  },

  computed: {},
  watch: {
    visible: function visible() {
      if (!this.visible) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    open: function open(table, callback) {
      this.table = table;
      this.visible = true;
    },
    onSubmit: function onSubmit() {
      this.submit();
      this.visible = false;
    }
  }
});

/***/ }),

/***/ 2598:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_question_editor_format_convert__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_question_editor_utils_questions__ = __webpack_require__(1870);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  inject: ['request'],
  props: {
    fixedIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      stripTags: filter.stripTags,
      loading: false,
      visible: false,
      rules: {
        fromIndex: [{ required: true, message: '请选择来源题目', type: 'array', trigger: 'change' }]
      },
      fromQuestions: [],
      toQuestions: [],
      form: {
        fromId: null,
        fromIndex: [],
        toIndex: null,
        questions: []
      }
    };
  },

  computed: {},
  watch: {
    visible: function visible() {
      var _this = this;

      if (!this.visible) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
        this.$nextTick(function () {
          return _this.$refs.form.clearValidate();
        });
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    getStepTemplateTable: function getStepTemplateTable(_) {
      return request(this.request.table, _);
    },
    getStepTemplateDetail: function getStepTemplateDetail(_) {
      return request(this.request.detail, _);
    },
    open: function open(questions) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

      this.toQuestions = questions;
      this.callback = callback;
      this.visible = true;
    },
    changeTemplate: function changeTemplate(_ref) {
      var _this2 = this;

      var id = _ref.id;

      this.form.fromIndex = [];
      this.getStepTemplateDetail({ id: id }).then(function (_ref2) {
        var data = _ref2.data;

        _this2.fromQuestions = JSON.parse(data.json);
      });
    },
    changeQuestion: function changeQuestion(value) {
      this.form.fromIndex = _.sortBy(value);
    },
    resetId: function resetId(questions) {
      questions.forEach(function (question) {
        __WEBPACK_IMPORTED_MODULE_2__views_question_editor_utils_questions__["a" /* default */].replaceId(questions, question.id);
      });
    },
    getForm: function getForm() {
      var _this3 = this;

      // 获得选择的题目列表
      var questions = filter.copyJson(_.filter(Object(__WEBPACK_IMPORTED_MODULE_1__views_question_editor_format_convert__["b" /* convertQuestions */])(this.fromQuestions), function (question, index) {
        return _this3.form.fromIndex.includes(index);
      }));
      // 移除不存在的题目ID
      __WEBPACK_IMPORTED_MODULE_2__views_question_editor_utils_questions__["a" /* default */].removeNonexistentTargetId(questions);
      // 重置题目的ID
      this.resetId(questions);
      this.form.questions = questions;
      return this.form;
    },
    onSubmit: function onSubmit() {
      var _this4 = this;

      this.loading = true;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this4.callback(_this4.getForm());
          _this4.visible = false;
        } else {
          _this4.$message.error('提交内容填写不正确！');
        }
        _this4.loading = false;
      });
    }
  }
});

/***/ }),

/***/ 2599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      visible: false,
      callback: function callback() {},
      dialogQuestions: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState('stepTemplate', {
    types: function types(state) {
      return state.types;
    }
  }), {
    questionCount: function questionCount() {
      return this.dialogQuestions.length;
    },
    questionSettledDataLabelCount: function questionSettledDataLabelCount() {
      var _this = this;

      return this.dialogQuestions.reduce(function (total, question) {
        if (_this.isDataLabelOnQuestion(question.type) && question.dataLabel.length) {
          return ++total;
        }

        if (_this.isDataLabelOnOption(question.type)) {
          for (var i in question.options) {
            if (question.options.hasOwnProperty(i) && question.options[i].dataLabel.length) {
              return ++total;
            }
          }
        }

        return total;
      }, 0);
    },
    optionSettledDataLabelCount: function optionSettledDataLabelCount() {
      var _this2 = this;

      return this.dialogQuestions.reduce(function (total, question) {
        if (_this2.isDataLabelOnQuestion(question.type) && question.dataLabel.length) {
          return ++total;
        }

        if (_this2.isDataLabelOnOption(question.type)) {
          var inc = 0;
          for (var i in question.options) {
            if (question.options.hasOwnProperty(i) && question.options[i].dataLabel.length) {
              inc++;
            }
          }

          return total + inc;
        }

        return total;
      }, 0);
    }
  }),
  methods: {
    open: function open(questions, callback) {
      this.visible = true;
      this.dialogQuestions = filter.copyJson(questions);
      this.callback = callback;
    },
    close: function close() {
      this.visible = false;
    },
    confirm: function confirm() {
      this.visible = false;
      this.callback(this.dialogQuestions);
    },
    isDataLabelOnQuestion: function isDataLabelOnQuestion(type) {
      return ['info', 'text', 'select'].includes(type);
    },
    isDataLabelOnOption: function isDataLabelOnOption(type) {
      return ['multitext', 'multiselect', 'imageMultiselect'].includes(type);
    }
  }
});

/***/ }),

/***/ 2600:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {},
  data: function data() {
    return {
      visible: false,
      table: [],
      submit: function submit() {}
    };
  },

  computed: {},
  watch: {
    visible: function visible() {
      if (!this.visible) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    open: function open(table, callback) {
      this.table = table;
      this.visible = true;
    },
    onSubmit: function onSubmit() {
      this.submit();
      this.visible = false;
    }
  }
});

/***/ }),

/***/ 2601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_question_review_components_CropperImage_src_CropperImage_vue__ = __webpack_require__(1609);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var URL = window.URL || window.webkitURL;
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {},
  data: function data() {
    return {
      visible: false,
      files: [
        // {
        //   src: '',
        //   datetime: '2016:03:14 15:22:33',
        //   loading: false,
        //   status: '' // success error
        // }
      ]
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {
    isShow: function isShow(index) {
      var file = this.files[index];
      return !file.status && !file.loading;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var maxSize = 5120;
      var isMore = file.size / 1024 / maxSize > 1;
      if (isMore) {
        this.$message.error('\u4E0A\u4F20\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 ' + maxSize + 'KB!');
      }
      return !isMore;
    },
    onSelectFile: function onSelectFile(event) {
      var _this = this;

      var files = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(event.target.files));
      files.forEach(function (file) {
        if (_this.beforeAvatarUpload(file)) {
          _this.files.push({
            src: URL.createObjectURL(file),
            data: file,
            loading: false,
            status: ''
          });
        }
      });
    },
    onEditImage: function onEditImage(index) {
      var file = this.files[index];
      Object(__WEBPACK_IMPORTED_MODULE_1__views_question_review_components_CropperImage_src_CropperImage_vue__["a" /* default */])({
        url: file.src,
        callback: function callback(blob) {
          URL.revokeObjectURL(file.data);
          file.src = URL.createObjectURL(blob);
          file.data = blob;
        }
      });
    },
    onDelete: function onDelete(index) {
      this.files.splice(index, 1);
    },
    onUploadFile: function onUploadFile(file) {
      file.loading = true;
      this.callback(file.data, this).then(function (src) {
        file.status = 'success';
      }, function (error) {
        file.status = 'error';
        throw Error(error);
      }).finally(function () {
        file.loading = false;
      });
    },
    onUploadFiles: function onUploadFiles() {
      var _this2 = this;

      this.files.forEach(function (file) {
        if (file.status !== 'success' && !file.loading) {
          _this2.onUploadFile(file);
        }
      });
    }
  }
});

/***/ }),

/***/ 3404:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3405);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("18b7295a", content, true, {});

/***/ }),

/***/ 3405:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".step-template-question-attr .el-form{width:250px}.step-template-question-attr .el-form .el-form-item{margin-bottom:10px}.step-template-question-attr .el-form .el-form-item .el-form-item__content>.el-input,.step-template-question-attr .el-form .el-form-item .el-form-item__content>.el-select{width:180px}.step-template-question-attr .step-template-question-attr-multiple-select .el-tag:first-child:last-child .el-select__tags-text{max-width:116px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:inline-block;vertical-align:middle}.step-template-question-attr .step-template-question-attr-multiple-select .el-tag:nth-last-child(2):first-child .el-select__tags-text{max-width:80px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:inline-block;vertical-align:middle}", "", {"version":3,"sources":["/workspace/src/views/step-template/pages/StepTemplateWorkspace.vue"],"names":[],"mappings":"AACA,sCAAsC,WAAW,CAChD,AACD,oDAAoD,kBAAkB,CACrE,AACD,2KAA2K,WAAW,CACrL,AACD,+HAAsI,gBAAgB,gBAAgB,uBAAuB,mBAAmB,qBAAqB,qBAAqB,CACzP,AACD,sIAAsI,eAAe,gBAAgB,uBAAuB,mBAAmB,qBAAqB,qBAAqB,CACxP","file":"StepTemplateWorkspace.vue","sourcesContent":["\n.step-template-question-attr .el-form{width:250px\n}\n.step-template-question-attr .el-form .el-form-item{margin-bottom:10px\n}\n.step-template-question-attr .el-form .el-form-item .el-form-item__content>.el-select,.step-template-question-attr .el-form .el-form-item .el-form-item__content>.el-input{width:180px\n}\n.step-template-question-attr .step-template-question-attr-multiple-select .el-tag:first-child:nth-last-child(1) .el-select__tags-text{max-width:116px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:inline-block;vertical-align:middle\n}\n.step-template-question-attr .step-template-question-attr-multiple-select .el-tag:nth-last-child(2):first-child .el-select__tags-text{max-width:80px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:inline-block;vertical-align:middle\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3406:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3407);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("d76c3788", content, true, {});

/***/ }),

/***/ 3407:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".question-type-container[data-v-36bd936f]{position:absolute;left:20px;top:20px;width:100px}.step-template-action-container[data-v-36bd936f],.step-template-right-container[data-v-36bd936f]{position:absolute;right:20px;top:20px;width:280px}.step-template-content-container[data-v-36bd936f]{position:relative;margin-left:120px;margin-right:300px}.question-attr-container[data-v-36bd936f]{position:absolute;right:20px;top:20px;width:280px}", "", {"version":3,"sources":["/workspace/src/views/step-template/pages/StepTemplateWorkspace.vue"],"names":[],"mappings":"AACA,0CAA0C,kBAAkB,UAAU,SAAS,WAAW,CACzF,AAGD,iGAFgD,kBAAkB,WAAW,SAAS,WAAW,CAGhG,AACD,kDAAkD,kBAAkB,kBAAkB,kBAAkB,CACvG,AACD,0CAA0C,kBAAkB,WAAW,SAAS,WAAW,CAC1F","file":"StepTemplateWorkspace.vue","sourcesContent":["\n.question-type-container[data-v-36bd936f]{position:absolute;left:20px;top:20px;width:100px\n}\n.step-template-right-container[data-v-36bd936f]{position:absolute;right:20px;top:20px;width:280px\n}\n.step-template-action-container[data-v-36bd936f]{position:absolute;right:20px;top:20px;width:280px\n}\n.step-template-content-container[data-v-36bd936f]{position:relative;margin-left:120px;margin-right:300px\n}\n.question-attr-container[data-v-36bd936f]{position:absolute;right:20px;top:20px;width:280px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3408:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3409);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("0fa6c950", content, true, {});

/***/ }),

/***/ 3409:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"StepTemplateWorkspace.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionNumber_vue__ = __webpack_require__(2562);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f658d3c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionNumber_vue__ = __webpack_require__(3417);
function injectStyle (ssrContext) {
  __webpack_require__(3411)
  __webpack_require__(3413)
  this["$style"] = __webpack_require__(3415)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f658d3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionNumber_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f658d3c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionNumber_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3411:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3412);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("1598ebde", content, true, {});

/***/ }),

/***/ 3412:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionNumber.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3413:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3414);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6da17e84", content, true, {});

/***/ }),

/***/ 3414:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".question-number[data-v-4f658d3c]{display:inline-block;margin-right:5px;margin-bottom:10px}.question-number .el-tag[data-v-4f658d3c]{position:relative;min-width:28px;text-align:center;padding:0 4px;cursor:pointer}.question-number .el-tag[data-v-4f658d3c]:hover{opacity:.8}.question-number .el-tag.el-tag--info[data-v-4f658d3c]{background-color:#f4f4f5;border-color:#e9e9eb;color:#606266}", "", {"version":3,"sources":["/workspace/src/views/question-editor/packages/sj-question-number/src/SjQuestionNumber.vue"],"names":[],"mappings":"AACA,kCAAkC,qBAAqB,iBAAiB,kBAAkB,CACzF,AACD,0CAA0C,kBAAkB,eAAe,kBAAkB,cAAc,cAAc,CACxH,AACD,gDAAgD,UAAU,CACzD,AACD,uDAAuD,yBAAyB,qBAAqB,aAAa,CACjH","file":"SjQuestionNumber.vue","sourcesContent":["\n.question-number[data-v-4f658d3c]{display:inline-block;margin-right:5px;margin-bottom:10px\n}\n.question-number .el-tag[data-v-4f658d3c]{position:relative;min-width:28px;text-align:center;padding:0 4px;cursor:pointer\n}\n.question-number .el-tag[data-v-4f658d3c]:hover{opacity:.8\n}\n.question-number .el-tag.el-tag--info[data-v-4f658d3c]{background-color:#f4f4f5;border-color:#e9e9eb;color:#606266\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3415:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3416);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("328dcfd8", content, true, {});

/***/ }),

/***/ 3416:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionNumber.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3417:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-height":"200px","overflow":"auto"}},[_c('draggable',{staticStyle:{"display":"inline-block"},attrs:{"list":_vm.value},on:{"start":function($event){_vm.disabled = true},"end":function($event){_vm.disabled = false}}},_vm._l((_vm.value),function(question,index){return (!_vm.fixedIds.includes(question.id))?_c('span',{staticClass:"question-number",on:{"click":function($event){return _vm.scrollIntoView(index)}}},[_c('el-tooltip',{attrs:{"disabled":_vm.disabled,"effect":"dark","content":_vm._f("stripTags")((question.title || '未填写标题')),"placement":"top","enterable":false}},[_c('el-tag',{attrs:{"size":"small","effect":"dark","type":_vm.dangerIds.includes(question.id) ? 'danger' : 'info'}},[_c('span',[_vm._v(_vm._s(index+1))])])],1)],1):_vm._e()}),0),_vm._v(" "),_vm._l((_vm.value),function(question,index){return (_vm.fixedIds.includes(question.id))?_c('span',{staticClass:"question-number",on:{"click":function($event){return _vm.scrollIntoView(index)}}},[_c('el-tooltip',{attrs:{"effect":"dark","content":_vm._f("stripTags")((question.title || '未填写标题')),"placement":"top"}},[_c('el-tag',{attrs:{"size":"small","effect":"dark","type":_vm.dangerIds.includes(question.id) ? 'danger' : 'info'}},[_c('span',[_vm._v(_vm._s(index+1))])])],1)],1):_vm._e()})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3418:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3419);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("5813b3a0", content, true, {});

/***/ }),

/***/ 3419:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestion.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3420:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3421);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("27beba3e", content, true, {});

/***/ }),

/***/ 3421:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestion.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3422:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3423);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("c272ac8c", content, true, {});

/***/ }),

/***/ 3423:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestion.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var refer = {
  get: function get(question) {
    var list = [];
    if (question.type === 'select') {
      question.options.forEach(function (option) {
        list = list.concat(option.referIds);
      });
    } else {
      list = list.concat(question.referIds);
    }
    return list;
  },

  /**
   * 清空题目参考ID
   * @param data
   * @param questionId
   * @returns {*}
   */
  empty: function empty(data, questionId) {
    var _this = this;

    if (data.type === 'select' && data.options) {
      data.options.forEach(function (option) {
        _this.empty(option, questionId);
      });
    } else {
      var index = data.referIds.indexOf(questionId);
      if (index !== -1) {
        data.referIds.splice(index, 1);
      }
    }

    return data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (refer);

/***/ }),

/***/ 3425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_vm._t("default",null,{"questions":_vm.questions})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateInfo_vue__ = __webpack_require__(2566);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26b6bdd4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateInfo_vue__ = __webpack_require__(3433);
function injectStyle (ssrContext) {
  __webpack_require__(3427)
  __webpack_require__(3429)
  this["$style"] = __webpack_require__(3431)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26b6bdd4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26b6bdd4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3427:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3428);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("03e3f54a", content, true, {});

/***/ }),

/***/ 3428:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"StepTemplateInfo.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3429:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3430);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("f3cb0262", content, true, {});

/***/ }),

/***/ 3430:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".end-answer-explain[data-v-26b6bdd4]{display:block;font-size:10px;margin-left:10px;color:#909399}", "", {"version":3,"sources":["/workspace/src/views/step-template/components/StepTemplateInfo.vue"],"names":[],"mappings":"AACA,qCAAqC,cAAc,eAAe,iBAAiB,aAAa,CAC/F","file":"StepTemplateInfo.vue","sourcesContent":["\n.end-answer-explain[data-v-26b6bdd4]{display:block;font-size:10px;margin-left:10px;color:#909399\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3431:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3432);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("1c4bc3a5", content, true, {});

/***/ }),

/***/ 3432:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"StepTemplateInfo.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-panel',[_c('template',{slot:"header"},[_vm._v("\n    模板信息\n  ")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"rules":_vm.infoRules,"model":_vm.form},nativeOn:{"submit":function($event){$event.preventDefault();}}},[_c('el-form-item',{attrs:{"prop":"title"}},[_c('el-input',{attrs:{"placeholder":"请输入模板标题"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"detail"}},[_c('el-input',{attrs:{"placeholder":"请输入模板描述","type":"textarea","autosize":{ minRows: 3}},model:{value:(_vm.form.detail),callback:function ($$v) {_vm.$set(_vm.form, "detail", $$v)},expression:"form.detail"}},[_c('template',{slot:"prepend"},[_vm._v("描述")])],2)],1),_vm._v(" "),_c('el-form-item',[[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"开启后用户执行任务时将全程录音且该模板不可添加其他录音视频类题目。","placement":"bottom"}},[_c('span',[_vm._v("全程录音"),_c('i',{staticClass:"el-icon-question",staticStyle:{"color":"#E6A23C"}})])]),_vm._v(" "),_c('el-switch',{model:{value:(_vm.form.through_record),callback:function ($$v) {_vm.$set(_vm.form, "through_record", $$v)},expression:"form.through_record"}})],_vm._v(" "),_c('span',{staticStyle:{"display":"inline-block","width":"30px"}}),_vm._v(" "),(_vm.form.through_record)?[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"开启后零工可在执行任务过程中，手动标记录音","placement":"bottom"}},[_c('span',[_vm._v("零工重点录音标记"),_c('i',{staticClass:"el-icon-question",staticStyle:{"color":"#E6A23C"}})])]),_vm._v(" "),_c('el-switch',{model:{value:(_vm.form.through_record_flag),callback:function ($$v) {_vm.$set(_vm.form, "through_record_flag", $$v)},expression:"form.through_record_flag"}})]:_vm._e()],2),_vm._v(" "),_c('el-form-item',[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"开启后用户第一次（排除门头题）完成需要拍摄照片的题目进入下一步时，静默调用前置摄像头拍摄1张照片，并静默上传","placement":"bottom"}},[_c('span',[_vm._v("执行中前置镜头抓拍"),_c('i',{staticClass:"el-icon-question",staticStyle:{"color":"#E6A23C"}})])]),_vm._v(" "),_c('el-switch',{model:{value:(_vm.form.has_sneak_photos),callback:function ($$v) {_vm.$set(_vm.form, "has_sneak_photos", $$v)},expression:"form.has_sneak_photos"}})],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"margin-bottom":"12px"}},[_vm._v("\n      强制用户结束答题的题号：\n      "),_c('el-input-number',{attrs:{"controls-position":"right","size":"mini","min":0},model:{value:(_vm.form.extended_steps_start),callback:function ($$v) {_vm.$set(_vm.form, "extended_steps_start", _vm._n($$v))},expression:"form.extended_steps_start"}})],1),_vm._v(" "),_c('span',{staticClass:"end-answer-explain"},[_vm._v("\n      1. 使用时有app版本要求\n       ")]),_vm._v(" "),_c('span',{staticClass:"end-answer-explain"},[_vm._v("\n      2. 显示题和隐藏题之间不能有逻辑跳转\n        ")]),_vm._v(" "),_c('span',{staticClass:"end-answer-explain"},[_vm._v("\n      3. 0 表示不强制\n          ")]),_vm._v(" "),_c('span',{staticClass:"end-answer-explain"},[_vm._v("\n      4. 不能和结束答题共用\n     ")]),_vm._v(" "),(_vm.scope === 'clb')?[_c('el-form-item',{staticStyle:{"margin-bottom":"12px"}},[_vm._v("\n        积分：\n        "),_c('el-input-number',{attrs:{"precision":0,"min":0,"controls":false,"size":"small"},model:{value:(_vm.form.points),callback:function ($$v) {_vm.$set(_vm.form, "points", $$v)},expression:"form.points"}}),_vm._v("\n        豆\n        "),_c('span',{staticStyle:{"padding-left":"20px"}}),_vm._v("\n        赏金：\n        "),_c('el-input-number',{attrs:{"precision":2,"min":0,"controls":false,"size":"small"},model:{value:(_vm.form.salary),callback:function ($$v) {_vm.$set(_vm.form, "salary", $$v)},expression:"form.salary"}}),_vm._v("\n        元\n      ")],1),_vm._v("\n      查理宝占位符: 一级区域 "),_c('code',[_vm._v("{$AREANAME}")]),_vm._v(" 二级分类 "),_c('code',[_vm._v("{$CATEGORYNAME}")]),_vm._v(" 产品名称 "),_c('code',[_vm._v("{$PRODUCTNAME}")])]:_vm._e()],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateQuestionAttr_vue__ = __webpack_require__(2567);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a55c467e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateQuestionAttr_vue__ = __webpack_require__(3450);
function injectStyle (ssrContext) {
  __webpack_require__(3435)
  __webpack_require__(3437)
  this["$style"] = __webpack_require__(3439)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a55c467e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateQuestionAttr_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a55c467e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateQuestionAttr_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3435:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3436);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("5cf18fc5", content, true, {});

/***/ }),

/***/ 3436:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"StepTemplateQuestionAttr.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3437:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3438);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("76e085ee", content, true, {});

/***/ }),

/***/ 3438:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"StepTemplateQuestionAttr.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3439:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3440);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("75e50be2", content, true, {});

/***/ }),

/***/ 3440:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"StepTemplateQuestionAttr.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3441:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 基本证据字段
var evidenceBaseFields = ['localFile', 'evidenceType'];
// 需要照片类型证据时显示的字段
var photoEvidenceFields = ['evidenceQuality', 'clarity', 'imageRecognitionType', 'takePhotoAuxiliaryLine', 'panoramicCamera', 'allowReusePhoto'];
// 需要视频类型证据时显示的字段
var videoEvidenceFields = ['evidenceQuality', 'minDuration'];
// 需要录音类型证据时显示的字段
var recordEvidenceFields = ['evidenceQuality', 'minDuration', 'allowCrossSubjectRecord'];

var qrcodeEvidenceFields = ['reportedTablesAssociationStepId'];

// 所有证据相关字段
var evidenceFields = _.uniq([].concat(evidenceBaseFields, photoEvidenceFields, videoEvidenceFields, recordEvidenceFields, qrcodeEvidenceFields));

/* harmony default export */ __webpack_exports__["a"] = ({
  evidence: evidenceFields,
  types: {
    photo: [].concat(evidenceBaseFields, photoEvidenceFields),
    qrcode: [].concat(evidenceBaseFields, qrcodeEvidenceFields),
    video: [].concat(evidenceBaseFields, videoEvidenceFields),
    record: [].concat(evidenceBaseFields, recordEvidenceFields)
  },
  selectTypes: {
    photo: ['evidenceType', 'evidenceQuality', 'clarity', 'imageRecognitionType', 'allowReusePhoto'],
    qrcode: ['evidenceType'].concat(qrcodeEvidenceFields),
    video: ['evidenceType'].concat(videoEvidenceFields),
    record: ['evidenceType'].concat(recordEvidenceFields)
  }
});

/***/ }),

/***/ 3442:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NORMAL", function() { return NORMAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHOOT_THE_MAIN_SHELF_BY_GROUP", function() { return SHOOT_THE_MAIN_SHELF_BY_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHOOT_THE_SECONDARY_DISPLAY_BY_GROUP", function() { return SHOOT_THE_SECONDARY_DISPLAY_BY_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NORMAL_CN", function() { return NORMAL_CN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHOOT_THE_MAIN_SHELF_BY_GROUP_CN", function() { return SHOOT_THE_MAIN_SHELF_BY_GROUP_CN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHOOT_THE_SECONDARY_DISPLAY_BY_GROUP_CN", function() { return SHOOT_THE_SECONDARY_DISPLAY_BY_GROUP_CN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "options", function() { return options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "labelsByValue", function() { return labelsByValue; });

var NORMAL = 0;
var SHOOT_THE_MAIN_SHELF_BY_GROUP = 1;
var SHOOT_THE_SECONDARY_DISPLAY_BY_GROUP = 2;

var NORMAL_CN = '无';
var SHOOT_THE_MAIN_SHELF_BY_GROUP_CN = '主货架分组拍摄';
var SHOOT_THE_SECONDARY_DISPLAY_BY_GROUP_CN = '二级陈列分组拍摄';

var options = [{
  value: NORMAL,
  label: NORMAL_CN
}, {
  value: SHOOT_THE_MAIN_SHELF_BY_GROUP,
  label: SHOOT_THE_MAIN_SHELF_BY_GROUP_CN
}, {
  value: SHOOT_THE_SECONDARY_DISPLAY_BY_GROUP,
  label: SHOOT_THE_SECONDARY_DISPLAY_BY_GROUP_CN
}];

var labelsByValue = _.mapValues(_.keyBy(options, 'value'), 'label');

/***/ }),

/***/ 3443:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3444);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("29ceda01", content, true, {});

/***/ }),

/***/ 3444:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"AttrInputType.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3445:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3446);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("605c21bf", content, true, {});

/***/ }),

/***/ 3446:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"AttrInputType.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3447:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3448);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("ac4cafb6", content, true, {});

/***/ }),

/***/ 3448:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"AttrInputType.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3449:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form-item',{attrs:{"label":"输入类型"}},[_c('el-select',{attrs:{"disabled":_vm.disabled,"placeholder":"请选择"},on:{"change":_vm.onChangeInputType},model:{value:(_vm.value.inputType),callback:function ($$v) {_vm.$set(_vm.value, "inputType", $$v)},expression:"value.inputType"}},_vm._l((_vm.inputType),function(item,key){return _c('el-option',{key:key,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),[(_vm.value.inputType === 'date')?_c('el-form-item',{attrs:{"label":"可输入最早日期"}},[_c('el-date-picker',{staticStyle:{"width":"140px"},attrs:{"disabled":_vm.disabled,"type":"date","format":"yyyy-MM-dd","value-format":"timestamp","picker-options":_vm.dateTimePickerOptions,"placeholder":"最早日期","align":"center"},model:{value:(_vm.value.inputMin),callback:function ($$v) {_vm.$set(_vm.value, "inputMin", $$v)},expression:"value.inputMin"}})],1):_vm._e(),_vm._v(" "),(_vm.value.inputType === 'date')?_c('el-form-item',{attrs:{"label":"可输入最晚日期"}},[_c('el-date-picker',{staticStyle:{"width":"140px"},attrs:{"disabled":_vm.disabled,"type":"date","format":"yyyy-MM-dd","value-format":"timestamp","picker-options":_vm.dateTimePickerOptions,"placeholder":"最晚日期","align":"center"},model:{value:(_vm.value.inputMax),callback:function ($$v) {_vm.$set(_vm.value, "inputMax", $$v)},expression:"value.inputMax"}})],1):_c('el-form-item',{attrs:{"label":"输入范围"}},[_c('el-input',{staticStyle:{"width":"82px"},attrs:{"disabled":_vm.disabled,"placeholder":"最小/短"},on:{"change":function (_) { return _vm.value.inputMin = _vm.changeNumber(_); }},model:{value:(_vm.value.inputMin),callback:function ($$v) {_vm.$set(_vm.value, "inputMin", $$v)},expression:"value.inputMin"}}),_vm._v("\n      ~\n      "),_c('el-input',{staticStyle:{"width":"82px"},attrs:{"disabled":_vm.disabled,"placeholder":"最大/长"},on:{"change":function (_) { return _vm.value.inputMax = _vm.changeNumber(_); }},model:{value:(_vm.value.inputMax),callback:function ($$v) {_vm.$set(_vm.value, "inputMax", $$v)},expression:"value.inputMax"}})],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-panel',{attrs:{"hide-collapse":"","body-style":_vm.bodyStyle}},[_c('template',{slot:"header"},[_vm._v("\n    Q"+_vm._s(_vm.index + 1)+" "+_vm._s(_vm.types[_vm.question.type])+" 属性设置\n  ")]),_vm._v(" "),_c('el-form',{attrs:{"model":_vm.question,"size":"mini"},nativeOn:{"submit":function($event){$event.preventDefault();}}},[(_vm.displayFields.includes('titleAlias'))?_c('el-form-item',{attrs:{"label":"标题别名"}},[_c('el-input',{attrs:{"disabled":_vm.disabled,"placeholder":"请输入标题别名"},model:{value:(_vm.question.titleAlias),callback:function ($$v) {_vm.$set(_vm.question, "titleAlias", $$v)},expression:"question.titleAlias"}})],1):_vm._e(),_vm._v(" "),(_vm.displayFields.includes('textPrefix'))?_c('el-form-item',{attrs:{"label":"二检描述"}},[_c('el-input',{attrs:{"disabled":_vm.disabled,"placeholder":"多促销员二次检查描述"},model:{value:(_vm.question.textPrefix),callback:function ($$v) {_vm.$set(_vm.question, "textPrefix", $$v)},expression:"question.textPrefix"}})],1):_vm._e(),_vm._v(" "),(_vm.displayFields.includes('jumpTargetId'))?_c('el-form-item',{attrs:{"label":"跳转到题"}},[_c('el-select',{attrs:{"placeholder":"请选择","disabled":_vm.disabled,"clearable":""},model:{value:(_vm.question.jumpTargetId),callback:function ($$v) {_vm.$set(_vm.question, "jumpTargetId", $$v)},expression:"question.jumpTargetId"}},[_c('el-option',{attrs:{"label":"结束答题","value":"end"}}),_vm._v(" "),(_vm.scope === 'clb')?[_c('el-option',{attrs:{"label":"下一个产品","value":"nextProduct"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"下一个模板","value":"nextTemplate"}})]:_vm._e(),_vm._v(" "),_vm._l((_vm.questions),function(item,key){return (_vm.isJump(key))?_c('el-option',{key:key,attrs:{"label":_vm.getLabel(item, key),"value":item.id}}):_vm._e()})],2)],1):_vm._e(),_vm._v(" "),(_vm.displayFields.includes('referIds'))?_c('el-form-item',{attrs:{"label":"审核参考"}},[_c('el-select',{staticClass:"step-template-question-attr-multiple-select",attrs:{"placeholder":"请选择","multiple":"","collapse-tags":"","disabled":_vm.disabled},model:{value:(_vm.question.referIds),callback:function ($$v) {_vm.$set(_vm.question, "referIds", $$v)},expression:"question.referIds"}},_vm._l((_vm.questions),function(item,key){return ((key !== _vm.index))?_c('el-option',{key:key,attrs:{"label":_vm.getLabel(item, key),"value":item.id}}):_vm._e()}),1)],1):_vm._e(),_vm._v(" "),(_vm.displayFields.includes('evidenceType'))?_c('el-form-item',{attrs:{"label":"证据类型"}},[_c('el-select',{attrs:{"disabled":_vm.disabled,"placeholder":"请选择"},model:{value:(_vm.question.evidenceType),callback:function ($$v) {_vm.$set(_vm.question, "evidenceType", $$v)},expression:"question.evidenceType"}},_vm._l((_vm.evidenceOptionType),function(item,key){return _c('el-option',{key:key,attrs:{"label":item.label,"value":item.value}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.displayFields.includes('reportedTablesAssociationStepId'))?_c('el-form-item',{attrs:{"label":"宴桌数关联题"}},[_c('el-select',{staticClass:"step-template-question-attr-multiple-select",staticStyle:{"width":"150px"},attrs:{"placeholder":"请选择","collapse-tags":"","disabled":_vm.disabled},model:{value:(_vm.question.reportedTablesAssociationStepId),callback:function ($$v) {_vm.$set(_vm.question, "reportedTablesAssociationStepId", $$v)},expression:"question.reportedTablesAssociationStepId"}},_vm._l((_vm.questions),function(item,key){return (_vm.isBefore(item, key))?_c('el-option',{key:key,attrs:{"label":_vm.getLabel(item, key),"value":item.id}}):_vm._e()}),1)],1):_vm._e(),_vm._v(" "),(_vm.displayFields.includes('imageRecognitionType'))?_c('el-form-item',{attrs:{"label":"图像识别"}},[_c('el-select',{attrs:{"placeholder":"请选择","disabled":_vm.disabled,"multiple":""},model:{value:(_vm.question.imageRecognitionType),callback:function ($$v) {_vm.$set(_vm.question, "imageRecognitionType", $$v)},expression:"question.imageRecognitionType"}},_vm._l((_vm.imageRecognitionType),function(item,key){return _c('el-option',{key:key,attrs:{"label":item.label,"value":item.value}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.displayFields.includes('takePhotoAuxiliaryLine'))?_c('el-form-item',{attrs:{"label":"拍照辅助线"}},[_c('el-select',{staticStyle:{"width":"166px"},attrs:{"placeholder":"请选择","disabled":_vm.disabled},model:{value:(_vm.question.takePhotoAuxiliaryLine),callback:function ($$v) {_vm.$set(_vm.question, "takePhotoAuxiliaryLine", $$v)},expression:"question.takePhotoAuxiliaryLine"}},_vm._l((_vm.takePhotoAuxiliaryLineType),function(item,key){return _c('el-option',{key:key,attrs:{"label":item.label,"value":item.value}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.displayFields.includes('evidenceQuality'))?_c('el-form-item',{attrs:{"label":"证据品质"}},[_c('el-select',{attrs:{"disabled":_vm.disabled,"placeholder":"请选择"},model:{value:(_vm.question.evidenceQuality),callback:function ($$v) {_vm.$set(_vm.question, "evidenceQuality", $$v)},expression:"question.evidenceQuality"}},_vm._l((_vm.evidenceQuality),function(item,key){return _c('el-option',{key:key,attrs:{"label":item.label,"value":item.value}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.displayFields.includes('inputType'))?_c('attr-input-type',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.question),callback:function ($$v) {_vm.question=$$v},expression:"question"}}):_vm._e(),_vm._v(" "),(_vm.displayFields.includes('clarity'))?_c('el-form-item',{attrs:{"label":"清晰度","label-width":"68px"}},[_c('el-select',{attrs:{"disabled":_vm.disabled,"placeholder":"请选择"},model:{value:(_vm.question.clarity),callback:function ($$v) {_vm.$set(_vm.question, "clarity", $$v)},expression:"question.clarity"}},_vm._l((_vm.clarity),function(item,key){return _c('el-option',{key:key,attrs:{"label":item.label,"value":item.value}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.displayFields.includes('delay'))?_c('el-form-item',{attrs:{"label":"步骤延迟"}},[_c('el-input-number',{attrs:{"disabled":_vm.disabled,"min":0,"controls":false},model:{value:(_vm.question.delay),callback:function ($$v) {_vm.$set(_vm.question, "delay", $$v)},expression:"question.delay"}}),_vm._v(" "),_c('span',[_vm._v(" 秒")])],1):_vm._e(),_vm._v(" "),(['info','text','select'].includes(_vm.question.type))?_c('el-form-item',{attrs:{"label":"数据标签"}},[_c('el-input',{attrs:{"placeholder":"最多不超过50个字符","disabled":_vm.disabled,"maxlength":"50"},model:{value:(_vm.question.dataLabel),callback:function ($$v) {_vm.$set(_vm.question, "dataLabel", $$v)},expression:"question.dataLabel"}})],1):_vm._e(),_vm._v(" "),(_vm.displayFields.includes('minDuration'))?_c('el-form-item',{attrs:{"label":"录制时长"}},[_c('el-input-number',{attrs:{"disabled":_vm.disabled,"min":0,"controls":false},model:{value:(_vm.minDuration),callback:function ($$v) {_vm.minDuration=$$v},expression:"minDuration"}}),_vm._v(" "),_c('span',[_vm._v(" 分钟")])],1):_vm._e(),_vm._v(" "),(_vm.displayFields.includes('needEvidence'))?_c('el-form-item',{attrs:{"label":"需要用户上传证据"}},[_c('el-switch',{attrs:{"disabled":_vm.disabled || _vm.index === 0},model:{value:(_vm.question.needEvidence),callback:function ($$v) {_vm.$set(_vm.question, "needEvidence", $$v)},expression:"question.needEvidence"}})],1):_vm._e(),_vm._v(" "),(_vm.displayFields.includes('allowReusePhoto'))?_c('el-form-item',{attrs:{"label":"允许复用已拍摄的照片"}},[_c('el-switch',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.question.allowReusePhoto),callback:function ($$v) {_vm.$set(_vm.question, "allowReusePhoto", $$v)},expression:"question.allowReusePhoto"}})],1):_vm._e(),_vm._v(" "),(_vm.displayFields.includes('localFile'))?_c('el-form-item',{attrs:{"label":"允许上传本地文件"}},[_c('el-switch',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.question.localFile),callback:function ($$v) {_vm.$set(_vm.question, "localFile", $$v)},expression:"question.localFile"}})],1):_vm._e(),_vm._v(" "),(_vm.displayFields.includes('takePhotoScene'))?_c('el-form-item',{attrs:{"label":"陈列分组拍摄"}},[_c('el-select',{staticStyle:{"width":"150px"},attrs:{"disabled":_vm.disabled,"placeholder":"请选择"},model:{value:(_vm.question.takePhotoScene),callback:function ($$v) {_vm.$set(_vm.question, "takePhotoScene", $$v)},expression:"question.takePhotoScene"}},_vm._l((_vm.takePhotoScenes.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.displayFields.includes('allowCrossSubjectRecord'))?_c('el-form-item',{attrs:{"label":"允许跨题录制"}},[_c('el-switch',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.question.allowCrossSubjectRecord),callback:function ($$v) {_vm.$set(_vm.question, "allowCrossSubjectRecord", $$v)},expression:"question.allowCrossSubjectRecord"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"强制观看任务指引视频"}},[_c('el-switch',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.question.forceGuideAudio),callback:function ($$v) {_vm.$set(_vm.question, "forceGuideAudio", $$v)},expression:"question.forceGuideAudio"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"强制观看任务指引音频"}},[_c('el-switch',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.question.forceGuideVideo),callback:function ($$v) {_vm.$set(_vm.question, "forceGuideVideo", $$v)},expression:"question.forceGuideVideo"}})],1),_vm._v(" "),(_vm.displayFields.includes('intelligentCall'))?_c('el-form-item',{attrs:{"label":"开启智能外呼"}},[_c('el-switch',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.question.intelligentCall),callback:function ($$v) {_vm.$set(_vm.question, "intelligentCall", $$v)},expression:"question.intelligentCall"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"人员检查"}},[_c('el-switch',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.question.ondutyCheck),callback:function ($$v) {_vm.$set(_vm.question, "ondutyCheck", $$v)},expression:"question.ondutyCheck"}})],1),_vm._v(" "),(_vm.displayFields.includes('throughRecordKeyQuestion') && _vm.through_record)?_c('el-form-item',{attrs:{"label":"关键题目"}},[_c('el-switch',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.question.throughRecordKeyQuestion),callback:function ($$v) {_vm.$set(_vm.question, "throughRecordKeyQuestion", $$v)},expression:"question.throughRecordKeyQuestion"}})],1):_vm._e(),_vm._v(" "),(_vm.displayFields.includes('allow_screen_capture'))?_c('el-form-item',{attrs:{"label":"允许截图和录屏"}},[_c('el-switch',{attrs:{"active-value":1,"inactive-value":2,"disabled":_vm.disabled},model:{value:(_vm.question.allow_screen_capture),callback:function ($$v) {_vm.$set(_vm.question, "allow_screen_capture", $$v)},expression:"question.allow_screen_capture"}})],1):_vm._e(),_vm._v(" "),(_vm.displayFields.includes('allow_media_download'))?_c('el-form-item',{attrs:{"label":"允许下载图片和视频"}},[_c('el-switch',{attrs:{"active-value":1,"inactive-value":2,"disabled":_vm.disabled},model:{value:(_vm.question.allow_media_download),callback:function ($$v) {_vm.$set(_vm.question, "allow_media_download", $$v)},expression:"question.allow_media_download"}})],1):_vm._e()],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3451:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateQuestionOptionAttr_vue__ = __webpack_require__(2570);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c977f5e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateQuestionOptionAttr_vue__ = __webpack_require__(3458);
function injectStyle (ssrContext) {
  __webpack_require__(3452)
  __webpack_require__(3454)
  this["$style"] = __webpack_require__(3456)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c977f5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateQuestionOptionAttr_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c977f5e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateQuestionOptionAttr_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3452:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3453);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("26ef66d1", content, true, {});

/***/ }),

/***/ 3453:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"StepTemplateQuestionOptionAttr.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3454:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3455);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("f2a0adde", content, true, {});

/***/ }),

/***/ 3455:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"StepTemplateQuestionOptionAttr.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3456:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3457);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("17479bca", content, true, {});

/***/ }),

/***/ 3457:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"StepTemplateQuestionOptionAttr.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-panel',{attrs:{"hide-collapse":"","body-style":_vm.bodyStyle}},[_c('template',{slot:"header"},[_vm._v("\n    Q"+_vm._s(_vm.questionIndex + 1)+" "+_vm._s(_vm.types[_vm.question.type])+" OPT"+_vm._s(_vm.index + 1)+" 属性设置\n  ")]),_vm._v(" "),_c('el-form',{attrs:{"model":_vm.option,"size":"mini"}},[(_vm.includes('jumpTargetId'))?_c('el-form-item',{attrs:{"label":"跳转到题"}},[_c('el-select',{attrs:{"placeholder":"请选择","disabled":_vm.disabled,"clearable":""},model:{value:(_vm.option.jumpTargetId),callback:function ($$v) {_vm.$set(_vm.option, "jumpTargetId", $$v)},expression:"option.jumpTargetId"}},[_c('el-option',{attrs:{"label":"结束答题","value":"end"}}),_vm._v(" "),(_vm.scope === 'clb')?[_c('el-option',{attrs:{"label":"下一个产品","value":"nextProduct"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"下一个模板","value":"nextTemplate"}})]:_vm._e(),_vm._v(" "),_vm._l((_vm.questions),function(item,key){return (_vm.isJump(key))?_c('el-option',{key:key,attrs:{"label":_vm.getLabel(item, key),"value":item.id}}):_vm._e()})],2)],1):_vm._e(),_vm._v(" "),(_vm.includes('mutexOptions'))?_c('el-form-item',{attrs:{"label":"选项互斥"}},[_c('el-select',{attrs:{"placeholder":"请选择","multiple":"","disabled":_vm.disabled},on:{"change":_vm.onUpdateExclusiveOption},model:{value:(_vm.option.mutexOptions),callback:function ($$v) {_vm.$set(_vm.option, "mutexOptions", $$v)},expression:"option.mutexOptions"}},_vm._l((_vm.question.options),function(item,key){return (item.id !== _vm.option.id)?_c('el-option',{key:key,attrs:{"label":_vm.getOptionLabel(item, key),"value":item.id}}):_vm._e()}),1)],1):_vm._e(),_vm._v(" "),(_vm.includes('referIds'))?_c('el-form-item',{attrs:{"label":"审核参考"}},[_c('el-select',{staticClass:"step-template-question-attr-multiple-select",attrs:{"placeholder":"请选择","multiple":"","collapse-tags":"","disabled":_vm.disabled},model:{value:(_vm.option.referIds),callback:function ($$v) {_vm.$set(_vm.option, "referIds", $$v)},expression:"option.referIds"}},_vm._l((_vm.questions),function(item,key){return (key !== _vm.questionIndex)?_c('el-option',{key:key,attrs:{"label":_vm.getLabel(item, key),"value":item.id}}):_vm._e()}),1)],1):_vm._e(),_vm._v(" "),(_vm.includes('takePhotoAuxiliaryLine') && _vm.option.needEvidence && _vm.question.evidenceType === 'photo')?_c('el-form-item',{attrs:{"label":"拍照辅助线"}},[_c('el-select',{staticStyle:{"width":"166px"},attrs:{"placeholder":"请选择","disabled":_vm.disabled},model:{value:(_vm.option.takePhotoAuxiliaryLine),callback:function ($$v) {_vm.$set(_vm.option, "takePhotoAuxiliaryLine", $$v)},expression:"option.takePhotoAuxiliaryLine"}},_vm._l((_vm.takePhotoAuxiliaryLineType),function(item,key){return _c('el-option',{key:key,attrs:{"label":item.label,"value":item.value}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.includes('nextSelectDelay'))?_c('el-form-item',{attrs:{"label":"等待时长"}},[_c('el-input-number',{staticStyle:{"width":"60px"},attrs:{"min":0,"controls":false,"disabled":_vm.disabled},model:{value:(_vm.option.nextSelectDelay),callback:function ($$v) {_vm.$set(_vm.option, "nextSelectDelay", $$v)},expression:"option.nextSelectDelay"}}),_vm._v(" "),_c('span',[_vm._v(" 秒")])],1):_vm._e(),_vm._v(" "),(_vm.includes('settlementType'))?_c('el-form-item',{attrs:{"label":"结算方式"}},[_c('el-select',{staticStyle:{"width":"83px"},attrs:{"placeholder":"请选择结算方式","disabled":_vm.disabled},model:{value:(_vm.option.settlementType),callback:function ($$v) {_vm.$set(_vm.option, "settlementType", $$v)},expression:"option.settlementType"}},[_c('el-option',{attrs:{"label":"不修改","value":0}}),_vm._v(" "),_c('el-option',{attrs:{"label":"百分比金额","value":1}}),_vm._v(" "),_c('el-option',{attrs:{"label":"固定金额","value":2}})],1),_vm._v(" "),(_vm.option.settlementType === 1)?[_c('el-input-number',{staticStyle:{"width":"75px"},attrs:{"min":0,"max":100,"precision":2,"controls":false,"disabled":_vm.disabled},model:{value:(_vm.settlementAmountRatio),callback:function ($$v) {_vm.settlementAmountRatio=$$v},expression:"settlementAmountRatio"}}),_vm._v(" "),_c('span',[_vm._v(" %")])]:_vm._e(),_vm._v(" "),(_vm.option.settlementType === 2)?[_c('el-input-number',{staticStyle:{"width":"75px"},attrs:{"min":0,"precision":2,"controls":false,"disabled":_vm.disabled},model:{value:(_vm.option.settlementAmount),callback:function ($$v) {_vm.$set(_vm.option, "settlementAmount", $$v)},expression:"option.settlementAmount"}}),_vm._v(" "),_c('span',[_vm._v(" 元")])]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.includes('needEvidence'))?_c('el-form-item',{attrs:{"label":"需要用户上传证据"}},[_c('el-switch',{attrs:{"disabled":_vm.disabled || _vm.questionIndex===0},model:{value:(_vm.option.needEvidence),callback:function ($$v) {_vm.$set(_vm.option, "needEvidence", $$v)},expression:"option.needEvidence"}})],1):_vm._e(),_vm._v(" "),(_vm.includes('localFile'))?_c('el-form-item',{attrs:{"label":"允许上传本地文件"}},[_c('el-switch',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.option.localFile),callback:function ($$v) {_vm.$set(_vm.option, "localFile", $$v)},expression:"option.localFile"}})],1):_vm._e(),_vm._v(" "),(_vm.includes('intelligentCall'))?_c('el-form-item',{attrs:{"label":"开启智能外呼"}},[_c('el-switch',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.option.intelligentCall),callback:function ($$v) {_vm.$set(_vm.option, "intelligentCall", $$v)},expression:"option.intelligentCall"}})],1):_vm._e(),_vm._v(" "),(_vm.includes('autoIncreaseTaskGroupTarget'))?_c('el-form-item',{attrs:{"label":"群组任务自动计入目标数"}},[_c('el-switch',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.option.autoIncreaseTaskGroupTarget),callback:function ($$v) {_vm.$set(_vm.option, "autoIncreaseTaskGroupTarget", $$v)},expression:"option.autoIncreaseTaskGroupTarget"}})],1):_vm._e(),_vm._v(" "),(_vm.question.type === 'select')?_c('el-form-item',{attrs:{"label":"优先审核"}},[_c('el-switch',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.option.priorityReview),callback:function ($$v) {_vm.$set(_vm.option, "priorityReview", $$v)},expression:"option.priorityReview"}})],1):_vm._e(),_vm._v(" "),(_vm.includes('inputType'))?_c('attr-input-type',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.option),callback:function ($$v) {_vm.option=$$v},expression:"option"}}):_vm._e(),_vm._v(" "),(_vm.includes('required'))?_c('el-form-item',{attrs:{"label":"必填"}},[_c('el-switch',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.option.required),callback:function ($$v) {_vm.$set(_vm.option, "required", $$v)},expression:"option.required"}})],1):_vm._e(),_vm._v(" "),(['multitext','multiselect','imageMultiselect', 'select'].includes(_vm.question.type))?_c('el-form-item',{attrs:{"label":"数据标签"}},[_c('el-input',{attrs:{"placeholder":"最多不超过50个字符","disabled":_vm.disabled,"maxlength":"50"},model:{value:(_vm.option.dataLabel),callback:function ($$v) {_vm.$set(_vm.option, "dataLabel", $$v)},expression:"option.dataLabel"}})],1):_vm._e()],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateQuestions_vue__ = __webpack_require__(2571);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53574206_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateQuestions_vue__ = __webpack_require__(3610);
function injectStyle (ssrContext) {
  __webpack_require__(3460)
  __webpack_require__(3463)
  this["$style"] = __webpack_require__(3465)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53574206"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateQuestions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53574206_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateQuestions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3460:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3461);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2c36fa8a", content, true, {});

/***/ }),

/***/ 3461:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(993);
exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".step-template-questions-group.drag-add-placeholder:after{content:\"\";display:block;min-height:270px;background-image:url(" + escape(__webpack_require__(3462)) + ");background-position:10px 90px;background-repeat:no-repeat;border:1px dashed #dcdfe6;border-radius:4px}.step-template-questions-group .sortable-ghost{display:block;list-style:none;margin-bottom:15px}.step-template-questions-group .sortable-ghost button{width:100%}", "", {"version":3,"sources":["/workspace/src/views/step-template/components/StepTemplateQuestions.vue"],"names":[],"mappings":"AACA,0DAA0D,WAAW,cAAc,iBAAiB,+CAAyD,8BAA8B,4BAAsC,0BAA0B,iBAAiB,CAC3Q,AACD,+CAA+C,cAAc,gBAAgB,kBAAkB,CAC9F,AACD,sDAAsD,UAAU,CAC/D","file":"StepTemplateQuestions.vue","sourcesContent":["\n.step-template-questions-group.drag-add-placeholder:after{content:'';display:block;min-height:270px;background-image:url(../assets/drag-add-placeholder.png);background-position:10px 90px;background-repeat:no-repeat no-repeat;border:1px dashed #DCDFE6;border-radius:4px\n}\n.step-template-questions-group .sortable-ghost{display:block;list-style:none;margin-bottom:15px\n}\n.step-template-questions-group .sortable-ghost button{width:100%\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3462:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 3463:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3464);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("0e407cba", content, true, {});

/***/ }),

/***/ 3464:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"StepTemplateQuestions.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3465:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3466);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("32af26f6", content, true, {});

/***/ }),

/***/ 3466:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"StepTemplateQuestions.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateQuestion_vue__ = __webpack_require__(2572);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c66171c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateQuestion_vue__ = __webpack_require__(3609);
function injectStyle (ssrContext) {
  __webpack_require__(3468)
  __webpack_require__(3470)
  this["$style"] = __webpack_require__(3472)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c66171c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateQuestion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c66171c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateQuestion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3468:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3469);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("036685ac", content, true, {});

/***/ }),

/***/ 3469:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"StepTemplateQuestion.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3470:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3471);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("666f7500", content, true, {});

/***/ }),

/***/ 3471:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".question-panel[data-v-0c66171c]{-webkit-transition:-webkit-box-shadow .1s ease-in;transition:-webkit-box-shadow .1s ease-in;transition:box-shadow .1s ease-in;transition:box-shadow .1s ease-in,-webkit-box-shadow .1s ease-in}.question-panel.focus[data-v-0c66171c]{-webkit-box-shadow:0 0 10px 5px rgba(0,0,0,.1);box-shadow:0 0 10px 5px rgba(0,0,0,.1)}.question-panel .question-toolbar[data-v-0c66171c]{display:inline-block;opacity:0;-webkit-transition:opacity .1s ease-in;transition:opacity .1s ease-in}.question-panel:hover .question-toolbar[data-v-0c66171c]{opacity:1}.question-panel .question-option .question-option-toolbar[data-v-0c66171c]{display:none}.question-panel .question-option .question-option-toolbar button[data-v-0c66171c]{padding:12px;margin-left:0}.question-panel .question-option:hover .question-option-toolbar[data-v-0c66171c]{display:block;margin-left:10px;min-width:216px;width:216px}", "", {"version":3,"sources":["/workspace/src/views/step-template/components/StepTemplateQuestion.vue"],"names":[],"mappings":"AACA,iCAAiC,kDAAmD,0CAA2C,kCAAmC,gEAAmE,CACpO,AACD,uCAAuC,+CAAgD,sCAAuC,CAC7H,AACD,mDAAmD,qBAAqB,UAAU,uCAAwC,8BAA+B,CACxJ,AACD,yDAAyD,SAAS,CACjE,AACD,2EAA2E,YAAY,CACtF,AACD,kFAAkF,aAAa,aAAa,CAC3G,AACD,iFAAiF,cAAc,iBAAiB,gBAAgB,WAAW,CAC1I","file":"StepTemplateQuestion.vue","sourcesContent":["\n.question-panel[data-v-0c66171c]{-webkit-transition:0.1s -webkit-box-shadow ease-in;transition:0.1s -webkit-box-shadow ease-in;transition:0.1s box-shadow ease-in;transition:0.1s box-shadow ease-in, 0.1s -webkit-box-shadow ease-in\n}\n.question-panel.focus[data-v-0c66171c]{-webkit-box-shadow:0 0 10px 5px rgba(0,0,0,0.1);box-shadow:0 0 10px 5px rgba(0,0,0,0.1)\n}\n.question-panel .question-toolbar[data-v-0c66171c]{display:inline-block;opacity:0;-webkit-transition:0.1s opacity ease-in;transition:0.1s opacity ease-in\n}\n.question-panel:hover .question-toolbar[data-v-0c66171c]{opacity:1\n}\n.question-panel .question-option .question-option-toolbar[data-v-0c66171c]{display:none\n}\n.question-panel .question-option .question-option-toolbar button[data-v-0c66171c]{padding:12px;margin-left:0\n}\n.question-panel .question-option:hover .question-option-toolbar[data-v-0c66171c]{display:block;margin-left:10px;min-width:216px;width:216px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3472:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3473);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("35b49174", content, true, {});

/***/ }),

/***/ 3473:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"StepTemplateQuestion.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3474:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionItem_vue__ = __webpack_require__(2573);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c471896_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionItem_vue__ = __webpack_require__(3481);
function injectStyle (ssrContext) {
  __webpack_require__(3475)
  __webpack_require__(3477)
  this["$style"] = __webpack_require__(3479)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c471896"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c471896_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3475:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3476);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("52d8b96c", content, true, {});

/***/ }),

/***/ 3476:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionItem.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3477:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3478);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2d2c5b20", content, true, {});

/***/ }),

/***/ 3478:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionItem.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3479:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3480);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("79d60658", content, true, {});

/***/ }),

/***/ 3480:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionItem.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"question":_vm.question,"index":_vm.index,"jumpIndex":_vm.jumpIndex,"hasJump":_vm.hasJump})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3482:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3483);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("087b7744", content, true, {});

/***/ }),

/***/ 3483:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionButton.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3484:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3485);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("0efc3a72", content, true, {});

/***/ }),

/***/ 3485:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionButton.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3486:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3487);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("8b7e0864", content, true, {});

/***/ }),

/***/ 3487:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionButton.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3488:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3489:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_SjQuestionTooltip_vue__ = __webpack_require__(3490);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_SjQuestionTooltip_vue__["a" /* default */]);

/***/ }),

/***/ 3490:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionTooltip_vue__ = __webpack_require__(2576);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6303abfe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionTooltip_vue__ = __webpack_require__(3497);
function injectStyle (ssrContext) {
  __webpack_require__(3491)
  __webpack_require__(3493)
  this["$style"] = __webpack_require__(3495)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6303abfe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionTooltip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6303abfe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionTooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3491:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3492);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("8f5bdd96", content, true, {});

/***/ }),

/***/ 3492:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionTooltip.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3493:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3494);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("c26a6856", content, true, {});

/***/ }),

/***/ 3494:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionTooltip.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3495:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3496);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("316a1d82", content, true, {});

/***/ }),

/***/ 3496:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionTooltip.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"content":_vm.content,"placement":"top","open-delay":800}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3498:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionInput_vue__ = __webpack_require__(2577);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0b1e752_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionInput_vue__ = __webpack_require__(3505);
function injectStyle (ssrContext) {
  __webpack_require__(3499)
  __webpack_require__(3501)
  this["$style"] = __webpack_require__(3503)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e0b1e752"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0b1e752_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3499:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3500);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("cad60d5a", content, true, {});

/***/ }),

/***/ 3500:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionInput.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3501:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3502);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("ba29f5b6", content, true, {});

/***/ }),

/***/ 3502:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionInput.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3503:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3504);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2d9128dd", content, true, {});

/***/ }),

/***/ 3504:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionInput.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',_vm._b({model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}},'el-input',_vm.$attrs,false),[_c('template',{slot:"append"},[_vm._t("append")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3506:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_SjQuestionRichText_vue__ = __webpack_require__(3507);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_SjQuestionRichText_vue__["a" /* default */]);

/***/ }),

/***/ 3507:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionRichText_vue__ = __webpack_require__(2578);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d6bd5fe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionRichText_vue__ = __webpack_require__(3524);
function injectStyle (ssrContext) {
  __webpack_require__(3508)
  __webpack_require__(3510)
  this["$style"] = __webpack_require__(3512)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d6bd5fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionRichText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d6bd5fe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionRichText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3508:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3509);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6362e0ea", content, true, {});

/***/ }),

/***/ 3509:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionRichText.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3510:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3511);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("900af034", content, true, {});

/***/ }),

/***/ 3511:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".question-rich-text[data-v-2d6bd5fe]{position:relative;line-height:normal}.question-rich-text .question-rich-text-footer[data-v-2d6bd5fe]{position:absolute;bottom:5px;right:5px;z-index:2;pointer-events:auto;opacity:.8;-webkit-transition:opacity .1s ease-in;transition:opacity .1s ease-in}.question-rich-text.has-ai-footer .el-textarea__inner[data-v-2d6bd5fe]{padding-right:56px}.question-rich-text:hover .question-rich-text-footer[data-v-2d6bd5fe]{opacity:1}.question-rich-text .el-textarea[data-v-2d6bd5fe]{min-height:97px}.question-rich-text .el-textarea__inner[data-v-2d6bd5fe]{min-height:inherit;resize:none}.question-rich-text .el-textarea__inner[data-v-2d6bd5fe]:empty:before{color:#c7cbd1;content:attr(placeholder);display:block}.ai-preview-label[data-v-2d6bd5fe]{font-size:13px;color:#909399;margin-bottom:8px}.ai-preview-content[data-v-2d6bd5fe]{min-height:120px;max-height:300px;overflow-y:auto;padding:12px;border:1px solid #dcdfe6;border-radius:4px;background:#fafafa;line-height:1.6;word-break:break-word}", "", {"version":3,"sources":["/workspace/src/views/question-editor/packages/sj-question-rich-text/src/SjQuestionRichText.vue"],"names":[],"mappings":"AACA,qCAAqC,kBAAkB,kBAAkB,CACxE,AACD,gEAAgE,kBAAkB,WAAW,UAAU,UAAU,oBAAoB,WAAY,uCAAwC,8BAA+B,CACvN,AACD,uEAAuE,kBAAkB,CACxF,AACD,sEAAsE,SAAS,CAC9E,AACD,kDAAkD,eAAe,CAChE,AACD,yDAAyD,mBAAmB,WAAW,CACtF,AACD,sEAAsE,cAAc,0BAA0B,aAAa,CAC1H,AACD,mCAAmC,eAAe,cAAc,iBAAiB,CAChF,AACD,qCAAqC,iBAAiB,iBAAiB,gBAAgB,aAAa,yBAAyB,kBAAkB,mBAAmB,gBAAgB,qBAAqB,CACtM","file":"SjQuestionRichText.vue","sourcesContent":["\n.question-rich-text[data-v-2d6bd5fe]{position:relative;line-height:normal\n}\n.question-rich-text .question-rich-text-footer[data-v-2d6bd5fe]{position:absolute;bottom:5px;right:5px;z-index:2;pointer-events:auto;opacity:0.8;-webkit-transition:0.1s opacity ease-in;transition:0.1s opacity ease-in\n}\n.question-rich-text.has-ai-footer .el-textarea__inner[data-v-2d6bd5fe]{padding-right:56px\n}\n.question-rich-text:hover .question-rich-text-footer[data-v-2d6bd5fe]{opacity:1\n}\n.question-rich-text .el-textarea[data-v-2d6bd5fe]{min-height:97px\n}\n.question-rich-text .el-textarea__inner[data-v-2d6bd5fe]{min-height:inherit;resize:none\n}\n.question-rich-text .el-textarea__inner[data-v-2d6bd5fe]:empty:before{color:#c7cbd1;content:attr(placeholder);display:block\n}\n.ai-preview-label[data-v-2d6bd5fe]{font-size:13px;color:#909399;margin-bottom:8px\n}\n.ai-preview-content[data-v-2d6bd5fe]{min-height:120px;max-height:300px;overflow-y:auto;padding:12px;border:1px solid #dcdfe6;border-radius:4px;background:#fafafa;line-height:1.6;word-break:break-word\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3512:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3513);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("a90ea818", content, true, {});

/***/ }),

/***/ 3513:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionRichText.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export QuestionQuillEditor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_vue__ = __webpack_require__(3515);



var defaults = {};

var MainConstructor = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.extend(__WEBPACK_IMPORTED_MODULE_1__main_vue__["a" /* default */]);

var instance = void 0,
    currentBox = void 0;

var defaultCallback = function defaultCallback(value) {
  if (currentBox) {
    var callback = currentBox.callback;
    if (typeof callback === 'function') {
      callback(value);
    }
  }
};

var initInstance = function initInstance() {
  instance = new MainConstructor({
    el: document.createElement('div')
  });

  instance.callback = defaultCallback;
};

var showBox = function showBox() {
  initInstance();

  instance.content = '';

  if (currentBox) {
    var options = currentBox.options;
    for (var prop in options) {
      if (options.hasOwnProperty(prop)) {
        instance[prop] = options[prop];
      }
    }

    if (options.callback === undefined) {
      instance.callback = defaultCallback;
    }

    var oldCb = instance.callback;
    instance.callback = function (value, instance) {
      oldCb(value, instance);
    };

    if (options.onClick) {
      instance.$on('click', options.onClick);
    }

    options.container.appendChild(instance.$el);

    __WEBPACK_IMPORTED_MODULE_0_vue___default.a.nextTick(function () {
      instance.visible = true;
      !instance.mount && (instance.mount = true);
    });
  }
};

var QuestionQuillEditor = function QuestionQuillEditor(options, callback) {
  if (__WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$isServer) return;
  if (options.callback && !callback) {
    callback = options.callback;
  }
  if (!options.container) {
    options.container = document.body;
  }

  currentBox = {
    options: _.merge({}, defaults, QuestionQuillEditor.defaults, options),
    callback: callback
  };

  showBox();
};

QuestionQuillEditor.setDefaults = function (defaults) {
  QuestionQuillEditor.defaults = defaults;
};

QuestionQuillEditor.open = function (content, options) {
  return QuestionQuillEditor(_.merge({
    content: content
  }, options));
};

QuestionQuillEditor.close = function () {
  instance.visible = false;
  currentBox = null;
};

QuestionQuillEditor.destroy = function () {
  if (instance) {
    instance.$el.remove();
    instance.$destroy();
    instance = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (QuestionQuillEditor);


/***/ }),

/***/ 3515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(2580);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b593c0b8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(3523);
function injectStyle (ssrContext) {
  __webpack_require__(3516)
  __webpack_require__(3518)
  this["$style"] = __webpack_require__(3520)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b593c0b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b593c0b8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3516:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3517);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("29cd4094", content, true, {});

/***/ }),

/***/ 3517:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".question-quill-editor{position:absolute;background-color:#fff;border:1px solid #dcdfe6;border-radius:4px;-webkit-transition:border-color .2s cubic-bezier(.645,.045,.355,1);transition:border-color .2s cubic-bezier(.645,.045,.355,1);overflow:hidden;width:500px}.question-quill-editor:hover{border-color:#c0c4cc}.question-quill-editor .ql-container{font-size:inherit}.question-quill-editor .ql-container.ql-snow{height:100%!important}.question-quill-editor .ql-container.ql-snow,.question-quill-editor .ql-toolbar.ql-snow{background-color:#fff;-webkit-box-sizing:border-box;box-sizing:border-box;border:none;width:100%}.question-quill-editor .ql-toolbar.ql-snow{padding:5px 15px;border-bottom:1px solid #dcdfe6}", "", {"version":3,"sources":["/workspace/src/views/question-editor/components/question-quill-editor/src/main.vue"],"names":[],"mappings":"AACA,uBAAuB,kBAAkB,sBAAuB,yBAAyB,kBAAkB,mEAA0E,2DAAkE,gBAAgB,WAAW,CACjR,AACD,6BAA6B,oBAAoB,CAChD,AACD,qCAAqC,iBAAiB,CACrD,AACD,6CAA+I,qBAAsB,CACpK,AACD,wFAF6C,sBAAuB,8BAA8B,sBAAsB,YAAY,UAAW,CAG9I,AADD,2CAAkE,iBAAiB,AAA2E,+BAA+B,CAC5L","file":"main.vue","sourcesContent":["\n.question-quill-editor{position:absolute;background-color:white;border:1px solid #dcdfe6;border-radius:4px;-webkit-transition:border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);transition:border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);overflow:hidden;width:500px\n}\n.question-quill-editor:hover{border-color:#c0c4cc\n}\n.question-quill-editor .ql-container{font-size:inherit\n}\n.question-quill-editor .ql-container.ql-snow{background-color:white;-webkit-box-sizing:border-box;box-sizing:border-box;border:none;width:100%;height:100% !important\n}\n.question-quill-editor .ql-toolbar.ql-snow{background-color:white;padding:5px 15px;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;border:none;border-bottom:1px solid #dcdfe6\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3518:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3519);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("0c2265f6", content, true, {});

/***/ }),

/***/ 3519:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3520:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3521);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("942c3980", content, true, {});

/***/ }),

/***/ 3521:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3522:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(1814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(1815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(1816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_quill__ = __webpack_require__(1629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_quill__);






var Clipboard = __WEBPACK_IMPORTED_MODULE_5_quill___default.a.import('modules/clipboard');
var Delta = __WEBPACK_IMPORTED_MODULE_5_quill___default.a.import('delta');

/**
 * @see https://gist.github.com/ryanhaney/d4d205594b2993224b8ad111cebe1a13
 * @see https://quilljs.com/docs/modules/
 */

var PlainClipboard = function (_Clipboard) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PlainClipboard, _Clipboard);

  function PlainClipboard() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PlainClipboard);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PlainClipboard.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PlainClipboard)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PlainClipboard, [{
    key: 'onPaste',
    value: function onPaste(e) {
      e.preventDefault();
      var range = this.quill.getSelection();
      var text = e.clipboardData.getData('text/plain');
      var delta = new Delta().retain(range.index).delete(range.length).insert(text);
      var index = text.length + range.index;
      var length = 0;
      this.quill.updateContents(delta, 'silent');
      this.quill.setSelection(index, length, 'silent');
      this.quill.scrollIntoView();
    }
  }]);

  return PlainClipboard;
}(Clipboard);

/* harmony default export */ __webpack_exports__["a"] = (PlainClipboard);

/***/ }),

/***/ 3523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],on:{"click":function($event){$event.stopPropagation();return (function (_) { return _vm.$emit('click', _); })($event)}}},[(_vm.mount)?_c('quill-editor',{ref:"editor",staticClass:"question-quill-editor",style:(_vm.style),attrs:{"id":("question-quill-editor" + _vm._uid),"content":_vm.content,"options":_vm.options,"disabled":_vm.disabled},on:{"change":_vm.change}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3524:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['question-rich-text', { 'has-ai-footer': _vm.enableAiOptimize && !_vm.disabled }]},[_c('div',{staticClass:"ql-container"},[_c('div',{class:['el-textarea', _vm.disabled?'is-disabled':'']},[_c('div',{class:['ql-editor', 'el-textarea__inner'],attrs:{"placeholder":_vm.placeholder},domProps:{"innerHTML":_vm._s(_vm.currentValue)},on:{"mouseover":_vm.showRichTextEditor}})])]),_vm._v(" "),(_vm.enableAiOptimize && !_vm.disabled)?_c('div',{staticClass:"question-rich-text-footer"},[_c('el-tooltip',{attrs:{"content":"AI 优化描述内容","placement":"top"}},[_c('el-button',{staticStyle:{"padding":"0"},attrs:{"type":"text","size":"mini","loading":_vm.aiLoading},on:{"click":function($event){$event.stopPropagation();return _vm.onAiOptimize($event)}}},[(!_vm.aiLoading)?_c('span',[_vm._v("AI 优化")]):_vm._e()])],1)],1):_vm._e(),_vm._v(" "),_c('el-dialog',{attrs:{"title":"AI 优化预览","visible":_vm.previewVisible,"width":"720px","append-to-body":""},on:{"update:visible":function($event){_vm.previewVisible=$event},"close":_vm.onPreviewClose}},[_c('el-row',{attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"ai-preview-label"},[_vm._v("原文")]),_vm._v(" "),_c('div',{staticClass:"ai-preview-content",domProps:{"innerHTML":_vm._s(_vm.previewOriginal)}})]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"ai-preview-label"},[_vm._v("优化后")]),_vm._v(" "),_c('div',{staticClass:"ai-preview-content",domProps:{"innerHTML":_vm._s(_vm.previewOptimized)}})])],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.previewVisible = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.applyOptimized}},[_vm._v("应用")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3525:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionWangRichText_vue__ = __webpack_require__(2582);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1922024_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionWangRichText_vue__ = __webpack_require__(3559);
function injectStyle (ssrContext) {
  __webpack_require__(3526)
  __webpack_require__(3528)
  this["$style"] = __webpack_require__(3530)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f1922024"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionWangRichText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1922024_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionWangRichText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3526:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3527);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2b9fb4fa", content, true, {});

/***/ }),

/***/ 3527:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionWangRichText.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3528:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3529);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("43bdcebc", content, true, {});

/***/ }),

/***/ 3529:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".question-rich-text[data-v-f1922024]{position:relative;line-height:normal}.question-rich-text .wangEditor-container[data-v-f1922024]{border:none;position:relative}.question-rich-text .question-rich-text-footer[data-v-f1922024]{position:absolute;bottom:5px;right:5px;z-index:2;pointer-events:auto;opacity:.8;-webkit-transition:opacity .1s ease-in;transition:opacity .1s ease-in}.question-rich-text.has-ai-footer[data-v-f1922024] .el-textarea__inner{padding-right:80px}.question-rich-text:hover .question-rich-text-footer[data-v-f1922024]{opacity:1}.ai-preview-label[data-v-f1922024]{font-size:13px;color:#909399;margin-bottom:8px}.ai-preview-content[data-v-f1922024]{min-height:120px;max-height:300px;overflow-y:auto;padding:12px;border:1px solid #dcdfe6;border-radius:4px;background:#fafafa;line-height:1.6;word-break:break-word}", "", {"version":3,"sources":["/workspace/src/views/question-editor/packages/sj-question-rich-text/src/SjQuestionWangRichText.vue"],"names":[],"mappings":"AACA,qCAAqC,kBAAkB,kBAAkB,CACxE,AACD,2DAA2D,YAAY,iBAAiB,CACvF,AACD,gEAAgE,kBAAkB,WAAW,UAAU,UAAU,oBAAoB,WAAY,uCAAwC,8BAA+B,CACvN,AACD,uEAAuE,kBAAkB,CACxF,AACD,sEAAsE,SAAS,CAC9E,AACD,mCAAmC,eAAe,cAAc,iBAAiB,CAChF,AACD,qCAAqC,iBAAiB,iBAAiB,gBAAgB,aAAa,yBAAyB,kBAAkB,mBAAmB,gBAAgB,qBAAqB,CACtM","file":"SjQuestionWangRichText.vue","sourcesContent":["\n.question-rich-text[data-v-f1922024]{position:relative;line-height:normal\n}\n.question-rich-text .wangEditor-container[data-v-f1922024]{border:none;position:relative\n}\n.question-rich-text .question-rich-text-footer[data-v-f1922024]{position:absolute;bottom:5px;right:5px;z-index:2;pointer-events:auto;opacity:0.8;-webkit-transition:0.1s opacity ease-in;transition:0.1s opacity ease-in\n}\n.question-rich-text.has-ai-footer[data-v-f1922024] .el-textarea__inner{padding-right:80px\n}\n.question-rich-text:hover .question-rich-text-footer[data-v-f1922024]{opacity:1\n}\n.ai-preview-label[data-v-f1922024]{font-size:13px;color:#909399;margin-bottom:8px\n}\n.ai-preview-content[data-v-f1922024]{min-height:120px;max-height:300px;overflow-y:auto;padding:12px;border:1px solid #dcdfe6;border-radius:4px;background:#fafafa;line-height:1.6;word-break:break-word\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3530:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3531);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("c53253f8", content, true, {});

/***/ }),

/***/ 3531:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionWangRichText.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputHtml_vue__ = __webpack_require__(2583);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bcfab72_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputHtml_vue__ = __webpack_require__(3539);
function injectStyle (ssrContext) {
  __webpack_require__(3533)
  __webpack_require__(3535)
  this["$style"] = __webpack_require__(3537)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bcfab72"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputHtml_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bcfab72_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputHtml_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3533:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3534);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("af394ec8", content, true, {});

/***/ }),

/***/ 3534:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"InputHtml.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3535:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3536);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2ac7c3e0", content, true, {});

/***/ }),

/***/ 3536:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".el-textarea[data-v-7bcfab72]{min-height:66px}.el-textarea__inner[data-v-7bcfab72]{min-height:inherit;resize:none}.el-textarea__inner[contenteditable=true][data-v-7bcfab72]:empty:before{color:#c7cbd1;content:attr(placeholder);display:block}", "", {"version":3,"sources":["/workspace/src/views/question-editor/components/InputHtml.vue"],"names":[],"mappings":"AACA,8BAA8B,eAAe,CAC5C,AACD,qCAAqC,mBAAmB,WAAW,CAClE,AACD,wEAAwE,cAAc,0BAA0B,aAAa,CAC5H","file":"InputHtml.vue","sourcesContent":["\n.el-textarea[data-v-7bcfab72]{min-height:66px\n}\n.el-textarea__inner[data-v-7bcfab72]{min-height:inherit;resize:none\n}\n.el-textarea__inner[contenteditable=true][data-v-7bcfab72]:empty:before{color:#c7cbd1;content:attr(placeholder);display:block\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3537:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3538);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("16369434", content, true, {});

/***/ }),

/***/ 3538:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"InputHtml.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['el-textarea', _vm.disabled?'is-disabled':'']},[_c('div',{class:[_vm.innerClass, 'el-textarea__inner'],attrs:{"placeholder":_vm.placeholder,"contenteditable":!_vm.disabled},domProps:{"innerHTML":_vm._s(_vm.html)},on:{"input":_vm.input}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main_js__ = __webpack_require__(3541);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main_js__["a" /* default */]);

/***/ }),

/***/ 3541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export QuestionWangEditor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_vue__ = __webpack_require__(3542);



var defaults = {};

var MainConstructor = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.extend(__WEBPACK_IMPORTED_MODULE_1__main_vue__["a" /* default */]);

var instance = void 0,
    currentBox = void 0;

var defaultCallback = function defaultCallback(value) {
  if (currentBox) {
    var callback = currentBox.callback;
    if (typeof callback === 'function') {
      callback(value);
    }
  }
};

var initInstance = function initInstance() {
  instance = new MainConstructor({
    el: document.createElement('div')
  });

  instance.callback = defaultCallback;
};

var showBox = function showBox() {
  if (!instance) {
    initInstance();
  }

  instance.content = '';

  if (currentBox) {
    var options = currentBox.options;
    for (var prop in options) {
      if (options.hasOwnProperty(prop)) {
        instance[prop] = options[prop];
      }
    }

    if (options.callback === undefined) {
      instance.callback = defaultCallback;
    }

    var oldCb = instance.callback;
    instance.callback = function (value, instance) {
      oldCb(value, instance);
    };

    options.container.appendChild(instance.$el);

    __WEBPACK_IMPORTED_MODULE_0_vue___default.a.nextTick(function () {
      instance.visible = true;
    });
  }
};

var QuestionWangEditor = function QuestionWangEditor(options, callback) {
  if (__WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$isServer) return;
  if (options.callback && !callback) {
    callback = options.callback;
  }
  if (!options.container) {
    options.container = document.body;
  }

  currentBox = {
    options: _.merge({}, defaults, QuestionWangEditor.defaults, options),
    callback: callback
  };

  showBox();
};

QuestionWangEditor.setDefaults = function (defaults) {
  QuestionWangEditor.defaults = defaults;
};

QuestionWangEditor.open = function (content, options) {
  return QuestionWangEditor(_.merge({
    content: content
  }, options));
};

QuestionWangEditor.close = function () {
  instance.visible = false;
  currentBox = null;
};

QuestionWangEditor.destroy = function () {
  if (instance) {
    instance.$el.remove();
    instance.$destroy();
    instance = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (QuestionWangEditor);


/***/ }),

/***/ 3542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(2584);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b64c2740_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(3558);
function injectStyle (ssrContext) {
  __webpack_require__(3543)
  __webpack_require__(3545)
  this["$style"] = __webpack_require__(3547)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b64c2740"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b64c2740_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3543:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3544);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("72291b88", content, true, {});

/***/ }),

/***/ 3544:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".question-wang-editor{position:absolute;background-color:#fff;border:1px solid #dcdfe6;border-radius:4px;-webkit-transition:border-color .2s cubic-bezier(.645,.045,.355,1);transition:border-color .2s cubic-bezier(.645,.045,.355,1);width:500px;height:auto}.question-wang-editor .wangEditor-container{border:none}.question-wang-editor .wangEditor-txt{height:auto!important;min-height:115px}.question-wang-editor:hover{border-color:#c0c4cc}", "", {"version":3,"sources":["/workspace/src/views/question-editor/components/question-wang-editor/src/main.vue"],"names":[],"mappings":"AACA,sBAAsB,kBAAkB,sBAAuB,yBAAyB,kBAAkB,mEAA0E,2DAAkE,YAAY,WAAW,CAC5Q,AACD,4CAA4C,WAAW,CACtD,AACD,sCAAsC,sBAAuB,gBAAgB,CAC5E,AACD,4BAA4B,oBAAoB,CAC/C","file":"main.vue","sourcesContent":["\n.question-wang-editor{position:absolute;background-color:white;border:1px solid #dcdfe6;border-radius:4px;-webkit-transition:border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);transition:border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);width:500px;height:auto\n}\n.question-wang-editor .wangEditor-container{border:none\n}\n.question-wang-editor .wangEditor-txt{height:auto !important;min-height:115px\n}\n.question-wang-editor:hover{border-color:#c0c4cc\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3545:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3546);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("31e15520", content, true, {});

/***/ }),

/***/ 3546:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3547:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3548);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("06560284", content, true, {});

/***/ }),

/***/ 3548:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vendor_wangEditorV2_css_wangEditor_css__ = __webpack_require__(3550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vendor_wangEditorV2_css_wangEditor_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__vendor_wangEditorV2_css_wangEditor_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vendor_wangEditorV2_js_wangEditor__ = __webpack_require__(3557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vendor_wangEditorV2_js_wangEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__vendor_wangEditorV2_js_wangEditor__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wangEditor',
  props: {
    value: {
      type: String
    },
    tag: {
      type: String,
      default: 'div'
    },
    menus: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /**
     [
     'head',  // 标题
     'bold',  // 粗体
     'italic',  // 斜体
     'underline',  // 下划线
     'strikeThrough',  // 删除线
     'foreColor',  // 文字颜色
     'backColor',  // 背景颜色
     'link',  // 插入链接
     'list',  // 列表
     'justify',  // 对齐方式
     'quote',  // 引用
     'emoticon',  // 表情
     'image',  // 插入图片
     'table',  // 表格
     'video',  // 插入视频
     'code',  // 插入代码
     'undo',  // 撤销
     'redo'  // 重复
     ]
     */
    colors: {
      type: Array,
      default: function _default() {}
    },
    /**
     [
     '#000000',
     '#eeece0',
     '#1c487f',
     '#4d80bf',
     '#c24f4a',
     '#8baa4a',
     '#7b5ba1',
     '#46acc8',
     '#f9963b',
     '#ffffff'
     ]
     */
    config: {
      type: Object,
      default: function _default() {}
    },
    zIndex: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      editor: null
    };
  },

  watch: {
    value: function value() {
      // 双向绑定，父组件同步到子组件
      if (this.value !== this.editor.$txt.html()) {
        this.editor.$txt.html(this.value);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    // 实例化编辑器
    // 双向绑定，子组件同步到父组件
    this.editor = new __WEBPACK_IMPORTED_MODULE_3__vendor_wangEditorV2_js_wangEditor___default.a(this.$el);

    this.editor.onchange = function () {
      var html = _this.editor.$txt.html();
      if (html !== _this.value) {
        _this.$emit('input', html);
      }
    };

    // 配置数据
    this.editor.config.menus = ['source', 'pasteText', '|', 'bold', 'underline', 'italic', 'eraser', 'forecolor', '|', 'head', '|', 'link', 'unlink', '|', 'undo', 'redo', '|'].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.menus));
    this.editor.config.colors = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      '#333': '深灰色',
      '#f3605b': '红色'
    }, this.colors);
    // 创建编辑器
    this.editor.create();
    // 赋初始值
    this.editor.$txt.html(this.value);
  },
  destroyed: function destroyed() {
    // 销毁编辑器
    this.editor.destroy();
  },
  render: function render(h) {
    return h(this.tag, this.$slots.default);
  }
});

/***/ }),

/***/ 3550:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3551);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("648ff7da", content, true, {});

/***/ }),

/***/ 3551:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(993);
exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".wangEditor-container{position:relative;background-color:#fff;border:1px solid #ccc;z-index:1;width:100%}.wangEditor-container a:focus,.wangEditor-container button:focus{outline:none}.wangEditor-container,.wangEditor-container *{margin:0;padding:0;box-sizing:border-box;line-height:1}.wangEditor-container img{border:none}.wangEditor-container .clearfix:after{content:\"\";display:table;clear:both}.wangEditor-container .clearfix{*zoom:1}.wangEditor-container textarea{border:none}.wangEditor-container textarea:focus{outline:none}.wangEditor-container .height-tip{position:absolute;width:3px;background-color:#ccc;left:0;transition:top .2s}.wangEditor-container .txt-toolbar{position:absolute;background-color:#fff;padding:3px 5px;border-top:2px solid #666;box-shadow:1px 3px 3px #999;border-left:1px\\9#ccc\\9;border-bottom:1px\\9#999\\9;border-right:1px\\9#999\\9}.wangEditor-container .txt-toolbar .tip-triangle{display:block;position:absolute;width:0;height:0;border:5px solid;border-color:transparent transparent #666;top:-12px;left:50%;margin-left:-5px}.wangEditor-container .txt-toolbar a{color:#666;display:inline-block;margin:0 3px;padding:5px;text-decoration:none;border-radius:3px}.wangEditor-container .txt-toolbar a:hover{background-color:#f1f1f1}.wangEditor-container .img-drag-point{display:block;position:absolute;width:12px;height:12px;border-radius:50%;cursor:se-resize;background-color:#666;margin-left:-6px;margin-top:-6px;box-shadow:1px 1px 5px #999}.wangEditor-container .wangEditor-upload-progress{position:absolute;height:1px;background:#1e88e5;width:0;display:none;-webkit-transition:width .5s;-o-transition:width .5s;transition:width .5s}.wangEditor-fullscreen{position:fixed;top:0;bottom:0;left:0;right:0}.wangEditor-container .code-textarea{resize:none;width:100%;font-size:14px;line-height:1.5;font-family:Verdana;color:#333;padding:0 15px}.wangEditor-menu-container{width:100%;border-bottom:1px solid #f1f1f1;background-color:#fff}.wangEditor-menu-container a{text-decoration:none}.wangEditor-menu-container .menu-group{float:left;padding:0 8px;border-right:1px solid #f1f1f1}.wangEditor-menu-container .menu-item{float:left;position:relative;text-align:center;height:31px;width:35px}.wangEditor-menu-container .menu-item:hover{background-color:#f1f1f1}.wangEditor-menu-container .menu-item a{display:block;text-align:center;color:#666;width:100%;padding:8px 0;font-size:.9em}.wangEditor-menu-container .menu-item .selected{color:#1e88e5}.wangEditor-menu-container .menu-item .active{background-color:#f1f1f1}.wangEditor-menu-container .menu-item .disable{opacity:.5;filter:alpha(opacity=50)}.wangEditor-menu-container .menu-tip{display:block;position:absolute;z-index:20;width:60px;text-align:center;background-color:#666;color:#fff;padding:7px 0;font-size:12px;top:100%;left:50%;margin-left:-30px;border-radius:2px;box-shadow:1px 1px 5px #999;display:none}.wangEditor-menu-container .menu-tip-40{width:40px;margin-left:-20px}.wangEditor-menu-container .menu-tip-50{width:50px;margin-left:-25px}.wangEditor-menu-shadow{border-bottom:1px\\9#f1f1f1\\9;box-shadow:0 1px 3px #999}.wangEditor-container .wangEditor-txt{width:100%;text-align:left;padding:5px 15px;line-height:1.5;margin-top:0;overflow-y:auto}.wangEditor-container .wangEditor-txt h1,.wangEditor-container .wangEditor-txt h2,.wangEditor-container .wangEditor-txt h3,.wangEditor-container .wangEditor-txt h4,.wangEditor-container .wangEditor-txt h5,.wangEditor-container .wangEditor-txt p{margin:10px 0;line-height:1.8}.wangEditor-container .wangEditor-txt h1 *,.wangEditor-container .wangEditor-txt h2 *,.wangEditor-container .wangEditor-txt h3 *,.wangEditor-container .wangEditor-txt h4 *,.wangEditor-container .wangEditor-txt h5 *,.wangEditor-container .wangEditor-txt p *{line-height:1.8}.wangEditor-container .wangEditor-txt ol,.wangEditor-container .wangEditor-txt ul{padding-left:20px}.wangEditor-container .wangEditor-txt img{cursor:pointer}.wangEditor-container .wangEditor-txt img.clicked,.wangEditor-container .wangEditor-txt table.clicked{box-shadow:1px 1px 10px #999}.wangEditor-container .wangEditor-txt pre code{line-height:1.5}.wangEditor-container .wangEditor-txt:focus{outline:none}.wangEditor-container .wangEditor-txt blockquote{display:block;border-left:8px solid #d0e5f2;padding:5px 10px;margin:10px 0;line-height:1.4;font-size:100%;background-color:#f1f1f1}.wangEditor-container .wangEditor-txt table{border:none;border-collapse:collapse}.wangEditor-container .wangEditor-txt table td,.wangEditor-container .wangEditor-txt table th{border:1px solid #999;padding:3px 5px;min-width:50px;height:20px}.wangEditor-container .wangEditor-txt pre{border:1px solid #ccc;background-color:#f8f8f8;padding:10px;margin:5px 0;font-size:.8em;border-radius:3px}.wangEditor-drop-list{display:none;position:absolute;background-color:#fff;overflow:hidden;z-index:10;transition:height .7s;border-top:1px solid #f1f1f1;box-shadow:1px 3px 3px #999;border-left:1px\\9#ccc\\9;border-bottom:1px\\9#999\\9;border-right:1px\\9#999\\9}.wangEditor-drop-list a{text-decoration:none;display:block;color:#666;padding:3px 5px}.wangEditor-drop-list a:hover{background-color:#f1f1f1}.txt-toolbar,.wangEditor-drop-panel{display:none;position:absolute;padding:10px;font-size:14px;background-color:#fff;z-index:10;border-top:2px solid #666;box-shadow:1px 3px 3px #999;border-left:1px\\9#ccc\\9;border-bottom:1px\\9#999\\9;border-right:1px\\9#999\\9}.txt-toolbar .tip-triangle,.wangEditor-drop-panel .tip-triangle{display:block;position:absolute;width:0;height:0;border:5px solid;border-color:transparent transparent #666;top:-12px;left:50%;margin-left:-5px}.txt-toolbar a,.wangEditor-drop-panel a{text-decoration:none}.txt-toolbar input[type=text],.wangEditor-drop-panel input[type=text]{border:none;border-bottom:1px solid #ccc;font-size:14px;height:20px;color:#333;padding:3px 0}.txt-toolbar input[type=text]:focus,.wangEditor-drop-panel input[type=text]:focus{outline:none;border-bottom:2px solid #1e88e5}.txt-toolbar input[type=text].block,.wangEditor-drop-panel input[type=text].block{display:block;width:100%}.txt-toolbar textarea,.wangEditor-drop-panel textarea{border:1px solid #ccc}.txt-toolbar textarea:focus,.wangEditor-drop-panel textarea:focus{outline:none;border-color:#1e88e5}.txt-toolbar button,.wangEditor-drop-panel button{font-size:14px;color:#1e88e5;border:none;padding:10px;background-color:#fff;cursor:pointer;border-radius:3px}.txt-toolbar button:hover,.wangEditor-drop-panel button:hover{background-color:#f1f1f1}.txt-toolbar button:focus,.wangEditor-drop-panel button:focus{outline:none}.txt-toolbar button.right,.wangEditor-drop-panel button.right{float:right;margin-left:10px}.txt-toolbar button.gray,.wangEditor-drop-panel button.gray{color:#999}.txt-toolbar button.link,.wangEditor-drop-panel button.link{padding:5px 10px}.txt-toolbar button.link:hover,.wangEditor-drop-panel button.link:hover{background-color:#fff;text-decoration:underline}.txt-toolbar .color-item,.wangEditor-drop-panel .color-item{display:block;float:left;width:25px;height:25px;text-align:center;padding:2px;border-radius:2px;text-decoration:underline}.txt-toolbar .color-item:hover,.wangEditor-drop-panel .color-item:hover{background-color:#f1f1f1}.txt-toolbar .list-menu-item,.wangEditor-drop-panel .list-menu-item{display:block;float:left;color:#333;padding:5px;border-radius:2px}.txt-toolbar .list-menu-item:hover,.wangEditor-drop-panel .list-menu-item:hover{background-color:#f1f1f1}.txt-toolbar table.choose-table,.wangEditor-drop-panel table.choose-table{border:none;border-collapse:collapse}.txt-toolbar table.choose-table td,.wangEditor-drop-panel table.choose-table td{border:1px solid #ccc;width:16px;height:12px}.txt-toolbar table.choose-table td.active,.wangEditor-drop-panel table.choose-table td.active{background-color:#ccc;opacity:.5;filter:alpha(opacity=50)}.txt-toolbar .panel-tab .tab-container,.wangEditor-drop-panel .panel-tab .tab-container{margin-bottom:5px}.txt-toolbar .panel-tab .tab-container a,.wangEditor-drop-panel .panel-tab .tab-container a{display:inline-block;color:#999;text-align:center;margin:0 5px;padding:5px}.txt-toolbar .panel-tab .tab-container a.selected,.wangEditor-drop-panel .panel-tab .tab-container a.selected{color:#1e88e5;border-bottom:2px solid #1e88e5}.txt-toolbar .panel-tab .content-container .content,.wangEditor-drop-panel .panel-tab .content-container .content{display:none}.txt-toolbar .panel-tab .content-container .content a,.wangEditor-drop-panel .panel-tab .content-container .content a{display:inline-block;margin:2px;padding:2px;border-radius:2px}.txt-toolbar .panel-tab .content-container .content a:hover,.wangEditor-drop-panel .panel-tab .content-container .content a:hover{background-color:#f1f1f1}.txt-toolbar .panel-tab .content-container .selected,.wangEditor-drop-panel .panel-tab .content-container .selected{display:block}.txt-toolbar .panel-tab .emotion-content-container,.wangEditor-drop-panel .panel-tab .emotion-content-container{height:200px;overflow-y:auto}.txt-toolbar .upload-icon-container,.wangEditor-drop-panel .upload-icon-container{color:#ccc;text-align:center;margin:20px 20px 15px!important;padding:5px!important;font-size:65px;cursor:pointer;border:2px dotted #f1f1f1;display:block!important}.txt-toolbar .upload-icon-container:hover,.wangEditor-drop-panel .upload-icon-container:hover{color:#666;border-color:#ccc}.wangEditor-modal{position:absolute;top:50%;left:50%;background-color:#fff;border-top:1px solid #f1f1f1;box-shadow:1px 3px 3px #999;border-top:1px\\9#ccc\\9;border-left:1px\\9#ccc\\9;border-bottom:1px\\9#999\\9;border-right:1px\\9#999\\9}.wangEditor-modal .wangEditor-modal-close{position:absolute;top:0;right:0;margin-top:-25px;margin-right:-25px;font-size:1.5em;color:#666;cursor:pointer}@font-face{font-family:icomoon;src:url(" + escape(__webpack_require__(3552)) + ");src:url(" + escape(__webpack_require__(3553)) + "?#iefix-qdfu1s) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(3554)) + ") format(\"truetype\"),url(" + escape(__webpack_require__(3555)) + ") format(\"woff\"),url(" + escape(__webpack_require__(3556)) + "#icomoon) format(\"svg\");font-weight:400;font-style:normal}[class*=\" wangeditor-menu-img-\"],[class^=wangeditor-menu-img-]{font-family:icomoon;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.wangeditor-menu-img-link:before{content:\"\\E800\"}.wangeditor-menu-img-unlink:before{content:\"\\E801\"}.wangeditor-menu-img-code:before{content:\"\\E802\"}.wangeditor-menu-img-cancel:before{content:\"\\E803\"}.wangeditor-menu-img-terminal:before{content:\"\\E804\"}.wangeditor-menu-img-angle-down:before{content:\"\\E805\"}.wangeditor-menu-img-font:before{content:\"\\E806\"}.wangeditor-menu-img-bold:before{content:\"\\E807\"}.wangeditor-menu-img-italic:before{content:\"\\E808\"}.wangeditor-menu-img-header:before{content:\"\\E809\"}.wangeditor-menu-img-align-left:before{content:\"\\E80A\"}.wangeditor-menu-img-align-center:before{content:\"\\E80B\"}.wangeditor-menu-img-align-right:before{content:\"\\E80C\"}.wangeditor-menu-img-list-bullet:before{content:\"\\E80D\"}.wangeditor-menu-img-indent-left:before{content:\"\\E80E\"}.wangeditor-menu-img-indent-right:before{content:\"\\E80F\"}.wangeditor-menu-img-list-numbered:before{content:\"\\E810\"}.wangeditor-menu-img-underline:before{content:\"\\E811\"}.wangeditor-menu-img-table:before{content:\"\\E812\"}.wangeditor-menu-img-eraser:before{content:\"\\E813\"}.wangeditor-menu-img-text-height:before{content:\"\\E814\"}.wangeditor-menu-img-brush:before{content:\"\\E815\"}.wangeditor-menu-img-pencil:before{content:\"\\E816\"}.wangeditor-menu-img-minus:before{content:\"\\E817\"}.wangeditor-menu-img-picture:before{content:\"\\E818\"}.wangeditor-menu-img-file-image:before{content:\"\\E819\"}.wangeditor-menu-img-cw:before{content:\"\\E81A\"}.wangeditor-menu-img-ccw:before{content:\"\\E81B\"}.wangeditor-menu-img-music:before{content:\"\\E911\"}.wangeditor-menu-img-play:before{content:\"\\E912\"}.wangeditor-menu-img-location:before{content:\"\\E947\"}.wangeditor-menu-img-happy:before{content:\"\\E9DF\"}.wangeditor-menu-img-sigma:before{content:\"\\EA67\"}.wangeditor-menu-img-enlarge2:before{content:\"\\E98B\"}.wangeditor-menu-img-shrink2:before{content:\"\\E98C\"}.wangeditor-menu-img-newspaper:before{content:\"\\E904\"}.wangeditor-menu-img-camera:before{content:\"\\E90F\"}.wangeditor-menu-img-video-camera:before{content:\"\\E914\"}.wangeditor-menu-img-file-zip:before{content:\"\\E92B\"}.wangeditor-menu-img-stack:before{content:\"\\E92E\"}.wangeditor-menu-img-credit-card:before{content:\"\\E93F\"}.wangeditor-menu-img-address-book:before{content:\"\\E944\"}.wangeditor-menu-img-envelop:before{content:\"\\E945\"}.wangeditor-menu-img-drawer:before{content:\"\\E95C\"}.wangeditor-menu-img-download:before{content:\"\\E960\"}.wangeditor-menu-img-upload:before{content:\"\\E961\"}.wangeditor-menu-img-lock:before{content:\"\\E98F\"}.wangeditor-menu-img-unlocked:before{content:\"\\E990\"}.wangeditor-menu-img-wrench:before{content:\"\\E991\"}.wangeditor-menu-img-eye:before{content:\"\\E9CE\"}.wangeditor-menu-img-eye-blocked:before{content:\"\\E9D1\"}.wangeditor-menu-img-command:before{content:\"\\EA4E\"}.wangeditor-menu-img-font2:before{content:\"\\EA5C\"}.wangeditor-menu-img-libreoffice:before{content:\"\\EADE\"}.wangeditor-menu-img-quotes-left:before{content:\"\\E977\"}.wangeditor-menu-img-strikethrough:before{content:\"\\EA65\"}.wangeditor-menu-img-desktop:before{content:\"\\F108\"}.wangeditor-menu-img-tablet:before{content:\"\\F10A\"}.wangeditor-menu-img-search-plus:before{content:\"\\F00E\"}.wangeditor-menu-img-search-minus:before{content:\"\\F010\"}.wangeditor-menu-img-trash-o:before{content:\"\\F014\"}.wangeditor-menu-img-align-justify:before{content:\"\\F039\"}.wangeditor-menu-img-arrows-v:before{content:\"\\F07D\"}.wangeditor-menu-img-sigma2:before{content:\"\\EA68\"}.wangeditor-menu-img-omega:before{content:\"\\E900\"}.wangeditor-menu-img-cancel-circle:before{content:\"\\E901\"}.hljs{display:block;overflow-x:auto;padding:.5em;color:#333;background:#f8f8f8;-webkit-text-size-adjust:none}.diff .hljs-header,.hljs-comment{color:#998;font-style:italic}.css .rule .hljs-keyword,.hljs-keyword,.hljs-request,.hljs-status,.hljs-subst,.hljs-winutils,.nginx .hljs-title{color:#333;font-weight:700}.hljs-hexcolor,.hljs-number,.ruby .hljs-constant{color:teal}.hljs-doctag,.hljs-string,.hljs-tag .hljs-value,.tex .hljs-formula{color:#d14}.hljs-id,.hljs-title,.scss .hljs-preprocessor{color:#900;font-weight:700}.hljs-list .hljs-keyword,.hljs-subst{font-weight:400}.hljs-class .hljs-title,.hljs-type,.tex .hljs-command,.vhdl .hljs-literal{color:#458;font-weight:700}.django .hljs-tag .hljs-keyword,.hljs-rule .hljs-property,.hljs-tag,.hljs-tag .hljs-title{color:navy;font-weight:400}.hljs-attribute,.hljs-name,.hljs-variable,.lisp .hljs-body{color:teal}.hljs-regexp{color:#009926}.clojure .hljs-keyword,.hljs-prompt,.hljs-symbol,.lisp .hljs-keyword,.ruby .hljs-symbol .hljs-string,.scheme .hljs-keyword,.tex .hljs-special{color:#990073}.hljs-built_in{color:#0086b3}.hljs-cdata,.hljs-doctype,.hljs-pi,.hljs-pragma,.hljs-preprocessor,.hljs-shebang{color:#999;font-weight:700}.hljs-deletion{background:#fdd}.hljs-addition{background:#dfd}.diff .hljs-change{background:#0086b3}.hljs-chunk{color:#aaa}", "", {"version":3,"sources":["/workspace/src/vendor/wangEditorV2/css/wangEditor.css"],"names":[],"mappings":"AAMA,sBACE,kBAAmB,AACnB,sBAAuB,AACvB,sBAAuB,AACvB,UAAW,AACX,UAAY,CACb,AACD,iEAEE,YAAc,CACf,AACD,8CAEE,SAAU,AACV,UAAW,AACX,sBAAuB,AACvB,aAAe,CAChB,AACD,0BACE,WAAa,CACd,AACD,sCACE,WAAY,AACZ,cAAe,AACf,UAAY,CACb,AACD,iCACE,MAAS,CACV,AACD,+BACE,WAAa,CACd,AACD,qCACE,YAAc,CACf,AACD,kCACE,kBAAmB,AACnB,UAAW,AACX,sBAAuB,AACvB,OAAQ,AACR,kBAAoB,CACrB,AACD,mCACE,kBAAmB,AACnB,sBAAuB,AACvB,gBAAiB,AACjB,0BAA2B,AAC3B,4BAA6B,AAC7B,wBAAkC,AAClC,0BAAoC,AACpC,wBAAmC,CACpC,AACD,iDACE,cAAe,AACf,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,iBAAkB,AAClB,0CAAuD,AACvD,UAAW,AACX,SAAU,AACV,gBAAkB,CACnB,AACD,qCACE,WAAY,AACZ,qBAAsB,AACtB,aAAc,AACd,YAAa,AACb,qBAAsB,AACtB,iBAAmB,CACpB,AACD,2CACE,wBAA0B,CAC3B,AACD,sCACE,cAAe,AACf,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,iBAAkB,AAClB,sBAAuB,AACvB,iBAAkB,AAClB,gBAAiB,AACjB,2BAA6B,CAC9B,AACD,kDACE,kBAAmB,AACnB,WAAY,AACZ,mBAAoB,AACpB,QAAS,AACT,aAAc,AACd,6BAA8B,AAC9B,wBAAyB,AACzB,oBAAsB,CACvB,AACD,uBACE,eAAgB,AAChB,MAAO,AACP,SAAU,AACV,OAAQ,AACR,OAAS,CACV,AACD,qCACE,YAAa,AACb,WAAY,AACZ,eAAgB,AAChB,gBAAiB,AACjB,oBAAuB,AACvB,WAAY,AACZ,cAAuB,CACxB,AACD,2BACE,WAAY,AACZ,gCAAiC,AACjC,qBAAuB,CACxB,AACD,6BACE,oBAAsB,CACvB,AACD,uCACE,WAAY,AACZ,cAAe,AACf,8BAAgC,CACjC,AACD,sCACE,WAAY,AACZ,kBAAmB,AACnB,kBAAmB,AACnB,YAAa,AACb,UAAY,CACb,AACD,4CACE,wBAA0B,CAC3B,AACD,wCACE,cAAe,AACf,kBAAmB,AACnB,WAAY,AACZ,WAAY,AACZ,cAAe,AACf,cAAiB,CAClB,AACD,gDACE,aAAe,CAChB,AACD,8CACE,wBAA0B,CAC3B,AACD,+CACE,WAAa,AACb,wBAA0B,CAC3B,AACD,qCACE,cAAe,AACf,kBAAmB,AACnB,WAAY,AACZ,WAAY,AACZ,kBAAmB,AACnB,sBAAuB,AACvB,WAAY,AACZ,cAAe,AACf,eAAgB,AAChB,SAAU,AACV,SAAU,AACV,kBAAmB,AACnB,kBAAmB,AACnB,4BAA6B,AAC7B,YAAc,CAaf,AACD,wCACE,WAAY,AACZ,iBAAmB,CACpB,AACD,wCACE,WAAY,AACZ,iBAAmB,CACpB,AACD,wBAEE,6BAAuC,AACvC,yBAA2B,CAC5B,AACD,sCACE,WAAY,AACZ,gBAAiB,AACjB,iBAAkB,AAClB,gBAAiB,AACjB,aAAc,AACd,eAAiB,CAClB,AACD,qPAME,cAAe,AACf,eAAiB,CAClB,AACD,iQAME,eAAiB,CAClB,AACD,kFAEE,iBAAmB,CACpB,AACD,0CACE,cAAgB,CACjB,AAID,sGACE,4BAA8B,CAC/B,AACD,+CACE,eAAiB,CAClB,AACD,4CACE,YAAc,CACf,AACD,iDACE,cAAe,AACf,8BAA+B,AAC/B,iBAAkB,AAClB,cAAe,AACf,gBAAiB,AACjB,eAAgB,AAChB,wBAA0B,CAC3B,AACD,4CACE,YAAa,AACb,wBAA0B,CAC3B,AACD,8FAEE,sBAAuB,AACvB,gBAAiB,AACjB,eAAgB,AAChB,WAAa,CACd,AACD,0CACE,sBAAuB,AACvB,yBAA0B,AAC1B,aAAc,AACd,aAAgB,AAChB,eAAiB,AACjB,iBAAmB,CACpB,AACD,sBACE,aAAc,AACd,kBAAmB,AACnB,sBAAuB,AACvB,gBAAiB,AACjB,WAAY,AACZ,sBAAuB,AACvB,6BAA8B,AAC9B,4BAA6B,AAC7B,wBAAkC,AAClC,0BAAoC,AACpC,wBAAmC,CACpC,AACD,wBACE,qBAAsB,AACtB,cAAe,AACf,WAAY,AACZ,eAAiB,CAClB,AACD,8BACE,wBAA0B,CAC3B,AACD,oCAEE,aAAc,AACd,kBAAmB,AACnB,aAAc,AACd,eAAgB,AAEhB,sBAAuB,AACvB,WAAY,AACZ,0BAA2B,AAC3B,4BAA6B,AAC7B,wBAAkC,AAClC,0BAAoC,AACpC,wBAAmC,CACpC,AACD,gEAEE,cAAe,AACf,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,iBAAkB,AAClB,0CAAuD,AACvD,UAAW,AACX,SAAU,AACV,gBAAkB,CACnB,AACD,wCAEE,oBAAsB,CACvB,AACD,sEAEE,YAAa,AACb,6BAA8B,AAC9B,eAAgB,AAChB,YAAa,AACb,WAAY,AACZ,aAAe,CAChB,AACD,kFAEE,aAAc,AACd,+BAAiC,CAClC,AACD,kFAEE,cAAe,AACf,UAAY,CACb,AACD,sDAEE,qBAAuB,CACxB,AACD,kEAEE,aAAc,AACd,oBAAsB,CACvB,AACD,kDAEE,eAAgB,AAChB,cAAe,AACf,YAAa,AACb,aAAc,AACd,sBAAuB,AACvB,eAAgB,AAChB,iBAAmB,CACpB,AACD,8DAEE,wBAA0B,CAC3B,AACD,8DAEE,YAAc,CACf,AACD,8DAEE,YAAa,AACb,gBAAkB,CACnB,AACD,4DAEE,UAAY,CACb,AACD,4DAEE,gBAAkB,CACnB,AACD,wEAEE,sBAAuB,AACvB,yBAA2B,CAC5B,AACD,4DAEE,cAAe,AACf,WAAY,AACZ,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,YAAa,AACb,kBAAmB,AACnB,yBAA2B,CAC5B,AACD,wEAEE,wBAA0B,CAC3B,AACD,oEAEE,cAAe,AACf,WAAY,AACZ,WAAY,AACZ,YAAiB,AACjB,iBAAmB,CACpB,AACD,gFAEE,wBAA0B,CAC3B,AACD,0EAEE,YAAa,AACb,wBAA0B,CAC3B,AACD,gFAEE,sBAAuB,AACvB,WAAY,AACZ,WAAa,CACd,AACD,8FAEE,sBAAuB,AACvB,WAAY,AACZ,wBAA0B,CAC3B,AACD,wFAEE,iBAAmB,CACpB,AACD,4FAEE,qBAAsB,AACtB,WAAY,AACZ,kBAAmB,AACnB,aAAc,AACd,WAAiB,CAClB,AACD,8GAEE,cAAe,AACf,+BAAiC,CAClC,AACD,kHAEE,YAAc,CACf,AACD,sHAEE,qBAAsB,AACtB,WAAY,AACZ,YAAa,AACb,iBAAmB,CACpB,AACD,kIAEE,wBAA0B,CAC3B,AACD,oHAEE,aAAe,CAChB,AACD,gHAEE,aAAc,AACd,eAAiB,CAClB,AACD,kFAEE,WAAY,AACZ,kBAAmB,AACnB,gCAAuC,AACvC,sBAAwB,AACxB,eAAgB,AAChB,eAAgB,AAChB,0BAA2B,AAC3B,uBAA0B,CAC3B,AACD,8FAEE,WAAY,AACZ,iBAAmB,CACpB,AACD,kBACE,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,sBAAuB,AACvB,6BAA8B,AAC9B,4BAA6B,AAC7B,uBAAiC,AACjC,wBAAkC,AAClC,0BAAoC,AACpC,wBAAmC,CACpC,AACD,0CACE,kBAAmB,AACnB,MAAO,AACP,QAAS,AACT,iBAAkB,AAClB,mBAAoB,AACpB,gBAAiB,AACjB,WAAY,AACZ,cAAgB,CACjB,AACD,WACE,oBAAuB,AACvB,kCAAyC,AACzC,wMAAmP,AACnP,gBAAoB,AACpB,iBAAmB,CACpB,AACD,+DAEE,oBAAuB,AACvB,WAAY,AACZ,kBAAmB,AACnB,gBAAoB,AACpB,oBAAqB,AACrB,oBAAqB,AACrB,cAAe,AAEf,mCAAoC,AACpC,iCAAmC,CACpC,AACD,iCACE,eAAiB,CAClB,AACD,mCACE,eAAiB,CAClB,AACD,iCACE,eAAiB,CAClB,AACD,mCACE,eAAiB,CAClB,AACD,qCACE,eAAiB,CAClB,AACD,uCACE,eAAiB,CAClB,AACD,iCACE,eAAiB,CAClB,AACD,iCACE,eAAiB,CAClB,AACD,mCACE,eAAiB,CAClB,AACD,mCACE,eAAiB,CAClB,AACD,uCACE,eAAiB,CAClB,AACD,yCACE,eAAiB,CAClB,AACD,wCACE,eAAiB,CAClB,AACD,wCACE,eAAiB,CAClB,AACD,wCACE,eAAiB,CAClB,AACD,yCACE,eAAiB,CAClB,AACD,0CACE,eAAiB,CAClB,AACD,sCACE,eAAiB,CAClB,AACD,kCACE,eAAiB,CAClB,AACD,mCACE,eAAiB,CAClB,AACD,wCACE,eAAiB,CAClB,AACD,kCACE,eAAiB,CAClB,AACD,mCACE,eAAiB,CAClB,AACD,kCACE,eAAiB,CAClB,AACD,oCACE,eAAiB,CAClB,AACD,uCACE,eAAiB,CAClB,AACD,+BACE,eAAiB,CAClB,AACD,gCACE,eAAiB,CAClB,AACD,kCACE,eAAiB,CAClB,AACD,iCACE,eAAiB,CAClB,AACD,qCACE,eAAiB,CAClB,AACD,kCACE,eAAiB,CAClB,AACD,kCACE,eAAiB,CAClB,AACD,qCACE,eAAiB,CAClB,AACD,oCACE,eAAiB,CAClB,AACD,sCACE,eAAiB,CAClB,AACD,mCACE,eAAiB,CAClB,AACD,yCACE,eAAiB,CAClB,AACD,qCACE,eAAiB,CAClB,AACD,kCACE,eAAiB,CAClB,AACD,wCACE,eAAiB,CAClB,AACD,yCACE,eAAiB,CAClB,AACD,oCACE,eAAiB,CAClB,AACD,mCACE,eAAiB,CAClB,AACD,qCACE,eAAiB,CAClB,AACD,mCACE,eAAiB,CAClB,AACD,iCACE,eAAiB,CAClB,AACD,qCACE,eAAiB,CAClB,AACD,mCACE,eAAiB,CAClB,AACD,gCACE,eAAiB,CAClB,AACD,wCACE,eAAiB,CAClB,AACD,oCACE,eAAiB,CAClB,AACD,kCACE,eAAiB,CAClB,AACD,wCACE,eAAiB,CAClB,AACD,wCACE,eAAiB,CAClB,AACD,0CACE,eAAiB,CAClB,AACD,oCACE,eAAiB,CAClB,AACD,mCACE,eAAiB,CAClB,AACD,wCACE,eAAiB,CAClB,AACD,yCACE,eAAiB,CAClB,AACD,oCACE,eAAiB,CAClB,AACD,0CACE,eAAiB,CAClB,AACD,qCACE,eAAiB,CAClB,AACD,mCACE,eAAiB,CAClB,AACD,kCACE,eAAiB,CAClB,AACD,0CACE,eAAiB,CAClB,AACD,MACE,cAAe,AACf,gBAAiB,AACjB,aAAe,AACf,WAAY,AACZ,mBAAoB,AACpB,6BAA+B,CAChC,AACD,iCAEE,WAAY,AACZ,iBAAmB,CACpB,AACD,gHAOE,WAAY,AACZ,eAAkB,CACnB,AACD,iDAGE,UAAe,CAChB,AACD,mEAIE,UAAY,CACb,AACD,8CAGE,WAAY,AACZ,eAAkB,CACnB,AACD,qCAEE,eAAoB,CACrB,AACD,0EAIE,WAAY,AACZ,eAAkB,CACnB,AACD,0FAIE,WAAe,AACf,eAAoB,CACrB,AACD,2DAIE,UAAe,CAChB,AACD,aACE,aAAe,CAChB,AACD,8IAOE,aAAe,CAChB,AACD,eACE,aAAe,CAChB,AACD,iFAME,WAAY,AACZ,eAAkB,CACnB,AACD,eACE,eAAiB,CAClB,AACD,eACE,eAAiB,CAClB,AACD,mBACE,kBAAoB,CACrB,AACD,YACE,UAAY,CACb","file":"wangEditor.css","sourcesContent":["/* 编辑器边框颜色 */\n/* 菜单颜色、上边框颜色 */\n/* 菜单选中状态的颜色 */\n/* input focus 时的颜色 */\n/* 按钮颜色 */\n/* tab selected 状态下的颜色 */\n.wangEditor-container {\n  position: relative;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  z-index: 1;\n  width: 100%;\n}\n.wangEditor-container a:focus,\n.wangEditor-container button:focus {\n  outline: none;\n}\n.wangEditor-container,\n.wangEditor-container * {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  line-height: 1;\n}\n.wangEditor-container img {\n  border: none;\n}\n.wangEditor-container .clearfix:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.wangEditor-container .clearfix {\n  *zoom: 1;\n}\n.wangEditor-container textarea {\n  border: none;\n}\n.wangEditor-container textarea:focus {\n  outline: none;\n}\n.wangEditor-container .height-tip {\n  position: absolute;\n  width: 3px;\n  background-color: #ccc;\n  left: 0;\n  transition: top .2s;\n}\n.wangEditor-container .txt-toolbar {\n  position: absolute;\n  background-color: #fff;\n  padding: 3px 5px;\n  border-top: 2px solid #666;\n  box-shadow: 1px 3px 3px #999;\n  border-left: 1px\\9 solid\\9 #ccc\\9;\n  border-bottom: 1px\\9 solid\\9 #999\\9;\n  border-right: 1px\\9 solid\\9 #999\\9;\n}\n.wangEditor-container .txt-toolbar .tip-triangle {\n  display: block;\n  position: absolute;\n  width: 0;\n  height: 0;\n  border: 5px solid;\n  border-color: transparent transparent #666 transparent;\n  top: -12px;\n  left: 50%;\n  margin-left: -5px;\n}\n.wangEditor-container .txt-toolbar a {\n  color: #666;\n  display: inline-block;\n  margin: 0 3px;\n  padding: 5px;\n  text-decoration: none;\n  border-radius: 3px;\n}\n.wangEditor-container .txt-toolbar a:hover {\n  background-color: #f1f1f1;\n}\n.wangEditor-container .img-drag-point {\n  display: block;\n  position: absolute;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  cursor: se-resize;\n  background-color: #666;\n  margin-left: -6px;\n  margin-top: -6px;\n  box-shadow: 1px 1px 5px #999;\n}\n.wangEditor-container .wangEditor-upload-progress {\n  position: absolute;\n  height: 1px;\n  background: #1e88e5;\n  width: 0;\n  display: none;\n  -webkit-transition: width .5s;\n  -o-transition: width .5s;\n  transition: width .5s;\n}\n.wangEditor-fullscreen {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.wangEditor-container .code-textarea {\n  resize: none;\n  width: 100%;\n  font-size: 14px;\n  line-height: 1.5;\n  font-family: 'Verdana';\n  color: #333;\n  padding: 0 15px 0 15px;\n}\n.wangEditor-menu-container {\n  width: 100%;\n  border-bottom: 1px solid #f1f1f1;\n  background-color: #fff;\n}\n.wangEditor-menu-container a {\n  text-decoration: none;\n}\n.wangEditor-menu-container .menu-group {\n  float: left;\n  padding: 0 8px;\n  border-right: 1px solid #f1f1f1;\n}\n.wangEditor-menu-container .menu-item {\n  float: left;\n  position: relative;\n  text-align: center;\n  height: 31px;\n  width: 35px;\n}\n.wangEditor-menu-container .menu-item:hover {\n  background-color: #f1f1f1;\n}\n.wangEditor-menu-container .menu-item a {\n  display: block;\n  text-align: center;\n  color: #666;\n  width: 100%;\n  padding: 8px 0;\n  font-size: 0.9em;\n}\n.wangEditor-menu-container .menu-item .selected {\n  color: #1e88e5;\n}\n.wangEditor-menu-container .menu-item .active {\n  background-color: #f1f1f1;\n}\n.wangEditor-menu-container .menu-item .disable {\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n}\n.wangEditor-menu-container .menu-tip {\n  display: block;\n  position: absolute;\n  z-index: 20;\n  width: 60px;\n  text-align: center;\n  background-color: #666;\n  color: #fff;\n  padding: 7px 0;\n  font-size: 12px;\n  top: 100%;\n  left: 50%;\n  margin-left: -30px;\n  border-radius: 2px;\n  box-shadow: 1px 1px 5px #999;\n  display: none;\n  /*// 小三角\n        .tip-triangle {\n            display: block;\n            position: absolute;\n            width: 0;\n            height: 0;\n            border:5px solid;\n            border-color: transparent transparent @fore-color transparent;\n            top: -10px;\n            left: 50%;\n            margin-left: -5px;\n        }*/\n}\n.wangEditor-menu-container .menu-tip-40 {\n  width: 40px;\n  margin-left: -20px;\n}\n.wangEditor-menu-container .menu-tip-50 {\n  width: 50px;\n  margin-left: -25px;\n}\n.wangEditor-menu-shadow {\n  /*border-bottom-width: 0;*/\n  border-bottom: 1px\\9 solid\\9 #f1f1f1\\9;\n  box-shadow: 0 1px 3px #999;\n}\n.wangEditor-container .wangEditor-txt {\n  width: 100%;\n  text-align: left;\n  padding: 5px 15px;\n  line-height: 1.5;\n  margin-top: 0;\n  overflow-y: auto;\n}\n.wangEditor-container .wangEditor-txt p,\n.wangEditor-container .wangEditor-txt h1,\n.wangEditor-container .wangEditor-txt h2,\n.wangEditor-container .wangEditor-txt h3,\n.wangEditor-container .wangEditor-txt h4,\n.wangEditor-container .wangEditor-txt h5 {\n  margin: 10px 0;\n  line-height: 1.8;\n}\n.wangEditor-container .wangEditor-txt p *,\n.wangEditor-container .wangEditor-txt h1 *,\n.wangEditor-container .wangEditor-txt h2 *,\n.wangEditor-container .wangEditor-txt h3 *,\n.wangEditor-container .wangEditor-txt h4 *,\n.wangEditor-container .wangEditor-txt h5 * {\n  line-height: 1.8;\n}\n.wangEditor-container .wangEditor-txt ul,\n.wangEditor-container .wangEditor-txt ol {\n  padding-left: 20px;\n}\n.wangEditor-container .wangEditor-txt img {\n  cursor: pointer;\n}\n.wangEditor-container .wangEditor-txt img.clicked {\n  box-shadow: 1px 1px 10px #999;\n}\n.wangEditor-container .wangEditor-txt table.clicked {\n  box-shadow: 1px 1px 10px #999;\n}\n.wangEditor-container .wangEditor-txt pre code {\n  line-height: 1.5;\n}\n.wangEditor-container .wangEditor-txt:focus {\n  outline: none;\n}\n.wangEditor-container .wangEditor-txt blockquote {\n  display: block;\n  border-left: 8px solid #d0e5f2;\n  padding: 5px 10px;\n  margin: 10px 0;\n  line-height: 1.4;\n  font-size: 100%;\n  background-color: #f1f1f1;\n}\n.wangEditor-container .wangEditor-txt table {\n  border: none;\n  border-collapse: collapse;\n}\n.wangEditor-container .wangEditor-txt table td,\n.wangEditor-container .wangEditor-txt table th {\n  border: 1px solid #999;\n  padding: 3px 5px;\n  min-width: 50px;\n  height: 20px;\n}\n.wangEditor-container .wangEditor-txt pre {\n  border: 1px solid #ccc;\n  background-color: #f8f8f8;\n  padding: 10px;\n  margin: 5px 0px;\n  font-size: 0.8em;\n  border-radius: 3px;\n}\n.wangEditor-drop-list {\n  display: none;\n  position: absolute;\n  background-color: #fff;\n  overflow: hidden;\n  z-index: 10;\n  transition: height .7s;\n  border-top: 1px solid #f1f1f1;\n  box-shadow: 1px 3px 3px #999;\n  border-left: 1px\\9 solid\\9 #ccc\\9;\n  border-bottom: 1px\\9 solid\\9 #999\\9;\n  border-right: 1px\\9 solid\\9 #999\\9;\n}\n.wangEditor-drop-list a {\n  text-decoration: none;\n  display: block;\n  color: #666;\n  padding: 3px 5px;\n}\n.wangEditor-drop-list a:hover {\n  background-color: #f1f1f1;\n}\n.wangEditor-drop-panel,\n.txt-toolbar {\n  display: none;\n  position: absolute;\n  padding: 10px;\n  font-size: 14px;\n  /*border: 1px\\9 solid\\9 #cccccc\\9;*/\n  background-color: #fff;\n  z-index: 10;\n  border-top: 2px solid #666;\n  box-shadow: 1px 3px 3px #999;\n  border-left: 1px\\9 solid\\9 #ccc\\9;\n  border-bottom: 1px\\9 solid\\9 #999\\9;\n  border-right: 1px\\9 solid\\9 #999\\9;\n}\n.wangEditor-drop-panel .tip-triangle,\n.txt-toolbar .tip-triangle {\n  display: block;\n  position: absolute;\n  width: 0;\n  height: 0;\n  border: 5px solid;\n  border-color: transparent transparent #666 transparent;\n  top: -12px;\n  left: 50%;\n  margin-left: -5px;\n}\n.wangEditor-drop-panel a,\n.txt-toolbar a {\n  text-decoration: none;\n}\n.wangEditor-drop-panel input[type=text],\n.txt-toolbar input[type=text] {\n  border: none;\n  border-bottom: 1px solid #ccc;\n  font-size: 14px;\n  height: 20px;\n  color: #333;\n  padding: 3px 0;\n}\n.wangEditor-drop-panel input[type=text]:focus,\n.txt-toolbar input[type=text]:focus {\n  outline: none;\n  border-bottom: 2px solid #1e88e5;\n}\n.wangEditor-drop-panel input[type=text].block,\n.txt-toolbar input[type=text].block {\n  display: block;\n  width: 100%;\n}\n.wangEditor-drop-panel textarea,\n.txt-toolbar textarea {\n  border: 1px solid #ccc;\n}\n.wangEditor-drop-panel textarea:focus,\n.txt-toolbar textarea:focus {\n  outline: none;\n  border-color: #1e88e5;\n}\n.wangEditor-drop-panel button,\n.txt-toolbar button {\n  font-size: 14px;\n  color: #1e88e5;\n  border: none;\n  padding: 10px;\n  background-color: #fff;\n  cursor: pointer;\n  border-radius: 3px;\n}\n.wangEditor-drop-panel button:hover,\n.txt-toolbar button:hover {\n  background-color: #f1f1f1;\n}\n.wangEditor-drop-panel button:focus,\n.txt-toolbar button:focus {\n  outline: none;\n}\n.wangEditor-drop-panel button.right,\n.txt-toolbar button.right {\n  float: right;\n  margin-left: 10px;\n}\n.wangEditor-drop-panel button.gray,\n.txt-toolbar button.gray {\n  color: #999;\n}\n.wangEditor-drop-panel button.link,\n.txt-toolbar button.link {\n  padding: 5px 10px;\n}\n.wangEditor-drop-panel button.link:hover,\n.txt-toolbar button.link:hover {\n  background-color: #fff;\n  text-decoration: underline;\n}\n.wangEditor-drop-panel .color-item,\n.txt-toolbar .color-item {\n  display: block;\n  float: left;\n  width: 25px;\n  height: 25px;\n  text-align: center;\n  padding: 2px;\n  border-radius: 2px;\n  text-decoration: underline;\n}\n.wangEditor-drop-panel .color-item:hover,\n.txt-toolbar .color-item:hover {\n  background-color: #f1f1f1;\n}\n.wangEditor-drop-panel .list-menu-item,\n.txt-toolbar .list-menu-item {\n  display: block;\n  float: left;\n  color: #333;\n  padding: 5px 5px;\n  border-radius: 2px;\n}\n.wangEditor-drop-panel .list-menu-item:hover,\n.txt-toolbar .list-menu-item:hover {\n  background-color: #f1f1f1;\n}\n.wangEditor-drop-panel table.choose-table,\n.txt-toolbar table.choose-table {\n  border: none;\n  border-collapse: collapse;\n}\n.wangEditor-drop-panel table.choose-table td,\n.txt-toolbar table.choose-table td {\n  border: 1px solid #ccc;\n  width: 16px;\n  height: 12px;\n}\n.wangEditor-drop-panel table.choose-table td.active,\n.txt-toolbar table.choose-table td.active {\n  background-color: #ccc;\n  opacity: .5;\n  filter: alpha(opacity=50);\n}\n.wangEditor-drop-panel .panel-tab .tab-container,\n.txt-toolbar .panel-tab .tab-container {\n  margin-bottom: 5px;\n}\n.wangEditor-drop-panel .panel-tab .tab-container a,\n.txt-toolbar .panel-tab .tab-container a {\n  display: inline-block;\n  color: #999;\n  text-align: center;\n  margin: 0 5px;\n  padding: 5px 5px;\n}\n.wangEditor-drop-panel .panel-tab .tab-container a.selected,\n.txt-toolbar .panel-tab .tab-container a.selected {\n  color: #1e88e5;\n  border-bottom: 2px solid #1e88e5;\n}\n.wangEditor-drop-panel .panel-tab .content-container .content,\n.txt-toolbar .panel-tab .content-container .content {\n  display: none;\n}\n.wangEditor-drop-panel .panel-tab .content-container .content a,\n.txt-toolbar .panel-tab .content-container .content a {\n  display: inline-block;\n  margin: 2px;\n  padding: 2px;\n  border-radius: 2px;\n}\n.wangEditor-drop-panel .panel-tab .content-container .content a:hover,\n.txt-toolbar .panel-tab .content-container .content a:hover {\n  background-color: #f1f1f1;\n}\n.wangEditor-drop-panel .panel-tab .content-container .selected,\n.txt-toolbar .panel-tab .content-container .selected {\n  display: block;\n}\n.wangEditor-drop-panel .panel-tab .emotion-content-container,\n.txt-toolbar .panel-tab .emotion-content-container {\n  height: 200px;\n  overflow-y: auto;\n}\n.wangEditor-drop-panel .upload-icon-container,\n.txt-toolbar .upload-icon-container {\n  color: #ccc;\n  text-align: center;\n  margin: 20px 20px 15px 20px !important;\n  padding: 5px !important;\n  font-size: 65px;\n  cursor: pointer;\n  border: 2px dotted #f1f1f1;\n  display: block !important;\n}\n.wangEditor-drop-panel .upload-icon-container:hover,\n.txt-toolbar .upload-icon-container:hover {\n  color: #666;\n  border-color: #ccc;\n}\n.wangEditor-modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  background-color: #fff;\n  border-top: 1px solid #f1f1f1;\n  box-shadow: 1px 3px 3px #999;\n  border-top: 1px\\9 solid\\9 #ccc\\9;\n  border-left: 1px\\9 solid\\9 #ccc\\9;\n  border-bottom: 1px\\9 solid\\9 #999\\9;\n  border-right: 1px\\9 solid\\9 #999\\9;\n}\n.wangEditor-modal .wangEditor-modal-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  margin-top: -25px;\n  margin-right: -25px;\n  font-size: 1.5em;\n  color: #666;\n  cursor: pointer;\n}\n@font-face {\n  font-family: 'icomoon';\n  src: url('../fonts/icomoon.eot?-qdfu1s');\n  src: url('../fonts/icomoon.eot?#iefix-qdfu1s') format('embedded-opentype'), url('../fonts/icomoon.ttf?-qdfu1s') format('truetype'), url('../fonts/icomoon.woff?-qdfu1s') format('woff'), url('../fonts/icomoon.svg?-qdfu1s#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n[class^=\"wangeditor-menu-img-\"],\n[class*=\" wangeditor-menu-img-\"] {\n  font-family: 'icomoon';\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.wangeditor-menu-img-link:before {\n  content: \"\\e800\";\n}\n.wangeditor-menu-img-unlink:before {\n  content: \"\\e801\";\n}\n.wangeditor-menu-img-code:before {\n  content: \"\\e802\";\n}\n.wangeditor-menu-img-cancel:before {\n  content: \"\\e803\";\n}\n.wangeditor-menu-img-terminal:before {\n  content: \"\\e804\";\n}\n.wangeditor-menu-img-angle-down:before {\n  content: \"\\e805\";\n}\n.wangeditor-menu-img-font:before {\n  content: \"\\e806\";\n}\n.wangeditor-menu-img-bold:before {\n  content: \"\\e807\";\n}\n.wangeditor-menu-img-italic:before {\n  content: \"\\e808\";\n}\n.wangeditor-menu-img-header:before {\n  content: \"\\e809\";\n}\n.wangeditor-menu-img-align-left:before {\n  content: \"\\e80a\";\n}\n.wangeditor-menu-img-align-center:before {\n  content: \"\\e80b\";\n}\n.wangeditor-menu-img-align-right:before {\n  content: \"\\e80c\";\n}\n.wangeditor-menu-img-list-bullet:before {\n  content: \"\\e80d\";\n}\n.wangeditor-menu-img-indent-left:before {\n  content: \"\\e80e\";\n}\n.wangeditor-menu-img-indent-right:before {\n  content: \"\\e80f\";\n}\n.wangeditor-menu-img-list-numbered:before {\n  content: \"\\e810\";\n}\n.wangeditor-menu-img-underline:before {\n  content: \"\\e811\";\n}\n.wangeditor-menu-img-table:before {\n  content: \"\\e812\";\n}\n.wangeditor-menu-img-eraser:before {\n  content: \"\\e813\";\n}\n.wangeditor-menu-img-text-height:before {\n  content: \"\\e814\";\n}\n.wangeditor-menu-img-brush:before {\n  content: \"\\e815\";\n}\n.wangeditor-menu-img-pencil:before {\n  content: \"\\e816\";\n}\n.wangeditor-menu-img-minus:before {\n  content: \"\\e817\";\n}\n.wangeditor-menu-img-picture:before {\n  content: \"\\e818\";\n}\n.wangeditor-menu-img-file-image:before {\n  content: \"\\e819\";\n}\n.wangeditor-menu-img-cw:before {\n  content: \"\\e81a\";\n}\n.wangeditor-menu-img-ccw:before {\n  content: \"\\e81b\";\n}\n.wangeditor-menu-img-music:before {\n  content: \"\\e911\";\n}\n.wangeditor-menu-img-play:before {\n  content: \"\\e912\";\n}\n.wangeditor-menu-img-location:before {\n  content: \"\\e947\";\n}\n.wangeditor-menu-img-happy:before {\n  content: \"\\e9df\";\n}\n.wangeditor-menu-img-sigma:before {\n  content: \"\\ea67\";\n}\n.wangeditor-menu-img-enlarge2:before {\n  content: \"\\e98b\";\n}\n.wangeditor-menu-img-shrink2:before {\n  content: \"\\e98c\";\n}\n.wangeditor-menu-img-newspaper:before {\n  content: \"\\e904\";\n}\n.wangeditor-menu-img-camera:before {\n  content: \"\\e90f\";\n}\n.wangeditor-menu-img-video-camera:before {\n  content: \"\\e914\";\n}\n.wangeditor-menu-img-file-zip:before {\n  content: \"\\e92b\";\n}\n.wangeditor-menu-img-stack:before {\n  content: \"\\e92e\";\n}\n.wangeditor-menu-img-credit-card:before {\n  content: \"\\e93f\";\n}\n.wangeditor-menu-img-address-book:before {\n  content: \"\\e944\";\n}\n.wangeditor-menu-img-envelop:before {\n  content: \"\\e945\";\n}\n.wangeditor-menu-img-drawer:before {\n  content: \"\\e95c\";\n}\n.wangeditor-menu-img-download:before {\n  content: \"\\e960\";\n}\n.wangeditor-menu-img-upload:before {\n  content: \"\\e961\";\n}\n.wangeditor-menu-img-lock:before {\n  content: \"\\e98f\";\n}\n.wangeditor-menu-img-unlocked:before {\n  content: \"\\e990\";\n}\n.wangeditor-menu-img-wrench:before {\n  content: \"\\e991\";\n}\n.wangeditor-menu-img-eye:before {\n  content: \"\\e9ce\";\n}\n.wangeditor-menu-img-eye-blocked:before {\n  content: \"\\e9d1\";\n}\n.wangeditor-menu-img-command:before {\n  content: \"\\ea4e\";\n}\n.wangeditor-menu-img-font2:before {\n  content: \"\\ea5c\";\n}\n.wangeditor-menu-img-libreoffice:before {\n  content: \"\\eade\";\n}\n.wangeditor-menu-img-quotes-left:before {\n  content: \"\\e977\";\n}\n.wangeditor-menu-img-strikethrough:before {\n  content: \"\\ea65\";\n}\n.wangeditor-menu-img-desktop:before {\n  content: \"\\f108\";\n}\n.wangeditor-menu-img-tablet:before {\n  content: \"\\f10a\";\n}\n.wangeditor-menu-img-search-plus:before {\n  content: \"\\f00e\";\n}\n.wangeditor-menu-img-search-minus:before {\n  content: \"\\f010\";\n}\n.wangeditor-menu-img-trash-o:before {\n  content: \"\\f014\";\n}\n.wangeditor-menu-img-align-justify:before {\n  content: \"\\f039\";\n}\n.wangeditor-menu-img-arrows-v:before {\n  content: \"\\f07d\";\n}\n.wangeditor-menu-img-sigma2:before {\n  content: \"\\ea68\";\n}\n.wangeditor-menu-img-omega:before {\n  content: \"\\e900\";\n}\n.wangeditor-menu-img-cancel-circle:before {\n  content: \"\\e901\";\n}\n.hljs {\n  display: block;\n  overflow-x: auto;\n  padding: 0.5em;\n  color: #333;\n  background: #f8f8f8;\n  -webkit-text-size-adjust: none;\n}\n.hljs-comment,\n.diff .hljs-header {\n  color: #998;\n  font-style: italic;\n}\n.hljs-keyword,\n.css .rule .hljs-keyword,\n.hljs-winutils,\n.nginx .hljs-title,\n.hljs-subst,\n.hljs-request,\n.hljs-status {\n  color: #333;\n  font-weight: bold;\n}\n.hljs-number,\n.hljs-hexcolor,\n.ruby .hljs-constant {\n  color: #008080;\n}\n.hljs-string,\n.hljs-tag .hljs-value,\n.hljs-doctag,\n.tex .hljs-formula {\n  color: #d14;\n}\n.hljs-title,\n.hljs-id,\n.scss .hljs-preprocessor {\n  color: #900;\n  font-weight: bold;\n}\n.hljs-list .hljs-keyword,\n.hljs-subst {\n  font-weight: normal;\n}\n.hljs-class .hljs-title,\n.hljs-type,\n.vhdl .hljs-literal,\n.tex .hljs-command {\n  color: #458;\n  font-weight: bold;\n}\n.hljs-tag,\n.hljs-tag .hljs-title,\n.hljs-rule .hljs-property,\n.django .hljs-tag .hljs-keyword {\n  color: #000080;\n  font-weight: normal;\n}\n.hljs-attribute,\n.hljs-variable,\n.lisp .hljs-body,\n.hljs-name {\n  color: #008080;\n}\n.hljs-regexp {\n  color: #009926;\n}\n.hljs-symbol,\n.ruby .hljs-symbol .hljs-string,\n.lisp .hljs-keyword,\n.clojure .hljs-keyword,\n.scheme .hljs-keyword,\n.tex .hljs-special,\n.hljs-prompt {\n  color: #990073;\n}\n.hljs-built_in {\n  color: #0086b3;\n}\n.hljs-preprocessor,\n.hljs-pragma,\n.hljs-pi,\n.hljs-doctype,\n.hljs-shebang,\n.hljs-cdata {\n  color: #999;\n  font-weight: bold;\n}\n.hljs-deletion {\n  background: #fdd;\n}\n.hljs-addition {\n  background: #dfd;\n}\n.diff .hljs-change {\n  background: #0086b3;\n}\n.hljs-chunk {\n  color: #aaa;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3552:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/icomoon.0a74426.eot";

/***/ }),

/***/ 3553:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/icomoon.0a74426.eot";

/***/ }),

/***/ 3554:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/icomoon.9f5fd7b.ttf";

/***/ }),

/***/ 3555:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/icomoon.7d4ac7d.woff";

/***/ }),

/***/ 3556:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icomoon.f558046.svg";

/***/ }),

/***/ 3557:
/***/ (function(module, exports) {

(function (factory) {
    module.exports = factory(window.jQuery);
})(function ($) {

    // 验证是否引用jquery
    if (!$ || !$.fn || !$.fn.jquery) {
        alert('在引用wangEditor.js之前，先引用jQuery，否则无法使用 wangEditor');
        return;
    }

    // 定义扩展函数
    var _e = function _e(fn) {
        var E = window.wangEditorV2;
        if (E) {
            // 执行传入的函数
            fn(E, $);
        }
    };
    // 定义构造函数
    (function (window, $) {
        if (window.wangEditorV2) {
            // 重复引用
            alert('一个页面不能重复引用 wangEditor.js 或 wangEditor.min.js ！！！');
            return;
        }

        // 编辑器（整体）构造函数
        var E = function E(elem) {
            // 支持 id 和 element 两种形式
            if (typeof elem === 'string') {
                elem = '#' + elem;
            }

            // ---------------获取基本节点------------------
            var $elem = $(elem);
            if ($elem.length !== 1) {
                return;
            }
            var nodeName = $elem[0].nodeName;
            if (nodeName !== 'TEXTAREA' && nodeName !== 'DIV') {
                // 只能是 textarea 和 div ，其他类型的元素不行
                return;
            }
            this.valueNodeName = nodeName.toLowerCase();
            this.$valueContainer = $elem;

            // 记录 elem 的 prev 和 parent（最后渲染 editor 要用到）
            this.$prev = $elem.prev();
            this.$parent = $elem.parent();

            // ------------------初始化------------------
            this.init();
        };

        E.fn = E.prototype;

        E.$body = $('body');
        E.$document = $(document);
        E.$window = $(window);
        E.userAgent = navigator.userAgent;
        E.getComputedStyle = window.getComputedStyle;
        E.w3cRange = typeof document.createRange === 'function';
        E.hostname = location.hostname.toLowerCase();
        E.websiteHost = 'wangeditor.github.io|www.wangeditor.com|wangeditor.coding.me';
        E.isOnWebsite = E.websiteHost.indexOf(E.hostname) >= 0;
        E.docsite = 'http://www.kancloud.cn/wangfupeng/wangeditor2/113961';

        // 暴露给全局对象
        window.wangEditorV2 = E;

        // 注册 plugin 事件，用于用户自定义插件
        // 用户在引用 wangEditor.js 之后，还可以通过 E.plugin() 注入自定义函数，
        // 该函数将会在 editor.create() 方法的最后一步执行
        E.plugin = function (fn) {
            if (!E._plugins) {
                E._plugins = [];
            }

            if (typeof fn === 'function') {
                E._plugins.push(fn);
            }
        };
    })(window, $);
    // editor 绑定事件
    _e(function (E, $) {

        E.fn.init = function () {

            // 初始化 editor 默认配置
            this.initDefaultConfig();

            // 增加container
            this.addEditorContainer();

            // 增加编辑区域
            this.addTxt();

            // 增加menuContainer
            this.addMenuContainer();

            // 初始化菜单集合
            this.menus = {};

            // 初始化commandHooks
            this.commandHooks();
        };
    });
    // editor api
    _e(function (E, $) {

        // 预定义 ready 事件
        E.fn.ready = function (fn) {

            if (!this.readyFns) {
                this.readyFns = [];
            }

            this.readyFns.push(fn);
        };

        // 处理ready事件
        E.fn.readyHeadler = function () {
            var fns = this.readyFns;

            while (fns.length) {
                fns.shift().call(this);
            }
        };

        // 更新内容到 $valueContainer
        E.fn.updateValue = function () {
            var editor = this;
            var $valueContainer = editor.$valueContainer;
            var $txt = editor.txt.$txt;

            if ($valueContainer === $txt) {
                // 传入生成编辑器的div，即是编辑区域
                return;
            }

            var value = $txt.html();
            $valueContainer.val(value);
        };

        // 获取初始化的内容
        E.fn.getInitValue = function () {
            var editor = this;
            var $valueContainer = editor.$valueContainer;
            var currentValue = '';
            var nodeName = editor.valueNodeName;
            if (nodeName === 'div') {
                currentValue = $valueContainer.html();
            } else if (nodeName === 'textarea') {
                currentValue = $valueContainer.val();
            }

            return currentValue;
        };

        // 触发菜单updatestyle
        E.fn.updateMenuStyle = function () {
            var menus = this.menus;

            $.each(menus, function (k, menu) {
                menu.updateSelected();
            });
        };

        // 除了传入的 menuIds，其他全部启用
        E.fn.enableMenusExcept = function (menuIds) {
            if (this._disabled) {
                // 编辑器处于禁用状态，则不执行改操作
                return;
            }
            // menuIds参数：支持数组和字符串
            menuIds = menuIds || [];
            if (typeof menuIds === 'string') {
                menuIds = [menuIds];
            }

            $.each(this.menus, function (k, menu) {
                if (menuIds.indexOf(k) >= 0) {
                    return;
                }
                menu.disabled(false);
            });
        };

        // 除了传入的 menuIds，其他全部禁用
        E.fn.disableMenusExcept = function (menuIds) {
            if (this._disabled) {
                // 编辑器处于禁用状态，则不执行改操作
                return;
            }
            // menuIds参数：支持数组和字符串
            menuIds = menuIds || [];
            if (typeof menuIds === 'string') {
                menuIds = [menuIds];
            }

            $.each(this.menus, function (k, menu) {
                if (menuIds.indexOf(k) >= 0) {
                    return;
                }
                menu.disabled(true);
            });
        };

        // 隐藏所有 dropPanel droplist modal
        E.fn.hideDropPanelAndModal = function () {
            var menus = this.menus;

            $.each(menus, function (k, menu) {
                var m = menu.dropPanel || menu.dropList || menu.modal;
                if (m && m.hide) {
                    m.hide();
                }
            });
        };
    });
    // selection range API
    _e(function (E, $) {

        // 用到 w3c range 的函数，如果检测到浏览器不支持 w3c range，则赋值为空函数
        var ieRange = !E.w3cRange;
        function emptyFn() {}

        // 设置或读取当前的range
        E.fn.currentRange = function (cr) {
            if (cr) {
                this._rangeData = cr;
            } else {
                return this._rangeData;
            }
        };

        // 将当前选区折叠
        E.fn.collapseRange = function (range, opt) {
            // opt 参数说明：'start'-折叠到开始; 'end'-折叠到结束
            opt = opt || 'end';
            opt = opt === 'start' ? true : false;

            range = range || this.currentRange();

            if (range) {
                // 合并，保存
                range.collapse(opt);
                this.currentRange(range);
            }
        };

        // 获取选区的文字
        E.fn.getRangeText = ieRange ? emptyFn : function (range) {
            range = range || this.currentRange();
            if (!range) {
                return;
            }
            return range.toString();
        };

        // 获取选区对应的DOM对象
        E.fn.getRangeElem = ieRange ? emptyFn : function (range) {
            range = range || this.currentRange();
            var dom = range.commonAncestorContainer;

            if (dom.nodeType === 1) {
                return dom;
            } else {
                return dom.parentNode;
            }
        };

        // 选区内容是否为空？
        E.fn.isRangeEmpty = ieRange ? emptyFn : function (range) {
            range = range || this.currentRange();

            if (range && range.startContainer) {
                if (range.startContainer === range.endContainer) {
                    if (range.startOffset === range.endOffset) {
                        return true;
                    }
                }
            }

            return false;
        };

        // 保存选区数据
        E.fn.saveSelection = ieRange ? emptyFn : function (range) {
            var self = this,
                _parentElem,
                selection,
                txt = self.txt.$txt.get(0);

            if (range) {
                _parentElem = range.commonAncestorContainer;
            } else {
                selection = document.getSelection();
                if (selection.getRangeAt && selection.rangeCount) {
                    range = document.getSelection().getRangeAt(0);
                    _parentElem = range.commonAncestorContainer;
                }
            }
            // 确定父元素一定要包含在编辑器区域内
            if (_parentElem && ($.contains(txt, _parentElem) || txt === _parentElem)) {
                // 保存选择区域
                self.currentRange(range);
            }
        };

        // 恢复选中区域
        E.fn.restoreSelection = ieRange ? emptyFn : function (range) {
            var selection;

            range = range || this.currentRange();

            if (!range) {
                return;
            }

            // 使用 try catch 来防止 IE 某些情况报错
            try {
                selection = document.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
            } catch (ex) {
                E.error('执行 editor.restoreSelection 时，IE可能会有异常，不影响使用');
            }
        };

        // 根据elem恢复选区
        E.fn.restoreSelectionByElem = ieRange ? emptyFn : function (elem, opt) {
            // opt参数说明：'start'-折叠到开始，'end'-折叠到结束，'all'-全部选中
            if (!elem) {
                return;
            }
            opt = opt || 'end'; // 默认为折叠到结束

            // 根据elem获取选区
            this.setRangeByElem(elem);

            // 根据 opt 折叠选区
            if (opt === 'start') {
                this.collapseRange(this.currentRange(), 'start');
            }
            if (opt === 'end') {
                this.collapseRange(this.currentRange(), 'end');
            }

            // 恢复选区
            this.restoreSelection();
        };

        // 初始化选区
        E.fn.initSelection = ieRange ? emptyFn : function () {
            var editor = this;
            if (editor.currentRange()) {
                //如果currentRange有值，则不用再初始化
                return;
            }

            var range;
            var $txt = editor.txt.$txt;
            var $firstChild = $txt.children().first();

            if ($firstChild.length) {
                editor.restoreSelectionByElem($firstChild.get(0));
            }
        };

        // 根据元素创建选区
        E.fn.setRangeByElem = ieRange ? emptyFn : function (elem) {
            var editor = this;
            var txtElem = editor.txt.$txt.get(0);
            if (!elem || !$.contains(txtElem, elem)) {
                return;
            }

            // 找到elem的第一个 textNode 和 最后一个 textNode
            var firstTextNode = elem.firstChild;
            while (firstTextNode) {
                if (firstTextNode.nodeType === 3) {
                    break;
                }
                // 继续向下
                firstTextNode = firstTextNode.firstChild;
            }
            var lastTextNode = elem.lastChild;
            while (lastTextNode) {
                if (lastTextNode.nodeType === 3) {
                    break;
                }
                // 继续向下
                lastTextNode = lastTextNode.lastChild;
            }

            var range = document.createRange();
            if (firstTextNode && lastTextNode) {
                // 说明 elem 有内容，能取到子元素
                range.setStart(firstTextNode, 0);
                range.setEnd(lastTextNode, lastTextNode.textContent.length);
            } else {
                // 说明 elem 无内容
                range.setStart(elem, 0);
                range.setEnd(elem, 0);
            }

            // 保存选区
            editor.saveSelection(range);
        };
    });
    // selection range API - IE8及以下
    _e(function (E, $) {

        if (E.w3cRange) {
            // 说明支持 W3C 的range方法
            return;
        }

        // -----------------IE8时，需要重写以下方法-------------------

        // 获取选区的文字
        E.fn.getRangeText = function (range) {
            range = range || this.currentRange();
            if (!range) {
                return;
            }
            return range.text;
        };

        // 获取选区对应的DOM对象
        E.fn.getRangeElem = function (range) {
            range = range || this.currentRange();
            if (!range) {
                return;
            }
            var dom = range.parentElement();

            if (dom.nodeType === 1) {
                return dom;
            } else {
                return dom.parentNode;
            }
        };

        // 选区内容是否为空？
        E.fn.isRangeEmpty = function (range) {
            range = range || this.currentRange();

            if (range && range.text) {
                return false;
            }

            return true;
        };

        // 保存选区数据
        E.fn.saveSelection = function (range) {
            var self = this,
                _parentElem,
                selection,
                txt = self.txt.$txt.get(0);

            if (range) {
                _parentElem = range.parentElement();
            } else {
                range = document.selection.createRange();
                if (typeof range.parentElement === 'undefined') {
                    //IE6、7中，insertImage后会执行此处
                    //由于找不到range.parentElement，所以干脆将_parentElem赋值为null
                    _parentElem = null;
                } else {
                    _parentElem = range.parentElement();
                }
            }

            // 确定父元素一定要包含在编辑器区域内
            if (_parentElem && ($.contains(txt, _parentElem) || txt === _parentElem)) {
                // 保存选择区域
                self.currentRange(range);
            }
        };

        // 恢复选中区域
        E.fn.restoreSelection = function (currentRange) {
            var editor = this,
                selection,
                range;

            currentRange = currentRange || editor.currentRange();
            if (!currentRange) {
                return;
            }

            range = document.selection.createRange();
            try {
                // 此处，plupload上传上传图片时，IE8-会报一个『参数无效』的错误
                range.setEndPoint('EndToEnd', currentRange);
            } catch (ex) {}

            if (currentRange.text.length === 0) {
                try {
                    // IE8 插入表情会报错
                    range.collapse(false);
                } catch (ex) {}
            } else {
                range.setEndPoint('StartToStart', currentRange);
            }
            range.select();
        };
    });
    // editor command hooks
    _e(function (E, $) {

        E.fn.commandHooks = function () {
            var editor = this;
            var commandHooks = {};

            // insertHtml
            commandHooks.insertHtml = function (html) {
                var $elem = $(html);
                var rangeElem = editor.getRangeElem();
                var targetElem;

                targetElem = editor.getLegalTags(rangeElem);
                if (!targetElem) {
                    return;
                }

                $(targetElem).after($elem);
            };

            // 保存到对象
            editor.commandHooks = commandHooks;
        };
    });
    // editor command API
    _e(function (E, $) {

        // 基本命令
        E.fn.command = function (e, commandName, commandValue, callback) {
            var editor = this;
            var hooks;

            function commandFn() {
                if (!commandName) {
                    return;
                }
                if (editor.queryCommandSupported(commandName)) {
                    // 默认命令
                    document.execCommand(commandName, false, commandValue);
                } else {
                    // hooks 命令
                    hooks = editor.commandHooks;
                    if (commandName in hooks) {
                        hooks[commandName](commandValue);
                    }
                }
            }

            this.customCommand(e, commandFn, callback);
        };

        // 针对一个elem对象执行基础命令
        E.fn.commandForElem = function (elemOpt, e, commandName, commandValue, callback) {
            // 取得查询elem的查询条件和验证函数
            var selector;
            var check;
            if (typeof elemOpt === 'string') {
                selector = elemOpt;
            } else {
                selector = elemOpt.selector;
                check = elemOpt.check;
            }

            // 查询elem
            var rangeElem = this.getRangeElem();
            rangeElem = this.getSelfOrParentByName(rangeElem, selector, check);

            // 根据elem设置range
            if (rangeElem) {
                this.setRangeByElem(rangeElem);
            }

            // 然后执行基础命令
            this.command(e, commandName, commandValue, callback);
        };

        // 自定义命令
        E.fn.customCommand = function (e, commandFn, callback) {
            var editor = this;
            var range = editor.currentRange();

            if (!range) {
                // 目前没有选区，则无法执行命令
                e && e.preventDefault();
                return;
            }
            // 记录内容，以便撤销（执行命令之前就要记录）
            editor.undoRecord();

            // 恢复选区（有 range 参数）
            this.restoreSelection(range);

            // 执行命令事件
            commandFn.call(editor);

            // 保存选区（无参数，要从浏览器直接获取range信息）
            this.saveSelection();
            // 重新恢复选区（无参数，要取得刚刚从浏览器得到的range信息）
            this.restoreSelection();

            // 执行 callback
            if (callback && typeof callback === 'function') {
                callback.call(editor);
            }

            // 最后插入空行
            // editor.txt.insertEmptyP();

            // 包裹暴露的img和text
            editor.txt.wrapImgAndText();

            // 更新内容
            editor.updateValue();

            // 更新菜单样式
            editor.updateMenuStyle();

            // 隐藏 dropPanel dropList modal  设置 200ms 间隔
            function hidePanelAndModal() {
                editor.hideDropPanelAndModal();
            }
            setTimeout(hidePanelAndModal, 200);

            if (e) {
                e.preventDefault();
            }
        };

        // 封装 document.queryCommandValue 函数
        // IE8 直接执行偶尔会报错，因此直接用 try catch 封装一下
        E.fn.queryCommandValue = function (commandName) {
            var result = '';
            try {
                result = document.queryCommandValue(commandName);
            } catch (ex) {}
            return result;
        };

        // 封装 document.queryCommandState 函数
        // IE8 直接执行偶尔会报错，因此直接用 try catch 封装一下
        E.fn.queryCommandState = function (commandName) {
            var result = false;
            try {
                result = document.queryCommandState(commandName);
            } catch (ex) {}
            return result;
        };

        // 封装 document.queryCommandSupported 函数
        E.fn.queryCommandSupported = function (commandName) {
            var result = false;
            try {
                result = document.queryCommandSupported(commandName);
            } catch (ex) {}
            return result;
        };
    });
    // dom selector
    _e(function (E, $) {

        var matchesSelector;

        // matchesSelector hook
        function _matchesSelectorForIE(selector) {
            var elem = this;
            var $elems = $(selector);
            var result = false;

            // 用jquery查找 selector 所有对象，如果其中有一个和传入 elem 相同，则证明 elem 符合 selector
            $elems.each(function () {
                if (this === elem) {
                    result = true;
                    return false;
                }
            });

            return result;
        }

        // 从当前的elem，往上去查找合法标签 如 p head table blockquote ul ol 等
        E.fn.getLegalTags = function (elem) {
            var legalTags = this.config.legalTags;
            if (!legalTags) {
                E.error('配置项中缺少 legalTags 的配置');
                return;
            }
            return this.getSelfOrParentByName(elem, legalTags);
        };

        // 根据条件，查询自身或者父元素，符合即返回
        E.fn.getSelfOrParentByName = function (elem, selector, check) {

            if (!elem || !selector) {
                return;
            }

            if (!matchesSelector) {
                // 定义 matchesSelector 函数
                matchesSelector = elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.oMatchesSelector || elem.matchesSelector;
            }
            if (!matchesSelector) {
                // 如果浏览器本身不支持 matchesSelector 则使用自定义的hook
                matchesSelector = _matchesSelectorForIE;
            }

            var txt = this.txt.$txt.get(0);

            while (elem && txt !== elem && $.contains(txt, elem)) {
                if (matchesSelector.call(elem, selector)) {
                    // 符合 selector 查询条件

                    if (!check) {
                        // 没有 check 验证函数，直接返回即可
                        return elem;
                    }

                    if (check(elem)) {
                        // 如果有 check 验证函数，还需 check 函数的确认
                        return elem;
                    }
                }

                // 如果上一步没经过验证，则将跳转到父元素
                elem = elem.parentNode;
            }

            return;
        };
    });
    // undo redo
    _e(function (E, $) {

        var length = 20; // 缓存的最大长度
        function _getRedoList(editor) {
            if (editor._redoList == null) {
                editor._redoList = [];
            }
            return editor._redoList;
        }
        function _getUndoList(editor) {
            if (editor._undoList == null) {
                editor._undoList = [];
            }
            return editor._undoList;
        }

        // 数据处理
        function _handle(editor, data, type) {
            // var range = data.range;
            // var range2 = range.cloneRange && range.cloneRange();
            var val = data.val;
            var html = editor.txt.$txt.html();

            if (val == null) {
                return;
            }

            if (val === html) {
                if (type === 'redo') {
                    editor.redo();
                    return;
                } else if (type === 'undo') {
                    editor.undo();
                    return;
                } else {
                    return;
                }
            }

            // 保存数据
            editor.txt.$txt.html(val);
            // 更新数据到textarea（有必要的话）
            editor.updateValue();

            // onchange 事件
            if (editor.onchange && typeof editor.onchange === 'function') {
                editor.onchange.call(editor);
            }

            // ?????
            // 注释：$txt 被重新赋值之后，range会被重置，cloneRange() 也不好使
            // // 重置选区
            // if (range2) {
            //     editor.restoreSelection(range2);
            // }
        }

        // 记录
        E.fn.undoRecord = function () {
            var editor = this;
            var $txt = editor.txt.$txt;
            var val = $txt.html();
            var undoList = _getUndoList(editor);
            var redoList = _getRedoList(editor);
            var currentVal = undoList.length ? undoList[0] : '';

            if (val === currentVal.val) {
                return;
            }

            // 清空 redolist
            if (redoList.length) {
                redoList = [];
            }

            // 添加数据到 undoList
            undoList.unshift({
                range: editor.currentRange(), // 将当前的range也记录下
                val: val
            });

            // 限制 undoList 长度
            if (undoList.length > length) {
                undoList.pop();
            }
        };

        // undo 操作
        E.fn.undo = function () {
            var editor = this;
            var undoList = _getUndoList(editor);
            var redoList = _getRedoList(editor);

            if (!undoList.length) {
                return;
            }

            // 取出 undolist 第一个值，加入 redolist
            var data = undoList.shift();
            redoList.unshift(data);

            // 并修改编辑器的内容
            _handle(this, data, 'undo');
        };

        // redo 操作
        E.fn.redo = function () {
            var editor = this;
            var undoList = _getUndoList(editor);
            var redoList = _getRedoList(editor);
            if (!redoList.length) {
                return;
            }

            // 取出 redolist 第一个值，加入 undolist
            var data = redoList.shift();
            undoList.unshift(data);

            // 并修改编辑器的内容
            _handle(this, data, 'redo');
        };
    });
    // 暴露给用户的 API
    _e(function (E, $) {

        // 创建编辑器
        E.fn.create = function () {
            var editor = this;

            // 检查 E.$body 是否有值
            // 如果在 body 之前引用了 js 文件，body 尚未加载，可能没有值
            if (!E.$body || E.$body.length === 0) {
                E.$body = $('body');
                E.$document = $(document);
                E.$window = $(window);
            }

            // 执行 addMenus 之前：
            // 1. 允许用户修改 editor.UI 自定义配置UI
            // 2. 允许用户通过修改 editor.menus 来自定义配置菜单
            // 因此要在 create 时执行，而不是 init
            editor.addMenus();

            // 渲染
            editor.renderMenus();
            editor.renderMenuContainer();
            editor.renderTxt();
            editor.renderEditorContainer();

            // 绑定事件
            editor.eventMenus();
            editor.eventMenuContainer();
            editor.eventTxt();

            // 处理ready事件
            editor.readyHeadler();

            // 初始化选区
            editor.initSelection();

            // $txt 快捷方式
            editor.$txt = editor.txt.$txt;

            // 执行用户自定义事件，通过 E.ready() 添加
            var _plugins = E._plugins;
            if (_plugins && _plugins.length) {
                $.each(_plugins, function (k, val) {
                    val.call(editor);
                });
            }
        };

        // 禁用编辑器
        E.fn.disable = function () {
            this.txt.$txt.removeAttr('contenteditable');
            this.disableMenusExcept();

            // 先禁用，再记录状态
            this._disabled = true;
        };
        // 启用编辑器
        E.fn.enable = function () {
            // 先解除状态记录，再启用
            this._disabled = false;
            this.txt.$txt.attr('contenteditable', 'true');
            this.enableMenusExcept();
        };

        // 销毁编辑器
        E.fn.destroy = function () {
            var self = this;
            var $valueContainer = self.$valueContainer;
            var $editorContainer = self.$editorContainer;
            var valueNodeName = self.valueNodeName;

            if (valueNodeName === 'div') {
                // div 生成的编辑器
                $valueContainer.removeAttr('contenteditable');
                $editorContainer.after($valueContainer);
                $editorContainer.hide();
            } else {
                // textarea 生成的编辑器
                $valueContainer.show();
                $editorContainer.hide();
            }
        };

        // 撤销 销毁编辑器
        E.fn.undestroy = function () {
            var self = this;
            var $valueContainer = self.$valueContainer;
            var $editorContainer = self.$editorContainer;
            var $menuContainer = self.menuContainer.$menuContainer;
            var valueNodeName = self.valueNodeName;

            if (valueNodeName === 'div') {
                // div 生成的编辑器
                $valueContainer.attr('contenteditable', 'true');
                $menuContainer.after($valueContainer);
                $editorContainer.show();
            } else {
                // textarea 生成的编辑器
                $valueContainer.hide();
                $editorContainer.show();
            }
        };

        // 清空内容的快捷方式
        E.fn.clear = function () {
            var editor = this;
            var $txt = editor.txt.$txt;
            $txt.html('<p><br></p>');
            editor.restoreSelectionByElem($txt.find('p').get(0));
        };
    });
    // menuContainer 构造函数
    _e(function (E, $) {

        // 定义构造函数
        var MenuContainer = function MenuContainer(editor) {
            this.editor = editor;
            this.init();
        };

        MenuContainer.fn = MenuContainer.prototype;

        // 暴露给 E 即 window.wangEditorV2
        E.MenuContainer = MenuContainer;
    });
    // MenuContainer.fn bind fn
    _e(function (E, $) {

        var MenuContainer = E.MenuContainer;

        // 初始化
        MenuContainer.fn.init = function () {
            var self = this;
            var $menuContainer = $('<div class="wangEditor-menu-container clearfix"></div>');

            self.$menuContainer = $menuContainer;

            // change shadow
            self.changeShadow();
        };

        // 编辑区域滚动时，增加shadow
        MenuContainer.fn.changeShadow = function () {
            var $menuContainer = this.$menuContainer;
            var editor = this.editor;
            var $txt = editor.txt.$txt;

            $txt.on('scroll', function () {
                if ($txt.scrollTop() > 10) {
                    $menuContainer.addClass('wangEditor-menu-shadow');
                } else {
                    $menuContainer.removeClass('wangEditor-menu-shadow');
                }
            });
        };
    });
    // MenuContainer.fn API
    _e(function (E, $) {

        var MenuContainer = E.MenuContainer;

        MenuContainer.fn.render = function () {
            var $menuContainer = this.$menuContainer;
            var $editorContainer = this.editor.$editorContainer;

            $editorContainer.append($menuContainer);
        };

        // 获取菜单栏的高度
        MenuContainer.fn.height = function () {
            var $menuContainer = this.$menuContainer;
            return $menuContainer.height();
        };

        // 添加菜单
        MenuContainer.fn.appendMenu = function (groupIdx, menu) {
            // 判断是否需要新增一个菜单组
            this._addGroup(groupIdx);
            // 增加菜单（返回 $menuItem）
            return this._addOneMenu(menu);
        };
        MenuContainer.fn._addGroup = function (groupIdx) {
            var $menuContainer = this.$menuContainer;
            var $menuGroup;
            if (!this.$currentGroup || this.currentGroupIdx !== groupIdx) {
                $menuGroup = $('<div class="menu-group clearfix"></div>');
                $menuContainer.append($menuGroup);

                this.$currentGroup = $menuGroup;
                this.currentGroupIdx = groupIdx;
            }
        };
        MenuContainer.fn._addOneMenu = function (menu) {
            var $menuNormal = menu.$domNormal;
            var $menuSelected = menu.$domSelected;

            var $menuGroup = this.$currentGroup;
            var $item = $('<div class="menu-item clearfix"></div>');
            $menuSelected.hide();
            $item.append($menuNormal).append($menuSelected);
            $menuGroup.append($item);

            return $item;
        };
    });
    // menu 构造函数
    _e(function (E, $) {

        // 定义构造函数
        var Menu = function Menu(opt) {
            this.editor = opt.editor;
            this.id = opt.id;
            this.title = opt.title;
            this.$domNormal = opt.$domNormal;
            this.$domSelected = opt.$domSelected || opt.$domNormal;

            // document.execCommand 的参数
            this.commandName = opt.commandName;
            this.commandValue = opt.commandValue;
            this.commandNameSelected = opt.commandNameSelected || opt.commandName;
            this.commandValueSelected = opt.commandValueSelected || opt.commandValue;
        };

        Menu.fn = Menu.prototype;

        // 暴露给 E 即 window.wangEditorV2
        E.Menu = Menu;
    });
    // Menu.fn 初始化绑定的事件
    _e(function (E, $) {

        var Menu = E.Menu;

        // 初始化UI
        Menu.fn.initUI = function () {
            var editor = this.editor;
            var uiConfig = editor.UI.menus;
            var menuId = this.id;
            var menuUI = uiConfig[menuId];

            if (this.$domNormal && this.$domSelected) {
                // 自定义的菜单中，已经传入了 $dom 无需从配置文件中查找生成
                return;
            }

            if (menuUI == null) {
                E.warn('editor.UI配置中，没有菜单 "' + menuId + '" 的UI配置，只能取默认值');

                // 必须写成 uiConfig['default'];
                // 写成 uiConfig.default IE8会报错
                menuUI = uiConfig['default'];
            }

            // 正常状态
            this.$domNormal = $(menuUI.normal);

            // 选中状态
            if (/^\./.test(menuUI.selected)) {
                // 增加一个样式
                this.$domSelected = this.$domNormal.clone().addClass(menuUI.selected.slice(1));
            } else {
                // 一个新的dom对象
                this.$domSelected = $(menuUI.selected);
            }
        };
    });
    // Menu.fn API
    _e(function (E, $) {

        var Menu = E.Menu;

        // 渲染菜单
        Menu.fn.render = function (groupIdx) {
            // 渲染UI
            this.initUI();

            var editor = this.editor;
            var menuContainer = editor.menuContainer;
            var $menuItem = menuContainer.appendMenu(groupIdx, this);
            var onRender = this.onRender;

            // 渲染tip
            this._renderTip($menuItem);

            // 执行 onRender 函数
            if (onRender && typeof onRender === 'function') {
                onRender.call(this);
            }
        };
        Menu.fn._renderTip = function ($menuItem) {
            var self = this;
            var editor = self.editor;
            var title = self.title;
            var $tip = $('<div class="menu-tip"></div>');
            // var $triangle = $('<i class="tip-triangle"></i>'); // 小三角

            // 计算 tip 宽度
            var $tempDiv;
            if (!self.tipWidth) {
                // 设置一个纯透明的 p（absolute;top:-10000px;不会显示在内容区域）
                // 内容赋值为 title ，为了计算tip宽度
                $tempDiv = $('<p style="opacity:0; filter:Alpha(opacity=0); position:absolute;top:-10000px;">' + title + '</p>');
                // 先添加到body，计算完再 remove
                E.$body.append($tempDiv);
                editor.ready(function () {
                    var editor = this;
                    var titleWidth = $tempDiv.outerWidth() + 5; // 多出 5px 的冗余
                    var currentWidth = $tip.outerWidth();
                    var currentMarginLeft = parseFloat($tip.css('margin-left'), 10);
                    // 计算完，拿到数据，则弃用
                    $tempDiv.remove();
                    $tempDiv = null;

                    // 重新设置样式
                    $tip.css({
                        width: titleWidth,
                        'margin-left': currentMarginLeft + (currentWidth - titleWidth) / 2
                    });

                    // 存储
                    self.tipWidth = titleWidth;
                });
            }

            // $tip.append($triangle);
            $tip.append(title);
            $menuItem.append($tip);

            function show() {
                $tip.show();
            }
            function hide() {
                $tip.hide();
            }

            var timeoutId;
            $menuItem.find('a').on('mouseenter', function (e) {
                if (!self.active() && !self.disabled()) {
                    timeoutId = setTimeout(show, 200);
                }
            }).on('mouseleave', function (e) {
                timeoutId && clearTimeout(timeoutId);
                hide();
            }).on('click', hide);
        };

        // 绑定事件
        Menu.fn.bindEvent = function () {
            var self = this;

            var $domNormal = self.$domNormal;
            var $domSelected = self.$domSelected;

            // 试图获取该菜单定义的事件（未selected），没有则自己定义
            var clickEvent = self.clickEvent;
            if (!clickEvent) {
                clickEvent = function clickEvent(e) {
                    // -----------dropPanel dropList modal-----------
                    var dropObj = self.dropPanel || self.dropList || self.modal;
                    if (dropObj && dropObj.show) {
                        if (dropObj.isShowing) {
                            dropObj.hide();
                        } else {
                            dropObj.show();
                        }
                        return;
                    }

                    // -----------command-----------
                    var editor = self.editor;
                    var commandName;
                    var commandValue;

                    var selected = self.selected;
                    if (selected) {
                        commandName = self.commandNameSelected;
                        commandValue = self.commandValueSelected;
                    } else {
                        commandName = self.commandName;
                        commandValue = self.commandValue;
                    }

                    if (commandName) {
                        // 执行命令
                        editor.command(e, commandName, commandValue);
                    } else {
                        // 提示
                        E.warn('菜单 "' + self.id + '" 未定义click事件');
                        e.preventDefault();
                    }
                };
            }
            // 获取菜单定义的selected情况下的点击事件
            var clickEventSelected = self.clickEventSelected || clickEvent;

            // 将事件绑定到菜单dom上
            $domNormal.click(function (e) {
                if (!self.disabled()) {
                    clickEvent.call(self, e);
                    self.updateSelected();
                }
                e.preventDefault();
            });
            $domSelected.click(function (e) {
                if (!self.disabled()) {
                    clickEventSelected.call(self, e);
                    self.updateSelected();
                }
                e.preventDefault();
            });
        };

        // 更新选中状态
        Menu.fn.updateSelected = function () {
            var self = this;
            var editor = self.editor;

            // 试图获取用户自定义的判断事件
            var updateSelectedEvent = self.updateSelectedEvent;
            if (!updateSelectedEvent) {
                // 用户未自定义，则设置默认值
                updateSelectedEvent = function updateSelectedEvent() {
                    var self = this;
                    var editor = self.editor;
                    var commandName = self.commandName;
                    var commandValue = self.commandValue;

                    if (commandValue) {
                        if (editor.queryCommandValue(commandName).toLowerCase() === commandValue.toLowerCase()) {
                            return true;
                        }
                    } else if (editor.queryCommandState(commandName)) {
                        return true;
                    }

                    return false;
                };
            }

            // 获取结果
            var result = updateSelectedEvent.call(self);
            result = !!result;

            // 存储结果、显示效果
            self.changeSelectedState(result);
        };

        // 切换选中状态、显示效果
        Menu.fn.changeSelectedState = function (state) {
            var self = this;
            var selected = self.selected;

            if (state != null && typeof state === 'boolean') {
                if (selected === state) {
                    // 计算结果和当前的状态一样
                    return;
                }
                // 存储结果
                self.selected = state;

                // 切换菜单的显示
                if (state) {
                    // 选中
                    self.$domNormal.hide();
                    self.$domSelected.show();
                } else {
                    // 未选中
                    self.$domNormal.show();
                    self.$domSelected.hide();
                }
            } // if
        };

        // 点击菜单，显示了 dropPanel modal 时，菜单的状态
        Menu.fn.active = function (active) {
            if (active == null) {
                return this._activeState;
            }
            this._activeState = active;
        };
        Menu.fn.activeStyle = function (active) {
            var selected = this.selected;
            var $dom = this.$domNormal;
            var $domSelected = this.$domSelected;

            if (active) {
                $dom.addClass('active');
                $domSelected.addClass('active');
            } else {
                $dom.removeClass('active');
                $domSelected.removeClass('active');
            }

            // 记录状态 （ menu hover 时会取状态用 ）
            this.active(active);
        };

        // 菜单的启用和禁用
        Menu.fn.disabled = function (opt) {
            // 参数为空，取值
            if (opt == null) {
                return !!this._disabled;
            }

            if (this._disabled === opt) {
                // 要设置的参数值和当前参数只一样，无需再次设置
                return;
            }

            var $dom = this.$domNormal;
            var $domSelected = this.$domSelected;

            // 设置样式
            if (opt) {
                $dom.addClass('disable');
                $domSelected.addClass('disable');
            } else {
                $dom.removeClass('disable');
                $domSelected.removeClass('disable');
            }

            // 存储
            this._disabled = opt;
        };
    });
    // dropList 构造函数
    _e(function (E, $) {

        // 定义构造函数
        var DropList = function DropList(editor, menu, opt) {
            this.editor = editor;
            this.menu = menu;

            // list 的数据源，格式 {'commandValue': 'title', ...}
            this.data = opt.data;
            // 要为每个item自定义的模板
            this.tpl = opt.tpl;
            // 为了执行 editor.commandForElem 而传入的elem查询方式
            this.selectorForELemCommand = opt.selectorForELemCommand;

            // 执行事件前后的钩子
            this.beforeEvent = opt.beforeEvent;
            this.afterEvent = opt.afterEvent;

            // 初始化
            this.init();
        };

        DropList.fn = DropList.prototype;

        // 暴露给 E 即 window.wangEditorV2
        E.DropList = DropList;
    });
    // dropList fn bind
    _e(function (E, $) {

        var DropList = E.DropList;

        // init
        DropList.fn.init = function () {
            var self = this;

            // 生成dom对象
            self.initDOM();

            // 绑定command事件
            self.bindEvent();

            // 声明隐藏的事件
            self.initHideEvent();
        };

        // 初始化dom结构
        DropList.fn.initDOM = function () {
            var self = this;
            var data = self.data;
            var tpl = self.tpl || '<span>{#title}</span>';
            var $list = $('<div class="wangEditor-drop-list clearfix"></div>');

            var itemContent;
            var $item;
            $.each(data, function (commandValue, title) {
                itemContent = tpl.replace(/{#commandValue}/ig, commandValue).replace(/{#title}/ig, title);
                $item = $('<a href="#" commandValue="' + commandValue + '"></a>');
                $item.append(itemContent);
                $list.append($item);
            });

            self.$list = $list;
        };

        // 绑定事件
        DropList.fn.bindEvent = function () {
            var self = this;
            var editor = self.editor;
            var menu = self.menu;
            var commandName = menu.commandName;
            var selectorForELemCommand = self.selectorForELemCommand;
            var $list = self.$list;

            // 执行事件前后的钩子函数
            var beforeEvent = self.beforeEvent;
            var afterEvent = self.afterEvent;

            $list.on('click', 'a[commandValue]', function (e) {
                // 正式命令执行之前
                if (beforeEvent && typeof beforeEvent === 'function') {
                    beforeEvent.call(e);
                }

                // 执行命令
                var commandValue = $(e.currentTarget).attr('commandValue');
                if (menu.selected && editor.isRangeEmpty() && selectorForELemCommand) {
                    // 当前处于选中状态，并且选中内容为空
                    editor.commandForElem(selectorForELemCommand, e, commandName, commandValue);
                } else {
                    // 当前未处于选中状态，或者有选中内容。则执行默认命令
                    editor.command(e, commandName, commandValue);
                }

                // 正式命令之后的钩子
                if (afterEvent && typeof afterEvent === 'function') {
                    afterEvent.call(e);
                }
            });
        };

        // 点击其他地方，立即隐藏 droplist
        DropList.fn.initHideEvent = function () {
            var self = this;

            // 获取 list elem
            var thisList = self.$list.get(0);

            E.$body.on('click', function (e) {
                if (!self.isShowing) {
                    return;
                }
                var trigger = e.target;

                // 获取菜单elem
                var menu = self.menu;
                var menuDom;
                if (menu.selected) {
                    menuDom = menu.$domSelected.get(0);
                } else {
                    menuDom = menu.$domNormal.get(0);
                }

                if (menuDom === trigger || $.contains(menuDom, trigger)) {
                    // 说明由本菜单点击触发的
                    return;
                }

                if (thisList === trigger || $.contains(thisList, trigger)) {
                    // 说明由本list点击触发的
                    return;
                }

                // 其他情况，隐藏 list
                self.hide();
            });

            E.$window.scroll(function () {
                self.hide();
            });

            E.$window.on('resize', function () {
                self.hide();
            });
        };
    });
    // dropListfn api
    _e(function (E, $) {

        var DropList = E.DropList;

        // 渲染
        DropList.fn._render = function () {
            var self = this;
            var editor = self.editor;
            var $list = self.$list;

            // 渲染到页面
            editor.$editorContainer.append($list);

            // 记录状态
            self.rendered = true;
        };

        // 定位
        DropList.fn._position = function () {
            var self = this;
            var $list = self.$list;
            var editor = self.editor;
            var menu = self.menu;
            var $menuContainer = editor.menuContainer.$menuContainer;
            var $menuDom = menu.selected ? menu.$domSelected : menu.$domNormal;
            // 注意这里的 offsetParent() 要返回 .menu-item 的 position
            // 因为 .menu-item 是 position:relative
            var menuPosition = $menuDom.offsetParent().position();

            // 取得 menu 的位置、尺寸属性
            var menuTop = menuPosition.top;
            var menuLeft = menuPosition.left;
            var menuHeight = $menuDom.offsetParent().height();
            var menuWidth = $menuDom.offsetParent().width();

            // 取得 list 的尺寸属性
            var listWidth = $list.outerWidth();
            // var listHeight = $list.outerHeight();

            // 取得 $txt 的尺寸
            var txtWidth = editor.txt.$txt.outerWidth();

            // ------------开始计算-------------

            // 初步计算 list 位置属性
            var top = menuTop + menuHeight;
            var left = menuLeft + menuWidth / 2;
            var marginLeft = 0 - menuWidth / 2;

            // 如果超出了有边界，则要左移（且和右侧有间隙）
            var valWithTxt = left + listWidth - txtWidth;
            if (valWithTxt > -10) {
                marginLeft = marginLeft - valWithTxt - 10;
            }
            // 设置样式
            $list.css({
                top: top,
                left: left,
                'margin-left': marginLeft
            });

            // 如果因为向下滚动而导致菜单fixed，则再加一步处理
            if (editor._isMenufixed) {
                top = top + ($menuContainer.offset().top + $menuContainer.outerHeight() - $list.offset().top);

                // 重新设置top
                $list.css({
                    top: top
                });
            }
        };

        // 显示
        DropList.fn.show = function () {
            var self = this;
            var menu = self.menu;
            if (!self.rendered) {
                // 第一次show之前，先渲染
                self._render();
            }

            if (self.isShowing) {
                return;
            }

            var $list = self.$list;
            $list.show();

            // 定位
            self._position();

            // 记录状态
            self.isShowing = true;

            // 菜单状态
            menu.activeStyle(true);
        };

        // 隐藏
        DropList.fn.hide = function () {
            var self = this;
            var menu = self.menu;
            if (!self.isShowing) {
                return;
            }

            var $list = self.$list;
            $list.hide();

            // 记录状态
            self.isShowing = false;

            // 菜单状态
            menu.activeStyle(false);
        };
    });
    // dropPanel 构造函数
    _e(function (E, $) {

        // 定义构造函数
        var DropPanel = function DropPanel(editor, menu, opt) {
            this.editor = editor;
            this.menu = menu;
            this.$content = opt.$content;
            this.width = opt.width || 200;
            this.height = opt.height;
            this.onRender = opt.onRender;

            // init
            this.init();
        };

        DropPanel.fn = DropPanel.prototype;

        // 暴露给 E 即 window.wangEditorV2
        E.DropPanel = DropPanel;
    });
    // dropPanel fn bind
    _e(function (E, $) {

        var DropPanel = E.DropPanel;

        // init
        DropPanel.fn.init = function () {
            var self = this;

            // 生成dom对象
            self.initDOM();

            // 声明隐藏的事件
            self.initHideEvent();
        };

        // init DOM
        DropPanel.fn.initDOM = function () {
            var self = this;
            var $content = self.$content;
            var width = self.width;
            var height = self.height;
            var $panel = $('<div class="wangEditor-drop-panel clearfix"></div>');
            var $triangle = $('<div class="tip-triangle"></div>');

            $panel.css({
                width: width,
                height: height ? height : 'auto'
            });
            $panel.append($triangle);
            $panel.append($content);

            // 添加对象数据
            self.$panel = $panel;
            self.$triangle = $triangle;
        };

        // 点击其他地方，立即隐藏 dropPanel
        DropPanel.fn.initHideEvent = function () {
            var self = this;

            // 获取 panel elem
            var thisPanle = self.$panel.get(0);

            E.$body.on('click', function (e) {
                if (!self.isShowing) {
                    return;
                }
                var trigger = e.target;

                // 获取菜单elem
                var menu = self.menu;
                var menuDom;
                if (menu.selected) {
                    menuDom = menu.$domSelected.get(0);
                } else {
                    menuDom = menu.$domNormal.get(0);
                }

                if (menuDom === trigger || $.contains(menuDom, trigger)) {
                    // 说明由本菜单点击触发的
                    return;
                }

                if (thisPanle === trigger || $.contains(thisPanle, trigger)) {
                    // 说明由本panel点击触发的
                    return;
                }

                // 其他情况，隐藏 panel
                self.hide();
            });

            E.$window.scroll(function (e) {
                self.hide();
            });

            E.$window.on('resize', function () {
                self.hide();
            });
        };
    });
    // dropPanel fn api
    _e(function (E, $) {

        var DropPanel = E.DropPanel;

        // 渲染
        DropPanel.fn._render = function () {
            var self = this;
            var onRender = self.onRender;
            var editor = self.editor;
            var $panel = self.$panel;

            // 渲染到页面
            editor.$editorContainer.append($panel);

            // 渲染后的回调事件
            onRender && onRender.call(self);

            // 记录状态
            self.rendered = true;
        };

        // 定位
        DropPanel.fn._position = function () {
            var self = this;
            var $panel = self.$panel;
            var $triangle = self.$triangle;
            var editor = self.editor;
            var $menuContainer = editor.menuContainer.$menuContainer;
            var menu = self.menu;
            var $menuDom = menu.selected ? menu.$domSelected : menu.$domNormal;
            // 注意这里的 offsetParent() 要返回 .menu-item 的 position
            // 因为 .menu-item 是 position:relative
            var menuPosition = $menuDom.offsetParent().position();

            // 取得 menu 的位置、尺寸属性
            var menuTop = menuPosition.top;
            var menuLeft = menuPosition.left;
            var menuHeight = $menuDom.offsetParent().height();
            var menuWidth = $menuDom.offsetParent().width();

            // 取得 panel 的尺寸属性
            var panelWidth = $panel.outerWidth();
            // var panelHeight = $panel.outerHeight();

            // 取得 $txt 的尺寸
            var txtWidth = editor.txt.$txt.outerWidth();

            // ------------开始计算-------------

            // 初步计算 panel 位置属性
            var top = menuTop + menuHeight;
            var left = menuLeft + menuWidth / 2;
            var marginLeft = 0 - panelWidth / 2;
            var marginLeft2 = marginLeft; // 下文用于和 marginLeft 比较，来设置三角形tip的位置

            // 如果超出了左边界，则移动回来（要和左侧有10px间隙）
            if (0 - marginLeft > left - 10) {
                marginLeft = 0 - (left - 10);
            }

            // 如果超出了有边界，则要左移（且和右侧有10px间隙）
            var valWithTxt = left + panelWidth + marginLeft - txtWidth;
            if (valWithTxt > -10) {
                marginLeft = marginLeft - valWithTxt - 10;
            }

            // 设置样式
            $panel.css({
                top: top,
                left: left,
                'margin-left': marginLeft
            });

            // 如果因为向下滚动而导致菜单fixed，则再加一步处理
            if (editor._isMenufixed) {
                top = top + ($menuContainer.offset().top + $menuContainer.outerHeight() - $panel.offset().top);

                // 重新设置top
                $panel.css({
                    top: top
                });
            }

            // 设置三角形 tip 的位置
            $triangle.css({
                'margin-left': marginLeft2 - marginLeft - 5
            });
        };

        // focus 第一个 input
        DropPanel.fn.focusFirstInput = function () {
            var self = this;
            var $panel = self.$panel;
            $panel.find('input[type=text],textarea').each(function () {
                var $input = $(this);
                if ($input.attr('disabled') == null) {
                    $input.focus();
                    return false;
                }
            });
        };

        // 显示
        DropPanel.fn.show = function () {
            var self = this;
            var menu = self.menu;
            if (!self.rendered) {
                // 第一次show之前，先渲染
                self._render();
            }

            if (self.isShowing) {
                return;
            }

            var $panel = self.$panel;
            $panel.show();

            // 定位
            self._position();

            // 记录状态
            self.isShowing = true;

            // 菜单状态
            menu.activeStyle(true);

            if (E.w3cRange) {
                // 高级浏览器
                self.focusFirstInput();
            } else {
                // 兼容 IE8 input placeholder
                E.placeholderForIE8($panel);
            }
        };

        // 隐藏
        DropPanel.fn.hide = function () {
            var self = this;
            var menu = self.menu;
            if (!self.isShowing) {
                return;
            }

            var $panel = self.$panel;
            $panel.hide();

            // 记录状态
            self.isShowing = false;

            // 菜单状态
            menu.activeStyle(false);
        };
    });
    // modal 构造函数
    _e(function (E, $) {

        // 定义构造函数
        var Modal = function Modal(editor, menu, opt) {
            this.editor = editor;
            this.menu = menu;
            this.$content = opt.$content;

            this.init();
        };

        Modal.fn = Modal.prototype;

        // 暴露给 E 即 window.wangEditorV2
        E.Modal = Modal;
    });
    // modal fn bind
    _e(function (E, $) {

        var Modal = E.Modal;

        Modal.fn.init = function () {
            var self = this;

            // 初始化dom
            self.initDom();

            // 初始化隐藏事件
            self.initHideEvent();
        };

        // 初始化dom
        Modal.fn.initDom = function () {
            var self = this;
            var $content = self.$content;
            var $modal = $('<div class="wangEditor-modal"></div>');
            var $close = $('<div class="wangEditor-modal-close"><i class="wangeditor-menu-img-cancel-circle"></i></div>');

            $modal.append($close);
            $modal.append($content);

            // 记录数据
            self.$modal = $modal;
            self.$close = $close;
        };

        // 初始化隐藏事件
        Modal.fn.initHideEvent = function () {
            var self = this;
            var $close = self.$close;
            var modal = self.$modal.get(0);

            // 点击 $close 按钮，隐藏
            $close.click(function () {
                self.hide();
            });

            // 点击其他部分，隐藏
            E.$body.on('click', function (e) {
                if (!self.isShowing) {
                    return;
                }
                var trigger = e.target;

                // 获取菜单elem
                var menu = self.menu;
                var menuDom;
                if (menu) {
                    if (menu.selected) {
                        menuDom = menu.$domSelected.get(0);
                    } else {
                        menuDom = menu.$domNormal.get(0);
                    }

                    if (menuDom === trigger || $.contains(menuDom, trigger)) {
                        // 说明由本菜单点击触发的
                        return;
                    }
                }

                if (modal === trigger || $.contains(modal, trigger)) {
                    // 说明由本panel点击触发的
                    return;
                }

                // 其他情况，隐藏 panel
                self.hide();
            });
        };
    });
    // modal fn api
    _e(function (E, $) {

        var Modal = E.Modal;

        // 渲染
        Modal.fn._render = function () {
            var self = this;
            var editor = self.editor;
            var $modal = self.$modal;

            // $modal的z-index，在配置的z-index基础上再 +10
            $modal.css('z-index', editor.config.zindex + 10 + '');

            // 渲染到body最后面
            E.$body.append($modal);

            // 记录状态
            self.rendered = true;
        };

        // 定位
        Modal.fn._position = function () {
            var self = this;
            var $modal = self.$modal;
            var top = $modal.offset().top;
            var width = $modal.outerWidth();
            var height = $modal.outerHeight();
            var marginLeft = 0 - width / 2;
            var marginTop = 0 - height / 2;
            var sTop = E.$window.scrollTop();

            // 保证modal最顶部，不超过浏览器上边框
            if (height / 2 > top) {
                marginTop = 0 - top;
            }

            $modal.css({
                'margin-left': marginLeft + 'px',
                'margin-top': marginTop + sTop + 'px'
            });
        };

        // 显示
        Modal.fn.show = function () {
            var self = this;
            var menu = self.menu;
            if (!self.rendered) {
                // 第一次show之前，先渲染
                self._render();
            }

            if (self.isShowing) {
                return;
            }
            // 记录状态
            self.isShowing = true;

            var $modal = self.$modal;
            $modal.show();

            // 定位
            self._position();

            // 激活菜单状态
            menu && menu.activeStyle(true);
        };

        // 隐藏
        Modal.fn.hide = function () {
            var self = this;
            var menu = self.menu;
            if (!self.isShowing) {
                return;
            }
            // 记录状态
            self.isShowing = false;

            // 隐藏
            var $modal = self.$modal;
            $modal.hide();

            // 菜单状态
            menu && menu.activeStyle(false);
        };
    });
    // txt 构造函数
    _e(function (E, $) {

        // 定义构造函数
        var Txt = function Txt(editor) {
            this.editor = editor;

            // 初始化
            this.init();
        };

        Txt.fn = Txt.prototype;

        // 暴露给 E 即 window.wangEditorV2
        E.Txt = Txt;
    });
    // Txt.fn bind fn
    _e(function (E, $) {

        var Txt = E.Txt;

        // 初始化
        Txt.fn.init = function () {
            var self = this;
            var editor = self.editor;
            var $valueContainer = editor.$valueContainer;
            var currentValue = editor.getInitValue();
            var $txt;

            if ($valueContainer.get(0).nodeName === 'DIV') {
                // 如果传入生成编辑器的元素就是div，则直接使用
                $txt = $valueContainer;
                $txt.addClass("wangEditor-txt");
                $txt.attr('contentEditable', 'true');
            } else {
                // 如果不是div（是textarea），则创建一个div
                $txt = $('<div class="wangEditor-txt" contentEditable="true">' + currentValue + '</div>');
            }

            // 试图最后插入一个空行，ready之后才行
            editor.ready(function () {
                self.insertEmptyP();
            });

            self.$txt = $txt;

            // 删除时，如果没有内容了，就添加一个 <p><br></p>
            self.contentEmptyHandle();

            // enter时，不能使用 div 换行
            self.bindEnterForDiv();

            // enter时，用 p 包裹 text
            self.bindEnterForText();

            // tab 插入4个空格
            self.bindTabEvent();

            // 处理粘贴内容
            self.bindPasteFilter();

            // $txt.formatText() 方法
            self.bindFormatText();

            // 定义 $txt.html() 方法
            self.bindHtml();
        };

        // 删除时，如果没有内容了，就添加一个 <p><br></p>
        Txt.fn.contentEmptyHandle = function () {
            var self = this;
            var editor = self.editor;
            var $txt = self.$txt;
            var $p;

            $txt.on('keydown', function (e) {
                if (e.keyCode !== 8) {
                    return;
                }
                var txtHtml = $.trim($txt.html().toLowerCase());
                if (txtHtml === '<p><br></p>') {
                    // 如果最后还剩余一个空行，就不再继续删除了
                    e.preventDefault();
                    return;
                }
            });

            $txt.on('keyup', function (e) {
                if (e.keyCode !== 8) {
                    return;
                }
                var txtHtml = $.trim($txt.html().toLowerCase());
                // ff时用 txtHtml === '<br>' 判断，其他用 !txtHtml 判断
                if (!txtHtml || txtHtml === '<br>') {
                    // 内容空了
                    $p = $('<p><br/></p>');
                    $txt.html(''); // 一定要先清空，否则在 ff 下有问题
                    $txt.append($p);
                    editor.restoreSelectionByElem($p.get(0));
                }
            });
        };

        // enter时，不能使用 div 换行
        Txt.fn.bindEnterForDiv = function () {
            var tags = E.config.legalTags; // 配置中编辑器要求的合法标签，如 p head table blockquote ul ol 等
            var self = this;
            var editor = self.editor;
            var $txt = self.$txt;

            var $keydownDivElem;
            function divHandler() {
                if (!$keydownDivElem) {
                    return;
                }

                var $pElem = $('<p>' + $keydownDivElem.html() + '</p>');
                $keydownDivElem.after($pElem);
                $keydownDivElem.remove();
            }

            $txt.on('keydown keyup', function (e) {
                if (e.keyCode !== 13) {
                    return;
                }
                // 查找合法标签
                var rangeElem = editor.getRangeElem();
                var targetElem = editor.getLegalTags(rangeElem);
                var $targetElem;
                var $pElem;

                if (!targetElem) {
                    // 没找到合法标签，就去查找 div
                    targetElem = editor.getSelfOrParentByName(rangeElem, 'div');
                    if (!targetElem) {
                        return;
                    }
                    $targetElem = $(targetElem);

                    if (e.type === 'keydown') {
                        // 异步执行（同步执行会出现问题）
                        $keydownDivElem = $targetElem;
                        setTimeout(divHandler, 0);
                    }

                    if (e.type === 'keyup') {
                        // 将 div 的内容移动到 p 里面，并移除 div
                        $pElem = $('<p>' + $targetElem.html() + '</p>');
                        $targetElem.after($pElem);
                        $targetElem.remove();

                        // 如果是回车结束，将选区定位到行首
                        editor.restoreSelectionByElem($pElem.get(0), 'start');
                    }
                }
            });
        };

        // enter时，用 p 包裹 text
        Txt.fn.bindEnterForText = function () {
            var self = this;
            var $txt = self.$txt;
            var handle;
            $txt.on('keyup', function (e) {
                if (e.keyCode !== 13) {
                    return;
                }
                if (!handle) {
                    handle = function handle() {
                        self.wrapImgAndText();
                    };
                }
                setTimeout(handle);
            });
        };

        // tab 时，插入4个空格
        Txt.fn.bindTabEvent = function () {
            var self = this;
            var editor = self.editor;
            var $txt = self.$txt;

            $txt.on('keydown', function (e) {
                if (e.keyCode !== 9) {
                    // 只监听 tab 按钮
                    return;
                }
                // 如果浏览器支持 insertHtml 则插入4个空格。如果不支持，就不管了
                if (editor.queryCommandSupported('insertHtml')) {
                    editor.command(e, 'insertHtml', '&nbsp;&nbsp;&nbsp;&nbsp;');
                }
            });
        };

        // 处理粘贴内容
        Txt.fn.bindPasteFilter = function () {
            var self = this;
            var editor = self.editor;
            var resultHtml = ''; //存储最终的结果
            var $txt = self.$txt;
            var legalTags = editor.config.legalTags;
            var legalTagArr = legalTags.split(',');

            $txt.on('paste', function (e) {
                if (!editor.config.pasteFilter) {
                    // 配置中取消了粘贴过滤
                    return;
                }

                var currentNodeName = editor.getRangeElem().nodeName;
                if (currentNodeName === 'TD' || currentNodeName === 'TH') {
                    // 在表格的单元格中粘贴，忽略所有内容。否则会出现异常情况
                    return;
                }

                resultHtml = ''; // 先清空 resultHtml

                var pasteHtml, $paste, docSplitHtml;
                var data = e.clipboardData || e.originalEvent.clipboardData;
                var ieData = window.clipboardData;

                if (editor.config.pasteText) {
                    // 只粘贴纯文本

                    if (data && data.getData) {
                        // w3c
                        pasteHtml = data.getData('text/plain');
                    } else if (ieData && ieData.getData) {
                        // IE
                        pasteHtml = ieData.getData('text');
                    } else {
                        // 其他情况
                        return;
                    }

                    // 拼接为 <p> 标签
                    if (pasteHtml) {
                        resultHtml = '<p>' + pasteHtml + '</p>';
                    }
                } else {
                    // 粘贴过滤了样式的、只有标签的 html

                    if (data && data.getData) {
                        // w3c

                        // 获取粘贴过来的html
                        pasteHtml = data.getData('text/html');

                        // 过滤从 word excel 粘贴过来的乱码
                        docSplitHtml = pasteHtml.split('</html>');
                        if (docSplitHtml.length === 2) {
                            pasteHtml = docSplitHtml[0];
                        }

                        if (pasteHtml) {
                            // 创建dom
                            $paste = $('<div>' + pasteHtml + '</div>');
                            // 处理，并将结果存储到 resultHtml 『全局』变量
                            handle($paste.get(0));
                        } else {
                            // 得不到html，试图获取text
                            pasteHtml = data.getData('text/plain');
                            if (pasteHtml) {
                                // 替换特殊字符
                                pasteHtml = pasteHtml.replace(/[ ]/g, '&nbsp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '</p><p>');
                                // 拼接
                                resultHtml = '<p>' + pasteHtml + '</p>';

                                // 查询链接
                                resultHtml = resultHtml.replace(/<p>(https?:\/\/.*?)<\/p>/ig, function (match, link) {
                                    return '<p><a href="' + link + '" target="_blank">' + link + '</p>';
                                });
                            }
                        }
                    } else if (ieData && ieData.getData) {
                        // IE 直接从剪切板中取出纯文本格式
                        resultHtml = ieData.getData('text');
                        if (!resultHtml) {
                            return;
                        }
                        // 拼接为 <p> 标签
                        resultHtml = '<p>' + resultHtml + '</p>';
                        resultHtml = resultHtml.replace(new RegExp('\n', 'g'), '</p><p>');
                    } else {
                        // 其他情况
                        return;
                    }
                }

                // 执行命令
                if (resultHtml) {
                    editor.command(e, 'insertHtml', resultHtml);

                    // 删除内容为空的 p 和嵌套的 p
                    self.clearEmptyOrNestP();
                }
            });

            // 处理粘贴的内容
            function handle(elem) {
                if (!elem || !elem.nodeType || !elem.nodeName) {
                    return;
                }
                var $elem;
                var nodeName = elem.nodeName.toLowerCase();
                var nodeType = elem.nodeType;
                var childNodesClone;

                // 只处理文本和普通node标签
                if (nodeType !== 3 && nodeType !== 1) {
                    return;
                }

                $elem = $(elem);

                // 如果是容器，则继续深度遍历
                if (nodeName === 'div') {
                    childNodesClone = [];
                    $.each(elem.childNodes, function (index, item) {
                        // elem.childNodes 可获取TEXT节点，而 $elem.children() 就获取不到
                        // 先将 elem.childNodes 拷贝一份，一面在循环递归过程中 elem 发生变化
                        childNodesClone.push(item);
                    });
                    // 遍历子元素，执行操作
                    $.each(childNodesClone, function () {
                        handle(this);
                    });
                    return;
                }

                if (legalTagArr.indexOf(nodeName) >= 0) {
                    // 如果是合法标签之内的，则根据元素类型，获取值
                    resultHtml += getResult(elem);
                } else if (nodeType === 3) {
                    // 如果是文本，则直接插入 p 标签
                    resultHtml += '<p>' + elem.textContent + '</p>';
                } else if (nodeName === 'br') {
                    // <br>保留
                    resultHtml += '<br/>';
                } else {
                    // 忽略的标签
                    if (['meta', 'style', 'script', 'object', 'form', 'iframe', 'hr'].indexOf(nodeName) >= 0) {
                        return;
                    }
                    // 其他标签，移除属性，插入 p 标签
                    $elem = $(removeAttrs(elem));
                    // 注意，这里的 clone() 是必须的，否则会出错
                    resultHtml += $('<div>').append($elem.clone()).html();
                }
            }

            // 获取元素的结果
            function getResult(elem) {
                var nodeName = elem.nodeName.toLowerCase();
                var $elem;
                var htmlForP = '';
                var htmlForLi = '';

                if (['blockquote'].indexOf(nodeName) >= 0) {

                    // 直接取出元素text即可
                    $elem = $(elem);
                    return '<' + nodeName + '>' + $elem.text() + '</' + nodeName + '>';
                } else if (['p', 'h1', 'h2', 'h3', 'h4', 'h5'].indexOf(nodeName) >= 0) {

                    //p head 取出 text 和链接
                    elem = removeAttrs(elem);
                    $elem = $(elem);
                    htmlForP = $elem.html();

                    // 剔除 a img 之外的元素
                    htmlForP = htmlForP.replace(/<.*?>/ig, function (tag) {
                        if (tag === '</a>' || tag.indexOf('<a ') === 0 || tag.indexOf('<img ') === 0) {
                            return tag;
                        } else {
                            return '';
                        }
                    });

                    return '<' + nodeName + '>' + htmlForP + '</' + nodeName + '>';
                } else if (['ul', 'ol'].indexOf(nodeName) >= 0) {

                    // ul ol元素，获取子元素（li元素）的text link img，再拼接
                    $elem = $(elem);
                    $elem.children().each(function () {
                        var $li = $(removeAttrs(this));
                        var html = $li.html();

                        html = html.replace(/<.*?>/ig, function (tag) {
                            if (tag === '</a>' || tag.indexOf('<a ') === 0 || tag.indexOf('<img ') === 0) {
                                return tag;
                            } else {
                                return '';
                            }
                        });

                        htmlForLi += '<li>' + html + '</li>';
                    });
                    return '<' + nodeName + '>' + htmlForLi + '</' + nodeName + '>';
                } else {

                    // 其他元素，移除元素属性
                    $elem = $(removeAttrs(elem));
                    return $('<div>').append($elem).html();
                }
            }

            // 移除一个元素（子元素）的attr
            function removeAttrs(elem) {
                var attrs = elem.attributes || [];
                var attrNames = [];
                var exception = ['href', 'target', 'src', 'alt', 'rowspan', 'colspan']; //例外情况

                // 先存储下elem中所有 attr 的名称
                $.each(attrs, function (key, attr) {
                    if (attr && attr.nodeType === 2) {
                        attrNames.push(attr.nodeName);
                    }
                });
                // 再根据名称删除所有attr
                $.each(attrNames, function (key, attr) {
                    if (exception.indexOf(attr) < 0) {
                        // 除了 exception 规定的例外情况，删除其他属性
                        elem.removeAttribute(attr);
                    }
                });

                // 递归子节点
                var children = elem.childNodes;
                if (children.length) {
                    $.each(children, function (key, value) {
                        removeAttrs(value);
                    });
                }

                return elem;
            }
        };

        // 绑定 $txt.formatText() 方法
        Txt.fn.bindFormatText = function () {
            var self = this;
            var editor = self.editor;
            var $txt = self.$txt;
            var legalTags = E.config.legalTags;
            var legalTagArr = legalTags.split(',');
            var length = legalTagArr.length;
            var regArr = [];

            // 将 E.config.legalTags 配置的有效字符，生成正则表达式
            $.each(legalTagArr, function (k, tag) {
                var reg = '\>\\s*\<(' + tag + ')\>';
                regArr.push(new RegExp(reg, 'ig'));
            });

            // 增加 li
            regArr.push(new RegExp('\>\\s*\<(li)\>', 'ig'));

            // 增加 tr
            regArr.push(new RegExp('\>\\s*\<(tr)\>', 'ig'));

            // 增加 code
            regArr.push(new RegExp('\>\\s*\<(code)\>', 'ig'));

            // 生成 formatText 方法
            $txt.formatText = function () {
                var $temp = $('<div>');
                var html = $txt.html();

                // 去除空格
                html = html.replace(/\s*</ig, '<');

                // 段落、表格之间换行
                $.each(regArr, function (k, reg) {
                    if (!reg.test(html)) {
                        return;
                    }
                    html = html.replace(reg, function (matchStr, tag) {
                        return '>\n<' + tag + '>';
                    });
                });

                $temp.html(html);
                return $temp.text();
            };
        };

        // 定制 $txt.html 方法
        Txt.fn.bindHtml = function () {
            var self = this;
            var editor = self.editor;
            var $txt = self.$txt;
            var $valueContainer = editor.$valueContainer;
            var valueNodeName = editor.valueNodeName;

            $txt.html = function (html) {
                var result;

                if (valueNodeName === 'div') {
                    // div 生成的编辑器，取值、赋值，都直接触发jquery的html方法
                    result = $.fn.html.call($txt, html);
                }

                // textarea 生成的编辑器，则需要考虑赋值时，也给textarea赋值

                if (html === undefined) {
                    // 取值，直接触发jquery原生html方法
                    result = $.fn.html.call($txt);

                    // 替换 html 中，src和href属性中的 & 字符。
                    // 因为 .html() 或者 .innerHTML 会把所有的 & 字符都改成 &amp; 但是 src 和 href 中的要保持 &
                    result = result.replace(/(href|src)\=\"(.*)\"/igm, function (a, b, c) {
                        return b + '="' + c.replace('&amp;', '&') + '"';
                    });
                } else {
                    // 赋值，需要同时给 textarea 赋值
                    result = $.fn.html.call($txt, html);
                    $valueContainer.val(html);
                }

                if (html === undefined) {
                    return result;
                } else {
                    // 手动触发 change 事件，因为 $txt 监控了 change 事件来判断是否需要执行 editor.onchange
                    $txt.change();
                }
            };
        };
    });
    // Txt.fn api
    _e(function (E, $) {

        var Txt = E.Txt;

        var txtChangeEventNames = 'propertychange change click keyup input paste';

        // 渲染
        Txt.fn.render = function () {
            var $txt = this.$txt;
            var $editorContainer = this.editor.$editorContainer;
            $editorContainer.append($txt);
        };

        // 计算高度
        Txt.fn.initHeight = function () {
            var editor = this.editor;
            var $txt = this.$txt;
            var valueContainerHeight = editor.$valueContainer.height();
            var menuHeight = editor.menuContainer.height();
            var txtHeight = valueContainerHeight - menuHeight;

            // 限制最小为 50px
            txtHeight = txtHeight < 50 ? 50 : txtHeight;

            $txt.height(txtHeight);

            // 记录原始高度
            editor.valueContainerHeight = valueContainerHeight;

            // 设置 max-height
            this.initMaxHeight(txtHeight, menuHeight);
        };

        // 计算最大高度
        Txt.fn.initMaxHeight = function (txtHeight, menuHeight) {
            var editor = this.editor;
            var $menuContainer = editor.menuContainer.$menuContainer;
            var $txt = this.$txt;
            var $wrap = $('<div>');

            // 需要浏览器支持 max-height，否则不管
            if (window.getComputedStyle && 'max-height' in window.getComputedStyle($txt.get(0))) {
                // 获取 max-height 并判断是否有值
                var maxHeight = parseInt(editor.$valueContainer.css('max-height'));
                if (isNaN(maxHeight)) {
                    return;
                }

                // max-height 和『全屏』暂时有冲突
                if (editor.menus.fullscreen) {
                    E.warn('max-height和『全屏』菜单一起使用时，会有一些问题尚未解决，请暂时不要两个同时使用');
                    return;
                }

                // 标记
                editor.useMaxHeight = true;

                // 设置maxheight
                $wrap.css({
                    'max-height': maxHeight - menuHeight + 'px',
                    'overflow-y': 'auto'
                });
                $txt.css({
                    'height': 'auto',
                    'overflow-y': 'visible',
                    'min-height': txtHeight + 'px'
                });

                // 滚动式，菜单阴影
                $wrap.on('scroll', function () {
                    if ($txt.parent().scrollTop() > 10) {
                        $menuContainer.addClass('wangEditor-menu-shadow');
                    } else {
                        $menuContainer.removeClass('wangEditor-menu-shadow');
                    }
                });

                // 需在编辑器区域外面再包裹一层
                $txt.wrap($wrap);
            }
        };

        // 保存选区
        Txt.fn.saveSelectionEvent = function () {
            var $txt = this.$txt;
            var editor = this.editor;
            var timeoutId;
            var dt = Date.now();

            function save() {
                editor.saveSelection();
            }

            // 同步保存选区
            function saveSync() {
                // 100ms之内，不重复保存
                if (Date.now() - dt < 100) {
                    return;
                }

                dt = Date.now();
                save();
            }

            // 异步保存选区
            function saveAync() {
                // 节流，防止高频率重复操作
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
                timeoutId = setTimeout(save, 300);
            }

            // txt change 、focus、blur 时随时保存选区
            $txt.on(txtChangeEventNames + ' focus blur', function (e) {
                // 先同步保存选区，为了让接下来就马上要执行 editor.getRangeElem() 的程序
                // 能够获取到正确的 rangeElem
                saveSync();

                // 再异步保存选区，为了确定更加准确的选区，为后续的操作做准备
                saveAync();
            });

            // 鼠标拖拽选择时，可能会拖拽到编辑器区域外面再松手，此时 $txt 就监听不到 click事件了
            $txt.on('mousedown', function () {
                $txt.on('mouseleave.saveSelection', function (e) {
                    // 先同步后异步，如上述注释
                    saveSync();
                    saveAync();

                    // 顺道吧菜单状态也更新了
                    editor.updateMenuStyle();
                });
            }).on('mouseup', function () {
                $txt.off('mouseleave.saveSelection');
            });
        };

        // 随时更新 value
        Txt.fn.updateValueEvent = function () {
            var $txt = this.$txt;
            var editor = this.editor;
            var timeoutId, oldValue;

            // 触发 onchange 事件
            function doOnchange() {
                var val = $txt.html();
                if (oldValue === val) {
                    // 无变化
                    return;
                }

                // 触发 onchange 事件
                if (editor.onchange && typeof editor.onchange === 'function') {
                    editor.onchange.call(editor);
                }

                // 更新内容
                editor.updateValue();

                // 记录最新内容
                oldValue = val;
            }

            // txt change 时随时更新内容
            $txt.on(txtChangeEventNames, function (e) {
                // 初始化
                if (oldValue == null) {
                    oldValue = $txt.html();
                }

                // 监控内容变化（停止操作 100ms 之后立即执行）
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
                timeoutId = setTimeout(doOnchange, 100);
            });
        };

        // 随时更新 menustyle
        Txt.fn.updateMenuStyleEvent = function () {
            var $txt = this.$txt;
            var editor = this.editor;

            // txt change 时随时更新内容
            $txt.on(txtChangeEventNames, function (e) {
                editor.updateMenuStyle();
            });
        };

        // 最后插入试图插入 <p><br><p>
        Txt.fn.insertEmptyP = function () {
            var $txt = this.$txt;
            var $children = $txt.children();

            if ($children.length === 0) {
                $txt.append($('<p><br></p>'));
                return;
            }

            if ($.trim($children.last().html()).toLowerCase() !== '<br>') {
                $txt.append($('<p><br></p>'));
            }
        };

        // 将编辑器暴露出来的文字和图片，都用 p 来包裹
        Txt.fn.wrapImgAndText = function () {
            var $txt = this.$txt;
            var $imgs = $txt.children('img');
            var txt = $txt[0];
            var childNodes = txt.childNodes;
            var childrenLength = childNodes.length;
            var i, childNode, p;

            // 处理图片
            $imgs.length && $imgs.each(function () {
                $(this).wrap('<p>');
            });

            // 处理文字
            for (i = 0; i < childrenLength; i++) {
                childNode = childNodes[i];
                if (childNode.nodeType === 3 && childNode.textContent && $.trim(childNode.textContent)) {
                    $(childNode).wrap('<p>');
                }
            }
        };

        // 清空内容为空的<p>，以及重复包裹的<p>（在windows下的chrome粘贴文字之后，会出现上述情况）
        Txt.fn.clearEmptyOrNestP = function () {
            var $txt = this.$txt;
            var $pList = $txt.find('p');

            $pList.each(function () {
                var $p = $(this);
                var $children = $p.children();
                var childrenLength = $children.length;
                var $firstChild;
                var content = $.trim($p.html());

                // 内容为空的p
                if (!content) {
                    $p.remove();
                    return;
                }

                // 嵌套的p
                if (childrenLength === 1) {
                    $firstChild = $children.first();
                    if ($firstChild.get(0) && $firstChild.get(0).nodeName === 'P') {
                        $p.html($firstChild.html());
                    }
                }
            });
        };

        // 获取 scrollTop
        Txt.fn.scrollTop = function (val) {
            var self = this;
            var editor = self.editor;
            var $txt = self.$txt;

            if (editor.useMaxHeight) {
                return $txt.parent().scrollTop(val);
            } else {
                return $txt.scrollTop(val);
            }
        };

        // 鼠标hover时候，显示p、head的高度
        Txt.fn.showHeightOnHover = function () {
            var editor = this.editor;
            var $editorContainer = editor.$editorContainer;
            var menuContainer = editor.menuContainer;
            var $txt = this.$txt;
            var $tip = $('<i class="height-tip"><i>');
            var isTipInTxt = false;

            function addAndShowTip($target) {
                if (!isTipInTxt) {
                    $editorContainer.append($tip);
                    isTipInTxt = true;
                }

                var txtTop = $txt.position().top;
                var txtHeight = $txt.outerHeight();

                var height = $target.height();
                var top = $target.position().top;
                var marginTop = parseInt($target.css('margin-top'), 10);
                var paddingTop = parseInt($target.css('padding-top'), 10);
                var marginBottom = parseInt($target.css('margin-bottom'), 10);
                var paddingBottom = parseInt($target.css('padding-bottom'), 10);

                // 计算初步的结果
                var resultHeight = height + paddingTop + marginTop + paddingBottom + marginBottom;
                var resultTop = top + menuContainer.height();

                // var spaceValue;

                // // 判断是否超出下边界
                // spaceValue = (resultTop + resultHeight) - (txtTop + txtHeight);
                // if (spaceValue > 0) {
                //     resultHeight = resultHeight - spaceValue;
                // }

                // // 判断是否超出了下边界
                // spaceValue = txtTop > resultTop;
                // if (spaceValue) {
                //     resultHeight = resultHeight - spaceValue;
                //     top = top + spaceValue;
                // }

                // 按照最终结果渲染
                $tip.css({
                    height: height + paddingTop + marginTop + paddingBottom + marginBottom,
                    top: top + menuContainer.height()
                });
            }
            function removeTip() {
                if (!isTipInTxt) {
                    return;
                }
                $tip.remove();
                isTipInTxt = false;
            }

            $txt.on('mouseenter', 'ul,ol,blockquote,p,h1,h2,h3,h4,h5,table,pre', function (e) {
                addAndShowTip($(e.currentTarget));
            }).on('mouseleave', function () {
                removeTip();
            });
        };
    });
    // 工具函数
    _e(function (E, $) {

        // IE8 [].indexOf()
        if (!Array.prototype.indexOf) {
            //IE低版本不支持 arr.indexOf
            Array.prototype.indexOf = function (elem) {
                var i = 0,
                    length = this.length;
                for (; i < length; i++) {
                    if (this[i] === elem) {
                        return i;
                    }
                }
                return -1;
            };
            //IE低版本不支持 arr.lastIndexOf
            Array.prototype.lastIndexOf = function (elem) {
                var length = this.length;
                for (length = length - 1; length >= 0; length--) {
                    if (this[length] === elem) {
                        return length;
                    }
                }
                return -1;
            };
        }

        // IE8 Date.now()
        if (!Date.now) {
            Date.now = function () {
                return new Date().valueOf();
            };
        }

        // console.log && console.warn && console.error
        var console = window.console;
        var emptyFn = function emptyFn() {};
        $.each(['info', 'log', 'warn', 'error'], function (key, value) {
            if (console == null) {
                E[value] = emptyFn;
            } else {
                E[value] = function (info) {
                    // 通过配置来控制打印输出
                    if (E.config && E.config.printLog) {
                        console[value]('wangEditor提示: ' + info);
                    }
                };
            }
        });

        // 获取随机数
        E.random = function () {
            return Math.random().toString().slice(2);
        };

        // 浏览器是否支持 placeholder
        E.placeholder = 'placeholder' in document.createElement('input');

        // 兼容IE8的 input placeholder
        E.placeholderForIE8 = function ($container) {
            if (E.placeholder) {
                return;
            }
            $container.find('input[placeholder]').each(function () {
                var $input = $(this);
                var placeholder = $input.attr('placeholder');

                if ($input.val() === '') {
                    $input.css('color', '#666');
                    $input.val(placeholder);

                    $input.on('focus.placeholder click.placeholder', function () {
                        $input.val('');
                        $input.css('color', '#333');
                        $input.off('focus.placeholder click.placeholder');
                    });
                }
            });
        };
    });
    // 语言包
    _e(function (E, $) {
        E.langs = {};

        // 中文
        E.langs['zh-cn'] = {
            bold: '粗体',
            underline: '下划线',
            italic: '斜体',
            forecolor: '文字颜色',
            bgcolor: '背景色',
            strikethrough: '删除线',
            eraser: '清空格式',
            source: '源码',
            quote: '引用',
            fontfamily: '字体',
            fontsize: '字号',
            head: '标题',
            orderlist: '有序列表',
            unorderlist: '无序列表',
            alignleft: '左对齐',
            aligncenter: '居中',
            alignright: '右对齐',
            link: '链接',
            text: '文本',
            submit: '提交',
            cancel: '取消',
            unlink: '取消链接',
            table: '表格',
            emotion: '表情',
            img: '图片',
            uploadImg: '上传图片',
            linkImg: '网络图片',
            video: '视频',
            'width': '宽',
            'height': '高',
            location: '位置',
            loading: '加载中',
            searchlocation: '搜索位置',
            dynamicMap: '动态地图',
            clearLocation: '清除位置',
            langDynamicOneLocation: '动态地图只能显示一个位置',
            insertcode: '插入代码',
            undo: '撤销',
            redo: '重复',
            fullscreen: '全屏',
            openLink: '打开链接'
        };

        // 英文
        E.langs.en = {
            bold: 'Bold',
            underline: 'Underline',
            italic: 'Italic',
            forecolor: 'Color',
            bgcolor: 'Backcolor',
            strikethrough: 'Strikethrough',
            eraser: 'Eraser',
            source: 'Codeview',
            quote: 'Quote',
            fontfamily: 'Font family',
            fontsize: 'Font size',
            head: 'Head',
            orderlist: 'Ordered list',
            unorderlist: 'Unordered list',
            alignleft: 'Align left',
            aligncenter: 'Align center',
            alignright: 'Align right',
            link: 'Insert link',
            text: 'Text',
            submit: 'Submit',
            cancel: 'Cancel',
            unlink: 'Unlink',
            table: 'Table',
            emotion: 'Emotions',
            img: 'Image',
            uploadImg: 'Upload',
            linkImg: 'Link',
            video: 'Video',
            'width': 'width',
            'height': 'height',
            location: 'Location',
            loading: 'Loading',
            searchlocation: 'search',
            dynamicMap: 'Dynamic',
            clearLocation: 'Clear',
            langDynamicOneLocation: 'Only one location in dynamic map',
            insertcode: 'Insert Code',
            undo: 'Undo',
            redo: 'Redo',
            fullscreen: 'Full screnn',
            openLink: 'open link'
        };
    });
    // 全局配置
    _e(function (E, $) {

        E.config = {};

        // 全屏时的 z-index
        E.config.zindex = 10000;

        // 是否打印log
        E.config.printLog = true;

        // 菜单吸顶：false - 不吸顶；number - 吸顶，值为top值
        E.config.menuFixed = 0;

        // 编辑源码时，过滤 javascript
        E.config.jsFilter = true;

        // 编辑器允许的标签
        E.config.legalTags = 'p,h1,h2,h3,h4,h5,h6,blockquote,table,ul,ol,pre';

        // 语言包
        E.config.lang = E.langs['zh-cn'];

        // 菜单配置
        E.config.menus = ['source', '|', 'bold', 'underline', 'italic', 'strikethrough', 'eraser', 'forecolor', 'bgcolor', '|', 'quote', 'fontfamily', 'fontsize', 'head', 'unorderlist', 'orderlist', 'alignleft', 'aligncenter', 'alignright', '|', 'link', 'unlink', 'table', 'emotion', '|', 'img', 'video', 'location', 'insertcode', '|', 'undo', 'redo', 'fullscreen'];

        // 颜色配置
        E.config.colors = {
            // 'value': 'title'
            '#880000': '暗红色',
            '#800080': '紫色',
            '#ff0000': '红色',
            '#ff00ff': '鲜粉色',
            '#000080': '深蓝色',
            '#0000ff': '蓝色',
            '#00ffff': '湖蓝色',
            '#008080': '蓝绿色',
            '#008000': '绿色',
            '#808000': '橄榄色',
            '#00ff00': '浅绿色',
            '#ffcc00': '橙黄色',
            '#808080': '灰色',
            '#c0c0c0': '银色',
            '#000000': '黑色',
            '#ffffff': '白色'
        };

        // 字体
        E.config.familys = ['宋体', '黑体', '楷体', '微软雅黑', 'Arial', 'Verdana', 'Georgia', 'Times New Roman', 'Microsoft JhengHei', 'Trebuchet MS', 'Courier New', 'Impact', 'Comic Sans MS', 'Consolas'];

        // 字号
        E.config.fontsizes = {
            // 格式：'value': 'title'
            1: '12px',
            2: '13px',
            3: '16px',
            4: '18px',
            5: '24px',
            6: '32px',
            7: '48px'
        };

        // 表情包
        E.config.emotionsShow = 'icon'; // 显示项，默认为'icon'，也可以配置成'value'
        E.config.emotions = {
            // 'default': {
            //     title: '默认',
            //     data: './emotions.data'
            // },
            'weibo': {
                title: '微博表情',
                data: [{
                    icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/7a/shenshou_thumb.gif',
                    value: '[草泥马]'
                }, {
                    icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/60/horse2_thumb.gif',
                    value: '[神马]'
                }, {
                    icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/bc/fuyun_thumb.gif',
                    value: '[浮云]'
                }, {
                    icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/c9/geili_thumb.gif',
                    value: '[给力]'
                }, {
                    icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/f2/wg_thumb.gif',
                    value: '[围观]'
                }, {
                    icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/70/vw_thumb.gif',
                    value: '[威武]'
                }, {
                    icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/6e/panda_thumb.gif',
                    value: '[熊猫]'
                }, {
                    icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/81/rabbit_thumb.gif',
                    value: '[兔子]'
                }, {
                    icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/bc/otm_thumb.gif',
                    value: '[奥特曼]'
                }, {
                    icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/15/j_thumb.gif',
                    value: '[囧]'
                }, {
                    icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/89/hufen_thumb.gif',
                    value: '[互粉]'
                }, {
                    icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/c4/liwu_thumb.gif',
                    value: '[礼物]'
                }, {
                    icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/ac/smilea_thumb.gif',
                    value: '[呵呵]'
                }, {
                    icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/0b/tootha_thumb.gif',
                    value: '[哈哈]'
                }]
            }
        };

        // 百度地图的key
        // E.config.mapAk = '';

        // 上传图片的配置
        // server地址
        E.config.uploadImgUrl = '';
        // 超时时间
        E.config.uploadTimeout = 20 * 1000;
        // 用于存储上传回调事件
        E.config.uploadImgFns = {};
        // 自定义上传图片的filename
        // E.config.uploadImgFileName = 'customFileName';

        // 自定义上传，设置为 true 之后，显示上传图标
        E.config.customUpload = false;
        // 自定义上传的init事件
        // E.config.customUploadInit = function () {....};

        // 自定义上传时传递的参数（如 token）
        E.config.uploadParams = {
            /* token: 'abcdef12345' */
        };

        // 自定义上传是的header参数
        E.config.uploadHeaders = {
            /* 'Accept' : 'text/x-json' */
        };

        // 跨域上传时传递 cookie，默认为 true
        E.config.withCredentials = true;

        // 隐藏网络图片，默认为 false
        E.config.hideLinkImg = false;

        // 是否过滤粘贴内容
        E.config.pasteFilter = true;

        // 是否粘贴纯文本，当 editor.config.pasteFilter === false 时候，此配置将失效
        E.config.pasteText = false;

        // 插入代码时，默认的语言
        E.config.codeDefaultLang = 'javascript';
    });
    // 全局UI
    _e(function (E, $) {

        E.UI = {};

        // 为菜单自定义配置的UI
        E.UI.menus = {
            // 这个 default 不加引号，在 IE8 会报错
            'default': {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-command"></i></a>',
                selected: '.selected'
            },
            bold: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-bold"></i></a>',
                selected: '.selected'
            },
            underline: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-underline"></i></a>',
                selected: '.selected'
            },
            italic: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-italic"></i></a>',
                selected: '.selected'
            },
            forecolor: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-pencil"></i></a>',
                selected: '.selected'
            },
            bgcolor: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-brush"></i></a>',
                selected: '.selected'
            },
            strikethrough: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-strikethrough"></i></a>',
                selected: '.selected'
            },
            eraser: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-eraser"></i></a>',
                selected: '.selected'
            },
            quote: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-quotes-left"></i></a>',
                selected: '.selected'
            },
            source: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-code"></i></a>',
                selected: '.selected'
            },
            fontfamily: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-font2"></i></a>',
                selected: '.selected'
            },
            fontsize: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-text-height"></i></a>',
                selected: '.selected'
            },
            head: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-header"></i></a>',
                selected: '.selected'
            },
            orderlist: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-list-numbered"></i></a>',
                selected: '.selected'
            },
            unorderlist: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-list-bullet"></i></a>',
                selected: '.selected'
            },
            alignleft: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-align-left"></i></a>',
                selected: '.selected'
            },
            aligncenter: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-align-center"></i></a>',
                selected: '.selected'
            },
            alignright: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-align-right"></i></a>',
                selected: '.selected'
            },
            link: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-link"></i></a>',
                selected: '.selected'
            },
            unlink: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-unlink"></i></a>',
                selected: '.selected'
            },
            table: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-table"></i></a>',
                selected: '.selected'
            },
            emotion: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-happy"></i></a>',
                selected: '.selected'
            },
            img: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-picture"></i></a>',
                selected: '.selected'
            },
            video: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-play"></i></a>',
                selected: '.selected'
            },
            location: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-location"></i></a>',
                selected: '.selected'
            },
            insertcode: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-terminal"></i></a>',
                selected: '.selected'
            },
            undo: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-ccw"></i></a>',
                selected: '.selected'
            },
            redo: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-cw"></i></a>',
                selected: '.selected'
            },
            fullscreen: {
                normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-enlarge2"></i></a>',
                selected: '<a href="#" tabindex="-1" class="selected"><i class="wangeditor-menu-img-shrink2"></i></a>'
            }
        };
    });
    // 对象配置
    _e(function (E, $) {

        E.fn.initDefaultConfig = function () {
            var editor = this;
            editor.config = $.extend({}, E.config);
            editor.UI = $.extend({}, E.UI);
        };
    });
    // 增加 container
    _e(function (E, $) {

        E.fn.addEditorContainer = function () {
            this.$editorContainer = $('<div class="wangEditor-container"></div>');
        };
    });
    // 增加编辑区域对象
    _e(function (E, $) {

        E.fn.addTxt = function () {
            var editor = this;
            var txt = new E.Txt(editor);

            editor.txt = txt;
        };
    });
    // 增加menuContainer对象
    _e(function (E, $) {

        E.fn.addMenuContainer = function () {
            var editor = this;
            editor.menuContainer = new E.MenuContainer(editor);
        };
    });
    // 增加menus
    _e(function (E, $) {

        // 存储创建菜单的函数
        E.createMenuFns = [];
        E.createMenu = function (fn) {
            E.createMenuFns.push(fn);
        };

        // 创建所有菜单
        E.fn.addMenus = function () {
            var editor = this;
            var menuIds = editor.config.menus;

            // 检验 menuId 是否在配置中存在
            function check(menuId) {
                if (menuIds.indexOf(menuId) >= 0) {
                    return true;
                }
                return false;
            }

            // 遍历所有的菜单创建函数，并执行
            $.each(E.createMenuFns, function (k, createMenuFn) {
                createMenuFn.call(editor, check);
            });
        };
    });
    // bold菜单
    _e(function (E, $) {

        E.createMenu(function (check) {
            var menuId = 'bold';
            if (!check(menuId)) {
                return;
            }

            var editor = this;
            var lang = editor.config.lang;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.bold,
                commandName: 'Bold'
            });

            // 定义选中状态下的click事件
            menu.clickEventSelected = function (e) {
                var isRangeEmpty = editor.isRangeEmpty();
                if (!isRangeEmpty) {
                    // 如果选区有内容，则执行基础命令
                    editor.command(e, 'Bold');
                } else {
                    // 如果选区没有内容
                    editor.commandForElem('b,strong,h1,h2,h3,h4,h5', e, 'Bold');
                }
            };

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // underline菜单
    _e(function (E, $) {

        E.createMenu(function (check) {
            var menuId = 'underline';
            if (!check(menuId)) {
                return;
            }

            var editor = this;
            var lang = editor.config.lang;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.underline,
                commandName: 'Underline'
            });

            // 定义选中状态下的click事件
            menu.clickEventSelected = function (e) {
                var isRangeEmpty = editor.isRangeEmpty();
                if (!isRangeEmpty) {
                    // 如果选区有内容，则执行基础命令
                    editor.command(e, 'Underline');
                } else {
                    // 如果选区没有内容
                    editor.commandForElem('u,a', e, 'Underline');
                }
            };

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // italic 菜单
    _e(function (E, $) {

        E.createMenu(function (check) {
            var menuId = 'italic';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var lang = editor.config.lang;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.italic,
                commandName: 'Italic'
            });

            // 定义选中状态下的click事件
            menu.clickEventSelected = function (e) {
                var isRangeEmpty = editor.isRangeEmpty();
                if (!isRangeEmpty) {
                    // 如果选区有内容，则执行基础命令
                    editor.command(e, 'Italic');
                } else {
                    // 如果选区没有内容
                    editor.commandForElem('i', e, 'Italic');
                }
            };

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // forecolor 菜单
    _e(function (E, $) {

        E.createMenu(function (check) {
            var menuId = 'forecolor';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var lang = editor.config.lang;
            var configColors = editor.config.colors;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.forecolor
            });

            // 创建 dropPanel
            var $content = $('<div></div>');
            $.each(configColors, function (k, v) {
                $content.append(['<a href="#" class="color-item"', '    title="' + v + '" commandValue="' + k + '" ', '    style="color: ' + k + '" ', '><i class="wangeditor-menu-img-pencil"></i></a>'].join(''));
            });
            $content.on('click', 'a[commandValue]', function (e) {
                // 执行命令
                var $elem = $(this);
                var commandValue = $elem.attr('commandValue');

                if (menu.selected && editor.isRangeEmpty()) {
                    // 当前处于选中状态，并且选中内容为空
                    editor.commandForElem('font[color]', e, 'forecolor', commandValue);
                } else {
                    // 当前未处于选中状态，或者有选中内容。则执行默认命令
                    editor.command(e, 'forecolor', commandValue);
                }
            });
            menu.dropPanel = new E.DropPanel(editor, menu, {
                $content: $content,
                width: 125
            });

            // 定义 update selected 事件
            menu.updateSelectedEvent = function () {
                var rangeElem = editor.getRangeElem();
                rangeElem = editor.getSelfOrParentByName(rangeElem, 'font[color]');
                if (rangeElem) {
                    return true;
                }
                return false;
            };

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // bgcolor 菜单
    _e(function (E, $) {

        E.createMenu(function (check) {
            var menuId = 'bgcolor';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var lang = editor.config.lang;
            var configColors = editor.config.colors;

            // 检查元素是否有 background-color: 内联样式
            function checkElemFn(elem) {
                var cssText;
                if (elem && elem.style && elem.style.cssText != null) {
                    cssText = elem.style.cssText;
                    if (cssText && cssText.indexOf('background-color:') >= 0) {
                        return true;
                    }
                }
                return false;
            }

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.bgcolor
            });

            // 创建 dropPanel
            var $content = $('<div></div>');
            $.each(configColors, function (k, v) {
                $content.append(['<a href="#" class="color-item"', '    title="' + v + '" commandValue="' + k + '" ', '    style="color: ' + k + '" ', '><i class="wangeditor-menu-img-brush"></i></a>'].join(''));
            });
            $content.on('click', 'a[commandValue]', function (e) {
                // 执行命令

                var $elem = $(this);
                var commandValue = $elem.attr('commandValue');

                if (menu.selected && editor.isRangeEmpty()) {
                    // 当前处于选中状态，并且选中内容为空。使用 commandForElem 执行命令
                    editor.commandForElem({
                        selector: 'span,font',
                        check: checkElemFn
                    }, e, 'BackColor', commandValue);
                } else {
                    // 当前未处于选中状态，或者有选中内容。则执行默认命令
                    editor.command(e, 'BackColor', commandValue);
                }
            });
            menu.dropPanel = new E.DropPanel(editor, menu, {
                $content: $content,
                width: 125
            });

            // 定义 update selected 事件
            menu.updateSelectedEvent = function () {
                var rangeElem = editor.getRangeElem();
                rangeElem = editor.getSelfOrParentByName(rangeElem, 'span,font', checkElemFn);

                if (rangeElem) {
                    return true;
                }
                return false;
            };

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // strikethrough 菜单
    _e(function (E, $) {

        E.createMenu(function (check) {
            var menuId = 'strikethrough';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var lang = editor.config.lang;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.strikethrough,
                commandName: 'StrikeThrough'
            });

            // 定义选中状态下的click事件
            menu.clickEventSelected = function (e) {
                var isRangeEmpty = editor.isRangeEmpty();
                if (!isRangeEmpty) {
                    // 如果选区有内容，则执行基础命令
                    editor.command(e, 'StrikeThrough');
                } else {
                    // 如果选区没有内容
                    editor.commandForElem('strike', e, 'StrikeThrough');
                }
            };

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // eraser 菜单
    _e(function (E, $) {

        E.createMenu(function (check) {
            var menuId = 'eraser';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var lang = editor.config.lang;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.eraser,
                commandName: 'RemoveFormat'
            });

            // 定义点击事件
            menu.clickEvent = function (e) {
                var isRangeEmpty = editor.isRangeEmpty();

                if (!isRangeEmpty) {
                    // 选区不是空的，则执行默认命令
                    editor.command(e, 'RemoveFormat');
                    return;
                }

                var $clearElem;

                // 自定义的命令函数
                function commandFn() {
                    var editor = this;
                    var rangeElem;
                    var pElem, $pElem;
                    var quoteElem, $quoteElem;
                    var listElem, $listElem;

                    // 获取选区 elem
                    rangeElem = editor.getRangeElem();
                    // 第一步，获取 quote 父元素
                    quoteElem = editor.getSelfOrParentByName(rangeElem, 'blockquote');
                    if (quoteElem) {
                        $quoteElem = $(quoteElem);
                        $clearElem = $('<p>' + $quoteElem.text() + '</p>');
                        $quoteElem.after($clearElem).remove();
                    }
                    // 第二步，获取 p h 父元素
                    pElem = editor.getSelfOrParentByName(rangeElem, 'p,h1,h2,h3,h4,h5');
                    if (pElem) {
                        $pElem = $(pElem);
                        $clearElem = $('<p>' + $pElem.text() + '</p>');
                        $pElem.after($clearElem).remove();
                    }
                    // 第三步，获取list
                    listElem = editor.getSelfOrParentByName(rangeElem, 'ul,ol');
                    if (listElem) {
                        $listElem = $(listElem);
                        $clearElem = $('<p>' + $listElem.text() + '</p>');
                        $listElem.after($clearElem).remove();
                    }
                }

                // 自定义 callback 事件
                function callback() {
                    // callback中，设置range为clearElem
                    var editor = this;
                    if ($clearElem) {
                        editor.restoreSelectionByElem($clearElem.get(0));
                    }
                }

                // 执行自定义命令
                editor.customCommand(e, commandFn, callback);
            };

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // source 菜单
    _e(function (E, $) {

        E.createMenu(function (check) {
            var menuId = 'source';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var lang = editor.config.lang;
            var txtHtml;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.source
            });

            menu.isShowCode = false;

            // 更新内容
            function updateValue() {
                var $code = menu.$codeTextarea;
                var $txt = editor.txt.$txt;
                var value = $.trim($code.val()); // 取值

                if (!value) {
                    value = '<p><br></p>';
                }

                // 过滤js代码
                if (editor.config.jsFilter) {

                    value = value.replace(/<script[\s\S]*?<\/script>/ig, '');
                }
                // 赋值
                try {
                    $txt.html(value);
                } catch (ex) {
                    // 更新 html 源码出错，一般都是取消了 js 过滤之后，js报错导致的
                }
            }

            // 定义click事件
            menu.clickEvent = function (e) {
                var self = this;
                var editor = self.editor;
                var $txt = editor.txt.$txt;
                var txtOuterHeight = $txt.outerHeight();
                var txtHeight = $txt.height();

                if (!self.$codeTextarea) {
                    self.$codeTextarea = $('<textarea class="code-textarea"></textarea>');
                }
                var $code = self.$codeTextarea;
                $code.css({
                    height: txtHeight,
                    'margin-top': txtOuterHeight - txtHeight
                });

                // 赋值
                $code.val($txt.html());

                // 监控变化
                $code.on('change', function (e) {
                    updateValue();
                });

                // 渲染
                $txt.after($code).hide();
                $code.show();

                // 更新状态
                menu.isShowCode = true;

                // 执行 updateSelected 事件
                this.updateSelected();

                // 禁用其他菜单
                editor.disableMenusExcept('source');

                // 记录当前html值
                txtHtml = $txt.html();
            };

            // 定义选中状态下的click事件
            menu.clickEventSelected = function (e) {
                var self = this;
                var editor = self.editor;
                var $txt = editor.txt.$txt;
                var $code = self.$codeTextarea;
                var value;

                if (!$code) {
                    return;
                }

                // 更新内容
                updateValue();

                // 渲染
                $code.after($txt).hide();
                $txt.show();

                // 更新状态
                menu.isShowCode = false;

                // 执行 updateSelected 事件
                this.updateSelected();

                // 启用其他菜单
                editor.enableMenusExcept('source');

                // 判断是否执行 onchange 事件
                if ($txt.html() !== txtHtml) {
                    if (editor.onchange && typeof editor.onchange === 'function') {
                        editor.onchange.call(editor);
                    }
                }
            };

            // 定义切换选中状态事件
            menu.updateSelectedEvent = function () {
                return this.isShowCode;
            };

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // quote 菜单
    _e(function (E, $) {

        E.createMenu(function (check) {
            var menuId = 'quote';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var lang = editor.config.lang;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.quote,
                commandName: 'formatBlock',
                commandValue: 'blockquote'
            });

            // 定义click事件
            menu.clickEvent = function (e) {
                var rangeElem = editor.getRangeElem();
                var $rangeElem;
                if (!rangeElem) {
                    e.preventDefault();
                    return;
                }
                var currentQuote = editor.getSelfOrParentByName(rangeElem, 'blockquote');
                var $quote;

                if (currentQuote) {
                    // 说明当前在quote之内，不做任何处理
                    e.preventDefault();
                    return;
                }

                rangeElem = editor.getLegalTags(rangeElem);
                $rangeElem = $(rangeElem);

                // 无文字，则不允许执行引用
                if (!$rangeElem.text()) {
                    return;
                }

                if (!rangeElem) {
                    // 执行默认命令
                    // IE8 下执行此处（不过，经测试代码无效，也不报错）
                    editor.command(e, 'formatBlock', 'blockquote');
                    return;
                }

                // 自定义command事件
                function commandFn() {
                    $quote = $('<p>' + $rangeElem.text() + '</p>');
                    $rangeElem.after($quote).remove();
                    $quote.wrap('<blockquote>');
                }

                // 自定义 callback 事件
                function callback() {
                    // callback中，设置range为quote
                    var editor = this;
                    if ($quote) {
                        editor.restoreSelectionByElem($quote.get(0));
                    }
                }

                // 执行自定义命令
                editor.customCommand(e, commandFn, callback);
            };

            // 定义选中状态下的click事件
            menu.clickEventSelected = function (e) {
                var rangeElem;
                var quoteElem;
                var $lastChild;

                // 获取当前选区的elem，并试图往上找 quote 元素
                rangeElem = editor.getRangeElem();
                quoteElem = editor.getSelfOrParentByName(rangeElem, 'blockquote');
                if (!quoteElem) {
                    // 没找到，则返回
                    e.preventDefault();
                    return;
                }

                // 自定义的command事件
                function commandFn() {
                    var $quoteElem;
                    var $children;

                    $quoteElem = $(quoteElem);
                    $children = $quoteElem.children();
                    if ($children.length) {
                        $children.each(function (k) {
                            var $item = $(this);
                            if ($item.get(0).nodeName === 'P') {
                                $quoteElem.after($item);
                            } else {
                                $quoteElem.after('<p>' + $item.text() + '</p>');
                            }
                            $lastChild = $item; // 记录最后一个子元素，用于callback中的range定位
                        });
                        $quoteElem.remove();
                        return;
                    }
                }

                // 自定义的callback函数
                function callback() {
                    // callback中，设置range为lastChild
                    var editor = this;
                    if ($lastChild) {
                        editor.restoreSelectionByElem($lastChild.get(0));
                    }
                }

                // 执行自定义命令
                editor.customCommand(e, commandFn, callback);
            };

            // 定义更新选中状态的事件
            menu.updateSelectedEvent = function () {
                var self = this; //菜单对象
                var editor = self.editor;
                var rangeElem;

                rangeElem = editor.getRangeElem();
                rangeElem = editor.getSelfOrParentByName(rangeElem, 'blockquote');

                if (rangeElem) {
                    return true;
                }

                return false;
            };

            // 增加到editor对象中
            editor.menus[menuId] = menu;

            // --------------- 两次点击 enter 跳出引用 ---------------
            editor.ready(function () {
                var editor = this;
                var $txt = editor.txt.$txt;
                var isPrevEnter = false; // 是不是刚刚在quote中按了 enter 键
                $txt.on('keydown', function (e) {
                    if (e.keyCode !== 13) {
                        // 不是 enter 键
                        isPrevEnter = false;
                        return;
                    }

                    var rangeElem = editor.getRangeElem();
                    rangeElem = editor.getSelfOrParentByName(rangeElem, 'blockquote');
                    if (!rangeElem) {
                        // 选区不是 quote
                        isPrevEnter = false;
                        return;
                    }

                    if (!isPrevEnter) {
                        // 最近没有在qote中按enter键
                        isPrevEnter = true;
                        return;
                    }

                    var currentRangeElem = editor.getRangeElem();
                    var $currentRangeElem = $(currentRangeElem);
                    if ($currentRangeElem.length) {
                        $currentRangeElem.parent().after($currentRangeElem);
                    }

                    // 设置选区
                    editor.restoreSelectionByElem(currentRangeElem, 'start');

                    isPrevEnter = false;
                    // 阻止默认行文
                    e.preventDefault();
                });
            }); // editor.ready(

            // --------------- 处理quote中无内容时不能删除的问题 ---------------
            editor.ready(function () {
                var editor = this;
                var $txt = editor.txt.$txt;
                var $rangeElem;

                function commandFn() {
                    $rangeElem && $rangeElem.remove();
                }
                function callback() {
                    if (!$rangeElem) {
                        return;
                    }
                    var $prev = $rangeElem.prev();
                    if ($prev.length) {
                        // 有 prev 则定位到 prev 最后
                        editor.restoreSelectionByElem($prev.get(0));
                    } else {
                        // 无 prev 则初始化选区
                        editor.initSelection();
                    }
                }

                $txt.on('keydown', function (e) {
                    if (e.keyCode !== 8) {
                        // 不是 backspace 键
                        return;
                    }

                    var rangeElem = editor.getRangeElem();
                    rangeElem = editor.getSelfOrParentByName(rangeElem, 'blockquote');
                    if (!rangeElem) {
                        // 选区不是 quote
                        return;
                    }
                    $rangeElem = $(rangeElem);

                    var text = $rangeElem.text();
                    if (text) {
                        // quote 中还有内容
                        return;
                    }
                    editor.customCommand(e, commandFn, callback);
                }); // $txt.on
            }); // editor.ready(
        });
    });
    // 字体 菜单
    _e(function (E, $) {

        E.createMenu(function (check) {
            var menuId = 'fontfamily';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var lang = editor.config.lang;
            var configFamilys = editor.config.familys;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.fontfamily,
                commandName: 'fontName'
            });

            // 初始化数据
            var data = {};
            /*
                data 需要的结构
                {
                    'commandValue': 'title'
                    ...
                }
            */
            $.each(configFamilys, function (k, v) {
                // configFamilys 是数组，data 是对象
                data[v] = v;
            });

            // 创建droplist
            var tpl = '<span style="font-family:{#commandValue};">{#title}</span>';
            menu.dropList = new E.DropList(editor, menu, {
                data: data,
                tpl: tpl,
                selectorForELemCommand: 'font[face]' // 为了执行 editor.commandForElem 而传入的elem查询方式
            });

            // 定义 update selected 事件
            menu.updateSelectedEvent = function () {
                var rangeElem = editor.getRangeElem();
                rangeElem = editor.getSelfOrParentByName(rangeElem, 'font[face]');
                if (rangeElem) {
                    return true;
                }
                return false;
            };

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // 字号 菜单
    _e(function (E, $) {
        E.createMenu(function (check) {
            var menuId = 'fontsize';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var lang = editor.config.lang;
            var configSize = editor.config.fontsizes;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.fontsize,
                commandName: 'fontSize'
            });

            // 初始化数据
            var data = configSize;
            /*
                data 需要的结构
                {
                    'commandValue': 'title'
                    ...
                }
            */

            // 创建droplist
            var tpl = '<span style="font-size:{#title};">{#title}</span>';
            menu.dropList = new E.DropList(editor, menu, {
                data: data,
                tpl: tpl,
                selectorForELemCommand: 'font[size]' // 为了执行 editor.commandForElem 而传入的elem查询方式
            });

            // 定义 update selected 事件
            menu.updateSelectedEvent = function () {
                var rangeElem = editor.getRangeElem();
                rangeElem = editor.getSelfOrParentByName(rangeElem, 'font[size]');
                if (rangeElem) {
                    return true;
                }
                return false;
            };

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // head 菜单
    _e(function (E, $) {
        E.createMenu(function (check) {
            var menuId = 'head';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var lang = editor.config.lang;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.head,
                commandName: 'formatBlock'
            });

            // 初始化数据
            var data = {
                '<h1>': '标题1',
                '<h2>': '标题2',
                '<h3>': '标题3',
                '<h4>': '标题4',
                '<h5>': '标题5'
            };
            /*
                data 需要的结构
                {
                    'commandValue': 'title'
                    ...
                }
            */

            var isOrderedList;
            function beforeEvent(e) {
                if (editor.queryCommandState('InsertOrderedList')) {
                    isOrderedList = true;

                    // 先取消有序列表
                    editor.command(e, 'InsertOrderedList');
                } else {
                    isOrderedList = false;
                }
            }

            function afterEvent(e) {
                if (isOrderedList) {
                    // 再设置有序列表
                    editor.command(e, 'InsertOrderedList');
                }
            }

            // 创建droplist
            var tpl = '{#commandValue}{#title}';
            menu.dropList = new E.DropList(editor, menu, {
                data: data,
                tpl: tpl,
                // 对 ol 直接设置 head，会出现每个 li 的 index 都变成 1 的问题，因此要先取消 ol，然后设置 head，最后再增加上 ol
                beforeEvent: beforeEvent,
                afterEvent: afterEvent
            });

            // 定义 update selected 事件
            menu.updateSelectedEvent = function () {
                var rangeElem = editor.getRangeElem();
                rangeElem = editor.getSelfOrParentByName(rangeElem, 'h1,h2,h3,h4,h5');
                if (rangeElem) {
                    return true;
                }
                return false;
            };

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // unorderlist 菜单
    _e(function (E, $) {

        E.createMenu(function (check) {
            var menuId = 'unorderlist';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var lang = editor.config.lang;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.unorderlist,
                commandName: 'InsertUnorderedList'
            });

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // orderlist 菜单
    _e(function (E, $) {

        E.createMenu(function (check) {
            var menuId = 'orderlist';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var lang = editor.config.lang;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.orderlist,
                commandName: 'InsertOrderedList'
            });

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // alignleft 菜单
    _e(function (E, $) {

        E.createMenu(function (check) {
            var menuId = 'alignleft';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var lang = editor.config.lang;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.alignleft,
                commandName: 'JustifyLeft'
            });

            // 定义 update selected 事件
            menu.updateSelectedEvent = function () {
                var rangeElem = editor.getRangeElem();
                rangeElem = editor.getSelfOrParentByName(rangeElem, 'p,h1,h2,h3,h4,h5,li', function (elem) {
                    var cssText;
                    if (elem && elem.style && elem.style.cssText != null) {
                        cssText = elem.style.cssText;
                        if (cssText && /text-align:\s*left;/.test(cssText)) {
                            return true;
                        }
                    }
                    if ($(elem).attr('align') === 'left') {
                        // ff 中，设置align-left之后，会是 <p align="left">xxx</p>
                        return true;
                    }
                    return false;
                });
                if (rangeElem) {
                    return true;
                }
                return false;
            };

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // aligncenter 菜单
    _e(function (E, $) {

        E.createMenu(function (check) {
            var menuId = 'aligncenter';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var lang = editor.config.lang;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.aligncenter,
                commandName: 'JustifyCenter'
            });

            // 定义 update selected 事件
            menu.updateSelectedEvent = function () {
                var rangeElem = editor.getRangeElem();
                rangeElem = editor.getSelfOrParentByName(rangeElem, 'p,h1,h2,h3,h4,h5,li', function (elem) {
                    var cssText;
                    if (elem && elem.style && elem.style.cssText != null) {
                        cssText = elem.style.cssText;
                        if (cssText && /text-align:\s*center;/.test(cssText)) {
                            return true;
                        }
                    }
                    if ($(elem).attr('align') === 'center') {
                        // ff 中，设置align-center之后，会是 <p align="center">xxx</p>
                        return true;
                    }
                    return false;
                });
                if (rangeElem) {
                    return true;
                }
                return false;
            };

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // alignright 菜单
    _e(function (E, $) {

        E.createMenu(function (check) {
            var menuId = 'alignright';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var lang = editor.config.lang;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.alignright,
                commandName: 'JustifyRight'
            });

            // 定义 update selected 事件
            menu.updateSelectedEvent = function () {
                var rangeElem = editor.getRangeElem();
                rangeElem = editor.getSelfOrParentByName(rangeElem, 'p,h1,h2,h3,h4,h5,li', function (elem) {
                    var cssText;
                    if (elem && elem.style && elem.style.cssText != null) {
                        cssText = elem.style.cssText;
                        if (cssText && /text-align:\s*right;/.test(cssText)) {
                            return true;
                        }
                    }
                    if ($(elem).attr('align') === 'right') {
                        // ff 中，设置align-right之后，会是 <p align="right">xxx</p>
                        return true;
                    }
                    return false;
                });
                if (rangeElem) {
                    return true;
                }
                return false;
            };

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // link 菜单
    _e(function (E, $) {

        E.createMenu(function (check) {
            var menuId = 'link';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var lang = editor.config.lang;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.link
            });

            // 创建 dropPanel
            var $content = $('<div></div>');
            var $div1 = $('<div style="margin:20px 10px;" class="clearfix"></div>');
            var $div2 = $div1.clone();
            var $div3 = $div1.clone().css('margin', '0 10px');
            var $textInput = $('<input type="text" class="block" placeholder="' + lang.text + '"/>');
            var $urlInput = $('<input type="text" class="block" placeholder="' + lang.link + '"/>');
            var $btnSubmit = $('<button class="right">' + lang.submit + '</button>');
            var $btnCancel = $('<button class="right gray">' + lang.cancel + '</button>');

            $div1.append($textInput);
            $div2.append($urlInput);
            $div3.append($btnSubmit).append($btnCancel);
            $content.append($div1).append($div2).append($div3);

            menu.dropPanel = new E.DropPanel(editor, menu, {
                $content: $content,
                width: 300
            });

            // 定义click事件
            menu.clickEvent = function (e) {
                var menu = this;
                var dropPanel = menu.dropPanel;

                // -------------隐藏----------------
                if (dropPanel.isShowing) {
                    dropPanel.hide();
                    return;
                }

                // -------------显示----------------

                // 重置 input
                $textInput.val('');
                $urlInput.val('http://');

                // 获取url
                var url = '';
                var rangeElem = editor.getRangeElem();
                rangeElem = editor.getSelfOrParentByName(rangeElem, 'a');
                if (rangeElem) {
                    url = rangeElem.href || '';
                }

                // 获取 text
                var text = '';
                var isRangeEmpty = editor.isRangeEmpty();
                if (!isRangeEmpty) {
                    // 选区不是空
                    text = editor.getRangeText() || '';
                } else if (rangeElem) {
                    // 如果选区空，并且在 a 标签之内
                    text = rangeElem.textContent || rangeElem.innerHTML;
                }

                // 设置 url 和 text
                url && $urlInput.val(url);
                text && $textInput.val(text);

                // 如果有选区内容，textinput 不能修改
                if (!isRangeEmpty) {
                    $textInput.attr('disabled', true);
                } else {
                    $textInput.removeAttr('disabled');
                }

                // 显示（要设置好了所有input的值和属性之后再显示）
                dropPanel.show();
            };

            // 定义 update selected 事件
            menu.updateSelectedEvent = function () {
                var rangeElem = editor.getRangeElem();
                rangeElem = editor.getSelfOrParentByName(rangeElem, 'a');
                if (rangeElem) {
                    return true;
                }
                return false;
            };

            // 『取消』 按钮
            $btnCancel.click(function (e) {
                e.preventDefault();
                menu.dropPanel.hide();
            });

            // 『确定』按钮
            $btnSubmit.click(function (e) {
                e.preventDefault();
                var rangeElem = editor.getRangeElem();
                var targetElem = editor.getSelfOrParentByName(rangeElem, 'a');
                var isRangeEmpty = editor.isRangeEmpty();

                var $linkElem, linkHtml;
                var commandFn, callback;
                var $txt = editor.txt.$txt;
                var $oldLinks, $newLinks;
                var uniqId = 'link' + E.random();

                // 获取数据
                var url = $.trim($urlInput.val());
                var text = $.trim($textInput.val());

                if (!url) {
                    menu.dropPanel.focusFirstInput();
                    return;
                }
                if (!text) {
                    text = url;
                }

                if (!isRangeEmpty) {
                    // 选中区域有内容，则执行默认命令

                    // 获取目前 txt 内所有链接，并为当前链接做一个标记
                    $oldLinks = $txt.find('a');
                    $oldLinks.attr(uniqId, '1');

                    // 执行命令
                    editor.command(e, 'createLink', url);

                    // 去的没有标记的链接，即刚刚插入的链接
                    $newLinks = $txt.find('a').not('[' + uniqId + ']');
                    $newLinks.attr('target', '_blank'); // 增加 _blank

                    // 去掉之前做的标记
                    $oldLinks.removeAttr(uniqId);
                } else if (targetElem) {
                    // 无选中区域，在 a 标签之内，修改该 a 标签的内容和链接
                    $linkElem = $(targetElem);
                    commandFn = function commandFn() {
                        $linkElem.attr('href', url);
                        $linkElem.text(text);
                    };
                    callback = function callback() {
                        var editor = this;
                        editor.restoreSelectionByElem(targetElem);
                    };
                    // 执行命令
                    editor.customCommand(e, commandFn, callback);
                } else {
                    // 无选中区域，不在 a 标签之内，插入新的链接

                    linkHtml = '<a href="' + url + '" target="_blank">' + text + '</a>';
                    if (E.userAgent.indexOf('Firefox') > 0) {
                        linkHtml += '<span>&nbsp;</span>';
                    }
                    editor.command(e, 'insertHtml', linkHtml);
                }
            });

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // unlink 菜单
    _e(function (E, $) {

        E.createMenu(function (check) {
            var menuId = 'unlink';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var lang = editor.config.lang;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.unlink,
                commandName: 'unLink'
            });

            // click 事件
            menu.clickEvent = function (e) {
                var isRangeEmpty = editor.isRangeEmpty();
                if (!isRangeEmpty) {
                    // 有选中区域，或者IE8，执行默认命令
                    editor.command(e, 'unLink');
                    return;
                }

                // 无选中区域...

                var rangeElem = editor.getRangeElem();
                var aElem = editor.getSelfOrParentByName(rangeElem, 'a');
                if (!aElem) {
                    // 不在 a 之内，返回
                    e.preventDefault();
                    return;
                }

                // 在 a 之内
                var $a = $(aElem);
                var $span = $('<span>' + $a.text() + '</span>');
                function commandFn() {
                    $a.after($span).remove();
                }
                function callback() {
                    editor.restoreSelectionByElem($span.get(0));
                }
                editor.customCommand(e, commandFn, callback);
            };

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // table 菜单
    _e(function (E, $) {

        E.createMenu(function (check) {
            var menuId = 'table';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var lang = editor.config.lang;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.table
            });

            // dropPanel 内容
            var $content = $('<div style="font-size: 14px; color: #666; text-align:right;"></div>');
            var $table = $('<table class="choose-table" style="margin-bottom:10px;margin-top:5px;">');
            var $row = $('<span>0</span>');
            var $rowspan = $('<span> 行 </span>');
            var $col = $('<span>0</span>');
            var $colspan = $('<span> 列</span>');
            var $tr;
            var i, j;

            // 创建一个n行n列的表格
            for (i = 0; i < 15; i++) {
                $tr = $('<tr index="' + (i + 1) + '">');
                for (j = 0; j < 20; j++) {
                    $tr.append($('<td index="' + (j + 1) + '">'));
                }
                $table.append($tr);
            }
            $content.append($table);
            $content.append($row).append($rowspan).append($col).append($colspan);

            // 定义table事件
            $table.on('mouseenter', 'td', function (e) {
                var $currentTd = $(e.currentTarget);
                var currentTdIndex = $currentTd.attr('index');
                var $currentTr = $currentTd.parent();
                var currentTrIndex = $currentTr.attr('index');

                // 显示
                $row.text(currentTrIndex);
                $col.text(currentTdIndex);

                // 遍历设置背景颜色
                $table.find('tr').each(function () {
                    var $tr = $(this);
                    var trIndex = $tr.attr('index');
                    if (parseInt(trIndex, 10) <= parseInt(currentTrIndex, 10)) {
                        // 该行需要可能需要设置背景色
                        $tr.find('td').each(function () {
                            var $td = $(this);
                            var tdIndex = $td.attr('index');
                            if (parseInt(tdIndex, 10) <= parseInt(currentTdIndex, 10)) {
                                // 需要设置背景色
                                $td.addClass('active');
                            } else {
                                // 需要移除背景色
                                $td.removeClass('active');
                            }
                        });
                    } else {
                        // 改行不需要设置背景色
                        $tr.find('td').removeClass('active');
                    }
                });
            }).on('mouseleave', function (e) {
                // mouseleave 删除背景色
                $table.find('td').removeClass('active');

                $row.text(0);
                $col.text(0);
            });

            // 插入表格
            $table.on('click', 'td', function (e) {
                var $currentTd = $(e.currentTarget);
                var currentTdIndex = $currentTd.attr('index');
                var $currentTr = $currentTd.parent();
                var currentTrIndex = $currentTr.attr('index');

                var rownum = parseInt(currentTrIndex, 10);
                var colnum = parseInt(currentTdIndex, 10);

                // -------- 拼接tabel html --------

                var i, j;
                var tableHtml = '<table>';
                for (i = 0; i < rownum; i++) {
                    tableHtml += '<tr>';

                    for (j = 0; j < colnum; j++) {
                        tableHtml += '<td><span>&nbsp;</span></td>';
                    }
                    tableHtml += '</tr>';
                }
                tableHtml += '</table>';

                // -------- 执行命令 --------
                editor.command(e, 'insertHtml', tableHtml);
            });

            // 创建 panel
            menu.dropPanel = new E.DropPanel(editor, menu, {
                $content: $content,
                width: 262
            });

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // emotion 菜单
    _e(function (E, $) {

        E.createMenu(function (check) {
            var menuId = 'emotion';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var config = editor.config;
            var lang = config.lang;
            var configEmotions = config.emotions;
            var emotionsShow = config.emotionsShow;

            // 记录每一个表情图片的地址
            editor.emotionUrls = [];

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.emotion
            });

            // 添加表情图片的函数
            function insertEmotionImgs(data, $tabContent) {
                // 添加表情图片
                $.each(data, function (k, emotion) {
                    var src = emotion.icon || emotion.url;
                    var value = emotion.value || emotion.title;
                    // 通过配置 editor.config.emotionsShow 的值来修改插入到编辑器的内容（图片/value）
                    var commandValue = emotionsShow === 'icon' ? src : value;
                    var $command = $('<a href="#" commandValue="' + commandValue + '"></a>');
                    var $img = $('<img>');
                    $img.attr('_src', src); // 先将 src 复制到 '_src' 属性，先不加载

                    $command.append($img);
                    $tabContent.append($command);

                    // 记录下每一个表情图片的地址
                    editor.emotionUrls.push(src);
                });
            }

            // 拼接 dropPanel 内容
            var $panelContent = $('<div class="panel-tab"></div>');
            var $tabContainer = $('<div class="tab-container"></div>');
            var $contentContainer = $('<div class="content-container emotion-content-container"></div>');
            $.each(configEmotions, function (k, emotion) {
                var title = emotion.title;
                var data = emotion.data;

                E.log('正在处理 ' + title + ' 表情的数据...');

                // 增加该组表情的tab和content
                var $tab = $('<a href="#">' + title + ' </a>');
                $tabContainer.append($tab);
                var $tabContent = $('<div class="content"></div>');
                $contentContainer.append($tabContent);

                // tab 切换事件
                $tab.click(function (e) {
                    $tabContainer.children().removeClass('selected');
                    $contentContainer.children().removeClass('selected');
                    $tabContent.addClass('selected');
                    $tab.addClass('selected');
                    e.preventDefault();
                });

                // 处理data
                if (typeof data === 'string') {
                    // url 形式，需要通过ajax从该url获取数据
                    E.log('将通过 ' + data + ' 地址ajax下载表情包');
                    $.get(data, function (result) {
                        result = $.parseJSON(result);
                        E.log('下载完毕，得到 ' + result.length + ' 个表情');
                        insertEmotionImgs(result, $tabContent);
                    });
                } else if (Object.prototype.toString.call(data).toLowerCase().indexOf('array') > 0) {
                    // 数组，即 data 直接就是表情包数据
                    insertEmotionImgs(data, $tabContent);
                } else {
                    // 其他情况，data格式不对
                    E.error('data 数据格式错误，请修改为正确格式，参考文档：' + E.docsite);
                    return;
                }
            });
            $panelContent.append($tabContainer).append($contentContainer);

            // 默认显示第一个tab
            $tabContainer.children().first().addClass('selected');
            $contentContainer.children().first().addClass('selected');

            // 插入表情command事件
            $contentContainer.on('click', 'a[commandValue]', function (e) {
                var $a = $(e.currentTarget);
                var commandValue = $a.attr('commandValue');
                var img;

                // commandValue 有可能是图片url，也有可能是表情的 value，需要区别对待

                if (emotionsShow === 'icon') {
                    // 插入图片
                    editor.command(e, 'InsertImage', commandValue);
                } else {
                    // 插入value
                    editor.command(e, 'insertHtml', '<span>' + commandValue + '</span>');
                }

                e.preventDefault();
            });

            // 添加panel
            menu.dropPanel = new E.DropPanel(editor, menu, {
                $content: $panelContent,
                width: 350
            });

            // 定义click事件（异步加载表情图片）
            menu.clickEvent = function (e) {
                var menu = this;
                var dropPanel = menu.dropPanel;

                // -------------隐藏-------------
                if (dropPanel.isShowing) {
                    dropPanel.hide();
                    return;
                }

                // -------------显示-------------
                dropPanel.show();

                // 异步加载图片
                if (menu.imgLoaded) {
                    return;
                }
                $contentContainer.find('img').each(function () {
                    var $img = $(this);
                    var _src = $img.attr('_src');
                    $img.on('error', function () {
                        E.error('加载不出表情图片 ' + _src);
                    });
                    $img.attr('src', _src);
                    $img.removeAttr('_src');
                });
                menu.imgLoaded = true;
            };

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // img 菜单
    _e(function (E, $) {

        E.createMenu(function (check) {
            var menuId = 'img';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var lang = editor.config.lang;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.img
            });

            // 创建 panel content
            var $panelContent = $('<div class="panel-tab"></div>');
            var $tabContainer = $('<div class="tab-container"></div>');
            var $contentContainer = $('<div class="content-container"></div>');
            $panelContent.append($tabContainer).append($contentContainer);

            // tab
            var $uploadTab = $('<a href="#">' + lang.uploadImg + '</a>');
            var $linkTab = $('<a href="#">' + lang.linkImg + '</a>');
            $tabContainer.append($uploadTab).append($linkTab);

            // 上传图片 content
            var $uploadContent = $('<div class="content"></div>');
            $contentContainer.append($uploadContent);

            // 网络图片 content
            var $linkContent = $('<div class="content"></div>');
            $contentContainer.append($linkContent);
            linkContentHandler(editor, menu, $linkContent);

            // 添加panel
            menu.dropPanel = new E.DropPanel(editor, menu, {
                $content: $panelContent,
                width: 400,
                onRender: function onRender() {
                    // 渲染后的回调事件，用于执行自定义上传的init
                    // 因为渲染之后，上传面板的dom才会被渲染到页面，才能让第三方空间获取到
                    var init = editor.config.customUploadInit;
                    init && init.call(editor);
                }
            });

            // 增加到editor对象中
            editor.menus[menuId] = menu;

            // tab 切换事件
            function tabToggle() {
                $uploadTab.click(function (e) {
                    $tabContainer.children().removeClass('selected');
                    $contentContainer.children().removeClass('selected');
                    $uploadContent.addClass('selected');
                    $uploadTab.addClass('selected');
                    e.preventDefault();
                });
                $linkTab.click(function (e) {
                    $tabContainer.children().removeClass('selected');
                    $contentContainer.children().removeClass('selected');
                    $linkContent.addClass('selected');
                    $linkTab.addClass('selected');
                    e.preventDefault();

                    // focus input
                    if (E.placeholder) {
                        $linkContent.find('input[type=text]').focus();
                    }
                });

                // 默认情况
                // $uploadTab.addClass('selected');
                // $uploadContent.addClass('selected');
                $uploadTab.click();
            }

            // 隐藏上传图片
            function hideUploadImg() {
                $tabContainer.remove();
                $uploadContent.remove();
                $linkContent.addClass('selected');
            }

            // 隐藏网络图片
            function hideLinkImg() {
                $tabContainer.remove();
                $linkContent.remove();
                $uploadContent.addClass('selected');
            }

            // 判断用户是否配置了上传图片
            editor.ready(function () {
                var editor = this;
                var config = editor.config;
                var uploadImgUrl = config.uploadImgUrl;
                var customUpload = config.customUpload;
                var linkImg = config.hideLinkImg;
                var $uploadImgPanel;

                if (uploadImgUrl || customUpload) {
                    // 第一，暴露出 $uploadContent 以便用户自定义 ！！！重要
                    editor.$uploadContent = $uploadContent;

                    // 第二，绑定tab切换事件
                    tabToggle();

                    if (linkImg) {
                        // 隐藏网络图片
                        hideLinkImg();
                    }
                } else {
                    // 未配置上传图片功能
                    hideUploadImg();
                }

                // 点击 $uploadContent 立即隐藏 dropPanel
                // 为了兼容IE8、9的上传，因为IE8、9使用 modal 上传
                // 这里使用异步，为了不妨碍高级浏览器通过点击 $uploadContent 选择文件
                function hidePanel() {
                    menu.dropPanel.hide();
                }
                $uploadContent.click(function () {
                    setTimeout(hidePanel);
                });
            });
        });

        // --------------- 处理网络图片content ---------------
        function linkContentHandler(editor, menu, $linkContent) {
            var lang = editor.config.lang;
            var $urlContainer = $('<div style="margin:20px 10px 10px 10px;"></div>');
            var $urlInput = $('<input type="text" class="block" placeholder="http://"/>');
            $urlContainer.append($urlInput);
            var $btnSubmit = $('<button class="right">' + lang.submit + '</button>');
            var $btnCancel = $('<button class="right gray">' + lang.cancel + '</button>');

            $linkContent.append($urlContainer).append($btnSubmit).append($btnCancel);

            // 取消
            $btnCancel.click(function (e) {
                e.preventDefault();
                menu.dropPanel.hide();
            });

            // callback
            function callback() {
                $urlInput.val('');
            }

            // 确定
            $btnSubmit.click(function (e) {
                e.preventDefault();
                var url = $.trim($urlInput.val());
                if (!url) {
                    // 无内容
                    $urlInput.focus();
                    return;
                }

                var imgHtml = '<img style="max-width:100%;" src="' + url + '"/>';
                editor.command(e, 'insertHtml', imgHtml, callback);
            });
        }
    });
    // video 菜单
    _e(function (E, $) {

        E.createMenu(function (check) {
            var menuId = 'video';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var lang = editor.config.lang;
            var reg = /^<(iframe)|(embed)/i; // <iframe... 或者 <embed... 格式

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.video
            });

            // 创建 panel 内容
            var $content = $('<div></div>');
            var $linkInputContainer = $('<div style="margin:20px 10px;"></div>');
            var $linkInput = $('<input type="text" class="block" placeholder=\'格式如：<iframe src="..." frameborder=0 allowfullscreen></iframe>\'/>');
            $linkInputContainer.append($linkInput);
            var $sizeContainer = $('<div style="margin:20px 10px;"></div>');
            var $widthInput = $('<input type="text" value="640" style="width:50px;text-align:center;"/>');
            var $heightInput = $('<input type="text" value="498" style="width:50px;text-align:center;"/>');
            $sizeContainer.append('<span> ' + lang.width + ' </span>').append($widthInput).append('<span> px &nbsp;&nbsp;&nbsp;</span>').append('<span> ' + lang.height + ' </span>').append($heightInput).append('<span> px </span>');
            var $btnContainer = $('<div></div>');
            var $howToCopy = $('<a href="http://www.kancloud.cn/wangfupeng/wangeditor2/134973" target="_blank" style="display:inline-block;margin-top:10px;margin-left:10px;color:#999;">如何复制视频链接？</a>');
            var $btnSubmit = $('<button class="right">' + lang.submit + '</button>');
            var $btnCancel = $('<button class="right gray">' + lang.cancel + '</button>');
            $btnContainer.append($howToCopy).append($btnSubmit).append($btnCancel);
            $content.append($linkInputContainer).append($sizeContainer).append($btnContainer);

            // 取消按钮
            $btnCancel.click(function (e) {
                e.preventDefault();
                $linkInput.val('');
                menu.dropPanel.hide();
            });

            // 确定按钮
            $btnSubmit.click(function (e) {
                e.preventDefault();
                var link = $.trim($linkInput.val());
                var $link;
                var width = parseInt($widthInput.val());
                var height = parseInt($heightInput.val());
                var $div = $('<div>');
                var html = '<p>{content}</p>';

                // 验证数据
                if (!link) {
                    menu.dropPanel.focusFirstInput();
                    return;
                }

                if (!reg.test(link)) {
                    alert('视频链接格式错误！');
                    menu.dropPanel.focusFirstInput();
                    return;
                }

                if (isNaN(width) || isNaN(height)) {
                    alert('宽度或高度不是数字！');
                    return;
                }

                $link = $(link);

                // 设置高度和宽度
                $link.attr('width', width).attr('height', height);

                // 拼接字符串
                html = html.replace('{content}', $div.append($link).html());

                // 执行命令
                editor.command(e, 'insertHtml', html);
                $linkInput.val('');
            });

            // 创建panel
            menu.dropPanel = new E.DropPanel(editor, menu, {
                $content: $content,
                width: 400
            });

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // location 菜单
    _e(function (E, $) {

        // 判断浏览器的 input 是否支持 keyup
        var inputKeyup = function (input) {
            return 'onkeyup' in input;
        }(document.createElement('input'));

        // 百度地图的key
        // E.baiduMapAk = '';

        // 一个页面中，如果有多个编辑器，地图会出现问题。这个参数记录一下，如果超过 1 就提示
        E.numberOfLocation = 0;

        E.createMenu(function (check) {
            var menuId = 'location';
            if (!check(menuId)) {
                return;
            }

            if (++E.numberOfLocation > 1) {
                E.error('目前不支持在一个页面多个编辑器上同时使用地图，可通过自定义菜单配置去掉地图菜单');
                return;
            }

            var editor = this;
            var config = editor.config;
            var lang = config.lang;
            var ak = config.mapAk;

            // 地图的变量存储到这个地方
            editor.mapData = {};
            var mapData = editor.mapData;

            // ---------- 地图事件 ----------
            mapData.markers = [];
            mapData.mapContainerId = 'map' + E.random();

            mapData.clearLocations = function () {
                var map = mapData.map;
                if (!map) {
                    return;
                }
                map.clearOverlays();

                //同时，清空marker数组
                mapData.markers = [];
            };

            mapData.searchMap = function () {
                var map = mapData.map;
                if (!map) {
                    return;
                }

                var BMap = window.BMap;
                var cityName = $cityInput.val();
                var locationName = $searchInput.val();
                var myGeo, marker;

                if (cityName !== '') {
                    if (!locationName || locationName === '') {
                        map.centerAndZoom(cityName, 11);
                    }

                    //地址解析
                    if (locationName && locationName !== '') {
                        myGeo = new BMap.Geocoder();
                        // 将地址解析结果显示在地图上,并调整地图视野
                        myGeo.getPoint(locationName, function (point) {
                            if (point) {
                                map.centerAndZoom(point, 13);
                                marker = new BMap.Marker(point);
                                map.addOverlay(marker);
                                marker.enableDragging(); //允许拖拽
                                mapData.markers.push(marker); //将marker加入到数组中
                            } else {
                                // alert('未找到');
                                map.centerAndZoom(cityName, 11); //找不到则重新定位到城市
                            }
                        }, cityName);
                    }
                } // if(cityName !== '')
            };

            // load script 之后的 callback
            var hasCallback = false;
            window.baiduMapCallBack = function () {
                // 避免重复加载
                if (hasCallback) {
                    return;
                } else {
                    hasCallback = true;
                }

                var BMap = window.BMap;
                if (!mapData.map) {
                    // 创建Map实例
                    mapData.map = new BMap.Map(mapData.mapContainerId);
                }
                var map = mapData.map;

                map.centerAndZoom(new BMap.Point(116.404, 39.915), 11); // 初始化地图,设置中心点坐标和地图级别
                map.addControl(new BMap.MapTypeControl()); //添加地图类型控件
                map.setCurrentCity("北京"); // 设置地图显示的城市 此项是必须设置的
                map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放

                //根据IP定位
                function locationFun(result) {
                    var cityName = result.name;
                    map.setCenter(cityName);

                    // 设置城市名称
                    $cityInput.val(cityName);
                    if (E.placeholder) {
                        $searchInput.focus();
                    }
                    var timeoutId, _searchFn;
                    if (inputKeyup) {
                        // 并绑定搜索事件 - input 支持 keyup
                        _searchFn = function searchFn(e) {
                            if (e.type === 'keyup' && e.keyCode === 13) {
                                e.preventDefault();
                            }
                            if (timeoutId) {
                                clearTimeout(timeoutId);
                            }
                            timeoutId = setTimeout(mapData.searchMap, 500);
                        };
                        $cityInput.on('keyup change paste', _searchFn);
                        $searchInput.on('keyup change paste', _searchFn);
                    } else {
                        // 并绑定搜索事件 - input 不支持 keyup
                        _searchFn = function searchFn() {
                            if (!$content.is(':visible')) {
                                // panel 不显示了，就不用再监控了
                                clearTimeout(timeoutId);
                                return;
                            }

                            var currentCity = '';
                            var currentSearch = '';
                            var city = $cityInput.val();
                            var search = $searchInput.val();

                            if (city !== currentCity || search !== currentSearch) {
                                // 刚获取的数据和之前的数据不一致，执行查询
                                mapData.searchMap();
                                // 更新数据
                                currentCity = city;
                                currentSearch = search;
                            }

                            // 继续监控
                            if (timeoutId) {
                                clearTimeout(timeoutId);
                            }
                            timeoutId = setTimeout(_searchFn, 1000);
                        };
                        // 开始监控
                        timeoutId = setTimeout(_searchFn, 1000);
                    }
                }
                var myCity = new BMap.LocalCity();
                myCity.get(locationFun);

                //鼠标点击，创建位置
                map.addEventListener("click", function (e) {
                    var marker = new BMap.Marker(new BMap.Point(e.point.lng, e.point.lat));
                    map.addOverlay(marker);
                    marker.enableDragging();
                    mapData.markers.push(marker); //加入到数组中
                }, false);
            };

            mapData.loadMapScript = function () {
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.src = "https://api.map.baidu.com/api?v=2.0&ak=" + ak + "&s=1&callback=baiduMapCallBack"; // baiduMapCallBack是一个本地函数
                try {
                    // IE10- 报错
                    document.body.appendChild(script);
                } catch (ex) {
                    E.error('加载地图过程中发生错误');
                }
            };

            // 初始化地图
            mapData.initMap = function () {
                if (window.BMap) {
                    // 不是第一次，直接处理地图即可
                    window.baiduMapCallBack();
                } else {
                    // 第一次，先加载地图 script，再处理地图（script加载完自动执行处理）
                    mapData.loadMapScript();
                }
            };

            // ---------- 创建 menu 对象 ----------

            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.location
            });

            editor.menus[menuId] = menu;

            // ---------- 构建UI ----------

            // panel content
            var $content = $('<div></div>');

            // 搜索框
            var $inputContainer = $('<div style="margin:10px 0;"></div>');
            var $cityInput = $('<input type="text"/>');
            $cityInput.css({
                width: '80px',
                'text-align': 'center'
            });
            var $searchInput = $('<input type="text"/>');
            $searchInput.css({
                width: '300px',
                'margin-left': '10px'
            }).attr('placeholder', lang.searchlocation);
            var $clearBtn = $('<button class="right link">' + lang.clearLocation + '</button>');
            $inputContainer.append($clearBtn).append($cityInput).append($searchInput);
            $content.append($inputContainer);

            // 清除位置按钮
            $clearBtn.click(function (e) {
                $searchInput.val('');
                $searchInput.focus();
                mapData.clearLocations();
                e.preventDefault();
            });

            // 地图
            var $map = $('<div id="' + mapData.mapContainerId + '"></div>');
            $map.css({
                height: '260px',
                width: '100%',
                position: 'relative',
                'margin-top': '10px',
                border: '1px solid #f1f1f1'
            });
            var $mapLoading = $('<span>' + lang.loading + '</span>');
            $mapLoading.css({
                position: 'absolute',
                width: '100px',
                'text-align': 'center',
                top: '45%',
                left: '50%',
                'margin-left': '-50px'
            });
            $map.append($mapLoading);
            $content.append($map);

            // 按钮
            var $btnContainer = $('<div style="margin:10px 0;"></div>');
            var $btnSubmit = $('<button class="right">' + lang.submit + '</button>');
            var $btnCancel = $('<button class="right gray">' + lang.cancel + '</button>');
            var $checkLabel = $('<label style="display:inline-block;margin-top:10px;color:#666;"></label>');
            var $check = $('<input type="checkbox">');
            $checkLabel.append($check).append('<span style="display:inline-block;margin-left:5px;">  ' + lang.dynamicMap + '</span>');
            $btnContainer.append($checkLabel).append($btnSubmit).append($btnCancel);
            $content.append($btnContainer);

            function callback() {
                $searchInput.val('');
            }

            // 『取消』按钮事件
            $btnCancel.click(function (e) {
                e.preventDefault();
                callback();
                menu.dropPanel.hide();
            });

            // 『确定』按钮事件
            $btnSubmit.click(function (e) {
                e.preventDefault();
                var map = mapData.map,
                    isDynamic = $check.is(':checked'),
                    markers = mapData.markers,
                    center = map.getCenter(),
                    centerLng = center.lng,
                    centerLat = center.lat,
                    zoom = map.getZoom(),
                    size = map.getSize(),
                    sizeWidth = size.width,
                    sizeHeight = size.height,
                    position,
                    src,
                    iframe;

                if (isDynamic) {
                    //动态地址
                    src = 'http://ueditor.baidu.com/ueditor/dialogs/map/show.html#';
                } else {
                    //静态地址
                    src = 'http://api.map.baidu.com/staticimage?';
                }

                //src参数
                src = src + 'center=' + centerLng + ',' + centerLat + '&zoom=' + zoom + '&width=' + sizeWidth + '&height=' + sizeHeight;
                if (markers.length > 0) {
                    src = src + '&markers=';

                    //添加所有的marker
                    $.each(markers, function (key, value) {
                        position = value.getPosition();
                        if (key > 0) {
                            src = src + '|';
                        }
                        src = src + position.lng + ',' + position.lat;
                    });
                }

                if (isDynamic) {
                    if (markers.length > 1) {
                        alert(lang.langDynamicOneLocation);
                        return;
                    }

                    src += '&markerStyles=l,A';

                    //插入iframe
                    iframe = '<iframe class="ueditor_baidumap" src="{src}" frameborder="0" width="' + sizeWidth + '" height="' + sizeHeight + '"></iframe>';
                    iframe = iframe.replace('{src}', src);
                    editor.command(e, 'insertHtml', iframe, callback);
                } else {
                    //插入图片
                    editor.command(e, 'insertHtml', '<img style="max-width:100%;" src="' + src + '"/>', callback);
                }
            });

            // 根据 UI 创建菜单 panel
            menu.dropPanel = new E.DropPanel(editor, menu, {
                $content: $content,
                width: 500
            });

            // ---------- 事件 ----------

            // render 时执行事件
            menu.onRender = function () {
                if (ak === E.baiduMapAk) {
                    E.warn('建议在配置中自定义百度地图的mapAk，否则可能影响地图功能，文档：' + E.docsite);
                }
            };

            // click 事件
            menu.clickEvent = function (e) {
                var menu = this;
                var dropPanel = menu.dropPanel;
                var firstTime = false;

                // -------------隐藏-------------
                if (dropPanel.isShowing) {
                    dropPanel.hide();
                    return;
                }

                // -------------显示-------------
                if (!mapData.map) {
                    // 第一次，先加载地图
                    firstTime = true;
                }

                dropPanel.show();
                mapData.initMap();

                if (!firstTime) {
                    $searchInput.focus();
                }
            };
        });
    });
    // insertcode 菜单
    _e(function (E, $) {

        // 加载 highlightjs 代码
        function loadHljs() {
            if (E.userAgent.indexOf('MSIE 8') > 0) {
                // 不支持 IE8
                return;
            }
            if (window.hljs) {
                // 不要重复加载
                return;
            }
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "//cdn.bootcss.com/highlight.js/9.2.0/highlight.min.js";
            document.body.appendChild(script);
        }

        E.createMenu(function (check) {
            var menuId = 'insertcode';
            if (!check(menuId)) {
                return;
            }

            // 加载 highlightjs 代码
            setTimeout(loadHljs, 0);

            var editor = this;
            var config = editor.config;
            var lang = config.lang;
            var $txt = editor.txt.$txt;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.insertcode
            });

            // click 事件
            menu.clickEvent = function (e) {
                var menu = this;
                var dropPanel = menu.dropPanel;

                // 隐藏
                if (dropPanel.isShowing) {
                    dropPanel.hide();
                    return;
                }

                // 显示
                $textarea.val('');
                dropPanel.show();

                // highlightjs 语言列表
                var hljs = window.hljs;
                if (hljs && hljs.listLanguages) {
                    if ($langSelect.children().length !== 0) {
                        return;
                    }
                    $langSelect.css({
                        'margin-top': '9px',
                        'margin-left': '5px'
                    });
                    $.each(hljs.listLanguages(), function (key, lang) {
                        if (lang === 'xml') {
                            lang = 'html';
                        }
                        if (lang === config.codeDefaultLang) {
                            $langSelect.append('<option value="' + lang + '" selected="selected">' + lang + '</option>');
                        } else {
                            $langSelect.append('<option value="' + lang + '">' + lang + '</option>');
                        }
                    });
                } else {
                    $langSelect.hide();
                }
            };

            // 选中状态下的 click 事件
            menu.clickEventSelected = function (e) {
                var menu = this;
                var dropPanel = menu.dropPanel;

                // 隐藏
                if (dropPanel.isShowing) {
                    dropPanel.hide();
                    return;
                }

                // 显示
                dropPanel.show();

                var rangeElem = editor.getRangeElem();
                var targetElem = editor.getSelfOrParentByName(rangeElem, 'pre');
                var $targetElem;
                var className;
                if (targetElem) {
                    // 确定找到 pre 之后，再找 code
                    targetElem = editor.getSelfOrParentByName(rangeElem, 'code');
                }
                if (!targetElem) {
                    return;
                }
                $targetElem = $(targetElem);

                // 赋值内容
                $textarea.val($targetElem.text());
                if ($langSelect) {
                    // 赋值语言
                    className = $targetElem.attr('class');
                    if (className) {
                        $langSelect.val(className.split(' ')[0]);
                    }
                }
            };

            // 定义更新选中状态的事件
            menu.updateSelectedEvent = function () {
                var self = this; //菜单对象
                var editor = self.editor;
                var rangeElem;

                rangeElem = editor.getRangeElem();
                rangeElem = editor.getSelfOrParentByName(rangeElem, 'pre');

                if (rangeElem) {
                    return true;
                }

                return false;
            };

            // 创建 panel
            var $content = $('<div></div>');
            var $textarea = $('<textarea></textarea>');
            var $langSelect = $('<select></select>');
            contentHandle($content);
            menu.dropPanel = new E.DropPanel(editor, menu, {
                $content: $content,
                width: 500
            });

            // 增加到editor对象中
            editor.menus[menuId] = menu;

            // ------ 增加 content 内容 ------
            function contentHandle($content) {
                // textarea 区域
                var $textareaContainer = $('<div></div>');
                $textareaContainer.css({
                    margin: '15px 5px 5px 5px',
                    height: '160px',
                    'text-align': 'center'
                });
                $textarea.css({
                    width: '100%',
                    height: '100%',
                    padding: '10px'
                });
                $textarea.on('keydown', function (e) {
                    // 取消 tab 键默认行为
                    if (e.keyCode === 9) {
                        e.preventDefault();
                    }
                });
                $textareaContainer.append($textarea);
                $content.append($textareaContainer);

                // 按钮区域
                var $btnContainer = $('<div></div>');
                var $btnSubmit = $('<button class="right">' + lang.submit + '</button>');
                var $btnCancel = $('<button class="right gray">' + lang.cancel + '</button>');

                $btnContainer.append($btnSubmit).append($btnCancel).append($langSelect);
                $content.append($btnContainer);

                // 取消按钮
                $btnCancel.click(function (e) {
                    e.preventDefault();
                    menu.dropPanel.hide();
                });

                // 确定按钮
                var codeTpl = '<pre style="max-width:100%;overflow-x:auto;"><code{#langClass}>{#content}</code></pre>';
                $btnSubmit.click(function (e) {
                    e.preventDefault();
                    var val = $textarea.val();
                    if (!val) {
                        // 无内容
                        $textarea.focus();
                        return;
                    }

                    var rangeElem = editor.getRangeElem();
                    if ($.trim($(rangeElem).text()) && codeTpl.indexOf('<p><br></p>') !== 0) {
                        codeTpl = '<p><br></p>' + codeTpl;
                    }

                    var lang = $langSelect ? $langSelect.val() : ''; // 获取高亮语言
                    var langClass = '';
                    var doHightlight = function doHightlight() {
                        $txt.find('pre code').each(function (i, block) {
                            var $block = $(block);
                            if ($block.attr('codemark')) {
                                // 有 codemark 标记的代码块，就不再重新格式化了
                                return;
                            } else if (window.hljs) {
                                // 新代码块，格式化之后，立即标记 codemark
                                window.hljs.highlightBlock(block);
                                $block.attr('codemark', '1');
                            }
                        });
                    };

                    // 语言高亮样式
                    if (lang) {
                        langClass = ' class="' + lang + ' hljs"';
                    }

                    // 替换标签
                    val = val.replace(/&/gm, '&amp;').replace(/</gm, '&lt;').replace(/>/gm, '&gt;');

                    // ---- menu 未选中状态 ----
                    if (!menu.selected) {
                        // 拼接html
                        var html = codeTpl.replace('{#langClass}', langClass).replace('{#content}', val);
                        editor.command(e, 'insertHtml', html, doHightlight);
                        return;
                    }

                    // ---- menu 选中状态 ----
                    var targetElem = editor.getSelfOrParentByName(rangeElem, 'pre');
                    var $targetElem;
                    if (targetElem) {
                        // 确定找到 pre 之后，再找 code
                        targetElem = editor.getSelfOrParentByName(rangeElem, 'code');
                    }
                    if (!targetElem) {
                        return;
                    }
                    $targetElem = $(targetElem);

                    function commandFn() {
                        var className;
                        if (lang) {
                            className = $targetElem.attr('class');
                            if (className !== lang + ' hljs') {
                                $targetElem.attr('class', lang + ' hljs');
                            }
                        }
                        $targetElem.html(val);
                    }
                    function callback() {
                        editor.restoreSelectionByElem(targetElem);
                        doHightlight();
                    }
                    editor.customCommand(e, commandFn, callback);
                });
            }

            // ------ enter 时，不另起标签，只换行 ------
            $txt.on('keydown', function (e) {
                if (e.keyCode !== 13) {
                    return;
                }
                var rangeElem = editor.getRangeElem();
                var targetElem = editor.getSelfOrParentByName(rangeElem, 'code');
                if (!targetElem) {
                    return;
                }

                editor.command(e, 'insertHtml', '\n');
            });

            // ------ 点击时，禁用其他标签 ------
            function updateMenu() {
                var rangeElem = editor.getRangeElem();
                var targetElem = editor.getSelfOrParentByName(rangeElem, 'code');
                if (targetElem) {
                    // 在 code 之内，禁用其他菜单
                    editor.disableMenusExcept('insertcode');
                } else {
                    // 不是在 code 之内，启用其他菜单
                    editor.enableMenusExcept('insertcode');
                }
            }
            $txt.on('keydown click', function (e) {
                // 此处必须使用 setTimeout 异步处理，否则不对
                setTimeout(updateMenu);
            });
        });
    });
    // undo 菜单
    _e(function (E, $) {

        E.createMenu(function (check) {
            var menuId = 'undo';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var lang = editor.config.lang;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.undo
            });

            // click 事件
            menu.clickEvent = function (e) {
                editor.undo();
            };

            // 增加到editor对象中
            editor.menus[menuId] = menu;

            // ------------ 初始化时、enter 时、打字中断时，做记录 ------------
            // ------------ ctrl + z 是调用记录撤销，而不是使用浏览器默认的撤销 ------------
            editor.ready(function () {
                var editor = this;
                var $txt = editor.txt.$txt;
                var timeoutId;

                // 执行undo记录
                function undo() {
                    editor.undoRecord();
                }

                $txt.on('keydown', function (e) {
                    var keyCode = e.keyCode;

                    // 撤销 ctrl + z
                    if (e.ctrlKey && keyCode === 90) {
                        editor.undo();
                        return;
                    }

                    if (keyCode === 13) {
                        // enter 做记录
                        undo();
                    } else {
                        // keyup 之后 1s 之内不操作，则做一次记录
                        if (timeoutId) {
                            clearTimeout(timeoutId);
                        }
                        timeoutId = setTimeout(undo, 1000);
                    }
                });

                // 初始化做记录
                editor.undoRecord();
            });
        });
    });
    // redo 菜单
    _e(function (E, $) {

        E.createMenu(function (check) {
            var menuId = 'redo';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var lang = editor.config.lang;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.redo
            });

            // click 事件
            menu.clickEvent = function (e) {
                editor.redo();
            };

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // 全屏 菜单
    _e(function (E, $) {

        // 记录全屏时的scrollTop
        var scrollTopWhenFullScreen;

        E.createMenu(function (check) {
            var menuId = 'fullscreen';
            if (!check(menuId)) {
                return;
            }
            var editor = this;
            var $txt = editor.txt.$txt;
            var config = editor.config;
            var zIndexConfig = config.zindex || 10000;
            var lang = config.lang;

            var isSelected = false;
            var zIndex;

            var maxHeight;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor,
                id: menuId,
                title: lang.fullscreen
            });

            // 定义click事件
            menu.clickEvent = function (e) {
                // 增加样式
                var $editorContainer = editor.$editorContainer;
                $editorContainer.addClass('wangEditor-fullscreen');

                // （先保存当前的）再设置z-index
                zIndex = $editorContainer.css('z-index');
                $editorContainer.css('z-index', zIndexConfig);

                var $wrapper;
                var txtHeight = $txt.height();
                var txtOuterHeight = $txt.outerHeight();

                if (editor.useMaxHeight) {
                    // 记录 max-height，并暂时去掉maxheight
                    maxHeight = $txt.css('max-height');
                    $txt.css('max-height', 'none');

                    // 如果使用了maxHeight， 将$txt从它的父元素中移出来
                    $wrapper = $txt.parent();
                    $wrapper.after($txt);
                    $wrapper.remove();
                    $txt.css('overflow-y', 'auto');
                }

                // 设置高度到全屏
                var menuContainer = editor.menuContainer;
                $txt.height(E.$window.height() - menuContainer.height() - (txtOuterHeight - txtHeight) // 去掉内边距和外边距
                );

                // 取消menuContainer的内联样式（menu吸顶时，会为 menuContainer 设置一些内联样式）
                editor.menuContainer.$menuContainer.attr('style', '');

                // 保存状态
                isSelected = true;

                // 记录编辑器是否全屏
                editor.isFullScreen = true;

                // 记录设置全屏时的高度
                scrollTopWhenFullScreen = E.$window.scrollTop();
            };

            // 定义选中状态的 click 事件
            menu.clickEventSelected = function (e) {
                // 取消样式
                var $editorContainer = editor.$editorContainer;
                $editorContainer.removeClass('wangEditor-fullscreen');
                $editorContainer.css('z-index', zIndex);

                // 还原height
                if (editor.useMaxHeight) {
                    $txt.css('max-height', maxHeight);
                } else {
                    // editor.valueContainerHeight 在 editor.txt.initHeight() 中事先保存了
                    editor.$valueContainer.css('height', editor.valueContainerHeight);
                }

                // 重新计算高度
                editor.txt.initHeight();

                // 保存状态
                isSelected = false;

                // 记录编辑器是否全屏
                editor.isFullScreen = false;

                // 还原scrollTop
                if (scrollTopWhenFullScreen != null) {
                    E.$window.scrollTop(scrollTopWhenFullScreen);
                }
            };

            // 定义选中事件
            menu.updateSelectedEvent = function (e) {
                return isSelected;
            };

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // 渲染menus
    _e(function (E, $) {

        E.fn.renderMenus = function () {

            var editor = this;
            var menus = editor.menus;
            var menuIds = editor.config.menus;
            var menuContainer = editor.menuContainer;

            var menu;
            var groupIdx = 0;
            $.each(menuIds, function (k, v) {
                if (v === '|') {
                    groupIdx++;
                    return;
                }

                menu = menus[v];
                if (menu) {
                    menu.render(groupIdx);
                }
            });
        };
    });
    // 渲染menus
    _e(function (E, $) {

        E.fn.renderMenuContainer = function () {

            var editor = this;
            var menuContainer = editor.menuContainer;
            var $editorContainer = editor.$editorContainer;

            menuContainer.render();
        };
    });
    // 渲染 txt
    _e(function (E, $) {

        E.fn.renderTxt = function () {

            var editor = this;
            var txt = editor.txt;

            txt.render();

            // ready 时候，计算txt的高度
            editor.ready(function () {
                txt.initHeight();
            });
        };
    });
    // 渲染 container
    _e(function (E, $) {

        E.fn.renderEditorContainer = function () {

            var editor = this;
            var $valueContainer = editor.$valueContainer;
            var $editorContainer = editor.$editorContainer;
            var $txt = editor.txt.$txt;
            var $prev, $parent;

            // 将编辑器渲染到页面中
            if ($valueContainer === $txt) {
                $prev = editor.$prev;
                $parent = editor.$parent;

                if ($prev && $prev.length) {
                    // 有前置节点，就插入到前置节点的后面
                    $prev.after($editorContainer);
                } else {
                    // 没有前置节点，就直接插入到父元素
                    $parent.prepend($editorContainer);
                }
            } else {
                $valueContainer.after($editorContainer);
                $valueContainer.hide();
            }

            // 设置宽度（这样设置宽度有问题）
            // $editorContainer.css('width', $valueContainer.css('width'));
        };
    });
    // 菜单事件
    _e(function (E, $) {

        // 绑定每个菜单的click事件
        E.fn.eventMenus = function () {

            var menus = this.menus;

            // 绑定菜单的点击事件
            $.each(menus, function (k, v) {
                v.bindEvent();
            });
        };
    });
    // 菜单container事件
    _e(function (E, $) {

        E.fn.eventMenuContainer = function () {};
    });
    // 编辑区域事件
    _e(function (E, $) {

        E.fn.eventTxt = function () {

            var txt = this.txt;

            // txt内容变化时，保存选区
            txt.saveSelectionEvent();

            // txt内容变化时，随时更新 value
            txt.updateValueEvent();

            // txt内容变化时，随时更新 menu style
            txt.updateMenuStyleEvent();

            // // 鼠标hover时，显示 p head 高度（暂时关闭这个功能）
            // if (!/ie/i.test(E.userAgent)) {
            //     // 暂时不支持IE
            //     txt.showHeightOnHover();
            // }
        };
    });
    // 上传图片事件
    _e(function (E, $) {

        E.plugin(function () {
            var editor = this;
            var fns = editor.config.uploadImgFns; // editor.config.uploadImgFns = {} 在config文件中定义了

            // -------- 定义load函数 --------
            fns.onload || (fns.onload = function (resultText, xhr) {
                E.log('上传结束，返回结果为 ' + resultText);

                var editor = this;
                var originalName = editor.uploadImgOriginalName || ''; // 上传图片时，已经将图片的名字存在 editor.uploadImgOriginalName
                var img;
                if (resultText.indexOf('error|') === 0) {
                    // 提示错误
                    E.warn('上传失败：' + resultText.split('|')[1]);
                    alert(resultText.split('|')[1]);
                } else {
                    E.log('上传成功，即将插入编辑区域，结果为：' + resultText);

                    // 将结果插入编辑器
                    img = document.createElement('img');
                    img.onload = function () {
                        var html = '<img src="' + resultText + '" alt="' + originalName + '" style="max-width:100%;"/>';
                        editor.command(null, 'insertHtml', html);

                        E.log('已插入图片，地址 ' + resultText);
                        img = null;
                    };
                    img.onerror = function () {
                        E.error('使用返回的结果获取图片，发生错误。请确认以下结果是否正确：' + resultText);
                        img = null;
                    };
                    img.src = resultText;
                }
            });

            // -------- 定义tiemout函数 --------
            fns.ontimeout || (fns.ontimeout = function (xhr) {
                E.error('上传图片超时');
                alert('上传图片超时');
            });

            // -------- 定义error函数 --------
            fns.onerror || (fns.onerror = function (xhr) {
                E.error('上传上图片发生错误');
                alert('上传上图片发生错误');
            });
        });
    });
    // xhr 上传图片
    _e(function (E, $) {

        if (!window.FileReader || !window.FormData) {
            // 如果不支持html5的文档操作，直接返回
            return;
        }

        E.plugin(function () {

            var editor = this;
            var config = editor.config;
            var uploadImgUrl = config.uploadImgUrl;
            var uploadTimeout = config.uploadTimeout;

            // 获取配置中的上传事件
            var uploadImgFns = config.uploadImgFns;
            var onload = uploadImgFns.onload;
            var ontimeout = uploadImgFns.ontimeout;
            var onerror = uploadImgFns.onerror;

            if (!uploadImgUrl) {
                return;
            }

            // -------- 将以base64的图片url数据转换为Blob --------
            function convertBase64UrlToBlob(urlData, filetype) {
                //去掉url的头，并转换为byte
                var bytes = window.atob(urlData.split(',')[1]);

                //处理异常,将ascii码小于0的转换为大于0
                var ab = new ArrayBuffer(bytes.length);
                var ia = new Uint8Array(ab);
                var i;
                for (i = 0; i < bytes.length; i++) {
                    ia[i] = bytes.charCodeAt(i);
                }

                return new Blob([ab], { type: filetype });
            }

            // -------- 插入图片的方法 --------
            function insertImg(src, event) {
                var img = document.createElement('img');
                img.onload = function () {
                    var html = '<img src="' + src + '" style="max-width:100%;"/>';
                    editor.command(event, 'insertHtml', html);

                    E.log('已插入图片，地址 ' + src);
                    img = null;
                };
                img.onerror = function () {
                    E.error('使用返回的结果获取图片，发生错误。请确认以下结果是否正确：' + src);
                    img = null;
                };
                img.src = src;
            }

            // -------- onprogress 事件 --------
            function updateProgress(e) {
                if (e.lengthComputable) {
                    var percentComplete = e.loaded / e.total;
                    editor.showUploadProgress(percentComplete * 100);
                }
            }

            // -------- xhr 上传图片 --------
            editor.xhrUploadImg = function (opt) {
                // opt 数据
                var event = opt.event;
                var fileName = opt.filename || '';
                var base64 = opt.base64;
                var fileType = opt.fileType || 'image/png'; // 无扩展名则默认使用 png
                var name = opt.name || 'wangEditor_upload_file';
                var loadfn = opt.loadfn || onload;
                var errorfn = opt.errorfn || onerror;
                var timeoutfn = opt.timeoutfn || ontimeout;

                // 上传参数（如 token）
                var params = editor.config.uploadParams || {};

                // headers
                var headers = editor.config.uploadHeaders || {};

                // 获取文件扩展名
                var fileExt = 'png'; // 默认为 png
                if (fileName.indexOf('.') > 0) {
                    // 原来的文件名有扩展名
                    fileExt = fileName.slice(fileName.lastIndexOf('.') - fileName.length + 1);
                } else if (fileType.indexOf('/') > 0 && fileType.split('/')[1]) {
                    // 文件名没有扩展名，通过类型获取，如从 'image/png' 取 'png'
                    fileExt = fileType.split('/')[1];
                }

                // ------------ begin 预览模拟上传 ------------
                if (E.isOnWebsite) {
                    E.log('预览模拟上传');
                    insertImg(base64, event);
                    return;
                }
                // ------------ end 预览模拟上传 ------------

                // 变量声明
                var xhr = new XMLHttpRequest();
                var timeoutId;
                var src;
                var formData = new FormData();

                // 超时处理
                function timeoutCallback() {
                    if (timeoutId) {
                        clearTimeout(timeoutId);
                    }
                    if (xhr && xhr.abort) {
                        xhr.abort();
                    }

                    // 超时了就阻止默认行为
                    event.preventDefault();

                    // 执行回调函数，提示什么内容，都应该在回调函数中定义
                    timeoutfn && timeoutfn.call(editor, xhr);

                    // 隐藏进度条
                    editor.hideUploadProgress();
                }

                xhr.onload = function () {
                    if (timeoutId) {
                        clearTimeout(timeoutId);
                    }

                    // 记录文件名到 editor.uploadImgOriginalName ，插入图片时，可做 alt 属性用
                    editor.uploadImgOriginalName = fileName;
                    if (fileName.indexOf('.') > 0) {
                        editor.uploadImgOriginalName = fileName.split('.')[0];
                    }

                    // 执行load函数，任何操作，都应该在load函数中定义
                    loadfn && loadfn.call(editor, xhr.responseText, xhr);

                    // 隐藏进度条
                    editor.hideUploadProgress();
                };
                xhr.onerror = function () {
                    if (timeoutId) {
                        clearTimeout(timeoutId);
                    }

                    // 超时了就阻止默认行为
                    event.preventDefault();

                    // 执行error函数，错误提示，应该在error函数中定义
                    errorfn && errorfn.call(editor, xhr);

                    // 隐藏进度条
                    editor.hideUploadProgress();
                };
                // xhr.onprogress = updateProgress;
                xhr.upload.onprogress = updateProgress;

                // 填充数据
                formData.append(name, convertBase64UrlToBlob(base64, fileType), E.random() + '.' + fileExt);

                // 添加参数
                $.each(params, function (key, value) {
                    formData.append(key, value);
                });

                // 开始上传
                xhr.open('POST', uploadImgUrl, true);
                // xhr.setRequestHeader("Content-type","application/x-www-form-urlencoded");  // 将参数解析成传统form的方式上传

                // 修改自定义配置的headers
                $.each(headers, function (key, value) {
                    xhr.setRequestHeader(key, value);
                });

                // 跨域上传时，传cookie
                xhr.withCredentials = editor.config.withCredentials || true;

                // 发送数据
                xhr.send(formData);
                timeoutId = setTimeout(timeoutCallback, uploadTimeout);

                E.log('开始上传...并开始超时计算');
            };
        });
    });
    // 进度条
    _e(function (E, $) {

        E.plugin(function () {

            var editor = this;
            var menuContainer = editor.menuContainer;
            var menuHeight = menuContainer.height();
            var $editorContainer = editor.$editorContainer;
            var width = $editorContainer.width();
            var $progress = $('<div class="wangEditor-upload-progress"></div>');

            // 渲染事件
            var isRender = false;
            function render() {
                if (isRender) {
                    return;
                }
                isRender = true;

                $progress.css({
                    top: menuHeight + 'px'
                });
                $editorContainer.append($progress);
            }

            // ------ 显示进度 ------
            editor.showUploadProgress = function (progress) {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }

                // 显示之前，先判断是否渲染
                render();

                $progress.show();
                $progress.width(progress * width / 100);
            };

            // ------ 隐藏进度条 ------
            var timeoutId;
            function hideProgress() {
                $progress.hide();
                timeoutId = null;
            }
            editor.hideUploadProgress = function (time) {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
                time = time || 750;
                timeoutId = setTimeout(hideProgress, time);
            };
        });
    });
    // upload img 插件
    _e(function (E, $) {

        E.plugin(function () {
            var editor = this;
            var config = editor.config;
            var uploadImgUrl = config.uploadImgUrl;
            var uploadTimeout = config.uploadTimeout;
            var event;

            if (!uploadImgUrl) {
                return;
            }

            // 获取editor的上传dom
            var $uploadContent = editor.$uploadContent;
            if (!$uploadContent) {
                return;
            }

            // 自定义UI，并添加到上传dom节点上
            var $uploadIcon = $('<div class="upload-icon-container"><i class="wangeditor-menu-img-upload"></i></div>');
            $uploadContent.append($uploadIcon);

            // ---------- 构建上传对象 ----------
            var upfile = new E.UploadFile({
                editor: editor,
                uploadUrl: uploadImgUrl,
                timeout: uploadTimeout,
                fileAccept: 'image/jpg,image/jpeg,image/png,image/gif,image/bmp' // 只允许选择图片
            });

            // 选择本地文件，上传
            $uploadIcon.click(function (e) {
                event = e;
                upfile.selectFiles();
            });
        });
    });
    // h5 方式上传图片
    _e(function (E, $) {

        if (!window.FileReader || !window.FormData) {
            // 如果不支持html5的文档操作，直接返回
            return;
        }

        // 构造函数
        var UploadFile = function UploadFile(opt) {
            this.editor = opt.editor;
            this.uploadUrl = opt.uploadUrl;
            this.timeout = opt.timeout;
            this.fileAccept = opt.fileAccept;
            this.multiple = true;
        };

        UploadFile.fn = UploadFile.prototype;

        // clear
        UploadFile.fn.clear = function () {
            this.$input.val('');
            E.log('input value 已清空');
        };

        // 渲染
        UploadFile.fn.render = function () {
            var self = this;
            if (self._hasRender) {
                // 不要重复渲染
                return;
            }

            E.log('渲染dom');

            var fileAccept = self.fileAccept;
            var acceptTpl = fileAccept ? 'accept="' + fileAccept + '"' : '';
            var multiple = self.multiple;
            var multipleTpl = multiple ? 'multiple="multiple"' : '';
            var $input = $('<input type="file" ' + acceptTpl + ' ' + multipleTpl + '/>');
            var $container = $('<div style="display:none;"></div>');

            $container.append($input);
            E.$body.append($container);

            // onchange 事件
            $input.on('change', function (e) {
                self.selected(e, $input.get(0));
            });

            // 记录对象数据
            self.$input = $input;

            // 记录
            self._hasRender = true;
        };

        // 选择
        UploadFile.fn.selectFiles = function () {
            var self = this;

            E.log('使用 html5 方式上传');

            // 先渲染
            self.render();

            // 选择
            E.log('选择文件');
            self.$input.click();
        };

        // 选中文件之后
        UploadFile.fn.selected = function (e, input) {
            var self = this;
            var files = input.files || [];
            if (files.length === 0) {
                return;
            }

            E.log('选中 ' + files.length + ' 个文件');

            // 遍历选中的文件，预览、上传
            $.each(files, function (key, value) {
                self.upload(value);
            });
        };

        // 上传单个文件
        UploadFile.fn.upload = function (file) {
            var self = this;
            var editor = self.editor;
            var filename = file.name || '';
            var fileType = file.type || '';
            var uploadImgFns = editor.config.uploadImgFns;
            var uploadFileName = editor.config.uploadImgFileName || 'wangEditorH5File';
            var onload = uploadImgFns.onload;
            var ontimeout = uploadImgFns.ontimeout;
            var onerror = uploadImgFns.onerror;
            var reader = new FileReader();

            if (!onload || !ontimeout || !onerror) {
                E.error('请为编辑器配置上传图片的 onload ontimeout onerror 回调事件');
                return;
            }

            E.log('开始执行 ' + filename + ' 文件的上传');

            // 清空 input 数据
            function clearInput() {
                self.clear();
            }

            // onload事件
            reader.onload = function (e) {
                E.log('已读取' + filename + '文件');

                var base64 = e.target.result || this.result;
                editor.xhrUploadImg({
                    event: e,
                    filename: filename,
                    base64: base64,
                    fileType: fileType,
                    name: uploadFileName,
                    loadfn: function loadfn(resultText, xhr) {
                        clearInput();
                        // 执行配置中的方法
                        var editor = this;
                        onload.call(editor, resultText, xhr);
                    },
                    errorfn: function errorfn(xhr) {
                        clearInput();
                        if (E.isOnWebsite) {
                            alert('wangEditor官网暂时没有服务端，因此报错。实际项目中不会发生');
                        }
                        // 执行配置中的方法
                        var editor = this;
                        onerror.call(editor, xhr);
                    },
                    timeoutfn: function timeoutfn(xhr) {
                        clearInput();
                        if (E.isOnWebsite) {
                            alert('wangEditor官网暂时没有服务端，因此超时。实际项目中不会发生');
                        }
                        // 执行配置中的方法
                        var editor = this;
                        ontimeout(editor, xhr);
                    }
                });
            };

            // 开始取文件
            reader.readAsDataURL(file);
        };

        // 暴露给 E
        E.UploadFile = UploadFile;
    });
    // form方式上传图片
    _e(function (E, $) {

        if (window.FileReader && window.FormData) {
            // 如果支持 html5 上传，则返回
            return;
        }

        // 构造函数
        var UploadFile = function UploadFile(opt) {
            this.editor = opt.editor;
            this.uploadUrl = opt.uploadUrl;
            this.timeout = opt.timeout;
            this.fileAccept = opt.fileAccept;
            this.multiple = false;
        };

        UploadFile.fn = UploadFile.prototype;

        // clear
        UploadFile.fn.clear = function () {
            this.$input.val('');
            E.log('input value 已清空');
        };

        // 隐藏modal
        UploadFile.fn.hideModal = function () {
            this.modal.hide();
        };

        // 渲染
        UploadFile.fn.render = function () {
            var self = this;
            var editor = self.editor;
            var uploadFileName = editor.config.uploadImgFileName || 'wangEditorFormFile';
            if (self._hasRender) {
                // 不要重复渲染
                return;
            }

            // 服务器端路径
            var uploadUrl = self.uploadUrl;

            E.log('渲染dom');

            // 创建 form 和 iframe
            var iframeId = 'iframe' + E.random();
            var $iframe = $('<iframe name="' + iframeId + '" id="' + iframeId + '" frameborder="0" width="0" height="0"></iframe>');
            var multiple = self.multiple;
            var multipleTpl = multiple ? 'multiple="multiple"' : '';
            var $p = $('<p>选择图片并上传</p>');
            var $input = $('<input type="file" ' + multipleTpl + ' name="' + uploadFileName + '"/>');
            var $btn = $('<input type="submit" value="上传"/>');
            var $form = $('<form enctype="multipart/form-data" method="post" action="' + uploadUrl + '" target="' + iframeId + '"></form>');
            var $container = $('<div style="margin:10px 20px;"></div>');

            $form.append($p).append($input).append($btn);

            // 增加用户配置的参数，如 token
            $.each(editor.config.uploadParams, function (key, value) {
                $form.append($('<input type="hidden" name="' + key + '" value="' + value + '"/>'));
            });

            $container.append($form);
            $container.append($iframe);

            self.$input = $input;
            self.$iframe = $iframe;

            // 生成 modal
            var modal = new E.Modal(editor, undefined, {
                $content: $container
            });
            self.modal = modal;

            // 记录
            self._hasRender = true;
        };

        // 绑定 iframe load 事件
        UploadFile.fn.bindLoadEvent = function () {
            var self = this;
            if (self._hasBindLoad) {
                // 不要重复绑定
                return;
            }

            var editor = self.editor;
            var $iframe = self.$iframe;
            var iframe = $iframe.get(0);
            var iframeWindow = iframe.contentWindow;
            var onload = editor.config.uploadImgFns.onload;

            // 定义load事件
            function onloadFn() {
                var resultText = $.trim(iframeWindow.document.body.innerHTML);
                if (!resultText) {
                    return;
                }

                // 获取文件名
                var fileFullName = self.$input.val(); // 结果如 C:\folder\abc.png 格式
                var fileOriginalName = fileFullName;
                if (fileFullName.lastIndexOf('\\') >= 0) {
                    // 获取 abc.png 格式
                    fileOriginalName = fileFullName.slice(fileFullName.lastIndexOf('\\') + 1);
                    if (fileOriginalName.indexOf('.') > 0) {
                        // 获取 abc （即不带扩展名的文件名）
                        fileOriginalName = fileOriginalName.split('.')[0];
                    }
                }

                // 将文件名暂存到 editor.uploadImgOriginalName ，插入图片时，可作为 alt 属性来用
                editor.uploadImgOriginalName = fileOriginalName;

                // 执行load函数，插入图片的操作，应该在load函数中执行
                onload.call(editor, resultText);

                // 清空 input 数据
                self.clear();

                // 隐藏modal
                self.hideModal();
            }

            // 绑定 load 事件
            if (iframe.attachEvent) {
                iframe.attachEvent('onload', onloadFn);
            } else {
                iframe.onload = onloadFn;
            }

            // 记录
            self._hasBindLoad = true;
        };

        UploadFile.fn.show = function () {
            var self = this;
            var modal = self.modal;

            function show() {
                modal.show();
                self.bindLoadEvent();
            }
            setTimeout(show);
        };

        // 选择
        UploadFile.fn.selectFiles = function () {
            var self = this;

            E.log('使用 form 方式上传');

            // 先渲染
            self.render();

            // 先清空
            self.clear();

            // 显示
            self.show();
        };

        // 暴露给 E
        E.UploadFile = UploadFile;
    });
    // upload img 插件 粘贴图片
    _e(function (E, $) {

        E.plugin(function () {
            var editor = this;
            var txt = editor.txt;
            var $txt = txt.$txt;
            var config = editor.config;
            var uploadImgUrl = config.uploadImgUrl;
            var uploadFileName = config.uploadImgFileName || 'wangEditorPasteFile';
            var pasteEvent;
            var $imgsBeforePaste;

            // 未配置上传图片url，则忽略
            if (!uploadImgUrl) {
                return;
            }

            // -------- 非 chrome 下，通过查找粘贴的图片的方式上传 --------
            function findPasteImgAndUpload() {
                var reg = /^data:(image\/\w+);base64/;
                var $imgs = $txt.find('img');

                E.log('粘贴后，检查到编辑器有' + $imgs.length + '个图片。开始遍历图片，试图找到刚刚粘贴过来的图片');

                $.each($imgs, function () {
                    var img = this;
                    var $img = $(img);
                    var flag;
                    var base64 = $img.attr('src');
                    var type;

                    // 判断当前图片是否是粘贴之前的
                    $imgsBeforePaste.each(function () {
                        if (img === this) {
                            // 当前图片是粘贴之前的
                            flag = true;
                            return false;
                        }
                    });

                    // 当前图片是粘贴之前的，则忽略
                    if (flag) {
                        return;
                    }

                    E.log('找到一个粘贴过来的图片');

                    if (reg.test(base64)) {
                        // 得到的粘贴的图片是 base64 格式，符合要求
                        E.log('src 是 base64 格式，可以上传');
                        type = base64.match(reg)[1];
                        editor.xhrUploadImg({
                            event: pasteEvent,
                            base64: base64,
                            fileType: type,
                            name: uploadFileName
                        });
                    } else {
                        E.log('src 为 ' + base64 + ' ，不是 base64 格式，暂时不支持上传');
                    }

                    // 最终移除原图片
                    $img.remove();
                });

                E.log('遍历结束');
            }

            // 开始监控粘贴事件
            $txt.on('paste', function (e) {
                pasteEvent = e;
                var data = pasteEvent.clipboardData || pasteEvent.originalEvent.clipboardData;
                var text;
                var items;

                // -------- 试图获取剪切板中的文字，有文字的情况下，就不处理图片粘贴 --------
                if (data == null) {
                    text = window.clipboardData && window.clipboardData.getData('text');
                } else {
                    text = data.getData('text/plain') || data.getData('text/html');
                }
                if (text) {
                    return;
                }

                items = data && data.items;
                if (items) {
                    // -------- chrome 可以用 data.items 取出图片 -----
                    E.log('通过 data.items 得到了数据');

                    $.each(items, function (key, value) {
                        var fileType = value.type || '';
                        if (fileType.indexOf('image') < 0) {
                            // 不是图片
                            return;
                        }

                        var file = value.getAsFile();
                        var reader = new FileReader();

                        E.log('得到一个粘贴图片');

                        reader.onload = function (e) {
                            E.log('读取到粘贴的图片');

                            // 执行上传
                            var base64 = e.target.result || this.result;
                            editor.xhrUploadImg({
                                event: pasteEvent,
                                base64: base64,
                                fileType: fileType,
                                name: uploadFileName
                            });
                        };

                        //读取粘贴的文件
                        reader.readAsDataURL(file);
                    });
                } else {
                    // -------- 非 chrome 不能用 data.items 取图片 -----

                    E.log('未从 data.items 得到数据，使用检测粘贴图片的方式');

                    // 获取
                    $imgsBeforePaste = $txt.find('img');
                    E.log('粘贴前，检查到编辑器有' + $imgsBeforePaste.length + '个图片');

                    // 异步上传找到的图片
                    setTimeout(findPasteImgAndUpload, 0);
                }
            });
        });
    });
    // 拖拽上传图片 插件
    _e(function (E, $) {

        E.plugin(function () {

            var editor = this;
            var txt = editor.txt;
            var $txt = txt.$txt;
            var config = editor.config;
            var uploadImgUrl = config.uploadImgUrl;
            var uploadFileName = config.uploadImgFileName || 'wangEditorDragFile';

            // 未配置上传图片url，则忽略
            if (!uploadImgUrl) {
                return;
            }

            // 阻止浏览器默认行为
            E.$document.on('dragleave drop dragenter dragover', function (e) {
                e.preventDefault();
            });

            // 监控 $txt drop 事件
            $txt.on('drop', function (dragEvent) {
                dragEvent.preventDefault();

                var originalEvent = dragEvent.originalEvent;
                var files = originalEvent.dataTransfer && originalEvent.dataTransfer.files;

                if (!files || !files.length) {
                    return;
                }

                $.each(files, function (k, file) {
                    var type = file.type;
                    var name = file.name;

                    if (type.indexOf('image/') < 0) {
                        // 只接收图片
                        return;
                    }

                    E.log('得到图片 ' + name);

                    var reader = new FileReader();
                    reader.onload = function (e) {
                        E.log('读取到图片 ' + name);

                        // 执行上传
                        var base64 = e.target.result || this.result;
                        editor.xhrUploadImg({
                            event: dragEvent,
                            base64: base64,
                            fileType: type,
                            name: uploadFileName
                        });
                    };

                    //读取粘贴的文件
                    reader.readAsDataURL(file);
                });
            });
        });
    });
    // 编辑器区域 table toolbar
    _e(function (E, $) {

        E.plugin(function () {
            var editor = this;
            var txt = editor.txt;
            var $txt = txt.$txt;
            var html = '';
            // 说明：设置了 max-height 之后，$txt.parent() 负责滚动处理
            var $currentTxt = editor.useMaxHeight ? $txt.parent() : $txt;
            var $currentTable;

            // 用到的dom节点
            var isRendered = false;
            var $toolbar = $('<div class="txt-toolbar"></div>');
            var $triangle = $('<div class="tip-triangle"></div>');
            var $delete = $('<a href="#"><i class="wangeditor-menu-img-trash-o"></i></a>');
            var $zoomSmall = $('<a href="#"><i class="wangeditor-menu-img-search-minus"></i></a>');
            var $zoomBig = $('<a href="#"><i class="wangeditor-menu-img-search-plus"></i></a>');

            // 渲染到页面
            function render() {
                if (isRendered) {
                    return;
                }

                // 绑定事件
                bindEvent();

                // 拼接 渲染到页面上
                $toolbar.append($triangle).append($delete).append($zoomSmall).append($zoomBig);
                editor.$editorContainer.append($toolbar);
                isRendered = true;
            }

            // 绑定事件
            function bindEvent() {
                // 统一执行命令的方法
                var commandFn;
                function command(e, callback) {
                    // 执行命令之前，先存储html内容
                    html = $txt.html();
                    // 监控内容变化
                    var cb = function cb() {
                        if (callback) {
                            callback();
                        }
                        if (html !== $txt.html()) {
                            $txt.change();
                        }
                    };
                    // 执行命令
                    if (commandFn) {
                        editor.customCommand(e, commandFn, cb);
                    }
                }

                // 删除
                $delete.click(function (e) {
                    commandFn = function commandFn() {
                        $currentTable.remove();
                    };
                    command(e, function () {
                        setTimeout(hide, 100);
                    });
                });

                // 放大
                $zoomBig.click(function (e) {
                    commandFn = function commandFn() {
                        $currentTable.css({
                            width: '100%'
                        });
                    };
                    command(e, function () {
                        setTimeout(show);
                    });
                });

                // 缩小
                $zoomSmall.click(function (e) {
                    commandFn = function commandFn() {
                        $currentTable.css({
                            width: 'auto'
                        });
                    };
                    command(e, function () {
                        setTimeout(show);
                    });
                });
            }

            // 显示 toolbar
            function show() {
                if (editor._disabled) {
                    // 编辑器已经被禁用，则不让显示
                    return;
                }
                if ($currentTable == null) {
                    return;
                }
                $currentTable.addClass('clicked');
                var tablePosition = $currentTable.position();
                var tableTop = tablePosition.top;
                var tableLeft = tablePosition.left;
                var tableHeight = $currentTable.outerHeight();
                var tableWidth = $currentTable.outerWidth();

                // --- 定位 toolbar ---

                // 计算初步结果
                var top = tableTop + tableHeight;
                var left = tableLeft;
                var marginLeft = 0;

                var txtTop = $currentTxt.position().top;
                var txtHeight = $currentTxt.outerHeight();
                if (top > txtTop + txtHeight) {
                    // top 不得超出编辑范围
                    top = txtTop + txtHeight;
                }

                // 显示（方便计算 margin）
                $toolbar.show();

                // 计算 margin
                var width = $toolbar.outerWidth();
                marginLeft = tableWidth / 2 - width / 2;

                // 定位
                $toolbar.css({
                    top: top + 5,
                    left: left,
                    'margin-left': marginLeft
                });
                // 如果定位太靠左了
                if (marginLeft < 0) {
                    // 得到三角形的margin-left
                    $toolbar.css('margin-left', '0');
                    $triangle.hide();
                } else {
                    $triangle.show();
                }
            }

            // 隐藏 toolbar
            function hide() {
                if ($currentTable == null) {
                    return;
                }
                $currentTable.removeClass('clicked');
                $currentTable = null;
                $toolbar.hide();
            }

            // click table 事件
            $currentTxt.on('click', 'table', function (e) {
                var $table = $(e.currentTarget);

                // 渲染
                render();

                if ($currentTable && $currentTable.get(0) === $table.get(0)) {
                    setTimeout(hide, 100);
                    return;
                }

                // 显示 toolbar
                $currentTable = $table;
                show();

                // 阻止冒泡
                e.preventDefault();
                e.stopPropagation();
            }).on('click keydown scroll', function (e) {
                setTimeout(hide, 100);
            });
            E.$body.on('click keydown scroll', function (e) {
                setTimeout(hide, 100);
            });
        });
    });
    // 编辑器区域 img toolbar
    _e(function (E, $) {

        if (E.userAgent.indexOf('MSIE 8') > 0) {
            return;
        }

        E.plugin(function () {
            var editor = this;
            var lang = editor.config.lang;
            var txt = editor.txt;
            var $txt = txt.$txt;
            var html = '';
            // 说明：设置了 max-height 之后，$txt.parent() 负责滚动处理
            var $currentTxt = editor.useMaxHeight ? $txt.parent() : $txt;
            var $editorContainer = editor.$editorContainer;
            var $currentImg;
            var currentLink = '';

            // 用到的dom节点
            var isRendered = false;
            var $dragPoint = $('<div class="img-drag-point"></div>');

            var $toolbar = $('<div class="txt-toolbar"></div>');
            var $triangle = $('<div class="tip-triangle"></div>');

            var $menuContainer = $('<div></div>');
            var $delete = $('<a href="#"><i class="wangeditor-menu-img-trash-o"></i></a>');
            var $zoomSmall = $('<a href="#"><i class="wangeditor-menu-img-search-minus"></i></a>');
            var $zoomBig = $('<a href="#"><i class="wangeditor-menu-img-search-plus"></i></a>');
            // var $floatLeft = $('<a href="#"><i class="wangeditor-menu-img-align-left"></i></a>');
            // var $noFloat = $('<a href="#"><i class="wangeditor-menu-img-align-justify"></i></a>');
            // var $floatRight = $('<a href="#"><i class="wangeditor-menu-img-align-right"></i></a>');
            var $alignLeft = $('<a href="#"><i class="wangeditor-menu-img-align-left"></i></a>');
            var $alignCenter = $('<a href="#"><i class="wangeditor-menu-img-align-center"></i></a>');
            var $alignRight = $('<a href="#"><i class="wangeditor-menu-img-align-right"></i></a>');
            var $link = $('<a href="#"><i class="wangeditor-menu-img-link"></i></a>');
            var $unLink = $('<a href="#"><i class="wangeditor-menu-img-unlink"></i></a>');

            var $linkInputContainer = $('<div style="display:none;"></div>');
            var $linkInput = $('<input type="text" style="height:26px; margin-left:10px; width:200px;"/>');
            var $linkBtnSubmit = $('<button class="right">' + lang.submit + '</button>');
            var $linkBtnCancel = $('<button class="right gray">' + lang.cancel + '</button>');

            // 记录是否正在拖拽
            var isOnDrag = false;

            // 获取 / 设置 链接
            function imgLink(e, url) {
                if (!$currentImg) {
                    return;
                }
                var commandFn;
                var callback = function callback() {
                    // 及时保存currentLink
                    if (url != null) {
                        currentLink = url;
                    }
                    if (html !== $txt.html()) {
                        $txt.change();
                    }
                };
                var $link;
                var inLink = false;
                var $parent = $currentImg.parent();
                if ($parent.get(0).nodeName.toLowerCase() === 'a') {
                    // 父元素就是图片链接
                    $link = $parent;
                    inLink = true;
                } else {
                    // 父元素不是图片链接，则重新创建一个链接
                    $link = $('<a target="_blank"></a>');
                }

                if (url == null) {
                    // url 无值，是获取链接
                    return $link.attr('href') || '';
                } else if (url === '') {
                    // url 是空字符串，是取消链接
                    if (inLink) {
                        commandFn = function commandFn() {
                            $currentImg.unwrap();
                        };
                    }
                } else {
                    // url 有值，是设置链接
                    if (url === currentLink) {
                        return;
                    }
                    commandFn = function commandFn() {
                        $link.attr('href', url);

                        if (!inLink) {
                            // 当前图片未包含在链接中，则包含进来
                            $currentImg.wrap($link);
                        }
                    };
                }

                // 执行命令
                if (commandFn) {
                    // 记录下执行命令之前的html内容
                    html = $txt.html();
                    // 执行命令
                    editor.customCommand(e, commandFn, callback);
                }
            }

            // 渲染到页面
            function render() {
                if (isRendered) {
                    return;
                }

                // 绑定事件
                bindToolbarEvent();
                bindDragEvent();

                // 菜单放入 container
                $menuContainer.append($delete).append($zoomSmall).append($zoomBig)
                // .append($floatLeft)
                // .append($noFloat)
                // .append($floatRight);
                .append($alignLeft).append($alignCenter).append($alignRight).append($link).append($unLink);

                // 链接input放入container
                $linkInputContainer.append($linkInput).append($linkBtnCancel).append($linkBtnSubmit);

                // 拼接 渲染到页面上
                $toolbar.append($triangle).append($menuContainer).append($linkInputContainer);

                editor.$editorContainer.append($toolbar).append($dragPoint);
                isRendered = true;
            }

            // 绑定toolbar事件
            function bindToolbarEvent() {
                // 统一执行命令的方法
                var commandFn;
                function customCommand(e, callback) {
                    var cb;
                    // 记录下执行命令之前的html内容
                    html = $txt.html();
                    cb = function cb() {
                        if (callback) {
                            callback();
                        }
                        if (html !== $txt.html()) {
                            $txt.change();
                        }
                    };
                    // 执行命令
                    if (commandFn) {
                        editor.customCommand(e, commandFn, cb);
                    }
                }

                // 删除
                $delete.click(function (e) {
                    // 删除之前先unlink
                    imgLink(e, '');

                    // 删除图片
                    commandFn = function commandFn() {
                        $currentImg.remove();
                    };
                    customCommand(e, function () {
                        setTimeout(hide, 100);
                    });
                });

                // 放大
                $zoomBig.click(function (e) {
                    commandFn = function commandFn() {
                        var img = $currentImg.get(0);
                        var width = img.width;
                        var height = img.height;
                        width = width * 1.1;
                        height = height * 1.1;

                        $currentImg.css({
                            width: width + 'px',
                            height: height + 'px'
                        });
                    };
                    customCommand(e, function () {
                        setTimeout(show);
                    });
                });

                // 缩小
                $zoomSmall.click(function (e) {
                    commandFn = function commandFn() {
                        var img = $currentImg.get(0);
                        var width = img.width;
                        var height = img.height;
                        width = width * 0.9;
                        height = height * 0.9;

                        $currentImg.css({
                            width: width + 'px',
                            height: height + 'px'
                        });
                    };
                    customCommand(e, function () {
                        setTimeout(show);
                    });
                });

                // // 左浮动
                // $floatLeft.click(function (e) {
                //     commandFn = function () {
                //         $currentImg.css({
                //             float: 'left'
                //         });
                //     };
                //     customCommand(e, function () {
                //         setTimeout(hide, 100);
                //     });
                // });

                // alignLeft
                $alignLeft.click(function (e) {
                    commandFn = function commandFn() {
                        // 如果 img 增加了链接，那么 img.parent() 就是 a 标签，设置 align 没用的，因此必须找到 P 父节点来设置 align
                        $currentImg.parents('p').css({
                            'text-align': 'left'
                        }).attr('align', 'left');
                    };
                    customCommand(e, function () {
                        setTimeout(hide, 100);
                    });
                });

                // // 右浮动
                // $floatRight.click(function (e) {
                //     commandFn = function () {
                //         $currentImg.css({
                //             float: 'right'
                //         });
                //     };
                //     customCommand(e, function () {
                //         setTimeout(hide, 100);
                //     });
                // });

                // alignRight
                $alignRight.click(function (e) {
                    commandFn = function commandFn() {
                        // 如果 img 增加了链接，那么 img.parent() 就是 a 标签，设置 align 没用的，因此必须找到 P 父节点来设置 align
                        $currentImg.parents('p').css({
                            'text-align': 'right'
                        }).attr('align', 'right');
                    };
                    customCommand(e, function () {
                        setTimeout(hide, 100);
                    });
                });

                // // 无浮动
                // $noFloat.click(function (e) {
                //     commandFn = function () {
                //         $currentImg.css({
                //             float: 'none'
                //         });
                //     };
                //     customCommand(e, function () {
                //         setTimeout(hide, 100);
                //     });
                // });

                // alignCenter
                $alignCenter.click(function (e) {
                    commandFn = function commandFn() {
                        // 如果 img 增加了链接，那么 img.parent() 就是 a 标签，设置 align 没用的，因此必须找到 P 父节点来设置 align
                        $currentImg.parents('p').css({
                            'text-align': 'center'
                        }).attr('align', 'center');
                    };
                    customCommand(e, function () {
                        setTimeout(hide, 100);
                    });
                });

                // link
                // 显示链接input
                $link.click(function (e) {
                    e.preventDefault();

                    // 获取当前链接，并显示
                    currentLink = imgLink(e);
                    $linkInput.val(currentLink);

                    $menuContainer.hide();
                    $linkInputContainer.show();
                });
                // 设置链接
                $linkBtnSubmit.click(function (e) {
                    e.preventDefault();

                    var url = $.trim($linkInput.val());
                    if (url) {
                        // 设置链接，同时会自动更新 currentLink 的值
                        imgLink(e, url);
                    }

                    // 隐藏 toolbar
                    setTimeout(hide);
                });
                // 取消设置链接
                $linkBtnCancel.click(function (e) {
                    e.preventDefault();

                    // 重置链接 input
                    $linkInput.val(currentLink);

                    $menuContainer.show();
                    $linkInputContainer.hide();
                });

                // unlink
                $unLink.click(function (e) {
                    e.preventDefault();

                    // 执行 unlink
                    imgLink(e, '');

                    // 隐藏 toolbar
                    setTimeout(hide);
                });
            }

            // 绑定drag事件
            function bindDragEvent() {
                var _x, _y;
                var dragMarginLeft, dragMarginTop;
                var imgWidth, imgHeight;

                function mousemove(e) {
                    var diffX, diffY;

                    // 计算差额
                    diffX = e.pageX - _x;
                    diffY = e.pageY - _y;

                    // --------- 计算拖拽点的位置 ---------
                    var currentDragMarginLeft = dragMarginLeft + diffX;
                    var currentDragMarginTop = dragMarginTop + diffY;
                    $dragPoint.css({
                        'margin-left': currentDragMarginLeft,
                        'margin-top': currentDragMarginTop
                    });

                    // --------- 计算图片的大小 ---------
                    var currentImgWidth = imgWidth + diffX;
                    var currentImggHeight = imgHeight + diffY;
                    $currentImg && $currentImg.css({
                        width: currentImgWidth,
                        height: currentImggHeight
                    });
                }

                $dragPoint.on('mousedown', function (e) {
                    if (!$currentImg) {
                        return;
                    }
                    // 当前鼠标位置
                    _x = e.pageX;
                    _y = e.pageY;

                    // 当前拖拽点的位置
                    dragMarginLeft = parseFloat($dragPoint.css('margin-left'), 10);
                    dragMarginTop = parseFloat($dragPoint.css('margin-top'), 10);

                    // 当前图片的大小
                    imgWidth = $currentImg.width();
                    imgHeight = $currentImg.height();

                    // 隐藏 $toolbar
                    $toolbar.hide();

                    // 绑定计算事件
                    E.$document.on('mousemove._dragResizeImg', mousemove);
                    E.$document.on('mouseup._dragResizeImg', function (e) {
                        // 取消绑定
                        E.$document.off('mousemove._dragResizeImg');
                        E.$document.off('mouseup._dragResizeImg');

                        // 隐藏，并还原拖拽点的位置
                        hide();
                        $dragPoint.css({
                            'margin-left': dragMarginLeft,
                            'margin-top': dragMarginTop
                        });

                        // 记录
                        isOnDrag = false;
                    });

                    // 记录
                    isOnDrag = true;
                });
            }

            // 显示 toolbar
            function show() {
                if (editor._disabled) {
                    // 编辑器已经被禁用，则不让显示
                    return;
                }
                if ($currentImg == null) {
                    return;
                }
                $currentImg.addClass('clicked');
                var imgPosition = $currentImg.position();
                var imgTop = imgPosition.top;
                var imgLeft = imgPosition.left;
                var imgHeight = $currentImg.outerHeight();
                var imgWidth = $currentImg.outerWidth();

                // --- 定位 dragpoint ---
                $dragPoint.css({
                    top: imgTop + imgHeight,
                    left: imgLeft + imgWidth
                });

                // --- 定位 toolbar ---

                // 计算初步结果
                var top = imgTop + imgHeight;
                var left = imgLeft;
                var marginLeft = 0;

                var txtTop = $currentTxt.position().top;
                var txtHeight = $currentTxt.outerHeight();
                if (top > txtTop + txtHeight) {
                    // top 不得超出编辑范围
                    top = txtTop + txtHeight;
                } else {
                    // top 超出编辑范围，dragPoint就不显示了
                    $dragPoint.show();
                }

                // 显示（方便计算 margin）
                $toolbar.show();

                // 计算 margin
                var width = $toolbar.outerWidth();
                marginLeft = imgWidth / 2 - width / 2;

                // 定位
                $toolbar.css({
                    top: top + 5,
                    left: left,
                    'margin-left': marginLeft
                });
                // 如果定位太靠左了
                if (marginLeft < 0) {
                    // 得到三角形的margin-left
                    $toolbar.css('margin-left', '0');
                    $triangle.hide();
                } else {
                    $triangle.show();
                }

                // disable 菜单
                editor.disableMenusExcept();
            }

            // 隐藏 toolbar
            function hide() {
                if ($currentImg == null) {
                    return;
                }
                $currentImg.removeClass('clicked');
                $currentImg = null;

                $toolbar.hide();
                $dragPoint.hide();

                // enable 菜单
                editor.enableMenusExcept();
            }

            // 判断img是否是一个表情
            function isEmotion(imgSrc) {
                var result = false;
                if (!editor.emotionUrls) {
                    return result;
                }
                $.each(editor.emotionUrls, function (index, url) {
                    var flag = false;
                    if (imgSrc === url) {
                        result = true;
                        flag = true;
                    }
                    if (flag) {
                        return false; // break 循环
                    }
                });
                return result;
            }

            // click img 事件
            $currentTxt.on('mousedown', 'img', function (e) {
                e.preventDefault();
            }).on('click', 'img', function (e) {
                var $img = $(e.currentTarget);
                var src = $img.attr('src');

                if (!src || isEmotion(src)) {
                    // 是一个表情图标
                    return;
                }

                // ---------- 不是表情图标 ----------

                // 渲染
                render();

                if ($currentImg && $currentImg.get(0) === $img.get(0)) {
                    setTimeout(hide, 100);
                    return;
                }

                // 显示 toolbar
                $currentImg = $img;
                show();

                // 默认显示menuContainer，其他默认隐藏
                $menuContainer.show();
                $linkInputContainer.hide();

                // 阻止冒泡
                e.preventDefault();
                e.stopPropagation();
            }).on('click keydown scroll', function (e) {
                if (!isOnDrag) {
                    setTimeout(hide, 100);
                }
            });
        });
    });
    // 编辑区域 link toolbar
    _e(function (E, $) {
        E.plugin(function () {
            var editor = this;
            var lang = editor.config.lang;
            var $txt = editor.txt.$txt;

            // 当前命中的链接
            var $currentLink;

            var $toolbar = $('<div class="txt-toolbar"></div>');
            var $triangle = $('<div class="tip-triangle"></div>');
            var $triggerLink = $('<a href="#" target="_blank"><i class="wangeditor-menu-img-link"></i> ' + lang.openLink + '</a>');
            var isRendered;

            // 记录当前的显示/隐藏状态
            var isShow = false;

            var showTimeoutId, hideTimeoutId;
            var showTimeoutIdByToolbar, hideTimeoutIdByToolbar;

            // 渲染 dom
            function render() {
                if (isRendered) {
                    return;
                }

                $toolbar.append($triangle).append($triggerLink);

                editor.$editorContainer.append($toolbar);

                isRendered = true;
            }

            // 定位
            function setPosition() {
                if (!$currentLink) {
                    return;
                }

                var position = $currentLink.position();
                var left = position.left;
                var top = position.top;
                var height = $currentLink.height();

                // 初步计算top值
                var topResult = top + height + 5;

                // 判断 toolbar 是否超过了编辑器区域的下边界
                var menuHeight = editor.menuContainer.height();
                var txtHeight = editor.txt.$txt.outerHeight();
                if (topResult > menuHeight + txtHeight) {
                    topResult = menuHeight + txtHeight + 5;
                }

                // 最终设置
                $toolbar.css({
                    top: topResult,
                    left: left
                });
            }

            // 显示 toolbar
            function show() {
                if (isShow) {
                    return;
                }

                if (!$currentLink) {
                    return;
                }

                render();

                $toolbar.show();

                // 设置链接
                var href = $currentLink.attr('href');
                $triggerLink.attr('href', href);

                // 定位
                setPosition();

                isShow = true;
            }

            // 隐藏 toolbar
            function hide() {
                if (!isShow) {
                    return;
                }

                if (!$currentLink) {
                    return;
                }

                $toolbar.hide();
                isShow = false;
            }

            // $txt 绑定事件
            $txt.on('mouseenter', 'a', function (e) {
                // 延时 500ms 显示toolbar
                if (showTimeoutId) {
                    clearTimeout(showTimeoutId);
                }
                showTimeoutId = setTimeout(function () {
                    var a = e.currentTarget;
                    var $a = $(a);
                    $currentLink = $a;

                    var $img = $a.children('img');
                    if ($img.length) {
                        // 该链接下包含一个图片

                        // 图片点击时，隐藏toolbar
                        $img.click(function (e) {
                            hide();
                        });

                        if ($img.hasClass('clicked')) {
                            // 图片还处于clicked状态，则不显示toolbar
                            return;
                        }
                    }

                    // 显示toolbar
                    show();
                }, 500);
            }).on('mouseleave', 'a', function (e) {
                // 延时 500ms 隐藏toolbar
                if (hideTimeoutId) {
                    clearTimeout(hideTimeoutId);
                }
                hideTimeoutId = setTimeout(hide, 500);
            }).on('click keydown scroll', function (e) {
                setTimeout(hide, 100);
            });
            // $toolbar 绑定事件
            $toolbar.on('mouseenter', function (e) {
                // 先中断掉 $txt.mouseleave 导致的隐藏
                if (hideTimeoutId) {
                    clearTimeout(hideTimeoutId);
                }
            }).on('mouseleave', function (e) {
                // 延时 500ms 显示toolbar
                if (showTimeoutIdByToolbar) {
                    clearTimeout(showTimeoutIdByToolbar);
                }
                showTimeoutIdByToolbar = setTimeout(hide, 500);
            });
        });
    });
    // menu吸顶
    _e(function (E, $) {

        E.plugin(function () {
            var editor = this;
            var menuFixed = editor.config.menuFixed;
            if (menuFixed === false || typeof menuFixed !== 'number') {
                // 没有配置菜单吸顶
                return;
            }
            var bodyMarginTop = parseFloat(E.$body.css('margin-top'), 10);
            if (isNaN(bodyMarginTop)) {
                bodyMarginTop = 0;
            }

            var $editorContainer = editor.$editorContainer;
            var editorTop = $editorContainer.offset().top;
            var editorHeight = $editorContainer.outerHeight();

            var $menuContainer = editor.menuContainer.$menuContainer;
            var menuCssPosition = $menuContainer.css('position');
            var menuCssTop = $menuContainer.css('top');
            var menuTop = $menuContainer.offset().top;
            var menuHeight = $menuContainer.outerHeight();

            var $txt = editor.txt.$txt;

            E.$window.scroll(function () {
                //全屏模式不支持
                if (editor.isFullScreen) {
                    return;
                }

                var sTop = E.$window.scrollTop();

                // 需要重新计算宽度，因为浏览器可能此时出现滚动条
                var menuWidth = $menuContainer.width();

                // 如果 menuTop === 0 说明此前编辑器一直隐藏，后来显示出来了，要重新计算相关数据
                if (menuTop === 0) {
                    menuTop = $menuContainer.offset().top;
                    editorTop = $editorContainer.offset().top;
                    editorHeight = $editorContainer.outerHeight();
                    menuHeight = $menuContainer.outerHeight();
                }

                if (sTop >= menuTop && sTop + menuFixed + menuHeight + 30 < editorTop + editorHeight) {
                    // 吸顶
                    $menuContainer.css({
                        position: 'fixed',
                        top: menuFixed
                    });

                    // 固定宽度
                    $menuContainer.width(menuWidth);

                    // 增加body margin-top
                    E.$body.css({
                        'margin-top': bodyMarginTop + menuHeight
                    });

                    // 记录
                    if (!editor._isMenufixed) {
                        editor._isMenufixed = true;
                    }
                } else {
                    // 取消吸顶
                    $menuContainer.css({
                        position: menuCssPosition,
                        top: menuCssTop
                    });

                    // 取消宽度固定
                    $menuContainer.css('width', '100%');

                    // 还原 body margin-top
                    E.$body.css({
                        'margin-top': bodyMarginTop
                    });

                    // 撤销记录
                    if (editor._isMenufixed) {
                        editor._isMenufixed = false;
                    }
                }
            });
        });
    });
    // 缩进 菜单插件
    _e(function (E, $) {

        // 用 createMenu 方法创建菜单
        E.createMenu(function (check) {

            // 定义菜单id，不要和其他菜单id重复。编辑器自带的所有菜单id，可通过『参数配置-自定义菜单』一节查看
            var menuId = 'indent';

            // check将检查菜单配置（『参数配置-自定义菜单』一节描述）中是否该菜单id，如果没有，则忽略下面的代码。
            if (!check(menuId)) {
                return;
            }

            // this 指向 editor 对象自身
            var editor = this;

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor, // 编辑器对象
                id: menuId, // 菜单id
                title: '缩进', // 菜单标题

                // 正常状态和选中装下的dom对象，样式需要自定义
                $domNormal: $('<a href="#" tabindex="-1"><i class="wangeditor-menu-img-indent-left"></i></a>'),
                $domSelected: $('<a href="#" tabindex="-1" class="selected"><i class="wangeditor-menu-img-indent-left"></i></a>')
            });

            // 菜单正常状态下，点击将触发该事件
            menu.clickEvent = function (e) {
                var elem = editor.getRangeElem();
                var p = editor.getSelfOrParentByName(elem, 'p');
                var $p;

                if (!p) {
                    // 未找到 p 元素，则忽略
                    return e.preventDefault();
                }
                $p = $(p);

                // 使用自定义命令
                function commandFn() {
                    $p.css('text-indent', '2em');
                }
                editor.customCommand(e, commandFn);
            };

            // 菜单选中状态下，点击将触发该事件
            menu.clickEventSelected = function (e) {
                var elem = editor.getRangeElem();
                var p = editor.getSelfOrParentByName(elem, 'p');
                var $p;

                if (!p) {
                    // 未找到 p 元素，则忽略
                    return e.preventDefault();
                }
                $p = $(p);

                // 使用自定义命令
                function commandFn() {
                    $p.css('text-indent', '0');
                }
                editor.customCommand(e, commandFn);
            };

            // 根据当前选区，自定义更新菜单的选中状态或者正常状态
            menu.updateSelectedEvent = function () {
                // 获取当前选区所在的父元素
                var elem = editor.getRangeElem();
                var p = editor.getSelfOrParentByName(elem, 'p');
                var $p;
                var indent;

                if (!p) {
                    // 未找到 p 元素，则标记为未处于选中状态
                    return false;
                }
                $p = $(p);
                indent = $p.css('text-indent');

                if (!indent || indent === '0px') {
                    // 得到的p，text-indent 属性是 0，则标记为未处于选中状态
                    return false;
                }

                // 找到 p 元素，并且 text-indent 不是 0，则标记为选中状态
                return true;
            };

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // 行高 菜单插件
    _e(function (E, $) {

        // 用 createMenu 方法创建菜单
        E.createMenu(function (check) {

            // 定义菜单id，不要和其他菜单id重复。编辑器自带的所有菜单id，可通过『参数配置-自定义菜单』一节查看
            var menuId = 'lineheight';

            // check将检查菜单配置（『参数配置-自定义菜单』一节描述）中是否该菜单id，如果没有，则忽略下面的代码。
            if (!check(menuId)) {
                return;
            }

            // this 指向 editor 对象自身
            var editor = this;

            // 由于浏览器自身不支持 lineHeight 命令，因此要做一个hook
            editor.commandHooks.lineHeight = function (value) {
                var rangeElem = editor.getRangeElem();
                var targetElem = editor.getSelfOrParentByName(rangeElem, 'p,h1,h2,h3,h4,h5,pre');
                if (!targetElem) {
                    return;
                }
                $(targetElem).css('line-height', value + '');
            };

            // 创建 menu 对象
            var menu = new E.Menu({
                editor: editor, // 编辑器对象
                id: menuId, // 菜单id
                title: '行高', // 菜单标题
                commandName: 'lineHeight', // 命令名称

                // 正常状态和选中装下的dom对象，样式需要自定义
                $domNormal: $('<a href="#" tabindex="-1"><i class="wangeditor-menu-img-arrows-v"></i></a>'),
                $domSelected: $('<a href="#" tabindex="-1" class="selected"><i class="wangeditor-menu-img-arrows-v"></i></a>')
            });

            // 数据源
            var data = {
                // 格式： 'value' : 'title'
                '1.0': '1.0倍',
                '1.5': '1.5倍',
                '1.8': '1.8倍',
                '2.0': '2.0倍',
                '2.5': '2.5倍',
                '3.0': '3.0倍'
            };

            // 为menu创建droplist对象
            var tpl = '<span style="line-height:{#commandValue}">{#title}</span>';
            menu.dropList = new E.DropList(editor, menu, {
                data: data, // 传入数据源
                tpl: tpl // 传入模板
            });

            // 增加到editor对象中
            editor.menus[menuId] = menu;
        });
    });
    // 自定义上传
    _e(function (E, $) {

        E.plugin(function () {

            var editor = this;
            var customUpload = editor.config.customUpload;
            if (!customUpload) {
                return;
            } else if (editor.config.uploadImgUrl) {
                alert('自定义上传无效，详看浏览器日志console.log');
                E.error('已经配置了 uploadImgUrl ，就不能再配置 customUpload ，两者冲突。将导致自定义上传无效。');
                return;
            }

            var $uploadContent = editor.$uploadContent;
            if (!$uploadContent) {
                E.error('自定义上传，无法获取 editor.$uploadContent');
            }

            // UI
            var $uploadIcon = $('<div class="upload-icon-container"><i class="wangeditor-menu-img-upload"></i></div>');
            $uploadContent.append($uploadIcon);

            // 设置id，并暴露
            var btnId = 'upload' + E.random();
            var containerId = 'upload' + E.random();
            $uploadIcon.attr('id', btnId);
            $uploadContent.attr('id', containerId);

            editor.customUploadBtnId = btnId;
            editor.customUploadContainerId = containerId;
        });
    });
    // 版权提示
    _e(function (E, $) {
        E.info('本页面富文本编辑器由 wangEditor 提供 http://wangeditor.github.io/ ');
    });

    // 最终返回wangEditor构造函数
    return window.wangEditorV2;
});

/***/ }),

/***/ 3558:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"question-wang-editor",style:(_vm.style)},[_c('wang-editor-v2',{model:{value:(_vm.html),callback:function ($$v) {_vm.html=$$v},expression:"html"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['question-rich-text', { 'has-ai-footer': _vm.enableAiOptimize && !_vm.disabled }]},[_c('div',{staticClass:"wangEditor-container"},[_c('input-html',{staticStyle:{"min-height":"117px"},attrs:{"inner-class":"wangEditor-txt","disabled":_vm.disabled,"placeholder":_vm.placeholder},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}}),_vm._v(" "),(!_vm.disabled)?_c('div',{staticClass:"question-rich-text-footer"},[(_vm.enableAiOptimize)?_c('el-tooltip',{attrs:{"content":"AI 优化描述内容","placement":"top"}},[_c('el-button',{staticStyle:{"padding":"0"},attrs:{"type":"text","size":"mini","loading":_vm.aiLoading},on:{"click":function($event){$event.stopPropagation();return _vm.onAiOptimize($event)}}},[(!_vm.aiLoading)?_c('span',[_vm._v("AI 优化")]):_vm._e()])],1):_vm._e(),_vm._v(" "),_c('el-tooltip',{attrs:{"content":"编辑富文本格式","placement":"top"}},[_c('el-button',{staticStyle:{"padding":"0"},attrs:{"type":"text","size":"mini","icon":"el-icon-edit"},on:{"click":function($event){$event.stopPropagation();return _vm.showRichTextEditor($event)}}})],1)],1):_vm._e()],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"AI 优化预览","visible":_vm.previewVisible,"width":"720px","append-to-body":""},on:{"update:visible":function($event){_vm.previewVisible=$event},"close":_vm.onPreviewClose}},[_c('el-row',{attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"ai-preview-label"},[_vm._v("原文")]),_vm._v(" "),_c('div',{staticClass:"ai-preview-content",domProps:{"innerHTML":_vm._s(_vm.previewOriginal)}})]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"ai-preview-label"},[_vm._v("优化后")]),_vm._v(" "),_c('div',{staticClass:"ai-preview-content",domProps:{"innerHTML":_vm._s(_vm.previewOptimized)}})])],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.previewVisible = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.applyOptimized}},[_vm._v("应用")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_SjQuestionInlineRichText_vue__ = __webpack_require__(3561);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_SjQuestionInlineRichText_vue__["a" /* default */]);

/***/ }),

/***/ 3561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionInlineRichText_vue__ = __webpack_require__(2585);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b22d628_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionInlineRichText_vue__ = __webpack_require__(3576);
function injectStyle (ssrContext) {
  __webpack_require__(3562)
  __webpack_require__(3564)
  this["$style"] = __webpack_require__(3566)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b22d628"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionInlineRichText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b22d628_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionInlineRichText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3562:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3563);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6af74255", content, true, {});

/***/ }),

/***/ 3563:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionInlineRichText.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3564:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3565);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("d5930bea", content, true, {});

/***/ }),

/***/ 3565:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".question-rich-text[data-v-5b22d628]{position:relative;line-height:normal}.question-rich-text .question-rich-text-footer[data-v-5b22d628]{position:absolute;bottom:5px;right:5px;opacity:0;-webkit-transition:opacity .1s ease-in;transition:opacity .1s ease-in}.question-rich-text:hover .question-rich-text-footer[data-v-5b22d628]{opacity:1}", "", {"version":3,"sources":["/workspace/src/views/question-editor/packages/sj-question-inline-rich-text/src/SjQuestionInlineRichText.vue"],"names":[],"mappings":"AACA,qCAAqC,kBAAkB,kBAAkB,CACxE,AACD,gEAAgE,kBAAkB,WAAW,UAAU,UAAU,uCAAwC,8BAA+B,CACvL,AACD,sEAAsE,SAAS,CAC9E","file":"SjQuestionInlineRichText.vue","sourcesContent":["\n.question-rich-text[data-v-5b22d628]{position:relative;line-height:normal\n}\n.question-rich-text .question-rich-text-footer[data-v-5b22d628]{position:absolute;bottom:5px;right:5px;opacity:0;-webkit-transition:0.1s opacity ease-in;transition:0.1s opacity ease-in\n}\n.question-rich-text:hover .question-rich-text-footer[data-v-5b22d628]{opacity:1\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3566:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3567);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("1a11f70b", content, true, {});

/***/ }),

/***/ 3567:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionInlineRichText.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3568:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InlineInputHtml_vue__ = __webpack_require__(2586);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_316a9802_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InlineInputHtml_vue__ = __webpack_require__(3575);
function injectStyle (ssrContext) {
  __webpack_require__(3569)
  __webpack_require__(3571)
  this["$style"] = __webpack_require__(3573)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-316a9802"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InlineInputHtml_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_316a9802_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InlineInputHtml_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3569:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3570);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("79c98d88", content, true, {});

/***/ }),

/***/ 3570:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"InlineInputHtml.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3571:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3572);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("4b3835a0", content, true, {});

/***/ }),

/***/ 3572:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".el-textarea[data-v-316a9802]{height:40px}.el-input__inner[data-v-316a9802]{resize:none;line-height:40px;padding-left:30px}.el-input__inner[contenteditable=true][data-v-316a9802]:empty:before{color:#c7cbd1;content:attr(placeholder);display:block}", "", {"version":3,"sources":["/workspace/src/views/question-editor/components/InlineInputHtml.vue"],"names":[],"mappings":"AACA,8BAA8B,WAAW,CACxC,AACD,kCAAkC,YAAY,iBAAiB,iBAAiB,CAC/E,AACD,qEAAqE,cAAc,0BAA0B,aAAa,CACzH","file":"InlineInputHtml.vue","sourcesContent":["\n.el-textarea[data-v-316a9802]{height:40px\n}\n.el-input__inner[data-v-316a9802]{resize:none;line-height:40px;padding-left:30px\n}\n.el-input__inner[contenteditable=true][data-v-316a9802]:empty:before{color:#c7cbd1;content:attr(placeholder);display:block\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3573:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3574);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("3d4e10f4", content, true, {});

/***/ }),

/***/ 3574:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"InlineInputHtml.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3575:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['el-input', _vm.disabled?'is-disabled':'']},[_c('div',{staticClass:"el-input__inner",attrs:{"placeholder":_vm.placeholder,"contenteditable":!_vm.disabled},domProps:{"innerHTML":_vm._s(_vm.html)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return (function () { return false; })($event)},"paste":function($event){$event.preventDefault();return _vm.onPaste($event)},"blur":_vm.input}}),_vm._v(" "),(_vm.icon)?_c('span',{staticClass:"el-input__prefix"},[_c('i',{class:['el-input__icon', _vm.icon]})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-rich-text"},[_c('input-html',{staticStyle:{"height":"40px"},attrs:{"disabled":_vm.disabled,"icon":_vm.prefixIcon,"placeholder":_vm.placeholder},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}}),_vm._v(" "),(!_vm.disabled)?_c('div',{staticClass:"question-rich-text-footer"},[_c('el-tooltip',{attrs:{"content":"编辑富文本格式","placement":"top"}},[_c('el-button',{staticStyle:{"padding":"0"},attrs:{"type":"text","size":"mini","icon":"el-icon-edit"},on:{"click":function($event){$event.stopPropagation();return _vm.showRichTextEditor($event)}}})],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3577:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionOption_vue__ = __webpack_require__(2587);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6efb241f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionOption_vue__ = __webpack_require__(3584);
function injectStyle (ssrContext) {
  __webpack_require__(3578)
  __webpack_require__(3580)
  this["$style"] = __webpack_require__(3582)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6efb241f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionOption_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6efb241f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionOption_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3578:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3579);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("3e603a87", content, true, {});

/***/ }),

/***/ 3579:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionOption.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3580:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3581);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("3dd2be3a", content, true, {});

/***/ }),

/***/ 3581:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionOption.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3582:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3583);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("0f8066bd", content, true, {});

/***/ }),

/***/ 3583:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionOption.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3584:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"options":_vm.options})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3585:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionOptionButton_vue__ = __webpack_require__(2588);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_783d5ad8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionOptionButton_vue__ = __webpack_require__(3592);
function injectStyle (ssrContext) {
  __webpack_require__(3586)
  __webpack_require__(3588)
  this["$style"] = __webpack_require__(3590)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-783d5ad8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionOptionButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_783d5ad8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionOptionButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3586:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3587);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("22a53257", content, true, {});

/***/ }),

/***/ 3587:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionOptionButton.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3588:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3589);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("b07f6dda", content, true, {});

/***/ }),

/***/ 3589:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionOptionButton.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3590:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3591);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("1886bd8d", content, true, {});

/***/ }),

/***/ 3591:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionOptionButton.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3592:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block"},on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionOptionItem_vue__ = __webpack_require__(2589);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7072136b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionOptionItem_vue__ = __webpack_require__(3600);
function injectStyle (ssrContext) {
  __webpack_require__(3594)
  __webpack_require__(3596)
  this["$style"] = __webpack_require__(3598)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7072136b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionOptionItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7072136b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionOptionItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3594:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3595);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("cb462e32", content, true, {});

/***/ }),

/***/ 3595:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionOptionItem.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3596:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3597);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("4896bc43", content, true, {});

/***/ }),

/***/ 3597:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionOptionItem.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3598:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3599);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("55007f1d", content, true, {});

/***/ }),

/***/ 3599:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionOptionItem.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3600:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"option":_vm.option,"index":_vm.index,"hasJump":_vm.hasJump,"jumpIndex":_vm.jumpIndex})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionImage_vue__ = __webpack_require__(2590);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0d5086e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionImage_vue__ = __webpack_require__(3604);
function injectStyle (ssrContext) {
  __webpack_require__(3602)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e0d5086e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0d5086e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3602:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3603);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("63f5cc9a", content, true, {});

/***/ }),

/***/ 3603:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionImage.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3604:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"contextmenu":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onContextmenu($event)}}},[_c('sj-question-file',{attrs:{"disabled":_vm.disabled}},[_c('draggable',{attrs:{"list":_vm.files,"options":{disabled: _vm.disabled}}},_vm._l((_vm.files),function(file,index){return _c('sj-question-file-item',{key:index,attrs:{"poster":file.src,"disabled":_vm.disabled,"selected":_vm.checkedFiles.includes(file)},on:{"remove":function($event){return _vm.remove(index)}},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.onCheck(index)},"contextmenu":function($event){$event.preventDefault();$event.stopPropagation();return (function (event){_vm.onContextmenu(event, index)})($event)}}})}),1),_vm._v(" "),_c('el-tooltip',{attrs:{"effect":"dark","content":"添加图片","placement":"top"}},[_c('sj-question-file-add',{attrs:{"disabled":_vm.disabled},on:{"click":_vm.upload}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3605:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionOneImage_vue__ = __webpack_require__(2591);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aab3fda6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionOneImage_vue__ = __webpack_require__(3608);
function injectStyle (ssrContext) {
  __webpack_require__(3606)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aab3fda6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjQuestionOneImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aab3fda6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjQuestionOneImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3606:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3607);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("4e5b05ff", content, true, {});

/***/ }),

/***/ 3607:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SjQuestionOneImage.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3608:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"contextmenu":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onContextmenu($event)}}},[_c('sj-question-file',{attrs:{"disabled":_vm.disabled}},[_vm._l((_vm.progress),function(ref,index){
var percentage = ref.percentage;
return _c('sj-question-file-progress',{key:index,attrs:{"percentage":percentage}})}),_vm._v(" "),_vm._l((_vm.files),function(file,index){return _c('sj-question-file-item',{key:index,attrs:{"poster":file.src,"disabled":_vm.disabled},on:{"remove":function($event){return _vm.remove(index)}},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.view(index)},"contextmenu":function($event){$event.preventDefault();$event.stopPropagation();return (function (event){_vm.onContextmenu(event, index)})($event)}}})}),_vm._v(" "),_c('el-tooltip',{attrs:{"effect":"dark","content":"添加图片","placement":"top"}},[_c('sj-question-file-add',{attrs:{"disabled":_vm.disabled || _vm.files.length > 0},on:{"click":function($event){return _vm.$refs.selectFile.click()}}})],1)],2),_vm._v(" "),(!_vm.disabled)?_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"selectFile",attrs:{"type":"file","accept":".png,.jpg,.jpeg,.gif"},on:{"change":_vm.upload}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3609:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sj-question-item',{ref:"sjQuestionItem",attrs:{"prop":_vm.questionIndex},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('div',{on:{"click":function($event){return _vm.onQuestionFocus(_vm.questionIndex)}}},[_c('layout-panel',{class:['question-panel', _vm.focusClass],staticStyle:{"margin-bottom":"10px"},attrs:{"collapse":_vm.collapse},on:{"update:collapse":function($event){_vm.collapse=$event}}},[_c('template',{slot:"header"},[_c('span',{attrs:{"title":_vm.question.id}},[_vm._v("Q"+_vm._s(_vm.questionIndex + 1)+" "+_vm._s(_vm.types[_vm.question.type]))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(prop.hasJump),expression:"prop.hasJump"}],staticClass:"sj-icon-logic"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.collapse),expression:"collapse"}],staticClass:"text-ellipsis",staticStyle:{"width":"300px","font-weight":"normal"},domProps:{"innerHTML":_vm._s(_vm.question.title)}})]),_vm._v(" "),_c('template',{slot:"tools"},[_c('div',{staticClass:"question-toolbar"},[(_vm.isAppend || !_vm.disabled)?[(!_vm.isAppend)?_c('span',{staticStyle:{"display":"inline-block"}},[_c('sj-question-tooltip',{attrs:{"content":"拖拽排序"}},[_c('button',{staticClass:"sj-icon-move-dot drag-question-button"})])],1):_vm._e(),_vm._v(" "),_vm._l((_vm.buttons),function(ref){
var tip = ref.tip;
var icon = ref.icon;
var action = ref.action;
return [_c('sj-question-tooltip',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapse),expression:"!collapse"}],attrs:{"content":tip}},[_c('sj-question-button',{staticStyle:{"display":"inline-block"},attrs:{"action":action},model:{value:(_vm.questions),callback:function ($$v) {_vm.questions=$$v},expression:"questions"}},[_c('button',{class:icon})])],1)]})]:_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"display":"inline-block"}},[_c('sj-question-tooltip',{attrs:{"content":"发送到模板"}},[_c('button',{staticClass:"sj-icon-share",on:{"click":function($event){$event.stopPropagation();return _vm.sendQuestionTo($event)}}})])],1)],2)]),_vm._v(" "),_c('el-form',{ref:"questionForm",attrs:{"rules":_vm.questionRules,"model":_vm.question},nativeOn:{"submit":function($event){$event.preventDefault();}}},[_c('el-form-item',{attrs:{"prop":"title"}},[_c('sj-question-inline-rich-text',{attrs:{"prefix-icon":"sj-icon-title","disabled":_vm.disabled,"placeholder":"请输入题目标题"},on:{"input":_vm.validateTitle},model:{value:(_vm.question.title),callback:function ($$v) {_vm.$set(_vm.question, "title", $$v)},expression:"question.title"}})],1),_vm._v(" "),_c('el-row',[_c('el-col',[_c('el-form-item',{attrs:{"prop":"text"}},[_c('sj-question-inline-rich-text',{attrs:{"prefix-icon":"sj-icon-moban","disabled":_vm.disabled,"toolbar":[
                      ['bold', 'italic', 'underline', 'strike'],
                      [{'color': ['', '#F00']}],
                      ['clean'] ],"placeholder":"请输入后端描述"},model:{value:(_vm.question.auditText),callback:function ($$v) {_vm.$set(_vm.question, "auditText", $$v)},expression:"question.auditText"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":15}},[_c('el-col',{attrs:{"lg":12}},[_c('el-form-item',{attrs:{"prop":"text"}},[_c('sj-question-rich-text',{attrs:{"disabled":_vm.disabled,"placeholder":"请输入描述内容，请勿直接从Word、WPS等文字编辑软件直接复制粘贴带有格式的文字，模板内的复制粘贴是允许的。"},on:{"click":function($event){return _vm.onQuestionFocus(_vm.questionIndex)}},model:{value:(_vm.question.text),callback:function ($$v) {_vm.$set(_vm.question, "text", $$v)},expression:"question.text"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"lg":12}},[_c('el-form-item',{attrs:{"prop":"images"}},[_c('sj-question-image',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.question.images),callback:function ($$v) {_vm.$set(_vm.question, "images", $$v)},expression:"question.images"}})],1)],1)],1),_vm._v(" "),(_vm.question.options)?[_c('sj-question-option',{attrs:{"model":_vm.question.options}},[_c('draggable',{attrs:{"list":_vm.question.options,"options":{disabled: _vm.disabled, handle: '.drag-option-button'}}},[_c('transition-group',_vm._l((_vm.question.options),function(option,optionIndex){return _c('sj-question-option-item',{key:option.id,staticClass:"question-option",attrs:{"prop":optionIndex},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.onQuestionFocus(_vm.questionIndex, optionIndex)}}},[_c('el-form',{ref:"optionForm",refInFor:true,attrs:{"rules":_vm.questionOptionRules,"model":option},nativeOn:{"submit":function($event){$event.preventDefault();}}},[_c('el-form-item',{attrs:{"prop":"title"}},[_c('el-container',{attrs:{"gutter":15}},[_c('div',{staticClass:"width-max"},[_c('el-input',{attrs:{"prefix-icon":_vm.getOptionIcon(_vm.question.type),"suffix-icon":prop.hasJump?'sj-icon-logic':'',"disabled":_vm.disabled,"placeholder":"请输入选项标题"},model:{value:(option.title),callback:function ($$v) {_vm.$set(option, "title", $$v)},expression:"option.title"}},[_c('template',{slot:"prepend"},[_c('span',[_vm._v("OPT"+_vm._s(optionIndex + 1))])])],2)],1),_vm._v(" "),(!_vm.disabled)?_c('div',{staticClass:"question-option-toolbar"},[_c('sj-question-tooltip',{attrs:{"content":"拖拽排序"}},[_c('el-button',{staticClass:"drag-option-button",attrs:{"icon":"sj-icon-move-dot"}})],1),_vm._v(" "),_vm._l((_vm.buttons),function(ref){
                    var tip = ref.tip;
                    var icon = ref.icon;
                    var action = ref.action;
return [_c('sj-question-tooltip',{attrs:{"content":tip}},[_c('sj-question-option-button',{attrs:{"action":action},model:{value:(_vm.question.options),callback:function ($$v) {_vm.$set(_vm.question, "options", $$v)},expression:"question.options"}},[_c('el-button',{attrs:{"icon":icon}})],1)],1)]})],2):_vm._e()])],1),_vm._v(" "),(_vm.question.type === 'select')?[_c('el-row',{attrs:{"gutter":15}},[_c('el-col',{attrs:{"lg":12}},[_c('el-form-item',{attrs:{"prop":"text"}},[_c('sj-question-wang-rich-text',{attrs:{"disabled":_vm.disabled,"placeholder":"请输入示例内容，请勿直接从Word、WPS等文字编辑软件直接复制粘贴带有格式的文字，模板内的复制粘贴是允许的。"},model:{value:(option.exampleText),callback:function ($$v) {_vm.$set(option, "exampleText", $$v)},expression:"option.exampleText"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"lg":12}},[_c('el-form-item',{attrs:{"prop":"exampleImages"}},[_c('sj-question-image',{attrs:{"disabled":_vm.disabled},model:{value:(option.exampleImages),callback:function ($$v) {_vm.$set(option, "exampleImages", $$v)},expression:"option.exampleImages"}})],1)],1)],1)]:_vm._e(),_vm._v(" "),(_vm.question.type === 'imageMultiselect')?[_c('el-form-item',{attrs:{"prop":"images"}},[_c('sj-question-one-image',{attrs:{"disabled":_vm.disabled},model:{value:(option.images),callback:function ($$v) {_vm.$set(option, "images", $$v)},expression:"option.images"}})],1)]:_vm._e()],2)],1)]}}],null,true)})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"options"}},[(!_vm.disabled)?_c('sj-question-option-button',{staticStyle:{"width":"100%"},attrs:{"action":"add","options":{type: _vm.question.type}},model:{value:(_vm.question.options),callback:function ($$v) {_vm.$set(_vm.question, "options", $$v)},expression:"question.options"}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"plain":""}},[_vm._v("添加选项\n                  ")])],1):_vm._e()],1)],1)]:_vm._e()],2)],2)],1),_vm._v(" "),(_vm.visibleGuide)?_c('layout-panel',{class:['question-panel', _vm.focusClass],staticStyle:{"margin-bottom":"10px"},attrs:{"collapse":_vm.collapseGuide},on:{"update:collapse":function($event){_vm.collapseGuide=$event}}},[_c('template',{slot:"header"},[_c('span',{attrs:{"title":_vm.question.id}},[_vm._v("Q"+_vm._s(_vm.questionIndex + 1))]),_vm._v(" "),_c('span',[_vm._v("任务指引")])]),_vm._v(" "),_c('el-form',{attrs:{"label-position":"top","label-width":"70px"},nativeOn:{"submit":function($event){$event.preventDefault();}}},[_c('el-form-item',{attrs:{"prop":"guideText"}},[_c('el-input',{attrs:{"placeholder":"请输入任务指引说明","disabled":_vm.disabledGuide},model:{value:(_vm.question.guideText),callback:function ($$v) {_vm.$set(_vm.question, "guideText", $$v)},expression:"question.guideText"}})],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":15}},[_c('el-col',{attrs:{"lg":12}},[_c('el-form-item',{attrs:{"prop":"guideVideo"}},[_c('sj-question-guide-video',{attrs:{"disabled":_vm.disabledGuide},model:{value:(_vm.question.guideVideo),callback:function ($$v) {_vm.$set(_vm.question, "guideVideo", $$v)},expression:"question.guideVideo"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"lg":12}},[_c('el-form-item',{attrs:{"prop":"guideAudio"}},[_c('sj-question-guide-audio',{attrs:{"disabled":_vm.disabledGuide},model:{value:(_vm.question.guideAudio),callback:function ($$v) {_vm.$set(_vm.question, "guideAudio", $$v)},expression:"question.guideAudio"}})],1)],1)],1)],1)],2):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"20px"}})]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3610:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sj-question',{attrs:{"model":_vm.page.questions,"fixed-ids":_vm.page.appendQuestionIds,"scroll":"#main"}},[_c('draggable',{attrs:{"options":{handle: '.drag-question-button', group: 'questions'}},on:{"update":_vm.updateSort},model:{value:(_vm.draggableQuestions),callback:function ($$v) {_vm.draggableQuestions=$$v},expression:"draggableQuestions"}},[_c('transition-group',{class:['step-template-questions-group', 'drag-add-placeholder']},_vm._l((_vm.draggableQuestions),function(question,questionIndex){return _c('div',{key:question.id},[_c('step-template-question',{ref:"form",refInFor:true,attrs:{"question-index":questionIndex}})],1)}),0)],1),_vm._v(" "),_vm._l((_vm.appendQuestions),function(question,questionIndex){return _c('div',{key:question.id},[_c('step-template-question',{ref:"form",refInFor:true,staticClass:"margin t20",attrs:{"question-index":_vm.draggableQuestions.length + questionIndex}})],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3611:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateQuestionType_vue__ = __webpack_require__(2592);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_347edbe3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateQuestionType_vue__ = __webpack_require__(3618);
function injectStyle (ssrContext) {
  __webpack_require__(3612)
  __webpack_require__(3614)
  this["$style"] = __webpack_require__(3616)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-347edbe3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateQuestionType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_347edbe3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateQuestionType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3612:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3613);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("64b53a6e", content, true, {});

/***/ }),

/***/ 3613:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"StepTemplateQuestionType.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3614:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3615);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("68acd924", content, true, {});

/***/ }),

/***/ 3615:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".question-type-list[data-v-347edbe3]{margin:0;padding:0;list-style-type:none}.question-type-list li[data-v-347edbe3]{margin-bottom:10px}button[data-v-347edbe3]{white-space:normal;line-height:18px}", "", {"version":3,"sources":["/workspace/src/views/step-template/components/StepTemplateQuestionType.vue"],"names":[],"mappings":"AACA,qCAAqC,SAAS,UAAU,oBAAoB,CAC3E,AACD,wCAAwC,kBAAkB,CACzD,AACD,wBAAwB,mBAAmB,gBAAgB,CAC1D","file":"StepTemplateQuestionType.vue","sourcesContent":["\n.question-type-list[data-v-347edbe3]{margin:0;padding:0;list-style-type:none\n}\n.question-type-list li[data-v-347edbe3]{margin-bottom:10px\n}\nbutton[data-v-347edbe3]{white-space:normal;line-height:18px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3616:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3617);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("665db690", content, true, {});

/***/ }),

/***/ 3617:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"StepTemplateQuestionType.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3618:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-type-panel"},[_c('layout-panel',{attrs:{"hide-collapse":""}},[_c('template',{slot:"header"},[_vm._v("\n      题型列表\n    ")]),_vm._v(" "),_c('ul',{staticClass:"question-type-list"},[_c('draggable',{attrs:{"options":{sort: false, group: {name:'questions', pull:'clone', put:false}, disabled: _vm.disabled},"clone":_vm.clone},model:{value:(_vm.typeList),callback:function ($$v) {_vm.typeList=$$v},expression:"typeList"}},[_c('transition-group',_vm._l((_vm.typeList),function(type){return _c('li',{key:type},[(_vm.disabled)?_c('el-button',{attrs:{"disabled":_vm.disabled,"plain":"","size":"mini"}},[_vm._v("\n              "+_vm._s(_vm.types[type])+"\n            ")]):_c('sj-question-button',{attrs:{"action":"add","options":{type: type}},model:{value:(_vm.questions),callback:function ($$v) {_vm.questions=$$v},expression:"questions"}},[_c('el-button',{attrs:{"plain":"","size":"mini"}},[_vm._v("\n                "+_vm._s(_vm.types[type])+"\n              ")])],1)],1)}),0)],1)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3619:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main_js__ = __webpack_require__(3620);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main_js__["a" /* default */]);

/***/ }),

/***/ 3620:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export QuestionCacheBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_vue__ = __webpack_require__(3621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cache__ = __webpack_require__(3629);






var defaults = {};

var MainConstructor = __WEBPACK_IMPORTED_MODULE_2_vue___default.a.extend(__WEBPACK_IMPORTED_MODULE_3__main_vue__["a" /* default */]);

var instance = void 0,
    currentBox = void 0,
    cache = void 0;

var defaultCallback = function defaultCallback(action, value) {
  if (currentBox) {
    var callback = currentBox.callback;
    if (typeof callback === 'function') {
      callback(value);
    }
    if (currentBox.resolve) {
      if (action === 'confirm') {
        currentBox.resolve(value);
      } else if (currentBox.reject && (action === 'cancel' || action === 'close')) {
        currentBox.reject(action);
      }
    }
  }
};

var initInstance = function initInstance() {
  instance = new MainConstructor({
    el: document.createElement('div')
  });

  instance.callback = defaultCallback;
  instance.cache = cache;
};

var showBox = function showBox() {
  if (!instance) {
    initInstance();
  }

  instance.action = '';

  if (!instance.visible || instance.closeTimer) {
    if (currentBox) {
      var options = currentBox.options;
      for (var prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop];
        }
      }

      if (options.callback === undefined) {
        instance.callback = defaultCallback;
      }

      var oldCb = instance.callback;
      instance.callback = function (action, value) {
        oldCb(action, value);
      };

      document.body.appendChild(instance.$el);

      __WEBPACK_IMPORTED_MODULE_2_vue___default.a.nextTick(function () {
        instance.visible = true;
      });
    }
  }
};

var QuestionCacheBox = function QuestionCacheBox(options, callback) {
  if (__WEBPACK_IMPORTED_MODULE_2_vue___default.a.prototype.$isServer) return;
  if (typeof options === 'string') {
    options = {
      key: options
    };
  } else if (options.callback && !callback) {
    callback = options.callback;
  }

  if (typeof __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a !== 'undefined') {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      // eslint-disable-line
      currentBox = {
        options: _.merge({}, defaults, QuestionCacheBox.defaults, options),
        callback: callback,
        resolve: resolve,
        reject: reject
      };

      showBox();
    });
  } else {
    currentBox = {
      options: _.merge({}, defaults, QuestionCacheBox.defaults, options),
      callback: callback
    };

    showBox();
  }
};

QuestionCacheBox.setDefaults = function (defaults) {
  QuestionCacheBox.defaults = defaults;
};

QuestionCacheBox.cache = function (name, key, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (!cache) {
    cache = new __WEBPACK_IMPORTED_MODULE_4__cache__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ name: name }, options));
  }
  cache.set(key, value);
};

QuestionCacheBox.open = function (name, key, options) {
  if (!cache) {
    cache = new __WEBPACK_IMPORTED_MODULE_4__cache__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ name: name }, options));
  }
  return QuestionCacheBox(_.merge({
    key: key
  }, options));
};

QuestionCacheBox.close = function () {
  instance.doClose();
  instance.visible = false;
  currentBox = null;
};

QuestionCacheBox.destroy = function () {
  if (instance) {
    instance.$el.remove();
    instance.$destroy();
    instance = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (QuestionCacheBox);


/***/ }),

/***/ 3621:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(2593);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_444d2d28_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(3628);
function injectStyle (ssrContext) {
  __webpack_require__(3622)
  __webpack_require__(3624)
  this["$style"] = __webpack_require__(3626)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-444d2d28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_444d2d28_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3622:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3623);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("78b1b943", content, true, {});

/***/ }),

/***/ 3623:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3624:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3625);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("78aa0f13", content, true, {});

/***/ }),

/***/ 3625:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3626:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3627);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("e76e1c0e", content, true, {});

/***/ }),

/***/ 3627:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3628:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"缓存读取","visible":_vm.visible,"width":"810px"},on:{"update:visible":function($event){_vm.visible=$event},"close":_vm.onClose}},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.table.slice((_vm.pagination.current_page - 1) * _vm.pagination.per_page, _vm.pagination.current_page * _vm.pagination.per_page),"stripe":"","highlight-current-row":"","border":"","element-loading-text":"正在读取缓存中……"}},[_c('el-table-column',{attrs:{"prop":"key","label":"KEY"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":"创建日期","width":"185"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updated_at","label":"更新日期","width":"185"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"80"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"warning","size":"mini"},on:{"click":function($event){return _vm.onRead(scope.row.key)}}},[_vm._v("读取\n        ")])]}}])})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"15px"}},[_c('el-pagination',{attrs:{"background":"","layout":"total, prev, pager, next, jumper","current-page":_vm.pagination.current_page,"page-size":_vm.pagination.per_page,"total":_vm.pagination.total},on:{"current-change":_vm.handleCurrentPageChange}})],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){return _vm.handleAction('cancel')}}},[_vm._v("关 闭")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3629:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Cache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__db_outline_db__ = __webpack_require__(3630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__db_cache_db__ = __webpack_require__(3631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__db_version_db__ = __webpack_require__(3632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_question_editor_components_question_cache_box_utils__ = __webpack_require__(3633);










var queues = {};

var Cache = function () {
  function Cache(config) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Cache);

    this.config = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
      cacheMax: 30,
      versionMax: 30
    }, config);
    this.version = new __WEBPACK_IMPORTED_MODULE_7__db_version_db__["a" /* default */](this.config);
    this.outline = new __WEBPACK_IMPORTED_MODULE_5__db_outline_db__["a" /* default */](this.config);
    this.cache = new __WEBPACK_IMPORTED_MODULE_6__db_cache_db__["a" /* default */](this.config);

    this.outline.get('temp').then(function (temp) {
      if (temp) {
        // 判断该版本是否存在
        _this.cache.get(temp.key).then(function (versions) {
          var index = -1;
          // 获得数据的 MD5 key
          var versionKey = _this.version.makeKey(temp.key, temp.data);
          // 判断版本key是否存在
          if (versions) {
            index = versions.findIndex(function (_ref) {
              var key = _ref.key;
              return key === versionKey;
            });
          } else {
            versions = [];
          }
          // 不存在则写入该版本
          if (index === -1) {
            versions.push({
              key: versionKey,
              created_at: temp.created_at,
              updated_at: temp.updated_at
            });

            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this.cache.set(temp.key, versions), _this.version.set(versionKey, temp.data)]).then(function () {
              // 判断是否超出最大缓存数
              _this.removeCacheMax(temp.key);
              // 判断是否超出最大版本数
              _this.removeVersionMax(temp.key);
            });
          }
        });
        // 移除临时缓存
        _this.outline.remove('temp');
      }
    });
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Cache, [{
    key: 'getVersion',
    value: function getVersion(key) {
      return this.version.get(key);
    }
  }, {
    key: 'set',
    value: function set(key, data) {
      queues[key] = data;
      return this.nextSet();
    }
  }, {
    key: 'nextSet',
    value: function nextSet() {
      var _this2 = this;

      var setKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(queues);
      if (setKeys.length) {
        var key = setKeys[0];
        var data = queues[key];
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          _this2.outline.get('temp').then(function (temp) {
            // 获得创建该缓存的时间
            var createdAt = Object(__WEBPACK_IMPORTED_MODULE_8__views_question_editor_components_question_cache_box_utils__["a" /* nowDateString */])();
            if (temp) {
              createdAt = temp.created_at;
            }
            // 写入临时缓存
            _this2.outline.set('temp', {
              key: key,
              data: data,
              created_at: createdAt,
              updated_at: Object(__WEBPACK_IMPORTED_MODULE_8__views_question_editor_components_question_cache_box_utils__["a" /* nowDateString */])()
            }).then(resolve, reject).finally(function () {
              delete queues[key];
              _this2.nextSet();
            });
          });
        });
      }
    }
  }, {
    key: 'table',
    value: function table(key) {
      return this.cache.get(key);
    }
  }, {
    key: 'remove',
    value: function remove(key) {
      var _this3 = this;

      this.cache.get(key).then(function (versions) {
        if (versions) {
          _this3.version.remove(versions.map(function (_ref2) {
            var key = _ref2.key;
            return key;
          }));
          _this3.cache.remove(key);
        }
      });
    }
  }, {
    key: 'removeCacheMax',
    value: function removeCacheMax(key) {
      var _this4 = this;

      // 判断是否超出最大缓存数
      this.outline.get('cacheKeys').then(function (cacheKeys) {
        if (cacheKeys) {
          // 加入新的key
          if (!cacheKeys.includes(key)) {
            cacheKeys.push(key);
          }
          // 缓存数超出，删除最旧的记录
          if (cacheKeys.length > _this4.config.cacheMax) {
            _this4.remove(cacheKeys[0]);
            cacheKeys.splice(0, 1);
          }
          // 更新缓存key列表
          _this4.outline.set('cacheKeys', cacheKeys);
        } else {
          _this4.outline.set('cacheKeys', [key]);
        }
      });
    }
  }, {
    key: 'removeVersionMax',
    value: function removeVersionMax(key) {
      var _this5 = this;

      // 判断是否超出最大缓存数
      this.cache.get(key).then(function (versions) {
        if (versions) {
          // 缓存数超出，删除最旧的记录
          if (versions.length > _this5.config.versionMax) {
            _this5.version.remove(versions[0].key);
            versions.splice(0, 1);
            // 更新缓存key列表
            _this5.cache.set(key, versions);
          }
        }
      });
    }
  }]);

  return Cache;
}();


/* harmony default export */ __webpack_exports__["a"] = (Cache);

/***/ }),

/***/ 3630:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OutlineDB */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_localforage__ = __webpack_require__(1764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_localforage__);




var OutlineDB = function () {
  function OutlineDB(config) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, OutlineDB);

    this.config = config;
    this.db = __WEBPACK_IMPORTED_MODULE_2_localforage___default.a.createInstance({
      name: config.name,
      storeName: 'cache-outline'
    });
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(OutlineDB, [{
    key: 'get',
    value: function get(key) {
      return this.db.getItem(key);
    }
  }, {
    key: 'set',
    value: function set(key, value) {
      return this.db.setItem(key, value);
    }
  }, {
    key: 'remove',
    value: function remove(keys) {
      var _this = this;

      if (keys.constructor !== Array) {
        keys = [keys];
      }
      keys.forEach(function (key) {
        _this.db.removeItem(key);
      });
    }
  }]);

  return OutlineDB;
}();


/* harmony default export */ __webpack_exports__["a"] = (OutlineDB);

/***/ }),

/***/ 3631:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CacheDB */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_localforage__ = __webpack_require__(1764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_localforage__);




var CacheDB = function () {
  function CacheDB(config) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CacheDB);

    this.config = config;
    this.db = __WEBPACK_IMPORTED_MODULE_2_localforage___default.a.createInstance({
      name: config.name,
      storeName: 'cache'
    });
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CacheDB, [{
    key: 'get',
    value: function get(key) {
      return this.db.getItem(key);
    }
  }, {
    key: 'set',
    value: function set(key, value) {
      return this.db.setItem(key, value);
    }
  }, {
    key: 'remove',
    value: function remove(keys) {
      var _this = this;

      if (keys.constructor !== Array) {
        keys = [keys];
      }
      keys.forEach(function (key) {
        _this.db.removeItem(key);
      });
    }
  }]);

  return CacheDB;
}();


/* harmony default export */ __webpack_exports__["a"] = (CacheDB);

/***/ }),

/***/ 3632:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VersionDB */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_localforage__ = __webpack_require__(1764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_crypto_js_md5__ = __webpack_require__(1884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_crypto_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_crypto_js_md5__);






var VersionDB = function () {
  function VersionDB(config) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, VersionDB);

    this.db = __WEBPACK_IMPORTED_MODULE_3_localforage___default.a.createInstance({
      name: config.name,
      storeName: 'cache-versions'
    });
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(VersionDB, [{
    key: 'get',
    value: function get(key) {
      return this.db.getItem(key);
    }
  }, {
    key: 'set',
    value: function set(key, data) {
      return this.db.setItem(key, data);
    }
  }, {
    key: 'makeKey',
    value: function makeKey(key, data) {
      return key + '_' + __WEBPACK_IMPORTED_MODULE_4_crypto_js_md5___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)).toString();
    }
  }, {
    key: 'remove',
    value: function remove(keys) {
      var _this = this;

      if (keys.constructor !== Array) {
        keys = [keys];
      }
      keys.forEach(function (key) {
        _this.db.removeItem(key);
      });
    }
  }]);

  return VersionDB;
}();


/* harmony default export */ __webpack_exports__["a"] = (VersionDB);

/***/ }),

/***/ 3633:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return nowDateString; });
function nowDateString() {
  return filter.formatDate(new Date());
}



/***/ }),

/***/ 3634:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main_js__ = __webpack_require__(3635);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main_js__["a" /* default */]);

/***/ }),

/***/ 3635:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export QuestionTreeBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_vue__ = __webpack_require__(3636);





var defaults = {};

var MainConstructor = __WEBPACK_IMPORTED_MODULE_2_vue___default.a.extend(__WEBPACK_IMPORTED_MODULE_3__main_vue__["a" /* default */]);

var instance = void 0,
    currentBox = void 0;

var types = {
  info: '文字题',
  text: '填空题',
  multitext: '多项填空题',
  select: '单选题',
  multiselect: '多选题',
  imageMultiselect: '图片多选题'
};

var defaultCallback = function defaultCallback(action) {
  if (currentBox) {
    var callback = currentBox.callback;
    if (typeof callback === 'function') {
      callback(action);
    }
    if (currentBox.resolve) {
      if (action === 'confirm') {
        currentBox.resolve(action);
      } else if (currentBox.reject && (action === 'cancel' || action === 'close')) {
        currentBox.reject(action);
      }
    }
  }
};

var initInstance = function initInstance() {
  instance = new MainConstructor({
    el: document.createElement('div')
  });

  instance.callback = defaultCallback;
};

var showBox = function showBox() {
  if (!instance) {
    initInstance();
  }

  instance.action = '';

  if (!instance.visible || instance.closeTimer) {
    if (currentBox) {
      var options = currentBox.options;
      for (var prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop];
        }
      }

      if (options.callback === undefined) {
        instance.callback = defaultCallback;
      }

      var oldCb = instance.callback;
      instance.callback = function (action, value) {
        oldCb(action, value);
      };

      document.body.appendChild(instance.$el);

      __WEBPACK_IMPORTED_MODULE_2_vue___default.a.nextTick(function () {
        instance.visible = true;
      });
    }
  }
};

var generateDiagramData = function generateDiagramData(data) {
  var nodeData = [];
  var nodeOrder = [];
  var linkData = [];
  var diagram = [];
  for (var key in data) {
    if (data.hasOwnProperty(key) && data[key]['id']) {
      var nextKey = Number(key) + 1;
      nodeData.push({
        key: data[key]['id'],
        text: 'Q' + nextKey + ' ' + types[data[key]['type']], // 标题
        tooltip: data[key]['title'], // 悬浮框
        loc: 0 + ', ' + nextKey * 120 // 位置
      });
      nodeOrder[data[key]['id']] = key;
    }
  }
  if (nodeData.length) {
    nodeOrder['end'] = nodeData.length;
    nodeData.push({ key: 'end', text: '结束答题', tooltip: '结束答题', loc: 0 + ', ' + (nodeData.length + 1) * 120 });
  }

  for (var _key in data) {
    if (data.hasOwnProperty(_key) && data[_key]['id']) {
      var _nextKey = Number(_key) + 1;
      var nextNodeId = null;
      if (data.hasOwnProperty(_nextKey) && data[_nextKey]['id']) {
        nextNodeId = data[_nextKey]['id'];
      } else {
        nextNodeId = 'end';
      }

      var fromId = data[_key]['id'];
      // jumpid => [title...]
      var jumpDataArray = getJumpData(data[_key], nextNodeId);

      // 选项的跳转
      for (var jkey in jumpDataArray) {
        if (jumpDataArray.hasOwnProperty(jkey)) {
          var title = jumpDataArray[jkey];
          var link = {};
          var jumpNum = 0;
          link.from = fromId;
          link.text = title;

          if (jkey !== '') {
            link.to = jkey;
          } else {
            if (data[_key]['jumpTargetId']) {
              link.to = data[_key]['jumpTargetId'];
            } else if (data.hasOwnProperty(_nextKey) && data[_nextKey]['id']) {
              link.to = data[_nextKey]['id'];
            } else {
              link.to = 'end';
            }
          }

          jumpNum = nodeOrder[link.to] - nodeOrder[link.from];

          link.curviness = getCurvinessNum(jumpNum);
          if (jumpNum > 1) {
            link.color = 'orange';
          }

          linkData.push(link);
        }
      }
    }
  }

  diagram['nodeDataArray'] = nodeData;
  diagram['linkDataArray'] = linkData;
  return diagram;
};

var getJumpData = function getJumpData(data, nextNodeId) {
  var jumpOptions = [];
  // 有多种选项的题类
  if (data['type'] === 'select' || data['type'] === 'multiselect' || data['type'] === 'imageMultiselect') {
    for (var okey in data['options']) {
      if (data['options'].hasOwnProperty(okey)) {
        // 合并连接相同end node的option
        if (data['jumpTargetId'] === '' && data['options'][okey]['jumpTargetId'] === nextNodeId && nextNodeId === 'end') {
          data['options'][okey]['jumpTargetId'] = '';
        }
        if (jumpOptions.hasOwnProperty(data['options'][okey]['jumpTargetId'])) {
          jumpOptions[data['options'][okey]['jumpTargetId']] += ' + ' + data['options'][okey]['title'];
        } else {
          jumpOptions[data['options'][okey]['jumpTargetId']] = data['options'][okey]['title'];
        }
      }
    }
  } else {
    jumpOptions[data['jumpTargetId']] = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(''));
  }
  return jumpOptions;
};

var getCurvinessNum = function getCurvinessNum(jumpNum) {
  if (jumpNum <= 1) {
    return 0;
  }

  if (40 + 10 * jumpNum > 400) {
    return 450;
  } else {
    return 40 + 10 * jumpNum;
  }
};

var QuestionTreeBox = function QuestionTreeBox(options, callback) {
  if (__WEBPACK_IMPORTED_MODULE_2_vue___default.a.prototype.$isServer) return;

  options = generateDiagramData(options);
  if ((typeof options === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(options)) === 'object') {
    options = {
      diagramData: options
    };
  } else if (options.callback && !callback) {
    callback = options.callback;
  }

  currentBox = {
    options: _.merge({}, defaults, QuestionTreeBox.defaults, options),
    callback: callback
  };

  showBox();
};

QuestionTreeBox.setDefaults = function (defaults) {
  QuestionTreeBox.defaults = defaults;
};

QuestionTreeBox.open = function (name, options) {
  return QuestionTreeBox(_.merge({
    name: name
  }, options));
};

QuestionTreeBox.close = function () {
  instance.doClose();
  instance.visible = false;
  currentBox = null;
};

QuestionTreeBox.destroy = function () {
  if (instance) {
    instance.$el.remove();
    instance.$destroy();
    instance = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (QuestionTreeBox);


/***/ }),

/***/ 3636:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(2594);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3678d29b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(3641);
function injectStyle (ssrContext) {
  __webpack_require__(3637)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3678d29b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3678d29b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3637:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3638);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("64968bfb", content, true, {});

/***/ }),

/***/ 3638:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3639:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_diagram_vue__ = __webpack_require__(2595);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_702199fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_diagram_vue__ = __webpack_require__(3640);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_diagram_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_702199fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_diagram_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3640:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"myDiagramDIV",style:({ width: 100 + '%', height: _vm.clientHeight - 200 + 'px' })}),_vm._v(" "),_c('div',{ref:"myOverviewDiv",staticStyle:{"width":"200px","height":"200px","position":"absolute","top":"50px","left":"50px"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3641:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"逻辑树","visible":_vm.visible,"width":"1000px","fullscreen":_vm.fullscreen},on:{"update:visible":function($event){_vm.visible=$event},"close":_vm.onClose}},[_c('div',{staticStyle:{"width":"100%"}},[_c('diagram',{ref:"diag",staticStyle:{"width":"100%"},attrs:{"model-data":_vm.diagramData}})],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){return _vm.handleAction('cancel')}}},[_vm._v("关 闭")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3642:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SendQuestionTo_vue__ = __webpack_require__(2596);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_113f67aa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SendQuestionTo_vue__ = __webpack_require__(3649);
function injectStyle (ssrContext) {
  __webpack_require__(3643)
  __webpack_require__(3645)
  this["$style"] = __webpack_require__(3647)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-113f67aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SendQuestionTo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_113f67aa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SendQuestionTo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3643:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3644);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("01022f4a", content, true, {});

/***/ }),

/***/ 3644:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SendQuestionTo.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3645:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3646);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("f19c8d3a", content, true, {});

/***/ }),

/***/ 3646:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SendQuestionTo.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3647:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3648);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("19c948b6", content, true, {});

/***/ }),

/***/ 3648:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SendQuestionTo.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3649:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"发送题目到模板","visible":_vm.visible,"close-on-click-modal":false,"width":"500px"},on:{"update:visible":function($event){_vm.visible=$event}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onSubmit()}}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"status-icon":"","rules":_vm.rules,"label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"来源题目","prop":"pass"},domProps:{"innerHTML":_vm._s(_vm.question.title)}}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"目标模板","prop":"substep_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","label-key":"title","value-key":"id","placeholder":"请输入分步任务模板关键字","query-request":_vm.getStepTemplateTable},on:{"change":_vm.change},model:{value:(_vm.form.substep_id),callback:function ($$v) {_vm.$set(_vm.form, "substep_id", $$v)},expression:"form.substep_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"目标题目","prop":"index"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择题目","disabled":!_vm.form.substep_id},model:{value:(_vm.form.index),callback:function ($$v) {_vm.$set(_vm.form, "index", $$v)},expression:"form.index"}},_vm._l((_vm.toQuestions),function(question,index){return _c('el-option',{key:index,attrs:{"label":("Q" + (index+1) + " " + (_vm.stripTags(question.title))),"value":index,"disabled":_vm.fixedIds.includes(question.stepId)}},[_c('div',{domProps:{"innerHTML":_vm._s(("Q" + (index+1) + " " + (question.title)))}})])}),1)],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.visible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.loading},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v("确 定")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3650:
/***/ (function(module, exports) {

module.exports = [{"default_jump":"","delay":"0","desc":"请根据您在任务执行过程中所遇到的实际情况进行备注。若无，请直接提交，结束答题","descPrefix":"","guideAudio":[],"guideText":"","guideVideo":[],"images":[],"mtext":[{"id":"OPT201907010316101","inputMax":null,"inputMin":null,"inputType":"text","required":false,"title":"特殊情况报备"}],"referStepId":"","stepId":"Q201907170350281","title":"【报备】特殊情况备注","titleAlias":"","type":"mtext","allow_media_download":2,"allow_screen_capture":2}]

/***/ }),

/***/ 3651:
/***/ (function(module, exports) {

module.exports = [{"allowCrossSubjectRecord":false,"allowReusePhoto":false,"auditText":"","clarity":"0","conditional_jump":{"R1537956162849":"end"},"dataLabel":"","default_jump":"","delay":"0","desc":"<p>1.平台任务仅限<strong>本人</strong>在<strong>指定任务门店</strong>内完成，务必按照任务要求规范操作，不执行与任务无关的行为。</p><p>2.严格遵守平台使用规范，正确操作软件，真实提交任务相关材料及信息，有效完成任务。</p><p>1）禁止提交虚假照片（包括对着手机翻拍）；</p><p>2）禁止门头与店内陈列不一致；</p><p>3）禁止与其他人员（包含自己/ AI ）串通；</p><p>3.如需与门店人员沟通，请保持态度端正、语气礼貌。若遇到店内阻拦、拒绝配合等无法自行处理的特殊情况，<strong>切勿发生争执与冲突</strong>，请立即停止操作，并第一时间联系平台工作人员报备处理。</p><p><br></p><p><strong style=\"color: rgb(243, 96, 91);\">凡违反平台相关规范，或在店内发生冲突引发客诉的，平台有权对账号进行冻结处理，并禁止提现。</strong></p><p><strong style=\"color: rgb(243, 96, 91);\"> </strong></p><p>阅读完毕后请选择是否同意以上规则，选择 “不同意” 则任务立即终止，不产生佣金。</p>","descPrefix":"","evidenceQuality":"2","evidenceType":"photo","forceGuideAudio":false,"forceGuideVideo":false,"guideAudio":[],"guideText":"","guideVideo":[],"imageRecognitionType":[],"images":[],"ondutyCheck":false,"options":[{"autoIncreaseTaskGroupTarget":false,"examplePhotos":[],"exampleText":"","forceCamera":false,"forcePanorama":false,"intelligentCall":false,"mStepDelay":"0","needPhoto":false,"optionId":"R1537956162848","referIds":[],"referStepId":"","settlementAmount":0,"settlementAmountRatio":1,"settlementType":0,"takePhotoAuxiliaryLine":0,"title":"同意"},{"autoIncreaseTaskGroupTarget":false,"examplePhotos":[],"exampleText":"","forceCamera":false,"forcePanorama":false,"intelligentCall":false,"mStepDelay":"0","needPhoto":false,"optionId":"R1537956162849","referIds":[],"referStepId":"","settlementAmount":0,"settlementAmountRatio":1,"settlementType":2,"takePhotoAuxiliaryLine":0,"title":"不同意"}],"recordDuration":"0","stepId":"Q1537956162847","takePhotoScene":0,"throughRecordKeyQuestion":false,"title":"【平台规范】请在任务开始前仔细阅读并严格遵守","titleAlias":"","type":"options","videoDuration":"0","allow_media_download":2,"allow_screen_capture":2},{"allowCrossSubjectRecord":false,"allowReusePhoto":false,"auditText":"","clarity":"0","conditional_jump":{"OPT201911011000111":"Q201911200538402"},"dataLabel":"","default_jump":"","delay":"0","desc":"<p><strong style=\"color: rgb(51, 51, 51);\">【 步骤1 】到达指定门店</strong></p><p><span style=\"color: rgb(51, 51, 51);\">1.在任务详情页确认</span><strong style=\"color: rgb(51, 51, 51);\">门店名称</strong><span style=\"color: rgb(51, 51, 51);\">及</span><strong style=\"color: rgb(51, 51, 51);\">门店地址范围</strong></p><p><span style=\"color: rgb(51, 51, 51);\">2.利用</span><strong style=\"color: rgb(51, 51, 51);\">地图等</strong><span style=\"color: rgb(51, 51, 51);\">工具到达门店所在地址范围</span></p><p><span style=\"color: rgb(51, 51, 51);\">3.寻找该区域是否有</span><strong style=\"color: rgb(51, 51, 51);\">指定的门店</strong></p><p><strong style=\"color: rgb(51, 51, 51);\">【 步骤2 】判断门店状态</strong></p><p>请根据实际情况判断门店状态并选择：</p><p>1.正常营业</p><p>2.门店更名（找到指定地址，店名变更，经营范围不变）</p><p>3.店名一致但遇门店闭店/装修/歇业</p><p>4.该区域/地址没有指定门店</p><p><strong style=\"color: rgb(51, 51, 51);\">【 步骤3 】按要求拍摄门头照片</strong></p><p>1.拍摄指定门店<strong style=\"color: rgb(255, 0, 0);\"><u>门头全景，门牌</u></strong>照片<strong style=\"color: rgb(255, 0, 0);\"><u>各1张</u></strong>，证明找到正确门店。</p><p>2.如无<strong>门牌</strong>，则拍摄指定地址<strong>所在路街景，及路名牌或公车站牌</strong></p><p>3.如商场内没有目标门店<strong>，</strong>拍摄<strong>商场对应楼层导览图</strong></p><p>4.如门店<strong>有闭店/装修/歇业的信息告知</strong>，请拍摄告知信息的照片</p><p><span style=\"color: rgb(51, 51, 51);\">5.照片清晰不抖动，看得清</span><strong style=\"color: rgb(51, 51, 51);\">门头/门牌/路名牌/公交站牌上的字</strong></p><p><strong>【注意事项】</strong></p><p><strong style=\"color: rgb(255, 0, 0);\">如遇门店闭店/装修/歇业等异常情况</strong>，按拍摄要求提交证据照片，可获5元佣金</p>","descPrefix":"","evidenceQuality":"2","evidenceType":"photo","forceGuideAudio":false,"forceGuideVideo":false,"guideAudio":[],"guideText":"","guideVideo":[],"imageRecognitionType":[],"images":["http://oss-cn-hangzhou.aliyuncs.com/sjpub/191120/458/a79938371a196bc550db0dfaf12d3e52.png","http://oss-cn-hangzhou.aliyuncs.com/sjpub/191120/458/5c51cf179500329252df9dfba1f68428.png","http://oss-cn-hangzhou.aliyuncs.com/sjpub/191120/458/59a18586a991ed078f07f11d34bf59ea.png"],"ondutyCheck":false,"options":[{"autoIncreaseTaskGroupTarget":false,"examplePhotos":["http://oss-cn-hangzhou.aliyuncs.com/sjpub/191120/458/81b65b99ec79beb9d91e4c4c63dd17ae.png"],"exampleText":"<p><span style=\"font-weight: bolder;\">【拍摄要求】</span><br></p><p>拍摄指定门店的<u style=\"\"><b style=\"\"><font color=\"#ff0000\">门头全景，门牌</font></b></u>照片<b style=\"\"><u style=\"\"><font color=\"#ff0000\">各一张</font></u></b>，证明找到正确门店。<br>如<font color=\"#ff0000\"><b>没有门牌</b></font>，需要拍摄指定地址<font color=\"#ff0000\"><b>所在路名牌或公车站牌<br></b></font><font color=\"#000000\">如</font><b style=\"color: rgb(255, 0, 0);\">门店在商场内，</b><font color=\"#000000\">需要拍摄</font><b style=\"color: rgb(255, 0, 0);\">指定门店门头照片</b></p>","forceCamera":true,"forcePanorama":false,"intelligentCall":false,"mStepDelay":"0","needPhoto":true,"optionId":"R1515570260035","referIds":[],"referStepId":"","settlementAmount":0,"settlementAmountRatio":1,"settlementType":0,"takePhotoAuxiliaryLine":0,"title":"正常营业"},{"autoIncreaseTaskGroupTarget":false,"examplePhotos":["http://oss-cn-hangzhou.aliyuncs.com/sjpub/191120/458/8dd45987c51f24494352a9c252eaccc0.png","http://oss-cn-hangzhou.aliyuncs.com/sjpub/191120/458/ea384ad959216ad92ee8d701859f5098.png"],"exampleText":"<p>找到指定地址，若店名与任务描述不一致，但门牌号一致，<span style=\"font-size: inherit;\">请</span><span style=\"font-size: inherit; font-weight: bolder;\"><font color=\"#f3605b\">先联系在线客服</font></span><span style=\"font-size: inherit;\">，确认是否门店更名</span></p><p><span style=\"font-weight: bolder;\">【拍摄要求】</span><br></p><p>拍摄指定门店的<u><span style=\"font-weight: bolder;\"><font color=\"#ff0000\">门头全景，门牌</font></span></u>照片<span style=\"font-weight: bolder;\"><u><font color=\"#ff0000\">各一张</font></u></span>，证明找到正确门店。<br>如<font color=\"#ff0000\"><span style=\"font-weight: bolder;\">没有门牌</span></font>，需要拍摄指定地址<font color=\"#ff0000\"><span style=\"font-weight: bolder;\">所在路名牌或公车站牌<br></span></font><font color=\"#000000\">如</font><span style=\"font-weight: bolder; color: rgb(255, 0, 0);\">门店在商场内，</span><font color=\"#000000\">需要拍摄</font><span style=\"font-weight: bolder; color: rgb(255, 0, 0);\">指定门店门头照片</span><br></p><p><span style=\"font-weight: 700;\">【注意事项】</span><span style=\"font-weight: bolder;\"><font color=\"#000000\"><br></font></span></p><p><span style=\"font-weight: bolder;\"><font color=\"#333333\">由于系统合并，收购的原因，部分门店可能存在更名的情况，该种情况请根据要求拍摄门头，正常执行任务</font></span></p><p><font color=\"#f3605b\">例如：乐购vs华润；好又多vs沃尔玛</font></p>","forceCamera":true,"forcePanorama":false,"intelligentCall":false,"mStepDelay":"0","needPhoto":true,"optionId":"OPT201911011223454","referIds":[],"referStepId":"","settlementAmount":0,"settlementAmountRatio":1,"settlementType":0,"takePhotoAuxiliaryLine":0,"title":"门店更名（找到指定地址，店名变更，经营范围不变）"},{"autoIncreaseTaskGroupTarget":false,"examplePhotos":["http://oss-cn-hangzhou.aliyuncs.com/sjpub/191120/458/3f6367172161ad6ea06dc8ef43e89a77.png","http://oss-cn-hangzhou.aliyuncs.com/sjpub/191120/458/b4d9df2e098bc2907c70ef5e5801d993.png","http://oss-cn-hangzhou.aliyuncs.com/sjpub/191120/458/d2677d30f011fd5e57f46c3f1901617e.png"],"exampleText":"<p><span style=\"font-size: inherit;\">拍摄指定门店</span><u style=\"font-size: inherit;\"><b><font color=\"#ff0000\">门头全景，门牌</font></b></u><span style=\"font-size: inherit;\">照片</span><b style=\"font-size: inherit;\"><u><font color=\"#ff0000\">各一张</font></u></b><span style=\"font-size: inherit;\">，证明找到正确门店。</span><br></p><p>如<b><font color=\"#ff0000\">没有门牌</font></b>，需要拍摄指定地址<b><font color=\"#ff0000\">所在路街景，以及马路名牌</font><br></b>如门店<font color=\"#ff0000\"><b>有闭店的信息告知</b></font>，请<font color=\"#ff0000\" style=\"font-weight: bold;\">拍摄告知信息的照片</font><br></p>","forceCamera":true,"forcePanorama":false,"intelligentCall":false,"mStepDelay":"0","needPhoto":true,"optionId":"R1515570284253","referIds":[],"referStepId":"","settlementAmount":0,"settlementAmountRatio":0,"settlementType":1,"takePhotoAuxiliaryLine":0,"title":"店名一致但门店闭店/装修/歇业"},{"autoIncreaseTaskGroupTarget":false,"examplePhotos":["http://oss-cn-hangzhou.aliyuncs.com/sjpub/191120/458/19fadab1e88c8f56e97dadf67bdccb1f.png","http://oss-cn-hangzhou.aliyuncs.com/sjpub/191120/458/e0f7c5d75a5c046fe6605d97d8dce6d8.png"],"exampleText":"<p><font color=\"#333333\" style=\"font-size: inherit;\">请拍摄 两边</font><font style=\"font-size: inherit;\" color=\"#f3605b\"><b>街景、标志建筑及马路名牌&nbsp;&nbsp;</b></font><span style=\"font-size: inherit; color: rgb(243, 96, 91); font-weight: bolder;\">至少3张</span><br></p><p><font color=\"#333333\" style=\"\">拍摄&nbsp;</font><font color=\"#f3605b\"><b><u>门牌&nbsp;</u></b></font><font color=\"#000000\" style=\"font-size: inherit;\">必须对</font><span style=\"font-size: inherit;\">应任务的门店地址中的门牌号</span></p><p>如<span style=\"font-weight: bolder;\"><font color=\"#ff0000\">没有门牌</font></span>，需要拍摄指定地址<span style=\"font-weight: bolder;\"><font color=\"#ff0000\">所在路街景，以及马路名牌</font></span></p><p>如是商场内没有目标门店，请拍摄<span style=\"font-weight: bolder;\"><font color=\"#ff0000\">商场对应楼层导览图</font></span><span style=\"font-weight: bolder;\"><font color=\"#ff0000\"><br></font></span><br></p>","forceCamera":true,"forcePanorama":false,"intelligentCall":false,"mStepDelay":"0","needPhoto":true,"optionId":"OPT201911011000111","referIds":[],"referStepId":"","settlementAmount":0,"settlementAmountRatio":1,"settlementType":0,"takePhotoAuxiliaryLine":0,"title":"该区域/地址没有指定门店"}],"recordDuration":"0","stepId":"Q201911200537471","takePhotoScene":0,"throughRecordKeyQuestion":false,"title":"【到达】请到达指定门店，拍摄指定门店门头照","titleAlias":"","type":"options","videoDuration":"0","allow_media_download":2,"allow_screen_capture":2},{"allowCrossSubjectRecord":false,"allowReusePhoto":false,"auditText":"","clarity":"0","conditional_jump":{},"dataLabel":"","default_jump":"","delay":"0","desc":"<p>【第1步】</p><p><strong style=\"color: rgb(255, 0, 0);\">打开手机导航软件</strong>（高德、百度都可以）</p><p>【第2步】</p><p><strong style=\"color: rgb(255, 0, 0);\">搜索店名关键部分</strong>(如好又多、联华等)</p><p>【第3步】</p><p>确认周边没有目标门店<strong style=\"color: rgb(255, 0, 0);\">保存截图上传</strong></p><p>【第4步】</p><p>拍摄<strong style=\"color: rgb(255, 0, 0);\">地址路名/参照物1张</strong>+环境<strong style=\"color: rgb(255, 0, 0);\">全景照片至少5张</strong></p>","descPrefix":"","evidenceQuality":"2","evidenceType":"photo","forceGuideAudio":false,"forceGuideVideo":false,"guideAudio":[],"guideText":"","guideVideo":[],"imageRecognitionType":[],"images":["http://sjimgpub.oss-cn-hangzhou.aliyuncs.com/core/250411/2395/a2400df5e132b1f9a300a9f05635faee.png"],"ondutyCheck":false,"options":[{"autoIncreaseTaskGroupTarget":false,"examplePhotos":[],"exampleText":"","forceCamera":false,"forcePanorama":false,"intelligentCall":false,"mStepDelay":"0","needPhoto":true,"optionId":"OPT201911020923291","referIds":[],"referStepId":"","settlementAmount":0,"settlementAmountRatio":1,"settlementType":0,"takePhotoAuxiliaryLine":0,"title":"我已确认没有门店，按照示例图要求上传手机截图作为辅助证明"}],"recordDuration":"0","stepId":"Q201911200538402","takePhotoScene":0,"throughRecordKeyQuestion":false,"title":"我已确认没有门店，按照示例图要求上传手机截图作为辅助证明","titleAlias":"","type":"options","videoDuration":"0","allow_media_download":2,"allow_screen_capture":2}]

/***/ }),

/***/ 3652:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);



var checkFix = {
  existId: function existId(array, id, extendedStepsStart) {
    var specialJump = void 0;
    // 强制用户结束答题 不能和结束答题共用
    if (extendedStepsStart > 0) {
      specialJump = ['nextTemplate', 'nextProduct'];
    } else {
      specialJump = ['end', 'nextTemplate', 'nextProduct'];
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(array), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var data = _step.value;

        if (specialJump.includes(id) || data.id === id) {
          return true;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return false;
  },

  // 强制用户结束答题 显示题和隐藏题之间不能有逻辑跳转
  existJumpToExtendedStep: function existJumpToExtendedStep(array, jumpTargetId, extendedStepsStart) {
    for (var i = 0; i < array.length; i++) {
      if (i + 1 > extendedStepsStart) {
        if (array[i].id === jumpTargetId) {
          return true;
        }
      }
    }
    return false;
  },
  result: function result(array, data, questionIndex, extendedStepsStart) {
    var results = {};
    if (data.hasOwnProperty('jumpTargetId') && data.jumpTargetId) {
      var isExist = this.existId(array, data.jumpTargetId, extendedStepsStart);
      if (!isExist) {
        results.isExistJumpTargetId = isExist;
        results.jumpTargetId = data.jumpTargetId;
      }
    }
    // 强制用户结束答题 显示题和隐藏题之间不能有逻辑跳转
    if (data.hasOwnProperty('jumpTargetId') && data.jumpTargetId && questionIndex < extendedStepsStart) {
      var _isExist = this.existJumpToExtendedStep(array, data.jumpTargetId, extendedStepsStart);
      if (_isExist) {
        results.isExistJumpToExtendedStep = _isExist;
      }
    }
    if (data.hasOwnProperty('referIds') && data.referIds.length) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(data.referIds), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var questionId = _step2.value;

          var _isExist2 = this.existId(array, questionId);
          if (!_isExist2) {
            results.referIds = _isExist2;
            break;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
    if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(results).length) {
      return results;
    }
    return false;
  },
  test: function test(questions, extendedStepsStart) {
    var _this = this;

    var results = [];
    questions.forEach(function (question, questionIndex) {
      var _result = _this.result(questions, question, questionIndex, extendedStepsStart);

      if (_result) {
        results.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_result, { question: question, questionIndex: questionIndex }));
      }

      // 验证选项
      if (question.hasOwnProperty('options')) {
        question.options.forEach(function (option, optionIndex) {
          var _result = _this.result(questions, option, questionIndex, extendedStepsStart);
          if (_result) {
            results.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_result, { question: question, questionIndex: questionIndex, option: option, optionIndex: optionIndex }));
          }
        });
      }
    });
    return results;
  },
  fix: function fix(results) {
    results.forEach(function (result) {
      var data = result.question;
      if (result.hasOwnProperty('option')) {
        data = result.option;
      }
      if (result.isExistJumpTargetId === false || result.isExistJumpToExtendedStep === true) {
        data.jumpTargetId = '';
      }
      if (result.referIds === false) {
        data.referIds = [];
      }
      console.log(result, data);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (checkFix);

/***/ }),

/***/ 3653:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

var check = {
  needEvidence: function needEvidence(data) {
    if (data.hasOwnProperty('needEvidence')) {
      return data.needEvidence;
    }
  },
  needLocalFile: function needLocalFile(data) {
    if (data.hasOwnProperty('localFile')) {
      return data.localFile;
    }
  },
  result: function result(data) {
    var results = {};
    results.needEvidence = this.needEvidence(data);
    if (results.needEvidence) {
      results.needLocalFile = this.needLocalFile(data);
      if (results.needLocalFile) {
        return results;
      }
    }
    return false;
  },
  questions: function questions(_questions) {
    var _this = this;

    var results = [];
    _questions.forEach(function (question, questionIndex) {
      if (question.type === 'select') {
        question.options.forEach(function (option, optionIndex) {
          var _result = _this.result(option);
          if (_result) {
            results.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ question: question, questionIndex: questionIndex, option: option, optionIndex: optionIndex }, _result));
          }
        });
      } else {
        var _result = _this.result(question);
        if (_result) {
          results.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ question: question, questionIndex: questionIndex }, _result));
        }
      }
    });
    return results;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (check);

/***/ }),

/***/ 3654:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckQuestionFix_vue__ = __webpack_require__(2597);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f41c4a3c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckQuestionFix_vue__ = __webpack_require__(3661);
function injectStyle (ssrContext) {
  __webpack_require__(3655)
  __webpack_require__(3657)
  this["$style"] = __webpack_require__(3659)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f41c4a3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckQuestionFix_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f41c4a3c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckQuestionFix_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3655:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3656);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("a51c8524", content, true, {});

/***/ }),

/***/ 3656:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CheckQuestionFix.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3657:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3658);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("088f5c68", content, true, {});

/***/ }),

/***/ 3658:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CheckQuestionFix.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3659:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3660);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("68a10890", content, true, {});

/***/ }),

/***/ 3660:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CheckQuestionFix.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3661:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"检查题目数据并修复","visible":_vm.visible,"close-on-click-modal":false,"width":"600px"},on:{"update:visible":function($event){_vm.visible=$event}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onSubmit()}}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""}},[_c('el-table-column',{attrs:{"label":"问题"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tooltip',{attrs:{"effect":"dark","content":scope.row.question.title,"placement":"top"}},[_c('span',[_vm._v("Q"+_vm._s(scope.row.questionIndex+1))])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"选项"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.option)?_c('el-tooltip',{attrs:{"effect":"dark","content":scope.row.option.title,"placement":"top"}},[_c('span',[_vm._v("OPT"+_vm._s(scope.row.optionIndex+1))])]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"参考目标"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.referIds === true)?_c('span',[_vm._v("正常")]):(scope.row.referIds === false)?_c('span',{staticClass:"color-danger"},[_vm._v("不存在")]):_c('span',[_vm._v("未选择")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"跳转目标"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.isExistJumpTargetId === true)?_c('span',[_vm._v("正常")]):(scope.row.isExistJumpTargetId === false && scope.row.jumpTargetId === 'end')?_c('span',{staticClass:"color-danger"},[_vm._v("不能和结束答题共用")]):(scope.row.isExistJumpTargetId === false)?_c('span',{staticClass:"color-danger"},[_vm._v("不存在")]):(scope.row.isExistJumpToExtendedStep === true)?_c('span',{staticClass:"color-danger"},[_vm._v("显示题和隐藏题之间不能有逻辑跳转")]):_c('span',[_vm._v("未选择")])]}}])})],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.visible = false}}},[_vm._v("手动清理")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v("清理并保存")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3662:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CopyQuestionTo_vue__ = __webpack_require__(2598);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04f847e4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CopyQuestionTo_vue__ = __webpack_require__(3669);
function injectStyle (ssrContext) {
  __webpack_require__(3663)
  __webpack_require__(3665)
  this["$style"] = __webpack_require__(3667)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04f847e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CopyQuestionTo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04f847e4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CopyQuestionTo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3663:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3664);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("3b140a7e", content, true, {});

/***/ }),

/***/ 3664:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".step-template-copy-question-to .el-select-multiple-tag-ellipsis .el-tag .el-select__tags-text{max-width:280px;display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;vertical-align:top}", "", {"version":3,"sources":["/workspace/src/views/step-template/components/CopyQuestionTo.vue"],"names":[],"mappings":"AACA,+FAA+F,gBAAgB,qBAAqB,mBAAmB,gBAAgB,uBAAuB,kBAAkB,CAC/M","file":"CopyQuestionTo.vue","sourcesContent":["\n.step-template-copy-question-to .el-select-multiple-tag-ellipsis .el-tag .el-select__tags-text{max-width:280px;display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;vertical-align:top\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3665:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3666);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("e80cb19e", content, true, {});

/***/ }),

/***/ 3666:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CopyQuestionTo.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3667:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3668);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("53db23ea", content, true, {});

/***/ }),

/***/ 3668:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CopyQuestionTo.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3669:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticClass:"step-template-copy-question-to",attrs:{"title":"从其他模板复制题目","visible":_vm.visible,"close-on-click-modal":false,"width":"500px"},on:{"update:visible":function($event){_vm.visible=$event}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onSubmit()}}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"status-icon":"","rules":_vm.rules,"label-width":"80px"}},[_c('el-form-item',{attrs:{"label":"来源模板","prop":"substep_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","label-key":"title","value-key":"id","placeholder":"请输入分步任务模板关键字","query-request":_vm.getStepTemplateTable},on:{"change":_vm.changeTemplate},model:{value:(_vm.form.fromId),callback:function ($$v) {_vm.$set(_vm.form, "fromId", $$v)},expression:"form.fromId"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"el-select-multiple-tag-ellipsis",attrs:{"label":"来源题目","prop":"fromIndex"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择题目","multiple":"","disabled":!_vm.form.fromId},on:{"change":_vm.changeQuestion},model:{value:(_vm.form.fromIndex),callback:function ($$v) {_vm.$set(_vm.form, "fromIndex", $$v)},expression:"form.fromIndex"}},_vm._l((_vm.fromQuestions),function(question,index){return _c('el-option',{key:index,attrs:{"label":("Q" + (index+1) + " " + (_vm.stripTags(question.title))),"value":index,"disabled":_vm.fixedIds.includes(question.id)}},[_c('div',{domProps:{"innerHTML":_vm._s(("Q" + (index+1) + " " + (question.title)))}})])}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"复制到","prop":"toIndex"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择题目"},model:{value:(_vm.form.toIndex),callback:function ($$v) {_vm.$set(_vm.form, "toIndex", $$v)},expression:"form.toIndex"}},_vm._l((_vm.toQuestions),function(question,index){return _c('el-option',{key:index,attrs:{"label":("Q" + (index+1) + " " + (_vm.stripTags(question.title))),"value":index,"disabled":_vm.fixedIds.includes(question.id)}},[_c('div',{domProps:{"innerHTML":_vm._s(("Q" + (index+1) + " " + (question.title)))}})])}),1)],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.visible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.loading},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v("确 定")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3670:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateDataLabels_vue__ = __webpack_require__(2599);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_055112d5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateDataLabels_vue__ = __webpack_require__(3673);
function injectStyle (ssrContext) {
  __webpack_require__(3671)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateDataLabels_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_055112d5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateDataLabels_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3671:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3672);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2913e070", content, true, {});

/***/ }),

/***/ 3672:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".el-row{margin-bottom:20px}.el-row:last-child{margin-bottom:0}.el-row>.el-col>.grid-content{padding-left:10px}.el-col{border-radius:4px}.bg-purple{background:#e5e9f2;line-height:36px}.grid-content{border-radius:4px;min-height:36px}", "", {"version":3,"sources":["/workspace/src/views/step-template/components/StepTemplateDataLabels.vue"],"names":[],"mappings":"AACA,QAAQ,kBAAkB,CACzB,AACD,mBAAmB,eAAe,CACjC,AACD,8BAA8B,iBAAiB,CAC9C,AACD,QAAQ,iBAAiB,CACxB,AACD,WAAW,mBAAmB,gBAAgB,CAC7C,AACD,cAAc,kBAAkB,eAAe,CAC9C","file":"StepTemplateDataLabels.vue","sourcesContent":["\n.el-row{margin-bottom:20px\n}\n.el-row:last-child{margin-bottom:0\n}\n.el-row>.el-col>.grid-content{padding-left:10px\n}\n.el-col{border-radius:4px\n}\n.bg-purple{background:#e5e9f2;line-height:36px\n}\n.grid-content{border-radius:4px;min-height:36px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3673:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"批量设置数据标签","top":"10px","fullscreen":true,"visible":_vm.visible},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',{staticStyle:{"font-size":"x-large","margin":"20px"}},[_c('el-row',{attrs:{"gutter":24}},[_c('el-col',{attrs:{"span":6}},[_vm._v("总题数："+_vm._s(_vm.questionCount))]),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_vm._v("已设置题数："+_vm._s(_vm.questionSettledDataLabelCount))]),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_vm._v("已设置数据标签数："+_vm._s(_vm.optionSettledDataLabelCount))])],1)],1),_vm._v(" "),_vm._l((_vm.dialogQuestions),function(question,index){return [(_vm.isDataLabelOnQuestion(question.type))?[_c('el-row',{attrs:{"gutter":24}},[_c('el-col',{attrs:{"span":16}},[_c('div',{staticClass:"grid-content bg-purple"},[_vm._v("Q"+_vm._s(index+1)+" "+_vm._s(_vm.types[question.type])+" "+_vm._s(question.title))])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"grid-content"},[_c('el-input',{attrs:{"placeholder":"最多不超过50个字符","size":"small","maxlength":"50"},model:{value:(question.dataLabel),callback:function ($$v) {_vm.$set(question, "dataLabel", $$v)},expression:"question.dataLabel"}})],1)])],1)]:_vm._e(),_vm._v(" "),(_vm.isDataLabelOnOption(question.type))?[_c('el-row',{attrs:{"gutter":24}},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"grid-content bg-purple"},[_vm._v("Q"+_vm._s(index+1)+" "+_vm._s(_vm.types[question.type])+" "+_vm._s(question.title))])])],1),_vm._v(" "),_vm._l((question.options),function(option,index2){return _c('el-row',{key:index + '_' + index2,attrs:{"gutter":24}},[_c('el-col',{attrs:{"span":15,"offset":1}},[_c('div',{staticClass:"grid-content bg-purple"},[_vm._v("OPT"+_vm._s(index2+1)+" "+_vm._s(option.title))])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"grid-content"},[_c('el-input',{attrs:{"placeholder":"最多不超过50个字符","size":"small","maxlength":"50"},model:{value:(option.dataLabel),callback:function ($$v) {_vm.$set(option, "dataLabel", $$v)},expression:"option.dataLabel"}})],1)])],1)})]:_vm._e()]}),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.close}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.confirm}},[_vm._v("确 定")])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3674:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValidateQuestionWarning_vue__ = __webpack_require__(2600);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61a7e5f8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValidateQuestionWarning_vue__ = __webpack_require__(3681);
function injectStyle (ssrContext) {
  __webpack_require__(3675)
  __webpack_require__(3677)
  this["$style"] = __webpack_require__(3679)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61a7e5f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValidateQuestionWarning_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61a7e5f8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValidateQuestionWarning_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3675:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3676);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("60cbc168", content, true, {});

/***/ }),

/***/ 3676:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ValidateQuestionWarning.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3677:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3678);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6a791732", content, true, {});

/***/ }),

/***/ 3678:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ValidateQuestionWarning.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3679:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3680);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("dd3fd7d4", content, true, {});

/***/ }),

/***/ 3680:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ValidateQuestionWarning.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3681:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"请确认以下信息","visible":_vm.visible,"close-on-click-modal":false,"width":"600px"},on:{"update:visible":function($event){_vm.visible=$event}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onSubmit()}}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""}},[_c('el-table-column',{attrs:{"label":"问题"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tooltip',{attrs:{"effect":"dark","content":scope.row.question.title,"placement":"top"}},[_c('span',[_vm._v("Q"+_vm._s(scope.row.questionIndex+1))])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"选项"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.option)?_c('el-tooltip',{attrs:{"effect":"dark","content":scope.row.option.title,"placement":"top"}},[_c('span',[_vm._v("OPT"+_vm._s(scope.row.optionIndex+1))])]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"上传证据"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.needEvidence)?_c('span',[_vm._v("需要")]):_c('span',[_vm._v("不需要")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"上传本地证据"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.needLocalFile)?_c('span',{staticClass:"color-danger"},[_vm._v("允许")]):_c('span',[_vm._v("不允许")])]}}])})],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.visible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v("确 定")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3682:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main_js__ = __webpack_require__(3683);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main_js__["a" /* default */]);

/***/ }),

/***/ 3683:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export QuestionImageUploadBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_vue__ = __webpack_require__(3684);



var defaults = {
  files: []
};

var MainConstructor = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.extend(__WEBPACK_IMPORTED_MODULE_1__main_vue__["a" /* default */]);

var instance = void 0,
    currentBox = void 0;

var initInstance = function initInstance() {
  instance = new MainConstructor({
    el: document.createElement('div')
  });
};

var showBox = function showBox() {
  if (!instance) {
    initInstance();
  }

  if (!instance.visible || instance.closeTimer) {
    if (currentBox) {
      var options = currentBox.options;
      for (var prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop];
        }
      }

      instance.callback = currentBox.callback;

      document.body.appendChild(instance.$el);

      __WEBPACK_IMPORTED_MODULE_0_vue___default.a.nextTick(function () {
        instance.visible = true;
      });
    }
  }
};

var QuestionImageUploadBox = function QuestionImageUploadBox(options, callback) {
  if (__WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$isServer) return;
  if (options.callback && !callback) {
    callback = options.callback;
  }

  currentBox = {
    options: _.merge({}, defaults, QuestionImageUploadBox.defaults, options),
    callback: callback
  };

  showBox();
};

QuestionImageUploadBox.setDefaults = function (defaults) {
  QuestionImageUploadBox.defaults = defaults;
};

QuestionImageUploadBox.open = function (callback) {
  return QuestionImageUploadBox({}, callback);
};

QuestionImageUploadBox.close = function () {
  instance.visible = false;
  currentBox = null;
};

QuestionImageUploadBox.destroy = function () {
  if (instance) {
    instance.$el.remove();
    instance.$destroy();
    instance = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (QuestionImageUploadBox);


/***/ }),

/***/ 3684:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(2601);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_471476b6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(3691);
function injectStyle (ssrContext) {
  __webpack_require__(3685)
  __webpack_require__(3687)
  this["$style"] = __webpack_require__(3689)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-471476b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_471476b6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3685:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3686);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("5ce79d9e", content, true, {});

/***/ }),

/***/ 3686:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3687:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3688);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("4c1340ba", content, true, {});

/***/ }),

/***/ 3688:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".upload-list[data-v-471476b6]{margin-bottom:-30px}.upload-list ul[data-v-471476b6]{margin:0;padding:0;list-style-type:none}.upload-list ul li[data-v-471476b6]{float:left;margin:10px 10px 30px;border:1px solid #c0c4cc;width:130px;height:130px;position:relative}.upload-list ul li.sj-icon-add-image[data-v-471476b6]{color:#c0c4cc;border:1px solid transparent;font-size:130px;line-height:130px}.upload-list ul li.sj-icon-add-image input[data-v-471476b6]{cursor:pointer;font-size:0;width:100%;height:100%;opacity:0;position:absolute;top:0;left:0}.upload-list ul li .upload-image[data-v-471476b6]{position:relative;vertical-align:middle;text-align:center;height:100%;width:100%}.upload-list ul li .upload-image[data-v-471476b6]:before{content:\"\";display:inline-block;height:100%;vertical-align:middle;width:0}.upload-list ul li .upload-image img[data-v-471476b6]{max-width:130px;max-height:130px;vertical-align:middle}.upload-list ul li .upload-image .upload-image-status[data-v-471476b6]{position:absolute;width:130px;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.upload-list ul li .upload-image .upload-image-toolbar[data-v-471476b6]{display:none;position:absolute;bottom:8px;left:0;width:130px;padding-top:5px}.upload-list ul li .upload-image:hover .upload-image-toolbar[data-v-471476b6]{display:block}.upload-list ul li .upload-image-date[data-v-471476b6]{position:absolute;bottom:-28px;left:0;width:130px;font-size:12px;color:#909399;cursor:pointer;text-align:center}.upload-list ul li .upload-image-date[data-v-471476b6]:hover{color:#409eff}.upload-list ul li .upload-image-date .modify-image-date[data-v-471476b6]{width:190px;-webkit-transform-origin:center bottom 0;transform-origin:center bottom 0;position:absolute;left:-25px;bottom:0;margin-bottom:27px}.upload-list ul li .upload-image-date .modify-image-date .el-date-editor.el-input[data-v-471476b6]{width:190px}.upload-list ul li .upload-image-date .modify-image-date .el-input--suffix .el-input__inner[data-v-471476b6]{padding-right:0}", "", {"version":3,"sources":["/workspace/src/views/question-editor/components/question-image-upload-box/src/main.vue"],"names":[],"mappings":"AACA,8BAA8B,mBAAmB,CAChD,AACD,iCAAiC,SAAW,UAAY,oBAAoB,CAC3E,AACD,oCAAoC,WAAW,sBAAsB,yBAAyB,YAAY,aAAa,iBAAiB,CACvI,AACD,sDAAsD,cAAc,6BAA6B,gBAAgB,iBAAiB,CACjI,AACD,4DAA4D,eAAe,YAAY,WAAW,YAAY,UAAU,kBAAkB,MAAQ,MAAQ,CACzJ,AACD,kDAAkD,kBAAkB,sBAAsB,kBAAkB,YAAY,UAAU,CACjI,AACD,yDAA0D,WAAW,qBAAqB,YAAY,sBAAsB,OAAO,CAClI,AACD,sDAAsD,gBAAgB,iBAAiB,qBAAqB,CAC3G,AACD,uEAAuE,kBAAkB,YAAY,SAAS,QAAQ,uCAAwC,8BAA+B,CAC5L,AACD,wEAAwE,aAAa,kBAAkB,WAAW,OAAS,YAAY,eAAe,CACrJ,AACD,8EAA8E,aAAa,CAC1F,AACD,uDAAuD,kBAAkB,aAAa,OAAS,YAAY,eAAe,cAAc,eAAe,iBAAiB,CACvK,AACD,6DAA6D,aAAa,CACzE,AACD,0EAA0E,YAAY,yCAA2C,iCAAmC,kBAAkB,WAAW,SAAW,kBAAkB,CAC7N,AACD,mGAAmG,WAAW,CAC7G,AACD,6GAA6G,eAAiB,CAC7H","file":"main.vue","sourcesContent":["\n.upload-list[data-v-471476b6]{margin-bottom:-30px\n}\n.upload-list ul[data-v-471476b6]{margin:0px;padding:0px;list-style-type:none\n}\n.upload-list ul li[data-v-471476b6]{float:left;margin:10px 10px 30px;border:1px solid #c0c4cc;width:130px;height:130px;position:relative\n}\n.upload-list ul li.sj-icon-add-image[data-v-471476b6]{color:#c0c4cc;border:1px solid transparent;font-size:130px;line-height:130px\n}\n.upload-list ul li.sj-icon-add-image input[data-v-471476b6]{cursor:pointer;font-size:0;width:100%;height:100%;opacity:0;position:absolute;top:0px;left:0px\n}\n.upload-list ul li .upload-image[data-v-471476b6]{position:relative;vertical-align:middle;text-align:center;height:100%;width:100%\n}\n.upload-list ul li .upload-image[data-v-471476b6]::before{content:\"\";display:inline-block;height:100%;vertical-align:middle;width:0\n}\n.upload-list ul li .upload-image img[data-v-471476b6]{max-width:130px;max-height:130px;vertical-align:middle\n}\n.upload-list ul li .upload-image .upload-image-status[data-v-471476b6]{position:absolute;width:130px;left:50%;top:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)\n}\n.upload-list ul li .upload-image .upload-image-toolbar[data-v-471476b6]{display:none;position:absolute;bottom:8px;left:0px;width:130px;padding-top:5px\n}\n.upload-list ul li .upload-image:hover .upload-image-toolbar[data-v-471476b6]{display:block\n}\n.upload-list ul li .upload-image-date[data-v-471476b6]{position:absolute;bottom:-28px;left:0px;width:130px;font-size:12px;color:#909399;cursor:pointer;text-align:center\n}\n.upload-list ul li .upload-image-date[data-v-471476b6]:hover{color:#409eff\n}\n.upload-list ul li .upload-image-date .modify-image-date[data-v-471476b6]{width:190px;-webkit-transform-origin:center bottom 0px;transform-origin:center bottom 0px;position:absolute;left:-25px;bottom:0px;margin-bottom:27px\n}\n.upload-list ul li .upload-image-date .modify-image-date .el-date-editor.el-input[data-v-471476b6]{width:190px\n}\n.upload-list ul li .upload-image-date .modify-image-date .el-input--suffix .el-input__inner[data-v-471476b6]{padding-right:0px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3689:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3690);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("1c08408a", content, true, {});

/***/ }),

/***/ 3690:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3691:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.visible,"title":"图片上传","width":"50%"},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',{staticClass:"upload-list"},[_c('ul',{staticClass:"clear-both"},[_vm._l((_vm.files),function(file,index){return _c('li',{key:index},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(file.loading),expression:"file.loading"}],staticClass:"upload-image"},[_c('img',{attrs:{"src":file.src,"alt":file.src}}),_vm._v(" "),_c('div',{staticClass:"upload-image-status"},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(file.status === 'success'),expression:"file.status === 'success'"}],staticClass:"el-icon-success",attrs:{"type":"success","size":"mini"}},[_vm._v(" 上传成功\n            ")]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(file.status === 'error'),expression:"file.status === 'error'"}],staticClass:"el-icon-error",attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.onUploadFile(file)}}},[_vm._v(" 重新上传\n            ")])],1),_vm._v(" "),_c('div',{staticClass:"upload-image-toolbar"},[(_vm.isShow(index))?_c('el-button-group',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-edit-outline","size":"mini"},on:{"click":function($event){return _vm.onEditImage(index)}}}),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","icon":"el-icon-delete","size":"mini"},on:{"click":function($event){return _vm.onDelete(index)}}})],1):_vm._e()],1)])])}),_vm._v(" "),_c('li',{staticClass:"sj-icon-add-image"},[(_vm.visible)?_c('input',{attrs:{"type":"file","accept":"image/jpeg, image/png, image/gif","multiple":""},on:{"change":_vm.onSelectFile}}):_vm._e()])],2),_vm._v(" "),_c('span',{staticClass:"color-danger",staticStyle:{"font-size":"12px","line-height":"40px"}},[_vm._v("为避免前端闪退，请控制上传照片尺寸≤1000*1000，大小≤500KB。")])]),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.visible = false}}},[_vm._v("关 闭")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":_vm.files.length === 0},on:{"click":function($event){return _vm.onUploadFiles()}}},[_vm._v("开始上传\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3692:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"question-type-container"},[_c('sj-question',{attrs:{"model":_vm.questions,"fixed-ids":_vm.appendQuestionIds}},[_c('step-template-question-type',{attrs:{"disabled":_vm.disabled.add},model:{value:(_vm.questions),callback:function ($$v) {_vm.questions=$$v},expression:"questions"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"step-template-content-container"},[_c('step-template-info',{ref:"infoForm",attrs:{"disabled":_vm.disabled.base},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}}),_vm._v(" "),_c('step-template-questions',{ref:"questionForm",model:{value:(_vm.questions),callback:function ($$v) {_vm.questions=$$v},expression:"questions"}})],1),_vm._v(" "),_c('div',{staticClass:"step-template-right-container",style:({maxHeight: _vm.rightHeight + 'px'})},[_c('div',{ref:"stepTemplateAction"},[_c('layout-panel',{attrs:{"hide-collapse":""}},[_c('template',{slot:"header"},[_vm._v("\n          模板操作\n        ")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-tooltip',{attrs:{"content":"复制模板数据","placement":"top"}},[_c('button',{ref:"copyQuestions",staticClass:"sj-icon-copy"})]),_vm._v(" "),_c('el-dropdown',[_c('button',{staticClass:"el-icon-more"}),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.collapseAllQuestion(true)}}},[_vm._v("全部收起")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.collapseAllQuestion(false)}}},[_vm._v("全部展开")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.openCache($event)}}},[_vm._v("读取缓存")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.copyQuestionTo($event)}}},[_vm._v("从其他模板复制题目")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.showDataLabelModal($event)}}},[_vm._v("批量设置数据标签")])],1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.questions.length),expression:"questions.length"}]},[_c('sj-question-number',{attrs:{"question-items":_vm.sjQuestionItems,"danger-ids":_vm.validateFailQuestionIds,"fixed-ids":_vm.appendQuestionIds},model:{value:(_vm.questions),callback:function ($$v) {_vm.questions=$$v},expression:"questions"}}),_vm._v(" "),_c('hr',{staticClass:"hr-dashed margin b15"})],1),_vm._v(" "),(_vm.allowSave)?_c('el-button',{attrs:{"type":"primary","size":"small","disabled":!_vm.questions.length},on:{"click":_vm.onSubmit}},[_vm._v("保存模板\n        ")]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"type":"info","size":"small","plain":""},on:{"click":_vm.openTree}},[_vm._v("逻辑树\n        ")])],2)],1),_vm._v(" "),[_c('div',{staticClass:"step-template-question-attr"},[(_vm.hasQuestionFocus)?_c('step-template-question-attr',{attrs:{"body-style":{maxHeight: this.questionAttrHeight + 'px'},"index":_vm.focusQuestionIndex,"questions":_vm.questions,"disabled":_vm.disabled.base,"through_record":_vm.form.through_record},model:{value:(_vm.focusQuestion),callback:function ($$v) {_vm.focusQuestion=$$v},expression:"focusQuestion"}}):_vm._e(),_vm._v(" "),(_vm.hasOptionFocus)?_c('step-template-question-option-attr',{attrs:{"body-style":{maxHeight: this.questionAttrHeight + 'px'},"index":_vm.focusOptionIndex,"questions":_vm.questions,"question":_vm.focusQuestion,"question-index":_vm.focusQuestionIndex,"disabled":_vm.disabled.base},model:{value:(_vm.focusOption),callback:function ($$v) {_vm.focusOption=$$v},expression:"focusOption"}}):_vm._e()],1)]],2),_vm._v(" "),_c('send-question-to',{ref:"SendQuestionTo",attrs:{"fixed-ids":_vm.appendQuestionIds}}),_vm._v(" "),_c('copy-question-to',{ref:"CopyQuestionTo",attrs:{"fixed-ids":_vm.appendQuestionIds}}),_vm._v(" "),_c('step-template-data-labels',{ref:"StepTemplateDataLabels"}),_vm._v(" "),_c('validate-question-warning',{ref:"ValidateQuestionWarning"}),_vm._v(" "),_c('check-question-fix',{ref:"CheckQuestionFix"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/step-template-workspace.00c5d38221eff6d63884.js